/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domready = __webpack_require__(560);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _constants = __webpack_require__(2);
	
	var _chat_ui = __webpack_require__(927);
	
	var _chat_ui2 = _interopRequireDefault(_chat_ui);
	
	var _init = __webpack_require__(506);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 *
	 * Entry point for rchat plugin javascripts.
	 *
	 */
	
	
	var loadUI = function loadUI() {
	  (0, _domready2.default)(function () {
	    var uiElement = document.querySelector(_constants.UI_SELECTOR);
	
	    if (uiElement) {
	      if (uiElement.className.length > 0) uiElement.className += ' ';
	      uiElement.className += _constants.UI_CLASS;
	
	      _reactDom2.default.render(_react2.default.createElement(_chat_ui2.default, null), uiElement);
	    }
	  });
	};
	
	(0, _init.initDataForUI)();
	(0, _init.initSettings)(rchat._conf);
	loadUI();

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.13.0
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            m._isValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                m._isValid = m._isValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            return Math.ceil(number);
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (utils_hooks__hooks.deprecationHandler != null) {
	                utils_hooks__hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (utils_hooks__hooks.deprecationHandler != null) {
	            utils_hooks__hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	    utils_hooks__hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function isObject(input) {
	        return Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    // internal storage for locale config files
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                __webpack_require__(417)("./" + name);
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale');
	                config = mergeConfigs(locales[name]._config, config);
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    config = mergeConfigs(locales[config.parentLocale]._config, config);
	                } else {
	                    // treat as if there is no base config
	                    deprecateSimple('parentLocaleUndefined',
	                            'specified parentLocale is not defined yet');
	                }
	            }
	            locales[name] = new Locale(config);
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale;
	            if (locales[name] != null) {
	                config = mergeConfigs(locales[name]._config, config);
	            }
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function locale_locales__listLocales() {
	        return keys(locales);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function get_set__set (mom, unit, value) {
	        if (mom.isValid()) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	
	    // MOMENTS
	
	    function getSet (units, value) {
	        var unit;
	        if (typeof units === 'object') {
	            for (unit in units) {
	                this.set(unit, units[unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function units_month__handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = create_utc__createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return units_month__handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (typeof value !== 'number') {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'moment construction falls back to js Date. This is ' +
	        'discouraged and will be removed in upcoming major ' +
	        'release. Please refer to ' +
	        'https://github.com/moment/moment/issues/1407 for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        //the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(utils_hooks__hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (getParsingFlags(config).bigHour === true &&
	                config._a[HOUR] <= 12 &&
	                config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else {
	            configFromInput(config);
	        }
	
	        if (!valid__isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date(utils_hooks__hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	         'moment().min is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
	         function () {
	             var other = local__createLocal.apply(null, arguments);
	             if (this.isValid() && other.isValid()) {
	                 return other < this ? this : other;
	             } else {
	                 return valid__createInvalid();
	             }
	         }
	     );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = ((string || '').match(matcher) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	            } else if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            this.utcOffset(offsetFromString(matchOffset, this._i));
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])        * sign,
	                h  : toInt(match[HOUR])        * sign,
	                m  : toInt(match[MINUTE])      * sign,
	                s  : toInt(match[SECOND])      * sign,
	                ms : toInt(match[MILLISECOND]) * sign
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            diff = this.diff(sod, 'days', true),
	            format = diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format]() : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            delta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if (isFunction(Date.prototype.toISOString)) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return this._offset ? new Date(this.valueOf()) : this._d;
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return this._weekdaysShort[m.day()];
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return this._weekdaysMin[m.day()];
	    }
	
	    function day_of_week__handleStrictParse(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = create_utc__createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add               = add_subtract__add;
	    momentPrototype__proto.calendar          = moment_calendar__calendar;
	    momentPrototype__proto.clone             = clone;
	    momentPrototype__proto.diff              = diff;
	    momentPrototype__proto.endOf             = endOf;
	    momentPrototype__proto.format            = format;
	    momentPrototype__proto.from              = from;
	    momentPrototype__proto.fromNow           = fromNow;
	    momentPrototype__proto.to                = to;
	    momentPrototype__proto.toNow             = toNow;
	    momentPrototype__proto.get               = getSet;
	    momentPrototype__proto.invalidAt         = invalidAt;
	    momentPrototype__proto.isAfter           = isAfter;
	    momentPrototype__proto.isBefore          = isBefore;
	    momentPrototype__proto.isBetween         = isBetween;
	    momentPrototype__proto.isSame            = isSame;
	    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
	    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
	    momentPrototype__proto.isValid           = moment_valid__isValid;
	    momentPrototype__proto.lang              = lang;
	    momentPrototype__proto.locale            = locale;
	    momentPrototype__proto.localeData        = localeData;
	    momentPrototype__proto.max               = prototypeMax;
	    momentPrototype__proto.min               = prototypeMin;
	    momentPrototype__proto.parsingFlags      = parsingFlags;
	    momentPrototype__proto.set               = getSet;
	    momentPrototype__proto.startOf           = startOf;
	    momentPrototype__proto.subtract          = add_subtract__subtract;
	    momentPrototype__proto.toArray           = toArray;
	    momentPrototype__proto.toObject          = toObject;
	    momentPrototype__proto.toDate            = toDate;
	    momentPrototype__proto.toISOString       = moment_format__toISOString;
	    momentPrototype__proto.toJSON            = toJSON;
	    momentPrototype__proto.toString          = toString;
	    momentPrototype__proto.unix              = unix;
	    momentPrototype__proto.valueOf           = to_type__valueOf;
	    momentPrototype__proto.creationData      = creationData;
	
	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto._calendar       = defaultCalendar;
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto._longDateFormat = defaultLongDateFormat;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto._invalidDate    = defaultInvalidDate;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto._ordinal        = defaultOrdinal;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto._ordinalParse   = defaultOrdinalParse;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto._relativeTime   = defaultRelativeTime;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;
	
	    // Month
	    prototype__proto.months            =        localeMonths;
	    prototype__proto._months           = defaultLocaleMonths;
	    prototype__proto.monthsShort       =        localeMonthsShort;
	    prototype__proto._monthsShort      = defaultLocaleMonthsShort;
	    prototype__proto.monthsParse       =        localeMonthsParse;
	    prototype__proto._monthsRegex      = defaultMonthsRegex;
	    prototype__proto.monthsRegex       = monthsRegex;
	    prototype__proto._monthsShortRegex = defaultMonthsShortRegex;
	    prototype__proto.monthsShortRegex  = monthsShortRegex;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto._week = defaultLocaleWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto._weekdays      = defaultLocaleWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
	    prototype__proto._weekdaysRegex      = defaultWeekdaysRegex;
	    prototype__proto.weekdaysRegex       =        weekdaysRegex;
	    prototype__proto._weekdaysShortRegex = defaultWeekdaysShortRegex;
	    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
	    prototype__proto._weekdaysMinRegex   = defaultWeekdaysMinRegex;
	    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = lists__get(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = locale_locales__getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return lists__get(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function lists__listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function lists__listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function lists__listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function lists__listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function lists__listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes <= 1           && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   <= 1           && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    <= 1           && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  <= 1           && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   <= 1           && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    utils_hooks__hooks.version = '2.13.0';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.now                   = now;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.updateLocale          = updateLocale;
	    utils_hooks__hooks.locales               = locale_locales__listLocales;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	    utils_hooks__hooks.prototype             = momentPrototype;
	
	    var _moment = utils_hooks__hooks;
	
	    return _moment;
	
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXPERT_SESSIONS_REF_USER_ENDPOINT = EXPERT_SESSIONS_REF_USER_ENDPOINT;
	exports.USER_CONVERSATIONS_PRIVATE_ENDPOINT = USER_CONVERSATIONS_PRIVATE_ENDPOINT;
	exports.CONVERSATIONS_PRIVATE_MESSAGES_ENDPOINT = CONVERSATIONS_PRIVATE_MESSAGES_ENDPOINT;
	exports.USER_MESSAGE_NOTIFICATIONS_ENDPOINT = USER_MESSAGE_NOTIFICATIONS_ENDPOINT;
	exports.USER_IGNORED_USER_ENDPOINT = USER_IGNORED_USER_ENDPOINT;
	exports.USER_IGNORING_USER_ENDPOINT = USER_IGNORING_USER_ENDPOINT;
	exports.USER_REPORTS_ENDPOINT = USER_REPORTS_ENDPOINT;
	var UI_SELECTOR = exports.UI_SELECTOR = '[data-rchat-ui]';
	var UI_CLASS = exports.UI_CLASS = 'rchat-ui';
	var ADMIN_SELECTOR = exports.ADMIN_SELECTOR = '[data-rchat-admin]';
	var ADMIN_CLASS = exports.ADMIN_CLASS = 'rchat-admin';
	var EMBED_NAME = exports.EMBED_NAME = 'data-rchat-embed';
	var EMBED_SELECTOR = exports.EMBED_SELECTOR = '[' + EMBED_NAME + ']';
	var EMBED_CLASS = exports.EMBED_CLASS = 'rchat-embeds';
	
	var SETTINGS_ENDPOINT = exports.SETTINGS_ENDPOINT = '/settings';
	var SETTINGS_GUEST_PREFIX_ENDPOINT = exports.SETTINGS_GUEST_PREFIX_ENDPOINT = SETTINGS_ENDPOINT + '/guestPrefix';
	var SETTINGS_GUEST_NAMES_ENDPOINT = exports.SETTINGS_GUEST_NAMES_ENDPOINT = SETTINGS_ENDPOINT + '/guestNames';
	
	var USERS_ENDPOINT = exports.USERS_ENDPOINT = '/users';
	var CONNECTED_ENDPOINT = exports.CONNECTED_ENDPOINT = '/.info/connected';
	var PRESENCE_ENDPOINT = exports.PRESENCE_ENDPOINT = '/presence';
	var GUESTS_ENDPOINT = exports.GUESTS_ENDPOINT = '/guests';
	
	var MESSAGES_ENDPOINT = exports.MESSAGES_ENDPOINT = '/messages';
	
	var CONVERSATIONS_PRIVATE_ENDPOINT = exports.CONVERSATIONS_PRIVATE_ENDPOINT = '/conversations/private';
	var CONVERSATIONS_PRIVATE_REFS_ENDPOINT = exports.CONVERSATIONS_PRIVATE_REFS_ENDPOINT = '/conversations/_refs/private';
	var CONVERSATION_STACKS_ENDPOINT = exports.CONVERSATION_STACKS_ENDPOINT = '/conversations/_stacks';
	var CONVERSATION_MESSAGE_COUNTS_ENDPOINT = exports.CONVERSATION_MESSAGE_COUNTS_ENDPOINT = '/conversations/_counts';
	var CONVERSATION_REF_MESSAGE_COUNTS_ENDPOINT = exports.CONVERSATION_REF_MESSAGE_COUNTS_ENDPOINT = '/conversations/_refs/_counts';
	
	var NOTIFICATIONS_ENDPOINT = exports.NOTIFICATIONS_ENDPOINT = '/notifications';
	var MESSAGE_NOTIFICATIONS_ENDPOINT = exports.MESSAGE_NOTIFICATIONS_ENDPOINT = NOTIFICATIONS_ENDPOINT + '/messages';
	var REPORT_NOTIFICATIONS_ENDPOINT = exports.REPORT_NOTIFICATIONS_ENDPOINT = NOTIFICATIONS_ENDPOINT + '/reports';
	
	var SETTINGS_SEGMENTS_ENDPOINT = exports.SETTINGS_SEGMENTS_ENDPOINT = SETTINGS_ENDPOINT + '/segments';
	
	var SESSIONS_ENDPOINT = exports.SESSIONS_ENDPOINT = '/sessions';
	var EXPERT_SESSIONS_ENDPOINT = exports.EXPERT_SESSIONS_ENDPOINT = SESSIONS_ENDPOINT + '/experts';
	var EXPERT_SESSION_ACTIVITIES_ENDPOINT = exports.EXPERT_SESSION_ACTIVITIES_ENDPOINT = SESSIONS_ENDPOINT + '/_activities/experts';
	var EXPERT_SESSION_COUNTS_ENDPOINT = exports.EXPERT_SESSION_COUNTS_ENDPOINT = SESSIONS_ENDPOINT + '/_counts';
	var EXPERT_SESSIONS_REF_ENDPOINT = exports.EXPERT_SESSIONS_REF_ENDPOINT = SESSIONS_ENDPOINT + '/_refs/experts';
	var EXPERT_SESSION_REQUESTS_ENDPOINT = exports.EXPERT_SESSION_REQUESTS_ENDPOINT = SESSIONS_ENDPOINT + '/_requests/experts';
	var EXPERT_SESSION_CLAIMS_ENDPOINT = exports.EXPERT_SESSION_CLAIMS_ENDPOINT = SESSIONS_ENDPOINT + '/_claims/experts';
	
	var PAYOUTS_ENDPOINT = exports.PAYOUTS_ENDPOINT = '/payouts';
	var STRIPE_PAYOUTS_ENDPOINT = exports.STRIPE_PAYOUTS_ENDPOINT = PAYOUTS_ENDPOINT + '/stripe';
	var STRIPE_PAYOUT_REQUESTS_ENDPOINT = exports.STRIPE_PAYOUT_REQUESTS_ENDPOINT = PAYOUTS_ENDPOINT + '/_requests/stripe';
	
	var CUSTOMERS_ENDPOINT = exports.CUSTOMERS_ENDPOINT = '/customers';
	var STRIPE_CUSTOMERS_ENDPOINT = exports.STRIPE_CUSTOMERS_ENDPOINT = CUSTOMERS_ENDPOINT + '/stripe';
	
	var REVIEWS_ENDPOINT = exports.REVIEWS_ENDPOINT = '/reviews';
	var EXPERT_REVIEWS_ENDPOINT = exports.EXPERT_REVIEWS_ENDPOINT = REVIEWS_ENDPOINT + '/experts';
	var EXPERT_REVIEW_COUNTS_ENDPOINT = exports.EXPERT_REVIEW_COUNTS_ENDPOINT = REVIEWS_ENDPOINT + '/_counts/experts';
	
	var SCHEDULES_ENDPOINT = exports.SCHEDULES_ENDPOINT = '/schedules';
	
	var VIEW_AGGREGATIONS_ENDPOINT = exports.VIEW_AGGREGATIONS_ENDPOINT = '/viewAggregations';
	var CHAT_LIST_VIEW_ENDPOINT = exports.CHAT_LIST_VIEW_ENDPOINT = VIEW_AGGREGATIONS_ENDPOINT + '/chatList';
	var USERS_VIEW_ENDPOINT = exports.USERS_VIEW_ENDPOINT = VIEW_AGGREGATIONS_ENDPOINT + '/users';
	
	var GROUP_CHAT_ENDPOINT = exports.GROUP_CHAT_ENDPOINT = '/groups';
	var GROUP_CHAT_SCOPES_ENDPOINT = exports.GROUP_CHAT_SCOPES_ENDPOINT = GROUP_CHAT_ENDPOINT + '/_scopes';
	var GROUP_CHAT_ORDERS_ENDPOINT = exports.GROUP_CHAT_ORDERS_ENDPOINT = GROUP_CHAT_ENDPOINT + '/_orders';
	var GROUP_CHAT_BOOKMARKS_ENDPOINT = exports.GROUP_CHAT_BOOKMARKS_ENDPOINT = GROUP_CHAT_ENDPOINT + '/_bookmarks';
	var GROUP_CHAT_SUBSCRIPTIONS_ENDPOINT = exports.GROUP_CHAT_SUBSCRIPTIONS_ENDPOINT = GROUP_CHAT_ENDPOINT + '/_subscriptions';
	var GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT = exports.GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT = GROUP_CHAT_SUBSCRIPTIONS_ENDPOINT + '/users';
	var GROUP_CHAT_SUBSCRIPTION_GROUPS_ENDPOINT = exports.GROUP_CHAT_SUBSCRIPTION_GROUPS_ENDPOINT = GROUP_CHAT_SUBSCRIPTIONS_ENDPOINT + '/groups';
	
	var ADVERTISEMENTS_ENDPOINT = exports.ADVERTISEMENTS_ENDPOINT = '/advertisements';
	var FIXED_SLOT_ADVERTISEMENTS_ENDPOINT = exports.FIXED_SLOT_ADVERTISEMENTS_ENDPOINT = ADVERTISEMENTS_ENDPOINT + '/fixedSlot';
	var CHAT_BOT_SLOT_ADVERTISEMENTS_ENDPOINT = exports.CHAT_BOT_SLOT_ADVERTISEMENTS_ENDPOINT = ADVERTISEMENTS_ENDPOINT + '/chatBotSlot';
	var GENERAL_SETTINGS_ADVERTISEMENTS_ENDPOINT = exports.GENERAL_SETTINGS_ADVERTISEMENTS_ENDPOINT = ADVERTISEMENTS_ENDPOINT + '/settings';
	
	var SERVICES_ENDPOINT = exports.SERVICES_ENDPOINT = '/services';
	var SEARCH_SERVICE_ENDPOINT = exports.SEARCH_SERVICE_ENDPOINT = SERVICES_ENDPOINT + '/search';
	var SEARCH_SERVICE_TRANSACTIONS_ENDPOINT = exports.SEARCH_SERVICE_TRANSACTIONS_ENDPOINT = SEARCH_SERVICE_ENDPOINT + '/transactions';
	var SEARCH_SERVICE_TRANSACTIONS_REQUEST_ENDPOINT = exports.SEARCH_SERVICE_TRANSACTIONS_REQUEST_ENDPOINT = SEARCH_SERVICE_TRANSACTIONS_ENDPOINT + '/requests';
	var SEARCH_SERVICE_TRANSACTIONS_RESPONSE_ENDPOINT = exports.SEARCH_SERVICE_TRANSACTIONS_RESPONSE_ENDPOINT = SEARCH_SERVICE_TRANSACTIONS_ENDPOINT + '/responses';
	
	function EXPERT_SESSIONS_REF_USER_ENDPOINT(uid, otherUid) {
	  return EXPERT_SESSIONS_REF_ENDPOINT + '/' + uid + '/' + otherUid;
	}
	
	function USER_CONVERSATIONS_PRIVATE_ENDPOINT(userId, otherUserId) {
	  return CONVERSATIONS_PRIVATE_REFS_ENDPOINT + '/' + userId + '/' + otherUserId;
	}
	
	function CONVERSATIONS_PRIVATE_MESSAGES_ENDPOINT(conversationId) {
	  return CONVERSATIONS_PRIVATE_ENDPOINT + '/' + conversationId + '/messages';
	}
	
	function USER_MESSAGE_NOTIFICATIONS_ENDPOINT(uid) {
	  return MESSAGE_NOTIFICATIONS_ENDPOINT + '/' + uid;
	}
	
	function USER_IGNORED_USER_ENDPOINT(cUid, uid) {
	  return USERS_ENDPOINT + '/' + cUid + '/ignored/' + uid;
	}
	
	function USER_IGNORING_USER_ENDPOINT(uid, cUid) {
	  return USERS_ENDPOINT + '/' + uid + '/ignoring/' + cUid;
	}
	
	function USER_REPORTS_ENDPOINT(uid) {
	  return USERS_ENDPOINT + '/' + uid + '/reports';
	}
	
	var VIEWPORT_MAX_WIDTH_PHONE = exports.VIEWPORT_MAX_WIDTH_PHONE = 480;
	
	var VIEWPORT_TYPES = exports.VIEWPORT_TYPES = {
	  PHONE: 'phone',
	  DESKTOP: 'desktop'
	};
	
	var PRESENCE = exports.PRESENCE = {
	  OFFLINE: 0,
	  AWAY: 1,
	  BUSY: 2,
	  ONLINE: 3
	};
	
	var PRESENCE_COLORS = exports.PRESENCE_COLORS = {
	  0: '#9E9E9E',
	  1: '#FFCA28',
	  2: '#E62A10',
	  3: '#2BAF2B'
	};
	
	var PRESENCE_LABELS = exports.PRESENCE_LABELS = {
	  // 0: 'Offline', // TODO: reenable this after making 'seen offline'
	  1: 'Away',
	  2: 'Busy',
	  3: 'Online'
	};
	
	var PRESENCE_CRUD_LABELS = exports.PRESENCE_CRUD_LABELS = {
	  0: 'Offline',
	  1: 'Away',
	  2: 'Busy',
	  3: 'Online'
	};
	
	var ROLES = exports.ROLES = {
	  GUEST: 0,
	  USER: 1,
	  PREMIUM: 2,
	  EXPERT: 3,
	  AUTHOR: 4,
	  ADMIN: 5
	};
	
	var ROLE_COLORS = exports.ROLE_COLORS = {
	  0: '#BDBDBD',
	  1: '#4FC3F7',
	  2: '#EF6C00',
	  3: '#D84315',
	  4: '#056F00',
	  5: '#C52100'
	};
	
	var ROLE_LABELS = exports.ROLE_LABELS = {
	  0: 'Guest',
	  1: 'User',
	  2: 'Premium',
	  3: 'Expert',
	  4: 'Author',
	  5: 'Admin'
	};
	
	var BAN_VALUES = exports.BAN_VALUES = {
	  NOT_BANNED: 0,
	  BANNED: 1
	};
	
	var BAN_LABELS = exports.BAN_LABELS = {
	  0: 'Not Banned',
	  1: 'Banned'
	};
	
	var CHAT_STATUS = exports.CHAT_STATUS = {
	  ON: 1,
	  OFF: 0
	};
	
	var CHAT_SETTINGS = exports.CHAT_SETTINGS = {
	  chatStatus: CHAT_STATUS.OFF,
	  idleStartMinutes: 3,
	  inactivityStartSeconds: 15,
	  stopWords: '',
	  guestPrefix: 'Guest',
	  guestNames: '',
	  helpPageUrl: 'https://www.rotoballer.com',
	  colors: {
	    main: {
	      primary: '#0C2B44'
	    },
	    chatList: {
	      background: '#FFFFFF',
	      headerBackground: '#0C2B44',
	      currentUserBarBackground: '#0E3351',
	      itemHoverColor: '#F2F2F2',
	      username: '#212121'
	    },
	    conversation: {
	      background: '#F5F5F5',
	      headerBackground: '#0C2B44',
	      secondaryHeaderBackground: '#0E3351',
	      messageColor: '#212121',
	      receiverBubbleBackground: '#E0E0E0',
	      senderBubbleBackground: '#FFFFFF'
	    }
	  },
	  segments: {
	    recents: { order: 0, title: 'RECENTS', numberOfUsers: 10, dayTimeout: 5 },
	    groups: { order: 1, title: 'GROUP CHATS' },
	    admins: { order: 2, title: 'ADMINS', numberOfUsers: 10 },
	    writers: { order: 3, title: 'WRITERS', numberOfUsers: 10 },
	    experts: { order: 4, title: 'EXPERTS', numberOfUsers: 10 },
	    users: { order: 5, title: 'USERS', numberOfUsers: 10 }
	  },
	  sessionPaymentLengths: [{ label: '10 minutes', value: 10 }, { label: '15 minutes', value: 15 }, { label: '30 minutes', value: 30 }, { label: '1 hour', value: 60 }, { label: '2 hours', value: 120 }],
	  sessionRequestTimeout: 60
	};
	
	var PAY_AS_YOU_GO_VALUE = exports.PAY_AS_YOU_GO_VALUE = 999999;
	
	var CONVERSATION_TYPES = exports.CONVERSATION_TYPES = {
	  GUEST: 0,
	  NORMAL: 1,
	  EXPERT: 2,
	  GROUP: 3,
	  MIXED: 999
	};
	
	var SESSION_REQUEST_STATUSES = exports.SESSION_REQUEST_STATUSES = {
	  DISMISSED: -1,
	  INITIAL: 0,
	  REQUESTED: 1,
	  ACCEPTED: 2,
	  TIMEDOUT: 999
	};
	
	var SESSION_STATUSES = exports.SESSION_STATUSES = {
	  CANCELLED: -2,
	  REQUESTED_CANCEL: -1,
	  INITIATED: 0,
	  BOOKED: 1,
	  PAID: 2,
	  ACTIVE: 3,
	  PAUSED: 4,
	  COMPLETED: 5
	};
	
	var SESSION_TYPES = exports.SESSION_TYPES = {
	  IMMEDIATE: 1,
	  BOOKED: 2
	};
	
	var SESSION_CANCELLATION_TYPES = exports.SESSION_CANCELLATION_TYPES = {
	  EXPERT_CANCELLED: 1,
	  USER_CANCELLED: 2,
	  EXPERT_NOT_SHOWED_UP: 3,
	  USER_NOT_SHOWED_UP: 4,
	  NOBODY_SHOWED_UP: 5
	};
	
	var SESSION_CANCELLATION_TYPE_REASONS = exports.SESSION_CANCELLATION_TYPE_REASONS = {
	  1: 'Expert cancelled the session',
	  2: 'User cancelled the session',
	  3: 'Expert didn\'t show up',
	  4: 'User didn\'t show up',
	  5: 'Both sides didn\'t show up'
	};
	
	var SESSION_STATUS_LABELS = exports.SESSION_STATUS_LABELS = {
	  '-2': 'Canceled',
	  '-1': 'Requested Cancel',
	  0: 'Initiated',
	  1: 'Booked',
	  2: 'Paid',
	  3: 'Active',
	  4: 'Paused',
	  5: 'Completed'
	};
	
	var SESSION_PRESENCES = exports.SESSION_PRESENCES = {
	  DISCONNECTED: -1,
	  INITIAL: 0,
	  ACTIVE: 1
	};
	
	var MESSAGE_TYPES = exports.MESSAGE_TYPES = {
	  NORMAL: 1,
	  EXPERT: 2,
	  GROUP: 3,
	  MODERATED_GROUP: 4,
	  ADVERTISEMENT_BOT: 10
	};
	
	var MESSAGE_APPROVAL_STATUSES = exports.MESSAGE_APPROVAL_STATUSES = {
	  DECLINED: -1,
	  INITIAL: 0,
	  APPROVED: 1
	};
	
	var PAYOUT_REQUEST_STATUSES = exports.PAYOUT_REQUEST_STATUSES = {
	  ERROR: -2,
	  CANCELLED: -1,
	  PENDING: 0,
	  REQUESTED: 1,
	  BOOKED: 2,
	  SUCCESS: 3
	};
	
	var PAYOUT_STATUSES = exports.PAYOUT_STATUSES = {
	  REFUNDED: -1,
	  PAID: 1
	};
	
	var PAYOUT_STATUS_LABELS = exports.PAYOUT_STATUS_LABELS = {
	  '-1': 'Refunded',
	  1: 'Paid'
	};
	
	var SCHEDULE_ENTRIES = exports.SCHEDULE_ENTRIES = {
	  AVAILABLE_TIME: 1,
	  BOOKED: 2
	};
	
	var SCHEDULE_SLOT_SPAN = exports.SCHEDULE_SLOT_SPAN = 15;
	
	var GROUP_CHAT_SCOPES = exports.GROUP_CHAT_SCOPES = {
	  DELETED: 'deleted',
	  SUPER_PRIVATE: 'superPrivate',
	  PRIVATE: 'private',
	  GLOBAL: 'global'
	};
	
	var GROUP_CHAT_SCOPE_OPTIONS = exports.GROUP_CHAT_SCOPE_OPTIONS = [{ val: GROUP_CHAT_SCOPES.SUPER_PRIVATE, label: 'Super Private' }, { val: GROUP_CHAT_SCOPES.PRIVATE, label: 'Private' }, { val: GROUP_CHAT_SCOPES.GLOBAL, label: 'Global' }, { val: GROUP_CHAT_SCOPES.DELETED, label: 'Deleted' }];
	
	var GROUP_CHAT_MODERATED_OPTIONS = exports.GROUP_CHAT_MODERATED_OPTIONS = [{ val: false, label: 'No', isDefault: true }, { val: true, label: 'Yes' }];
	
	var GROUP_CHAT_SUBSCRIPTION_TYPES = exports.GROUP_CHAT_SUBSCRIPTION_TYPES = {
	  INSTANT: 'instant',
	  DAILY: 'daily',
	  WEEKLY: 'weekly'
	};
	
	var SCROLL_POS_CONCERNS = exports.SCROLL_POS_CONCERNS = {
	  HISTORY: -1,
	  TOP: 0,
	  MIDDLE: 1,
	  BOTTOM: 2,
	  FORCE_BOTTOM: 3
	};
	
	var CONVERSATION_PANE_STATUSES = exports.CONVERSATION_PANE_STATUSES = {
	  OPEN: 1,
	  MINIMIZED: 2
	};
	
	var CHAT_LIST_WIDTH = exports.CHAT_LIST_WIDTH = 300;
	var CHAT_LIST_RIGHT_MARGIN = exports.CHAT_LIST_RIGHT_MARGIN = 20;
	var CONVERSATION_PANE_WIDTH = exports.CONVERSATION_PANE_WIDTH = 300;
	var CONVERSATION_PANE_HEIGHT = exports.CONVERSATION_PANE_HEIGHT = 400;
	
	var CONVERSATION_PANE_ADV_DIMENSIONS = exports.CONVERSATION_PANE_ADV_DIMENSIONS = {
	  WIDTH: 280,
	  HEIGHT: 44
	};
	
	var CHAT_BOT_ADVERTISEMENT_SIZES = exports.CHAT_BOT_ADVERTISEMENT_SIZES = [{ val: 250, label: 'Square Unit (300x250)' }, { val: 50, label: 'Rectangle Unit (320x50)' }];
	
	var SEARCH_TRANSACTION_TYPES = exports.SEARCH_TRANSACTION_TYPES = {
	  CREATE: 'create',
	  DELETE: 'delete',
	  RECREATE: 'recreate',
	  INDEX: 'index',
	  SEARCH: 'search'
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = window.React || {Component: {}};

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FIREBASE_LOGIN = exports.FIREBASE_LOGIN = 'FIREBASE_LOGIN';
	var FIREBASE_UNAUTH = exports.FIREBASE_UNAUTH = 'FIREBASE_UNAUTH';
	
	var SET_PLUGIN_SETTINGS = exports.SET_PLUGIN_SETTINGS = 'SET_PLUGIN_SETTINGS';
	
	var SIGNIN_GUEST = exports.SIGNIN_GUEST = 'SIGNIN_GUEST';
	
	var SET_CURRENT_USER = exports.SET_CURRENT_USER = 'SET_CURRENT_USER';
	var SET_CURRENT_GUEST = exports.SET_CURRENT_GUEST = 'SET_CURRENT_GUEST';
	var SET_CURRENT_CUSTOMER = exports.SET_CURRENT_CUSTOMER = 'SET_CURRENT_CUSTOMER';
	
	var SET_CURRENT_USER_PRESENCE = exports.SET_CURRENT_USER_PRESENCE = 'SET_CURRENT_USER_PRESENCE';
	var SET_CURRENT_USER_ACTIVITY = exports.SET_CURRENT_USER_ACTIVITY = 'SET_CURRENT_USER_ACTIVITY';
	var MAKE_CURRENT_USER_ACTIVE = exports.MAKE_CURRENT_USER_ACTIVE = 'MAKE_CURRENT_USER_ACTIVE';
	var MAKE_CURRENT_USER_IDLE = exports.MAKE_CURRENT_USER_IDLE = 'MAKE_CURRENT_USER_IDLE';
	
	var SET_CHAT_SETTINGS = exports.SET_CHAT_SETTINGS = 'SET_CHAT_SETTINGS';
	
	var SET_USERS = exports.SET_USERS = 'SET_USERS';
	var SET_PRESENCES = exports.SET_PRESENCES = 'SET_PRESENCES';
	var SET_USER_PRESENCE = exports.SET_USER_PRESENCE = 'SET_USER_PRESENCE';
	var SET_TOP_EXPERTS = exports.SET_TOP_EXPERTS = 'SET_TOP_EXPERTS';
	
	var SET_USER = exports.SET_USER = 'SET_USER';
	
	var SET_CONVERSATION_REFS = exports.SET_CONVERSATION_REFS = 'SET_CONVERSATION_REFS';
	var SET_RECENT_CONVERSATIONS = exports.SET_RECENT_CONVERSATIONS = 'SET_RECENT_CONVERSATIONS';
	var SET_RECENT_CONVERSATION_USER = exports.SET_RECENT_CONVERSATION_USER = 'SET_RECENT_CONVERSATION_USER';
	var SET_CONVERSATION_STACK = exports.SET_CONVERSATION_STACK = 'SET_CONVERSATION_STACK';
	var SET_FOCUSED_CONVERSATION = exports.SET_FOCUSED_CONVERSATION = 'SET_FOCUSED_CONVERSATION';
	var SET_LAST_OPEN_TIME_FOR_CONVERSATION = exports.SET_LAST_OPEN_TIME_FOR_CONVERSATION = 'SET_LAST_OPEN_TIME_FOR_CONVERSATION';
	
	var SET_TOTAL_CONV_MESSAGE_COUNT = exports.SET_TOTAL_CONV_MESSAGE_COUNT = 'SET_TOTAL_CONV_MESSAGE_COUNT';
	var SET_READ_CONV_MESSAGE_COUNT = exports.SET_READ_CONV_MESSAGE_COUNT = 'SET_READ_CONV_MESSAGE_COUNT';
	
	var SET_NEW_NOTIFICATION = exports.SET_NEW_NOTIFICATION = 'SET_NEW_NOTIFICATION';
	var SET_NEW_MESSAGE_NOTIFICATION = exports.SET_NEW_MESSAGE_NOTIFICATION = 'SET_NEW_MESSAGE_NOTIFICATIONS';
	var SET_NEW_SESSION_REQUEST_NOTIFICATION = exports.SET_NEW_SESSION_REQUEST_NOTIFICATION = 'SET_NEW_SESSION_REQUEST_NOTIFICATION';
	var UNSET_NEW_MESSAGE_INDICATOR_ON_MOBILE = exports.UNSET_NEW_MESSAGE_INDICATOR_ON_MOBILE = 'UNSET_NEW_MESSAGE_INDICATOR_ON_MOBILE';
	
	var SET_USER_SESSIONS = exports.SET_USER_SESSIONS = 'SET_USER_SESSIONS';
	var SET_USER_SESSION_REFS = exports.SET_USER_SESSION_REFS = 'SET_USER_SESSION_REFS';
	var SET_USER_SESSIONS_COUNT = exports.SET_USER_SESSIONS_COUNT = 'SET_USER_SESSIONS_COUNT';
	var SET_CURRENT_SESSION = exports.SET_CURRENT_SESSION = 'SET_CURRENT_SESSION';
	var REMOVE_USER_SESSION_REF = exports.REMOVE_USER_SESSION_REF = 'REMOVE_USER_SESSION_REF';
	var SET_SESSION_ACTIVITY = exports.SET_SESSION_ACTIVITY = 'SET_SESSION_ACTIVITY';
	var SET_SESSION_REQUEST = exports.SET_SESSION_REQUEST = 'SET_SESSION_REQUEST';
	var SET_SESSION_REQUESTS = exports.SET_SESSION_REQUESTS = 'SET_SESSION_REQUESTS';
	var SET_SESSION = exports.SET_SESSION = 'SET_SESSION';
	var SET_SESSIONS = exports.SET_SESSIONS = 'SET_SESSIONS';
	var SET_SESSION_CLAIMS = exports.SET_SESSION_CLAIMS = 'SET_SESSION_CLAIMS';
	
	var SET_NEW_MESSAGE = exports.SET_NEW_MESSAGE = 'SET_NEW_MESSAGE';
	var SET_PREVIOUS_MESSAGES = exports.SET_PREVIOUS_MESSAGES = 'SET_PREVIOUS_MESSAGES';
	var REMOVE_PREVIOUS_MESSAGES = exports.REMOVE_PREVIOUS_MESSAGES = 'REMOVE_PREVIOUS_MESSAGES';
	var UPDATE_MESSAGE_ATTR = exports.UPDATE_MESSAGE_ATTR = 'UPDATE_MESSAGE_ATTR';
	
	var SHOW_MODAL = exports.SHOW_MODAL = 'SHOW_MODAL';
	var CLOSE_MODAL = exports.CLOSE_MODAL = 'CLOSE_MODAL';
	var CLOSE_ALL_MODALS = exports.CLOSE_ALL_MODALS = 'CLOSE_ALL_MODALS';
	
	var SET_PAYOUTS = exports.SET_PAYOUTS = 'SET_PAYOUTS';
	var ORDER_PAYOUTS = exports.ORDER_PAYOUTS = 'ORDER_PAYOUTS';
	var SET_CURRENT_PAYOUT_REQUEST = exports.SET_CURRENT_PAYOUT_REQUEST = 'SET_CURRENT_PAYOUT_REQUEST';
	var SET_CURRENT_USER_PAYOUTS = exports.SET_CURRENT_USER_PAYOUTS = 'SET_CURRENT_USER_PAYOUTS';
	
	var SET_CURRENT_EXPERT_REVIEWS = exports.SET_CURRENT_EXPERT_REVIEWS = 'SET_CURRENT_EXPERT_REVIEWS';
	
	var SET_USER_SCHEDULE = exports.SET_USER_SCHEDULE = 'SET_USER_SCHEDULE';
	
	var SET_CHAT_LIST_TOGGLED = exports.SET_CHAT_LIST_TOGGLED = 'SET_CHAT_LIST_TOGGLED';
	
	var SET_CHAT_LIST_USER = exports.SET_CHAT_LIST_USER = 'SET_CHAT_LIST_USER';
	var REMOVE_CHAT_LIST_USER = exports.REMOVE_CHAT_LIST_USER = 'REMOVE_CHAT_LIST_USER';
	var CHANGE_CHAT_LIST_USER_ROLE = exports.CHANGE_CHAT_LIST_USER_ROLE = 'CHANGE_CHAT_LIST_USER_ROLE';
	var SET_CHAT_LIST_GUESTS = exports.SET_CHAT_LIST_GUESTS = 'SET_CHAT_LIST_GUESTS';
	
	var SET_GROUP_CHATS = exports.SET_GROUP_CHATS = 'SET_GROUP_CHATS';
	var SET_GROUP_CHAT = exports.SET_GROUP_CHAT = 'SET_GROUP_CHAT';
	var SET_GROUP_CHAT_ORDERS = exports.SET_GROUP_CHAT_ORDERS = 'SET_GROUP_CHAT_ORDERS';
	var SET_BOOKMARKED_GROUP_CHATS = exports.SET_BOOKMARKED_GROUP_CHATS = 'SET_BOOKMARKED_GROUP_CHATS';
	var REMOVE_BOOKMARKED_GROUP_CHAT = exports.REMOVE_BOOKMARKED_GROUP_CHAT = 'REMOVE_BOOKMARKED_GROUP_CHAT';
	var SET_SUBSCRIBED_GROUP_CHATS = exports.SET_SUBSCRIBED_GROUP_CHATS = 'SET_SUBSCRIBED_GROUP_CHATS';
	var REMOVE_SUBSCRIBED_GROUP_CHAT = exports.REMOVE_SUBSCRIBED_GROUP_CHAT = 'REMOVE_SUBSCRIBED_GROUP_CHAT';
	var SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT = exports.SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT = 'SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT';
	var REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT = exports.REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT = 'REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT';
	
	var SET_VIEWPORT_DIMENSIONS = exports.SET_VIEWPORT_DIMENSIONS = 'SET_VIEWPORT_DIMENSIONS';
	
	var SET_ADVERTISEMENTS = exports.SET_ADVERTISEMENTS = 'SET_ADVERTISEMENTS';

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _firebase = __webpack_require__(33);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _es6Promise = __webpack_require__(354);
	
	var _es6Promise2 = _interopRequireDefault(_es6Promise);
	
	var _lodash = __webpack_require__(411);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _updeep = __webpack_require__(436);
	
	var _updeep2 = _interopRequireDefault(_updeep);
	
	var _dev = __webpack_require__(40);
	
	var _dev2 = _interopRequireDefault(_dev);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Promise = _es6Promise2.default.Promise;
	
	
	var localStorage = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' ? window.localStorage : null;
	
	var initialState = {
	  data: {}
	};
	
	function splitUrl(url) {
	  return url.replace(/^\//, '').split(/\//);
	}
	
	function urlToKeyPath(url) {
	  var keyPath = splitUrl(url).join('.');
	  return keyPath;
	}
	
	var Firedux = function () {
	  function Firedux(options) {
	    _classCallCheck(this, Firedux);
	
	    var that = this;
	    this.url = options.url;
	    if (this.url.slice(-1) !== '/') {
	      this.url += '/';
	    }
	    this.omit = options.omit || [];
	    this.ref = new _firebase2.default(this.url);
	    this.token = null;
	    this.getting = {};
	    this.removing = {};
	    this.watching = {};
	    this.actionId = 0;
	    this.dispatch = null;
	
	    function makeFirebaseState(action, state, path, value) {
	      var keyPath = urlToKeyPath(path);
	      // const dataPath = 'data.' + keyPath
	      var dataPath = ['data'].concat(splitUrl(path));
	      // const statusPath = 'status.' + keyPath
	      var newState = _updeep2.default.updateIn(dataPath, _updeep2.default.constant(value), state);
	      return newState;
	    }
	
	    function removeFirebaseState(action, state, path) {
	      var split = splitUrl(path);
	      var dataSplit = ['data'].concat(split);
	
	      // get & set value for restore in case of error
	      // TODO: Find a cleaner way to do this.
	      action.setValue(_lodash2.default.get(state, dataSplit));
	
	      var id = split.pop();
	      var parentPath = split.join('.');
	      that.ref.child(path).off();
	      var keyPath = parentPath;
	      var dataPath = 'data.' + keyPath;
	      var newState = _updeep2.default.updateIn(dataPath, _updeep2.default.omit(id), state);
	      return newState;
	    }
	
	    this.reducer = function reducer() {
	      return function () {
	        var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	        var action = arguments[1];
	
	        switch (action.type) {
	          case 'FIREBASE_GET':
	          case 'FIREBASE_WATCH':
	            return makeFirebaseState(action, state, action.path, action.snapshot.val());
	          case 'FIREBASE_SET':
	          case 'FIREBASE_UPDATE':
	          case 'FIREBASE_PUSH':
	            return makeFirebaseState(action, state, action.path, action.value);
	          case 'FIREBASE_REMOVE':
	            return removeFirebaseState(action, state, action.path);
	          case 'FIREBASE_SET_RESPONSE':
	          case 'FIREBASE_UPDATE_RESPONSE':
	          case 'FIREBASE_REMOVE_RESPONSE':
	            // TODO: Error handling, at per-path level, somehow async without clobber, maybe queues?
	            if (action.error) {
	              console.error(action.error);
	              // restore state
	              return makeFirebaseState(action, state, action.path, action.value);
	            }
	            return state;
	          case 'FIREBASE_PUSH_RESPONSE':
	            if (action.error) {
	              // return removeFirebaseState(action, state, action.path)
	            }
	            return state;
	          case 'FIREBASE_LOGIN':
	          case 'FIREBASE_LOGOUT':
	          case 'FIREBASE_LOGIN_ERROR':
	            return (0, _updeep2.default)({
	              authData: action.authData,
	              authError: action.error
	            }, state);
	          default:
	            return state;
	        }
	      };
	    };
	
	    return this;
	  }
	
	  _createClass(Firedux, [{
	    key: 'cleanValue',
	    value: function cleanValue(value) {
	      return _lodash2.default.isObject(value) ? _lodash2.default.omit(value, this.omit) : value;
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      var dispatch = this.dispatch;
	
	      var that = this;
	      return new Promise(function (resolve, reject) {
	        _this.token = localStorage.getItem('FIREBASE_TOKEN');
	        if (_this.token) {
	          resolve(_this.login(dispatch, {
	            token: _this.token
	          }));
	        }
	
	        // listen for auth changes
	        _this.ref.onAuth(function (authData) {
	          if (!authData) {
	            localStorage.removeItem('FIREBASE_TOKEN');
	            that.authData = null;
	            dispatch({ type: 'FIREBASE_LOGOUT' });
	            reject();
	          }
	          resolve(authData);
	        });
	      });
	    }
	  }, {
	    key: 'login',
	    value: function login(credentials) {
	      if (credentials.token) {
	        this.ref.authWithCustomToken(this.token);
	      } else {
	        this.ref.authWithPassword(credentials);
	      }
	      // const { dispatch } = this
	      // const that = this
	      // return new Promise((resolve, reject) => {
	      //   dispatch({type: 'FIREBASE_LOGIN_ATTEMPT'})
	
	      //   const handler = function (error, authData) {
	      //     // TODO: Error handling.
	      //     if (error) {
	      //       console.error('FB AUTH ERROR', error, authData)
	      //       dispatch({type: 'FIREBASE_LOGIN_ERROR', error})
	      //       reject(error)
	      //       return
	      //     }
	      //     localStorage.setItem('FIREBASE_TOKEN', authData.token)
	      //     that.authData = authData
	      //     dispatch({type: 'FIREBASE_LOGIN', authData: authData, error: error})
	      //     resolve(authData)
	      //   }
	
	      //   try {
	      //     if (credentials.token) {
	      //       this.ref.authWithCustomToken(this.token, handler)
	      //     } else {
	      //       this.ref.authWithPassword(credentials, handler)
	      //     }
	      //   } catch (error) {
	      //     console.error('FB AUTH ERROR', error)
	      //     dispatch({type: 'FIREBASE_LOGIN_ERROR', error})
	      //     reject(error)
	      //   }
	      // })
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      this.ref.unauth();
	      // const { dispatch } = this
	      // return new Promise((resolve) => {
	      // dispatch({type: 'FIREBASE_LOGOUT_ATTEMPT'})
	      // this.ref.unauth()
	      // this.authData = null
	      // this.authError = null
	      // dispatch({type: 'FIREBASE_LOGOUT'})
	      // resolve()
	      // })
	    }
	  }, {
	    key: 'watch',
	    value: function watch(path, onComplete) {
	      var _this2 = this;
	
	      var dispatch = this.dispatch;
	
	      return new Promise(function (resolve) {
	        if (_this2.watching[path]) {
	          return false;
	        }
	        _this2.watching[path] = true;
	        _this2.ref.child(path).on('value', function (snapshot) {
	          // TODO: Make watches smart enough to ignore pending updates, e.g. not replace
	          //  a path that has been removed locally but is queued for remote delete?
	          dispatch({
	            type: 'FIREBASE_WATCH',
	            path: path,
	            snapshot: snapshot
	          });
	
	          if (onComplete) onComplete(snapshot);
	          resolve({ snapshot: snapshot });
	        });
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get(path, onComplete) {
	      var _this3 = this;
	
	      var dispatch = this.dispatch;
	
	      return new Promise(function (resolve) {
	        if (_this3.getting[path]) {
	          return { type: 'FIREBASE_GET_PENDING' };
	        }
	        _this3.getting[path] = true;
	        _this3.ref.child(path).once('value', function (snapshot) {
	          _this3.getting[path] = false;
	          dispatch({
	            type: 'FIREBASE_GET',
	            path: path,
	            snapshot: snapshot
	          });
	          if (onComplete) onComplete(snapshot);
	          resolve({ snapshot: snapshot });
	        });
	      });
	    }
	  }, {
	    key: 'set',
	    value: function set(path, value, onComplete) {
	      var _this4 = this;
	
	      var dispatch = this.dispatch;
	
	      return new Promise(function (resolve, reject) {
	        var newValue = _this4.cleanValue(value);
	        // optimism
	        dispatch({
	          type: 'FIREBASE_SET',
	          path: path,
	          value: newValue
	        });
	        _this4.ref.child(path).set(newValue, function (error) {
	          dispatch({
	            type: 'FIREBASE_SET_RESPONSE',
	            path: path,
	            value: newValue,
	            error: error
	          });
	          if (onComplete) onComplete(error);
	          if (error) reject(error);else resolve({ value: newValue });
	        });
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update(path, value, onComplete) {
	      var _this5 = this;
	
	      var dispatch = this.dispatch;
	
	      return new Promise(function (resolve, reject) {
	        var newValue = _this5.cleanValue(value);
	        // optimism
	        dispatch({
	          type: 'FIREBASE_UPDATE',
	          path: path,
	          value: newValue
	        });
	        _this5.ref.child(path).update(newValue, function (error) {
	          dispatch({
	            type: 'FIREBASE_UPDATE_RESPONSE',
	            path: path,
	            value: newValue,
	            error: error
	          });
	          if (onComplete) onComplete(error);
	          if (error) reject(error);else resolve({ value: newValue });
	        });
	      });
	    }
	  }, {
	    key: 'remove',
	    value: function remove(path, onComplete) {
	      var _this6 = this;
	
	      var dispatch = this.dispatch;
	
	      return new Promise(function (resolve, reject) {
	        if (_this6.removing[path]) {
	          return { type: 'FIREBASE_REMOVE_PENDING' };
	        }
	        _this6.removing[path] = true;
	
	        var value = void 0;
	
	        // optimism
	        dispatch({
	          type: 'FIREBASE_REMOVE',
	          path: path,
	          // TODO: How to access state for cleaner rollback?
	          setValue: function setValue(v) {
	            return value = v;
	          }
	        });
	        _this6.ref.child(path).remove(function (error) {
	          _this6.removing[path] = false;
	          dispatch({
	            type: 'FIREBASE_REMOVE_RESPONSE',
	            path: path,
	            value: value,
	            error: error
	          });
	          if (onComplete) onComplete(error);
	          if (error) reject(error);else resolve();
	        });
	      });
	    }
	  }, {
	    key: 'push',
	    value: function push(toPath, value, onId, onComplete) {
	      var dispatch = this.dispatch;
	
	      var that = this;
	      var newValue = this.cleanValue(value);
	
	      return new Promise(function (resolve, reject) {
	        var path = void 0,
	            newId = void 0;
	        var ref = that.ref.child(toPath);
	        var pushRef = ref.push(newValue, function (error) {
	          dispatch({
	            type: 'FIREBASE_PUSH_RESPONSE',
	            path: path,
	            toPath: toPath,
	            newId: newId,
	            value: newValue,
	            error: error
	          });
	          if (onComplete) onComplete(error, newId);
	          if (error) reject(error);else resolve(newId);
	        });
	        path = pushRef.toString().replace(that.url, '');
	        newId = pushRef.key();
	        if (onId) onId(newId);
	
	        // optimism
	        dispatch({
	          type: 'FIREBASE_PUSH',
	          path: path,
	          toPath: toPath,
	          newId: newId,
	          value: newValue,
	          ref: pushRef,
	          toRef: ref
	        });
	      });
	    }
	  }]);
	
	  return Firedux;
	}();
	/////////////////
	
	var RChatFiredux = function (_Firedux) {
	  _inherits(RChatFiredux, _Firedux);
	
	  function RChatFiredux() {
	    _classCallCheck(this, RChatFiredux);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(RChatFiredux).apply(this, arguments));
	  }
	
	  _createClass(RChatFiredux, [{
	    key: 'init',
	    value: function init() {
	      // const { dispatch } = this
	      // const that = this
	      // return new Promise((resolve, reject) => {
	      //   this.token = localStorage.getItem('FIREBASE_TOKEN')
	      //   if (this.token) {
	      //     resolve(this.login({token: this.token}))
	      //   }
	
	      // listen for auth changes
	      // this.ref.onAuth(function (authData) {
	      //   if (!authData) {
	      //     localStorage.removeItem('FIREBASE_TOKEN')
	      //     that.authData = null
	      //     dispatch({type: 'FIREBASE_LOGOUT'})
	      //     reject()
	      //   }
	      //   resolve(authData)
	      // })
	      // })
	    }
	  }, {
	    key: 'login',
	    value: function login(credentials) {
	      if (!credentials) {
	        this.ref.authAnonymously();
	      } else if (credentials.token) {
	        this.ref.authWithCustomToken(credentials.token);
	      } else {
	        this.ref.authWithPassword(credentials);
	      }
	      // const { dispatch } = this
	      // const that = this
	
	      // return new Promise((resolve, reject) => {
	      //   dispatch({type: 'FIREBASE_LOGIN_ATTEMPT'})
	
	      //   const handler = function (error, authData) {
	      //     // TODO: Error handling.
	      //     if (error) {
	      //       console.error('FB AUTH ERROR', error, authData)
	      //       dispatch({type: 'FIREBASE_LOGIN_ERROR', error})
	      //       reject(error)
	      //       return
	      //     }
	      //     localStorage.setItem('FIREBASE_TOKEN', authData.token)
	      //     that.authData = authData
	      //     dispatch({type: 'FIREBASE_LOGIN', authData: authData, error: error})
	      //     resolve(authData)
	      //   }
	
	      //   try {
	      //     if (!credentials) {
	      //       this.ref.authAnonymously(handler)
	      //     } else if (credentials.token) {
	      //       this.ref.authWithCustomToken(credentials.token, handler)
	      //     } else {
	      //       this.ref.authWithPassword(credentials, handler)
	      //     }
	      //   } catch (error) {
	      //     console.error('FB AUTH ERROR', error)
	      //     dispatch({type: 'FIREBASE_LOGIN_ERROR', error})
	      //     reject(error)
	      //   }
	      // })
	    }
	  }]);
	
	  return RChatFiredux;
	}(Firedux);
	
	var firedux = new RChatFiredux({
	  url: _dev2.default.firebaseUrl
	});
	
	firedux.init();
	
	exports.default = firedux;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(583);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(584);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getState = exports.dispatch = undefined;
	
	var _redux = __webpack_require__(237);
	
	var _immutable = __webpack_require__(5);
	
	var _reduxThunk = __webpack_require__(427);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _notifications = __webpack_require__(307);
	
	var _notifications2 = _interopRequireDefault(_notifications);
	
	var _root = __webpack_require__(327);
	
	var _root2 = _interopRequireDefault(_root);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// const store = applyMiddleware(thunk, notifications)(createStore)(rootReducer)
	var store = (0, _redux.createStore)(_root2.default, (0, _immutable.Map)({}), (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default, _notifications2.default), window.devToolsExtension ? window.devToolsExtension() : function (f) {
	  return f;
	}));
	
	var dispatch = exports.dispatch = store.dispatch;
	var getState = exports.getState = store.getState;
	
	_firedux2.default.dispatch = dispatch;
	
	exports.default = store;

/***/ },
/* 9 */,
/* 10 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, global) {var checkGlobal = __webpack_require__(381);
	
	/** Used to determine if values are of the language type `Object`. */
	var objectTypes = {
	  'function': true,
	  'object': true
	};
	
	/** Detect free variable `exports`. */
	var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
	  ? exports
	  : undefined;
	
	/** Detect free variable `module`. */
	var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
	  ? module
	  : undefined;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);
	
	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(objectTypes[typeof self] && self);
	
	/** Detect free variable `window`. */
	var freeWindow = checkGlobal(objectTypes[typeof window] && window);
	
	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
	
	/**
	 * Used as a reference to the global object.
	 *
	 * The `this` value is used if it's the global object to avoid Greasemonkey's
	 * restricted `window` object, otherwise the `window` object is used.
	 */
	var root = freeGlobal ||
	  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
	    freeSelf || thisGlobal || Function('return this')();
	
	module.exports = root;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module), (function() { return this; }())))

/***/ },
/* 12 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 14 */,
/* 15 */
/***/ function(module, exports) {

	module.exports = window.ReactDOM;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (modal) {
	  return { type: _action_types.SHOW_MODAL, modal: modal };
	};

/***/ },
/* 17 */,
/* 18 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _set_user = __webpack_require__(224);
	
	var _set_user2 = _interopRequireDefault(_set_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (uid) {
	  var user = (0, _store.getState)().getIn(['users', uid]);
	
	  if (user) return Promise.resolve(user);
	
	  var ENDPOINT = _constants.USERS_ENDPOINT + '/' + uid;
	
	  return _firedux2.default.ref.child(ENDPOINT).once('value').then(function (snapshot) {
	    if (!snapshot.exists()) return null;
	    user = snapshot.val();
	    (0, _store.dispatch)((0, _set_user2.default)(user));
	    return (0, _immutable.fromJS)(user);
	  });
	};

/***/ },
/* 20 */,
/* 21 */,
/* 22 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 23 */,
/* 24 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(26),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(409);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 27 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 28 */,
/* 29 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.curry1 = curry1;
	exports.curry2 = curry2;
	exports.curry3 = curry3;
	exports.curry4 = curry4;
	exports.default = curry;
	/* eslint no-shadow:0, no-param-reassign:0 */
	var _ = exports._ = '@@updeep/placeholder';
	
	function countArguments(args, max) {
	  var n = args.length;
	  if (n > max) n = max;
	
	  while (args[n - 1] === _) {
	    n--;
	  }
	
	  return n;
	}
	
	function curry1(fn) {
	  return function curried(a) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var b = args[0];
	    var c = args[1];
	
	    var n = countArguments(arguments);
	
	    if (n >= 1) return fn(a, b, c);
	    return curried;
	  };
	}
	
	function curry2(fn) {
	  return function curried(a, b) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	      args[_key2 - 2] = arguments[_key2];
	    }
	
	    var c = args[0];
	    var d = args[1];
	
	    var n = countArguments(arguments, 2);
	
	    if (b === _ || c === _ || d === _) {
	      throw new Error('Can only use placeholder on first argument of this function.');
	    }
	
	    if (n >= 2) {
	      if (a === _) return curry1(function (a, c, d) {
	        return fn(a, b, c, d);
	      });
	      return fn(a, b, c, d);
	    }
	
	    if (n === 1) return curry1(function (b, c, d) {
	      return fn(a, b, c, d);
	    });
	    return curried;
	  };
	}
	
	function curry3(fn) {
	  return function curried(a, b, c) {
	    for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	      args[_key3 - 3] = arguments[_key3];
	    }
	
	    var d = args[0];
	    var e = args[1];
	
	    var n = countArguments(arguments, 3);
	
	    if (c === _ || d === _ || e === _) {
	      throw new Error('Can only use placeholder on first or second argument of this function.');
	    }
	
	    if (n >= 3) {
	      if (a === _) {
	        if (b === _) return curry2(function (a, b, d, e) {
	          return fn(a, b, c, d, e);
	        });
	        return curry1(function (a, d, e) {
	          return fn(a, b, c, d, e);
	        });
	      }
	      if (b === _) return curry1(function (b, d, e) {
	        return fn(a, b, c, d, e);
	      });
	      return fn(a, b, c, d, e);
	    }
	
	    if (n === 2) {
	      if (a === _) return curry2(function (a, c, d, e) {
	        return fn(a, b, c, d, e);
	      });
	      return curry1(function (c, d, e) {
	        return fn(a, b, c, d, e);
	      });
	    }
	
	    if (n === 1) return curry2(function (b, c, d, e) {
	      return fn(a, b, c, d, e);
	    });
	
	    return curried;
	  };
	}
	
	function curry4(fn) {
	  return function curried(a, b, c, d) {
	    for (var _len4 = arguments.length, args = Array(_len4 > 4 ? _len4 - 4 : 0), _key4 = 4; _key4 < _len4; _key4++) {
	      args[_key4 - 4] = arguments[_key4];
	    }
	
	    var e = args[0];
	    var f = args[1];
	
	    var n = countArguments(arguments, 4);
	
	    if (d === _ || e === _ || f === _) {
	      throw new Error('Can only use placeholder on first, second or third argument of this function.');
	    }
	
	    if (n >= 4) {
	      if (a === _) {
	        if (b === _) {
	          if (c === _) return curry3(function (a, b, c, e, f) {
	            return fn(a, b, c, d, e, f);
	          });
	          return curry2(function (a, b, e, f) {
	            return fn(a, b, c, d, e, f);
	          });
	        }
	        if (c === _) return curry2(function (a, c, e, f) {
	          return fn(a, b, c, d, e, f);
	        });
	        return curry1(function (a, e, f) {
	          return fn(a, b, c, d, e, f);
	        });
	      }
	      if (b === _) {
	        if (c === _) return curry2(function (b, c, e, f) {
	          return fn(a, b, c, d, e, f);
	        });
	        return curry1(function (b, e, f) {
	          return fn(a, b, c, d, e, f);
	        });
	      }
	      if (c === _) return curry1(function (c, e, f) {
	        return fn(a, b, c, d, e, f);
	      });
	      return fn(a, b, c, d, e, f);
	    }
	
	    if (n === 3) {
	      if (a === _) {
	        if (b === _) return curry3(function (a, b, d, e, f) {
	          return fn(a, b, c, d, e, f);
	        });
	        return curry2(function (a, d, e, f) {
	          return fn(a, b, c, d, e, f);
	        });
	      }
	      if (b === _) return curry2(function (b, d, e, f) {
	        return fn(a, b, c, d, e, f);
	      });
	      return curry1(function (d, e, f) {
	        return fn(a, b, c, d, e, f);
	      });
	    }
	
	    if (n === 2) {
	      if (a === _) return curry3(function (a, c, d, e, f) {
	        return fn(a, b, c, d, e, f);
	      });
	      return curry2(function (c, d, e, f) {
	        return fn(a, b, c, d, e, f);
	      });
	    }
	
	    if (n === 1) return curry3(function (b, c, d, e, f) {
	      return fn(a, b, c, d, e, f);
	    });
	    return curried;
	  };
	}
	
	function curry(fn) {
	  var length = arguments.length <= 1 || arguments[1] === undefined ? fn.length : arguments[1];
	
	  return [fn, curry1, curry2, curry3, curry4][length](fn);
	}

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 31 */,
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(386),
	    isFunction = __webpack_require__(57),
	    isLength = __webpack_require__(52);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value)) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = window.Firebase;

/***/ },
/* 34 */,
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(44);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(371),
	    baseMatchesProperty = __webpack_require__(372),
	    identity = __webpack_require__(256),
	    isArray = __webpack_require__(10),
	    property = __webpack_require__(414);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _wrap = __webpack_require__(39);
	
	var _wrap2 = _interopRequireDefault(_wrap);
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function isEmpty(object) {
	  return !Object.keys(object).length;
	}
	
	function reduce(object, callback, initialValue) {
	  return Object.keys(object).reduce(function (acc, key) {
	    return callback(acc, object[key], key);
	  }, initialValue);
	}
	
	function resolveUpdates(updates, object) {
	  return reduce(updates, function (acc, value, key) {
	    var updatedValue = value;
	
	    if (!Array.isArray(value) && value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      updatedValue = update(value, object[key]); // eslint-disable-line no-use-before-define
	    } else if (typeof value === 'function') {
	        updatedValue = value(object[key]);
	      }
	
	    if (object[key] !== updatedValue) {
	      acc[key] = updatedValue; // eslint-disable-line no-param-reassign
	    }
	
	    return acc;
	  }, {});
	}
	
	function updateArray(updates, object) {
	  var newArray = [].concat(_toConsumableArray(object));
	
	  Object.keys(updates).forEach(function (key) {
	    newArray[key] = updates[key];
	  });
	
	  return newArray;
	}
	
	/**
	 * Recursively update an object or array.
	 *
	 * Can update with values:
	 * update({ foo: 3 }, { foo: 1, bar: 2 });
	 * // => { foo: 3, bar: 2 }
	 *
	 * Or with a function:
	 * update({ foo: x => (x + 1) }, { foo: 2 });
	 * // => { foo: 3 }
	 *
	 * @function
	 * @name update
	 * @param {Object|Function} updates
	 * @param {Object|Array}    object to update
	 * @return {Object|Array}   new object with modifications
	 */
	function update(updates, object) {
	  if (typeof updates === 'function') {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    return updates.apply(undefined, [object].concat(args));
	  }
	
	  if (!(0, _isPlainObject2.default)(updates)) {
	    return updates;
	  }
	
	  var defaultedObject = typeof object === 'undefined' || object === null ? {} : object;
	
	  var resolvedUpdates = resolveUpdates(updates, defaultedObject);
	
	  if (isEmpty(resolvedUpdates)) {
	    return defaultedObject;
	  }
	
	  if (Array.isArray(defaultedObject)) {
	    return updateArray(resolvedUpdates, defaultedObject);
	  }
	
	  return _extends({}, defaultedObject, resolvedUpdates);
	}
	
	exports.default = (0, _wrap2.default)(update, 2);

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = wrap;
	
	var _curry = __webpack_require__(29);
	
	var _curry2 = _interopRequireDefault(_curry);
	
	var _freeze = __webpack_require__(68);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrap(func) {
	  var length = arguments.length <= 1 || arguments[1] === undefined ? func.length : arguments[1];
	
	  return (0, _curry2.default)(function () {
	    return (0, _freeze2.default)(func.apply(undefined, arguments));
	  }, length);
	}

/***/ },
/* 40 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var config = {
	  firebaseUrl: 'https://rchat-prod.firebaseio.com',
	  hostUrl: 'https://rchat-prod.firebaseapp.com',
	  googleApiKey: 'AIzaSyB6bUg0mHgyDpRyrdd45Sg0-VldTaXaSVs',
	  dependencies: [{ type: 'script', url: 'https://cdnjs.cloudflare.com/ajax/libs/react/0.14.7/react.js' }, { type: 'script', url: 'https://cdnjs.cloudflare.com/ajax/libs/react/0.14.7/react-dom.js' }, { type: 'script', url: 'https://js.stripe.com/v2/stripe.js' }, { type: 'script', url: 'https://cdn.firebase.com/js/client/2.4.2/firebase.js' }, { type: 'script', url: 'https://rchat-prod.firebaseapp.com/rchat.auth.min.js' }],
	  modules: {
	    ui: {
	      paths: [{ type: 'script', url: 'https://rchat-prod.firebaseapp.com/rchat.ui.min.js' }, { type: 'style', url: 'https://rchat-prod.firebaseapp.com/rchat.ui.min.css' }]
	    },
	    embeds: {
	      paths: [{ type: 'script', url: 'https://rchat-prod.firebaseapp.com/rchat.embeds.min.js' }, { type: 'style', url: 'https://rchat-prod.firebaseapp.com/rchat.embeds.min.css' }]
	    },
	    admin: {
	      paths: [{ type: 'script', url: 'https://rchat-prod.firebaseapp.com/rchat.admin.min.js' }, { type: 'style', url: 'https://rchat-prod.firebaseapp.com/rchat.admin.min.css' }]
	    }
	  }
	};
	
	exports.default = config;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(99),
	    baseKeys = __webpack_require__(284),
	    indexKeys = __webpack_require__(105),
	    isArrayLike = __webpack_require__(32),
	    isIndex = __webpack_require__(49),
	    isPrototype = __webpack_require__(85);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  var isProto = isPrototype(object);
	  if (!(isProto || isArrayLike(object))) {
	    return baseKeys(object);
	  }
	  var indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  for (var key in object) {
	    if (baseHas(object, key) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(isProto && key == 'constructor')) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 42 */,
/* 43 */,
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(24);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sample = __webpack_require__(257);
	
	var _sample2 = _interopRequireDefault(_sample);
	
	var _full_path = __webpack_require__(239);
	
	var _full_path2 = _interopRequireDefault(_full_path);
	
	var _presence_indicator = __webpack_require__(79);
	
	var _presence_indicator2 = _interopRequireDefault(_presence_indicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileImage = function (_React$Component) {
	  _inherits(ProfileImage, _React$Component);
	
	  function ProfileImage(props) {
	    _classCallCheck(this, ProfileImage);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ProfileImage).call(this, props));
	
	    _this.state = {
	      defaultAvatars: ['/avatars/1.png', '/avatars/2.png', '/avatars/3.png', '/avatars/4.png', '/avatars/5.png', '/avatars/6.png', '/avatars/7.png', '/avatars/8.png', '/avatars/9.png', '/avatars/10.png', '/avatars/11.png', '/avatars/12.png', '/avatars/13.png', '/avatars/14.png', '/avatars/15.png', '/avatars/16.png', '/avatars/17.png', '/avatars/18.png', '/avatars/19.png', '/avatars/20.png', '/avatars/21.png', '/avatars/22.png', '/avatars/23.png']
	    };
	    return _this;
	  }
	
	  _createClass(ProfileImage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ sampleAvatar: (0, _sample2.default)(this.state.defaultAvatars) });
	    }
	  }, {
	    key: 'imageUrl',
	    value: function imageUrl() {
	      return this.props.image || (0, _full_path2.default)(this.state.sampleAvatar);
	    }
	  }, {
	    key: 'renderPresenceIndicator',
	    value: function renderPresenceIndicator() {
	      if (this.props.hasIndicator) {
	        return _react2.default.createElement(_presence_indicator2.default, { user: this.props.user, size: this.props.indicatorSize });
	      }
	    }
	  }, {
	    key: 'renderProfileImage',
	    value: function renderProfileImage() {
	      return _react2.default.createElement('img', { src: this.imageUrl(), style: { width: this.props.size, height: this.props.size } });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'profile-image', style: { width: this.props.size, height: this.props.size } },
	        this.renderProfileImage(),
	        this.renderPresenceIndicator()
	      );
	    }
	  }]);
	
	  return ProfileImage;
	}(_react2.default.Component);
	
	ProfileImage.defaultProps = {
	  hasIndicator: true
	};
	
	exports.default = ProfileImage;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (modalKey) {
	  return { type: _action_types.CLOSE_MODAL, modalKey: modalKey };
	};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalView = function (_React$Component) {
	  _inherits(ModalView, _React$Component);
	
	  function ModalView(props) {
	    _classCallCheck(this, ModalView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ModalView).call(this, props));
	
	    _this.state = {
	      isActive: _this.props.isActive
	    };
	    return _this;
	  }
	
	  _createClass(ModalView, [{
	    key: 'onClose',
	    value: function onClose() {
	      this.setState({
	        isActive: false
	      });
	
	      this.props.onClose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.isActive) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'modal ' + this.props.size, onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          this.props.children
	        );
	      } else {
	        return false;
	      }
	    }
	  }]);
	
	  return ModalView;
	}(_react2.default.Component);
	
	ModalView.defaultProps = {
	  size: 'medium',
	  onClose: function onClose() {}
	};
	
	exports.default = ModalView;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(109);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 49 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(10),
	    isSymbol = __webpack_require__(44);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(26);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 52 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length,
	 *  else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(56),
	    isHostObject = __webpack_require__(61),
	    isObjectLike = __webpack_require__(24);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object,
	 *  else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 55 */,
/* 56 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetPrototype = Object.getPrototypeOf;
	
	/**
	 * Gets the `[[Prototype]]` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {null|Object} Returns the `[[Prototype]]`.
	 */
	function getPrototype(value) {
	  return nativeGetPrototype(Object(value));
	}
	
	module.exports = getPrototype;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loader = __webpack_require__(340);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _crud_pagination = __webpack_require__(465);
	
	var _crud_pagination2 = _interopRequireDefault(_crud_pagination);
	
	var _crud_list_sortable_column = __webpack_require__(446);
	
	var _crud_list_sortable_column2 = _interopRequireDefault(_crud_list_sortable_column);
	
	var _crud_title = __webpack_require__(296);
	
	var _crud_title2 = _interopRequireDefault(_crud_title);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CRUDList = function (_React$Component) {
	  _inherits(CRUDList, _React$Component);
	
	  function CRUDList(props) {
	    _classCallCheck(this, CRUDList);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CRUDList).call(this, props));
	
	    _this.state = {
	      isLoading: true,
	      page: 1
	    };
	
	    _this.onNewPage = _this.onNewPage.bind(_this);
	    _this.onClickDetails = _this.onClickDetails.bind(_this);
	    return _this;
	  }
	
	  _createClass(CRUDList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.resources) {
	        this.initiateResources(this.props.resources);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.resources !== nextProps.resources) {
	        this.initiateResources(nextProps.resources);
	      }
	
	      if (this.props.isLoading !== nextProps.isLoading) {
	        this.setState({
	          isLoading: nextProps.isLoading
	        });
	      }
	    }
	  }, {
	    key: 'initiateResources',
	    value: function initiateResources(resources) {
	      this.setState({ isLoading: false });
	      this.loadCurrentPage(resources);
	    }
	  }, {
	    key: 'loadCurrentPage',
	    value: function loadCurrentPage(resources, page) {
	      resources = resources || this.props.resources;
	      page = page || this.state.page;
	
	      var start = this.props.limit * (page - 1);
	      var end = start + this.props.limit;
	
	      var pageResources = resources.slice(start, end);
	
	      this.setState({ pageResources: pageResources });
	    }
	  }, {
	    key: 'calculateTotal',
	    value: function calculateTotal() {
	      if (this.props.isResourceSearchBased) {
	        return this.props.totalRecords || 0;
	      } else {
	        return this.props.resources ? this.props.resources.size : 0;
	      }
	    }
	  }, {
	    key: 'onNewPage',
	    value: function onNewPage(page) {
	      this.setState({ page: page });
	
	      if (this.props.isResourceSearchBased) {
	        this.props.onNewPage(page);
	      } else {
	        this.loadCurrentPage(this.props.resources, page);
	      }
	    }
	  }, {
	    key: 'onClickDetails',
	    value: function onClickDetails(resource, e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      this.props.onSwitchToDetail(resource);
	    }
	  }, {
	    key: 'renderAttributeHeader',
	    value: function renderAttributeHeader(attr) {
	      var item = attr.label;
	      var width = void 0;
	
	      if (attr.headerFormatter) return attr.headerFormatter();
	      if (attr.isBold && !attr.isSortable) item = _react2.default.createElement(
	        'b',
	        null,
	        item
	      );
	
	      if (attr.isSortable) {
	        item = _react2.default.createElement(_crud_list_sortable_column2.default, {
	          name: attr.name, label: attr.label,
	          onSortChange: this.props.onSortChange });
	      }
	
	      if (attr.isPrimary) width = '100%';else if (attr.width) width = attr.width;
	
	      return _react2.default.createElement(
	        'th',
	        { key: attr.name, className: attr.name, style: { width: width } },
	        item
	      );
	    }
	  }, {
	    key: 'renderResourceActionsHeader',
	    value: function renderResourceActionsHeader() {
	      if (this.props.isActionsEnabled) {
	        return _react2.default.createElement(
	          'th',
	          null,
	          'Actions'
	        );
	      }
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          this.props.attrs.map(function (attr) {
	            return _this2.renderAttributeHeader(attr);
	          }),
	          this.renderResourceActionsHeader()
	        )
	      );
	    }
	  }, {
	    key: 'renderResourceAttribute',
	    value: function renderResourceAttribute(resource, attr) {
	      var item = resource.get(attr.name);
	
	      if (attr.formatter) item = attr.formatter(item, resource);
	      if (attr.prefix) item = attr.prefix + item;
	      if (attr.isBold) item = _react2.default.createElement(
	        'b',
	        null,
	        item
	      );
	
	      return _react2.default.createElement(
	        'td',
	        { key: attr.name },
	        item
	      );
	    }
	  }, {
	    key: 'renderResourceAttributes',
	    value: function renderResourceAttributes(resource) {
	      var _this3 = this;
	
	      return this.props.attrs.map(function (attr) {
	        return _this3.renderResourceAttribute(resource, attr);
	      });
	    }
	  }, {
	    key: 'renderCustomAction',
	    value: function renderCustomAction(resource, key) {
	      if (this.props.customAction) {
	        return this.props.customAction(resource, key);
	      }
	    }
	  }, {
	    key: 'renderActionDetails',
	    value: function renderActionDetails(resource) {
	      var _this4 = this;
	
	      if (this.props.isActionDetailsEnabled) {
	        return _react2.default.createElement(
	          'a',
	          { href: '#', className: 'btn btn-default', onClick: function onClick(e) {
	              return _this4.onClickDetails(resource, e);
	            } },
	          'Details'
	        );
	      }
	    }
	  }, {
	    key: 'renderResourceActions',
	    value: function renderResourceActions(resource, key) {
	      if (this.props.isActionsEnabled) {
	        return _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'resource-row-actions' },
	            this.renderCustomAction(resource, key),
	            this.renderActionDetails(resource)
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      var _this5 = this;
	
	      var pageResources = this.props.isResourceSearchBased ? this.props.resources : this.state.pageResources;
	
	      if (this.props.resources && pageResources) {
	        return _react2.default.createElement(
	          'tbody',
	          null,
	          pageResources.map(function (resource, key) {
	            return _react2.default.createElement(
	              'tr',
	              { key: key || resource.get('key'), className: _this5.props.rowClassName },
	              _this5.renderResourceAttributes(resource),
	              _this5.renderResourceActions(resource, key)
	            );
	          })
	        );
	      }
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle() {
	      if (this.props.title) {
	        return _react2.default.createElement(_crud_title2.default, { title: this.props.title });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'crud-list table-responsive', style: { position: 'relative' } },
	        _react2.default.createElement(_loader2.default, { loading: this.state.isLoading }),
	        this.renderTitle(),
	        _react2.default.createElement(
	          'table',
	          { className: 'table table-hover' },
	          this.renderHeader(),
	          this.renderBody()
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { textAlign: 'center' } },
	          _react2.default.createElement(_crud_pagination2.default, {
	            total: this.calculateTotal(),
	            currentPage: this.state.page,
	            limitPerPage: this.props.limit,
	            onNewPage: this.onNewPage,
	            style: this.props.paginationStyle })
	        )
	      );
	    }
	  }]);
	
	  return CRUDList;
	}(_react2.default.Component);
	
	CRUDList.defaultProps = {
	  limit: 20,
	  isActionsEnabled: false,
	  isActionDetailsEnabled: true,
	  onSwitchToDetail: function onSwitchToDetail() {},
	  onNewPage: function onNewPage() {}
	};
	
	exports.default = CRUDList;

/***/ },
/* 59 */,
/* 60 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 61 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 62 */,
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var mapClear = __webpack_require__(396),
	    mapDelete = __webpack_require__(397),
	    mapGet = __webpack_require__(398),
	    mapHas = __webpack_require__(399),
	    mapSet = __webpack_require__(400);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function MapCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = values[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapClear;
	MapCache.prototype['delete'] = mapDelete;
	MapCache.prototype.get = mapGet;
	MapCache.prototype.has = mapHas;
	MapCache.prototype.set = mapSet;
	
	module.exports = MapCache;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(84),
	    createBaseEach = __webpack_require__(382);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(75);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	module.exports = isArguments;


/***/ },
/* 66 */,
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var React, cx;
	
	React = __webpack_require__(3);
	
	cx = __webpack_require__(36);
	
	module.exports = React.createClass({
	  displayName: "SpinKit",
	  propTypes: {
	    spinnerName: React.PropTypes.string.isRequired,
	    noFadeIn: React.PropTypes.bool,
	    overrideSpinnerClassName: React.PropTypes.string
	  },
	  getDefaultProps: function() {
	    return {
	      spinnerName: 'three-bounce',
	      noFadeIn: false,
	      overrideSpinnerClassName: ""
	    };
	  },
	  render: function() {
	    var classTests, classes;
	    classTests = {
	      "fade-in": !this.props.noFadeIn,
	      spinner: this.props.overrideSpinnerClassName === ""
	    };
	    classTests[this.props.overrideSpinnerClassName] = this.props.overrideSpinnerClassName;
	    classes = cx(classTests);
	    if (this.props.className) {
	      classes = classes + " " + this.props.className;
	    }
	    if (!this.props.noFadeIn) {
	      __webpack_require__(591);
	    }
	    switch (this.props.spinnerName) {
	      case "three-bounce":
	        __webpack_require__(594);
	        return React.createElement("div", Object.assign({}, this.props, {
	          "className": "three-bounce " + classes
	        }), React.createElement("div", {
	          "className": "bounce1"
	        }), React.createElement("div", {
	          "className": "bounce2"
	        }), React.createElement("div", {
	          "className": "bounce3"
	        }));
	      case "double-bounce":
	        __webpack_require__(590);
	        return React.createElement("div", Object.assign({}, this.props, {
	          "className": "double-bounce " + classes
	        }), React.createElement("div", {
	          "className": "double-bounce1"
	        }), React.createElement("div", {
	          "className": "double-bounce2"
	        }));
	      case "rotating-plane":
	        __webpack_require__(593);
	        return React.createElement("div", Object.assign({}, this.props, {
	          "className": classes
	        }), React.createElement("div", {
	          "className": "rotating-plane"
	        }));
	      case "wave":
	        __webpack_require__(596);
	        return React.createElement("div", Object.assign({}, this.props, {
	          "className": "wave " + classes
	        }), React.createElement("div", {
	          "className": "rect1"
	        }), React.createElement("div", {
	          "className": "rect2"
	        }), React.createElement("div", {
	          "className": "rect3"
	        }), React.createElement("div", {
	          "className": "rect4"
	        }), React.createElement("div", {
	          "className": "rect5"
	        }));
	      case "wandering-cubes":
	        __webpack_require__(595);
	        return React.createElement("div", Object.assign({}, this.props, {
	          "className": "wandering-cubes " + classes
	        }), React.createElement("div", {
	          "className": "cube1"
	        }), React.createElement("div", {
	          "className": "cube2"
	        }));
	      case "pulse":
	        __webpack_require__(592);
	        return React.createElement("div", Object.assign({}, this.props, {
	          "className": classes
	        }), React.createElement("div", {
	          "className": "pulse"
	        }));
	      case "chasing-dots":
	        __webpack_require__(587);
	        return React.createElement("div", Object.assign({}, this.props, {
	          "className": classes
	        }), React.createElement("div", {
	          "className": "chasing-dots"
	        }, React.createElement("div", {
	          "className": "dot1"
	        }), React.createElement("div", {
	          "className": "dot2"
	        })));
	      case "circle":
	        __webpack_require__(588);
	        return React.createElement("div", Object.assign({}, this.props, {
	          "className": "circle-wrapper " + classes
	        }), React.createElement("div", {
	          "className": "circle1 circle"
	        }), React.createElement("div", {
	          "className": "circle2 circle"
	        }), React.createElement("div", {
	          "className": "circle3 circle"
	        }), React.createElement("div", {
	          "className": "circle4 circle"
	        }), React.createElement("div", {
	          "className": "circle5 circle"
	        }), React.createElement("div", {
	          "className": "circle6 circle"
	        }), React.createElement("div", {
	          "className": "circle7 circle"
	        }), React.createElement("div", {
	          "className": "circle8 circle"
	        }), React.createElement("div", {
	          "className": "circle9 circle"
	        }), React.createElement("div", {
	          "className": "circle10 circle"
	        }), React.createElement("div", {
	          "className": "circle11 circle"
	        }), React.createElement("div", {
	          "className": "circle12 circle"
	        }));
	      case "cube-grid":
	        __webpack_require__(589);
	        return React.createElement("div", Object.assign({}, this.props, {
	          "className": "cube-grid " + classes
	        }), React.createElement("div", {
	          "className": "cube"
	        }), React.createElement("div", {
	          "className": "cube"
	        }), React.createElement("div", {
	          "className": "cube"
	        }), React.createElement("div", {
	          "className": "cube"
	        }), React.createElement("div", {
	          "className": "cube"
	        }), React.createElement("div", {
	          "className": "cube"
	        }), React.createElement("div", {
	          "className": "cube"
	        }), React.createElement("div", {
	          "className": "cube"
	        }), React.createElement("div", {
	          "className": "cube"
	        }));
	      case "wordpress":
	        __webpack_require__(597);
	        return React.createElement("div", Object.assign({}, this.props, {
	          "className": classes
	        }), React.createElement("div", {
	          "className": "wordpress"
	        }, React.createElement("span", {
	          "className": "inner-circle"
	        })));
	    }
	  }
	});


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function isFreezable(object) {
	  if (object === null) return false;
	
	  return Array.isArray(object) || (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object';
	}
	
	function needsFreezing(object) {
	  return isFreezable(object) && !Object.isFrozen(object);
	}
	
	function recur(object) {
	  Object.freeze(object);
	
	  Object.keys(object).forEach(function (key) {
	    var value = object[key];
	    if (needsFreezing(value)) {
	      recur(value);
	    }
	  });
	
	  return object;
	}
	
	/**
	 * Deeply freeze a plain javascript object.
	 *
	 * If `process.env.NODE_ENV === 'production'`, this returns the original object
	 * witout freezing.
	 *
	 * @function
	 * @sig a -> a
	 * @param  {object} object Object to freeze.
	 * @return {object} Frozen object, unless in production, then the same object.
	 */
	function freeze(object) {
	  if (true) {
	    return object;
	  }
	
	  if (needsFreezing(object)) {
	    recur(object);
	  }
	
	  return object;
	}
	
	exports.default = freeze;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (epoch) {
	  if (!epoch || epoch === 0) return 'N/A';
	
	  return (0, _moment2.default)(epoch).format('M/D/YY, h:mm A');
	};

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(2);
	
	exports.default = function (role) {
	  if (!role) return false;
	
	  if (role === _constants.ROLES.EXPERT || role === _constants.ROLES.AUTHOR) return true;
	
	  return false;
	};

/***/ },
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(32),
	    isObjectLike = __webpack_require__(24);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 76 */,
/* 77 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name) {
	  var size = arguments.length <= 1 || arguments[1] === undefined ? 20 : arguments[1];
	
	  if (!name) return name;
	
	  if (name.length > size) return name.slice(0, size - 3) + '...';
	
	  return name;
	};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpertRating = function (_React$Component) {
	  _inherits(ExpertRating, _React$Component);
	
	  function ExpertRating(props) {
	    _classCallCheck(this, ExpertRating);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ExpertRating).call(this, props));
	
	    _this.state = {
	      ratingMapping: [0, 0, 0, 0, 0]
	    };
	    return _this;
	  }
	
	  _createClass(ExpertRating, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.mapRatingToArray(this.props.rating);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.rating !== nextProps.rating) {
	        this.mapRatingToArray(nextProps.rating);
	      }
	    }
	  }, {
	    key: 'mapRatingToArray',
	    value: function mapRatingToArray(rating) {
	      var precision = rating - Math.floor(rating);
	      var full = rating - precision;
	      var half = 0;
	
	      if (precision < 0.25) full = full;else if (precision >= 0.25 && precision < 0.75) half = 0.5;else if (precision >= 0.75) full += 1;
	
	      var ratingMapping = [0, 0, 0, 0, 0];
	
	      for (var i = 0; i < full; i++) {
	        ratingMapping[i] = 1;
	      }
	
	      if (half === 0.5) ratingMapping[full] = 0.5;
	
	      this.setState({ ratingMapping: ratingMapping });
	    }
	  }, {
	    key: 'renderRatingStar',
	    value: function renderRatingStar(ratingMap, i) {
	      if (ratingMap === 1) return _react2.default.createElement('i', { key: i, className: 'rc-icon-star' });else if (ratingMap === 0.5) return _react2.default.createElement('i', { key: i, className: 'rc-icon-star-half' });else return _react2.default.createElement('i', { key: i, className: 'rc-icon-star-outline' });
	    }
	  }, {
	    key: 'renderRatingStars',
	    value: function renderRatingStars() {
	      return this.state.ratingMapping.map(this.renderRatingStar);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'rating-stars', style: { display: this.props.display, fontSize: this.props.size, color: this.props.color, marginBottom: this.props.margin } },
	        this.renderRatingStars()
	      );
	    }
	  }]);
	
	  return ExpertRating;
	}(_react2.default.Component);
	
	exports.default = ExpertRating;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _user_presence = __webpack_require__(531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PresenceIndicator = function (_React$Component) {
	  _inherits(PresenceIndicator, _React$Component);
	
	  function PresenceIndicator(props) {
	    _classCallCheck(this, PresenceIndicator);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PresenceIndicator).call(this, props));
	
	    _this.state = {
	      isWatching: false
	    };
	    return _this;
	  }
	
	  _createClass(PresenceIndicator, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.user && this.props.user.uid && (typeof this.props.presence !== 'number' || this.props.shouldForceWatch)) {
	        this.props.onComponentLoaded(this.props.user.uid);
	        this.setState({ isWatching: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var user = nextProps.user || this.props.user;
	
	      if (user && user.uid && typeof nextProps.presence !== 'number' && !this.state.isWatching) {
	        this.props.onComponentLoaded(user.uid);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.isWatching) {
	        this.props.onComponentUnLoaded(this.props.user.uid);
	      }
	    }
	  }, {
	    key: 'presenceColor',
	    value: function presenceColor(presence) {
	      if (!presence || (typeof presence === 'undefined' ? 'undefined' : _typeof(presence)) === 'object' && Object.keys(presence).length === 0) {
	        presence = _constants.PRESENCE.OFFLINE;
	      }
	
	      return _constants.PRESENCE_COLORS[presence];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { className: 'presence-indicator', style: { backgroundColor: this.presenceColor(this.props.presence), height: this.props.size, width: this.props.size } });
	    }
	  }]);
	
	  return PresenceIndicator;
	}(_react2.default.Component);
	
	PresenceIndicator.defaultProps = {
	  size: 10,
	  presence: _constants.PRESENCE.OFFLINE
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var presence = ownProps.presence;
	
	  if (ownProps.user && ownProps.user.uid) {
	    presence = state.getIn(['presences', ownProps.user.uid]);
	  }
	
	  return {
	    presence: presence
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    onComponentLoaded: _user_presence.watchCurrentUserPresence,
	    onComponentUnLoaded: _user_presence.unwatchCurrentUserPresence
	  };
	};
	
	var PresenceIndicatorContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PresenceIndicator);
	
	exports.default = PresenceIndicatorContainer;

/***/ },
/* 80 */,
/* 81 */,
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var stackClear = __webpack_require__(401),
	    stackDelete = __webpack_require__(402),
	    stackGet = __webpack_require__(403),
	    stackHas = __webpack_require__(404),
	    stackSet = __webpack_require__(405);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function Stack(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = values[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(11);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(365),
	    keys = __webpack_require__(41);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 85 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*!
	 * verge 1.9.1+201402130803
	 * https://github.com/ryanve/verge
	 * MIT License 2013 Ryan Van Etten
	 */
	
	(function(root, name, make) {
	  if (typeof module != 'undefined' && module['exports']) module['exports'] = make();
	  else root[name] = make();
	}(this, 'verge', function() {
	
	  var xports = {}
	    , win = typeof window != 'undefined' && window
	    , doc = typeof document != 'undefined' && document
	    , docElem = doc && doc.documentElement
	    , matchMedia = win['matchMedia'] || win['msMatchMedia']
	    , mq = matchMedia ? function(q) {
	        return !!matchMedia.call(win, q).matches;
	      } : function() {
	        return false;
	      }
	    , viewportW = xports['viewportW'] = function() {
	        var a = docElem['clientWidth'], b = win['innerWidth'];
	        return a < b ? b : a;
	      }
	    , viewportH = xports['viewportH'] = function() {
	        var a = docElem['clientHeight'], b = win['innerHeight'];
	        return a < b ? b : a;
	      };
	  
	  /** 
	   * Test if a media query is active. Like Modernizr.mq
	   * @since 1.6.0
	   * @return {boolean}
	   */  
	  xports['mq'] = mq;
	
	  /** 
	   * Normalized matchMedia
	   * @since 1.6.0
	   * @return {MediaQueryList|Object}
	   */ 
	  xports['matchMedia'] = matchMedia ? function() {
	    // matchMedia must be binded to window
	    return matchMedia.apply(win, arguments);
	  } : function() {
	    // Gracefully degrade to plain object
	    return {};
	  };
	
	  /**
	   * @since 1.8.0
	   * @return {{width:number, height:number}}
	   */
	  function viewport() {
	    return {'width':viewportW(), 'height':viewportH()};
	  }
	  xports['viewport'] = viewport;
	  
	  /** 
	   * Cross-browser window.scrollX
	   * @since 1.0.0
	   * @return {number}
	   */
	  xports['scrollX'] = function() {
	    return win.pageXOffset || docElem.scrollLeft; 
	  };
	
	  /** 
	   * Cross-browser window.scrollY
	   * @since 1.0.0
	   * @return {number}
	   */
	  xports['scrollY'] = function() {
	    return win.pageYOffset || docElem.scrollTop; 
	  };
	
	  /**
	   * @param {{top:number, right:number, bottom:number, left:number}} coords
	   * @param {number=} cushion adjustment
	   * @return {Object}
	   */
	  function calibrate(coords, cushion) {
	    var o = {};
	    cushion = +cushion || 0;
	    o['width'] = (o['right'] = coords['right'] + cushion) - (o['left'] = coords['left'] - cushion);
	    o['height'] = (o['bottom'] = coords['bottom'] + cushion) - (o['top'] = coords['top'] - cushion);
	    return o;
	  }
	
	  /**
	   * Cross-browser element.getBoundingClientRect plus optional cushion.
	   * Coords are relative to the top-left corner of the viewport.
	   * @since 1.0.0
	   * @param {Element|Object} el element or stack (uses first item)
	   * @param {number=} cushion +/- pixel adjustment amount
	   * @return {Object|boolean}
	   */
	  function rectangle(el, cushion) {
	    el = el && !el.nodeType ? el[0] : el;
	    if (!el || 1 !== el.nodeType) return false;
	    return calibrate(el.getBoundingClientRect(), cushion);
	  }
	  xports['rectangle'] = rectangle;
	
	  /**
	   * Get the viewport aspect ratio (or the aspect ratio of an object or element)
	   * @since 1.7.0
	   * @param {(Element|Object)=} o optional object with width/height props or methods
	   * @return {number}
	   * @link http://w3.org/TR/css3-mediaqueries/#orientation
	   */
	  function aspect(o) {
	    o = null == o ? viewport() : 1 === o.nodeType ? rectangle(o) : o;
	    var h = o['height'], w = o['width'];
	    h = typeof h == 'function' ? h.call(o) : h;
	    w = typeof w == 'function' ? w.call(o) : w;
	    return w/h;
	  }
	  xports['aspect'] = aspect;
	
	  /**
	   * Test if an element is in the same x-axis section as the viewport.
	   * @since 1.0.0
	   * @param {Element|Object} el
	   * @param {number=} cushion
	   * @return {boolean}
	   */
	  xports['inX'] = function(el, cushion) {
	    var r = rectangle(el, cushion);
	    return !!r && r.right >= 0 && r.left <= viewportW();
	  };
	
	  /**
	   * Test if an element is in the same y-axis section as the viewport.
	   * @since 1.0.0
	   * @param {Element|Object} el
	   * @param {number=} cushion
	   * @return {boolean}
	   */
	  xports['inY'] = function(el, cushion) {
	    var r = rectangle(el, cushion);
	    return !!r && r.bottom >= 0 && r.top <= viewportH();
	  };
	
	  /**
	   * Test if an element is in the viewport.
	   * @since 1.0.0
	   * @param {Element|Object} el
	   * @param {number=} cushion
	   * @return {boolean}
	   */
	  xports['inViewport'] = function(el, cushion) {
	    // Equiv to `inX(el, cushion) && inY(el, cushion)` but just manually do both 
	    // to avoid calling rectangle() twice. It gzips just as small like this.
	    var r = rectangle(el, cushion);
	    return !!r && r.bottom >= 0 && r.right >= 0 && r.top <= viewportH() && r.left <= viewportW();
	  };
	
	  return xports;
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ },
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(48);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the associative array.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function assocDelete(array, key) {
	  var index = assocIndexOf(array, key);
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = array.length - 1;
	  if (index == lastIndex) {
	    array.pop();
	  } else {
	    splice.call(array, index, 1);
	  }
	  return true;
	}
	
	module.exports = assocDelete;


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(48);
	
	/**
	 * Gets the associative array value for `key`.
	 *
	 * @private
	 * @param {Array} array The array to query.
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function assocGet(array, key) {
	  var index = assocIndexOf(array, key);
	  return index < 0 ? undefined : array[index][1];
	}
	
	module.exports = assocGet;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(48);
	
	/**
	 * Checks if an associative array value for `key` exists.
	 *
	 * @private
	 * @param {Array} array The array to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function assocHas(array, key) {
	  return assocIndexOf(array, key) > -1;
	}
	
	module.exports = assocHas;


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(48);
	
	/**
	 * Sets the associative array `key` to `value`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 */
	function assocSet(array, key, value) {
	  var index = assocIndexOf(array, key);
	  if (index < 0) {
	    array.push([key, value]);
	  } else {
	    array[index][1] = value;
	  }
	}
	
	module.exports = assocSet;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(102),
	    isKey = __webpack_require__(50),
	    toKey = __webpack_require__(35);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(56);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	  // that are composed entirely of index properties, return `false` for
	  // `hasOwnProperty` checks of them.
	  return hasOwnProperty.call(object, key) ||
	    (typeof object == 'object' && key in object && getPrototype(object) === null);
	}
	
	module.exports = baseHas;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(368),
	    isObject = __webpack_require__(18),
	    isObjectLike = __webpack_require__(24);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 101 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(10),
	    stringToPath = __webpack_require__(290);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	module.exports = castPath;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(362);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var index = -1,
	      isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      isUnordered = bitmask & UNORDERED_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(array, other);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isUnordered) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue ||
	              equalFunc(arrValue, othValue, customizer, bitmask, stack);
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(51);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @param {Object} hash The hash to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(hash, key) {
	  return nativeCreate ? hash[key] !== undefined : hasOwnProperty.call(hash, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(376),
	    isArguments = __webpack_require__(65),
	    isArray = __webpack_require__(10),
	    isLength = __webpack_require__(52),
	    isString = __webpack_require__(110);
	
	/**
	 * Creates an array of index keys for `object` values of arrays,
	 * `arguments` objects, and strings, otherwise `null` is returned.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array|null} Returns index keys, else `null`.
	 */
	function indexKeys(object) {
	  var length = object ? object.length : undefined;
	  if (isLength(length) &&
	      (isArray(object) || isString(object) || isArguments(object))) {
	    return baseTimes(length, String);
	  }
	  return null;
	}
	
	module.exports = indexKeys;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 107 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 108 */
/***/ function(module, exports) {

	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 109 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(10),
	    isObjectLike = __webpack_require__(24);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(361),
	    baseFilter = __webpack_require__(364),
	    baseIteratee = __webpack_require__(37),
	    isArray = __webpack_require__(10);
	
	/**
	 * The opposite of `_.filter`; this method returns the elements of `collection`
	 * that `predicate` does **not** return truthy for.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|Object|string} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.filter
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': true }
	 * ];
	 *
	 * _.reject(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.reject(users, { 'age': 40, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.reject(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.reject(users, 'active');
	 * // => objects for ['barney']
	 */
	function reject(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  predicate = baseIteratee(predicate, 3);
	  return func(collection, function(value, index, collection) {
	    return !predicate(value, index, collection);
	  });
	}
	
	module.exports = reject;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(232),
	    toInteger = __webpack_require__(235);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as
	 * an array.
	 *
	 * **Note:** This method is based on the
	 * [rest parameter](https://mdn.io/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.rest(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function rest(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, array);
	      case 1: return func.call(this, args[0], array);
	      case 2: return func.call(this, args[0], args[1], array);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = rest;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(379),
	    keys = __webpack_require__(41);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object ? baseValues(object, keys(object)) : [];
	}
	
	module.exports = values;


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : afrikaans (af)
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	}));

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Moroccan Arabic (ar-ma)
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_ma = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ma;
	
	}));

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic Saudi Arabia (ar-sa)
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var ar_sa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_sa;
	
	}));

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  : Tunisian Arabic (ar-tn)
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_tn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ar_tn;
	
	}));

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! Locale: Arabic (ar)
	//! Author: Abdel Said: https://github.com/abdelsaid
	//! Changes in months, weekdays: Ahmed Elkhatib
	//! Native plural forms: forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'كانون الثاني يناير',
	        'شباط فبراير',
	        'آذار مارس',
	        'نيسان أبريل',
	        'أيار مايو',
	        'حزيران يونيو',
	        'تموز يوليو',
	        'آب أغسطس',
	        'أيلول سبتمبر',
	        'تشرين الأول أكتوبر',
	        'تشرين الثاني نوفمبر',
	        'كانون الأول ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	}));

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : azerbaijani (az)
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	}));

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : belarusian (be)
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        ordinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	}));

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : bulgarian (bg)
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	}));

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (bn)
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রব_সম_মঙ্গ_বু_ব্রিহ_শু_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	}));

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : tibetan (bo)
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	}));

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : breton (br)
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        ordinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	}));

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : bosnian (bs)
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	}));

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : catalan (ca)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	}));

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : czech (cs)
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	}));

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : chuvash (cv)
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        ordinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	}));

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh (cy)
	//! author : Robert Allen
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	}));

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : danish (da)
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[I dag kl.] LT',
	            nextDay : '[I morgen kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[I går kl.] LT',
	            lastWeek : '[sidste] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	}));

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : austrian german (de-at)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de_at = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de_at;
	
	}));

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : german (de)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	}));

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : dhivehi (dv)
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	
	}));

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : modern greek (el)
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        ordinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	}));

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : australian english (en-au)
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_au = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_au;
	
	}));

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : canadian english (en-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ca = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return en_ca;
	
	}));

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : great britain english (en-gb)
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_gb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_gb;
	
	}));

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish english (en-ie)
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ie = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_ie;
	
	}));

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : New Zealand english (en-nz)
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_nz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_nz;
	
	}));

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : esperanto (eo)
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	        weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-an de] MMMM, YYYY',
	            LLL : 'D[-an de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'je %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        ordinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	}));

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : spanish (es)
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	}));

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : estonian (et)
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	}));

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : euskara (eu)
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	}));

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian (fa)
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چندین ثانیه',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        ordinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	}));

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : finnish (fi)
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	}));

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : faroese (fo)
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	}));

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : canadian french (fr-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ca = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        }
	    });
	
	    return fr_ca;
	
	}));

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : swiss french (fr)
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ch = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr_ch;
	
	}));

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : french (fr)
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	}));

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : frisian (fy)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	}));

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : great britain scottish gealic (gd)
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        ordinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	}));

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : galician (gl)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
	        monthsShort : 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
	        weekdaysShort : 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str === 'uns segundos') {
	                    return 'nuns segundos';
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gl;
	
	}));

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew (he)
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	}));

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hindi (hi)
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	}));

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hrvatski (hr)
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	}));

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hungarian (hu)
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hu;
	
	}));

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian (hy-am)
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var hy_am = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hy_am;
	
	}));

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Indonesia (id)
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	}));

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : icelandic (is)
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	}));

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : italian (it)
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	        weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	}));

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : japanese (ja)
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'Ah時m分',
	            LTS : 'Ah時m分s秒',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah時m分',
	            LLLL : 'YYYY年M月D日Ah時m分 dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : '[来週]dddd LT',
	            lastDay : '[昨日] LT',
	            lastWeek : '[前週]dddd LT',
	            sameElse : 'L'
	        },
	        ordinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	}));

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Boso Jowo (jv)
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	}));

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian (ka)
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	}));

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : kazakh (kk)
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	
	}));

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : khmer (km)
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	}));

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : korean (ko)
	//!
	//! authors
	//!
	//! - Kyungwook, Park : https://github.com/kyungw00k
	//! - Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h시 m분',
	            LTS : 'A h시 m분 s초',
	            L : 'YYYY.MM.DD',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h시 m분',
	            LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '일분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        ordinalParse : /\d{1,2}일/,
	        ordinal : '%d일',
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	}));

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : kyrgyz (ky)
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кече саат] LT',
	            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ky;
	
	}));

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish (lb)
	//! author : mweimerskirch : https://github.com/mweimerskirch, David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	}));

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : lao (lo)
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        ordinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	}));

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian (lt)
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_')
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	}));

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : latvian (lv)
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	}));

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin (me)
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	}));

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : macedonian (mk)
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	}));

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : malayalam (ml)
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	}));

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi (mr)
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	}));

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms_my = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms_my;
	
	}));

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	}));

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese (my)
	//! author : Squar team, mysquar.com
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	}));

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : norwegian bokmål (nb)
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	}));

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : nepali/nepalese
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	}));

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : dutch (nl)
	//! author : Joris Röling : https://github.com/jjupiter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	}));

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : norwegian nynorsk (nn)
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	}));

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : punjabi india (pa-in)
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var pa_in = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return pa_in;
	
	}));

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : polish (pl)
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	}));

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : brazilian portuguese (pt-br)
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt_br = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : '%s atrás',
	            s : 'poucos segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return pt_br;
	
	}));

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : portuguese (pt)
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	}));

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : romanian (ro)
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	}));

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : russian (ru)
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        monthsRegex: /^(сентябр[яь]|октябр[яь]|декабр[яь]|феврал[яь]|январ[яь]|апрел[яь]|августа?|ноябр[яь]|сент\.|февр\.|нояб\.|июнь|янв.|июль|дек.|авг.|апр.|марта|мар[.т]|окт.|июн[яь]|июл[яь]|ма[яй])/i,
	        monthsShortRegex: /^(сентябр[яь]|октябр[яь]|декабр[яь]|феврал[яь]|январ[яь]|апрел[яь]|августа?|ноябр[яь]|сент\.|февр\.|нояб\.|июнь|янв.|июль|дек.|авг.|апр.|марта|мар[.т]|окт.|июн[яь]|июл[яь]|ма[яй])/i,
	        monthsStrictRegex: /^(сентябр[яь]|октябр[яь]|декабр[яь]|феврал[яь]|январ[яь]|апрел[яь]|августа?|ноябр[яь]|марта?|июн[яь]|июл[яь]|ма[яй])/i,
	        monthsShortStrictRegex: /^(нояб\.|февр\.|сент\.|июль|янв\.|июн[яь]|мар[.т]|авг\.|апр\.|окт\.|дек\.|ма[яй])/i,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ru;
	
	}));

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami (se)
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	}));

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese (si)
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        ordinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	}));

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : slovak (sk)
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	}));

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : slovenian (sl)
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	}));

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian (sq)
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author: Menelion Elensúle: https://github.com/Oire (tests)
	//! author : Oerd Cukalla : https://github.com/oerd (fixes)
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	}));

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian-cyrillic (sr-cyrl)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr_cyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr_cyrl;
	
	}));

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian-latin (sr)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	}));

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati (ss)
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	}));

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : swedish (sv)
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	}));

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : swahili (sw)
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	
	}));

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : tamil (ta)
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        ordinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	}));

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : telugu (te)
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        ordinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	
	}));

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : thai (th)
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'มกรา_กุมภา_มีนา_เมษา_พฤษภา_มิถุนา_กรกฎา_สิงหา_กันยา_ตุลา_พฤศจิกา_ธันวา'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H นาฬิกา m นาที',
	            LTS : 'H นาฬิกา m นาที s วินาที',
	            L : 'YYYY/MM/DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H นาฬิกา m นาที',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H นาฬิกา m นาที'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	}));

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog/Filipino (tl-ph)
	//! author : Dan Hagman
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tl_ph = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ngayon sa] LT',
	            nextDay: '[Bukas sa] LT',
	            nextWeek: 'dddd [sa] LT',
	            lastDay: '[Kahapon sa] LT',
	            lastWeek: 'dddd [huling linggo] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tl_ph;
	
	}));

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon (tlh)
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	    	time.slice(0, -3) + 'leS' :
	    	(output.indexOf('jar') !== -1) ?
	    	time.slice(0, -3) + 'waQ' :
	    	(output.indexOf('DIS') !== -1) ?
	    	time.slice(0, -3) + 'nem' :
	    	time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	    	time.slice(0, -3) + 'Hu’' :
	    	(output.indexOf('jar') !== -1) ?
	    	time.slice(0, -3) + 'wen' :
	    	(output.indexOf('DIS') !== -1) ?
	    	time.slice(0, -3) + 'ben' :
	    	time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	    	ten = Math.floor((number % 100) / 10),
	    	one = number % 10,
	    	word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	}));

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : turkish (tr)
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[haftaya] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen hafta] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	}));

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : talossan (tzl)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v with the help of Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	}));

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt in Latin (tzm-latn)
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm_latn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm_latn;
	
	}));

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt (tzm)
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	}));

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : ukrainian (uk)
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        },
	        nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	}));

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : uzbek (uz)
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	}));

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : vietnamese (vi)
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	}));

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : pseudo (x-pseudo)
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var x_pseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return x_pseudo;
	
	}));

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : chinese (zh-cn)
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_cn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah点mm分',
	            LTS : 'Ah点m分s秒',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah点mm分',
	            LLLL : 'YYYY年MMMD日ddddAh点mm分',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah点mm分',
	            llll : 'YYYY年MMMD日ddddAh点mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : function () {
	                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	            },
	            nextDay : function () {
	                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	            },
	            lastDay : function () {
	                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	            },
	            nextWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            lastWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            sameElse : 'LL'
	        },
	        ordinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zh_cn;
	
	}));

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : traditional chinese (zh-tw)
	//! author : Ben : https://github.com/ben-lin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_tw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '1分鐘',
	            mm : '%d分鐘',
	            h : '1小時',
	            hh : '%d小時',
	            d : '1天',
	            dd : '%d天',
	            M : '1個月',
	            MM : '%d個月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return zh_tw;
	
	}));

/***/ },
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  } else {
	    var _ret = function () {
	      var last = funcs[funcs.length - 1];
	      var rest = funcs.slice(0, -1);
	      return {
	        v: function v() {
	          return rest.reduceRight(function (composed, f) {
	            return f(composed);
	          }, last.apply(undefined, arguments));
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	}

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports["default"] = createStore;
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(431);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [initialState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, initialState, enhancer) {
	  var _ref2;
	
	  if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = initialState;
	    initialState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, initialState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = initialState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2["default"])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2["default"]] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2["default"]] = observable, _ref2;
	}

/***/ },
/* 220 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _update = __webpack_require__(38);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _wrap = __webpack_require__(39);
	
	var _wrap2 = _interopRequireDefault(_wrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateIfElse(predicate, trueUpdates, falseUpdates, object) {
	  var test = typeof predicate === 'function' ? predicate(object) : predicate;
	
	  var updates = test ? trueUpdates : falseUpdates;
	
	  return (0, _update2.default)(updates, object);
	}
	
	exports.default = (0, _wrap2.default)(updateIfElse);

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _update = __webpack_require__(38);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _wrap = __webpack_require__(39);
	
	var _wrap2 = _interopRequireDefault(_wrap);
	
	var _forEach = __webpack_require__(406);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _map = __webpack_require__(292);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _mapValues = __webpack_require__(412);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shallowEqual(object, otherObject) {
	  var equal = true;
	  (0, _forEach2.default)(otherObject, function (value, key) {
	    if (value !== object[key]) {
	      equal = false;
	
	      // exit early
	      return false;
	    }
	  });
	
	  return equal;
	}
	
	function map(iteratee, object) {
	  var updater = typeof iteratee === 'function' ? iteratee : (0, _update2.default)(iteratee);
	
	  var mapper = Array.isArray(object) ? _map2.default : _mapValues2.default;
	
	  var newObject = mapper(object, updater);
	  var equal = shallowEqual(object, newObject);
	
	  return equal ? object : newObject;
	}
	
	exports.default = (0, _wrap2.default)(map);

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = splitPath;
	
	var _reject = __webpack_require__(111);
	
	var _reject2 = _interopRequireDefault(_reject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function splitPath(path) {
	  return Array.isArray(path) ? path : (0, _reject2.default)(path.split('.'), function (x) {
	    return !x;
	  });
	}

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (user) {
	  return { type: _action_types.SET_USER, user: user };
	};

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (presence, uid) {
	  var state = _store2.default.getState();
	
	  if (!uid) uid = state.getIn(['currentUser', 'uid']);
	
	  console.log('setting current user presence', presence, uid, state.getIn(['currentUser', 'uid']));
	
	  if (!uid) return;
	
	  var ENDPOINT = _constants.PRESENCE_ENDPOINT + '/' + uid;
	  _firedux2.default.ref.child(ENDPOINT).set(presence);
	};

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchGroupChats = exports.watchGroupChats = exports.unwatchDeletedGroupChats = exports.watchDeletedGroupChats = exports.unwatchSuperPrivateGroupChats = exports.watchSuperPrivateGroupChats = exports.unwatchPrivateGroupChats = exports.watchPrivateGroupChats = exports.unwatchGlobalGroupChats = exports.watchGlobalGroupChats = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_group_chats = __webpack_require__(299);
	
	var _set_group_chats2 = _interopRequireDefault(_set_group_chats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onGroups = function onGroups(scope, snapshot) {
	  return (0, _store.dispatch)((0, _set_group_chats2.default)(snapshot.val(), scope));
	};
	var onGlobalGroups = function onGlobalGroups(snapshot) {
	  return onGroups(_constants.GROUP_CHAT_SCOPES.GLOBAL, snapshot);
	};
	var onPrivateGroups = function onPrivateGroups(snapshot) {
	  return onGroups(_constants.GROUP_CHAT_SCOPES.PRIVATE, snapshot);
	};
	var onSuperPrivateGroups = function onSuperPrivateGroups(snapshot) {
	  return onGroups(_constants.GROUP_CHAT_SCOPES.SUPER_PRIVATE, snapshot);
	};
	var onDeletedGroups = function onDeletedGroups(snapshot) {
	  return onGroups(_constants.GROUP_CHAT_SCOPES.DELETED, snapshot);
	};
	
	var watchGlobalGroupChats = exports.watchGlobalGroupChats = function watchGlobalGroupChats() {
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_ENDPOINT).child(_constants.GROUP_CHAT_SCOPES.GLOBAL);
	
	  ref.on('value', onGlobalGroups);
	};
	
	var unwatchGlobalGroupChats = exports.unwatchGlobalGroupChats = function unwatchGlobalGroupChats() {
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_ENDPOINT).child(_constants.GROUP_CHAT_SCOPES.GLOBAL);
	
	  ref.off('value', onGlobalGroups);
	};
	
	var watchPrivateGroupChats = exports.watchPrivateGroupChats = function watchPrivateGroupChats() {
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_ENDPOINT).child(_constants.GROUP_CHAT_SCOPES.PRIVATE);
	
	  ref.on('value', onPrivateGroups);
	};
	
	var unwatchPrivateGroupChats = exports.unwatchPrivateGroupChats = function unwatchPrivateGroupChats() {
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_ENDPOINT).child(_constants.GROUP_CHAT_SCOPES.PRIVATE);
	
	  ref.off('value', onPrivateGroups);
	};
	
	var watchSuperPrivateGroupChats = exports.watchSuperPrivateGroupChats = function watchSuperPrivateGroupChats() {
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_ENDPOINT).child(_constants.GROUP_CHAT_SCOPES.SUPER_PRIVATE);
	
	  ref.on('value', onSuperPrivateGroups);
	};
	
	var unwatchSuperPrivateGroupChats = exports.unwatchSuperPrivateGroupChats = function unwatchSuperPrivateGroupChats() {
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_ENDPOINT).child(_constants.GROUP_CHAT_SCOPES.SUPER_PRIVATE);
	
	  ref.off('value', onSuperPrivateGroups);
	};
	
	var watchDeletedGroupChats = exports.watchDeletedGroupChats = function watchDeletedGroupChats() {
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_ENDPOINT).child(_constants.GROUP_CHAT_SCOPES.DELETED);
	
	  ref.on('value', onDeletedGroups);
	};
	
	var unwatchDeletedGroupChats = exports.unwatchDeletedGroupChats = function unwatchDeletedGroupChats() {
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_ENDPOINT).child(_constants.GROUP_CHAT_SCOPES.DELETED);
	
	  ref.off('value', onDeletedGroups);
	};
	
	var watchGroupChats = exports.watchGroupChats = function watchGroupChats() {
	  watchGlobalGroupChats();
	  watchPrivateGroupChats();
	  watchSuperPrivateGroupChats();
	};
	
	var unwatchGroupChats = exports.unwatchGroupChats = function unwatchGroupChats() {
	  unwatchGlobalGroupChats();
	  unwatchPrivateGroupChats();
	  unwatchSuperPrivateGroupChats();
	};

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _show_modal = __webpack_require__(16);
	
	var _show_modal2 = _interopRequireDefault(_show_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PHONE = _constants.VIEWPORT_TYPES.PHONE;
	
	var GroupChatSubscribeButton = function (_React$Component) {
	  _inherits(GroupChatSubscribeButton, _React$Component);
	
	  function GroupChatSubscribeButton(props) {
	    _classCallCheck(this, GroupChatSubscribeButton);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GroupChatSubscribeButton).call(this, props));
	
	    _this.state = {};
	
	    _this.blur = _this.blur.bind(_this);
	    _this.focus = _this.focus.bind(_this);
	    _this.openSubscriptionModal = _this.openSubscriptionModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(GroupChatSubscribeButton, [{
	    key: 'blur',
	    value: function blur() {
	      this.setState({ isFocused: false });
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.setState({ isFocused: true });
	    }
	  }, {
	    key: 'openSubscriptionModal',
	    value: function openSubscriptionModal(e) {
	      if (e && e.preventDefault) e.preventDefault();
	      this.setState({ isFocused: false });
	
	      var _props = this.props;
	      var uid = _props.uid;
	      var groupId = _props.groupId;
	      var source = _props.source;
	
	      this.props.showModal({ type: 'groupSubscribe', identifier: 'group-chat-subscription-modal', props: { uid: uid, groupId: groupId, source: source } });
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel(text) {
	      if (this.props.shouldShowLabels && this.props.viewportType !== PHONE) {
	        return _react2.default.createElement(
	          'span',
	          { style: { verticalAlign: 'middle' } },
	          text
	        );
	      }
	    }
	  }, {
	    key: 'renderSubscribedButton',
	    value: function renderSubscribedButton() {
	      var width = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? this.props.width : 'auto';
	      var marginRight = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? 4 : null;
	
	      if (this.state.isFocused) {
	        return _react2.default.createElement(
	          'a',
	          { href: '#', title: 'Change Subscription for Email Notifications', className: 'btn btn-warning btn-sm', onMouseLeave: this.blur, onClick: this.openSubscriptionModal },
	          _react2.default.createElement(
	            'div',
	            { style: { width: width, textAlign: 'left' } },
	            _react2.default.createElement('i', { className: 'rc-icon-subscribe', style: { marginRight: marginRight, verticalAlign: 'middle', fontSize: 16 } }),
	            this.renderLabel('Change')
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'a',
	          { href: '#', className: 'btn btn-success btn-sm', onMouseEnter: this.focus, onTouchEnd: this.openSubscriptionModal },
	          _react2.default.createElement(
	            'div',
	            { style: { width: width, textAlign: 'left' } },
	            _react2.default.createElement('i', { className: 'rc-icon-subscribe', style: { marginRight: marginRight, verticalAlign: 'middle', fontSize: 16 } }),
	            this.renderLabel('Notifications')
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderUnSubscribedButton',
	    value: function renderUnSubscribedButton() {
	      var width = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? this.props.width : 'auto';
	      var marginRight = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? 4 : null;
	
	      return _react2.default.createElement(
	        'a',
	        { href: '#', title: 'Subscribe for Email Notifications', className: 'btn btn-success btn-sm btn-stripped', onClick: this.openSubscriptionModal },
	        _react2.default.createElement(
	          'div',
	          { style: { width: width, textAlign: 'left' } },
	          _react2.default.createElement('i', { className: 'rc-icon-subscribe', style: { marginRight: marginRight, verticalAlign: 'middle', fontSize: 16 } }),
	          this.renderLabel('Notifications')
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.uid) return false;
	      if (this.props.subscribedGroup) return this.renderSubscribedButton();
	
	      return this.renderUnSubscribedButton();
	    }
	  }]);
	
	  return GroupChatSubscribeButton;
	}(_react2.default.Component);
	
	GroupChatSubscribeButton.defaultProps = {
	  width: 90,
	  shouldShowLabels: true
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var uid = void 0,
	      subscribedGroup = void 0;
	
	  if (ownProps.source === 'user') {
	    uid = ownProps.uid;
	    subscribedGroup = state.getIn(['groups', '_subscriptions', 'groups', ownProps.groupId, uid]);
	  } else {
	    uid = state.getIn(['currentUser', 'uid']);
	    subscribedGroup = state.getIn(['groups', '_subscriptions', 'users', uid, ownProps.groupId]);
	  }
	
	  return {
	    uid: uid,
	    subscribedGroup: subscribedGroup,
	    viewportType: state.getIn(['viewport', 'type'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    showModal: function showModal(modal) {
	      return dispatch((0, _show_modal2.default)(modal));
	    }
	  };
	};
	
	var GroupChatSubscribeButtonContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GroupChatSubscribeButton);
	
	exports.default = GroupChatSubscribeButtonContainer;

/***/ },
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(53);
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var splice = Array.prototype.splice;
	
	var assign = Object.assign || function assign(target, source) {
	  var keys = getAllKeys(source);
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (hasOwnProperty.call(source, key)) {
	      target[key] = source[key];
	    }
	  }
	  return target;
	}
	
	var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ?
	  function(obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)) } :
	  function(obj) { return Object.keys(obj) }
	;
	
	function copy(object) {
	  if (object instanceof Array) {
	    return object.slice();
	  } else if (object && typeof object === 'object') {
	    return assign(new object.constructor(), object);
	  } else {
	    return object;
	  }
	}
	
	
	function newContext() {
	  var commands = assign({}, defaultCommands);
	  update.extend = function(directive, fn) {
	    commands[directive] = fn;
	  }
	
	  return update;
	
	  function update(object, spec) {
	    invariant(
	      !Array.isArray(spec),
	      'update(): You provided an invalid spec to update(). The spec may ' +
	      'not contain an array except as the value of $set, $push, $unshift, ' +
	      '$splice or any custom command allowing an array value.'
	    );
	
	    invariant(
	      typeof spec === 'object' && spec !== null,
	      'update(): You provided an invalid spec to update(). The spec and ' +
	      'every included key path must be plain objects containing one of the ' +
	      'following commands: %s.',
	      Object.keys(commands).join(', ')
	    );
	
	    var nextObject = object;
	    var specKeys = getAllKeys(spec)
	    var index, key;
	    for (index = 0; index < specKeys.length; index++) {
	      var key = specKeys[index];
	      if (hasOwnProperty.call(commands, key)) {
	        nextObject = commands[key](spec[key], nextObject, spec, object);
	      } else {
	        var nextValueForKey = update(object[key], spec[key]);
	        if (nextValueForKey !== nextObject[key]) {
	          if (nextObject === object) {
	            nextObject = copy(object);
	          }
	          nextObject[key] = nextValueForKey;
	        }
	      }
	    }
	    return nextObject;
	  }
	
	}
	
	var defaultCommands = {
	  $push: function(value, original, spec) {
	    invariantPushAndUnshift(original, spec, '$push');
	    return original.concat(value);
	  },
	  $unshift: function(value, original, spec) {
	    invariantPushAndUnshift(original, spec, '$unshift');
	    return value.concat(original);
	  },
	  $splice: function(value, nextObject, spec, object) {
	    var originalValue = nextObject === object ? copy(object) : nextObject;
	    invariantSplices(originalValue, spec);
	    value.forEach(function(args) {
	      invariantSplice(args);
	      splice.apply(originalValue, args);
	    });
	    return originalValue;
	  },
	  $set: function(value, original, spec) {
	    invariantSet(spec);
	    return value;
	  },
	  $merge: function(value, nextObject, spec, object) {
	    var originalValue = nextObject === object ? copy(object) : nextObject;
	    invariantMerge(originalValue, value);
	    getAllKeys(value).forEach(function(key) {
	      originalValue[key] = value[key];
	    });
	    return originalValue;
	  },
	  $apply: function(value, original) {
	    invariantApply(value);
	    return value(original);
	  }
	};
	
	
	
	module.exports = newContext();
	module.exports.newContext = newContext;
	
	
	// invariants
	
	function invariantPushAndUnshift(value, spec, command) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected target of %s to be an array; got %s.',
	    command,
	    value
	  );
	  var specValue = spec[command];
	  invariant(
	    Array.isArray(specValue),
	    'update(): expected spec of %s to be an array; got %s. ' +
	    'Did you forget to wrap your parameter in an array?',
	    command,
	    specValue
	  );
	}
	
	function invariantSplices(value, spec) {
	  invariant(
	    Array.isArray(value),
	    'Expected $splice target to be an array; got %s',
	    value
	  );
	  invariantSplice(spec['$splice']);
	}
	
	function invariantSplice(value) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected spec of $splice to be an array of arrays; got %s. ' +
	    'Did you forget to wrap your parameters in an array?',
	    value
	  );
	}
	
	function invariantApply(fn) {
	  invariant(
	    typeof fn === 'function',
	    'update(): expected spec of $apply to be a function; got %s.',
	    fn
	  );
	}
	
	function invariantSet(spec) {
	  invariant(
	    Object.keys(spec).length === 1,
	    'Cannot have more than one key in an object with $set'
	  );
	}
	
	function invariantMerge(target, specValue) {
	  invariant(
	    specValue && typeof specValue === 'object',
	    'update(): $merge expects a spec of type \'object\'; got %s',
	    specValue
	  );
	  invariant(
	    target && typeof target === 'object',
	    'update(): $merge expects a target of type \'object\'; got %s',
	    target
	  );
	}


/***/ },
/* 232 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  var length = args.length;
	  switch (length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 233 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 234 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing wrapper metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(236);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3');
	 * // => 3
	 */
	function toInteger(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  var remainder = value % 1;
	  return value === value ? (remainder ? value - remainder : value) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(57),
	    isObject = __webpack_require__(18),
	    isSymbol = __webpack_require__(44);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3);
	 * // => 3
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3');
	 * // => 3
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = isFunction(value.valueOf) ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(219);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(430);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(429);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(428);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(218);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(220);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2["default"])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2["default"];
	exports.combineReducers = _combineReducers2["default"];
	exports.bindActionCreators = _bindActionCreators2["default"];
	exports.applyMiddleware = _applyMiddleware2["default"];
	exports.compose = _compose2["default"];

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (currentUserUid, viewportType) {
	  var stack = (0, _store.getState)().getIn(['conversations', '_stack', 'list']);
	
	  if (stack) return Promise.resolve(stack);
	
	  var ref = _firedux2.default.ref.child(_constants.CONVERSATION_STACKS_ENDPOINT).child(viewportType).child(currentUserUid);
	
	  return ref.once('value').then(function (snapshot) {
	    return snapshot.val();
	  });
	  // TODO: add dispatcher for setting conversation stack.
	};

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dev = __webpack_require__(40);
	
	var _dev2 = _interopRequireDefault(_dev);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (relativePath) {
	  return '' + _dev2.default.hostUrl + relativePath;
	};

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(2);
	
	exports.default = function (role) {
	  if (!role) return false;
	
	  if (role >= _constants.ROLES.EXPERT) return true;
	
	  return false;
	};

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (currentUserUid, viewportType, stack) {
	  var ref = _firedux2.default.ref.child(_constants.CONVERSATION_STACKS_ENDPOINT).child(viewportType).child(currentUserUid);
	
	  if (_immutable.List.isList(stack)) stack = stack.toJS();
	
	  return ref.set(stack);
	};

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _firebase = __webpack_require__(33);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (type, notificationData) {
	  if (!type || !notificationData) return Promise.resolve();
	
	  var ENDPOINT = _constants.NOTIFICATIONS_ENDPOINT + '/' + type;
	
	  var notification = (0, _immutable.Map)({ time: _firebase2.default.ServerValue.TIMESTAMP }).merge(notificationData).toJS();
	
	  return _firedux2.default.ref.child(ENDPOINT).push(notification);
	};

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchPresences = exports.watchPresences = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_presences = __webpack_require__(301);
	
	var _set_presences2 = _interopRequireDefault(_set_presences);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var watchPresences = exports.watchPresences = function watchPresences() {
	  _firedux2.default.ref.child(_constants.PRESENCE_ENDPOINT).on('value', function (snapshot) {
	    if (snapshot.val()) (0, _store.dispatch)((0, _set_presences2.default)(snapshot.val()));
	  });
	};
	
	var unwatchPresences = exports.unwatchPresences = function unwatchPresences() {
	  _firedux2.default.ref.child(_constants.PRESENCE_ENDPOINT).off();
	  (0, _store.dispatch)((0, _set_presences2.default)(null));
	};

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _group_chat_avatar_bookmarked_indicator = __webpack_require__(694);
	
	var _group_chat_avatar_bookmarked_indicator2 = _interopRequireDefault(_group_chat_avatar_bookmarked_indicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupChatAvatar = function GroupChatAvatar(props) {
	  var size = props.size || 36;
	  var initials = props.initials.substring(0, 3);
	  var letterClass = initials.length < 3 ? 'two-letters' : 'three-letters';
	  var fontSize = initials.length < 3 ? size * 0.36 : size * 0.30;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'group-chat-avatar ' + letterClass, style: { width: size, height: size, lineHeight: size + 'px', fontSize: fontSize } },
	    initials,
	    _react2.default.createElement(_group_chat_avatar_bookmarked_indicator2.default, { groupId: props.groupId })
	  );
	};
	
	exports.default = GroupChatAvatar;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _close_all_modals = __webpack_require__(467);
	
	var _close_all_modals2 = _interopRequireDefault(_close_all_modals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalDirector = function (_React$Component) {
	  _inherits(ModalDirector, _React$Component);
	
	  function ModalDirector(props) {
	    _classCallCheck(this, ModalDirector);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ModalDirector).call(this, props));
	
	    _this.closeAllModals = _this.closeAllModals.bind(_this);
	    return _this;
	  }
	
	  _createClass(ModalDirector, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var prevActiveModals = prevProps.activeModals;
	      var activeModals = this.props.activeModals;
	
	
	      if (prevActiveModals !== activeModals) {
	        this.scrollTop();
	      }
	    }
	  }, {
	    key: 'closeAllModals',
	    value: function closeAllModals(e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      this.props.closeAll();
	    }
	  }, {
	    key: 'scrollTop',
	    value: function scrollTop() {
	      var scroller = this.refs.modalContainer;
	
	      if (scroller && scroller.scrollTop) scroller.scrollTop = 0;
	    }
	  }, {
	    key: 'renderActiveModal',
	    value: function renderActiveModal(modal) {
	      var modalType = modal.get('type');
	      var ModalComponent = this.props.modalsList[modalType];
	
	      if (ModalComponent) {
	        return _react2.default.createElement(ModalComponent, modal.get('props').toObject());
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'renderCloseAll',
	    value: function renderCloseAll() {
	      if (this.props.activeModals) {
	        return _react2.default.createElement('span', { className: 'close-modals rc-icon-close', onClick: this.closeAllModals });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (!this.props.activeModals) return false;
	      if (this.props.activeModals.size === 0) return false;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-container', ref: 'modalContainer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-stack' },
	          this.props.activeModals.map(function (modal) {
	            return _this2.renderActiveModal(modal);
	          })
	        ),
	        this.renderCloseAll()
	      );
	    }
	  }]);
	
	  return ModalDirector;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    activeModals: state.get('modals')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    closeAll: function closeAll() {
	      return dispatch((0, _close_all_modals2.default)());
	    }
	  };
	};
	
	var ModalDirectorContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModalDirector);
	
	exports.default = ModalDirectorContainer;

/***/ },
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(63),
	    cachePush = __webpack_require__(380);
	
	/**
	 *
	 * Creates a set cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.push(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(367);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  return !!array.length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 252 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 253 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(27);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Checks if `value` is in `cache`.
	 *
	 * @private
	 * @param {Object} cache The set cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function cacheHas(cache, value) {
	  var map = cache.__data__;
	  if (isKeyable(value)) {
	    var data = map.__data__,
	        hash = typeof value == 'string' ? data.string : data.hash;
	
	    return hash[value] === HASH_UNDEFINED;
	  }
	  return map.has(value);
	}
	
	module.exports = cacheHas;


/***/ },
/* 255 */
/***/ function(module, exports) {

	/** Built-in value references. */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	function getSymbols(object) {
	  // Coerce `object` to an object to avoid non-object errors in V8.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=3443 for more details.
	  return getOwnPropertySymbols(Object(object));
	}
	
	// Fallback for IE < 11.
	if (!getOwnPropertySymbols) {
	  getSymbols = function() {
	    return [];
	  };
	}
	
	module.exports = getSymbols;


/***/ },
/* 256 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument given to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var baseRandom = __webpack_require__(375),
	    isArrayLike = __webpack_require__(32),
	    values = __webpack_require__(113);
	
	/**
	 * Gets a random element from `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to sample.
	 * @returns {*} Returns the random element.
	 * @example
	 *
	 * _.sample([1, 2, 3, 4]);
	 * // => 2
	 */
	function sample(collection) {
	  var array = isArrayLike(collection) ? collection : values(collection),
	      length = array.length;
	
	  return length > 0 ? array[baseRandom(0, length - 1)] : undefined;
	}
	
	module.exports = sample;


/***/ },
/* 258 */
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(8);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var onSigninRequest = _store2.default.getState().getIn(['pluginSettings', 'onSigninRequest']);
	
	  if (typeof onSigninRequest === 'function') onSigninRequest();
	};

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (groupId) {
	  if (!groupId) throw new Error('cannot get group scope because no groupId is given');
	
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_SCOPES_ENDPOINT).child(groupId);
	
	  return ref.once('value').then(function (snapshot) {
	    return snapshot.val();
	  });
	};

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(2);
	
	exports.default = function () {
	  var slotSpanMinutes = _constants.SCHEDULE_SLOT_SPAN;
	  var endOfDay = 24 * 60;
	
	  var slots = [];
	
	  for (var i = 0; i < endOfDay; i += slotSpanMinutes) {
	    slots.push({ available: false });
	  }
	
	  return slots;
	};

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	exports.default = function () {
	  var groupChats = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({}) : arguments[0];
	  var groupChatOrders = arguments.length <= 1 || arguments[1] === undefined ? (0, _immutable.fromJS)({}) : arguments[1];
	
	  groupChatOrders = groupChatOrders === null ? (0, _immutable.fromJS)({}) : groupChatOrders;
	
	  return groupChats.map(function (gc, key) {
	    return gc.set('key', key);
	  }).map(function (gc, key) {
	    return gc.set('order', groupChatOrders.get(key));
	  }).toList().sortBy(function (gc) {
	    return gc.get('order');
	  });
	};

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createExpertSessionRef = undefined;
	
	var _immutable = __webpack_require__(5);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _firebase = __webpack_require__(33);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createExpertSession = function createExpertSession(expertUid, userUid, sessionLength, startTime, type) {
	  // TODO: refactor this after changing users to complete immutable map
	  var expert = (0, _store.getState)().getIn(['users', expertUid]);
	  var user = (0, _store.getState)().getIn(['users', userUid]);
	  var expertName = void 0,
	      userName = void 0;
	
	  if (expert) expertName = _immutable.Map.isMap(expert) ? expert.get('name') : expert.name;
	  if (user) userName = _immutable.Map.isMap(user) ? user.get('name') : user.name;
	
	  var sessionData = {
	    expert: expertUid,
	    expertName: expertName,
	    user: userUid,
	    userName: userName,
	    bookTime: _firebase2.default.ServerValue.TIMESTAMP,
	    type: type,
	    startTime: startTime,
	    sessionLength: sessionLength,
	    status: _constants.SESSION_STATUSES.INITIATED
	  };
	
	  return _firedux2.default.ref.child(_constants.EXPERT_SESSIONS_ENDPOINT).push(sessionData).then(function (snapshot) {
	    return snapshot.key();
	  });
	};
	
	var createExpertSessionRef = exports.createExpertSessionRef = function createExpertSessionRef(uid, otherUid, startTime, sessionId) {
	  var REF_ENDPOINT = (0, _constants.EXPERT_SESSIONS_REF_USER_ENDPOINT)(uid, otherUid);
	
	  if (!startTime) startTime = (0, _moment2.default)().valueOf();
	
	  var sessionRefObj = {
	    sessionId: sessionId, startTime: startTime
	  };
	
	  return _firedux2.default.ref.child(REF_ENDPOINT).child(sessionId).set(sessionRefObj).then(function () {
	    return sessionId;
	  });
	};
	
	exports.default = function (expertUid, userUid, sessionLength) {
	  var startTime = arguments.length <= 3 || arguments[3] === undefined ? (0, _moment2.default)().valueOf() : arguments[3];
	  var type = arguments.length <= 4 || arguments[4] === undefined ? _constants.SESSION_TYPES.IMMEDIATE : arguments[4];
	
	  if (!expertUid) return;
	  if (!userUid) return;
	
	  return createExpertSession(expertUid, userUid, sessionLength, startTime, type).then(createExpertSessionRef.bind(null, userUid, expertUid, startTime)).then(createExpertSessionRef.bind(null, expertUid, userUid, startTime));
	};

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(2);
	
	var _initiate_conversation = __webpack_require__(335);
	
	var _initiate_conversation2 = _interopRequireDefault(_initiate_conversation);
	
	var _conversation_stack = __webpack_require__(241);
	
	var _conversation_stack2 = _interopRequireDefault(_conversation_stack);
	
	var _conversation_stack3 = __webpack_require__(238);
	
	var _conversation_stack4 = _interopRequireDefault(_conversation_stack3);
	
	var _focused_conversation = __webpack_require__(303);
	
	var _focused_conversation2 = _interopRequireDefault(_focused_conversation);
	
	var _stack_visible_slot = __webpack_require__(304);
	
	var _stack_visible_slot2 = _interopRequireDefault(_stack_visible_slot);
	
	var _add_conversation_to_stack = __webpack_require__(305);
	
	var _add_conversation_to_stack2 = _interopRequireDefault(_add_conversation_to_stack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NORMAL = _constants.CONVERSATION_TYPES.NORMAL;
	var EXPERT = _constants.CONVERSATION_TYPES.EXPERT;
	var GROUP = _constants.CONVERSATION_TYPES.GROUP;
	
	
	var updateConversationStack = function updateConversationStack(currentUserUid, targetId, type, viewportType, conversationId) {
	  var focused = (0, _focused_conversation2.default)();
	  var visibleSlot = (0, _stack_visible_slot2.default)();
	
	  return (0, _conversation_stack4.default)(currentUserUid).then(_add_conversation_to_stack2.default.bind(null, conversationId, targetId, focused, visibleSlot, type)).then(_conversation_stack2.default.bind(null, currentUserUid, viewportType));
	};
	
	exports.default = function (currentUserUid, targetId, conversationId, type, viewportType) {
	  if (!conversationId) {
	    if (type === NORMAL || type === EXPERT) {
	      return (0, _initiate_conversation2.default)(currentUserUid, targetId).then(updateConversationStack.bind(null, currentUserUid, targetId, type, viewportType));
	    } else if (type === GROUP) {
	      return (0, _initiate_conversation.initiateGroupChatRefForUser)(currentUserUid, targetId).then(updateConversationStack.bind(null, currentUserUid, targetId, type, viewportType));
	    }
	  } else {
	    return updateConversationStack(currentUserUid, targetId, type, viewportType, conversationId);
	  }
	};

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchAdvertisements = exports.watchAdvertisements = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _set_advertisements = __webpack_require__(297);
	
	var _set_advertisements2 = _interopRequireDefault(_set_advertisements);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onAdvertisements = function onAdvertisements(snapshot) {
	  if (!snapshot.exists()) return;
	
	  var advs = snapshot.val();
	
	  (0, _store.dispatch)((0, _set_advertisements2.default)(advs));
	};
	
	var watchAdvertisements = exports.watchAdvertisements = function watchAdvertisements() {
	  _firedux2.default.ref.child(_constants.ADVERTISEMENTS_ENDPOINT).on('value', onAdvertisements);
	};
	
	var unwatchAdvertisements = exports.unwatchAdvertisements = function unwatchAdvertisements() {
	  _firedux2.default.ref.child(_constants.ADVERTISEMENTS_ENDPOINT).off('value', onAdvertisements);
	};

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _user_sessions_count = __webpack_require__(663);
	
	var _user_sessions_count2 = _interopRequireDefault(_user_sessions_count);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpertSessionsCount = function (_React$Component) {
	  _inherits(ExpertSessionsCount, _React$Component);
	
	  function ExpertSessionsCount() {
	    _classCallCheck(this, ExpertSessionsCount);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ExpertSessionsCount).apply(this, arguments));
	  }
	
	  _createClass(ExpertSessionsCount, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.onComponentLoaded(this.props.uid);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.sessionsCount) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'expert-sessions-count', style: { marginLeft: this.props.marginLeft, fontSize: this.props.size } },
	          _react2.default.createElement('i', { className: 'rc-icon-session-count' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.sessionsCount
	          )
	        );
	      } else {
	        return false;
	      }
	    }
	  }]);
	
	  return ExpertSessionsCount;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    sessionsCount: state.getIn(['sessions', '_counts', ownProps.uid])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    onComponentLoaded: _user_sessions_count2.default
	  };
	};
	
	var ExpertSessionsCountContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ExpertSessionsCount);
	
	exports.default = ExpertSessionsCountContainer;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _bookmark_group = __webpack_require__(607);
	
	var _bookmark_group2 = _interopRequireDefault(_bookmark_group);
	
	var _unbookmark_group = __webpack_require__(610);
	
	var _unbookmark_group2 = _interopRequireDefault(_unbookmark_group);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PHONE = _constants.VIEWPORT_TYPES.PHONE;
	
	var GroupChatBookmarkButton = function (_React$Component) {
	  _inherits(GroupChatBookmarkButton, _React$Component);
	
	  function GroupChatBookmarkButton(props) {
	    _classCallCheck(this, GroupChatBookmarkButton);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GroupChatBookmarkButton).call(this, props));
	
	    _this.state = {};
	
	    _this.blur = _this.blur.bind(_this);
	    _this.focus = _this.focus.bind(_this);
	    _this.bookmark = _this.bookmark.bind(_this);
	    _this.unbookmark = _this.unbookmark.bind(_this);
	    return _this;
	  }
	
	  _createClass(GroupChatBookmarkButton, [{
	    key: 'blur',
	    value: function blur() {
	      this.setState({ isFocused: false });
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.setState({ isFocused: true });
	    }
	  }, {
	    key: 'bookmark',
	    value: function bookmark(e) {
	      if (e && e.preventDefault) e.preventDefault();
	      this.setState({ isFocused: false });
	
	      this.props.bookmarkGroup(this.props.currentUserUid, this.props.groupId);
	    }
	  }, {
	    key: 'unbookmark',
	    value: function unbookmark(e) {
	      if (e && e.preventDefault) e.preventDefault();
	      this.setState({ isFocused: false });
	
	      this.props.unbookmarkGroup(this.props.currentUserUid, this.props.groupId);
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel(text) {
	      if (this.props.shouldShowLabels && this.props.viewportType !== PHONE) {
	        return _react2.default.createElement(
	          'span',
	          { style: { verticalAlign: 'middle' } },
	          text
	        );
	      }
	    }
	  }, {
	    key: 'renderBookmarkedButton',
	    value: function renderBookmarkedButton() {
	      var width = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? this.props.width : 'auto';
	      var marginRight = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? 4 : null;
	
	      if (this.state.isFocused) {
	        return _react2.default.createElement(
	          'a',
	          { href: '#', style: this.props.style, title: 'Remove from My List', className: 'btn btn-danger btn-sm', onMouseLeave: this.blur, onClick: this.unbookmark },
	          _react2.default.createElement(
	            'div',
	            { style: { width: width, textAlign: 'left' } },
	            _react2.default.createElement('i', { className: 'rc-icon-bookmark-outline', style: { marginRight: marginRight, verticalAlign: 'middle', fontSize: 16 } }),
	            this.renderLabel('Remove')
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'a',
	          { href: '#', style: this.props.style, className: 'btn btn-success btn-sm', onMouseEnter: this.focus, onTouchEnd: this.unbookmark },
	          _react2.default.createElement(
	            'div',
	            { style: { width: width, textAlign: 'left' } },
	            _react2.default.createElement('i', { className: 'rc-icon-bookmark', style: { marginRight: marginRight, verticalAlign: 'middle', fontSize: 16 } }),
	            this.renderLabel('In My List')
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderUnBookmarkedButton',
	    value: function renderUnBookmarkedButton() {
	      var width = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? this.props.width : 'auto';
	      var marginRight = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? 4 : null;
	
	      return _react2.default.createElement(
	        'a',
	        { href: '#', title: 'Add to My List', style: this.props.style, className: 'btn btn-success btn-sm btn-stripped', onClick: this.bookmark },
	        _react2.default.createElement(
	          'div',
	          { style: { width: width, textAlign: 'left' } },
	          _react2.default.createElement('i', { className: 'rc-icon-bookmark-outline', style: { marginRight: marginRight, verticalAlign: 'middle', fontSize: 16 } }),
	          this.renderLabel('Add to My List')
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.currentUserUid) return false;
	      if (this.props.bookmarkedGroup) return this.renderBookmarkedButton();
	
	      return this.renderUnBookmarkedButton();
	    }
	  }]);
	
	  return GroupChatBookmarkButton;
	}(_react2.default.Component);
	
	GroupChatBookmarkButton.defaultProps = {
	  width: 94,
	  shouldShowLabels: true
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    currentUserUid: state.getIn(['currentUser', 'uid']),
	    bookmarkedGroup: state.getIn(['groups', '_bookmarks', 'all', ownProps.groupId]),
	    viewportType: state.getIn(['viewport', 'type'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    bookmarkGroup: _bookmark_group2.default,
	    unbookmarkGroup: _unbookmark_group2.default
	  };
	};
	
	var GroupChatBookmarkButtonContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GroupChatBookmarkButton);
	
	exports.default = GroupChatBookmarkButtonContainer;

/***/ },
/* 275 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Idle;
	
	if (!document.addEventListener) {
	  if (document.attachEvent) {
	    document.addEventListener = function (event, callback, useCapture) {
	      return document.attachEvent("on" + event, callback, useCapture);
	    };
	  } else {
	    document.addEventListener = function () {
	      return {};
	    };
	  }
	}
	
	if (!document.removeEventListener) {
	  if (document.detachEvent) {
	    document.removeEventListener = function (event, callback) {
	      return document.detachEvent("on" + event, callback);
	    };
	  } else {
	    document.removeEventListener = function () {
	      return {};
	    };
	  }
	}
	
	"use strict";
	
	Idle = {};
	
	Idle = function () {
	  Idle.isAway = false;
	
	  Idle.awayTimeout = 3000;
	
	  Idle.awayTimestamp = 0;
	
	  Idle.awayTimer = null;
	
	  Idle.onAway = null;
	
	  Idle.onAwayBack = null;
	
	  Idle.onVisible = null;
	
	  Idle.onHidden = null;
	
	  function Idle(options) {
	    var activeMethod, activity;
	    if (options) {
	      this.awayTimeout = parseInt(options.awayTimeout, 10);
	      this.onAway = options.onAway;
	      this.onAwayBack = options.onAwayBack;
	      this.onVisible = options.onVisible;
	      this.onHidden = options.onHidden;
	    }
	    activity = this;
	    activeMethod = function activeMethod() {
	      return activity.onActive();
	    };
	    window.addEventListener('click', activeMethod);
	    window.addEventListener('mousemove', activeMethod);
	    window.addEventListener('mouseenter', activeMethod);
	    window.addEventListener('keydown', activeMethod);
	    window.addEventListener('scroll', activeMethod);
	    window.addEventListener('mousewheel', activeMethod);
	  }
	
	  Idle.prototype.onActive = function () {
	    this.awayTimestamp = new Date().getTime() + this.awayTimeout;
	    if (this.isAway) {
	      if (this.onAwayBack) {
	        this.onAwayBack();
	      }
	      this.start();
	    }
	    this.isAway = false;
	    return true;
	  };
	
	  Idle.prototype.start = function () {
	    var activity;
	    if (!this.listener) {
	      this.listener = function () {
	        return activity.handleVisibilityChange();
	      };
	      document.addEventListener("visibilitychange", this.listener, false);
	      document.addEventListener("webkitvisibilitychange", this.listener, false);
	      document.addEventListener("msvisibilitychange", this.listener, false);
	    }
	    this.awayTimestamp = new Date().getTime() + this.awayTimeout;
	    if (this.awayTimer !== null) {
	      clearTimeout(this.awayTimer);
	    }
	    activity = this;
	    this.awayTimer = setTimeout(function () {
	      return activity.checkAway();
	    }, this.awayTimeout + 100);
	    return this;
	  };
	
	  Idle.prototype.stop = function () {
	    if (this.awayTimer !== null) {
	      clearTimeout(this.awayTimer);
	    }
	    if (this.listener !== null) {
	      document.removeEventListener("visibilitychange", this.listener);
	      document.removeEventListener("webkitvisibilitychange", this.listener);
	      document.removeEventListener("msvisibilitychange", this.listener);
	      this.listener = null;
	    }
	    return this;
	  };
	
	  Idle.prototype.setAwayTimeout = function (ms) {
	    this.awayTimeout = parseInt(ms, 10);
	    return this;
	  };
	
	  Idle.prototype.checkAway = function () {
	    var activity, t;
	    t = new Date().getTime();
	    if (t < this.awayTimestamp) {
	      this.isAway = false;
	      activity = this;
	      this.awayTimer = setTimeout(function () {
	        return activity.checkAway();
	      }, this.awayTimestamp - t + 100);
	      return;
	    }
	    if (this.awayTimer !== null) {
	      clearTimeout(this.awayTimer);
	    }
	    this.isAway = true;
	    if (this.onAway) {
	      return this.onAway();
	    }
	  };
	
	  Idle.prototype.handleVisibilityChange = function () {
	    if (document.hidden || document.msHidden || document.webkitHidden) {
	      if (this.onHidden) {
	        return this.onHidden();
	      }
	    } else {
	      if (this.onVisible) {
	        return this.onVisible();
	      }
	    }
	  };
	
	  return Idle;
	}();
	
	exports.default = Idle;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RoleIndicator = function (_React$Component) {
	  _inherits(RoleIndicator, _React$Component);
	
	  function RoleIndicator(props) {
	    _classCallCheck(this, RoleIndicator);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(RoleIndicator).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(RoleIndicator, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'role-indicator label label-primary', style: { backgroundColor: _constants.ROLE_COLORS[this.props.role], fontSize: this.props.size } },
	        _constants.ROLE_LABELS[this.props.role]
	      );
	    }
	  }]);
	
	  return RoleIndicator;
	}(_react2.default.Component);
	
	RoleIndicator.defaultProps = {
	  role: 1,
	  size: 10
	};
	
	exports.default = RoleIndicator;

/***/ },
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(11);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(26),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(60),
	    isFlattenable = __webpack_require__(394);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(60),
	    isArray = __webpack_require__(10);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object)
	    ? result
	    : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 284 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = Object.keys;
	
	/**
	 * The base implementation of `_.keys` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  return nativeKeys(Object(object));
	}
	
	module.exports = baseKeys;


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(64),
	    isArrayLike = __webpack_require__(32);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(283),
	    getSymbolsIn = __webpack_require__(388),
	    keysIn = __webpack_require__(410);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(356),
	    Map = __webpack_require__(25),
	    Promise = __webpack_require__(358),
	    Set = __webpack_require__(360),
	    WeakMap = __webpack_require__(281),
	    toSource = __webpack_require__(108);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function getTag(value) {
	  return objectToString.call(value);
	}
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 288 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to an array.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 289 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(413),
	    toString = __webpack_require__(416);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  var result = [];
	  toString(string).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(52),
	    isObjectLike = __webpack_require__(24);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(22),
	    baseIteratee = __webpack_require__(37),
	    baseMap = __webpack_require__(285),
	    isArray = __webpack_require__(10);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|Object|string} [iteratee=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(22),
	    baseDifference = __webpack_require__(363),
	    baseFlatten = __webpack_require__(282),
	    basePick = __webpack_require__(373),
	    getAllKeysIn = __webpack_require__(286),
	    rest = __webpack_require__(112),
	    toKey = __webpack_require__(35);
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable string keyed properties of `object` that are
	 * not omitted.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = rest(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  props = arrayMap(baseFlatten(props, 1), toKey);
	  return basePick(object, baseDifference(getAllKeysIn(object), props));
	});
	
	module.exports = omit;


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 295 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CRUDTitle = function CRUDTitle(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h5',
	      { style: { marginBottom: 4 } },
	      _react2.default.createElement(
	        'b',
	        null,
	        props.title
	      )
	    ),
	    _react2.default.createElement('hr', { style: { marginTop: 0, marginBottom: 10 } })
	  );
	};
	
	exports.default = CRUDTitle;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (advertisements) {
	  return { type: _action_types.SET_ADVERTISEMENTS, advertisements: advertisements };
	};

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (orders, scope) {
	  return { type: _action_types.SET_GROUP_CHAT_ORDERS, orders: orders, scope: scope };
	};

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (groups, scope) {
	  return { type: _action_types.SET_GROUP_CHATS, groups: groups, scope: scope };
	};

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (conversationId, time) {
	  return { type: _action_types.SET_LAST_OPEN_TIME_FOR_CONVERSATION, conversationId: conversationId, time: time };
	};

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (presences) {
	  return { type: _action_types.SET_PRESENCES, presences: presences };
	};

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (time) {
	  if (!_moment2.default.isMoment(time)) time = (0, _moment2.default)(time);
	
	  return time.format('h:mm A');
	};

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(8);
	
	exports.default = function () {
	  return (0, _store.getState)().getIn(['conversations', '_stack', 'focused'], null);
	};

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(8);
	
	exports.default = function () {
	  return (0, _store.getState)().getIn(['conversations', '_stack', 'visibleSlot'], null);
	};

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var newConv = function newConv(conversationId, targetId, type) {
	  return {
	    conversationId: conversationId,
	    targetId: targetId,
	    type: type,
	    status: _constants.CONVERSATION_PANE_STATUSES.OPEN
	  };
	};
	
	var existingConversation = function existingConversation(convId, conv) {
	  return conv.get('conversationId') === convId;
	};
	
	var shiftFocusedConvToPosition = function shiftFocusedConvToPosition(focusedIndex, stack) {
	  var focusedConv = typeof focusedIndex === 'number' ? stack.get(focusedIndex + 1) : null;
	
	  if (focusedConv) {
	    stack = stack.delete(focusedIndex + 1);
	    stack = stack.insert(focusedIndex, focusedConv);
	  }
	
	  return stack;
	};
	
	var addNewConversationToStack = function addNewConversationToStack(conv, focusedIndex, stack) {
	  stack = stack.unshift(conv);
	  stack = shiftFocusedConvToPosition(focusedIndex, stack);
	
	  return stack;
	};
	
	var repositionExistingConversation = function repositionExistingConversation(index, focusedIndex, type, stack) {
	  var conv = stack.get(index).set('type', type);
	  stack = stack.delete(index).unshift(conv);
	  stack = shiftFocusedConvToPosition(focusedIndex, stack);
	
	  return stack;
	};
	
	exports.default = function (conversationId, targetId, focusedIndex, visibleSlot, type, stack) {
	  if (typeof stack === 'undefined' || stack === null) stack = (0, _immutable.fromJS)([]);
	  if (!_immutable.List.isList(stack)) stack = (0, _immutable.fromJS)(stack);
	  if (!conversationId) return stack;
	
	  // check exists in stack
	  var index = stack.findKey(existingConversation.bind(null, conversationId));
	  if (typeof index !== 'number' || index < 0) return addNewConversationToStack(newConv(conversationId, targetId, type), focusedIndex, stack);
	  if (index === focusedIndex) return stack;
	  if (index < visibleSlot) return stack;else return repositionExistingConversation(index, focusedIndex, type, stack);
	};

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var keyParams = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	  var identifier = arguments.length <= 1 || arguments[1] === undefined ? (0, _moment2.default)().valueOf() : arguments[1];
	
	  return keyParams.concat(identifier).join('-');
	};

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _favico = __webpack_require__(355);
	
	var _favico2 = _interopRequireDefault(_favico);
	
	var _immutable = __webpack_require__(5);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(2);
	
	var _action_types = __webpack_require__(4);
	
	var _desktop_notifications_handler = __webpack_require__(339);
	
	var _desktop_notifications_handler2 = _interopRequireDefault(_desktop_notifications_handler);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _open_conversation = __webpack_require__(271);
	
	var _open_conversation2 = _interopRequireDefault(_open_conversation);
	
	var _set_last_open_time_for_conversation = __webpack_require__(300);
	
	var _set_last_open_time_for_conversation2 = _interopRequireDefault(_set_last_open_time_for_conversation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openConversationFromNotification = function openConversationFromNotification(currentUserUid, message, viewportType) {
	  var from = message.from;
	  var type = message.type;
	  var conversationId = message.conversationId;
	
	  if (!currentUserUid || !from || !conversationId) return;
	
	  (0, _open_conversation2.default)(currentUserUid, from, conversationId, type, viewportType);
	};
	
	var setIsReceivedForNotification = function setIsReceivedForNotification(uid, notifId) {
	  var ENDPOINT = (0, _constants.USER_MESSAGE_NOTIFICATIONS_ENDPOINT)(uid) + '/' + notifId + '/isReceived';
	
	  _firedux2.default.ref.child(ENDPOINT).set(true);
	};
	
	var desktopNotificationsHandler = new _desktop_notifications_handler2.default();
	
	var updateLastOpenTimeForConversation = function updateLastOpenTimeForConversation(conversationId) {
	  var now = (0, _moment2.default)().valueOf();
	  // TODO: find better way to update/force input focus for conversations.
	  // calling dispatch inside middleware is nasty.
	  (0, _store.dispatch)((0, _set_last_open_time_for_conversation2.default)(conversationId, now));
	};
	
	var notifyDesktop = function notifyDesktop(notification, key, uid) {
	  if (notification.isReceived) return;
	
	  var desktopNotif = desktopNotificationsHandler.notify(notification);
	  var conversationId = notification.payload.conversationId;
	
	
	  desktopNotif.addEventListener('show', function () {
	    return setIsReceivedForNotification(uid, key);
	  });
	
	  if (conversationId) {
	    desktopNotif.addEventListener('click', updateLastOpenTimeForConversation.bind(null, conversationId));
	  }
	};
	
	var originalPageTitle = void 0;
	var pageTitleInterval = void 0;
	var unreadMessageCount = 0;
	
	var pageTitleNotificationsHandler = new _favico2.default({ animation: 'slide', position: 'up' });
	
	var notifyPageTitle = function notifyPageTitle(notification) {
	  var newCount = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	  if (!originalPageTitle) originalPageTitle = document.title;
	
	  var notifTitle = notification.title + ' -' + notification.body;
	  unreadMessageCount += newCount;
	  pageTitleNotificationsHandler.badge(unreadMessageCount);
	
	  if (pageTitleInterval) clearInterval(pageTitleInterval);
	
	  var swapTitle = function swapTitle() {
	    if (document.hasFocus()) {
	      clearInterval(pageTitleInterval);
	      document.title = originalPageTitle;
	      pageTitleNotificationsHandler.reset();
	      unreadMessageCount = 0;
	
	      return;
	    }
	
	    document.title = notifTitle;
	
	    setTimeout(function () {
	      return document.title = originalPageTitle;
	    }, 600);
	  };
	
	  pageTitleInterval = setInterval(swapTitle, 1200);
	  swapTitle();
	};
	
	var notifySessionRequest = function notifySessionRequest(store, notificationPayload) {
	  var user = store.getState().getIn(['users', notificationPayload.from]);
	
	  var title = 'New Session Request';
	  var body = 'You have a new immediate session request';
	  var icon = null;
	  var tag = notificationPayload.tag;
	
	  if (user) {
	    title = title + ' From ' + user.get('name');
	    body = user.get('name') + ' requested a new immediate session...';
	    icon = user.get('profileImage');
	  }
	
	  desktopNotificationsHandler.notify({ title: title, body: body, tag: tag, icon: icon });
	};
	
	var handleNewMessageNotification = function handleNewMessageNotification(uid, isActive, ignoredUsers, viewportType, action, next) {
	  var notification = action.notification;
	  var key = action.key;
	
	  if (!notification) return next(action);
	  if (notification.isReceived) return next(action);
	
	  if (ignoredUsers && ignoredUsers[notification.from]) {
	    setIsReceivedForNotification(uid, key);
	    return next(action);
	  }
	
	  if (viewportType === _constants.VIEWPORT_TYPES.DESKTOP) {
	    openConversationFromNotification(uid, notification.payload, viewportType);
	  }
	
	  if (isActive) {
	    desktopNotificationsHandler.markAllAsRead();
	    setIsReceivedForNotification(uid, key);
	    return next(action);
	  }
	
	  notifyDesktop(notification, key, uid);
	  notifyPageTitle(notification, 1);
	
	  return next(action);
	};
	
	exports.default = function (store) {
	  return function (next) {
	    return function (action) {
	      var currentUser = store.getState().get('currentUser', (0, _immutable.fromJS)({})).toJS();
	      var viewportType = store.getState().getIn(['viewport', 'type']);
	      var uid = currentUser.uid;
	      var presence = currentUser.presence;
	      var isActive = currentUser.isActive;
	      var ignoredUsers = currentUser.ignored;
	
	
	      if (!uid) return next(action);
	      // TODO: test this if it is working.
	      if (presence === _constants.PRESENCE.OFFLINE) return next(action);
	
	      if (action.type === _action_types.SET_NEW_MESSAGE_NOTIFICATION) {
	        return handleNewMessageNotification(uid, isActive, ignoredUsers, viewportType, action, next);
	      } else if (action.type === _action_types.SET_NEW_SESSION_REQUEST_NOTIFICATION) {
	        if (!isActive) {
	          notifySessionRequest(store, action.notification);
	          return next(action);
	        }
	      } else if (action.type === _action_types.SET_NEW_NOTIFICATION) {
	        if (!action.options) return next(action);
	        if (isActive) return next(action);
	
	        var _action$options = action.options;
	        var title = _action$options.title;
	        var desktop = _action$options.desktop;
	
	
	        if (title) notifyPageTitle(action.notification, 1);
	        if (desktop) {} // TODO: add notify desktop for this.
	      }
	
	      return next(action);
	    };
	  };
	};

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({ count: 0 }) : arguments[0];
	  var action = arguments[1];
	
	  var count = void 0;
	
	  switch (action.type) {
	    case _action_types.SET_CHAT_LIST_USER:
	      count = state.get('count', 0) + 1;
	
	      return state.set('count', count);
	
	    case _action_types.REMOVE_CHAT_LIST_USER:
	      count = state.get('count', 0) - 1;
	      if (count < 0) count = 0;
	
	      return state.set('count', count);
	
	    case _action_types.SET_CHAT_LIST_GUESTS:
	      count = state.get('count', 0) + action.guests.size;
	
	      return state.set('count', count);
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _CHAT_LIST_USER_SEGME;
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _action_types = __webpack_require__(4);
	
	var _order_group_chats = __webpack_require__(269);
	
	var _order_group_chats2 = _interopRequireDefault(_order_group_chats);
	
	var _recent_conversations_view_reducer = __webpack_require__(326);
	
	var _recent_conversations_view_reducer2 = _interopRequireDefault(_recent_conversations_view_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CHAT_LIST_USER_SEGMENTS = (_CHAT_LIST_USER_SEGME = {}, _defineProperty(_CHAT_LIST_USER_SEGME, _constants.ROLES.ADMIN, 'admins'), _defineProperty(_CHAT_LIST_USER_SEGME, _constants.ROLES.AUTHOR, 'authors'), _defineProperty(_CHAT_LIST_USER_SEGME, _constants.ROLES.EXPERT, 'experts'), _defineProperty(_CHAT_LIST_USER_SEGME, _constants.ROLES.PREMIUM, 'users'), _defineProperty(_CHAT_LIST_USER_SEGME, _constants.ROLES.USER, 'users'), _CHAT_LIST_USER_SEGME);
	
	var excludeCurrentUser = function excludeCurrentUser() {
	  var segments = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({}) : arguments[0];
	  var uid = arguments[1];
	
	  if (!uid) return segments;
	
	  return segments.map(function (segment) {
	    return segment.filter(function (user) {
	      return user.get('uid') !== uid;
	    });
	  });
	};
	
	var globalGroupChatReducer = function globalGroupChatReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({}) : arguments[0];
	  var action = arguments[1];
	
	  var groups = void 0,
	      orders = void 0;
	
	  switch (action.type) {
	    case _action_types.SET_GROUP_CHATS:
	      groups = (0, _immutable.fromJS)(action.groups);
	      orders = state.get('orders');
	
	      state = state.set('groups', groups);
	      state = state.set('list', (0, _order_group_chats2.default)(groups, orders));
	
	      return state;
	
	    case _action_types.SET_GROUP_CHAT_ORDERS:
	      groups = state.get('groups');
	      orders = (0, _immutable.fromJS)(action.orders);
	
	      state = state.set('orders', orders);
	      state = state.set('list', (0, _order_group_chats2.default)(groups, orders));
	
	      return state;
	
	    default:
	      return state;
	  }
	};
	
	var groupChatSegmentReducer = function groupChatSegmentReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_GROUP_CHATS:
	    case _action_types.SET_GROUP_CHAT_ORDERS:
	      state = state.set('globals', globalGroupChatReducer(state.get('globals'), action));
	
	      state = state.set('list', state.getIn(['globals', 'list']));
	
	      return state;
	
	    default:
	      return (0, _immutable.List)();
	  }
	};
	
	var getSegmentByRole = function getSegmentByRole(role) {
	  return CHAT_LIST_USER_SEGMENTS[role];
	};
	
	var userSegmentReducer = function userSegmentReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)([]) : arguments[0];
	  var currentUserUid = arguments[1];
	  var action = arguments[2];
	
	  var uid = action.user.get('uid');
	
	  switch (action.type) {
	    case _action_types.SET_CHAT_LIST_USER:
	      if (uid === currentUserUid) return state;
	
	      state = state.filter(function (a) {
	        return a.get('uid') !== uid;
	      }).filter(function (a) {
	        return a.get('uid') !== currentUserUid;
	      }).push(action.user.set('presence', action.presence)).sortBy(function (a) {
	        return -1 * a.get('presence');
	      });
	
	      return state;
	
	    case _action_types.REMOVE_CHAT_LIST_USER:
	      state = state.filter(function (a) {
	        return a.get('uid') !== uid;
	      });
	
	      return state;
	
	    default:
	      return state;
	  }
	};
	
	var chatListUserReducer = function chatListUserReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({}) : arguments[0];
	  var action = arguments[1];
	
	  if (!action.user) return state;
	
	  var segment = getSegmentByRole(action.user.get('role'));
	
	  switch (action.type) {
	    case _action_types.SET_CHAT_LIST_USER:
	    case _action_types.REMOVE_CHAT_LIST_USER:
	      var segmentState = userSegmentReducer(state.getIn(['segments', segment]), state.get('_currentUserUid'), action);
	
	      return state.setIn(['segments', segment], segmentState);
	
	    case _action_types.CHANGE_CHAT_LIST_USER_ROLE:
	      var oldSegment = getSegmentByRole(action.prevRole);
	
	      var newSegmentState = userSegmentReducer(state.getIn(['segments', segment]), state.get('_currentUserUid'), _extends({}, action, { type: _action_types.SET_CHAT_LIST_USER }));
	
	      var oldSegmentState = userSegmentReducer(state.getIn(['segments', oldSegment]), state.get('_currentUserUid'), _extends({}, action, { type: _action_types.REMOVE_CHAT_LIST_USER }));
	
	      return state.setIn(['segments', segment], newSegmentState).setIn(['segments', oldSegment], oldSegmentState);
	
	    default:
	      return state;
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_CHAT_LIST_USER:
	    case _action_types.REMOVE_CHAT_LIST_USER:
	    case _action_types.CHANGE_CHAT_LIST_USER_ROLE:
	      state = chatListUserReducer(state, action);
	
	      return state;
	
	    case _action_types.SET_CHAT_LIST_GUESTS:
	      return state.setIn(['segments', 'guests'], action.guests);
	
	    case _action_types.SET_CURRENT_USER:
	      if (action.user) {
	        state = state.set('_currentUserUid', action.user.uid);
	      } else {
	        state = state.delete('_currentUserUid');
	      }
	      state = state.set('segments', excludeCurrentUser(state.get('segments'), state.get('_currentUserUid')));
	
	      return state;
	
	    case _action_types.SET_RECENT_CONVERSATIONS:
	    case _action_types.SET_RECENT_CONVERSATION_USER:
	      return state.setIn(['segments', 'recents'], (0, _recent_conversations_view_reducer2.default)(state.getIn(['segments', 'recents']), action));
	
	    case _action_types.SET_GROUP_CHATS:
	    case _action_types.SET_GROUP_CHAT_ORDERS:
	      if (action.scope === _constants.GROUP_CHAT_SCOPES.GLOBAL) {
	        return state.setIn(['segments', 'groups'], groupChatSegmentReducer(state.getIn(['segments', 'groups']), action));
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _action_types = __webpack_require__(4);
	
	var TOTAL_CHAT_LIST_WIDTH = _constants.CHAT_LIST_RIGHT_MARGIN + _constants.CHAT_LIST_WIDTH;
	
	var getVisibleSlot = function getVisibleSlot(width) {
	  if (width <= _constants.VIEWPORT_MAX_WIDTH_PHONE) return 1;
	
	  return parseInt((width - TOTAL_CHAT_LIST_WIDTH) / _constants.CONVERSATION_PANE_WIDTH, 10);
	};
	
	var reduceConversationCounts = function reduceConversationCounts() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_TOTAL_CONV_MESSAGE_COUNT:
	      state = state.setIn([action.conversationId, 'total'], action.count || 0);
	
	      var read = state.getIn([action.conversationId, 'read'], action.count);
	
	      if (read === 0) {
	        state = state.setIn([action.conversationId, 'unread'], 0);
	      } else {
	        state = state.setIn([action.conversationId, 'unread'], action.count - read);
	      }
	
	      return state;
	
	    case _action_types.SET_READ_CONV_MESSAGE_COUNT:
	      state = state.setIn([action.conversationId, 'read'], action.count || 0);
	
	      var total = state.getIn([action.conversationId, 'total'], action.count);
	
	      if (action.count === 0) {
	        state = state.setIn([action.conversationId, 'unread'], 0);
	      } else {
	        state = state.setIn([action.conversationId, 'unread'], action.count - total);
	      }
	
	      return state;
	
	    default:
	      return state;
	  }
	};
	
	var reduceConversationStack = function reduceConversationStack() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_CONVERSATION_STACK:
	      var visibleSlot = state.get('visibleSlot');
	      var stack = action.stack ? (0, _immutable.fromJS)(action.stack) : (0, _immutable.fromJS)([]);
	
	      state = state.set('list', stack);
	      state = state.set('visibles', state.get('list').take(visibleSlot));
	
	      return state;
	
	    case _action_types.SET_VIEWPORT_DIMENSIONS:
	      var currentVisibleSlot = state.get('visibleSlot');
	      var newVisibleSlot = getVisibleSlot(action.width);
	
	      if (newVisibleSlot !== currentVisibleSlot) {
	        state = state.set('visibleSlot', newVisibleSlot);
	        state = state.set('visibles', state.get('list', (0, _immutable.fromJS)([])).take(newVisibleSlot));
	
	        return state;
	      }
	
	    case _action_types.SET_FOCUSED_CONVERSATION:
	      if (action.isFocused) {
	        var focused = state.get('focused');
	        if (focused !== action.index) {
	          return state.set('focused', action.index);
	        }
	      } else {
	        return state.delete('focused');
	      }
	
	    default:
	      return state;
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_CONVERSATION_REFS:
	      return state.mergeDeep({ _refs: action.refs });
	
	    case _action_types.SET_CONVERSATION_STACK:
	    case _action_types.SET_VIEWPORT_DIMENSIONS:
	    case _action_types.SET_FOCUSED_CONVERSATION:
	      return state.set('_stack', reduceConversationStack(state.get('_stack'), action));
	
	    case _action_types.SET_TOTAL_CONV_MESSAGE_COUNT:
	    case _action_types.SET_READ_CONV_MESSAGE_COUNT:
	      return state.set('_counts', reduceConversationCounts(state.get('_counts'), action));
	
	    case _action_types.SET_LAST_OPEN_TIME_FOR_CONVERSATION:
	      return state.setIn(['_lastOpenTimes', action.conversationId], action.time);
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_CURRENT_CUSTOMER:
	      return state.mergeDeep(action.customer);
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	var injectKeys = function injectKeys(review, key) {
	  return review.merge({ key: key });
	};
	
	var sortByTime = function sortByTime(review) {
	  return (review.get('time') || 0) * -1;
	};
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.List)() : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_CURRENT_EXPERT_REVIEWS:
	      return (0, _immutable.fromJS)(action.reviews).map(injectKeys).toList().sortBy(sortByTime);
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)() : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_CURRENT_GUEST:
	      if (action.guest) {
	        return state.merge(action.guest);
	      } else {
	        return (0, _immutable.Map)();
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_CURRENT_PAYOUT_REQUEST:
	      if (action.payoutRequest) {
	        return state.mergeDeep(action.payoutRequest).merge({ key: action.payoutRequestId });
	      } else {
	        return (0, _immutable.Map)({});
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	var _current_user_presence = __webpack_require__(316);
	
	var _current_user_presence2 = _interopRequireDefault(_current_user_presence);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)() : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_CURRENT_USER:
	      if (action.user) {
	        var user = (0, _immutable.fromJS)(action.user).delete('presence');
	        return state.merge(user);
	      } else {
	        return (0, _immutable.Map)();
	      }
	
	    case _action_types.SET_CURRENT_USER_PRESENCE:
	      if (typeof action.presence === 'number') {
	        return state.set('presence', (0, _current_user_presence2.default)(state.getIn('presence'), action));
	      }
	
	    case _action_types.SET_CURRENT_USER_ACTIVITY:
	      return state.set('isActive', action.isActive);
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	var _constants = __webpack_require__(2);
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? _constants.PRESENCE.ONLINE : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_CURRENT_USER_PRESENCE:
	      return action.presence;
	    default:
	      return state;
	  }
	};

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _action_types = __webpack_require__(4);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var bookmarkedGroupChatsReducer = function bookmarkedGroupChatsReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({ list: [] }) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_BOOKMARKED_GROUP_CHATS:
	      if (!action.groups) return state;
	
	      var bookmarkedGroups = (0, _immutable.fromJS)(action.groups).reduce(function (list, g) {
	        return list.set(g.get('key'), g);
	      }, (0, _immutable.fromJS)({}));
	
	      state = state.set('all', bookmarkedGroups);
	
	      var list = bookmarkedGroups.toList().sortBy(function (g) {
	        return g.get('name').toLowerCase();
	      });
	
	      state = state.set('list', list);
	
	      return state;
	
	    case _action_types.REMOVE_BOOKMARKED_GROUP_CHAT:
	      state = state.deleteIn(['all', action.key]);
	
	      var index = state.get('list', (0, _immutable.fromJS)([])).findIndex(function (g) {
	        return g.get('key') === action.key;
	      });
	
	      state = state.deleteIn(['list', index]);
	
	      return state;
	
	    default:
	      return state;
	  }
	};
	var groupChatSubscriptionsGroupsReducer = function groupChatSubscriptionsGroupsReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT:
	      if (!action.users) {
	        state = state.set(action.groupId, state.get(action.groupId, (0, _immutable.fromJS)({})).map(function (s) {
	          return s.delete(action.scope);
	        }));
	      } else {
	        var subscriptions = (0, _immutable.fromJS)(action.users).map(function (s) {
	          return (0, _immutable.fromJS)(_defineProperty({}, action.scope, s));
	        });
	
	        state = state.set(action.groupId, state.get(action.groupId, (0, _immutable.fromJS)({})).mergeDeep(subscriptions));
	      }
	
	      return state;
	
	    case _action_types.REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT:
	      state = state.deleteIn([action.groupId, action.key, action.scope]);
	
	      if (state.getIn([action.groupId, action.key], (0, _immutable.fromJS)({})).size === 0) {
	        state = state.deleteIn([action.groupId, action.key]);
	      }
	
	      return state;
	
	    default:
	      return state;
	  }
	};
	
	var groupChatSubscriptionsUsersReducer = function groupChatSubscriptionsUsersReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_SUBSCRIBED_GROUP_CHATS:
	      if (!action.groups) {
	        state = state.set(action.uid, state.get(action.uid, (0, _immutable.fromJS)({})).map(function (s) {
	          return s.delete(action.scope);
	        }));
	      } else {
	        var subscriptions = (0, _immutable.fromJS)(action.groups).map(function (s) {
	          return (0, _immutable.fromJS)(_defineProperty({}, action.scope, s));
	        });
	
	        state = state.set(action.uid, state.get(action.uid, (0, _immutable.fromJS)({})).mergeDeep(subscriptions));
	      }
	
	      return state;
	
	    case _action_types.REMOVE_SUBSCRIBED_GROUP_CHAT:
	      state = state.deleteIn([action.uid, action.key, action.scope]);
	
	      if (state.getIn([action.uid, action.key], (0, _immutable.fromJS)({})).size === 0) {
	        state = state.deleteIn([action.uid, action.key]);
	      }
	
	      return state;
	
	    default:
	      return state;
	  }
	};
	
	var groupChatSubscriptionsReducer = function groupChatSubscriptionsReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_SUBSCRIBED_GROUP_CHATS:
	    case _action_types.REMOVE_SUBSCRIBED_GROUP_CHAT:
	      state = state.set('users', groupChatSubscriptionsUsersReducer(state.get('users'), action));
	
	      return state;
	
	    case _action_types.SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT:
	    case _action_types.REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT:
	      state = state.set('groups', groupChatSubscriptionsGroupsReducer(state.get('groups'), action));
	
	      return state;
	
	    default:
	      return state;
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_GROUP_CHATS:
	      var scope = action.scope;
	      var groups = action.groups;
	
	      state = state.set(scope, (0, _immutable.fromJS)(groups));
	
	      if (scope !== _constants.GROUP_CHAT_SCOPES.DELETED) {
	        state = state.set('all', (0, _immutable.fromJS)({}).merge(state.get(_constants.GROUP_CHAT_SCOPES.SUPER_PRIVATE)).merge(state.get(_constants.GROUP_CHAT_SCOPES.PRIVATE)).merge(state.get(_constants.GROUP_CHAT_SCOPES.GLOBAL)));
	      }
	
	      return state;
	
	    case _action_types.SET_GROUP_CHAT:
	      if (!action.groupChat) return state.deleteIn(['all', action.key]);
	
	      var key = action.groupChat.key;
	
	      state = state.setIn([action.groupChat.scope, key], (0, _immutable.fromJS)(action.groupChat));
	      state = state.setIn(['all', key], (0, _immutable.fromJS)(action.groupChat));
	
	      return state;
	
	    case _action_types.SET_BOOKMARKED_GROUP_CHATS:
	    case _action_types.REMOVE_BOOKMARKED_GROUP_CHAT:
	      state = state.set('_bookmarks', bookmarkedGroupChatsReducer(state.get('_bookmarks'), action));
	
	      return state;
	
	    case _action_types.SET_SUBSCRIBED_GROUP_CHATS:
	    case _action_types.REMOVE_SUBSCRIBED_GROUP_CHAT:
	    case _action_types.SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT:
	    case _action_types.REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT:
	      state = state.set('_subscriptions', groupChatSubscriptionsReducer(state.get('_subscriptions'), action));
	
	      return state;
	
	    case _action_types.SET_GROUP_CHAT_ORDERS:
	      state = state.setIn(['_orders', action.scope], (0, _immutable.fromJS)(action.orders));
	
	      return state;
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	var groupByFrom = function groupByFrom(notification) {
	  return notification.from;
	};
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_NEW_MESSAGE_NOTIFICATIONS:
	      return (0, _immutable.Map)(action.notifications).groupBy(groupByFrom);
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var injectKey = function injectKey(message, key) {
	  return message.set('key', key);
	};
	var sortByTime = function sortByTime(message) {
	  return message.get('time');
	};
	
	var concatPreviousMessages = function concatPreviousMessages(prevMessages, state) {
	  var prevLastTime = prevMessages.getIn([prevMessages.size - 1, 'time']);
	  var currentFirstTime = state.getIn([0, 'time']);
	
	  if (!prevLastTime) return state;
	  if (!currentFirstTime) return prevMessages;
	  if (prevLastTime >= currentFirstTime) return state;
	
	  return (0, _immutable.List)().concat(prevMessages, state);
	};
	
	var updateMessageAttribute = function updateMessageAttribute(state, messageId, attr, val) {
	  var index = state.findKey(function (message) {
	    return message.get('key') === messageId;
	  });
	
	  if (!index || index < 0) return state;
	
	  if (attr === 'approvalStatus') return state.delete(index);
	
	  return state.setIn([index, attr], val);
	};
	
	var messageListReducer = function messageListReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.List)() : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_PREVIOUS_MESSAGES:
	      var previousMessages = (0, _immutable.fromJS)(action.messages).map(injectKey).toList().sortBy(sortByTime);
	
	      return concatPreviousMessages(previousMessages, state);
	
	    case _action_types.SET_NEW_MESSAGE:
	      var newMessage = (0, _immutable.fromJS)(action.message).merge({ key: action.messageKey });
	
	      return state.push(newMessage);
	
	    case _action_types.UPDATE_MESSAGE_ATTR:
	      return updateMessageAttribute(state, action.messageId, action.attr, action.val);
	
	    default:
	      return state;
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.REMOVE_PREVIOUS_MESSAGES:
	      return state.set(action.containerId, (0, _immutable.List)());
	
	    case _action_types.SET_PREVIOUS_MESSAGES:
	      var updatedMessagesWithPrev = messageListReducer(state.get(action.containerId), action);
	      return state.mergeDeep(_defineProperty({}, action.containerId, updatedMessagesWithPrev));
	
	    case _action_types.SET_NEW_MESSAGE:
	      var updatedMessagesWithNew = messageListReducer(state.get(action.containerId), action);
	
	      return state.mergeDeep(_defineProperty({}, action.containerId, updatedMessagesWithNew));
	
	    case _action_types.UPDATE_MESSAGE_ATTR:
	      var updatedMessages = messageListReducer(state.get(action.containerId), action);
	
	      return state.mergeDeep(_defineProperty({}, action.containerId, updatedMessages));
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	var _create_timestamp_key = __webpack_require__(306);
	
	var _create_timestamp_key2 = _interopRequireDefault(_create_timestamp_key);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.List)() : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SHOW_MODAL:
	      if (action.modal.identifier) {
	        var _ret = function () {
	          var modalKey = (0, _create_timestamp_key2.default)([action.modal.type], action.modal.identifier);
	          var modal = (0, _immutable.fromJS)(action.modal).mergeDeep({ props: { modalKey: modalKey } });
	
	          var index = state.findKey(function (modal) {
	            return modal.getIn(['props', 'modalKey']) === modalKey;
	          });
	
	          if (typeof index === 'undefined') return {
	              v: state.unshift(modal)
	            };
	
	          return {
	            v: state.set(index, modal)
	          };
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      } else {
	        var _modalKey = (0, _create_timestamp_key2.default)([action.modal.type]);
	        var _modal = (0, _immutable.fromJS)(action.modal).mergeDeep({ props: { modalKey: _modalKey } });
	
	        return state.unshift(_modal);
	      }
	
	    case _action_types.CLOSE_MODAL:
	      return state.filterNot(function (modal) {
	        return modal.getIn(['props', 'modalKey']) === action.modalKey;
	      });
	
	    case _action_types.CLOSE_ALL_MODALS:
	      return (0, _immutable.List)();
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	var _message_notifications = __webpack_require__(318);
	
	var _message_notifications2 = _interopRequireDefault(_message_notifications);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_NEW_MESSAGE_NOTIFICATIONS:
	      return state.set('messages', (0, _message_notifications2.default)(state.get('messages'), action));
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	var injectKeys = function injectKeys(payout, key) {
	  return payout.merge({ key: key });
	};
	
	var sortPayouts = function sortPayouts(attr, payout) {
	  return payout.get(attr);
	};
	
	var sortPayoutsByTime = function sortPayoutsByTime(payout) {
	  var time = payout.get('time');
	  // TODO: make it -1 * time after adding time to payouts.
	  if (time) return time;
	
	  return payout.get('key');
	};
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.List)() : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_PAYOUTS:
	    case _action_types.SET_CURRENT_USER_PAYOUTS:
	      return (0, _immutable.fromJS)(action.payouts).map(injectKeys).toList().sortBy(sortPayoutsByTime)
	      // TODO: disable this after adding time to payouts
	      .reverse();
	
	    case _action_types.ORDER_PAYOUTS:
	      if (action.order === 'desc') {
	        return state.sortBy(sortPayouts.bind(null, action.attr)).reverse();
	      } else {
	        return state.sortBy(sortPayouts.bind(null, action.attr));
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_PLUGIN_SETTINGS:
	      return state.merge(action.settings);
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_PRESENCES:
	      return state.mergeDeep(action.presences);
	
	    case _action_types.SET_USER_PRESENCE:
	      return state.set(action.uid, action.presence);
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_RECENT_CONVERSATIONS:
	      var convs = (0, _immutable.OrderedMap)(action.recentConversations).map(function (c, key) {
	        return (0, _immutable.Map)(c).merge({ uid: key }).toObject();
	      }).sortBy(function (c) {
	        return c.latestMessageTime ? -1 * c.latestMessageTime : 0;
	      });
	
	      return convs;
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	var setConvs = function setConvs(state, convs) {
	  return state.set('_convs', convs);
	};
	var setUser = function setUser(state, user) {
	  return state.setIn(['_users', user.get('uid')], user);
	};
	
	var setSegment = function setSegment(state, convs, users) {
	  if (!convs || !users) return state;
	
	  var segment = convs.map(function (conv, uid) {
	    return conv.merge(users.get(uid));
	  }).toList().filter(function (conv) {
	    return typeof conv.get('uid') === 'string';
	  }).sortBy(function (conv) {
	    return conv.get('latestMessageTime') ? -1 * conv.get('latestMessageTime') : 0;
	  });
	
	  return state.set('segment', segment);
	};
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_RECENT_CONVERSATIONS:
	      state = setConvs(state, (0, _immutable.fromJS)(action.recentConversations));
	      state = setSegment(state, state.get('_convs'), state.get('_users'));
	
	      return state;
	
	    case _action_types.SET_RECENT_CONVERSATION_USER:
	      state = setUser(state, (0, _immutable.fromJS)(action.user));
	      state = setSegment(state, state.get('_convs'), state.get('_users'));
	
	      return state;
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	var _settings = __webpack_require__(331);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _plugin_settings = __webpack_require__(323);
	
	var _plugin_settings2 = _interopRequireDefault(_plugin_settings);
	
	var _current_user = __webpack_require__(315);
	
	var _current_user2 = _interopRequireDefault(_current_user);
	
	var _current_guest = __webpack_require__(313);
	
	var _current_guest2 = _interopRequireDefault(_current_guest);
	
	var _users = __webpack_require__(333);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _chat_list_view = __webpack_require__(309);
	
	var _chat_list_view2 = _interopRequireDefault(_chat_list_view);
	
	var _presences = __webpack_require__(324);
	
	var _presences2 = _interopRequireDefault(_presences);
	
	var _chat_list_count = __webpack_require__(308);
	
	var _chat_list_count2 = _interopRequireDefault(_chat_list_count);
	
	var _conversations = __webpack_require__(310);
	
	var _conversations2 = _interopRequireDefault(_conversations);
	
	var _recent_conversations = __webpack_require__(325);
	
	var _recent_conversations2 = _interopRequireDefault(_recent_conversations);
	
	var _notifications = __webpack_require__(321);
	
	var _notifications2 = _interopRequireDefault(_notifications);
	
	var _sessions = __webpack_require__(330);
	
	var _sessions2 = _interopRequireDefault(_sessions);
	
	var _messages = __webpack_require__(319);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	var _modals = __webpack_require__(320);
	
	var _modals2 = _interopRequireDefault(_modals);
	
	var _current_payout_request = __webpack_require__(314);
	
	var _current_payout_request2 = _interopRequireDefault(_current_payout_request);
	
	var _current_customer = __webpack_require__(311);
	
	var _current_customer2 = _interopRequireDefault(_current_customer);
	
	var _current_expert_reviews = __webpack_require__(312);
	
	var _current_expert_reviews2 = _interopRequireDefault(_current_expert_reviews);
	
	var _payouts = __webpack_require__(322);
	
	var _payouts2 = _interopRequireDefault(_payouts);
	
	var _schedules = __webpack_require__(328);
	
	var _schedules2 = _interopRequireDefault(_schedules);
	
	var _top_experts = __webpack_require__(332);
	
	var _top_experts2 = _interopRequireDefault(_top_experts);
	
	var _group_chats = __webpack_require__(317);
	
	var _group_chats2 = _interopRequireDefault(_group_chats);
	
	var _viewport = __webpack_require__(334);
	
	var _viewport2 = _interopRequireDefault(_viewport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_CHAT_SETTINGS:
	      return state.set('chatSettings', (0, _settings2.default)(state.get('chatSettings'), action));
	
	    case _action_types.SET_PLUGIN_SETTINGS:
	      return state.set('pluginSettings', (0, _plugin_settings2.default)(state.get('pluginSettings'), action));
	
	    case _action_types.SET_CURRENT_USER:
	    case _action_types.SET_CURRENT_USER_PRESENCE:
	    case _action_types.SET_CURRENT_USER_ACTIVITY:
	      return state.set('currentUser', (0, _current_user2.default)(state.get('currentUser'), action)).set('users', (0, _users2.default)(state.get('users'), action)).set('chatListView', (0, _chat_list_view2.default)(state.get('chatListView'), action));
	
	    case _action_types.SET_CURRENT_GUEST:
	      return state.set('currentGuest', (0, _current_guest2.default)(state.getIn('currentGuest'), action));
	
	    case _action_types.SET_USERS:
	      return state.set('users', (0, _users2.default)(state.get('users'), action));
	
	    case _action_types.SET_CHAT_LIST_USER:
	    case _action_types.REMOVE_CHAT_LIST_USER:
	    case _action_types.CHANGE_CHAT_LIST_USER_ROLE:
	    case _action_types.SET_CHAT_LIST_GUESTS:
	      return state.set('chatListView', (0, _chat_list_view2.default)(state.get('chatListView'), action)).set('chatListCount', (0, _chat_list_count2.default)(state.get('chatListCount'), action));
	
	    case _action_types.SET_CHAT_LIST_TOGGLED:
	      return state.setIn(['chatListState', 'isToggled'], action.toggled);
	
	    case _action_types.SET_TOP_EXPERTS:
	      return state.set('topExperts', (0, _top_experts2.default)(state.get('topExperts'), action));
	
	    case _action_types.SET_USER:
	      return state.set('users', (0, _users2.default)(state.get('users'), action));
	
	    case _action_types.SET_PRESENCES:
	      return state.set('presences', (0, _presences2.default)(state.get('presences'), action));
	
	    case _action_types.SET_USER_PRESENCE:
	      return state.set('presences', (0, _presences2.default)(state.get('presences', action)));
	
	    case _action_types.SET_VIEWPORT_DIMENSIONS:
	      return state.set('viewport', (0, _viewport2.default)(state.get('viewport'), action)).set('conversations', (0, _conversations2.default)(state.get('conversations'), action));
	
	    case _action_types.SET_CONVERSATION_REFS:
	    case _action_types.SET_CONVERSATION_STACK:
	    case _action_types.SET_FOCUSED_CONVERSATION:
	    case _action_types.SET_LAST_OPEN_TIME_FOR_CONVERSATION:
	    case _action_types.SET_TOTAL_CONV_MESSAGE_COUNT:
	    case _action_types.SET_READ_CONV_MESSAGE_COUNT:
	      return state.set('conversations', (0, _conversations2.default)(state.get('conversations'), action));
	
	    case _action_types.SET_RECENT_CONVERSATIONS:
	    case _action_types.SET_RECENT_CONVERSATION_USER:
	      return state.set('recentConversations', (0, _recent_conversations2.default)(state.get('recentConversations'), action)).set('chatListView', (0, _chat_list_view2.default)(state.get('chatListView'), action));
	
	    case _action_types.SET_NEW_MESSAGE_NOTIFICATION:
	      return state.set('notifications', (0, _notifications2.default)(state.get('notifications'), action)).set('shouldShowNewMessageIndicatorOnMobile', true);
	
	    case _action_types.UNSET_NEW_MESSAGE_INDICATOR_ON_MOBILE:
	      return state.set('shouldShowNewMessageIndicatorOnMobile', false);
	
	    case _action_types.SET_USER_SESSION_REFS:
	    case _action_types.REMOVE_USER_SESSION_REF:
	    case _action_types.SET_SESSION_ACTIVITY:
	    case _action_types.SET_SESSION_REQUEST:
	    case _action_types.SET_SESSION_REQUESTS:
	    case _action_types.SET_USER_SESSIONS:
	    case _action_types.SET_USER_SESSIONS_COUNT:
	    case _action_types.SET_SESSION:
	    case _action_types.SET_SESSIONS:
	    case _action_types.SET_CURRENT_SESSION:
	    case _action_types.SET_SESSION_CLAIMS:
	      return state.set('sessions', (0, _sessions2.default)(state.get('sessions'), action));
	
	    case _action_types.SET_PREVIOUS_MESSAGES:
	    case _action_types.REMOVE_PREVIOUS_MESSAGES:
	    case _action_types.SET_NEW_MESSAGE:
	    case _action_types.UPDATE_MESSAGE_ATTR:
	      return state.set('messages', (0, _messages2.default)(state.get('messages'), action));
	
	    case _action_types.SET_CURRENT_CUSTOMER:
	      return state.set('currentCustomer', (0, _current_customer2.default)(state.get('currentCustomer'), action));
	
	    case _action_types.SHOW_MODAL:
	    case _action_types.CLOSE_MODAL:
	    case _action_types.CLOSE_ALL_MODALS:
	      return state.set('modals', (0, _modals2.default)(state.get('modals'), action));
	
	    case _action_types.SET_CURRENT_PAYOUT_REQUEST:
	      return state.set('currentPayoutRequest', (0, _current_payout_request2.default)(state.get('currentPayoutRequest'), action));
	
	    case _action_types.SET_CURRENT_EXPERT_REVIEWS:
	      return state.set('currentExpertReviews', (0, _current_expert_reviews2.default)(state.get('currentExpertReviews'), action));
	
	    case _action_types.SET_CURRENT_USER_PAYOUTS:
	      return state.set('currentUserPayouts', (0, _payouts2.default)(state.get('currentUserPayouts'), action));
	
	    case _action_types.SET_PAYOUTS:
	    case _action_types.ORDER_PAYOUTS:
	      return state.set('payouts', (0, _payouts2.default)(state.get('payouts'), action));
	
	    case _action_types.SET_USER_SCHEDULE:
	      return state.set('schedules', (0, _schedules2.default)(state.get('schedules'), action));
	
	    case _action_types.SET_GROUP_CHATS:
	    case _action_types.SET_GROUP_CHAT_ORDERS:
	    case _action_types.SET_BOOKMARKED_GROUP_CHATS:
	    case _action_types.REMOVE_BOOKMARKED_GROUP_CHAT:
	    case _action_types.SET_SUBSCRIBED_GROUP_CHATS:
	    case _action_types.REMOVE_SUBSCRIBED_GROUP_CHAT:
	    case _action_types.SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT:
	    case _action_types.REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT:
	      return state.set('groups', (0, _group_chats2.default)(state.get('groups'), action)).set('chatListView', (0, _chat_list_view2.default)(state.get('chatListView'), action));
	
	    case _action_types.SET_GROUP_CHAT:
	      return state.set('groups', (0, _group_chats2.default)(state.get('groups'), action));
	
	    case _action_types.SET_ADVERTISEMENTS:
	      return state.set('advertisements', (0, _immutable.fromJS)(action.advertisements));
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _action_types = __webpack_require__(4);
	
	var _get_empty_daily_availability_slots = __webpack_require__(268);
	
	var _get_empty_daily_availability_slots2 = _interopRequireDefault(_get_empty_daily_availability_slots);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	__webpack_require__(433); // TODO: find a way to use es6 style.
	
	var addRangeObjectToEntry = function addRangeObjectToEntry(entry) {
	  return entry.set('range', (0, _moment2.default)(entry.get('startTime')).twix(entry.get('endTime')));
	};
	
	var addEventAttributesToEntry = function addEventAttributesToEntry(entry) {
	  var updatingEntry = entry.set('start', (0, _moment2.default)(entry.get('startTime')).toDate()).set('end', (0, _moment2.default)(entry.get('endTime')).toDate());
	
	  var type = entry.get('type');
	  var otherUserName = entry.getIn(['payload', 'otherUser', 'name']);
	
	  if (type === _constants.SCHEDULE_ENTRIES.AVAILABLE_TIME) {
	    updatingEntry = updatingEntry.set('title', 'Available Time').set('className', 'schedule-event available-time');
	  } else if (type === _constants.SCHEDULE_ENTRIES.BOOKED) {
	    var title = 'Booked Session';
	
	    if (otherUserName) title += ' with ' + otherUserName;
	
	    updatingEntry = updatingEntry.set('className', 'schedule-event booked-session').set('title', title);
	  }
	
	  return updatingEntry;
	};
	
	var injectKeys = function injectKeys(entry, key) {
	  return entry.merge({ key: key });
	};
	
	var transformSchedule = function transformSchedule(schedule) {
	  return schedule.map(addRangeObjectToEntry).map(addEventAttributesToEntry).map(injectKeys);
	};
	
	var mappedSchedule = function mappedSchedule(rawSchedule) {
	  return (0, _immutable.Map)({}).withMutations(function (schedule) {
	    rawSchedule.map(function (rawEntries) {
	      rawEntries.get('range').split(1, 'day').map(function (dayRange) {
	        var day = dayRange.start();
	        var dayOfYear = day.dayOfYear();
	
	        var existingSlots = schedule.getIn([dayOfYear.toString(), 'slots']) || (0, _immutable.List)((0, _get_empty_daily_availability_slots2.default)());
	
	        var slots = existingSlots.withMutations(function (existingSlots) {
	          dayRange.split(_constants.SCHEDULE_SLOT_SPAN, 'minute').forEach(function (minuteRange) {
	            var slotStartTime = minuteRange.start();
	            var minutes = slotStartTime.diff((0, _moment2.default)(slotStartTime).startOf('day'), 'minutes');
	            var slotIndex = 0;
	            if (minutes > 0) slotIndex = minutes / _constants.SCHEDULE_SLOT_SPAN;
	            existingSlots.set(slotIndex, { available: true, startTime: slotStartTime });
	          });
	        });
	
	        schedule.mergeDeep(_defineProperty({}, dayOfYear, { day: day, slots: slots, index: dayOfYear }));
	      });
	    });
	  });
	};
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_USER_SCHEDULE:
	      var schedule = (0, _immutable.fromJS)(action.schedule);
	      var raw = transformSchedule(schedule).toList();
	      var mapped = mappedSchedule(raw);
	      // const availability = retrieveAvailabilitySlots(mapped)
	
	      return state.mergeDeep(_defineProperty({}, action.uid, { raw: raw, mapped: mapped /*, availability*/ }));
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	var sortRefsByStartTime = function sortRefsByStartTime(refObject) {
	  return refObject.get('startTime');
	};
	
	var arrangeSessionRefsByUser = function arrangeSessionRefsByUser(userRefs) {
	  return userRefs.toList().sortBy(sortRefsByStartTime);
	};
	
	var userSessionRefs = function userSessionRefs(refs) {
	  return (0, _immutable.fromJS)(refs).withMutations(function (sessionRefs) {
	    sessionRefs.merge(sessionRefs.map(arrangeSessionRefsByUser));
	  });
	};
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_USER_SESSION_REFS:
	      var sessionRefs = userSessionRefs(action.refs);
	      return state.mergeDeep(sessionRefs);
	
	    case _action_types.REMOVE_USER_SESSION_REF:
	      return state.delete(action.refKey);
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	var _session_refs = __webpack_require__(329);
	
	var _session_refs2 = _interopRequireDefault(_session_refs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_USER_SESSION_REFS:
	      return state.set('_refs', (0, _session_refs2.default)(state.get('_refs'), action));
	
	    case _action_types.REMOVE_USER_SESSION_REF:
	      return state.set('_refs', (0, _session_refs2.default)(state.get('_refs'), action));
	
	    case _action_types.SET_USER_SESSIONS:
	      if (action.sessions == null) {
	        return state.set('experts', action.sessions);
	      } else {
	        return state.mergeDeep({ experts: action.sessions });
	      }
	
	    case _action_types.SET_USER_SESSIONS_COUNT:
	      return state.mergeDeep({ _counts: _defineProperty({}, action.uid, action.count) });
	
	    case _action_types.SET_SESSION:
	      return state.mergeDeep({ experts: _defineProperty({}, action.key, action.session) });
	
	    case _action_types.SET_SESSIONS:
	      return state.set('experts', (0, _immutable.fromJS)(action.sessions));
	
	    case _action_types.SET_CURRENT_SESSION:
	      return state.set('_current', action.sessionId);
	
	    case _action_types.SET_SESSION_ACTIVITY:
	      if (action.sessionActivity && action.sessionId) {
	        return state.mergeDeep({ _activities: _defineProperty({}, action.sessionId, action.sessionActivity) });
	      }
	
	    case _action_types.SET_SESSION_REQUESTS:
	      // return state.mergeDeep({_requests: action.sessionRequests})
	      return state.set('_requests', (0, _immutable.fromJS)(action.sessionRequests));
	
	    case _action_types.SET_SESSION_REQUEST:
	      // TODO: change it to {_requests:{expertUid:{...}}}
	      // return state.mergeDeep({
	      //   _requests: {[action.expertUid]: {[action.userUid]: action.sessionRequest}}
	      // })
	      return state.setIn(['_requests', action.expertUid, action.userUid], (0, _immutable.fromJS)(action.sessionRequest));
	
	    case _action_types.SET_SESSION_CLAIMS:
	      return state.set('claims', (0, _immutable.fromJS)(action.claims || {}));
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)(_constants.CHAT_SETTINGS) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_CHAT_SETTINGS:
	      return state.mergeDeep(action.settings);
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	var getTopExperts = function getTopExperts(experts, count) {
	  return (0, _immutable.fromJS)(experts).toList().sortBy(function (expert) {
	    return -1 * expert.get('rating');
	  }).take(count);
	};
	
	exports.default = function (state, action) {
	  switch (action.type) {
	    case _action_types.SET_TOP_EXPERTS:
	      return getTopExperts(action.experts, action.count);
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_USERS:
	      return state.mergeDeep((0, _immutable.fromJS)(action.users));
	
	    case _action_types.SET_USER:
	      if (action.user.uid) {
	        return state.set(action.user.uid, (0, _immutable.fromJS)(action.user));
	      }
	
	    case _action_types.SET_CURRENT_USER:
	      if (action.user && action.user.uid) {
	        return state.set(action.user.uid, (0, _immutable.fromJS)(action.user));
	      }
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _action_types = __webpack_require__(4);
	
	var PHONE = _constants.VIEWPORT_TYPES.PHONE;
	var DESKTOP = _constants.VIEWPORT_TYPES.DESKTOP;
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.fromJS)({}) : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _action_types.SET_VIEWPORT_DIMENSIONS:
	      var width = action.width;
	      var height = action.height;
	
	      var type = width > _constants.VIEWPORT_MAX_WIDTH_PHONE ? DESKTOP : PHONE;
	
	      state = state.set('width', width);
	      state = state.set('height', height);
	      state = state.set('type', type);
	
	      return state;
	
	    default:
	      return state;
	  }
	};

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initiateGroupChatRefForUser = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getConversationFromState = function getConversationFromState(otherUid) {
	  return new Promise(function (resolve) {
	    resolve((0, _store.getState)().getIn(['conversations', '_refs', otherUid, 'conversationId']));
	  });
	};
	
	var getConversationRemote = function getConversationRemote(uid, otherUid, conversationId) {
	  if (conversationId) return conversationId;
	
	  var ENDPOINT = _constants.CONVERSATIONS_PRIVATE_REFS_ENDPOINT + '/' + uid + '/' + otherUid + '/conversationId';
	
	  return _firedux2.default.ref.child(ENDPOINT).once('value').then(function (snapshot) {
	    return snapshot.val();
	  });
	};
	
	var createConversationIfDoesntExist = function createConversationIfDoesntExist(conversationId) {
	  if (conversationId) return conversationId;
	
	  return _firedux2.default.ref.child(_constants.CONVERSATIONS_PRIVATE_ENDPOINT).push({}).then(function (ref) {
	    return ref.key();
	  });
	};
	
	var setConversationForUser = function setConversationForUser(uid, otherUid, conversationId) {
	  var ENDPOINT = _constants.CONVERSATIONS_PRIVATE_REFS_ENDPOINT + '/' + uid + '/' + otherUid + '/conversationId';
	
	  return _firedux2.default.ref.child(ENDPOINT).set(conversationId).then(function () {
	    return conversationId;
	  });
	};
	
	var initiateGroupChatRefForUser = exports.initiateGroupChatRefForUser = function initiateGroupChatRefForUser(uid, groupId) {
	  if (!uid || !groupId) return;
	
	  return getConversationFromState(groupId).then(getConversationRemote.bind(null, uid, groupId)).then(setConversationForUser.bind(null, uid, groupId, groupId));
	};
	
	exports.default = function (uid, otherUid) {
	  if (!uid || !otherUid) return;
	
	  return getConversationFromState(otherUid).then(getConversationRemote.bind(null, uid, otherUid)).then(createConversationIfDoesntExist).then(setConversationForUser.bind(null, uid, otherUid)).then(setConversationForUser.bind(null, otherUid, uid));
	};

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchGlobalGroupOrders = exports.watchGlobalGroupOrders = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_group_chat_orders = __webpack_require__(298);
	
	var _set_group_chat_orders2 = _interopRequireDefault(_set_group_chat_orders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onGroupOrders = function onGroupOrders(scope, snapshot) {
	  return (0, _store.dispatch)((0, _set_group_chat_orders2.default)(snapshot.val(), scope));
	};
	var onGlobalGroupOrders = function onGlobalGroupOrders(snapshot) {
	  return onGroupOrders(_constants.GROUP_CHAT_SCOPES.GLOBAL, snapshot);
	};
	
	var watchGlobalGroupOrders = exports.watchGlobalGroupOrders = function watchGlobalGroupOrders() {
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_ORDERS_ENDPOINT).child(_constants.GROUP_CHAT_SCOPES.GLOBAL);
	
	  ref.on('value', onGlobalGroupOrders);
	};
	
	var unwatchGlobalGroupOrders = exports.unwatchGlobalGroupOrders = function unwatchGlobalGroupOrders() {
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_ORDERS_ENDPOINT).child(_constants.GROUP_CHAT_SCOPES.GLOBAL);
	
	  ref.off('value', onGlobalGroupOrders);
	};

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoToSessionButton = function (_React$Component) {
	  _inherits(GoToSessionButton, _React$Component);
	
	  function GoToSessionButton() {
	    _classCallCheck(this, GoToSessionButton);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(GoToSessionButton).apply(this, arguments));
	  }
	
	  _createClass(GoToSessionButton, [{
	    key: 'sessionUrl',
	    value: function sessionUrl() {
	      return this.props.sessionsUrl + '?sessionId=' + this.props.sessionId;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'a',
	        { href: this.sessionUrl(), target: '_blank', className: this.props.classNames, style: this.props.style },
	        this.props.text ? this.props.text : 'Go to your session'
	      );
	    }
	  }]);
	
	  return GoToSessionButton;
	}(_react2.default.Component);
	
	GoToSessionButton.defaultProps = {
	  classNames: 'button success'
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    sessionsUrl: state.getIn(['pluginSettings', 'sessionsUrl'])
	  };
	};
	
	var GoToSessionButtonContainer = (0, _reactRedux.connect)(mapStateToProps)(GoToSessionButton);
	
	exports.default = GoToSessionButtonContainer;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _close_modal = __webpack_require__(46);
	
	var _close_modal2 = _interopRequireDefault(_close_modal);
	
	var _group_chat_subscription = __webpack_require__(507);
	
	var _modal_view = __webpack_require__(47);
	
	var _modal_view2 = _interopRequireDefault(_modal_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INSTANT = _constants.GROUP_CHAT_SUBSCRIPTION_TYPES.INSTANT;
	var DAILY = _constants.GROUP_CHAT_SUBSCRIPTION_TYPES.DAILY;
	var WEEKLY = _constants.GROUP_CHAT_SUBSCRIPTION_TYPES.WEEKLY;
	
	var GroupChatSubscriptionModal = function (_React$Component) {
	  _inherits(GroupChatSubscriptionModal, _React$Component);
	
	  function GroupChatSubscriptionModal(props) {
	    var _this$subscriptionAct;
	
	    _classCallCheck(this, GroupChatSubscriptionModal);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GroupChatSubscriptionModal).call(this, props));
	
	    _this.closeModal = _this.closeModal.bind(_this);
	
	    _this.subscriptionActionAttrs = (_this$subscriptionAct = {}, _defineProperty(_this$subscriptionAct, INSTANT, {
	      header: 'Instant',
	      infoUnchecked: 'Get every message by email for this group chat when you are offline',
	      infoChecked: 'You are getting every message by email for this group chat when you are offline'
	    }), _defineProperty(_this$subscriptionAct, DAILY, {
	      header: 'Daily',
	      infoUnchecked: 'Get daily digests by email for this group chat',
	      infoChecked: 'You are getting daily digests by email for this group chat'
	    }), _defineProperty(_this$subscriptionAct, WEEKLY, {
	      header: 'Weekly',
	      infoUnchecked: 'Get weekly digests by email for this group chat',
	      infoChecked: 'You are getting weekly digests by email for this group chat'
	    }), _this$subscriptionAct);
	
	    _this.renderSubscriptionRow = _this.renderSubscriptionRow.bind(_this);
	    return _this;
	  }
	
	  _createClass(GroupChatSubscriptionModal, [{
	    key: 'toggleSubscription',
	    value: function toggleSubscription(type, isSubscribed) {
	      if (isSubscribed) this.props.unsubscribeGroup(this.props.uid, this.props.groupId, type);else this.props.subscribeGroup(this.props.uid, this.props.groupId, type);
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal(e) {
	      if (e) e.preventDefault();
	
	      this.props.onCloseModal(this.props.modalKey);
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      if (!this.props.uid) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'alert alert-warning warning' },
	          'You have to sign in to change subscription options.'
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'alert alert-success success' },
	          'You can subscribe to any option below to be up to date for this group chat.'
	        );
	      }
	    }
	  }, {
	    key: 'renderSubscribedMark',
	    value: function renderSubscribedMark(isSubscribed) {
	      if (!isSubscribed) return false;
	
	      return _react2.default.createElement('i', { className: 'rc-icon-check', style: { fontSize: 24 } });
	    }
	  }, {
	    key: 'renderSubscriptionRow',
	    value: function renderSubscriptionRow(type) {
	      var _subscriptionActionAt = this.subscriptionActionAttrs[type];
	      var header = _subscriptionActionAt.header;
	      var infoUnchecked = _subscriptionActionAt.infoUnchecked;
	      var infoChecked = _subscriptionActionAt.infoChecked;
	
	      var isSubscribed = this.props.subscription.get(type);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'action-row', onClick: this.toggleSubscription.bind(this, type, isSubscribed) },
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'table-cell', width: '100%' } },
	          _react2.default.createElement(
	            'div',
	            { style: { marginRight: 5 } },
	            _react2.default.createElement(
	              'h5',
	              { style: { marginTop: 0, marginBottom: 0, fontWeight: 'bold' } },
	              header
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { fontSize: 10, color: '#A0A0A0' } },
	              isSubscribed ? infoChecked : infoUnchecked
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'table-cell', verticalAlign: 'middle', textAlign: 'right', color: '#259B24' } },
	          this.renderSubscribedMark(isSubscribed)
	        )
	      );
	    }
	  }, {
	    key: 'renderSubscriptionRows',
	    value: function renderSubscriptionRows() {
	      if (!this.props.uid) return false;
	
	      return [INSTANT, DAILY, WEEKLY].map(this.renderSubscriptionRow);
	    }
	  }, {
	    key: 'renderActions',
	    value: function renderActions() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'actions stacked' },
	        this.renderSubscriptionRows(),
	        _react2.default.createElement(
	          'div',
	          { className: 'cancel action-row', onClick: this.closeModal, style: { textAlign: 'center' } },
	          'Close'
	        )
	      );
	    }
	  }, {
	    key: 'renderSecondaryHeader',
	    value: function renderSecondaryHeader() {
	      if (this.props.source === 'user' && this.props.uid) {
	        return _react2.default.createElement(
	          'h6',
	          null,
	          'For: ',
	          this.props.uid
	        );
	      }
	    }
	  }, {
	    key: 'renderModalContent',
	    value: function renderModalContent() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-header' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Subscribe to Group Chat: ',
	            this.props.groupChat.get('name')
	          ),
	          this.renderSecondaryHeader()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-body' },
	          this.renderBody()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-footer no-padding' },
	          this.renderActions()
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _modal_view2.default,
	        { isActive: true, onClose: this.onClose },
	        this.renderModalContent()
	      );
	    }
	  }]);
	
	  return GroupChatSubscriptionModal;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var uid = void 0,
	      subscription = void 0;
	
	  if (ownProps.source === 'user') {
	    uid = ownProps.uid;
	    subscription = state.getIn(['groups', '_subscriptions', 'groups', ownProps.groupId, uid], (0, _immutable.fromJS)({}));
	  } else {
	    uid = state.getIn(['currentUser', 'uid']);
	    subscription = state.getIn(['groups', '_subscriptions', 'users', uid, ownProps.groupId], (0, _immutable.fromJS)({}));
	  }
	
	  return {
	    groupChat: state.getIn(['groups', 'all', ownProps.groupId]),
	    uid: uid,
	    subscription: subscription
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    subscribeGroup: _group_chat_subscription.subscribeGroupChat,
	    unsubscribeGroup: _group_chat_subscription.unsubscribeGroupChat,
	    onCloseModal: function onCloseModal(modalKey) {
	      return dispatch((0, _close_modal2.default)(modalKey));
	    }
	  };
	};
	
	var GroupChatSubscriptionModalContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GroupChatSubscriptionModal);
	
	exports.default = GroupChatSubscriptionModalContainer;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutabilityHelper = __webpack_require__(231);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _values = __webpack_require__(113);
	
	var _values2 = _interopRequireDefault(_values);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DesktopNotificationsHandler = function () {
	  function DesktopNotificationsHandler() {
	    _classCallCheck(this, DesktopNotificationsHandler);
	
	    this.notifications = {};
	    this.NotificationHandler = window.Notification;
	  }
	
	  _createClass(DesktopNotificationsHandler, [{
	    key: 'hasSupport',
	    value: function hasSupport() {
	      return this.NotificationHandler ? true : false;
	    }
	  }, {
	    key: 'getPermission',
	    value: function getPermission() {
	      if (!this.hasSupport()) return;
	      return this.NotificationHandler.permission;
	    }
	  }, {
	    key: 'requestPermission',
	    value: function requestPermission(cb) {
	      if (!this.hasSupport()) return;
	      this.NotificationHandler.requestPermission(cb);
	    }
	  }, {
	    key: 'notify',
	    value: function notify(notification) {
	      var _this = this;
	
	      if (!notification) return;
	      if (!this.hasSupport()) return;
	
	      if (this.getPermission() === 'default') {
	        return this.requestPermission(function (permission) {
	          if (permission === 'granted') _this.notify(notification);
	        });
	      }
	
	      var from = notification.from;
	      if (!this.notifications[from]) this.notifications[from] = [];
	
	      var desktopNotif = new this.NotificationHandler(notification.title, {
	        icon: notification.icon, body: notification.body, tag: notification.tag
	      });
	
	      desktopNotif.onclick = function () {
	        window.focus();
	        _this.markAllAsReadFrom(from);
	      };
	
	      this.notifications = (0, _immutabilityHelper2.default)(this.notifications, _defineProperty({}, from, { $push: [desktopNotif] }));
	
	      return desktopNotif;
	    }
	  }, {
	    key: 'markAllAsReadFrom',
	    value: function markAllAsReadFrom(from) {
	      if (!this.notifications[from]) return;
	
	      this.notifications[from].forEach(function (notif) {
	        notif.close();
	      });
	      this.notifications = (0, _immutabilityHelper2.default)(this.notifications, _defineProperty({}, from, { $set: [] }));
	    }
	  }, {
	    key: 'markAllAsRead',
	    value: function markAllAsRead() {
	      var _this2 = this;
	
	      if (!this.notifications) return;
	
	      (0, _values2.default)(this.notifications).forEach(function (notifs, from) {
	        _this2.markAllAsReadFrom(from);
	      });
	    }
	  }]);
	
	  return DesktopNotificationsHandler;
	}();
	
	exports.default = DesktopNotificationsHandler;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSpinkit = __webpack_require__(67);
	
	var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Loader = function (_React$Component) {
	  _inherits(Loader, _React$Component);
	
	  function Loader(props) {
	    _classCallCheck(this, Loader);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Loader).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Loader, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'loader-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'loader' },
	            _react2.default.createElement(_reactSpinkit2.default, { type: 'three-bounce' })
	          )
	        );
	      } else {
	        return false;
	      }
	    }
	  }]);
	
	  return Loader;
	}(_react2.default.Component);
	
	Loader.defaultProps = {
	  loading: false
	};
	
	exports.default = Loader;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(2);
	
	var _truncate_string = __webpack_require__(77);
	
	var _truncate_string2 = _interopRequireDefault(_truncate_string);
	
	var _is_user_expert = __webpack_require__(70);
	
	var _is_user_expert2 = _interopRequireDefault(_is_user_expert);
	
	var _expert_rating = __webpack_require__(78);
	
	var _expert_rating2 = _interopRequireDefault(_expert_rating);
	
	var _expert_sessions_count = __webpack_require__(273);
	
	var _expert_sessions_count2 = _interopRequireDefault(_expert_sessions_count);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserItemInfo = function (_React$Component) {
	  _inherits(UserItemInfo, _React$Component);
	
	  function UserItemInfo(props) {
	    _classCallCheck(this, UserItemInfo);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(UserItemInfo).call(this, props));
	
	    _this.state = {
	      shouldShowSpecialtyTooltip: false
	    };
	
	    _this.onShowSpecialtyTooltip = _this.onShowSpecialtyTooltip.bind(_this);
	    _this.onHideSpecialtyTooltip = _this.onHideSpecialtyTooltip.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserItemInfo, [{
	    key: 'onShowSpecialtyTooltip',
	    value: function onShowSpecialtyTooltip() {
	      this.setState({ shouldShowSpecialtyTooltip: true });
	    }
	  }, {
	    key: 'onHideSpecialtyTooltip',
	    value: function onHideSpecialtyTooltip() {
	      this.setState({ shouldShowSpecialtyTooltip: false });
	    }
	  }, {
	    key: 'renderExpertRating',
	    value: function renderExpertRating() {
	      if (this.props.ratingEnabled && this.props.user.rating) {
	        return _react2.default.createElement(_expert_rating2.default, { rating: this.props.user.rating, margin: this.props.ratingMargin, display: 'inline-block' });
	      }
	    }
	  }, {
	    key: 'renderSessionsCount',
	    value: function renderSessionsCount() {
	      if (this.props.sessionsCountEnabled) {
	        return _react2.default.createElement(_expert_sessions_count2.default, { uid: this.props.user.uid, marginLeft: 10 });
	      }
	    }
	  }, {
	    key: 'renderExpertFields',
	    value: function renderExpertFields() {
	      if (this.props.user.role === _constants.ROLES.EXPERT && (this.props.ratingEnabled || this.props.sessionsCountEnabled)) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.renderExpertRating(),
	          this.renderSessionsCount()
	        );
	      }
	    }
	  }, {
	    key: 'renderSpecialtyTooltip',
	    value: function renderSpecialtyTooltip() {
	      if (this.state.shouldShowSpecialtyTooltip) {
	        return _react2.default.createElement(
	          'div',
	          { style: { background: 'rgba(30, 30, 30, .9)', fontSize: 11, lineHeight: '1.2em', padding: 5, position: 'absolute', top: 30, zIndex: 10, left: 0, borderRadius: 4, color: '#F0F0F0' } },
	          this.props.user.specialty
	        );
	      }
	    }
	  }, {
	    key: 'renderExpertSpecialty',
	    value: function renderExpertSpecialty() {
	      if (this.props.specialtyEnabled && (0, _is_user_expert2.default)(this.props.user.role) && this.props.user.specialty) {
	        var className = 'expert-sepecialty';
	        if (this.props.threeLineSpecialty) className += ' three-line-text';
	
	        return _react2.default.createElement(
	          'div',
	          { style: { position: 'relative' }, onMouseEnter: this.onShowSpecialtyTooltip, onMouseLeave: this.onHideSpecialtyTooltip },
	          _react2.default.createElement(
	            'div',
	            { className: className, style: { fontSize: 12, fontWeight: 'bold', lineHeight: '1.2em', height: this.props.specialtyHeight, overflowY: 'hidden' } },
	            'Expert in: ',
	            this.props.user.specialty
	          ),
	          this.renderSpecialtyTooltip()
	        );
	      }
	    }
	  }, {
	    key: 'renderUserName',
	    value: function renderUserName(name) {
	      if (this.props.truncateTo) return (0, _truncate_string2.default)(name, this.props.truncateTo);
	
	      return name;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var userNameClassName = 'name';
	
	      if (this.props.twoLineName) userNameClassName += ' two-line-expert-text';else if (this.props.freeLineName) userNameClassName += ' free-line-expert-text';else userNameClassName += ' one-line-text';
	
	      var whiteSpace = this.props.shouldFixLineClamp ? 'initial' : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'user-item-info ' + this.props.className, style: this.props.style },
	        _react2.default.createElement(
	          'h4',
	          { className: userNameClassName, style: { color: this.props.usernameColor || this.props.usernameStyle.color, fontSize: this.props.usernameStyle.fontSize, fontWeight: this.props.usernameStyle.fontWeight, whiteSpace: whiteSpace } },
	          this.renderUserName(this.props.user.name)
	        ),
	        this.renderExpertFields(),
	        this.renderExpertSpecialty()
	      );
	    }
	  }]);
	
	  return UserItemInfo;
	}(_react2.default.Component);
	
	UserItemInfo.defaultProps = {
	  ratingEnabled: false,
	  sessionsCountEnabled: false,
	  specialtyEnabled: false,
	  specialtyHeight: '2.5em',
	  usernameStyle: { color: '#212121' }
	};
	
	exports.default = UserItemInfo;

/***/ },
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var require;var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, global, module) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
	 * @version   3.1.2
	 */
	
	(function() {
	    "use strict";
	    function lib$es6$promise$utils$$objectOrFunction(x) {
	      return typeof x === 'function' || (typeof x === 'object' && x !== null);
	    }
	
	    function lib$es6$promise$utils$$isFunction(x) {
	      return typeof x === 'function';
	    }
	
	    function lib$es6$promise$utils$$isMaybeThenable(x) {
	      return typeof x === 'object' && x !== null;
	    }
	
	    var lib$es6$promise$utils$$_isArray;
	    if (!Array.isArray) {
	      lib$es6$promise$utils$$_isArray = function (x) {
	        return Object.prototype.toString.call(x) === '[object Array]';
	      };
	    } else {
	      lib$es6$promise$utils$$_isArray = Array.isArray;
	    }
	
	    var lib$es6$promise$utils$$isArray = lib$es6$promise$utils$$_isArray;
	    var lib$es6$promise$asap$$len = 0;
	    var lib$es6$promise$asap$$vertxNext;
	    var lib$es6$promise$asap$$customSchedulerFn;
	
	    var lib$es6$promise$asap$$asap = function asap(callback, arg) {
	      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len] = callback;
	      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len + 1] = arg;
	      lib$es6$promise$asap$$len += 2;
	      if (lib$es6$promise$asap$$len === 2) {
	        // If len is 2, that means that we need to schedule an async flush.
	        // If additional callbacks are queued before the queue is flushed, they
	        // will be processed by this flush that we are scheduling.
	        if (lib$es6$promise$asap$$customSchedulerFn) {
	          lib$es6$promise$asap$$customSchedulerFn(lib$es6$promise$asap$$flush);
	        } else {
	          lib$es6$promise$asap$$scheduleFlush();
	        }
	      }
	    }
	
	    function lib$es6$promise$asap$$setScheduler(scheduleFn) {
	      lib$es6$promise$asap$$customSchedulerFn = scheduleFn;
	    }
	
	    function lib$es6$promise$asap$$setAsap(asapFn) {
	      lib$es6$promise$asap$$asap = asapFn;
	    }
	
	    var lib$es6$promise$asap$$browserWindow = (typeof window !== 'undefined') ? window : undefined;
	    var lib$es6$promise$asap$$browserGlobal = lib$es6$promise$asap$$browserWindow || {};
	    var lib$es6$promise$asap$$BrowserMutationObserver = lib$es6$promise$asap$$browserGlobal.MutationObserver || lib$es6$promise$asap$$browserGlobal.WebKitMutationObserver;
	    var lib$es6$promise$asap$$isNode = typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	    // test for web worker but not in IE10
	    var lib$es6$promise$asap$$isWorker = typeof Uint8ClampedArray !== 'undefined' &&
	      typeof importScripts !== 'undefined' &&
	      typeof MessageChannel !== 'undefined';
	
	    // node
	    function lib$es6$promise$asap$$useNextTick() {
	      // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	      // see https://github.com/cujojs/when/issues/410 for details
	      return function() {
	        process.nextTick(lib$es6$promise$asap$$flush);
	      };
	    }
	
	    // vertx
	    function lib$es6$promise$asap$$useVertxTimer() {
	      return function() {
	        lib$es6$promise$asap$$vertxNext(lib$es6$promise$asap$$flush);
	      };
	    }
	
	    function lib$es6$promise$asap$$useMutationObserver() {
	      var iterations = 0;
	      var observer = new lib$es6$promise$asap$$BrowserMutationObserver(lib$es6$promise$asap$$flush);
	      var node = document.createTextNode('');
	      observer.observe(node, { characterData: true });
	
	      return function() {
	        node.data = (iterations = ++iterations % 2);
	      };
	    }
	
	    // web worker
	    function lib$es6$promise$asap$$useMessageChannel() {
	      var channel = new MessageChannel();
	      channel.port1.onmessage = lib$es6$promise$asap$$flush;
	      return function () {
	        channel.port2.postMessage(0);
	      };
	    }
	
	    function lib$es6$promise$asap$$useSetTimeout() {
	      return function() {
	        setTimeout(lib$es6$promise$asap$$flush, 1);
	      };
	    }
	
	    var lib$es6$promise$asap$$queue = new Array(1000);
	    function lib$es6$promise$asap$$flush() {
	      for (var i = 0; i < lib$es6$promise$asap$$len; i+=2) {
	        var callback = lib$es6$promise$asap$$queue[i];
	        var arg = lib$es6$promise$asap$$queue[i+1];
	
	        callback(arg);
	
	        lib$es6$promise$asap$$queue[i] = undefined;
	        lib$es6$promise$asap$$queue[i+1] = undefined;
	      }
	
	      lib$es6$promise$asap$$len = 0;
	    }
	
	    function lib$es6$promise$asap$$attemptVertx() {
	      try {
	        var r = require;
	        var vertx = __webpack_require__(443);
	        lib$es6$promise$asap$$vertxNext = vertx.runOnLoop || vertx.runOnContext;
	        return lib$es6$promise$asap$$useVertxTimer();
	      } catch(e) {
	        return lib$es6$promise$asap$$useSetTimeout();
	      }
	    }
	
	    var lib$es6$promise$asap$$scheduleFlush;
	    // Decide what async method to use to triggering processing of queued callbacks:
	    if (lib$es6$promise$asap$$isNode) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useNextTick();
	    } else if (lib$es6$promise$asap$$BrowserMutationObserver) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMutationObserver();
	    } else if (lib$es6$promise$asap$$isWorker) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMessageChannel();
	    } else if (lib$es6$promise$asap$$browserWindow === undefined && "function" === 'function') {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$attemptVertx();
	    } else {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useSetTimeout();
	    }
	    function lib$es6$promise$then$$then(onFulfillment, onRejection) {
	      var parent = this;
	      var state = parent._state;
	
	      if (state === lib$es6$promise$$internal$$FULFILLED && !onFulfillment || state === lib$es6$promise$$internal$$REJECTED && !onRejection) {
	        return this;
	      }
	
	      var child = new this.constructor(lib$es6$promise$$internal$$noop);
	      var result = parent._result;
	
	      if (state) {
	        var callback = arguments[state - 1];
	        lib$es6$promise$asap$$asap(function(){
	          lib$es6$promise$$internal$$invokeCallback(state, child, callback, result);
	        });
	      } else {
	        lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection);
	      }
	
	      return child;
	    }
	    var lib$es6$promise$then$$default = lib$es6$promise$then$$then;
	    function lib$es6$promise$promise$resolve$$resolve(object) {
	      /*jshint validthis:true */
	      var Constructor = this;
	
	      if (object && typeof object === 'object' && object.constructor === Constructor) {
	        return object;
	      }
	
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	      lib$es6$promise$$internal$$resolve(promise, object);
	      return promise;
	    }
	    var lib$es6$promise$promise$resolve$$default = lib$es6$promise$promise$resolve$$resolve;
	
	    function lib$es6$promise$$internal$$noop() {}
	
	    var lib$es6$promise$$internal$$PENDING   = void 0;
	    var lib$es6$promise$$internal$$FULFILLED = 1;
	    var lib$es6$promise$$internal$$REJECTED  = 2;
	
	    var lib$es6$promise$$internal$$GET_THEN_ERROR = new lib$es6$promise$$internal$$ErrorObject();
	
	    function lib$es6$promise$$internal$$selfFulfillment() {
	      return new TypeError("You cannot resolve a promise with itself");
	    }
	
	    function lib$es6$promise$$internal$$cannotReturnOwn() {
	      return new TypeError('A promises callback cannot return that same promise.');
	    }
	
	    function lib$es6$promise$$internal$$getThen(promise) {
	      try {
	        return promise.then;
	      } catch(error) {
	        lib$es6$promise$$internal$$GET_THEN_ERROR.error = error;
	        return lib$es6$promise$$internal$$GET_THEN_ERROR;
	      }
	    }
	
	    function lib$es6$promise$$internal$$tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	      try {
	        then.call(value, fulfillmentHandler, rejectionHandler);
	      } catch(e) {
	        return e;
	      }
	    }
	
	    function lib$es6$promise$$internal$$handleForeignThenable(promise, thenable, then) {
	       lib$es6$promise$asap$$asap(function(promise) {
	        var sealed = false;
	        var error = lib$es6$promise$$internal$$tryThen(then, thenable, function(value) {
	          if (sealed) { return; }
	          sealed = true;
	          if (thenable !== value) {
	            lib$es6$promise$$internal$$resolve(promise, value);
	          } else {
	            lib$es6$promise$$internal$$fulfill(promise, value);
	          }
	        }, function(reason) {
	          if (sealed) { return; }
	          sealed = true;
	
	          lib$es6$promise$$internal$$reject(promise, reason);
	        }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	        if (!sealed && error) {
	          sealed = true;
	          lib$es6$promise$$internal$$reject(promise, error);
	        }
	      }, promise);
	    }
	
	    function lib$es6$promise$$internal$$handleOwnThenable(promise, thenable) {
	      if (thenable._state === lib$es6$promise$$internal$$FULFILLED) {
	        lib$es6$promise$$internal$$fulfill(promise, thenable._result);
	      } else if (thenable._state === lib$es6$promise$$internal$$REJECTED) {
	        lib$es6$promise$$internal$$reject(promise, thenable._result);
	      } else {
	        lib$es6$promise$$internal$$subscribe(thenable, undefined, function(value) {
	          lib$es6$promise$$internal$$resolve(promise, value);
	        }, function(reason) {
	          lib$es6$promise$$internal$$reject(promise, reason);
	        });
	      }
	    }
	
	    function lib$es6$promise$$internal$$handleMaybeThenable(promise, maybeThenable, then) {
	      if (maybeThenable.constructor === promise.constructor &&
	          then === lib$es6$promise$then$$default &&
	          constructor.resolve === lib$es6$promise$promise$resolve$$default) {
	        lib$es6$promise$$internal$$handleOwnThenable(promise, maybeThenable);
	      } else {
	        if (then === lib$es6$promise$$internal$$GET_THEN_ERROR) {
	          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$GET_THEN_ERROR.error);
	        } else if (then === undefined) {
	          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	        } else if (lib$es6$promise$utils$$isFunction(then)) {
	          lib$es6$promise$$internal$$handleForeignThenable(promise, maybeThenable, then);
	        } else {
	          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	        }
	      }
	    }
	
	    function lib$es6$promise$$internal$$resolve(promise, value) {
	      if (promise === value) {
	        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$selfFulfillment());
	      } else if (lib$es6$promise$utils$$objectOrFunction(value)) {
	        lib$es6$promise$$internal$$handleMaybeThenable(promise, value, lib$es6$promise$$internal$$getThen(value));
	      } else {
	        lib$es6$promise$$internal$$fulfill(promise, value);
	      }
	    }
	
	    function lib$es6$promise$$internal$$publishRejection(promise) {
	      if (promise._onerror) {
	        promise._onerror(promise._result);
	      }
	
	      lib$es6$promise$$internal$$publish(promise);
	    }
	
	    function lib$es6$promise$$internal$$fulfill(promise, value) {
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }
	
	      promise._result = value;
	      promise._state = lib$es6$promise$$internal$$FULFILLED;
	
	      if (promise._subscribers.length !== 0) {
	        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, promise);
	      }
	    }
	
	    function lib$es6$promise$$internal$$reject(promise, reason) {
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }
	      promise._state = lib$es6$promise$$internal$$REJECTED;
	      promise._result = reason;
	
	      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publishRejection, promise);
	    }
	
	    function lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection) {
	      var subscribers = parent._subscribers;
	      var length = subscribers.length;
	
	      parent._onerror = null;
	
	      subscribers[length] = child;
	      subscribers[length + lib$es6$promise$$internal$$FULFILLED] = onFulfillment;
	      subscribers[length + lib$es6$promise$$internal$$REJECTED]  = onRejection;
	
	      if (length === 0 && parent._state) {
	        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, parent);
	      }
	    }
	
	    function lib$es6$promise$$internal$$publish(promise) {
	      var subscribers = promise._subscribers;
	      var settled = promise._state;
	
	      if (subscribers.length === 0) { return; }
	
	      var child, callback, detail = promise._result;
	
	      for (var i = 0; i < subscribers.length; i += 3) {
	        child = subscribers[i];
	        callback = subscribers[i + settled];
	
	        if (child) {
	          lib$es6$promise$$internal$$invokeCallback(settled, child, callback, detail);
	        } else {
	          callback(detail);
	        }
	      }
	
	      promise._subscribers.length = 0;
	    }
	
	    function lib$es6$promise$$internal$$ErrorObject() {
	      this.error = null;
	    }
	
	    var lib$es6$promise$$internal$$TRY_CATCH_ERROR = new lib$es6$promise$$internal$$ErrorObject();
	
	    function lib$es6$promise$$internal$$tryCatch(callback, detail) {
	      try {
	        return callback(detail);
	      } catch(e) {
	        lib$es6$promise$$internal$$TRY_CATCH_ERROR.error = e;
	        return lib$es6$promise$$internal$$TRY_CATCH_ERROR;
	      }
	    }
	
	    function lib$es6$promise$$internal$$invokeCallback(settled, promise, callback, detail) {
	      var hasCallback = lib$es6$promise$utils$$isFunction(callback),
	          value, error, succeeded, failed;
	
	      if (hasCallback) {
	        value = lib$es6$promise$$internal$$tryCatch(callback, detail);
	
	        if (value === lib$es6$promise$$internal$$TRY_CATCH_ERROR) {
	          failed = true;
	          error = value.error;
	          value = null;
	        } else {
	          succeeded = true;
	        }
	
	        if (promise === value) {
	          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$cannotReturnOwn());
	          return;
	        }
	
	      } else {
	        value = detail;
	        succeeded = true;
	      }
	
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) {
	        // noop
	      } else if (hasCallback && succeeded) {
	        lib$es6$promise$$internal$$resolve(promise, value);
	      } else if (failed) {
	        lib$es6$promise$$internal$$reject(promise, error);
	      } else if (settled === lib$es6$promise$$internal$$FULFILLED) {
	        lib$es6$promise$$internal$$fulfill(promise, value);
	      } else if (settled === lib$es6$promise$$internal$$REJECTED) {
	        lib$es6$promise$$internal$$reject(promise, value);
	      }
	    }
	
	    function lib$es6$promise$$internal$$initializePromise(promise, resolver) {
	      try {
	        resolver(function resolvePromise(value){
	          lib$es6$promise$$internal$$resolve(promise, value);
	        }, function rejectPromise(reason) {
	          lib$es6$promise$$internal$$reject(promise, reason);
	        });
	      } catch(e) {
	        lib$es6$promise$$internal$$reject(promise, e);
	      }
	    }
	
	    function lib$es6$promise$promise$all$$all(entries) {
	      return new lib$es6$promise$enumerator$$default(this, entries).promise;
	    }
	    var lib$es6$promise$promise$all$$default = lib$es6$promise$promise$all$$all;
	    function lib$es6$promise$promise$race$$race(entries) {
	      /*jshint validthis:true */
	      var Constructor = this;
	
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	
	      if (!lib$es6$promise$utils$$isArray(entries)) {
	        lib$es6$promise$$internal$$reject(promise, new TypeError('You must pass an array to race.'));
	        return promise;
	      }
	
	      var length = entries.length;
	
	      function onFulfillment(value) {
	        lib$es6$promise$$internal$$resolve(promise, value);
	      }
	
	      function onRejection(reason) {
	        lib$es6$promise$$internal$$reject(promise, reason);
	      }
	
	      for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
	        lib$es6$promise$$internal$$subscribe(Constructor.resolve(entries[i]), undefined, onFulfillment, onRejection);
	      }
	
	      return promise;
	    }
	    var lib$es6$promise$promise$race$$default = lib$es6$promise$promise$race$$race;
	    function lib$es6$promise$promise$reject$$reject(reason) {
	      /*jshint validthis:true */
	      var Constructor = this;
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	      lib$es6$promise$$internal$$reject(promise, reason);
	      return promise;
	    }
	    var lib$es6$promise$promise$reject$$default = lib$es6$promise$promise$reject$$reject;
	
	    var lib$es6$promise$promise$$counter = 0;
	
	    function lib$es6$promise$promise$$needsResolver() {
	      throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	    }
	
	    function lib$es6$promise$promise$$needsNew() {
	      throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	    }
	
	    var lib$es6$promise$promise$$default = lib$es6$promise$promise$$Promise;
	    /**
	      Promise objects represent the eventual result of an asynchronous operation. The
	      primary way of interacting with a promise is through its `then` method, which
	      registers callbacks to receive either a promise's eventual value or the reason
	      why the promise cannot be fulfilled.
	
	      Terminology
	      -----------
	
	      - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	      - `thenable` is an object or function that defines a `then` method.
	      - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	      - `exception` is a value that is thrown using the throw statement.
	      - `reason` is a value that indicates why a promise was rejected.
	      - `settled` the final resting state of a promise, fulfilled or rejected.
	
	      A promise can be in one of three states: pending, fulfilled, or rejected.
	
	      Promises that are fulfilled have a fulfillment value and are in the fulfilled
	      state.  Promises that are rejected have a rejection reason and are in the
	      rejected state.  A fulfillment value is never a thenable.
	
	      Promises can also be said to *resolve* a value.  If this value is also a
	      promise, then the original promise's settled state will match the value's
	      settled state.  So a promise that *resolves* a promise that rejects will
	      itself reject, and a promise that *resolves* a promise that fulfills will
	      itself fulfill.
	
	
	      Basic Usage:
	      ------------
	
	      ```js
	      var promise = new Promise(function(resolve, reject) {
	        // on success
	        resolve(value);
	
	        // on failure
	        reject(reason);
	      });
	
	      promise.then(function(value) {
	        // on fulfillment
	      }, function(reason) {
	        // on rejection
	      });
	      ```
	
	      Advanced Usage:
	      ---------------
	
	      Promises shine when abstracting away asynchronous interactions such as
	      `XMLHttpRequest`s.
	
	      ```js
	      function getJSON(url) {
	        return new Promise(function(resolve, reject){
	          var xhr = new XMLHttpRequest();
	
	          xhr.open('GET', url);
	          xhr.onreadystatechange = handler;
	          xhr.responseType = 'json';
	          xhr.setRequestHeader('Accept', 'application/json');
	          xhr.send();
	
	          function handler() {
	            if (this.readyState === this.DONE) {
	              if (this.status === 200) {
	                resolve(this.response);
	              } else {
	                reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	              }
	            }
	          };
	        });
	      }
	
	      getJSON('/posts.json').then(function(json) {
	        // on fulfillment
	      }, function(reason) {
	        // on rejection
	      });
	      ```
	
	      Unlike callbacks, promises are great composable primitives.
	
	      ```js
	      Promise.all([
	        getJSON('/posts'),
	        getJSON('/comments')
	      ]).then(function(values){
	        values[0] // => postsJSON
	        values[1] // => commentsJSON
	
	        return values;
	      });
	      ```
	
	      @class Promise
	      @param {function} resolver
	      Useful for tooling.
	      @constructor
	    */
	    function lib$es6$promise$promise$$Promise(resolver) {
	      this._id = lib$es6$promise$promise$$counter++;
	      this._state = undefined;
	      this._result = undefined;
	      this._subscribers = [];
	
	      if (lib$es6$promise$$internal$$noop !== resolver) {
	        typeof resolver !== 'function' && lib$es6$promise$promise$$needsResolver();
	        this instanceof lib$es6$promise$promise$$Promise ? lib$es6$promise$$internal$$initializePromise(this, resolver) : lib$es6$promise$promise$$needsNew();
	      }
	    }
	
	    lib$es6$promise$promise$$Promise.all = lib$es6$promise$promise$all$$default;
	    lib$es6$promise$promise$$Promise.race = lib$es6$promise$promise$race$$default;
	    lib$es6$promise$promise$$Promise.resolve = lib$es6$promise$promise$resolve$$default;
	    lib$es6$promise$promise$$Promise.reject = lib$es6$promise$promise$reject$$default;
	    lib$es6$promise$promise$$Promise._setScheduler = lib$es6$promise$asap$$setScheduler;
	    lib$es6$promise$promise$$Promise._setAsap = lib$es6$promise$asap$$setAsap;
	    lib$es6$promise$promise$$Promise._asap = lib$es6$promise$asap$$asap;
	
	    lib$es6$promise$promise$$Promise.prototype = {
	      constructor: lib$es6$promise$promise$$Promise,
	
	    /**
	      The primary way of interacting with a promise is through its `then` method,
	      which registers callbacks to receive either a promise's eventual value or the
	      reason why the promise cannot be fulfilled.
	
	      ```js
	      findUser().then(function(user){
	        // user is available
	      }, function(reason){
	        // user is unavailable, and you are given the reason why
	      });
	      ```
	
	      Chaining
	      --------
	
	      The return value of `then` is itself a promise.  This second, 'downstream'
	      promise is resolved with the return value of the first promise's fulfillment
	      or rejection handler, or rejected if the handler throws an exception.
	
	      ```js
	      findUser().then(function (user) {
	        return user.name;
	      }, function (reason) {
	        return 'default name';
	      }).then(function (userName) {
	        // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	        // will be `'default name'`
	      });
	
	      findUser().then(function (user) {
	        throw new Error('Found user, but still unhappy');
	      }, function (reason) {
	        throw new Error('`findUser` rejected and we're unhappy');
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	        // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	      });
	      ```
	      If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	
	      ```js
	      findUser().then(function (user) {
	        throw new PedagogicalException('Upstream error');
	      }).then(function (value) {
	        // never reached
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // The `PedgagocialException` is propagated all the way down to here
	      });
	      ```
	
	      Assimilation
	      ------------
	
	      Sometimes the value you want to propagate to a downstream promise can only be
	      retrieved asynchronously. This can be achieved by returning a promise in the
	      fulfillment or rejection handler. The downstream promise will then be pending
	      until the returned promise is settled. This is called *assimilation*.
	
	      ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // The user's comments are now available
	      });
	      ```
	
	      If the assimliated promise rejects, then the downstream promise will also reject.
	
	      ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // If `findCommentsByAuthor` fulfills, we'll have the value here
	      }, function (reason) {
	        // If `findCommentsByAuthor` rejects, we'll have the reason here
	      });
	      ```
	
	      Simple Example
	      --------------
	
	      Synchronous Example
	
	      ```javascript
	      var result;
	
	      try {
	        result = findResult();
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	
	      Errback Example
	
	      ```js
	      findResult(function(result, err){
	        if (err) {
	          // failure
	        } else {
	          // success
	        }
	      });
	      ```
	
	      Promise Example;
	
	      ```javascript
	      findResult().then(function(result){
	        // success
	      }, function(reason){
	        // failure
	      });
	      ```
	
	      Advanced Example
	      --------------
	
	      Synchronous Example
	
	      ```javascript
	      var author, books;
	
	      try {
	        author = findAuthor();
	        books  = findBooksByAuthor(author);
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	
	      Errback Example
	
	      ```js
	
	      function foundBooks(books) {
	
	      }
	
	      function failure(reason) {
	
	      }
	
	      findAuthor(function(author, err){
	        if (err) {
	          failure(err);
	          // failure
	        } else {
	          try {
	            findBoooksByAuthor(author, function(books, err) {
	              if (err) {
	                failure(err);
	              } else {
	                try {
	                  foundBooks(books);
	                } catch(reason) {
	                  failure(reason);
	                }
	              }
	            });
	          } catch(error) {
	            failure(err);
	          }
	          // success
	        }
	      });
	      ```
	
	      Promise Example;
	
	      ```javascript
	      findAuthor().
	        then(findBooksByAuthor).
	        then(function(books){
	          // found books
	      }).catch(function(reason){
	        // something went wrong
	      });
	      ```
	
	      @method then
	      @param {Function} onFulfilled
	      @param {Function} onRejected
	      Useful for tooling.
	      @return {Promise}
	    */
	      then: lib$es6$promise$then$$default,
	
	    /**
	      `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	      as the catch block of a try/catch statement.
	
	      ```js
	      function findAuthor(){
	        throw new Error('couldn't find that author');
	      }
	
	      // synchronous
	      try {
	        findAuthor();
	      } catch(reason) {
	        // something went wrong
	      }
	
	      // async with promises
	      findAuthor().catch(function(reason){
	        // something went wrong
	      });
	      ```
	
	      @method catch
	      @param {Function} onRejection
	      Useful for tooling.
	      @return {Promise}
	    */
	      'catch': function(onRejection) {
	        return this.then(null, onRejection);
	      }
	    };
	    var lib$es6$promise$enumerator$$default = lib$es6$promise$enumerator$$Enumerator;
	    function lib$es6$promise$enumerator$$Enumerator(Constructor, input) {
	      this._instanceConstructor = Constructor;
	      this.promise = new Constructor(lib$es6$promise$$internal$$noop);
	
	      if (Array.isArray(input)) {
	        this._input     = input;
	        this.length     = input.length;
	        this._remaining = input.length;
	
	        this._result = new Array(this.length);
	
	        if (this.length === 0) {
	          lib$es6$promise$$internal$$fulfill(this.promise, this._result);
	        } else {
	          this.length = this.length || 0;
	          this._enumerate();
	          if (this._remaining === 0) {
	            lib$es6$promise$$internal$$fulfill(this.promise, this._result);
	          }
	        }
	      } else {
	        lib$es6$promise$$internal$$reject(this.promise, this._validationError());
	      }
	    }
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._validationError = function() {
	      return new Error('Array Methods must be provided an Array');
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._enumerate = function() {
	      var length  = this.length;
	      var input   = this._input;
	
	      for (var i = 0; this._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
	        this._eachEntry(input[i], i);
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._eachEntry = function(entry, i) {
	      var c = this._instanceConstructor;
	      var resolve = c.resolve;
	
	      if (resolve === lib$es6$promise$promise$resolve$$default) {
	        var then = lib$es6$promise$$internal$$getThen(entry);
	
	        if (then === lib$es6$promise$then$$default &&
	            entry._state !== lib$es6$promise$$internal$$PENDING) {
	          this._settledAt(entry._state, i, entry._result);
	        } else if (typeof then !== 'function') {
	          this._remaining--;
	          this._result[i] = entry;
	        } else if (c === lib$es6$promise$promise$$default) {
	          var promise = new c(lib$es6$promise$$internal$$noop);
	          lib$es6$promise$$internal$$handleMaybeThenable(promise, entry, then);
	          this._willSettleAt(promise, i);
	        } else {
	          this._willSettleAt(new c(function(resolve) { resolve(entry); }), i);
	        }
	      } else {
	        this._willSettleAt(resolve(entry), i);
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._settledAt = function(state, i, value) {
	      var promise = this.promise;
	
	      if (promise._state === lib$es6$promise$$internal$$PENDING) {
	        this._remaining--;
	
	        if (state === lib$es6$promise$$internal$$REJECTED) {
	          lib$es6$promise$$internal$$reject(promise, value);
	        } else {
	          this._result[i] = value;
	        }
	      }
	
	      if (this._remaining === 0) {
	        lib$es6$promise$$internal$$fulfill(promise, this._result);
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._willSettleAt = function(promise, i) {
	      var enumerator = this;
	
	      lib$es6$promise$$internal$$subscribe(promise, undefined, function(value) {
	        enumerator._settledAt(lib$es6$promise$$internal$$FULFILLED, i, value);
	      }, function(reason) {
	        enumerator._settledAt(lib$es6$promise$$internal$$REJECTED, i, reason);
	      });
	    };
	    function lib$es6$promise$polyfill$$polyfill() {
	      var local;
	
	      if (typeof global !== 'undefined') {
	          local = global;
	      } else if (typeof self !== 'undefined') {
	          local = self;
	      } else {
	          try {
	              local = Function('return this')();
	          } catch (e) {
	              throw new Error('polyfill failed because global object is unavailable in this environment');
	          }
	      }
	
	      var P = local.Promise;
	
	      if (P && Object.prototype.toString.call(P.resolve()) === '[object Promise]' && !P.cast) {
	        return;
	      }
	
	      local.Promise = lib$es6$promise$promise$$default;
	    }
	    var lib$es6$promise$polyfill$$default = lib$es6$promise$polyfill$$polyfill;
	
	    var lib$es6$promise$umd$$ES6Promise = {
	      'Promise': lib$es6$promise$promise$$default,
	      'polyfill': lib$es6$promise$polyfill$$default
	    };
	
	    /* global define:true module:true window: true */
	    if ("function" === 'function' && __webpack_require__(442)['amd']) {
	      !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return lib$es6$promise$umd$$ES6Promise; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined' && module['exports']) {
	      module['exports'] = lib$es6$promise$umd$$ES6Promise;
	    } else if (typeof this !== 'undefined') {
	      this['ES6Promise'] = lib$es6$promise$umd$$ES6Promise;
	    }
	
	    lib$es6$promise$polyfill$$default();
	}).call(this);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(258), (function() { return this; }()), __webpack_require__(30)(module)))

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * @license MIT
	 * @fileOverview Favico animations
	 * @author Miroslav Magda, http://blog.ejci.net
	 * @version 0.3.10
	 */
	
	/**
	 * Create new favico instance
	 * @param {Object} Options
	 * @return {Object} Favico object
	 * @example
	 * var favico = new Favico({
	 *    bgColor : '#d00',
	 *    textColor : '#fff',
	 *    fontFamily : 'sans-serif',
	 *    fontStyle : 'bold',
	 *    position : 'down',
	 *    type : 'circle',
	 *    animation : 'slide',
	 *    dataUrl: function(url){},
	 *    win: top
	 * });
	 */
	(function () {
	
		var Favico = (function (opt) {
			'use strict';
			opt = (opt) ? opt : {};
			var _def = {
				bgColor: '#d00',
				textColor: '#fff',
				fontFamily: 'sans-serif', //Arial,Verdana,Times New Roman,serif,sans-serif,...
				fontStyle: 'bold', //normal,italic,oblique,bold,bolder,lighter,100,200,300,400,500,600,700,800,900
				type: 'circle',
				position: 'down', // down, up, left, leftup (upleft)
				animation: 'slide',
				elementId: false,
				dataUrl: false,
				win: window
			};
			var _opt, _orig, _h, _w, _canvas, _context, _img, _ready, _lastBadge, _running, _readyCb, _stop, _browser, _animTimeout, _drawTimeout, _doc;
	
			_browser = {};
			_browser.ff = typeof InstallTrigger != 'undefined';
			_browser.chrome = !!window.chrome;
			_browser.opera = !!window.opera || navigator.userAgent.indexOf('Opera') >= 0;
			_browser.ie = /*@cc_on!@*/false;
			_browser.safari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
			_browser.supported = (_browser.chrome || _browser.ff || _browser.opera);
	
			var _queue = [];
			_readyCb = function () {
			};
			_ready = _stop = false;
			/**
			 * Initialize favico
			 */
			var init = function () {
				//merge initial options
				_opt = merge(_def, opt);
				_opt.bgColor = hexToRgb(_opt.bgColor);
				_opt.textColor = hexToRgb(_opt.textColor);
				_opt.position = _opt.position.toLowerCase();
				_opt.animation = (animation.types['' + _opt.animation]) ? _opt.animation : _def.animation;
	
				_doc = _opt.win.document;
	
				var isUp = _opt.position.indexOf('up') > -1;
				var isLeft = _opt.position.indexOf('left') > -1;
	
				//transform animation
				if (isUp || isLeft) {
					for (var i = 0; i < animation.types['' + _opt.animation].length; i++) {
						var step = animation.types['' + _opt.animation][i];
	
						if (isUp) {
							if (step.y < 0.6) {
								step.y = step.y - 0.4;
							} else {
								step.y = step.y - 2 * step.y + (1 - step.w);
							}
						}
	
						if (isLeft) {
							if (step.x < 0.6) {
								step.x = step.x - 0.4;
							} else {
								step.x = step.x - 2 * step.x + (1 - step.h);
							}
						}
	
						animation.types['' + _opt.animation][i] = step;
					}
				}
				_opt.type = (type['' + _opt.type]) ? _opt.type : _def.type;
	
				_orig = link.getIcon();
				//create temp canvas
				_canvas = document.createElement('canvas');
				//create temp image
				_img = document.createElement('img');
				if (_orig.hasAttribute('href')) {
					_img.setAttribute('crossOrigin', 'anonymous');
					//get width/height
					_img.onload = function () {
						_h = (_img.height > 0) ? _img.height : 32;
						_w = (_img.width > 0) ? _img.width : 32;
						_canvas.height = _h;
						_canvas.width = _w;
						_context = _canvas.getContext('2d');
						icon.ready();
					};
					_img.setAttribute('src', _orig.getAttribute('href'));
				} else {
					_img.onload = function () {
						_h = 32;
						_w = 32;
						_img.height = _h;
						_img.width = _w;
						_canvas.height = _h;
						_canvas.width = _w;
						_context = _canvas.getContext('2d');
						icon.ready();
					};
					_img.setAttribute('src', '');
				}
	
			};
			/**
			 * Icon namespace
			 */
			var icon = {};
			/**
			 * Icon is ready (reset icon) and start animation (if ther is any)
			 */
			icon.ready = function () {
				_ready = true;
				icon.reset();
				_readyCb();
			};
			/**
			 * Reset icon to default state
			 */
			icon.reset = function () {
				//reset
				if (!_ready) {
					return;
				}
				_queue = [];
				_lastBadge = false;
				_running = false;
				_context.clearRect(0, 0, _w, _h);
				_context.drawImage(_img, 0, 0, _w, _h);
				//_stop=true;
				link.setIcon(_canvas);
				//webcam('stop');
				//video('stop');
				window.clearTimeout(_animTimeout);
				window.clearTimeout(_drawTimeout);
			};
			/**
			 * Start animation
			 */
			icon.start = function () {
				if (!_ready || _running) {
					return;
				}
				var finished = function () {
					_lastBadge = _queue[0];
					_running = false;
					if (_queue.length > 0) {
						_queue.shift();
						icon.start();
					} else {
	
					}
				};
				if (_queue.length > 0) {
					_running = true;
					var run = function () {
						// apply options for this animation
						['type', 'animation', 'bgColor', 'textColor', 'fontFamily', 'fontStyle'].forEach(function (a) {
							if (a in _queue[0].options) {
								_opt[a] = _queue[0].options[a];
							}
						});
						animation.run(_queue[0].options, function () {
							finished();
						}, false);
					};
					if (_lastBadge) {
						animation.run(_lastBadge.options, function () {
							run();
						}, true);
					} else {
						run();
					}
				}
			};
	
			/**
			 * Badge types
			 */
			var type = {};
			var options = function (opt) {
				opt.n = ((typeof opt.n) === 'number') ? Math.abs(opt.n | 0) : opt.n;
				opt.x = _w * opt.x;
				opt.y = _h * opt.y;
				opt.w = _w * opt.w;
				opt.h = _h * opt.h;
				opt.len = ("" + opt.n).length;
				return opt;
			};
			/**
			 * Generate circle
			 * @param {Object} opt Badge options
			 */
			type.circle = function (opt) {
				opt = options(opt);
				var more = false;
				if (opt.len === 2) {
					opt.x = opt.x - opt.w * 0.4;
					opt.w = opt.w * 1.4;
					more = true;
				} else if (opt.len >= 3) {
					opt.x = opt.x - opt.w * 0.65;
					opt.w = opt.w * 1.65;
					more = true;
				}
				_context.clearRect(0, 0, _w, _h);
				_context.drawImage(_img, 0, 0, _w, _h);
				_context.beginPath();
				_context.font = _opt.fontStyle + " " + Math.floor(opt.h * (opt.n > 99 ? 0.85 : 1)) + "px " + _opt.fontFamily;
				_context.textAlign = 'center';
				if (more) {
					_context.moveTo(opt.x + opt.w / 2, opt.y);
					_context.lineTo(opt.x + opt.w - opt.h / 2, opt.y);
					_context.quadraticCurveTo(opt.x + opt.w, opt.y, opt.x + opt.w, opt.y + opt.h / 2);
					_context.lineTo(opt.x + opt.w, opt.y + opt.h - opt.h / 2);
					_context.quadraticCurveTo(opt.x + opt.w, opt.y + opt.h, opt.x + opt.w - opt.h / 2, opt.y + opt.h);
					_context.lineTo(opt.x + opt.h / 2, opt.y + opt.h);
					_context.quadraticCurveTo(opt.x, opt.y + opt.h, opt.x, opt.y + opt.h - opt.h / 2);
					_context.lineTo(opt.x, opt.y + opt.h / 2);
					_context.quadraticCurveTo(opt.x, opt.y, opt.x + opt.h / 2, opt.y);
				} else {
					_context.arc(opt.x + opt.w / 2, opt.y + opt.h / 2, opt.h / 2, 0, 2 * Math.PI);
				}
				_context.fillStyle = 'rgba(' + _opt.bgColor.r + ',' + _opt.bgColor.g + ',' + _opt.bgColor.b + ',' + opt.o + ')';
				_context.fill();
				_context.closePath();
				_context.beginPath();
				_context.stroke();
				_context.fillStyle = 'rgba(' + _opt.textColor.r + ',' + _opt.textColor.g + ',' + _opt.textColor.b + ',' + opt.o + ')';
				//_context.fillText((more) ? '9+' : opt.n, Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.15));
				if ((typeof opt.n) === 'number' && opt.n > 999) {
					_context.fillText(((opt.n > 9999) ? 9 : Math.floor(opt.n / 1000)) + 'k+', Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.2));
				} else {
					_context.fillText(opt.n, Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.15));
				}
				_context.closePath();
			};
			/**
			 * Generate rectangle
			 * @param {Object} opt Badge options
			 */
			type.rectangle = function (opt) {
				opt = options(opt);
				var more = false;
				if (opt.len === 2) {
					opt.x = opt.x - opt.w * 0.4;
					opt.w = opt.w * 1.4;
					more = true;
				} else if (opt.len >= 3) {
					opt.x = opt.x - opt.w * 0.65;
					opt.w = opt.w * 1.65;
					more = true;
				}
				_context.clearRect(0, 0, _w, _h);
				_context.drawImage(_img, 0, 0, _w, _h);
				_context.beginPath();
				_context.font = _opt.fontStyle + " " + Math.floor(opt.h * (opt.n > 99 ? 0.9 : 1)) + "px " + _opt.fontFamily;
				_context.textAlign = 'center';
				_context.fillStyle = 'rgba(' + _opt.bgColor.r + ',' + _opt.bgColor.g + ',' + _opt.bgColor.b + ',' + opt.o + ')';
				_context.fillRect(opt.x, opt.y, opt.w, opt.h);
				_context.fillStyle = 'rgba(' + _opt.textColor.r + ',' + _opt.textColor.g + ',' + _opt.textColor.b + ',' + opt.o + ')';
				//_context.fillText((more) ? '9+' : opt.n, Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.15));
				if ((typeof opt.n) === 'number' && opt.n > 999) {
					_context.fillText(((opt.n > 9999) ? 9 : Math.floor(opt.n / 1000)) + 'k+', Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.2));
				} else {
					_context.fillText(opt.n, Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * 0.15));
				}
				_context.closePath();
			};
	
			/**
			 * Set badge
			 */
			var badge = function (number, opts) {
				opts = ((typeof opts) === 'string' ? {
					animation: opts
				} : opts) || {};
				_readyCb = function () {
					try {
						if (typeof (number) === 'number' ? (number > 0) : (number !== '')) {
							var q = {
								type: 'badge',
								options: {
									n: number
								}
							};
							if ('animation' in opts && animation.types['' + opts.animation]) {
								q.options.animation = '' + opts.animation;
							}
							if ('type' in opts && type['' + opts.type]) {
								q.options.type = '' + opts.type;
							}
							['bgColor', 'textColor'].forEach(function (o) {
								if (o in opts) {
									q.options[o] = hexToRgb(opts[o]);
								}
							});
							['fontStyle', 'fontFamily'].forEach(function (o) {
								if (o in opts) {
									q.options[o] = opts[o];
								}
							});
							_queue.push(q);
							if (_queue.length > 100) {
								throw new Error('Too many badges requests in queue.');
							}
							icon.start();
						} else {
							icon.reset();
						}
					} catch (e) {
						throw new Error('Error setting badge. Message: ' + e.message);
					}
				};
				if (_ready) {
					_readyCb();
				}
			};
	
			/**
			 * Set image as icon
			 */
			var image = function (imageElement) {
				_readyCb = function () {
					try {
						var w = imageElement.width;
						var h = imageElement.height;
						var newImg = document.createElement('img');
						var ratio = (w / _w < h / _h) ? (w / _w) : (h / _h);
						newImg.setAttribute('crossOrigin', 'anonymous');
						newImg.onload=function(){
							_context.clearRect(0, 0, _w, _h);
							_context.drawImage(newImg, 0, 0, _w, _h);
							link.setIcon(_canvas);
						};
						newImg.setAttribute('src', imageElement.getAttribute('src'));
						newImg.height = (h / ratio);
						newImg.width = (w / ratio);
					} catch (e) {
						throw new Error('Error setting image. Message: ' + e.message);
					}
				};
				if (_ready) {
					_readyCb();
				}
			};
			/**
			 * Set video as icon
			 */
			var video = function (videoElement) {
				_readyCb = function () {
					try {
						if (videoElement === 'stop') {
							_stop = true;
							icon.reset();
							_stop = false;
							return;
						}
						//var w = videoElement.width;
						//var h = videoElement.height;
						//var ratio = (w / _w < h / _h) ? (w / _w) : (h / _h);
						videoElement.addEventListener('play', function () {
							drawVideo(this);
						}, false);
	
					} catch (e) {
						throw new Error('Error setting video. Message: ' + e.message);
					}
				};
				if (_ready) {
					_readyCb();
				}
			};
			/**
			 * Set video as icon
			 */
			var webcam = function (action) {
				//UR
				if (!window.URL || !window.URL.createObjectURL) {
					window.URL = window.URL || {};
					window.URL.createObjectURL = function (obj) {
						return obj;
					};
				}
				if (_browser.supported) {
					var newVideo = false;
					navigator.getUserMedia = navigator.getUserMedia || navigator.oGetUserMedia || navigator.msGetUserMedia || navigator.mozGetUserMedia || navigator.webkitGetUserMedia;
					_readyCb = function () {
						try {
							if (action === 'stop') {
								_stop = true;
								icon.reset();
								_stop = false;
								return;
							}
							newVideo = document.createElement('video');
							newVideo.width = _w;
							newVideo.height = _h;
							navigator.getUserMedia({
								video: true,
								audio: false
							}, function (stream) {
								newVideo.src = URL.createObjectURL(stream);
								newVideo.play();
								drawVideo(newVideo);
							}, function () {
							});
						} catch (e) {
							throw new Error('Error setting webcam. Message: ' + e.message);
						}
					};
					if (_ready) {
						_readyCb();
					}
				}
	
			};
	
			/**
			 * Draw video to context and repeat :)
			 */
			function drawVideo(video) {
				if (video.paused || video.ended || _stop) {
					return false;
				}
				//nasty hack for FF webcam (Thanks to Julian Ćwirko, kontakt@redsunmedia.pl)
				try {
					_context.clearRect(0, 0, _w, _h);
					_context.drawImage(video, 0, 0, _w, _h);
				} catch (e) {
	
				}
				_drawTimeout = setTimeout(function () {
					drawVideo(video);
				}, animation.duration);
				link.setIcon(_canvas);
			}
	
			var link = {};
			/**
			 * Get icon from HEAD tag or create a new <link> element
			 */
			link.getIcon = function () {
				var elm = false;
				//get link element
				var getLink = function () {
					var link = _doc.getElementsByTagName('head')[0].getElementsByTagName('link');
					for (var l = link.length, i = (l - 1); i >= 0; i--) {
						if ((/(^|\s)icon(\s|$)/i).test(link[i].getAttribute('rel'))) {
							return link[i];
						}
					}
					return false;
				};
				if (_opt.element) {
					elm = _opt.element;
				} else if (_opt.elementId) {
					//if img element identified by elementId
					elm = _doc.getElementById(_opt.elementId);
					elm.setAttribute('href', elm.getAttribute('src'));
				} else {
					//if link element
					elm = getLink();
					if (elm === false) {
						elm = _doc.createElement('link');
						elm.setAttribute('rel', 'icon');
						_doc.getElementsByTagName('head')[0].appendChild(elm);
					}
				}
				elm.setAttribute('type', 'image/png');
				return elm;
			};
			link.setIcon = function (canvas) {
				var url = canvas.toDataURL('image/png');
				if (_opt.dataUrl) {
					//if using custom exporter
					_opt.dataUrl(url);
				}
				if (_opt.element) {
					_opt.element.setAttribute('href', url);
					_opt.element.setAttribute('src', url);
				} else if (_opt.elementId) {
					//if is attached to element (image)
					var elm = _doc.getElementById(_opt.elementId);
					elm.setAttribute('href', url);
					elm.setAttribute('src', url);
				} else {
					//if is attached to fav icon
					if (_browser.ff || _browser.opera) {
						//for FF we need to "recreate" element, atach to dom and remove old <link>
						//var originalType = _orig.getAttribute('rel');
						var old = _orig;
						_orig = _doc.createElement('link');
						//_orig.setAttribute('rel', originalType);
						if (_browser.opera) {
							_orig.setAttribute('rel', 'icon');
						}
						_orig.setAttribute('rel', 'icon');
						_orig.setAttribute('type', 'image/png');
						_doc.getElementsByTagName('head')[0].appendChild(_orig);
						_orig.setAttribute('href', url);
						if (old.parentNode) {
							old.parentNode.removeChild(old);
						}
					} else {
						_orig.setAttribute('href', url);
					}
				}
			};
	
			//http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb#answer-5624139
			//HEX to RGB convertor
			function hexToRgb(hex) {
				var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
				hex = hex.replace(shorthandRegex, function (m, r, g, b) {
					return r + r + g + g + b + b;
				});
				var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
				return result ? {
					r: parseInt(result[1], 16),
					g: parseInt(result[2], 16),
					b: parseInt(result[3], 16)
				} : false;
			}
	
			/**
			 * Merge options
			 */
			function merge(def, opt) {
				var mergedOpt = {};
				var attrname;
				for (attrname in def) {
					mergedOpt[attrname] = def[attrname];
				}
				for (attrname in opt) {
					mergedOpt[attrname] = opt[attrname];
				}
				return mergedOpt;
			}
	
			/**
			 * Cross-browser page visibility shim
			 * http://stackoverflow.com/questions/12536562/detect-whether-a-window-is-visible
			 */
			function isPageHidden() {
				return _doc.hidden || _doc.msHidden || _doc.webkitHidden || _doc.mozHidden;
			}
	
			/**
			 * @namespace animation
			 */
			var animation = {};
			/**
			 * Animation "frame" duration
			 */
			animation.duration = 40;
			/**
			 * Animation types (none,fade,pop,slide)
			 */
			animation.types = {};
			animation.types.fade = [{
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 0.0
			}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.1
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.2
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.3
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.4
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.5
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.6
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.7
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.8
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 0.9
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 1.0
				}];
			animation.types.none = [{
				x: 0.4,
				y: 0.4,
				w: 0.6,
				h: 0.6,
				o: 1
			}];
			animation.types.pop = [{
				x: 1,
				y: 1,
				w: 0,
				h: 0,
				o: 1
			}, {
					x: 0.9,
					y: 0.9,
					w: 0.1,
					h: 0.1,
					o: 1
				}, {
					x: 0.8,
					y: 0.8,
					w: 0.2,
					h: 0.2,
					o: 1
				}, {
					x: 0.7,
					y: 0.7,
					w: 0.3,
					h: 0.3,
					o: 1
				}, {
					x: 0.6,
					y: 0.6,
					w: 0.4,
					h: 0.4,
					o: 1
				}, {
					x: 0.5,
					y: 0.5,
					w: 0.5,
					h: 0.5,
					o: 1
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 1
				}];
			animation.types.popFade = [{
				x: 0.75,
				y: 0.75,
				w: 0,
				h: 0,
				o: 0
			}, {
					x: 0.65,
					y: 0.65,
					w: 0.1,
					h: 0.1,
					o: 0.2
				}, {
					x: 0.6,
					y: 0.6,
					w: 0.2,
					h: 0.2,
					o: 0.4
				}, {
					x: 0.55,
					y: 0.55,
					w: 0.3,
					h: 0.3,
					o: 0.6
				}, {
					x: 0.50,
					y: 0.50,
					w: 0.4,
					h: 0.4,
					o: 0.8
				}, {
					x: 0.45,
					y: 0.45,
					w: 0.5,
					h: 0.5,
					o: 0.9
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 1
				}];
			animation.types.slide = [{
				x: 0.4,
				y: 1,
				w: 0.6,
				h: 0.6,
				o: 1
			}, {
					x: 0.4,
					y: 0.9,
					w: 0.6,
					h: 0.6,
					o: 1
				}, {
					x: 0.4,
					y: 0.9,
					w: 0.6,
					h: 0.6,
					o: 1
				}, {
					x: 0.4,
					y: 0.8,
					w: 0.6,
					h: 0.6,
					o: 1
				}, {
					x: 0.4,
					y: 0.7,
					w: 0.6,
					h: 0.6,
					o: 1
				}, {
					x: 0.4,
					y: 0.6,
					w: 0.6,
					h: 0.6,
					o: 1
				}, {
					x: 0.4,
					y: 0.5,
					w: 0.6,
					h: 0.6,
					o: 1
				}, {
					x: 0.4,
					y: 0.4,
					w: 0.6,
					h: 0.6,
					o: 1
				}];
			/**
			 * Run animation
			 * @param {Object} opt Animation options
			 * @param {Object} cb Callabak after all steps are done
			 * @param {Object} revert Reverse order? true|false
			 * @param {Object} step Optional step number (frame bumber)
			 */
			animation.run = function (opt, cb, revert, step) {
				var animationType = animation.types[isPageHidden() ? 'none' : _opt.animation];
				if (revert === true) {
					step = (typeof step !== 'undefined') ? step : animationType.length - 1;
				} else {
					step = (typeof step !== 'undefined') ? step : 0;
				}
				cb = (cb) ? cb : function () {
				};
				if ((step < animationType.length) && (step >= 0)) {
					type[_opt.type](merge(opt, animationType[step]));
					_animTimeout = setTimeout(function () {
						if (revert) {
							step = step - 1;
						} else {
							step = step + 1;
						}
						animation.run(opt, cb, revert, step);
					}, animation.duration);
	
					link.setIcon(_canvas);
				} else {
					cb();
					return;
				}
			};
			//auto init
			init();
			return {
				badge: badge,
				video: video,
				image: image,
				webcam: webcam,
				reset: icon.reset,
				browser: {
					supported: _browser.supported
				}
			};
		});
	
		// AMD / RequireJS
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return Favico;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		// CommonJS
		else if (typeof module !== 'undefined' && module.exports) {
			module.exports = Favico;
		}
		// included directly via <script> tag
		else {
			this.Favico = Favico;
		}
	
	})();


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(26),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(51);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @returns {Object} Returns the new hash object.
	 */
	function Hash() {}
	
	// Avoid inheriting from `Object.prototype` when possible.
	Hash.prototype = nativeCreate ? nativeCreate(null) : objectProto;
	
	module.exports = Hash;


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(26),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(11);
	
	/** Built-in value references. */
	var Reflect = root.Reflect;
	
	module.exports = Reflect;


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(26),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 361 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 362 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(250),
	    arrayIncludes = __webpack_require__(251),
	    arrayIncludesWith = __webpack_require__(252),
	    arrayMap = __webpack_require__(22),
	    baseUnary = __webpack_require__(234),
	    cacheHas = __webpack_require__(254);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(64);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(383);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 366 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(393);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(82),
	    equalArrays = __webpack_require__(103),
	    equalByTag = __webpack_require__(384),
	    equalObjects = __webpack_require__(385),
	    getTag = __webpack_require__(287),
	    isArray = __webpack_require__(10),
	    isHostObject = __webpack_require__(61),
	    isTypedArray = __webpack_require__(291);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(82),
	    baseIsEqual = __webpack_require__(100);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	var Reflect = __webpack_require__(359),
	    iteratorToArray = __webpack_require__(395);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var enumerate = Reflect ? Reflect.enumerate : undefined,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  object = object == null ? object : Object(object);
	
	  var result = [];
	  for (var key in object) {
	    result.push(key);
	  }
	  return result;
	}
	
	// Fallback for IE < 9 with es6-shim.
	if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
	  baseKeysIn = function(object) {
	    return iteratorToArray(enumerate(object));
	  };
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(369),
	    getMatchData = __webpack_require__(387),
	    matchesStrictComparable = __webpack_require__(107);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(100),
	    get = __webpack_require__(407),
	    hasIn = __webpack_require__(408),
	    isKey = __webpack_require__(50),
	    isStrictComparable = __webpack_require__(106),
	    matchesStrictComparable = __webpack_require__(107),
	    toKey = __webpack_require__(35);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(253);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return arrayReduce(props, function(result, key) {
	    if (key in object) {
	      result[key] = object[key];
	    }
	    return result;
	  }, {});
	}
	
	module.exports = basePick;


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(98);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 375 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeRandom = Math.random;
	
	/**
	 * The base implementation of `_.random` without support for returning
	 * floating-point numbers.
	 *
	 * @private
	 * @param {number} lower The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the random number.
	 */
	function baseRandom(lower, upper) {
	  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	}
	
	module.exports = baseRandom;


/***/ },
/* 376 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(22);
	
	/**
	 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	 * of key-value pairs for `object` corresponding to the property names of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the new array of key-value pairs.
	 */
	function baseToPairs(object, props) {
	  return arrayMap(props, function(key) {
	    return [key, object[key]];
	  });
	}
	
	module.exports = baseToPairs;


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(83),
	    isSymbol = __webpack_require__(44);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(22);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(27);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the set cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var map = this.__data__;
	  if (isKeyable(value)) {
	    var data = map.__data__,
	        hash = typeof value == 'string' ? data.string : data.hash;
	
	    hash[value] = HASH_UNDEFINED;
	  }
	  else {
	    map.set(value, HASH_UNDEFINED);
	  }
	}
	
	module.exports = cachePush;


/***/ },
/* 381 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}
	
	module.exports = checkGlobal;


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(32);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 383 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(83),
	    Uint8Array = __webpack_require__(280),
	    equalArrays = __webpack_require__(103),
	    mapToArray = __webpack_require__(288),
	    setToArray = __webpack_require__(289);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and
	      // booleans to `1` or `0` treating invalid dates coerced to `NaN` as
	      // not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object) ? other != +other : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/6.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	      stack.set(object, other);
	
	      // Recursively compare objects (susceptible to call stack limits).
	      return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(99),
	    keys = __webpack_require__(41);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : baseHas(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(101);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a
	 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	 * Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(106),
	    toPairs = __webpack_require__(415);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = toPairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(60),
	    getPrototype = __webpack_require__(56),
	    getSymbols = __webpack_require__(255);
	
	/** Built-in value references. */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbol properties
	 * of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !getOwnPropertySymbols ? getSymbols : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(102),
	    isArguments = __webpack_require__(65),
	    isArray = __webpack_require__(10),
	    isIndex = __webpack_require__(49),
	    isKey = __webpack_require__(50),
	    isLength = __webpack_require__(52),
	    isString = __webpack_require__(110),
	    toKey = __webpack_require__(35);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isString(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	var hashHas = __webpack_require__(104);
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(hash, key) {
	  return hashHas(hash, key) && delete hash[key];
	}
	
	module.exports = hashDelete;


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(51);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @param {Object} hash The hash to query.
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(hash, key) {
	  if (nativeCreate) {
	    var result = hash[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(hash, key) ? hash[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(51);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 */
	function hashSet(hash, key, value) {
	  hash[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	}
	
	module.exports = hashSet;


/***/ },
/* 393 */
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(65),
	    isArray = __webpack_require__(10),
	    isArrayLikeObject = __webpack_require__(75);
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArrayLikeObject(value) && (isArray(value) || isArguments(value));
	}
	
	module.exports = isFlattenable;


/***/ },
/* 395 */
/***/ function(module, exports) {

	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function iteratorToArray(iterator) {
	  var data,
	      result = [];
	
	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}
	
	module.exports = iteratorToArray;


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(357),
	    Map = __webpack_require__(25);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': Map ? new Map : [],
	    'string': new Hash
	  };
	}
	
	module.exports = mapClear;


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(25),
	    assocDelete = __webpack_require__(94),
	    hashDelete = __webpack_require__(390),
	    isKeyable = __webpack_require__(27);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapDelete(key) {
	  var data = this.__data__;
	  if (isKeyable(key)) {
	    return hashDelete(typeof key == 'string' ? data.string : data.hash, key);
	  }
	  return Map ? data.map['delete'](key) : assocDelete(data.map, key);
	}
	
	module.exports = mapDelete;


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(25),
	    assocGet = __webpack_require__(95),
	    hashGet = __webpack_require__(391),
	    isKeyable = __webpack_require__(27);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapGet(key) {
	  var data = this.__data__;
	  if (isKeyable(key)) {
	    return hashGet(typeof key == 'string' ? data.string : data.hash, key);
	  }
	  return Map ? data.map.get(key) : assocGet(data.map, key);
	}
	
	module.exports = mapGet;


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(25),
	    assocHas = __webpack_require__(96),
	    hashHas = __webpack_require__(104),
	    isKeyable = __webpack_require__(27);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapHas(key) {
	  var data = this.__data__;
	  if (isKeyable(key)) {
	    return hashHas(typeof key == 'string' ? data.string : data.hash, key);
	  }
	  return Map ? data.map.has(key) : assocHas(data.map, key);
	}
	
	module.exports = mapHas;


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(25),
	    assocSet = __webpack_require__(97),
	    hashSet = __webpack_require__(392),
	    isKeyable = __webpack_require__(27);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapSet(key, value) {
	  var data = this.__data__;
	  if (isKeyable(key)) {
	    hashSet(typeof key == 'string' ? data.string : data.hash, key, value);
	  } else if (Map) {
	    data.map.set(key, value);
	  } else {
	    assocSet(data.map, key, value);
	  }
	  return this;
	}
	
	module.exports = mapSet;


/***/ },
/* 401 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = { 'array': [], 'map': null };
	}
	
	module.exports = stackClear;


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	var assocDelete = __webpack_require__(94);
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      array = data.array;
	
	  return array ? assocDelete(array, key) : data.map['delete'](key);
	}
	
	module.exports = stackDelete;


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	var assocGet = __webpack_require__(95);
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  var data = this.__data__,
	      array = data.array;
	
	  return array ? assocGet(array, key) : data.map.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	var assocHas = __webpack_require__(96);
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  var data = this.__data__,
	      array = data.array;
	
	  return array ? assocHas(array, key) : data.map.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(63),
	    assocSet = __webpack_require__(97);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__,
	      array = data.array;
	
	  if (array) {
	    if (array.length < (LARGE_ARRAY_SIZE - 1)) {
	      assocSet(array, key, value);
	    } else {
	      data.array = null;
	      data.map = new MapCache(array);
	    }
	  }
	  var map = data.map;
	  if (map) {
	    map.set(key, value);
	  }
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(233),
	    baseEach = __webpack_require__(64),
	    baseIteratee = __webpack_require__(37),
	    isArray = __webpack_require__(10);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _([1, 2]).forEach(function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  return (typeof iteratee == 'function' && isArray(collection))
	    ? arrayEach(collection, iteratee)
	    : baseEach(collection, baseIteratee(iteratee));
	}
	
	module.exports = forEach;


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(98);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is used in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(366),
	    hasPath = __webpack_require__(389);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(57),
	    isHostObject = __webpack_require__(61),
	    isObject = __webpack_require__(18),
	    toSource = __webpack_require__(108);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = isNative;


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeysIn = __webpack_require__(370),
	    indexKeys = __webpack_require__(105),
	    isIndex = __webpack_require__(49),
	    isPrototype = __webpack_require__(85);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  var index = -1,
	      isProto = isPrototype(object),
	      props = baseKeysIn(object),
	      propsLength = props.length,
	      indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 4.11.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash -d -o ./foo/lodash.js`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.11.2';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256,
	      FLIP_FLAG = 512;
	
	  /** Used to compose bitmasks for comparison styles. */
	  var UNORDERED_COMPARE_FLAG = 1,
	      PARTIAL_COMPARE_FLAG = 2;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match non-compound words composed of alphanumeric characters. */
	  var reBasicWord = /[a-zA-Z0-9]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0x/i;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	      rsComboSymbolsRange = '\\u20d0-\\u20f0',
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reComplexWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	    rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	    rsUpper + '+' + rsOptUpperContr,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasComplexWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'Reflect', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError',
	    'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `exports`. */
	  var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
	    ? exports
	    : undefined;
	
	  /** Detect free variable `module`. */
	  var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
	    ? module
	    : undefined;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = (freeModule && freeModule.exports === freeExports)
	    ? freeExports
	    : undefined;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);
	
	  /** Detect free variable `self`. */
	  var freeSelf = checkGlobal(objectTypes[typeof self] && self);
	
	  /** Detect free variable `window`. */
	  var freeWindow = checkGlobal(objectTypes[typeof window] && window);
	
	  /** Detect `this` as the global object. */
	  var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal ||
	    ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
	      freeSelf || thisGlobal || Function('return this')();
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `Map#set` because it doesn't return the map instance in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    var length = args.length;
	    switch (length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * Creates a new array concatenating `array` with `other`.
	   *
	   * @private
	   * @param {Array} array The first array to concatenate.
	   * @param {Array} other The second array to concatenate.
	   * @returns {Array} Returns the new concatenated array.
	   */
	  function arrayConcat(array, other) {
	    var index = -1,
	        length = array.length,
	        othIndex = -1,
	        othLength = other.length,
	        result = Array(length + othLength);
	
	    while (++index < length) {
	      result[index] = array[index];
	    }
	    while (++othIndex < othLength) {
	      result[index++] = other[othIndex];
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    return !!array.length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * The base implementation of methods like `_.find` and `_.findKey`, without
	   * support for iteratee shorthands, which iterates over `collection` using
	   * `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @param {boolean} [retKey] Specify returning the key of the found element
	   *  instead of the element itself.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFind(collection, predicate, eachFunc, retKey) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = retKey ? key : value;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array ? array.length : 0;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the new array of key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing wrapper metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Checks if `value` is a global object.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	   */
	  function checkGlobal(value) {
	    return (value && value.Object === Object) ? value : null;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        result++;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is a host object in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	   */
	  function isHostObject(value) {
	    // Many host objects are `Object` objects that can coerce to strings
	    // despite having improperly defined `toString` methods.
	    var result = false;
	    if (value != null && typeof value.toString != 'function') {
	      try {
	        result = !!(value + '');
	      } catch (e) {}
	    }
	    return result;
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to an array.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    if (!(string && reHasComplexSymbol.test(string))) {
	      return string.length;
	    }
	    var result = reComplexSymbol.lastIndex = 0;
	    while (reComplexSymbol.test(string)) {
	      result++;
	    }
	    return result;
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return string.match(reComplexSymbol);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Use `context` to mock `Date#getTime` use in `_.now`.
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    context = context ? _.defaults({}, context, _.pick(root, contextProps)) : root;
	
	    /** Built-in constructor references. */
	    var Date = context.Date,
	        Error = context.Error,
	        Math = context.Math,
	        RegExp = context.RegExp,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = context.Array.prototype,
	        objectProto = context.Object.prototype,
	        stringProto = context.String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = context.Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objectToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Reflect = context.Reflect,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        clearTimeout = context.clearTimeout,
	        enumerate = Reflect ? Reflect.enumerate : undefined,
	        getOwnPropertySymbols = Object.getOwnPropertySymbols,
	        iteratorSymbol = typeof (iteratorSymbol = Symbol && Symbol.iterator) == 'symbol' ? iteratorSymbol : undefined,
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetPrototype = Object.getPrototypeOf,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = Object.keys,
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReplace = stringProto.replace,
	        nativeReverse = arrayProto.reverse,
	        nativeSplit = stringProto.split;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	    var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array of at least `200` elements
	     * and any iteratees accept only one argument. The heuristic for whether a
	     * section qualifies for shortcut fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `deburr`, `divide`, `each`,
	     * `eachRight`, `endsWith`, `eq`, `escape`, `escapeRegExp`, `every`, `find`,
	     * `findIndex`, `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `first`,
	     * `floor`, `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`,
	     * `forOwnRight`, `get`, `gt`, `gte`, `has`, `hasIn`, `head`, `identity`,
	     * `includes`, `indexOf`, `inRange`, `invoke`, `isArguments`, `isArray`,
	     * `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`, `isBoolean`, `isBuffer`,
	     * `isDate`, `isElement`, `isEmpty`, `isEqual`, `isEqualWith`, `isError`,
	     * `isFinite`, `isFunction`, `isInteger`, `isLength`, `isMap`, `isMatch`,
	     * `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`, `isNumber`,
	     * `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`, `isSafeInteger`,
	     * `isSet`, `isString`, `isUndefined`, `isTypedArray`, `isWeakMap`, `isWeakSet`,
	     * `join`, `kebabCase`, `last`, `lastIndexOf`, `lowerCase`, `lowerFirst`,
	     * `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`, `min`, `minBy`, `multiply`,
	     * `noConflict`, `noop`, `now`, `nth`, `pad`, `padEnd`, `padStart`, `parseInt`,
	     * `pop`, `random`, `reduce`, `reduceRight`, `repeat`, `result`, `round`,
	     * `runInContext`, `sample`, `shift`, `size`, `snakeCase`, `some`, `sortedIndex`,
	     * `sortedIndexBy`, `sortedLastIndex`, `sortedLastIndexBy`, `startCase`,
	     * `startsWith`, `subtract`, `sum`, `sumBy`, `template`, `times`, `toInteger`,
	     * `toJSON`, `toLength`, `toLower`, `toNumber`, `toSafeInteger`, `toString`,
	     * `toUpper`, `trim`, `trimEnd`, `trimStart`, `truncate`, `unescape`,
	     * `uniqueId`, `upperCase`, `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE ||
	          (arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @returns {Object} Returns the new hash object.
	     */
	    function Hash() {}
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(hash, key) {
	      return hashHas(hash, key) && delete hash[key];
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @param {Object} hash The hash to query.
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(hash, key) {
	      if (nativeCreate) {
	        var result = hash[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(hash, key) ? hash[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @param {Object} hash The hash to query.
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(hash, key) {
	      return nativeCreate ? hash[key] !== undefined : hasOwnProperty.call(hash, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     */
	    function hashSet(hash, key, value) {
	      hash[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	    }
	
	    // Avoid inheriting from `Object.prototype` when possible.
	    Hash.prototype = nativeCreate ? nativeCreate(null) : objectProto;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function MapCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = values[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapClear() {
	      this.__data__ = {
	        'hash': new Hash,
	        'map': Map ? new Map : [],
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapDelete(key) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        return hashDelete(typeof key == 'string' ? data.string : data.hash, key);
	      }
	      return Map ? data.map['delete'](key) : assocDelete(data.map, key);
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapGet(key) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        return hashGet(typeof key == 'string' ? data.string : data.hash, key);
	      }
	      return Map ? data.map.get(key) : assocGet(data.map, key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        return hashHas(typeof key == 'string' ? data.string : data.hash, key);
	      }
	      return Map ? data.map.has(key) : assocHas(data.map, key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapSet(key, value) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        hashSet(typeof key == 'string' ? data.string : data.hash, key, value);
	      } else if (Map) {
	        data.map.set(key, value);
	      } else {
	        assocSet(data.map, key, value);
	      }
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapClear;
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a set cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.push(values[index]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache`.
	     *
	     * @private
	     * @param {Object} cache The set cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function cacheHas(cache, value) {
	      var map = cache.__data__;
	      if (isKeyable(value)) {
	        var data = map.__data__,
	            hash = typeof value == 'string' ? data.string : data.hash;
	
	        return hash[value] === HASH_UNDEFINED;
	      }
	      return map.has(value);
	    }
	
	    /**
	     * Adds `value` to the set cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var map = this.__data__;
	      if (isKeyable(value)) {
	        var data = map.__data__,
	            hash = typeof value == 'string' ? data.string : data.hash;
	
	        hash[value] = HASH_UNDEFINED;
	      }
	      else {
	        map.set(value, HASH_UNDEFINED);
	      }
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.push = cachePush;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function Stack(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = values[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = { 'array': [], 'map': null };
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          array = data.array;
	
	      return array ? assocDelete(array, key) : data.map['delete'](key);
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      var data = this.__data__,
	          array = data.array;
	
	      return array ? assocGet(array, key) : data.map.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      var data = this.__data__,
	          array = data.array;
	
	      return array ? assocHas(array, key) : data.map.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__,
	          array = data.array;
	
	      if (array) {
	        if (array.length < (LARGE_ARRAY_SIZE - 1)) {
	          assocSet(array, key, value);
	        } else {
	          data.array = null;
	          data.map = new MapCache(array);
	        }
	      }
	      var map = data.map;
	      if (map) {
	        map.set(key, value);
	      }
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Removes `key` and its value from the associative array.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function assocDelete(array, key) {
	      var index = assocIndexOf(array, key);
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = array.length - 1;
	      if (index == lastIndex) {
	        array.pop();
	      } else {
	        splice.call(array, index, 1);
	      }
	      return true;
	    }
	
	    /**
	     * Gets the associative array value for `key`.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function assocGet(array, key) {
	      var index = assocIndexOf(array, key);
	      return index < 0 ? undefined : array[index][1];
	    }
	
	    /**
	     * Checks if an associative array value for `key` exists.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function assocHas(array, key) {
	      return assocIndexOf(array, key) > -1;
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to search.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Sets the associative array `key` to `value`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     */
	    function assocSet(array, key, value) {
	      var index = assocIndexOf(array, key);
	      if (index < 0) {
	        array.push([key, value]);
	      } else {
	        array[index][1] = value;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function assignInDefaults(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (typeof key == 'number' && value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          isNil = object == null,
	          length = paths.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = isNil ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {boolean} [isFull] Specify a clone including symbols.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          if (isHostObject(value)) {
	            return object ? value : {};
	          }
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (!isArr) {
	        var props = isFull ? getAllKeys(value) : keys(value);
	      }
	      // Recursively populate clone (susceptible to call stack limits).
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new function.
	     */
	    function baseConforms(source) {
	      var props = keys(source),
	          length = props.length;
	
	      return function(object) {
	        if (object == null) {
	          return !length;
	        }
	        var index = length;
	        while (index--) {
	          var key = props[index],
	              predicate = source[key],
	              value = object[key];
	
	          if ((value === undefined &&
	              !(key in Object(object))) || !predicate(value)) {
	            return false;
	          }
	        }
	        return true;
	      };
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    function baseCreate(proto) {
	      return isObject(proto) ? objectCreate(proto) : {};
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an array
	     * of `func` arguments.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments to provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object)
	        ? result
	        : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	      // that are composed entirely of index properties, return `false` for
	      // `hasOwnProperty` checks of them.
	      return hasOwnProperty.call(object, key) ||
	        (typeof object == 'object' && key in object && getPrototype(object) === null);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      if (!isKey(path, object)) {
	        path = castPath(path);
	        object = parent(object, path);
	        path = last(path);
	      }
	      var func = object == null ? object : object[toKey(path)];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {boolean} [bitmask] The bitmask of comparison flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - Unordered comparison
	     *     2 - Partial comparison
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, bitmask, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = getTag(object);
	        objTag = objTag == argsTag ? objectTag : objTag;
	      }
	      if (!othIsArr) {
	        othTag = getTag(other);
	        othTag = othTag == argsTag ? objectTag : othTag;
	      }
	      var objIsObj = objTag == objectTag && !isHostObject(object),
	          othIsObj = othTag == objectTag && !isHostObject(other),
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	          : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	      }
	      if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't skip the constructor
	     * property of prototypes or treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      return nativeKeys(Object(object));
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't skip the constructor
	     * property of prototypes or treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      object = object == null ? object : Object(object);
	
	      var result = [];
	      for (var key in object) {
	        result.push(key);
	      }
	      return result;
	    }
	
	    // Fallback for IE < 9 with es6-shim.
	    if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
	      baseKeysIn = function(object) {
	        return iteratorToArray(enumerate(object));
	      };
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      if (!(isArray(source) || isTypedArray(source))) {
	        var props = keysIn(source);
	      }
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      });
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        newValue = srcValue;
	        if (isArray(srcValue) || isTypedArray(srcValue)) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	          else {
	            newValue = objValue;
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      stack.set(srcValue, newValue);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	      }
	      stack['delete'](srcValue);
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce `n` to an integer.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, props) {
	      object = Object(object);
	      return arrayReduce(props, function(result, key) {
	        if (key in object) {
	          result[key] = object[key];
	        }
	        return result;
	      }, {});
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, predicate) {
	      var index = -1,
	          props = getAllKeysIn(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (predicate(value, key)) {
	          result[key] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          }
	          else if (!isKey(index, array)) {
	            var path = castPath(index),
	                object = parent(array, path);
	
	            if (object != null) {
	              delete object[toKey(last(path))];
	            }
	          }
	          else {
	            delete array[toKey(index)];
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the new array of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]);
	        if (isObject(nested)) {
	          var newValue = value;
	          if (index != lastIndex) {
	            var objValue = nested[key];
	            newValue = customizer ? customizer(objValue, key, nested) : undefined;
	            if (newValue === undefined) {
	              newValue = objValue == null
	                ? (isIndex(path[index + 1]) ? [] : {})
	                : objValue;
	            }
	          }
	          assignValue(nested, key, newValue);
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	      object = parent(object, path);
	
	      var key = toKey(last(path));
	      return !(object != null && baseHas(object, key)) || delete object[key];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var index = -1,
	          length = arrays.length;
	
	      while (++index < length) {
	        var result = result
	          ? arrayPush(
	              baseDifference(result, arrays[index], iteratee, comparator),
	              baseDifference(arrays[index], result, iteratee, comparator)
	            )
	          : arrays[index];
	      }
	      return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value) {
	      return isArray(value) ? value : stringToPath(value);
	    }
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var result = new buffer.constructor(buffer.length);
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : source[key];
	
	        assignValue(object, key, newValue);
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbol properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return rest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = typeof customizer == 'function'
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBaseWrapper(func, bitmask, thisArg) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = reHasComplexSymbol.test(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurryWrapper(func, bitmask, arity) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getPlaceholder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurryWrapper(
	            func, bitmask, createHybridWrapper, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return rest(function(funcs) {
	        funcs = baseFlatten(funcs, 1);
	
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 &&
	              isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	          isFlip = bitmask & FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getPlaceholder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurryWrapper(
	            func, bitmask, createHybridWrapper, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return 0;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new invoker function.
	     */
	    function createOver(arrayFunc) {
	      return rest(function(iteratees) {
	        iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
	          ? arrayMap(iteratees[0], baseUnary(getIteratee()))
	          : arrayMap(baseFlatten(iteratees, 1, isFlattenableIteratee), baseUnary(getIteratee()));
	
	        return rest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return reHasComplexSymbol.test(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toNumber(start);
	        start = start === start ? start : 0;
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toNumber(end) || 0;
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : (toNumber(step) || 0);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	      if (!(bitmask & CURRY_BOUND_FLAG)) {
	        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = toInteger(precision);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] == null
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == BIND_FLAG) {
	        var result = createBaseWrapper(func, bitmask, thisArg);
	      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	        result = createCurryWrapper(func, bitmask, arity);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	        result = createPartialWrapper(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	      var index = -1,
	          isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          isUnordered = bitmask & UNORDERED_COMPARE_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(array, other);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isUnordered) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue ||
	                  equalFunc(arrValue, othValue, customizer, bitmask, stack);
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, customizer, bitmask, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and
	          // booleans to `1` or `0` treating invalid dates coerced to `NaN` as
	          // not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object) ? other != +other : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/6.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= UNORDERED_COMPARE_FLAG;
	          stack.set(object, other);
	
	          // Recursively compare objects (susceptible to call stack limits).
	          return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : baseHas(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      return result;
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a
	     * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	     * Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = toPairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getPlaceholder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the `[[Prototype]]` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {null|Object} Returns the `[[Prototype]]`.
	     */
	    function getPrototype(value) {
	      return nativeGetPrototype(Object(value));
	    }
	
	    /**
	     * Creates an array of the own enumerable symbol properties of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    function getSymbols(object) {
	      // Coerce `object` to an object to avoid non-object errors in V8.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=3443 for more details.
	      return getOwnPropertySymbols(Object(object));
	    }
	
	    // Fallback for IE < 11.
	    if (!getOwnPropertySymbols) {
	      getSymbols = function() {
	        return [];
	      };
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable symbol properties
	     * of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !getOwnPropertySymbols ? getSymbols : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function getTag(value) {
	      return objectToString.call(value);
	    }
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11,
	    // for data views in Edge, and promises in Node.js.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = objectToString.call(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : undefined;
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var result,
	          index = -1,
	          length = path.length;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result) {
	        return result;
	      }
	      var length = object ? object.length : 0;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isString(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Creates an array of index keys for `object` values of arrays,
	     * `arguments` objects, and strings, otherwise `null` is returned.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array|null} Returns index keys, else `null`.
	     */
	    function indexKeys(object) {
	      var length = object ? object.length : undefined;
	      if (isLength(length) &&
	          (isArray(object) || isString(object) || isArguments(object))) {
	        return baseTimes(length, String);
	      }
	      return null;
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArrayLikeObject(value) && (isArray(value) || isArguments(value));
	    }
	
	    /**
	     * Checks if `value` is a flattenable array and not a `_.matchesProperty`
	     * iteratee shorthand.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenableIteratee(value) {
	      return isArray(value) && !(value.length == 2 && !isFunction(value[0]));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	        ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack.set(srcValue, objValue));
	      }
	      return objValue;
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoize(function(string) {
	      var result = [];
	      toString(string).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to process.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array ? array.length : 0;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length,
	          array = castArray(arguments[0]);
	
	      if (length < 2) {
	        return length ? copyArray(array) : [];
	      }
	      var args = Array(length - 1);
	      while (length--) {
	        args[length - 1] = arguments[length];
	      }
	      return arrayConcat(array, baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other given
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([3, 2, 1], [4, 2]);
	     * // => [3, 1]
	     */
	    var difference = rest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([3.1, 2.2, 1.3], [4.4, 2.5], Math.floor);
	     * // => [3.1, 1.3]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = rest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. Result values
	     * are chosen from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = rest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate) {
	      return (array && array.length)
	        ? baseFindIndex(array, getIteratee(predicate, 3))
	        : -1;
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate) {
	      return (array && array.length)
	        ? baseFindIndex(array, getIteratee(predicate, 3), true)
	        : -1;
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs ? pairs.length : 0,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      fromIndex = toInteger(fromIndex);
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return baseIndexOf(array, value, fromIndex);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [4, 2], [1, 2]);
	     * // => [2]
	     */
	    var intersection = rest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = rest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. Result values are chosen
	     * from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = rest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (comparator === last(mapped)) {
	        comparator = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array ? nativeJoin.call(array, separator) : '';
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = (
	          index < 0
	            ? nativeMax(length + index, 0)
	            : nativeMin(index, length - 1)
	        ) + 1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Gets the nth element of `array`. If `n` is negative, the nth element
	     * from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    var pull = rest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pullAll(array, [2, 3]);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = rest(function(array, indexes) {
	      indexes = baseFlatten(indexes, 1);
	
	      var length = array ? array.length : 0,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array ? nativeReverse.call(array) : array;
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 5], 4);
	     * // => 0
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var dict = { 'thirty': 30, 'forty': 40, 'fifty': 50 };
	     *
	     * _.sortedIndexBy(['thirty', 'fifty'], 'forty', _.propertyOf(dict));
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy([{ 'x': 4 }, { 'x': 5 }], { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([1, 1, 2, 2], 2);
	     * // => 2
	     */
	    function sortedIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5], 4);
	     * // => 1
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy([{ 'x': 4 }, { 'x': 5 }], { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([1, 1, 2, 2], 2);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2, 1], [4, 2], [1, 2]);
	     * // => [2, 1, 4]
	     */
	    var union = rest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	     * // => [2.1, 1.2, 4.3]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = rest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = rest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each
	     * element is kept.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length)
	        ? baseUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseUniq(array, getIteratee(iteratee))
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 },  { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      return (array && array.length)
	        ? baseUniq(array, undefined, comparator)
	        : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = rest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [4, 2]);
	     * // => [1, 4]
	     */
	    var xor = rest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	     * // => [1.2, 4.3]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = rest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = rest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = rest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = rest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     *
	     * _(['a', 'b', 'c']).at(0, 2).value();
	     * // => ['a', 'c']
	     */
	    var wrapperAt = rest(function(paths) {
	      paths = baseFlatten(paths, 1);
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    function find(collection, predicate) {
	      predicate = getIteratee(predicate, 3);
	      if (isArray(collection)) {
	        var index = baseFindIndex(collection, predicate);
	        return index > -1 ? collection[index] : undefined;
	      }
	      return baseFind(collection, predicate, baseEach);
	    }
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    function findLast(collection, predicate) {
	      predicate = getIteratee(predicate, 3);
	      if (isArray(collection)) {
	        var index = baseFindIndex(collection, predicate, true);
	        return index > -1 ? collection[index] : undefined;
	      }
	      return baseFind(collection, predicate, baseEachRight);
	    }
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _([1, 2]).forEach(function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      return (typeof iteratee == 'function' && isArray(collection))
	        ? arrayEach(collection, iteratee)
	        : baseEach(collection, getIteratee(iteratee));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      return (typeof iteratee == 'function' && isArray(collection))
	        ? arrayEachRight(collection, iteratee)
	        : baseEachRight(collection, getIteratee(iteratee));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function, it's
	     * invoked for and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = rest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getIteratee(predicate, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var array = isArrayLike(collection) ? collection : values(collection),
	          length = array.length;
	
	      return length > 0 ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = baseClamp(toInteger(n), 0, length);
	      }
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sampleSize(collection, MAX_ARRAY_LENGTH);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        var result = collection.length;
	        return (result && isString(collection)) ? stringSize(collection) : result;
	      }
	      if (isObjectLike(collection)) {
	        var tag = getTag(collection);
	        if (tag == mapTag || tag == setTag) {
	          return collection.size;
	        }
	      }
	      return keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [iteratees=[_.identity]] The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, function(o) { return o.user; });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     *
	     * _.sortBy(users, 'user', function(o) {
	     *   return Math.floor(o.age / 10);
	     * });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    var sortBy = rest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
	        ? iteratees[0]
	        : baseFlatten(iteratees, 1, isFlattenableIteratee);
	
	      return baseOrderBy(collection, iteratees, []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @type {Function}
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred function to be invoked.
	     */
	    var now = Date.now;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = rest(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getPlaceholder(bind));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = rest(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getPlaceholder(bindKey));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrapper(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrapper(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide an options object to indicate whether `func` should be invoked on
	     * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent calls
	     * to the debounced function return the result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime = 0,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (!lastCallTime || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        clearTimeout(timerId);
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastCallTime = lastInvokeTime = 0;
	        lastArgs = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one or more milliseconds.
	     */
	    var defer = rest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = rest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrapper(func, FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with arguments transformed by
	     * corresponding `transforms`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [transforms[_.identity]] The functions to transform.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = rest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1, isFlattenableIteratee), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return rest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = rest(function(func, partials) {
	      var holders = replaceHolders(partials, getPlaceholder(partial));
	      return createWrapper(func, PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = rest(function(func, partials) {
	      var holders = replaceHolders(partials, getPlaceholder(partialRight));
	      return createWrapper(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = rest(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes, 1));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, array);
	          case 1: return func.call(this, args[0], array);
	          case 2: return func.call(this, args[0], args[1], array);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = array;
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/6.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	      return rest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide an options object to indicate whether
	     * `func` should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return partial(wrapper, value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, false, true);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      return baseClone(value, false, true, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, true, true);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      return baseClone(value, true, true, customizer);
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	      return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	        (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @type {Function}
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    function isArrayBuffer(value) {
	      return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
	    }
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value)) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && objectToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = !Buffer ? constant(false) : function(value) {
	      return value instanceof Buffer;
	    };
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objectToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element,
	     *  else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (isArrayLike(value) &&
	          (isArray(value) || isString(value) || isFunction(value.splice) ||
	            isArguments(value) || isBuffer(value))) {
	        return !value.length;
	      }
	      if (isObjectLike(value)) {
	        var tag = getTag(value);
	        if (tag == mapTag || tag == setTag) {
	          return !value.size;
	        }
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return !(nonEnumShadows && keys(value).length);
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are **not** supported.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent,
	     *  else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent,
	     *  else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object,
	     *  else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      return (objectToString.call(value) == errorTag) ||
	        (typeof value.message == 'string' && typeof value.name == 'string');
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number,
	     *  else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MAX_VALUE);
	     * // => true
	     *
	     * _.isFinite(3.14);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 8 which returns 'object' for typed array and weak map constructors,
	      // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	      var tag = isObject(value) ? objectToString.call(value) : '';
	      return tag == funcTag || tag == genTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length,
	     *  else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return !!value && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    function isMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values. This method is
	     * equivalent to a `_.matches` function when `source` is partially applied.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && objectToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object,
	     *  else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) ||
	          objectToString.call(value) != objectTag || isHostObject(value)) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return (typeof Ctor == 'function' &&
	        Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objectToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer,
	     *  else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    function isSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && objectToString.call(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && objectToString.call(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (iteratorSymbol && value[iteratorSymbol]) {
	        return iteratorToArray(value[iteratorSymbol]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This function is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3');
	     * // => 3
	     */
	    function toInteger(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      var remainder = value % 1;
	      return value === value ? (remainder ? value - remainder : value) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3);
	     * // => 3
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3');
	     * // => 3
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = isFunction(value.valueOf) ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.c = 3;
	     * }
	     *
	     * function Bar() {
	     *   this.e = 5;
	     * }
	     *
	     * Foo.prototype.d = 4;
	     * Bar.prototype.f = 6;
	     *
	     * _.assign({ 'a': 1 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3, 'e': 5 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * function Bar() {
	     *   this.d = 4;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     * Bar.prototype.e = 5;
	     *
	     * _.assignIn({ 'a': 1 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4, 'e': 5 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keysIn(source), object);
	        return;
	      }
	      for (var key in source) {
	        assignValue(object, key, source[key]);
	      }
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     *
	     * _.at(['a', 'b', 'c'], 0, 2);
	     * // => ['a', 'c']
	     */
	    var at = rest(function(object, paths) {
	      return baseAt(object, baseFlatten(paths, 1));
	    });
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = rest(function(args) {
	      args.push(undefined, assignInDefaults);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = rest(function(args) {
	      args.push(undefined, mergeDefaults);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFind(object, getIteratee(predicate, 3), baseForOwn, true);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFind(object, getIteratee(predicate, 3), baseForOwnRight, true);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = rest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      var isProto = isPrototype(object);
	      if (!(isProto || isArrayLike(object))) {
	        return baseKeys(object);
	      }
	      var indexes = indexKeys(object),
	          skipIndexes = !!indexes,
	          result = indexes || [],
	          length = result.length;
	
	      for (var key in object) {
	        if (baseHas(object, key) &&
	            !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	            !(isProto && key == 'constructor')) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      var index = -1,
	          isProto = isPrototype(object),
	          props = baseKeysIn(object),
	          propsLength = props.length,
	          indexes = indexKeys(object),
	          skipIndexes = !!indexes,
	          result = indexes || [],
	          length = result.length;
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[iteratee(value, key, object)] = value;
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[key] = iteratee(value, key, object);
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively.Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with seven arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable string keyed properties of `object` that are
	     * not omitted.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = rest(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      props = arrayMap(baseFlatten(props, 1), toKey);
	      return basePick(object, baseDifference(getAllKeysIn(object), props));
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      predicate = getIteratee(predicate);
	      return basePickBy(object, function(value, key) {
	        return !predicate(value, key);
	      });
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = rest(function(object, props) {
	      return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      return object == null ? {} : basePickBy(object, getIteratee(predicate));
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        object = undefined;
	        length = 1;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    function toPairs(object) {
	      return baseToPairs(object, keys(object));
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 1]] (iteration order is not guaranteed)
	     */
	    function toPairsIn(object) {
	      return baseToPairs(object, keysIn(object));
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. The iteratee is invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getIteratee(iteratee, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object ? baseValues(object, keys(object)) : [];
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toNumber(start) || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toNumber(end) || 0;
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toNumber(lower) || 0;
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toNumber(upper) || 0;
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in IE < 9, they can break out of
	     * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the
	     * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=3109 for more details.
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = toString(string).replace(reTrim, '');
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : nativeReplace.call(string, args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the new array of string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (separator == '' && reHasComplexSymbol.test(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return nativeSplit.call(string, separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = baseClamp(toInteger(position), 0, string.length);
	      return string.lastIndexOf(baseToString(target), position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, assignInDefaults);
	
	      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (reHasComplexSymbol.test(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        pattern = reHasComplexWord.test(string) ? reComplexWord : reBasicWord;
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = rest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, 'onClick');
	     * jQuery(element).on('click', view.onClick);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = rest(function(object, methodNames) {
	      arrayEach(baseFlatten(methodNames, 1), function(key) {
	        key = toKey(key);
	        object[key] = bind(object[key], object);
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.constant(true),                _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs ? pairs.length : 0,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return rest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.filter(users, _.conforms({ 'age': _.partial(_.gt, _, 38) }));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument given to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`. The created function is equivalent to
	     * `_.isMatch` with a `source` partially applied.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = rest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = rest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns its nth argument. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return rest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [iteratees=[_.identity]] The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over(Math.max, Math.min);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [predicates=[_.identity]] The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery(Boolean, isFinite);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [predicates=[_.identity]] The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome(Boolean, isFinite);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(true));
	     * // => [true, true, true, true]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     *
	     * var path = ['a', 'b', 'c'],
	     *     newPath = _.toPath(path);
	     *
	     * console.log(newPath);
	     * // => ['a', 'b', 'c']
	     *
	     * console.log(path === newPath);
	     * // => false
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    });
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    });
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    });
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    });
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.deburr = deburr;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = rest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      predicate = getIteratee(predicate, 3);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    if (iteratorSymbol) {
	      lodash.prototype[iteratorSymbol] = wrapperToIterator;
	    }
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Expose Lodash on the free variable `window` or `self` when available so it's
	  // globally accessible, even when bundled with Browserify, Webpack, etc. This
	  // also prevents errors in cases where Lodash is loaded by a script tag in the
	  // presence of an AMD loader. See http://requirejs.org/docs/errors.html#mismatch
	  // for more details. Use `_.noConflict` to remove Lodash from the global object.
	  (freeWindow || freeSelf || {})._ = _;
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module), (function() { return this; }())))

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(84),
	    baseIteratee = __webpack_require__(37);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Array|Function|Object|string} [iteratee=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    result[key] = iteratee(value, key, object);
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(63);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoizing function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(101),
	    basePropertyDeep = __webpack_require__(374),
	    isKey = __webpack_require__(50),
	    toKey = __webpack_require__(35);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var baseToPairs = __webpack_require__(377),
	    keys = __webpack_require__(41);
	
	/**
	 * Creates an array of own enumerable string keyed-value pairs for `object`
	 * which can be consumed by `_.fromPairs`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias entries
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairs(new Foo);
	 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	 */
	function toPairs(object) {
	  return baseToPairs(object, keys(object));
	}
	
	module.exports = toPairs;


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(378);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 114,
		"./af.js": 114,
		"./ar": 118,
		"./ar-ma": 115,
		"./ar-ma.js": 115,
		"./ar-sa": 116,
		"./ar-sa.js": 116,
		"./ar-tn": 117,
		"./ar-tn.js": 117,
		"./ar.js": 118,
		"./az": 119,
		"./az.js": 119,
		"./be": 120,
		"./be.js": 120,
		"./bg": 121,
		"./bg.js": 121,
		"./bn": 122,
		"./bn.js": 122,
		"./bo": 123,
		"./bo.js": 123,
		"./br": 124,
		"./br.js": 124,
		"./bs": 125,
		"./bs.js": 125,
		"./ca": 126,
		"./ca.js": 126,
		"./cs": 127,
		"./cs.js": 127,
		"./cv": 128,
		"./cv.js": 128,
		"./cy": 129,
		"./cy.js": 129,
		"./da": 130,
		"./da.js": 130,
		"./de": 132,
		"./de-at": 131,
		"./de-at.js": 131,
		"./de.js": 132,
		"./dv": 133,
		"./dv.js": 133,
		"./el": 134,
		"./el.js": 134,
		"./en-au": 135,
		"./en-au.js": 135,
		"./en-ca": 136,
		"./en-ca.js": 136,
		"./en-gb": 137,
		"./en-gb.js": 137,
		"./en-ie": 138,
		"./en-ie.js": 138,
		"./en-nz": 139,
		"./en-nz.js": 139,
		"./eo": 140,
		"./eo.js": 140,
		"./es": 141,
		"./es.js": 141,
		"./et": 142,
		"./et.js": 142,
		"./eu": 143,
		"./eu.js": 143,
		"./fa": 144,
		"./fa.js": 144,
		"./fi": 145,
		"./fi.js": 145,
		"./fo": 146,
		"./fo.js": 146,
		"./fr": 149,
		"./fr-ca": 147,
		"./fr-ca.js": 147,
		"./fr-ch": 148,
		"./fr-ch.js": 148,
		"./fr.js": 149,
		"./fy": 150,
		"./fy.js": 150,
		"./gd": 151,
		"./gd.js": 151,
		"./gl": 152,
		"./gl.js": 152,
		"./he": 153,
		"./he.js": 153,
		"./hi": 154,
		"./hi.js": 154,
		"./hr": 155,
		"./hr.js": 155,
		"./hu": 156,
		"./hu.js": 156,
		"./hy-am": 157,
		"./hy-am.js": 157,
		"./id": 158,
		"./id.js": 158,
		"./is": 159,
		"./is.js": 159,
		"./it": 160,
		"./it.js": 160,
		"./ja": 161,
		"./ja.js": 161,
		"./jv": 162,
		"./jv.js": 162,
		"./ka": 163,
		"./ka.js": 163,
		"./kk": 164,
		"./kk.js": 164,
		"./km": 165,
		"./km.js": 165,
		"./ko": 166,
		"./ko.js": 166,
		"./ky": 167,
		"./ky.js": 167,
		"./lb": 168,
		"./lb.js": 168,
		"./lo": 169,
		"./lo.js": 169,
		"./lt": 170,
		"./lt.js": 170,
		"./lv": 171,
		"./lv.js": 171,
		"./me": 172,
		"./me.js": 172,
		"./mk": 173,
		"./mk.js": 173,
		"./ml": 174,
		"./ml.js": 174,
		"./mr": 175,
		"./mr.js": 175,
		"./ms": 177,
		"./ms-my": 176,
		"./ms-my.js": 176,
		"./ms.js": 177,
		"./my": 178,
		"./my.js": 178,
		"./nb": 179,
		"./nb.js": 179,
		"./ne": 180,
		"./ne.js": 180,
		"./nl": 181,
		"./nl.js": 181,
		"./nn": 182,
		"./nn.js": 182,
		"./pa-in": 183,
		"./pa-in.js": 183,
		"./pl": 184,
		"./pl.js": 184,
		"./pt": 186,
		"./pt-br": 185,
		"./pt-br.js": 185,
		"./pt.js": 186,
		"./ro": 187,
		"./ro.js": 187,
		"./ru": 188,
		"./ru.js": 188,
		"./se": 189,
		"./se.js": 189,
		"./si": 190,
		"./si.js": 190,
		"./sk": 191,
		"./sk.js": 191,
		"./sl": 192,
		"./sl.js": 192,
		"./sq": 193,
		"./sq.js": 193,
		"./sr": 195,
		"./sr-cyrl": 194,
		"./sr-cyrl.js": 194,
		"./sr.js": 195,
		"./ss": 196,
		"./ss.js": 196,
		"./sv": 197,
		"./sv.js": 197,
		"./sw": 198,
		"./sw.js": 198,
		"./ta": 199,
		"./ta.js": 199,
		"./te": 200,
		"./te.js": 200,
		"./th": 201,
		"./th.js": 201,
		"./tl-ph": 202,
		"./tl-ph.js": 202,
		"./tlh": 203,
		"./tlh.js": 203,
		"./tr": 204,
		"./tr.js": 204,
		"./tzl": 205,
		"./tzl.js": 205,
		"./tzm": 207,
		"./tzm-latn": 206,
		"./tzm-latn.js": 206,
		"./tzm.js": 207,
		"./uk": 208,
		"./uk.js": 208,
		"./uz": 209,
		"./uz.js": 209,
		"./vi": 210,
		"./vi.js": 210,
		"./x-pseudo": 211,
		"./x-pseudo.js": 211,
		"./zh-cn": 212,
		"./zh-cn.js": 212,
		"./zh-tw": 213,
		"./zh-tw.js": 213
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 417;


/***/ },
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keymirror = __webpack_require__(743);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _keymirror2.default)({
	  HORIZONTAL: null,
	  RECTANGLE: null,
	  VERTICAL: null,
	  MOBILE: null,
	  MOBILE_BIG: null
	});

/***/ },
/* 426 */,
/* 427 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = thunkMiddleware;
	function thunkMiddleware(_ref) {
	  var dispatch = _ref.dispatch;
	  var getState = _ref.getState;
	
	  return function (next) {
	    return function (action) {
	      if (typeof action === 'function') {
	        return action(dispatch, getState);
	      }
	
	      return next(action);
	    };
	  };
	}

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = applyMiddleware;
	
	var _compose = __webpack_require__(218);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2["default"].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 429 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = combineReducers;
	
	var _createStore = __webpack_require__(219);
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(220);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2["default"])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key);
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action);
	      if (warningMessage) {
	        (0, _warning2["default"])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';
	
	module.exports = __webpack_require__(432)(global || window || this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 432 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function symbolObservablePonyfill(root) {
		var result;
		var Symbol = root.Symbol;
	
		if (typeof Symbol === 'function') {
			if (Symbol.observable) {
				result = Symbol.observable;
			} else {
				result = Symbol('observable');
				Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {// Generated by CoffeeScript 1.10.0
	(function() {
	  var hasModule, isArray, makeTwix,
	    slice = [].slice;
	
	  hasModule = (typeof module !== "undefined" && module !== null) && (module.exports != null);
	
	  isArray = function(input) {
	    return Object.prototype.toString.call(input) === '[object Array]';
	  };
	
	  makeTwix = function(moment) {
	    var Twix;
	    if (moment == null) {
	      throw new Error("Can't find moment");
	    }
	    Twix = (function() {
	      function Twix(start, end, parseFormat, options) {
	        var ref;
	        if (options == null) {
	          options = {};
	        }
	        if (typeof parseFormat !== 'string') {
	          options = parseFormat != null ? parseFormat : {};
	          parseFormat = null;
	        }
	        if (typeof options === 'boolean') {
	          options = {
	            allDay: options
	          };
	        }
	        this._oStart = moment(start, parseFormat, options.parseStrict);
	        this._oEnd = moment(end, parseFormat, options.parseStrict);
	        this.allDay = (ref = options.allDay) != null ? ref : false;
	        this._mutated();
	      }
	
	      Twix._extend = function() {
	        var attr, first, j, len, other, others;
	        first = arguments[0], others = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	        for (j = 0, len = others.length; j < len; j++) {
	          other = others[j];
	          for (attr in other) {
	            if (typeof other[attr] !== 'undefined') {
	              first[attr] = other[attr];
	            }
	          }
	        }
	        return first;
	      };
	
	      Twix.prototype.start = function() {
	        return this._start.clone();
	      };
	
	      Twix.prototype.end = function() {
	        return this._end.clone();
	      };
	
	      Twix.prototype.isSame = function(period) {
	        return this._start.isSame(this._end, period);
	      };
	
	      Twix.prototype.length = function(period) {
	        return this._displayEnd.diff(this._start, period);
	      };
	
	      Twix.prototype.count = function(period) {
	        var end, start;
	        start = this.start().startOf(period);
	        end = this.end().startOf(period);
	        return end.diff(start, period) + 1;
	      };
	
	      Twix.prototype.countInner = function(period) {
	        var end, ref, start;
	        ref = this._inner(period), start = ref[0], end = ref[1];
	        if (start >= end) {
	          return 0;
	        }
	        return end.diff(start, period);
	      };
	
	      Twix.prototype.iterate = function(intervalAmount, period, minHours) {
	        var end, hasNext, ref, start;
	        ref = this._prepIterateInputs(intervalAmount, period, minHours), intervalAmount = ref[0], period = ref[1], minHours = ref[2];
	        start = this.start().startOf(period);
	        end = this.end().startOf(period);
	        if (this.allDay) {
	          end = end.add(1, 'd');
	        }
	        hasNext = (function(_this) {
	          return function() {
	            return (!_this.allDay && start <= end && (!minHours || !start.isSame(end) || _this._end.hours() > minHours)) || (_this.allDay && start < end);
	          };
	        })(this);
	        return this._iterateHelper(period, start, hasNext, intervalAmount);
	      };
	
	      Twix.prototype.iterateInner = function(intervalAmount, period) {
	        var end, hasNext, ref, ref1, start;
	        ref = this._prepIterateInputs(intervalAmount, period), intervalAmount = ref[0], period = ref[1];
	        ref1 = this._inner(period, intervalAmount), start = ref1[0], end = ref1[1];
	        hasNext = function() {
	          return start < end;
	        };
	        return this._iterateHelper(period, start, hasNext, intervalAmount);
	      };
	
	      Twix.prototype.humanizeLength = function() {
	        if (this.allDay) {
	          if (this.isSame('d')) {
	            return 'all day';
	          } else {
	            return this._start.from(this.end().add(1, 'd'), true);
	          }
	        } else {
	          return this._start.from(this._end, true);
	        }
	      };
	
	      Twix.prototype.asDuration = function(units) {
	        var diff;
	        diff = this._end.diff(this._start);
	        return moment.duration(diff);
	      };
	
	      Twix.prototype.isPast = function() {
	        return this._lastMilli < moment();
	      };
	
	      Twix.prototype.isFuture = function() {
	        return this._start > moment();
	      };
	
	      Twix.prototype.isCurrent = function() {
	        return !this.isPast() && !this.isFuture();
	      };
	
	      Twix.prototype.contains = function(mom) {
	        if (!moment.isMoment(mom)) {
	          mom = moment(mom);
	        }
	        return this._start <= mom && this._lastMilli >= mom;
	      };
	
	      Twix.prototype.isEmpty = function() {
	        return this._start.isSame(this._displayEnd);
	      };
	
	      Twix.prototype.overlaps = function(other) {
	        return this._displayEnd.isAfter(other._start) && this._start.isBefore(other._displayEnd);
	      };
	
	      Twix.prototype.engulfs = function(other) {
	        return this._start <= other._start && this._displayEnd >= other._displayEnd;
	      };
	
	      Twix.prototype.union = function(other) {
	        var allDay, newEnd, newStart;
	        allDay = this.allDay && other.allDay;
	        newStart = this._start < other._start ? this._start : other._start;
	        newEnd = this._lastMilli > other._lastMilli ? (allDay ? this._end : this._displayEnd) : (allDay ? other._end : other._displayEnd);
	        return new Twix(newStart, newEnd, allDay);
	      };
	
	      Twix.prototype.intersection = function(other) {
	        var allDay, newEnd, newStart;
	        allDay = this.allDay && other.allDay;
	        newStart = this._start > other._start ? this._start : other._start;
	        newEnd = this._lastMilli < other._lastMilli ? (allDay ? this._end : this._displayEnd) : (allDay ? other._end : other._displayEnd);
	        return new Twix(newStart, newEnd, allDay);
	      };
	
	      Twix.prototype.xor = function() {
	        var allDay, arr, endTime, i, item, j, k, last, len, len1, o, open, other, others, ref, results, start, t;
	        others = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	        open = 0;
	        start = null;
	        results = [];
	        allDay = ((function() {
	          var j, len, results1;
	          results1 = [];
	          for (j = 0, len = others.length; j < len; j++) {
	            o = others[j];
	            if (o.allDay) {
	              results1.push(o);
	            }
	          }
	          return results1;
	        })()).length === others.length;
	        arr = [];
	        ref = [this].concat(others);
	        for (i = j = 0, len = ref.length; j < len; i = ++j) {
	          item = ref[i];
	          arr.push({
	            time: item._start,
	            i: i,
	            type: 0
	          });
	          arr.push({
	            time: item._displayEnd,
	            i: i,
	            type: 1
	          });
	        }
	        arr = arr.sort(function(a, b) {
	          return a.time - b.time;
	        });
	        for (k = 0, len1 = arr.length; k < len1; k++) {
	          other = arr[k];
	          if (other.type === 1) {
	            open -= 1;
	          }
	          if (open === other.type) {
	            start = other.time;
	          }
	          if (open === (other.type + 1) % 2) {
	            if (start) {
	              last = results[results.length - 1];
	              if (last && last._end.isSame(start)) {
	                last._oEnd = other.time;
	                last._mutated();
	              } else {
	                endTime = allDay ? other.time.clone().subtract(1, 'd') : other.time;
	                t = new Twix(start, endTime, allDay);
	                if (!t.isEmpty()) {
	                  results.push(t);
	                }
	              }
	            }
	            start = null;
	          }
	          if (other.type === 0) {
	            open += 1;
	          }
	        }
	        return results;
	      };
	
	      Twix.prototype.difference = function() {
	        var j, len, others, ref, results1, t;
	        others = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	        ref = this.xor.apply(this, others).map((function(_this) {
	          return function(i) {
	            return _this.intersection(i);
	          };
	        })(this));
	        results1 = [];
	        for (j = 0, len = ref.length; j < len; j++) {
	          t = ref[j];
	          if (!t.isEmpty() && t.isValid()) {
	            results1.push(t);
	          }
	        }
	        return results1;
	      };
	
	      Twix.prototype.split = function() {
	        var args, dur, end, final, i, mom, start, time, times, vals;
	        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	        end = start = this.start();
	        if (moment.isDuration(args[0])) {
	          dur = args[0];
	        } else if ((!moment.isMoment(args[0]) && !isArray(args[0]) && typeof args[0] === 'object') || (typeof args[0] === 'number' && typeof args[1] === 'string')) {
	          dur = moment.duration(args[0], args[1]);
	        } else if (isArray(args[0])) {
	          times = args[0];
	        } else {
	          times = args;
	        }
	        if (times) {
	          times = (function() {
	            var j, len, results1;
	            results1 = [];
	            for (j = 0, len = times.length; j < len; j++) {
	              time = times[j];
	              results1.push(moment(time));
	            }
	            return results1;
	          })();
	          times = ((function() {
	            var j, len, results1;
	            results1 = [];
	            for (j = 0, len = times.length; j < len; j++) {
	              mom = times[j];
	              if (mom.isValid() && mom >= start) {
	                results1.push(mom);
	              }
	            }
	            return results1;
	          })()).sort();
	        }
	        if ((dur && dur.asMilliseconds() === 0) || (times && times.length === 0)) {
	          return [this];
	        }
	        vals = [];
	        i = 0;
	        final = this._displayEnd;
	        while (start < final && ((times == null) || times[i])) {
	          end = dur ? start.clone().add(dur) : times[i].clone();
	          end = moment.min(final, end);
	          if (!start.isSame(end)) {
	            vals.push(moment.twix(start, end));
	          }
	          start = end;
	          i += 1;
	        }
	        if (!end.isSame(this._displayEnd) && times) {
	          vals.push(moment.twix(end, this._displayEnd));
	        }
	        return vals;
	      };
	
	      Twix.prototype.isValid = function() {
	        return this._start.isValid() && this._end.isValid() && this._start <= this._displayEnd;
	      };
	
	      Twix.prototype.equals = function(other) {
	        return (other instanceof Twix) && this.allDay === other.allDay && this._start.valueOf() === other._start.valueOf() && this._end.valueOf() === other._end.valueOf();
	      };
	
	      Twix.prototype.toString = function() {
	        return "{start: " + (this._start.format()) + ", end: " + (this._end.format()) + ", allDay: " + (this.allDay ? 'true' : 'false') + "}";
	      };
	
	      Twix.prototype.simpleFormat = function(momentOpts, inopts) {
	        var options, s;
	        options = {
	          allDay: '(all day)',
	          template: Twix.formatTemplate
	        };
	        Twix._extend(options, inopts || {});
	        s = options.template(this._start.format(momentOpts), this._end.format(momentOpts));
	        if (this.allDay && options.allDay) {
	          s += " " + options.allDay;
	        }
	        return s;
	      };
	
	      Twix.prototype.format = function(inopts) {
	        var common_bucket, end_bucket, fold, format, fs, global_first, goesIntoTheMorning, j, len, momentHourFormat, needDate, needsMeridiem, options, process, start_bucket, together;
	        if (this.isEmpty()) {
	          return '';
	        }
	        momentHourFormat = this._start.localeData()._longDateFormat['LT'][0];
	        options = {
	          groupMeridiems: true,
	          spaceBeforeMeridiem: true,
	          showDayOfWeek: false,
	          hideTime: false,
	          hideYear: false,
	          implicitMinutes: true,
	          implicitDate: false,
	          implicitYear: true,
	          yearFormat: 'YYYY',
	          monthFormat: 'MMM',
	          weekdayFormat: 'ddd',
	          dayFormat: 'D',
	          meridiemFormat: 'A',
	          hourFormat: momentHourFormat,
	          minuteFormat: 'mm',
	          allDay: 'all day',
	          explicitAllDay: false,
	          lastNightEndsAt: 0,
	          template: Twix.formatTemplate
	        };
	        Twix._extend(options, inopts || {});
	        fs = [];
	        needsMeridiem = options.hourFormat && options.hourFormat[0] === 'h';
	        goesIntoTheMorning = options.lastNightEndsAt > 0 && !this.allDay && this.end().startOf('d').valueOf() === this.start().add(1, 'd').startOf('d').valueOf() && this._start.hours() > 12 && this._end.hours() < options.lastNightEndsAt;
	        needDate = !options.hideDate && (!options.implicitDate || this.start().startOf('d').valueOf() !== moment().startOf('d').valueOf() || !(this.isSame('d') || goesIntoTheMorning));
	        if (this.allDay && this.isSame('d') && (options.implicitDate || options.explicitAllDay)) {
	          fs.push({
	            name: 'all day simple',
	            fn: function() {
	              return options.allDay;
	            },
	            pre: ' ',
	            slot: 0
	          });
	        }
	        if (needDate && !options.hideYear && (!options.implicitYear || this._start.year() !== moment().year() || !this.isSame('y'))) {
	          fs.push({
	            name: 'year',
	            fn: function(date) {
	              return date.format(options.yearFormat);
	            },
	            pre: ', ',
	            slot: 4
	          });
	        }
	        if (!this.allDay && needDate) {
	          fs.push({
	            name: 'all day month',
	            fn: function(date) {
	              return date.format(options.monthFormat + " " + options.dayFormat);
	            },
	            ignoreEnd: function() {
	              return goesIntoTheMorning;
	            },
	            pre: ' ',
	            slot: 2
	          });
	        }
	        if (this.allDay && needDate) {
	          fs.push({
	            name: 'month',
	            fn: function(date) {
	              return date.format(options.monthFormat);
	            },
	            pre: ' ',
	            slot: 2
	          });
	        }
	        if (this.allDay && needDate) {
	          fs.push({
	            name: 'date',
	            fn: function(date) {
	              return date.format(options.dayFormat);
	            },
	            pre: ' ',
	            slot: 3
	          });
	        }
	        if (needDate && options.showDayOfWeek) {
	          fs.push({
	            name: 'day of week',
	            fn: function(date) {
	              return date.format(options.weekdayFormat);
	            },
	            pre: ' ',
	            slot: 1
	          });
	        }
	        if (options.groupMeridiems && needsMeridiem && !this.allDay && !options.hideTime) {
	          fs.push({
	            name: 'meridiem',
	            fn: function(t) {
	              return t.format(options.meridiemFormat);
	            },
	            slot: 6,
	            pre: options.spaceBeforeMeridiem ? ' ' : ''
	          });
	        }
	        if (!this.allDay && !options.hideTime) {
	          fs.push({
	            name: 'time',
	            fn: function(date) {
	              var str;
	              str = date.minutes() === 0 && options.implicitMinutes && needsMeridiem ? date.format(options.hourFormat) : date.format(options.hourFormat + ":" + options.minuteFormat);
	              if (!options.groupMeridiems && needsMeridiem) {
	                if (options.spaceBeforeMeridiem) {
	                  str += ' ';
	                }
	                str += date.format(options.meridiemFormat);
	              }
	              return str;
	            },
	            slot: 5,
	            pre: ', '
	          });
	        }
	        start_bucket = [];
	        end_bucket = [];
	        common_bucket = [];
	        together = true;
	        process = (function(_this) {
	          return function(format) {
	            var end_str, start_group, start_str;
	            start_str = format.fn(_this._start);
	            end_str = format.ignoreEnd && format.ignoreEnd() ? start_str : format.fn(_this._end);
	            start_group = {
	              format: format,
	              value: function() {
	                return start_str;
	              }
	            };
	            if (end_str === start_str && together) {
	              return common_bucket.push(start_group);
	            } else {
	              if (together) {
	                together = false;
	                common_bucket.push({
	                  format: {
	                    slot: format.slot,
	                    pre: ''
	                  },
	                  value: function() {
	                    return options.template(fold(start_bucket), fold(end_bucket, true).trim());
	                  }
	                });
	              }
	              start_bucket.push(start_group);
	              return end_bucket.push({
	                format: format,
	                value: function() {
	                  return end_str;
	                }
	              });
	            }
	          };
	        })(this);
	        for (j = 0, len = fs.length; j < len; j++) {
	          format = fs[j];
	          process(format);
	        }
	        global_first = true;
	        fold = function(array, skip_pre) {
	          var k, len1, local_first, ref, section, str;
	          local_first = true;
	          str = '';
	          ref = array.sort(function(a, b) {
	            return a.format.slot - b.format.slot;
	          });
	          for (k = 0, len1 = ref.length; k < len1; k++) {
	            section = ref[k];
	            if (!global_first) {
	              if (local_first && skip_pre) {
	                str += ' ';
	              } else {
	                str += section.format.pre;
	              }
	            }
	            str += section.value();
	            global_first = false;
	            local_first = false;
	          }
	          return str;
	        };
	        return fold(common_bucket);
	      };
	
	      Twix.prototype._iterateHelper = function(period, iter, hasNext, intervalAmount) {
	        return {
	          next: function() {
	            var val;
	            if (!hasNext()) {
	              return null;
	            } else {
	              val = iter.clone();
	              iter.add(intervalAmount, period);
	              return val;
	            }
	          },
	          hasNext: hasNext
	        };
	      };
	
	      Twix.prototype._prepIterateInputs = function() {
	        var inputs, intervalAmount, minHours, period, ref, ref1;
	        inputs = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	        if (typeof inputs[0] === 'number') {
	          return inputs;
	        }
	        if (typeof inputs[0] === 'string') {
	          period = inputs.shift();
	          intervalAmount = (ref = inputs.pop()) != null ? ref : 1;
	          if (inputs.length) {
	            minHours = (ref1 = inputs[0]) != null ? ref1 : false;
	          }
	        }
	        if (moment.isDuration(inputs[0])) {
	          period = 'ms';
	          intervalAmount = inputs[0].as(period);
	        }
	        return [intervalAmount, period, minHours];
	      };
	
	      Twix.prototype._inner = function(period, intervalAmount) {
	        var durationCount, durationPeriod, end, modulus, start;
	        if (period == null) {
	          period = 'ms';
	        }
	        if (intervalAmount == null) {
	          intervalAmount = 1;
	        }
	        start = this.start();
	        end = this._displayEnd.clone();
	        if (start > start.clone().startOf(period)) {
	          start.startOf(period).add(intervalAmount, period);
	        }
	        if (end < end.clone().endOf(period)) {
	          end.startOf(period);
	        }
	        durationPeriod = start.twix(end).asDuration(period);
	        durationCount = durationPeriod.get(period);
	        modulus = durationCount % intervalAmount;
	        end.subtract(modulus, period);
	        return [start, end];
	      };
	
	      Twix.prototype._mutated = function() {
	        this._start = this.allDay ? this._oStart.clone().startOf('d') : this._oStart;
	        this._lastMilli = this.allDay ? this._oEnd.clone().endOf('d') : this._oEnd;
	        this._end = this.allDay ? this._oEnd.clone().startOf('d') : this._oEnd;
	        return this._displayEnd = this.allDay ? this._end.clone().add(1, 'd') : this._end;
	      };
	
	      return Twix;
	
	    })();
	    Twix._extend(moment.locale(), {
	      _twix: Twix.defaults
	    });
	    Twix.formatTemplate = function(leftSide, rightSide) {
	      return leftSide + " - " + rightSide;
	    };
	    moment.twix = function() {
	      return (function(func, args, ctor) {
	        ctor.prototype = func.prototype;
	        var child = new ctor, result = func.apply(child, args);
	        return Object(result) === result ? result : child;
	      })(Twix, arguments, function(){});
	    };
	    moment.fn.twix = function() {
	      return (function(func, args, ctor) {
	        ctor.prototype = func.prototype;
	        var child = new ctor, result = func.apply(child, args);
	        return Object(result) === result ? result : child;
	      })(Twix, [this].concat(slice.call(arguments)), function(){});
	    };
	    moment.fn.forDuration = function(duration, allDay) {
	      return new Twix(this, this.clone().add(duration), allDay);
	    };
	    if (moment.duration.fn) {
	      moment.duration.fn.afterMoment = function(startingTime, allDay) {
	        return new Twix(startingTime, moment(startingTime).clone().add(this), allDay);
	      };
	      moment.duration.fn.beforeMoment = function(startingTime, allDay) {
	        return new Twix(moment(startingTime).clone().subtract(this), startingTime, allDay);
	      };
	    }
	    moment.twixClass = Twix;
	    return Twix;
	  };
	
	  if (hasModule) {
	    return module.exports = makeTwix(__webpack_require__(1));
	  }
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(moment) {
	      return makeTwix(moment);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	
	  if (this.moment) {
	    this.Twix = makeTwix(this.moment);
	  } else if (typeof moment !== "undefined" && moment !== null) {
	    this.Twix = makeTwix(moment);
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _freeze = __webpack_require__(68);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a function that always returns the supplied value.
	 *
	 * Useful for replacing an object outright rather than merging it.
	 *
	 * @function
	 * @sig a -> (* -> a)
	 * @memberOf u
	 * @param  {*} value what to return from returned function.
	 * @return {function} a new function that will always return value.
	 *
	 * @example
	 * var alwaysFour = u.constant(4);
	 * expect(alwaysFour(32)).toEqual(4);
	 *
	 * @example
	 * var user = {
	 *   name: 'Mitch',
	 *   favorites: {
	 *     band: 'Nirvana',
	 *     movie: 'The Matrix'
	 *   }
	 * };
	 *
	 * var newFavorites = {
	 *   band: 'Coldplay'
	 * };
	 *
	 * var result = u({ favorites: u.constant(newFavorites) }, user);
	 *
	 * expect(result).toEqual({ name: 'Mitch', favorites: { band: 'Coldplay' } });
	 */
	function constant(value) {
	  var frozen = (0, _freeze2.default)(value);
	  return function () {
	    return frozen;
	  };
	}
	
	exports.default = constant;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ifElse = __webpack_require__(221);
	
	var _ifElse2 = _interopRequireDefault(_ifElse);
	
	var _curry = __webpack_require__(29);
	
	var _curry2 = _interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _curry2.default)(function (predicate, trueUpdates, object) {
	  return (0, _ifElse2.default)(predicate, trueUpdates, function (x) {
	    return x;
	  }, object);
	});

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _constant = __webpack_require__(434);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _freeze = __webpack_require__(68);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _is = __webpack_require__(437);
	
	var _is2 = _interopRequireDefault(_is);
	
	var _if2 = __webpack_require__(435);
	
	var _if3 = _interopRequireDefault(_if2);
	
	var _ifElse = __webpack_require__(221);
	
	var _ifElse2 = _interopRequireDefault(_ifElse);
	
	var _map = __webpack_require__(222);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _omit = __webpack_require__(438);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _reject = __webpack_require__(439);
	
	var _reject2 = _interopRequireDefault(_reject);
	
	var _update = __webpack_require__(38);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _updateIn = __webpack_require__(440);
	
	var _updateIn2 = _interopRequireDefault(_updateIn);
	
	var _withDefault = __webpack_require__(441);
	
	var _withDefault2 = _interopRequireDefault(_withDefault);
	
	var _curry = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var u = _update2.default;
	
	u._ = _curry._;
	u.constant = _constant2.default;
	u.if = _if3.default;
	u.ifElse = _ifElse2.default;
	u.is = _is2.default;
	u.freeze = _freeze2.default;
	u.map = _map2.default;
	u.omit = _omit2.default;
	u.reject = _reject2.default;
	u.update = _update2.default;
	u.updateIn = _updateIn2.default;
	u.withDefault = _withDefault2.default;
	
	module.exports = u;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _splitPath = __webpack_require__(223);
	
	var _splitPath2 = _interopRequireDefault(_splitPath);
	
	var _curry = __webpack_require__(29);
	
	var _curry2 = _interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function is(path, predicate, object) {
	  var parts = (0, _splitPath2.default)(path);
	
	  var rest = object;
	  for (var i = 0; i < parts.length; ++i) {
	    if (typeof rest === 'undefined') return false;
	    var part = parts[i];
	    rest = rest[part];
	  }
	
	  if (typeof predicate === 'function') {
	    return predicate(rest);
	  }
	
	  return predicate === rest;
	}
	
	exports.default = (0, _curry2.default)(is);

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _omit2 = __webpack_require__(293);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _wrap = __webpack_require__(39);
	
	var _wrap2 = _interopRequireDefault(_wrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function omit(predicate, collection) {
	  return (0, _omit3.default)(collection, predicate);
	}
	
	exports.default = (0, _wrap2.default)(omit);

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reject2 = __webpack_require__(111);
	
	var _reject3 = _interopRequireDefault(_reject2);
	
	var _wrap = __webpack_require__(39);
	
	var _wrap2 = _interopRequireDefault(_wrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function reject(predicate, collection) {
	  return (0, _reject3.default)(collection, predicate);
	}
	
	exports.default = (0, _wrap2.default)(reject);

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _curry = __webpack_require__(29);
	
	var _curry2 = _interopRequireDefault(_curry);
	
	var _update2 = __webpack_require__(38);
	
	var _update3 = _interopRequireDefault(_update2);
	
	var _map = __webpack_require__(222);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _splitPath = __webpack_require__(223);
	
	var _splitPath2 = _interopRequireDefault(_splitPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var wildcard = '*';
	
	function reducePath(acc, key) {
	  if (key === wildcard) {
	    return function (value) {
	      return Object.prototype.hasOwnProperty.call(value, wildcard) ?
	      // If we actually have wildcard as a property, update that
	      (0, _update3.default)(_defineProperty({}, wildcard, acc), value) :
	      // Otherwise map over all properties
	      (0, _map2.default)(acc, value);
	    };
	  }
	
	  return _defineProperty({}, key, acc);
	}
	
	function updateIn(path, value, object) {
	  var parts = (0, _splitPath2.default)(path);
	  var updates = parts.reduceRight(reducePath, value);
	
	  return (0, _update3.default)(updates, object);
	}
	
	exports.default = (0, _curry2.default)(updateIn);

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _update = __webpack_require__(38);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _curry = __webpack_require__(29);
	
	var _curry2 = _interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function withDefault(defaultValue, updates, object) {
	  if (typeof object === 'undefined') {
	    return (0, _update2.default)(updates, defaultValue);
	  }
	
	  return (0, _update2.default)(updates, object);
	}
	
	exports.default = (0, _curry2.default)(withDefault);

/***/ },
/* 442 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 443 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _chat_list_item = __webpack_require__(910);
	
	var _chat_list_item2 = _interopRequireDefault(_chat_list_item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatListSegment = function (_React$Component) {
	  _inherits(ChatListSegment, _React$Component);
	
	  function ChatListSegment(props) {
	    _classCallCheck(this, ChatListSegment);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatListSegment).call(this, props));
	
	    _this.state = {
	      toggled: true
	    };
	    return _this;
	  }
	
	  _createClass(ChatListSegment, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({ toggled: !this.state.toggled });
	    }
	  }, {
	    key: 'renderCarret',
	    value: function renderCarret() {
	      if (this.state.toggled) {
	        return _react2.default.createElement('i', { className: 'rc-icon-caret-down' });
	      } else {
	        return _react2.default.createElement('i', { className: 'rc-icon-caret-right' });
	      }
	    }
	  }, {
	    key: 'renderSegmentHeader',
	    value: function renderSegmentHeader() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'chat-list-segment-header', onClick: this.toggle.bind(this) },
	        this.renderCarret(),
	        _react2.default.createElement(
	          'span',
	          null,
	          this.props.label
	        )
	      );
	    }
	  }, {
	    key: 'renderList',
	    value: function renderList(list, _ref) {
	      var _this2 = this;
	
	      var hasIndicator = _ref.hasIndicator;
	
	      if (list && list.size > 0) {
	        return list.map(function (item) {
	          var id = item.get('uid') || item.get('key');
	
	          return _react2.default.createElement(_chat_list_item2.default, {
	            key: id,
	            id: id,
	            item: item,
	            hasIndicator: hasIndicator,
	            conversationType: _this2.props.conversationType,
	            shouldForceHideRatings: _this2.props.shouldForceHideRatings,
	            shouldShowUnreadMessageCount: _this2.props.shouldShowUnreadMessageCount });
	        }).toArray();
	      }
	    }
	  }, {
	    key: 'renderEmptyMessage',
	    value: function renderEmptyMessage(list, emptyMessage) {
	      if (emptyMessage && list && list.size === 0) {
	        return _react2.default.createElement(
	          'em',
	          { style: { display: 'inline-block', fontStyle: 'italic', fontSize: 12, textAlign: 'center', width: '100%', padding: 5, color: '#C0C0C0' } },
	          emptyMessage
	        );
	      }
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      if (this.state.toggled) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'segment-body' },
	          this.renderEmptyMessage(this.props.list, this.props.emptyMessage),
	          this.renderList(this.props.list, { hasIndicator: this.props.hasListItemIndicator })
	        );
	      }
	    }
	  }, {
	    key: 'renderFooter',
	    value: function renderFooter() {
	      if (this.props.footer) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'chat-list-segment-footer' },
	          this.props.footer
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.list) {
	        if (this.state.toggled) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'chat-list-segment' },
	            this.renderSegmentHeader(),
	            this.renderBody(),
	            this.renderFooter()
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { className: 'chat-list-segment closed' },
	            this.renderSegmentHeader(),
	            this.renderBody(),
	            this.renderFooter()
	          );
	        }
	      } else {
	        return false;
	      }
	    }
	  }]);
	
	  return ChatListSegment;
	}(_react2.default.Component);
	
	ChatListSegment.defaultProps = {
	  label: 'Chat List Segment',
	  hasListItemIndicator: true
	};
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	var ChatListSegmentContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatListSegment);
	
	exports.default = ChatListSegmentContainer;

/***/ },
/* 445 */,
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SortableColumn = function (_React$Component) {
	  _inherits(SortableColumn, _React$Component);
	
	  function SortableColumn(props) {
	    _classCallCheck(this, SortableColumn);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SortableColumn).call(this, props));
	
	    _this.state = {
	      name: _this.props.name,
	      order: _this.props.order
	    };
	    return _this;
	  }
	
	  _createClass(SortableColumn, [{
	    key: 'onSortClick',
	    value: function onSortClick() {
	      this.props.onSortChange(this.state.name, this.state.order);
	
	      var order = this.state.order === 'desc' ? 'asc' : 'desc';
	      this.setState({ order: order });
	    }
	  }, {
	    key: 'renderOrderIndicator',
	    value: function renderOrderIndicator() {
	      if (this.state.order === 'desc') {
	        return _react2.default.createElement('i', { className: 'sort-icon rc-icon-caret-down' });
	      } else {
	        return _react2.default.createElement('i', { className: 'sort-icon rc-icon-caret-up' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        {
	          className: 'sortable-column',
	          onClick: this.onSortClick.bind(this) },
	        this.props.children || this.props.label || this.state.name,
	        this.renderOrderIndicator()
	      );
	    }
	  }]);
	
	  return SortableColumn;
	}(_react2.default.Component);
	
	SortableColumn.defaultProps = {
	  name: '',
	  order: 'desc',
	  onSortChange: function onSortChange() {}
	};
	
	exports.default = SortableColumn;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (schedule, uid) {
	  return { type: _action_types.SET_USER_SCHEDULE, schedule: schedule, uid: uid };
	};

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (users, currentUser) {
	  return { type: _action_types.SET_USERS, users: users, currentUser: currentUser };
	};

/***/ },
/* 449 */,
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (time) {
	  if (!_moment2.default.isMoment(time)) time = (0, _moment2.default)(time);
	
	  return time.format('MMM DD');
	};

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (uid, startTime, endTime, entryType) {
	  var typeKey = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
	  var payload = arguments.length <= 5 || arguments[5] === undefined ? null : arguments[5];
	
	  if (!uid || !startTime || !endTime || !entryType) return;
	
	  var ENDPOINT = _constants.SCHEDULES_ENDPOINT + '/' + uid;
	
	  var obj = {
	    type: entryType,
	    startTime: startTime,
	    endTime: endTime,
	    typeKey: typeKey,
	    payload: payload
	  };
	
	  var ref = _firedux2.default.ref.child(ENDPOINT).push({});
	
	  return ref.setWithPriority(obj, endTime);
	};

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchUserSchedule = exports.watchUserSchedule = undefined;
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_user_schedule = __webpack_require__(447);
	
	var _set_user_schedule2 = _interopRequireDefault(_set_user_schedule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onUserSchedule = function onUserSchedule(snapshot) {
	  if (snapshot.exists()) (0, _store.dispatch)((0, _set_user_schedule2.default)(snapshot.val(), snapshot.key()));else (0, _store.dispatch)((0, _set_user_schedule2.default)({}, snapshot.key()));
	};
	
	var ref = void 0;
	
	var watchUserSchedule = exports.watchUserSchedule = function watchUserSchedule(uid) {
	  var startTime = arguments.length <= 1 || arguments[1] === undefined ? (0, _moment2.default)().valueOf() : arguments[1];
	  var endTime = arguments[2];
	
	  if (!uid) return;
	
	  if (!endTime) endTime = (0, _moment2.default)().add(3, 'month').endOf('day').valueOf();
	
	  var ENDPOINT = _constants.SCHEDULES_ENDPOINT + '/' + uid;
	
	  ref = _firedux2.default.ref.child(ENDPOINT).orderByPriority().startAt(startTime).endAt(endTime);
	
	  ref.on('value', onUserSchedule);
	};
	
	var unwatchUserSchedule = exports.unwatchUserSchedule = function unwatchUserSchedule() {
	  if (!ref) return;
	
	  ref.off('value', onUserSchedule);
	};

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(5);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _accept_session_request = __webpack_require__(669);
	
	var _accept_session_request2 = _interopRequireDefault(_accept_session_request);
	
	var _dismiss_session_request = __webpack_require__(674);
	
	var _dismiss_session_request2 = _interopRequireDefault(_dismiss_session_request);
	
	var _close_modal = __webpack_require__(46);
	
	var _close_modal2 = _interopRequireDefault(_close_modal);
	
	var _modal_view = __webpack_require__(47);
	
	var _modal_view2 = _interopRequireDefault(_modal_view);
	
	var _go_to_session_button = __webpack_require__(337);
	
	var _go_to_session_button2 = _interopRequireDefault(_go_to_session_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SessionRequestModal = function (_React$Component) {
	  _inherits(SessionRequestModal, _React$Component);
	
	  function SessionRequestModal(props) {
	    _classCallCheck(this, SessionRequestModal);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SessionRequestModal).call(this, props));
	
	    _this.acceptRequest = _this.acceptRequest.bind(_this);
	    _this.dismissRequest = _this.dismissRequest.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(SessionRequestModal, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var sessionRequest = this.props.sessionRequest;
	      var nextSessionRequest = nextProps.sessionRequest;
	
	
	      if (sessionRequest && !nextSessionRequest) {
	        this.closeModal();
	      }
	    }
	  }, {
	    key: 'isSessionGoodToGo',
	    value: function isSessionGoodToGo(status, length) {
	      var BOOKED = _constants.SESSION_STATUSES.BOOKED;
	      var COMPLETED = _constants.SESSION_STATUSES.COMPLETED;
	
	
	      if (status === BOOKED && length === _constants.PAY_AS_YOU_GO_VALUE) return true;
	      if (status > BOOKED && status < COMPLETED) return true;
	
	      return false;
	    }
	  }, {
	    key: 'acceptRequest',
	    value: function acceptRequest(e) {
	      if (e) e.preventDefault();
	
	      this.props.onAcceptRequest(this.props.sessionRequest.get('expert'), this.props.sessionRequest.get('user'), this.props.sessionRequest.get('sessionLength'));
	    }
	  }, {
	    key: 'dismissRequest',
	    value: function dismissRequest(e) {
	      if (e) e.preventDefault();
	
	      this.props.onDismissRequest(this.props.sessionRequest.get('expert'), this.props.sessionRequest.get('user'));
	
	      this.closeModal(e);
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal(e) {
	      if (e) e.preventDefault();
	
	      this.props.onCloseModal(this.props.modalKey);
	    }
	  }, {
	    key: 'renderJustAcceptedMessage',
	    value: function renderJustAcceptedMessage() {
	      return _react2.default.createElement(
	        'p',
	        null,
	        'You have accepted this session request from ',
	        this.props.userName,
	        '.',
	        _react2.default.createElement('br', null),
	        'Give user a moment to complete payout steps.'
	      );
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      if (this.props.currentSessionRef && this.props.currentSession) {
	        var status = this.props.currentSession.get('status');
	        var sessionLength = this.props.currentSession.get('sessionLength');
	
	        if (status === _constants.SESSION_STATUSES.COMPLETED) {
	          return _react2.default.createElement(
	            'p',
	            null,
	            'Your session with ',
	            this.props.userName,
	            ' is ended.',
	            _react2.default.createElement('br', null)
	          );
	        } else if (this.isSessionGoodToGo(status, sessionLength)) {
	          return _react2.default.createElement(
	            'p',
	            null,
	            'Your session with ',
	            this.props.userName,
	            ' is good to go.',
	            _react2.default.createElement('br', null),
	            'Go to your session now.'
	          );
	        } else if (status <= _constants.SESSION_STATUSES.REQUESTED_CANCEL) {
	          return _react2.default.createElement(
	            'p',
	            null,
	            'Your session with ',
	            this.props.userName,
	            ' is cancelled.',
	            _react2.default.createElement('br', null)
	          );
	        } else if (this.props.sessionRequest.get('status') === _constants.SESSION_REQUEST_STATUSES.ACCEPTED) {
	          return this.renderJustAcceptedMessage();
	        }
	      } else if (this.props.sessionRequest.get('status') === _constants.SESSION_REQUEST_STATUSES.ACCEPTED) {
	        return this.renderJustAcceptedMessage();
	      } else if (this.props.sessionRequest.get('status') === _constants.SESSION_REQUEST_STATUSES.REQUESTED) {
	        return _react2.default.createElement(
	          'p',
	          null,
	          'User ',
	          this.props.userName,
	          ' has just requested an immediate session with you.',
	          _react2.default.createElement('br', null),
	          'Press accept to initiate this session now.'
	        );
	      } else if (this.props.sessionRequest.get('status') === _constants.SESSION_REQUEST_STATUSES.TIMEDOUT) {
	        return _react2.default.createElement(
	          'p',
	          null,
	          'You have just missed an immediate session request from ',
	          this.props.userName,
	          '.'
	        );
	      }
	    }
	  }, {
	    key: 'renderActions',
	    value: function renderActions() {
	      if (this.props.currentSessionRef && this.props.currentSession) {
	        var status = this.props.currentSession.get('status');
	        var sessionLength = this.props.currentSession.get('sessionLength');
	
	        if (status === _constants.SESSION_STATUSES.COMPLETED) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'actions right' },
	            _react2.default.createElement(
	              'div',
	              { className: 'cancel button default', onClick: this.closeModal },
	              'Close'
	            )
	          );
	        } else if (this.isSessionGoodToGo(status, sessionLength)) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'actions right' },
	            _react2.default.createElement(_go_to_session_button2.default, { sessionId: this.props.currentSessionRef }),
	            _react2.default.createElement(
	              'div',
	              { className: 'cancel button default', onClick: this.closeModal },
	              'Close'
	            )
	          );
	        } else if (status <= _constants.SESSION_STATUSES.REQUESTED_CANCEL) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'actions right' },
	            _react2.default.createElement(
	              'div',
	              { className: 'cancel button default', onClick: this.closeModal },
	              'Close'
	            )
	          );
	        }
	      } else if (this.props.sessionRequest.get('status') === _constants.SESSION_REQUEST_STATUSES.REQUESTED) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'actions right' },
	          _react2.default.createElement(
	            'div',
	            { className: 'accept button success', onClick: this.acceptRequest },
	            'Accept'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'cancel button default', onClick: this.dismissRequest },
	            'Dismiss'
	          )
	        );
	      } else if (this.props.sessionRequest.get('status') === _constants.SESSION_REQUEST_STATUSES.TIMEDOUT) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'actions right' },
	          _react2.default.createElement(
	            'div',
	            { className: 'cancel button default', onClick: this.closeModal },
	            'Close'
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderModalContent',
	    value: function renderModalContent() {
	      if (this.props.sessionRequest && this.props.userName) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-header' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Session Request from ',
	              this.props.userName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-body' },
	            this.renderBody()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-footer' },
	            this.renderActions()
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _modal_view2.default,
	        { isActive: true, onClose: this.onClose },
	        this.renderModalContent()
	      );
	    }
	  }]);
	
	  return SessionRequestModal;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  // TODO: remove this after turning users object in to full map at reducer.
	  var user = state.getIn(['users', ownProps.sessionRequest.get('user')]);
	  var userName = void 0;
	
	  if (user) {
	    userName = _immutable.Map.isMap(user) ? user.get('name') : user.name;
	  }
	
	  var sessionRequest = state.getIn(['sessions', '_requests', ownProps.sessionRequest.get('user')]);
	  var currentSessionRef = sessionRequest ? sessionRequest.get('sessionId') : null;
	  var currentSession = void 0;
	
	  if (currentSessionRef) {
	    currentSession = state.getIn(['sessions', 'experts', currentSessionRef]);
	  }
	
	  return {
	    userName: userName,
	    sessionRequest: sessionRequest,
	    currentSessionRef: currentSessionRef,
	    currentSession: currentSession
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onAcceptRequest: _accept_session_request2.default,
	    onDismissRequest: _dismiss_session_request2.default,
	    onCloseModal: function onCloseModal(modalKey) {
	      return dispatch((0, _close_modal2.default)(modalKey));
	    }
	  };
	};
	
	var SessionRequestModalContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SessionRequestModal);
	
	exports.default = SessionRequestModalContainer;

/***/ },
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(109),
	    isArrayLike = __webpack_require__(32),
	    isIndex = __webpack_require__(49),
	    isObject = __webpack_require__(18);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(564);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the new array of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _embedJs = __webpack_require__(741);
	
	var _embedJs2 = _interopRequireDefault(_embedJs);
	
	var _dev = __webpack_require__(40);
	
	var _dev2 = _interopRequireDefault(_dev);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RichMediaContainer = _react2.default.createClass({
	  displayName: 'RichMediaContainer',
	  getInitialState: function getInitialState() {
	    return {
	      embedContent: ''
	    };
	  },
	
	
	  defaultProps: {
	    content: '',
	    onHeightChange: function onHeightChange() {}
	  },
	
	  propTypes: {
	    content: _react2.default.PropTypes.string,
	    onHeightChange: _react2.default.PropTypes.func
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.initiateEmbedder();
	  },
	  componentDidMount: function componentDidMount() {
	    this.performEmbed();
	    this.updateHeightDifference();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.updateHeightDifference();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps() {
	    this.initiateEmbedder();
	    this.performEmbed();
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    if (nextProps.isHidden) return false;
	
	    return true;
	  },
	  initiateEmbedder: function initiateEmbedder() {
	    if (this.props.content && this.props.content.length > 0) {
	      var embedder = new _embedJs2.default({
	        input: this.props.content,
	        googleAuthKey: _dev2.default.googleApiKey,
	        inlineEmbed: ['youtube'],
	        excludeEmbed: ['gist'],
	        videoWidth: '100%',
	        videoDetails: false,
	        linkOptions: { target: '_blank' }
	      });
	      this.setState({ embedder: embedder });
	    }
	  },
	  updateHeightDifference: function updateHeightDifference() {
	    var _this = this;
	
	    var imageEls = this.refs.mediaContainer.querySelectorAll('img');
	
	    // wait for image load.
	    if (imageEls.length > 0 && !this.state.hasImageLoaded) {
	      var _ret = function () {
	        var el = imageEls[0];
	        el.style.display = 'none';
	
	        el.onload = function () {
	          _this.updateHeightDifference();
	          el.style.display = '';
	          _this.setState({ hasImageLoaded: true });
	        };
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	    }
	
	    var currentHeight = this.refs.mediaContainer.offsetHeight;
	
	    if (currentHeight === 0) return;
	
	    if (this.state.prevHeight) {
	      if (currentHeight !== this.state.prevHeight) {
	        var difference = currentHeight - this.state.prevHeight;
	
	        this.props.onHeightChange(difference, this.state.prevHeight, currentHeight);
	        this.setState({ prevHeight: currentHeight });
	      }
	    } else {
	      this.setState({ prevHeight: currentHeight });
	    }
	  },
	  performEmbed: function performEmbed() {
	    var _this2 = this;
	
	    if (this.state.embedder) {
	      this.state.embedder.text(function (embedContent) {
	        return _this2.setState({ embedContent: embedContent });
	      });
	    }
	  },
	  richContentMarkup: function richContentMarkup() {
	    return { __html: this.state.embedContent };
	  },
	  render: function render() {
	    if (this.state.embedContent.length > 0) {
	      return _react2.default.createElement('div', { ref: 'mediaContainer', className: 'rich-media-embed', dangerouslySetInnerHTML: this.richContentMarkup() });
	    } else {
	      return _react2.default.createElement(
	        'div',
	        { ref: 'mediaContainer', className: 'rich-media-embed' },
	        this.props.content
	      );
	    }
	  }
	});
	
	// function createContainer (Component) {
	//   let ComponentFactory = React.createFactory(Component);
	//
	//   // Higher order component here.
	// }
	
	exports.default = RichMediaContainer;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(7);
	
	var _intersection = __webpack_require__(751);
	
	var _intersection2 = _interopRequireDefault(_intersection);
	
	var _send_new_message = __webpack_require__(681);
	
	var _send_new_message2 = _interopRequireDefault(_send_new_message);
	
	var _request_signin = __webpack_require__(266);
	
	var _request_signin2 = _interopRequireDefault(_request_signin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConversationActions = function (_React$Component) {
	  _inherits(ConversationActions, _React$Component);
	
	  function ConversationActions(props) {
	    _classCallCheck(this, ConversationActions);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConversationActions).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ConversationActions, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.focusInputElement();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var prevLastOpenTime = prevProps.lastOpenTime;
	      var lastOpenTime = this.props.lastOpenTime;
	
	
	      if (!prevLastOpenTime && lastOpenTime || lastOpenTime > prevLastOpenTime) {
	        this.focusInputElement();
	      }
	    }
	  }, {
	    key: 'focusInputElement',
	    value: function focusInputElement() {
	      var inputDOM = _reactDom2.default.findDOMNode(this.refs.input);
	      if (inputDOM) setTimeout(function () {
	        return inputDOM.focus();
	      }, 0);
	    }
	  }, {
	    key: 'doesIncludeStopWord',
	    value: function doesIncludeStopWord(message) {
	      if (!this.props.stopWords) return false;
	      if (this.props.stopWords.length === 0) return false;
	
	      var messageWordsArr = message.replace(/\W+/g, ' ').match(/[^ ]+/g);
	      var stopWordsArr = this.props.stopWords.split(/\,\s+/g);
	
	      if ((0, _intersection2.default)(stopWordsArr, messageWordsArr).length > 0) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'shouldShowSigninAction',
	    value: function shouldShowSigninAction() {
	      if (!this.props.currentUser) return true;
	    }
	  }, {
	    key: 'canTypeNewMessage',
	    value: function canTypeNewMessage() {
	      if (!this.props.currentUser) return false;
	      if (!this.props.to && !this.props.otherUser) return false;
	      if (!this.props.isActive) return false;
	
	      return true;
	    }
	  }, {
	    key: 'onInputBlur',
	    value: function onInputBlur() {
	      if (this.props.onNewMessageInputBlur) this.props.onNewMessageInputBlur();
	    }
	  }, {
	    key: 'onInputFocus',
	    value: function onInputFocus() {
	      if (this.props.onNewMessageInputFocus) this.props.onNewMessageInputFocus();
	    }
	  }, {
	    key: 'onNewMessage',
	    value: function onNewMessage(event) {
	      if (event.key === 'Enter' && this.refs.input.value.length > 0) {
	        var message = this.refs.input.value;
	
	        if (this.doesIncludeStopWord(message)) {
	          this.setState({ shouldShowStopWordInformer: true });
	        } else {
	          this.setState({ shouldShowStopWordInformer: false });
	
	          var from = this.props.currentUser.get('uid');
	          var role = this.props.currentUser.get('role');
	          var to = this.props.to || this.props.otherUser.get('uid');
	          var containerId = this.props.conversationContainerId;
	
	          this.props.onNewMessage(message, containerId, from, to, this.props.shouldSendNotification, this.props.messageType, role);
	
	          this.refs.input.value = '';
	        }
	      }
	    }
	  }, {
	    key: 'renderSignInAction',
	    value: function renderSignInAction() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'signin-action-content', onClick: this.props.requestSignin },
	        _react2.default.createElement(
	          'span',
	          { style: { textDecoration: 'underline' } },
	          'Sign in'
	        ),
	        ' to chat.'
	      );
	    }
	  }, {
	    key: 'renderTypeInformer',
	    value: function renderTypeInformer() {
	      if (this.state.shouldShowStopWordInformer) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'type-informer' },
	          'You have used a banned word. Please remove it.'
	        );
	      }
	    }
	  }, {
	    key: 'renderInnerContent',
	    value: function renderInnerContent() {
	      return _react2.default.createElement('input', { type: 'text',
	        ref: 'input',
	        className: 'conversation-message-input',
	        placeholder: 'Type your message',
	        onBlur: this.onInputBlur.bind(this),
	        onFocus: this.onInputFocus.bind(this),
	        onKeyDown: this.onNewMessage.bind(this) });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.shouldShowSigninAction()) {
	        return _react2.default.createElement(
	          'div',
	          { ref: 'conversationActions', className: 'conversation-actions signin', style: { height: this.props.height } },
	          this.renderSignInAction()
	        );
	      }
	      if (this.props.warningMessage) {
	        return _react2.default.createElement(
	          'div',
	          { ref: 'conversationActions', className: 'conversation-actions warning', style: { height: this.props.height } },
	          this.props.warningMessage
	        );
	      }
	      if (this.canTypeNewMessage()) {
	        return _react2.default.createElement(
	          'div',
	          { ref: 'conversationActions', className: 'conversation-actions', style: { height: this.props.height } },
	          this.renderTypeInformer(),
	          this.renderInnerContent()
	        );
	      } else {
	        return _react2.default.createElement('div', { ref: 'conversationActions', className: 'conversation-actions disabled', style: { height: this.props.height } });
	      }
	    }
	  }]);
	
	  return ConversationActions;
	}(_react2.default.Component);
	
	ConversationActions.defaultProps = {
	  height: 41
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    currentUser: state.get('currentUser'),
	    stopWords: state.getIn(['chatSettings', 'stopWords']),
	    lastOpenTime: state.getIn(['conversations', '_lastOpenTimes', ownProps.conversationContainerId])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    onNewMessage: _send_new_message2.default,
	    requestSignin: _request_signin2.default
	  };
	};
	
	var ConversationActionsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConversationActions);
	
	exports.default = ConversationActionsContainer;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _previous_messages = __webpack_require__(662);
	
	var _previous_messages2 = _interopRequireDefault(_previous_messages);
	
	var _remove_previous_messages = __webpack_require__(654);
	
	var _remove_previous_messages2 = _interopRequireDefault(_remove_previous_messages);
	
	var _new_messages = __webpack_require__(691);
	
	var _is_user_moderator = __webpack_require__(240);
	
	var _is_user_moderator2 = _interopRequireDefault(_is_user_moderator);
	
	var _is_message_owned_by_user = __webpack_require__(502);
	
	var _is_message_owned_by_user2 = _interopRequireDefault(_is_message_owned_by_user);
	
	var _scroller = __webpack_require__(649);
	
	var _scroller2 = _interopRequireDefault(_scroller);
	
	var _messages_list = __webpack_require__(647);
	
	var _messages_list2 = _interopRequireDefault(_messages_list);
	
	var _inline_notification = __webpack_require__(642);
	
	var _inline_notification2 = _interopRequireDefault(_inline_notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MESSAGE_UPDATE_CONCERNS = {
	  HISTORY: -1,
	  INITIAL: 0,
	  NEW: 1
	};
	
	var ConversationContent = function (_React$Component) {
	  _inherits(ConversationContent, _React$Component);
	
	  function ConversationContent(props) {
	    _classCallCheck(this, ConversationContent);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConversationContent).call(this, props));
	
	    _this.state = {};
	
	    _this.onMessageItemHeightChange = _this.onMessageItemHeightChange.bind(_this);
	    _this.onScrollConcernChange = _this.onScrollConcernChange.bind(_this);
	    _this.scrollToBottom = _this.scrollToBottom.bind(_this);
	    return _this;
	  }
	
	  _createClass(ConversationContent, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.isDisabled) {
	        this.props.onContentLoaded(this.props.conversationContainerId, this.props.shouldLoadPreviousMessages, this.props.historyBatchLimit);
	      }
	
	      if (this.props.messages && this.props.messages.size > 0) {
	        this.setMessageUpdateSideEffects(this.props.messages);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _immutable.is)(this.props.messages, nextProps.messages)) {
	        this.setMessageUpdateSideEffects(nextProps.messages);
	      }
	
	      if (!nextProps.isDisabled && nextProps.conversationContainerId !== this.props.conversationContainerId) {
	        this.props.onContentUpdated(nextProps.conversationContainerId, this.props.conversationContainerId, this.props.shouldLoadPreviousMessages, this.props.historyBatchLimit);
	      }
	
	      if (this.props.isDisabled && !nextProps.isDisabled) {
	        this.props.onContentLoaded(nextProps.conversationContainerId, nextProps.shouldLoadPreviousMessages, nextProps.historyBatchLimit);
	      } else if (!this.props.isDisabled && nextProps.isDisabled) {
	        this.props.onContentUnloaded(this.props.conversationContainerId);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onContentUnloaded(this.props.conversationContainerId);
	    }
	  }, {
	    key: 'shouldLoadHistory',
	    value: function shouldLoadHistory(scrollConcern) {
	      return this.props.shouldLoadHistoryMessages && scrollConcern === _constants.SCROLL_POS_CONCERNS.TOP;
	    }
	  }, {
	    key: 'shouldPutNewMessageInformer',
	    value: function shouldPutNewMessageInformer(lastMessageTime) {
	      return this.state.scrollConcern !== _constants.SCROLL_POS_CONCERNS.BOTTOM && this.state.lastMessageTime && lastMessageTime > this.state.lastMessageTime;
	    }
	  }, {
	    key: 'setMessageUpdateSideEffects',
	    value: function setMessageUpdateSideEffects(nextMessages) {
	      var firstMessageTime = nextMessages.getIn([0, 'time']);
	      var lastMessageTime = nextMessages.getIn([nextMessages.size - 1, 'time']);
	      lastMessageTime = this.amendLastMessageTimeForModeratedGroups(lastMessageTime, nextMessages);
	
	      var newMessageInformer = false;
	      var updatingScrollConcern = this.getUpdatingScrollConcernForMessageConcern(firstMessageTime, lastMessageTime);
	
	      if (this.shouldPutNewMessageInformer(lastMessageTime)) {
	        newMessageInformer = true;
	      }
	
	      this.setState({ firstMessageTime: firstMessageTime, lastMessageTime: lastMessageTime, updatingScrollConcern: updatingScrollConcern });
	      this.setNewMessageInformer(newMessageInformer);
	    }
	  }, {
	    key: 'getUpdatingScrollConcernForMessageConcern',
	    value: function getUpdatingScrollConcernForMessageConcern(firstMessageTime, lastMessageTime) {
	      var HISTORY = MESSAGE_UPDATE_CONCERNS.HISTORY;
	      var INITIAL = MESSAGE_UPDATE_CONCERNS.INITIAL;
	      var NEW = MESSAGE_UPDATE_CONCERNS.NEW;
	
	      var messageUpdateConcern = this.getMessageUpdateConcern(firstMessageTime, lastMessageTime);
	
	      if (messageUpdateConcern === HISTORY) return _constants.SCROLL_POS_CONCERNS.HISTORY;
	      if (messageUpdateConcern === INITIAL) return _constants.SCROLL_POS_CONCERNS.BOTTOM;
	      if (messageUpdateConcern === NEW) return _constants.SCROLL_POS_CONCERNS.BOTTOM;
	    }
	  }, {
	    key: 'getMessageUpdateConcern',
	    value: function getMessageUpdateConcern(firstMessageTime, lastMessageTime) {
	      var HISTORY = MESSAGE_UPDATE_CONCERNS.HISTORY;
	      var INITIAL = MESSAGE_UPDATE_CONCERNS.INITIAL;
	      var NEW = MESSAGE_UPDATE_CONCERNS.NEW;
	
	
	      if (!this.state.firstMessageTime && firstMessageTime) return INITIAL;else if (this.state.firstMessageTime && this.state.firstMessageTime > firstMessageTime) return HISTORY;else if (this.state.lastMessageTime && this.state.lastMessageTime < lastMessageTime) return NEW;
	    }
	  }, {
	    key: 'amendLastMessageTimeForModeratedGroups',
	    value: function amendLastMessageTimeForModeratedGroups(lastMessageTime, nextMessages) {
	      if (this.props.messageType !== _constants.MESSAGE_TYPES.MODERATED_GROUP) return lastMessageTime;
	      if (this.props.currentUser && (0, _is_user_moderator2.default)(this.props.currentUser.get('role'))) return lastMessageTime;
	
	      var lastMessage = nextMessages.last();
	      if (this.props.currentUser && (0, _is_message_owned_by_user2.default)(lastMessage.get('from'), this.props.currentUser.get('uid'))) {
	        return lastMessageTime;
	      }
	
	      var lastApprovedMessage = nextMessages.findLast(function (m) {
	        return m.get('approvalStatus') === _constants.MESSAGE_APPROVAL_STATUSES.APPROVED;
	      });
	
	      if (lastApprovedMessage) lastMessageTime = lastApprovedMessage.get('time');
	
	      return lastMessageTime;
	    }
	  }, {
	    key: 'setScrollConcern',
	    value: function setScrollConcern(scrollConcern) {
	      this.setState({ scrollConcern: scrollConcern });
	
	      if (scrollConcern === _constants.SCROLL_POS_CONCERNS.BOTTOM) {
	        this.setNewMessageInformer(false);
	      }
	
	      if (scrollConcern === this.state.updatingScrollConcern || this.state.updatingScrollConcern === _constants.SCROLL_POS_CONCERNS.HISTORY) {
	        this.setState({ updatingScrollConcern: null });
	      }
	    }
	  }, {
	    key: 'setNewMessageInformer',
	    value: function setNewMessageInformer(newMessageInformer) {
	      if (newMessageInformer !== this.state.newMessageInformer) {
	        this.setState({ newMessageInformer: newMessageInformer });
	      }
	    }
	  }, {
	    key: 'getPreviousMessages',
	    value: function getPreviousMessages() {
	      this.props.getPreviousMessages(this.props.conversationContainerId, this.props.historyBatchLimit, this.state.firstMessageTime);
	    }
	  }, {
	    key: 'scrollToBottom',
	    value: function scrollToBottom(e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      if (this.state.scrollConcern !== _constants.SCROLL_POS_CONCERNS.BOTTOM) {
	        this.setState({ updatingScrollConcern: _constants.SCROLL_POS_CONCERNS.FORCE_BOTTOM });
	      }
	    }
	  }, {
	    key: 'onMessageItemHeightChange',
	    value: function onMessageItemHeightChange() /* difference */{
	      // TODO: implement scroll adjust behavior here
	    }
	  }, {
	    key: 'onScrollConcernChange',
	    value: function onScrollConcernChange(scrollConcern) {
	      if (this.shouldLoadHistory(scrollConcern)) this.getPreviousMessages();
	
	      this.setScrollConcern(scrollConcern);
	    }
	  }, {
	    key: 'renderInformer',
	    value: function renderInformer() {
	      if (this.state.newMessageInformer) {
	        return _react2.default.createElement(
	          _inline_notification2.default,
	          { onClick: this.scrollToBottom },
	          'New message ',
	          _react2.default.createElement('i', { className: 'rc-icon-arrow-down', style: { marginLeft: 5 } })
	        );
	      }
	    }
	  }, {
	    key: 'renderConversationContent',
	    value: function renderConversationContent() {
	      return _react2.default.createElement(
	        _scroller2.default,
	        {
	          updatingScrollConcern: this.state.updatingScrollConcern,
	          onScrollConcernChange: this.onScrollConcernChange },
	        _react2.default.createElement(_messages_list2.default, {
	          key: 'messagesList',
	          contentMessage: this.props.contentMessage,
	          messages: this.props.messages,
	          messageType: this.props.messageType,
	          containerId: this.props.conversationContainerId,
	          maxBubbleWidth: this.props.maxBubbleWidth,
	          onMessageItemHeightChange: this.onMessageItemHeightChange,
	          isRichMessageContentEnabled: this.props.isRichMessageContentEnabled })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'conversation-content',
	          style: { padding: 0, height: this.props.height, backgroundColor: this.props.backgroundColor } },
	        this.renderInformer(),
	        this.renderConversationContent()
	      );
	    }
	  }]);
	
	  return ConversationContent;
	}(_react2.default.Component);
	
	ConversationContent.defaultProps = {
	  shouldLoadPreviousMessages: true,
	  shouldLoadHistoryMessages: false,
	  historyBatchLimit: null
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    currentUser: state.get('currentUser'),
	    messages: state.getIn(['messages', ownProps.conversationContainerId], (0, _immutable.fromJS)([])),
	    backgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'background'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	  return {
	    onContentLoaded: function onContentLoaded(containerId, shouldLoadPreviousMessages, limit) {
	      if (shouldLoadPreviousMessages) {
	        (0, _previous_messages2.default)(containerId, limit).then(_new_messages.watchNewMessages.bind(null, containerId, ownProps.notificationOptions));
	      } else {
	        (0, _new_messages.watchNewMessages)(containerId, ownProps.notificationOptions);
	      }
	    },
	    onContentUpdated: function onContentUpdated(nextContainerId, containerId, shouldLoadPreviousMessages, limit) {
	      (0, _new_messages.unwatchNewMessages)(containerId);
	      dispatch((0, _remove_previous_messages2.default)(containerId));
	
	      if (shouldLoadPreviousMessages) {
	        (0, _previous_messages2.default)(nextContainerId, limit).then(_new_messages.watchNewMessages.bind(null, nextContainerId, ownProps.notificationOptions));
	      } else {
	        (0, _new_messages.watchNewMessages)(nextContainerId, ownProps.notificationOptions);
	      }
	    },
	    onContentUnloaded: function onContentUnloaded(containerId) {
	      (0, _new_messages.unwatchNewMessages)(containerId);
	      dispatch((0, _remove_previous_messages2.default)(containerId));
	    },
	    getPreviousMessages: _previous_messages2.default
	  };
	};
	
	var ConversationContentContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConversationContent);
	
	exports.default = ConversationContentContainer;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _range = __webpack_require__(461);
	
	var _range2 = _interopRequireDefault(_range);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pagination = function (_React$Component) {
	  _inherits(Pagination, _React$Component);
	
	  function Pagination(props) {
	    _classCallCheck(this, Pagination);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Pagination).call(this, props));
	
	    _this.state = {
	      pageCount: 1,
	      currentPage: _this.props.currentPage || 1
	    };
	    return _this;
	  }
	
	  _createClass(Pagination, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updatePageCount(this.props.total, this.props.limitPerPage);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.updatePageCount(nextProps.total, nextProps.limitPerPage);
	
	      if (nextProps.currentPage && nextProps.currentPage !== this.state.currentPage) {
	        this.setState({ currentPage: nextProps.currentPage });
	      }
	    }
	  }, {
	    key: 'updatePageCount',
	    value: function updatePageCount(total, limit) {
	      var pageCount = Math.ceil(total / limit);
	      this.setState({ pageCount: pageCount });
	    }
	  }, {
	    key: 'onNewPage',
	    value: function onNewPage(e, page) {
	      e.preventDefault();
	
	      this.setState({ currentPage: page });
	
	      this.props.onNewPage(page);
	    }
	  }, {
	    key: 'renderFirstPageItem',
	    value: function renderFirstPageItem() {
	      var _this2 = this;
	
	      if (this.state.currentPage === 1) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'disabled' },
	          _react2.default.createElement(
	            'span',
	            { ariaHidden: 'true' },
	            '«'
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'li',
	          { key: 0 },
	          _react2.default.createElement(
	            'a',
	            { href: '#', ariaLabel: 'Previous', onClick: function onClick(e) {
	                return _this2.onNewPage(e, 1);
	              } },
	            _react2.default.createElement(
	              'span',
	              { ariaHidden: 'true' },
	              '«'
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderLastPageItem',
	    value: function renderLastPageItem() {
	      var _this3 = this;
	
	      if (this.state.currentPage === this.state.pageCount) {
	        return _react2.default.createElement(
	          'li',
	          { key: this.state.pageCount, className: 'disabled' },
	          _react2.default.createElement(
	            'a',
	            { href: '#', ariaLabel: 'Next', onClick: function onClick(e) {
	                return _this3.onNewPage(e, _this3.state.pageCount);
	              } },
	            _react2.default.createElement(
	              'span',
	              { ariaHidden: 'true' },
	              '»'
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'li',
	          { key: this.state.pageCount + 1 },
	          _react2.default.createElement(
	            'a',
	            { href: '#', ariaLabel: 'Next', onClick: function onClick(e) {
	                return _this3.onNewPage(e, _this3.state.pageCount);
	              } },
	            _react2.default.createElement(
	              'span',
	              { ariaHidden: 'true' },
	              '»'
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderPaginationItem',
	    value: function renderPaginationItem(page) {
	      var _this4 = this;
	
	      if (this.state.currentPage === page) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'active' },
	          _react2.default.createElement(
	            'span',
	            { ariaHidden: 'true' },
	            page
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'li',
	          { key: page },
	          _react2.default.createElement(
	            'a',
	            { href: '#', ariaLabel: 'Previous', onClick: function onClick(e) {
	                return _this4.onNewPage(e, page);
	              } },
	            _react2.default.createElement(
	              'span',
	              { ariaHidden: 'true' },
	              page
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'pagination', style: this.props.style },
	        this.renderFirstPageItem(),
	        (0, _range2.default)(1, this.state.pageCount + 1).map(function (page) {
	          return _this5.renderPaginationItem(page);
	        }),
	        this.renderLastPageItem()
	      );
	    }
	  }]);
	
	  return Pagination;
	}(_react2.default.Component);
	
	Pagination.defaultProps = {
	  total: 0,
	  limitPerPage: 1,
	  onNewPage: function onNewPage() {}
	};
	
	exports.default = Pagination;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (user, role, prevRole) {
	  return { type: _action_types.CHANGE_CHAT_LIST_USER_ROLE, user: user, role: role, prevRole: prevRole };
	};

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function () {
	  return { type: _action_types.CLOSE_ALL_MODALS };
	};

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (uid) {
	  _firedux2.default.ref.child(_constants.PRESENCE_ENDPOINT + '/' + uid).set(_constants.PRESENCE.ONLINE);
	
	  return { type: _action_types.MAKE_CURRENT_USER_ACTIVE, uid: uid };
	};
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	var _action_types = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	var _action_types = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (uid) {
	  _firedux2.default.ref.child(_constants.PRESENCE_ENDPOINT + '/' + uid).set(_constants.PRESENCE.AWAY);
	
	  return { type: _action_types.MAKE_CURRENT_USER_IDLE, uid: uid };
	};

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (key) {
	  return { type: _action_types.REMOVE_BOOKMARKED_GROUP_CHAT, key: key };
	};

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (user) {
	  return { type: _action_types.REMOVE_CHAT_LIST_USER, user: user };
	};

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (uid, key, scope) {
	  return { type: _action_types.REMOVE_SUBSCRIBED_GROUP_CHAT, uid: uid, key: key, scope: scope };
	};

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (refKey) {
	  return { type: _action_types.REMOVE_USER_SESSION_REF, refKey: refKey };
	};

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (groups) {
	  return { type: _action_types.SET_BOOKMARKED_GROUP_CHATS, groups: groups };
	};

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (guests) {
	  return { type: _action_types.SET_CHAT_LIST_GUESTS, guests: guests };
	};

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (user, presence) {
	  return { type: _action_types.SET_CHAT_LIST_USER, user: user, presence: presence };
	};

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (settings) {
	  return { type: _action_types.SET_CHAT_SETTINGS, settings: settings };
	};
	
	var _action_types = __webpack_require__(4);

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (refs) {
	  return { type: _action_types.SET_CONVERSATION_REFS, refs: refs };
	};

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (stack) {
	  return { type: _action_types.SET_CONVERSATION_STACK, stack: stack };
	};

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (customer) {
	  return { type: _action_types.SET_CURRENT_CUSTOMER, customer: customer };
	};

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (sessionRequests) {
	  return { type: _action_types.SET_SESSION_REQUESTS, sessionRequests: sessionRequests };
	};

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (guest) {
	  return { type: _action_types.SET_CURRENT_GUEST, guest: guest };
	};
	
	var _action_types = __webpack_require__(4);

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (user) {
	  return { type: _action_types.SET_CURRENT_USER, user: user };
	};
	
	var _action_types = __webpack_require__(4);

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (isActive) {
	  return { type: _action_types.SET_CURRENT_USER_ACTIVITY, isActive: isActive };
	};

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (presence) {
	  return { type: _action_types.SET_CURRENT_USER_PRESENCE, presence: presence };
	};
	
	var _action_types = __webpack_require__(4);

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (notification, key) {
	  return { type: _action_types.SET_NEW_MESSAGE_NOTIFICATION, notification: notification, key: key };
	};

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (notification) {
	  return { type: _action_types.SET_NEW_SESSION_REQUEST_NOTIFICATION, notification: notification };
	};

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (user) {
	  return { type: _action_types.SET_RECENT_CONVERSATION_USER, user: user };
	};

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (recentConversations) {
	  return { type: _action_types.SET_RECENT_CONVERSATIONS, recentConversations: recentConversations };
	};

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (uid, groups, scope) {
	  return { type: _action_types.SET_SUBSCRIBED_GROUP_CHATS, uid: uid, groups: groups, scope: scope };
	};

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (presence, uid) {
	  return { type: _action_types.SET_USER_PRESENCE, presence: presence, uid: uid };
	};

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (refs) {
	  return { type: _action_types.SET_USER_SESSION_REFS, refs: refs };
	};

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (sessions) {
	  return { type: _action_types.SET_USER_SESSIONS, sessions: sessions };
	};

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (width, height) {
	  return { type: _action_types.SET_VIEWPORT_DIMENSIONS, width: width, height: height };
	};

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return { type: _action_types.SIGNIN_GUEST };
	};
	
	var _action_types = __webpack_require__(4);

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (authData, error) {
	  return { type: _action_types.FIREBASE_LOGIN, authData: authData, error: error };
	};
	
	var _action_types = __webpack_require__(4);

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (containerId, messageId, attr, val) {
	  return { type: _action_types.UPDATE_MESSAGE_ATTR, containerId: containerId, messageId: messageId, attr: attr, val: val };
	};

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _is_one_hour_before = __webpack_require__(503);
	
	var _is_one_hour_before2 = _interopRequireDefault(_is_one_hour_before);
	
	var _short_day = __webpack_require__(450);
	
	var _short_day2 = _interopRequireDefault(_short_day);
	
	var _short_time_of_day = __webpack_require__(302);
	
	var _short_time_of_day2 = _interopRequireDefault(_short_time_of_day);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (time) {
	  if (!time) return '';
	  if (!(0, _is_one_hour_before2.default)(time)) return '';
	
	  time = (0, _moment2.default)(time);
	  var now = (0, _moment2.default)();
	  var oneHourBefore = (0, _moment2.default)(now).subtract(1, 'hour');
	  var oneDayBefore = (0, _moment2.default)(now).subtract(1, 'day');
	
	  if (time.isBefore(oneDayBefore)) return (0, _short_day2.default)(time);
	  if (time.isBefore(oneHourBefore)) return (0, _short_time_of_day2.default)(time);
	
	  return time.to(now);
	};

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _group_chat_scope = __webpack_require__(267);
	
	var _group_chat_scope2 = _interopRequireDefault(_group_chat_scope);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (groupId, scope) {
	  if (!groupId) return Promise.reject('no groupId is given');
	
	  var groupChat = (0, _store.getState)().getIn(['groups', 'all', groupId]);
	
	  if (groupChat) return Promise.resolve(groupChat);
	
	  return Promise.resolve(scope).then(function (scope) {
	    return scope ? scope : (0, _group_chat_scope2.default)(groupId);
	  }).then(function (scope) {
	    var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_ENDPOINT).child(scope).child(groupId);
	
	    return ref.once('value');
	  }).then(function (snapshot) {
	    return (0, _immutable.fromJS)(snapshot.val());
	  });
	};

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _verge = __webpack_require__(86);
	
	var _verge2 = _interopRequireDefault(_verge);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PHONE = _constants.VIEWPORT_TYPES.PHONE;
	var DESKTOP = _constants.VIEWPORT_TYPES.DESKTOP;
	
	exports.default = function () {
	  var width = _verge2.default.viewportW();
	  var height = _verge2.default.viewportH();
	  var type = width > _constants.VIEWPORT_MAX_WIDTH_PHONE ? DESKTOP : PHONE;
	
	  return { width: width, height: height, type: type };
	};

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(2);
	
	exports.default = function (message) {
	  return message.get('type') === _constants.MESSAGE_TYPES.MODERATED_GROUP;
	};

/***/ },
/* 502 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (from, uid) {
	  return from === uid;
	};

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (time) {
	  var startTime = arguments.length <= 1 || arguments[1] === undefined ? (0, _moment2.default)().valueOf() : arguments[1];
	
	  return (0, _moment2.default)(time).isSameOrBefore((0, _moment2.default)(startTime).subtract(1, 'hour'));
	};

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (sessionTime) {
	  var time = (0, _moment2.default)(sessionTime);
	
	  if (time.isSameOrBefore((0, _moment2.default)())) return true;
	
	  return false;
	};

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _is_user_moderator = __webpack_require__(240);
	
	var _is_user_moderator2 = _interopRequireDefault(_is_user_moderator);
	
	var _is_message_approved = __webpack_require__(668);
	
	var _is_message_approved2 = _interopRequireDefault(_is_message_approved);
	
	var _is_message_owned_by_user = __webpack_require__(502);
	
	var _is_message_owned_by_user2 = _interopRequireDefault(_is_message_owned_by_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fromMessage, uid, approvalStatus, role) {
	  if ((0, _is_user_moderator2.default)(role)) return true;
	  if ((0, _is_message_approved2.default)(approvalStatus)) return true;
	  if ((0, _is_message_owned_by_user2.default)(fromMessage, uid)) return true;
	
	  return false;
	};

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initDataForUI = initDataForUI;
	exports.initDataForEmbeds = initDataForEmbeds;
	exports.initSettings = initSettings;
	exports.signInV2 = signInV2;
	exports.signIn = signIn;
	exports.signOut = signOut;
	exports.getAuth = getAuth;
	exports.onAuth = onAuth;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _watchers = __webpack_require__(527);
	
	var _plugin_settings = __webpack_require__(508);
	
	var _plugin_settings2 = _interopRequireDefault(_plugin_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function initDataForUI() {
	  (0, _watchers.watchUI)();
	
	  window.stoore = _store2.default;
	}
	
	function initDataForEmbeds() {
	  (0, _watchers.watchEmbeds)();
	}
	
	function initSettings(settings) {
	  (0, _plugin_settings2.default)(settings);
	}
	
	// Idempotent Signin
	function signInV2(credentials) {
	  var prevAuth = _firedux2.default.ref.getAuth();
	
	  if (!prevAuth && credentials && credentials.token) {
	    // sign in as user for first time
	    console.log('[RCHAT-AUTH] signing in user for the first time', prevAuth, credentials, !prevAuth && credentials && credentials.token);
	    return _firedux2.default.ref.authWithCustomToken(credentials.token);
	  }
	
	  if (!prevAuth && !credentials) {
	    // sign in guest for the first time
	    console.log('[RCHAT-AUTH] signing in guest for the first time', prevAuth, credentials, !prevAuth && !credentials);
	    return _firedux2.default.ref.authAnonymously();
	  }
	
	  if (prevAuth && prevAuth.provider === 'custom' && !credentials) {
	    // sign out and sign in as guest
	    console.log('[RCHAT-AUTH] sign out and sign in as guest', prevAuth, credentials, prevAuth && prevAuth.provider === 'custom' && !credentials);
	    _firedux2.default.ref.unauth();
	    return _firedux2.default.ref.authAnonymously();
	  }
	
	  if (prevAuth && prevAuth.provider === 'anonymous' && !credentials) {
	    // resolve silently - do nothing -
	    console.log('[RCHAT-AUTH] take as existing guest', prevAuth, credentials, prevAuth && prevAuth.provider === 'anonymous' && !credentials);
	    return Promise.resolve();
	  }
	
	  if (prevAuth && credentials && credentials.data && credentials.data.uid && credentials.data.uid !== prevAuth.uid) {
	    // sign out and sign in as user
	    console.log('[RCHAT-AUTH] sign out and sign in as user', prevAuth, credentials, prevAuth && credentials && credentials.data && credentials.data.token && credentials.data.uid !== prevAuth.uid);
	    _firedux2.default.ref.unauth();
	    return _firedux2.default.ref.authWithCustomToken(credentials.token);
	  }
	
	  if (prevAuth && credentials && credentials.data && credentials.data.uid === prevAuth.uid) {
	    // resolve silently - do nothing -
	    console.log('[RCHAT-AUTH] take as existing user', prevAuth, credentials, prevAuth && credentials && credentials.data && credentials.data.uid === prevAuth.uid);
	    return Promise.resolve();
	  }
	
	  // give detailed error about what's wrong
	  if (credentials && !credentials.token) {
	    return Promise.reject('rchat sign in failed: No token is provided within credentials');
	  }
	
	  return Promise.reject('rchat sign in failed: unknown reason. Make sure you are providing credentials correctly.');
	}
	
	// DEPRECIATED: use signInV2 instead.
	function signIn(credentials) {
	  if (!credentials) {
	    return _firedux2.default.ref.authAnonymously();
	  } else if (credentials.token) {
	    return _firedux2.default.ref.authWithCustomToken(credentials.token);
	  } else {
	    return _firedux2.default.ref.authWithPassword(credentials);
	  }
	}
	
	// DEPRECIATED: use signInV2 instead.
	function signOut() {
	  return _firedux2.default.ref.unauth();
	}
	
	function getAuth() {
	  return _firedux2.default.ref.getAuth();
	}
	
	function onAuth(cb) {
	  return _firedux2.default.ref.onAuth(cb);
	}

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unsubscribeGroupChat = exports.subscribeGroupChat = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscribeGroupChat = exports.subscribeGroupChat = function subscribeGroupChat(uid, groupId, type) {
	  if (!uid || !groupId || !type) return Promise.reject();
	
	  var userRef = _firedux2.default.ref.child(_constants.GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT).child(type).child(uid).child(groupId);
	
	  var groupRef = _firedux2.default.ref.child(_constants.GROUP_CHAT_SUBSCRIPTION_GROUPS_ENDPOINT).child(type).child(groupId).child(uid);
	
	  return userRef.set(true).then(function () {
	    return groupRef.set(true);
	  });
	};
	
	var unsubscribeGroupChat = exports.unsubscribeGroupChat = function unsubscribeGroupChat(uid, groupId, type) {
	  if (!uid || !groupId || !type) return Promise.reject();
	
	  var userRef = _firedux2.default.ref.child(_constants.GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT).child(type).child(uid).child(groupId);
	
	  var groupRef = _firedux2.default.ref.child(_constants.GROUP_CHAT_SUBSCRIPTION_GROUPS_ENDPOINT).child(type).child(groupId).child(uid);
	
	  return userRef.remove().then(function () {
	    return groupRef.remove();
	  });
	};

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(8);
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (settings) {
	  (0, _store.dispatch)({ type: _action_types.SET_PLUGIN_SETTINGS, settings: settings });
	};

/***/ },
/* 509 */,
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var updateSessionWithPayoutRequest = function updateSessionWithPayoutRequest(payoutRequestStatus, sessionId, snapshot) {
	  var requestId = snapshot.key();
	  var ENDPOINT = _constants.EXPERT_SESSIONS_ENDPOINT + '/' + sessionId;
	
	  var sessionUpdates = { status: _constants.SESSION_STATUSES.BOOKED };
	
	  if (payoutRequestStatus === _constants.PAYOUT_REQUEST_STATUSES.PENDING) {
	    sessionUpdates.pendingPayoutRequest = requestId;
	  }
	
	  return _firedux2.default.ref.child(ENDPOINT).update(sessionUpdates).then(function () {
	    return requestId;
	  });
	};
	
	exports.default = function (payoutRequestData) {
	  var shouldUpdateSession = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	  var shouldAllowExpertless = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	  if (!payoutRequestData) return;
	  if (!payoutRequestData.card) return;
	  if (!payoutRequestData.amount) return;
	  if (!payoutRequestData.user) return;
	  if (!shouldAllowExpertless && !payoutRequestData.expert) return;
	  if (!payoutRequestData.sessionId) return;
	
	  var status = _constants.PAYOUT_REQUEST_STATUSES.REQUESTED;
	
	  if (payoutRequestData.amount === _constants.PAY_AS_YOU_GO_VALUE) {
	    status = _constants.PAYOUT_REQUEST_STATUSES.PENDING;
	  }
	
	  payoutRequestData = (0, _immutable.Map)(payoutRequestData).merge({ status: status });
	
	  if (shouldAllowExpertless) {
	    payoutRequestData = payoutRequestData.set('expert', null).set('expertName', null);
	  }
	
	  payoutRequestData = payoutRequestData.toJS();
	
	  if (shouldUpdateSession) {
	    return _firedux2.default.ref.child(_constants.STRIPE_PAYOUT_REQUESTS_ENDPOINT).push(payoutRequestData).then(updateSessionWithPayoutRequest.bind(null, status, payoutRequestData.sessionId));
	  } else {
	    return _firedux2.default.ref.child(_constants.STRIPE_PAYOUT_REQUESTS_ENDPOINT).push(payoutRequestData).then(function (snapshot) {
	      return snapshot.key();
	    });
	  }
	};

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (uid) {
	  var ENDPOINT = _constants.PRESENCE_ENDPOINT + '/' + uid;
	
	  _firedux2.default.ref.child(ENDPOINT).onDisconnect().set(_constants.PRESENCE.OFFLINE);
	};

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _sign_in_user = __webpack_require__(496);
	
	var _sign_in_user2 = _interopRequireDefault(_sign_in_user);
	
	var _sign_in_guest = __webpack_require__(495);
	
	var _sign_in_guest2 = _interopRequireDefault(_sign_in_guest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (cb) {
	  _firedux2.default.ref.onAuth(function (authData) {
	    if (authData) {
	      (0, _store.dispatch)((0, _sign_in_user2.default)(authData, null));
	    }
	
	    cb(authData);
	  });
	};

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchBookmarkedGroups = exports.watchBookmarkedGroups = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _set_bookmarked_groups = __webpack_require__(474);
	
	var _set_bookmarked_groups2 = _interopRequireDefault(_set_bookmarked_groups);
	
	var _remove_bookmarked_group = __webpack_require__(470);
	
	var _remove_bookmarked_group2 = _interopRequireDefault(_remove_bookmarked_group);
	
	var _group_chat = __webpack_require__(499);
	
	var _group_chat2 = _interopRequireDefault(_group_chat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onBookmarkedGroups = function onBookmarkedGroups(snapshot) {
	  var groups = snapshot.val();
	
	  if (!groups) return (0, _store.dispatch)((0, _set_bookmarked_groups2.default)(groups));
	
	  groups = (0, _immutable.fromJS)(groups).map(function (_, key) {
	    return (0, _group_chat2.default)(key);
	  });
	
	  Promise.all(groups.toList().toJS()).then(function (groups) {
	    return (0, _store.dispatch)((0, _set_bookmarked_groups2.default)(groups));
	  });
	};
	
	var onBookmarkedGroupRemoved = function onBookmarkedGroupRemoved(snapshot) {
	  var key = snapshot.key();
	
	  (0, _store.dispatch)((0, _remove_bookmarked_group2.default)(key));
	};
	
	var watchBookmarkedGroups = exports.watchBookmarkedGroups = function watchBookmarkedGroups(uid) {
	  if (!uid) return Promise.reject();
	
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_BOOKMARKS_ENDPOINT).child('users').child(uid);
	
	  ref.on('value', onBookmarkedGroups);
	  ref.on('child_removed', onBookmarkedGroupRemoved);
	};
	
	var unwatchBookmarkedGroups = exports.unwatchBookmarkedGroups = function unwatchBookmarkedGroups(uid) {
	  if (!uid) return Promise.reject();
	
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_BOOKMARKS_ENDPOINT).child('users').child(uid);
	
	  ref.off('value', onBookmarkedGroups);
	  ref.off('child_removed', onBookmarkedGroupRemoved);
	};

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchChatListView = exports.watchChatListView = undefined;
	
	var _immutable = __webpack_require__(5);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _user = __webpack_require__(19);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _set_chat_list_user = __webpack_require__(476);
	
	var _set_chat_list_user2 = _interopRequireDefault(_set_chat_list_user);
	
	var _remove_chat_list_user = __webpack_require__(471);
	
	var _remove_chat_list_user2 = _interopRequireDefault(_remove_chat_list_user);
	
	var _change_chat_list_user_role = __webpack_require__(466);
	
	var _change_chat_list_user_role2 = _interopRequireDefault(_change_chat_list_user_role);
	
	var _set_chat_list_guests = __webpack_require__(475);
	
	var _set_chat_list_guests2 = _interopRequireDefault(_set_chat_list_guests);
	
	var _set_user = __webpack_require__(224);
	
	var _set_user2 = _interopRequireDefault(_set_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AWAY = _constants.PRESENCE.AWAY;
	var EXPERT = _constants.ROLES.EXPERT;
	var AUTHOR = _constants.ROLES.AUTHOR;
	
	
	var onChatListPresence = function onChatListPresence(snapshot) {
	  if (!snapshot.exists()) return Promise.resolve();
	
	  var uid = snapshot.key();
	  var presence = snapshot.val();
	
	  return (0, _user2.default)(uid).then(function (u) {
	    return (0, _store.dispatch)((0, _set_chat_list_user2.default)(u, presence));
	  });
	};
	
	var onChatListPresenceRemoved = function onChatListPresenceRemoved(snapshot) {
	  if (!snapshot.exists()) return Promise.resolve();
	
	  var uid = snapshot.key();
	
	  return (0, _user2.default)(uid).then(function (u) {
	    return (0, _store.dispatch)((0, _remove_chat_list_user2.default)(u));
	  });
	};
	
	var onChatListRoleChange = function onChatListRoleChange(snapshot) {
	  if (!snapshot.exists()) return Promise.resolve();
	
	  var user = snapshot.val();
	  var role = user.role;
	  var prevRole = role === EXPERT ? AUTHOR : EXPERT;
	
	  (0, _store.dispatch)((0, _set_user2.default)(user));
	  (0, _store.dispatch)((0, _change_chat_list_user_role2.default)((0, _immutable.fromJS)(user), role, prevRole));
	
	  return Promise.resolve();
	};
	
	var onGuestsLoaded = function onGuestsLoaded(snapshot) {
	  if (!snapshot.exists()) return Promise.resolve();
	
	  var guests = (0, _immutable.fromJS)(snapshot.val());
	
	  return Promise.resolve((0, _store.dispatch)((0, _set_chat_list_guests2.default)(guests)));
	};
	
	var watchChatListView = exports.watchChatListView = function watchChatListView() {
	  var presenceRef = _firedux2.default.ref.child(_constants.PRESENCE_ENDPOINT).orderByValue().startAt(AWAY);
	  var userRef = _firedux2.default.ref.child(_constants.USERS_ENDPOINT).orderByChild('role').startAt(EXPERT).endAt(AUTHOR);
	  var guestRef = _firedux2.default.ref.child(_constants.GUESTS_ENDPOINT).orderByKey().limitToLast(40);
	
	  presenceRef.on('child_added', onChatListPresence);
	  presenceRef.on('child_changed', onChatListPresence);
	  presenceRef.on('child_removed', onChatListPresenceRemoved);
	  userRef.on('child_changed', onChatListRoleChange);
	  guestRef.once('value', onGuestsLoaded);
	};
	
	var unwatchChatListView = exports.unwatchChatListView = function unwatchChatListView() {
	  var presenceRef = _firedux2.default.ref.child(_constants.PRESENCE_ENDPOINT).orderByValue().startAt(AWAY);
	  var userRef = _firedux2.default.ref.child(_constants.USERS_ENDPOINT).orderByChild('role').startAt(EXPERT).endAt(AUTHOR);
	
	  presenceRef.off('child_added', onChatListPresence);
	  presenceRef.off('child_changed', onChatListPresence);
	  presenceRef.off('child_removed', onChatListPresenceRemoved);
	  userRef.off('child_changed', onChatListRoleChange);
	};

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchChatSettings = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_chat_settings = __webpack_require__(477);
	
	var _set_chat_settings2 = _interopRequireDefault(_set_chat_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var watchChatSettings = exports.watchChatSettings = function watchChatSettings() {
	  (0, _store.dispatch)((0, _set_chat_settings2.default)()); // initiate with defaults
	
	  _firedux2.default.ref.child(_constants.SETTINGS_ENDPOINT).on('value', function (snapshot) {
	    if (snapshot.val()) return (0, _store.dispatch)((0, _set_chat_settings2.default)(snapshot.val()));
	  });
	};

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchConnection = exports.watchConnection = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _current_user_presence = __webpack_require__(225);
	
	var _current_user_presence2 = _interopRequireDefault(_current_user_presence);
	
	var _set_user_offline_on_disconnect = __webpack_require__(511);
	
	var _set_user_offline_on_disconnect2 = _interopRequireDefault(_set_user_offline_on_disconnect);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var watchConnection = exports.watchConnection = function watchConnection(uid) {
	
	  _firedux2.default.ref.child(_constants.CONNECTED_ENDPOINT).on('value', function (snapshot) {
	    console.log('connection status', snapshot.val() === true ? 'connected' : 'disconnected');
	
	    if (snapshot.val() === true) {
	      console.log('should set current user online');
	      (0, _current_user_presence2.default)(_constants.PRESENCE.ONLINE, uid);
	      (0, _set_user_offline_on_disconnect2.default)(uid);
	    } else {
	      console.log('should set current user offline');
	      (0, _current_user_presence2.default)(_constants.PRESENCE.OFFLINE, uid);
	    }
	  });
	};
	
	var unwatchConnection = exports.unwatchConnection = function unwatchConnection() {
	  _firedux2.default.ref.child(_constants.CONNECTED_ENDPOINT).off();
	};

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchConversationStack = exports.watchConversationStack = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_conversation_stack = __webpack_require__(479);
	
	var _set_conversation_stack2 = _interopRequireDefault(_set_conversation_stack);
	
	var _viewport = __webpack_require__(500);
	
	var _viewport2 = _interopRequireDefault(_viewport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onConversationStack = function onConversationStack(snapshot) {
	  var stack = snapshot.val();
	
	  (0, _store.dispatch)((0, _set_conversation_stack2.default)(stack));
	};
	
	var watchConversationStack = exports.watchConversationStack = function watchConversationStack(uid) {
	  var _getViewport = (0, _viewport2.default)();
	
	  var type = _getViewport.type;
	
	  var ref = _firedux2.default.ref.child(_constants.CONVERSATION_STACKS_ENDPOINT).child(type).child(uid);
	
	  ref.on('value', onConversationStack);
	};
	
	var unwatchConversationStack = exports.unwatchConversationStack = function unwatchConversationStack(uid) {
	  var _getViewport2 = (0, _viewport2.default)();
	
	  var type = _getViewport2.type;
	
	  var ref = _firedux2.default.ref.child(_constants.CONVERSATION_STACKS_ENDPOINT).child(type).child(uid);
	
	  ref.off('value', onConversationStack);
	  (0, _store.dispatch)((0, _set_conversation_stack2.default)([]));
	};

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchConversations = exports.watchConversations = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_conversation_refs = __webpack_require__(478);
	
	var _set_conversation_refs2 = _interopRequireDefault(_set_conversation_refs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ENDPOINT = void 0;
	
	var onConversationRefs = function onConversationRefs(snapshot) {
	  if (snapshot.exists()) (0, _store.dispatch)((0, _set_conversation_refs2.default)(snapshot.val()));
	};
	
	var watchConversations = exports.watchConversations = function watchConversations(uid) {
	  ENDPOINT = _constants.CONVERSATIONS_PRIVATE_REFS_ENDPOINT + '/' + uid;
	
	  _firedux2.default.ref.child(ENDPOINT).on('value', onConversationRefs);
	};
	
	var unwatchConversations = exports.unwatchConversations = function unwatchConversations() {
	  if (!ENDPOINT) return;
	
	  _firedux2.default.ref.child(ENDPOINT).off('value', onConversationRefs);
	};

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchCurrentCustomer = exports.watchCurrentCustomer = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_current_customer = __webpack_require__(480);
	
	var _set_current_customer2 = _interopRequireDefault(_set_current_customer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onCurrentCustomer = function onCurrentCustomer(snapshot) {
	  if (snapshot.exists()) (0, _store.dispatch)((0, _set_current_customer2.default)(snapshot.val()));
	};
	
	var watchCurrentCustomer = exports.watchCurrentCustomer = function watchCurrentCustomer(uid) {
	  if (!uid) return;
	
	  var ENDPOINT = _constants.STRIPE_CUSTOMERS_ENDPOINT + '/' + uid;
	
	  _firedux2.default.ref.child(ENDPOINT).on('value', onCurrentCustomer);
	};
	
	var unwatchCurrentCustomer = exports.unwatchCurrentCustomer = function unwatchCurrentCustomer() {
	  var uid = (0, _store.getState)().getIn(['currentUser', 'uid']);
	
	  if (!uid) return;
	
	  var ENDPOINT = _constants.STRIPE_CUSTOMERS_ENDPOINT + '/' + uid;
	
	  _firedux2.default.ref.child(ENDPOINT).off('value', onCurrentCustomer);
	};

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchCurrentExpertSessionRequests = exports.watchCurrentExpertSessionRequests = undefined;
	
	var _immutable = __webpack_require__(5);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _user = __webpack_require__(19);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _set_current_expert_session_requests = __webpack_require__(481);
	
	var _set_current_expert_session_requests2 = _interopRequireDefault(_set_current_expert_session_requests);
	
	var _set_new_session_request_notification = __webpack_require__(487);
	
	var _set_new_session_request_notification2 = _interopRequireDefault(_set_new_session_request_notification);
	
	var _show_modal = __webpack_require__(16);
	
	var _show_modal2 = _interopRequireDefault(_show_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var showRequestModal = function showRequestModal(sessionRequest, requestKey) {
	  (0, _store.dispatch)((0, _show_modal2.default)({
	    type: 'sessionRequest',
	    identifier: requestKey,
	    props: { sessionRequest: sessionRequest }
	  }));
	};
	
	var showDesktopNotification = function showDesktopNotification(sessionRequest) {
	  (0, _store.dispatch)((0, _set_new_session_request_notification2.default)({
	    from: sessionRequest.user,
	    to: sessionRequest.expert,
	    tag: 'sr-' + sessionRequest.expert + '-' + sessionRequest.user
	  }));
	};
	
	var handleSessionRequestSideEffects = function handleSessionRequestSideEffects(sessionRequests) {
	  (0, _immutable.Map)(sessionRequests).forEach(function (sessionRequest, requestKey) {
	    if (sessionRequest.status === _constants.SESSION_REQUEST_STATUSES.REQUESTED) {
	      showRequestModal(sessionRequest, requestKey);
	      showDesktopNotification(sessionRequest);
	
	      return false;
	    }
	  });
	};
	
	var getUsers = function getUsers(sessionRequests) {
	  (0, _immutable.Map)(sessionRequests).forEach(function (req) {
	    return (0, _user2.default)(req.user);
	  });
	};
	
	var onSessionRequest = function onSessionRequest(snapshot) {
	  if (snapshot.exists()) {
	    var sessionRequests = snapshot.val();
	
	    getUsers(sessionRequests);
	    (0, _store.dispatch)((0, _set_current_expert_session_requests2.default)(sessionRequests));
	
	    handleSessionRequestSideEffects(sessionRequests);
	  }
	};
	
	// const onSessionRequestRemove = (childSnapshot) => {
	//   dispatch(removeCurrentExpertSessionRequest)
	// }
	
	var watchCurrentExpertSessionRequests = exports.watchCurrentExpertSessionRequests = function watchCurrentExpertSessionRequests(uid, role) {
	  if (!(role === _constants.ROLES.EXPERT || role === _constants.ROLES.AUTHOR)) return;
	  if (!uid) return;
	
	  var ENDPOINT = _constants.EXPERT_SESSION_REQUESTS_ENDPOINT + '/' + uid;
	
	  var ref = _firedux2.default.ref.child(ENDPOINT).orderByChild('status').startAt(_constants.SESSION_REQUEST_STATUSES.REQUESTED);
	
	  ref.on('value', onSessionRequest);
	  // ref.on('child_removed', onSessionRequestRemove)
	};
	
	var unwatchCurrentExpertSessionRequests = exports.unwatchCurrentExpertSessionRequests = function unwatchCurrentExpertSessionRequests() {
	  var uid = (0, _store.getState)().getIn(['currentUser', 'uid']);
	  var role = (0, _store.getState)().getIn(['currentUser', 'role']);
	
	  if (!(role === _constants.ROLES.EXPERT || role === _constants.ROLES.AUTHOR)) return;
	  if (!uid) return;
	
	  var ENDPOINT = _constants.EXPERT_SESSION_REQUESTS_ENDPOINT + '/' + uid;
	
	  var ref = _firedux2.default.ref.child(ENDPOINT).orderByChild('status').equalTo(_constants.SESSION_REQUEST_STATUSES.REQUESTED);
	
	  ref.off('value', onSessionRequest);
	};

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchCurrentGuest = exports.watchCurrentGuest = undefined;
	
	var _sample = __webpack_require__(257);
	
	var _sample2 = _interopRequireDefault(_sample);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _constants = __webpack_require__(2);
	
	var _set_current_guest = __webpack_require__(482);
	
	var _set_current_guest2 = _interopRequireDefault(_set_current_guest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: read it from chatsettings
	var getGuestName = function getGuestName() {
	  return new Promise(function (resolve, reject) {
	    Promise.all([_firedux2.default.ref.child(_constants.SETTINGS_GUEST_PREFIX_ENDPOINT).once('value'), _firedux2.default.ref.child(_constants.SETTINGS_GUEST_NAMES_ENDPOINT).once('value')]).then(function (values) {
	      var guestPrefix = values[0].val() || 'Guest';
	      var guestNames = values[1].val() || 'Jade, Ruby, Haze, Archibald, Topaz, Emerald, Diamond,';
	
	      resolve(guestPrefix + ' ' + (0, _sample2.default)(guestNames.split(/\,\s+/g)));
	    });
	  });
	};
	
	var watchCurrentGuest = exports.watchCurrentGuest = function watchCurrentGuest(uid) {
	  var ENDPOINT = _constants.GUESTS_ENDPOINT + '/' + uid;
	
	  _firedux2.default.ref.child(ENDPOINT).on('value', function (snapshot) {
	    if (snapshot.val()) {
	      (0, _store.dispatch)((0, _set_current_guest2.default)(snapshot.val()));
	    } else {
	      getGuestName().then(function (guestName) {
	        _firedux2.default.ref.child(ENDPOINT).set({ name: guestName, uid: uid });
	      });
	    }
	  });
	};
	
	var unwatchCurrentGuest = exports.unwatchCurrentGuest = function unwatchCurrentGuest() {
	  var currentGuest = _store2.default.getState().get('currentGuest');
	
	  if (currentGuest && currentGuest.get('uid')) {
	    _firedux2.default.ref.child(_constants.GUESTS_ENDPOINT + '/' + currentGuest.get('uid')).off();
	    (0, _store.dispatch)((0, _set_current_guest2.default)(null));
	  }
	};

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchCurrentUser = exports.watchCurrentUser = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _constants = __webpack_require__(2);
	
	var _set_current_user = __webpack_require__(483);
	
	var _set_current_user2 = _interopRequireDefault(_set_current_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var watchCurrentUser = exports.watchCurrentUser = function watchCurrentUser(uid) {
	  _firedux2.default.ref.child(_constants.USERS_ENDPOINT + '/' + uid).on('value', function (snapshot) {
	    if (snapshot.val()) (0, _store.dispatch)((0, _set_current_user2.default)(snapshot.val()));
	  });
	};
	
	var unwatchCurrentUser = exports.unwatchCurrentUser = function unwatchCurrentUser() {
	  var currentUser = _store2.default.getState().get('currentUser');
	
	  if (currentUser && currentUser.get('uid')) {
	    _firedux2.default.ref.child(_constants.USERS_ENDPOINT + '/' + currentUser.get('uid')).off();
	    console.log('setting current user off');
	    (0, _store.dispatch)((0, _set_current_user2.default)(null));
	  }
	};

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchCurrentUserActivity = exports.watchCurrentUserActivity = undefined;
	
	var _idle = __webpack_require__(275);
	
	var _idle2 = _interopRequireDefault(_idle);
	
	var _store = __webpack_require__(8);
	
	var _set_current_user_activity = __webpack_require__(484);
	
	var _set_current_user_activity2 = _interopRequireDefault(_set_current_user_activity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var idle = void 0;
	
	var watchCurrentUserActivity = exports.watchCurrentUserActivity = function watchCurrentUserActivity() {
	  var inactivityStartTime = (0, _store.getState)().getIn(['chatSettings', 'inactivityStartSeconds']) * 1000;
	
	  idle = new _idle2.default({
	    onVisible: function onVisible() {
	      return (0, _store.dispatch)((0, _set_current_user_activity2.default)(true));
	    },
	    onHidden: function onHidden() {
	      return (0, _store.dispatch)((0, _set_current_user_activity2.default)(false));
	    },
	    onAway: function onAway() {
	      return (0, _store.dispatch)((0, _set_current_user_activity2.default)(false));
	    },
	    onAwayBack: function onAwayBack() {
	      return (0, _store.dispatch)((0, _set_current_user_activity2.default)(true));
	    },
	    awayTimeout: inactivityStartTime
	  });
	
	  idle.start();
	};
	
	var unwatchCurrentUserActivity = exports.unwatchCurrentUserActivity = function unwatchCurrentUserActivity() {
	  if (idle) idle.stop();
	};

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchCurrentUserIdle = exports.watchCurrentUserIdle = undefined;
	
	var _idle = __webpack_require__(275);
	
	var _idle2 = _interopRequireDefault(_idle);
	
	var _store = __webpack_require__(8);
	
	var _make_current_user_active = __webpack_require__(468);
	
	var _make_current_user_active2 = _interopRequireDefault(_make_current_user_active);
	
	var _make_current_user_idle = __webpack_require__(469);
	
	var _make_current_user_idle2 = _interopRequireDefault(_make_current_user_idle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var idle = void 0;
	
	var watchCurrentUserIdle = exports.watchCurrentUserIdle = function watchCurrentUserIdle(uid) {
	  var idleStartTime = (0, _store.getState)().getIn(['chatSettings', 'idleStartMinutes']) * 60 * 1000;
	
	  idle = new _idle2.default({
	    onAway: function onAway() {
	      return (0, _store.dispatch)((0, _make_current_user_idle2.default)(uid));
	    },
	    onAwayBack: function onAwayBack() {
	      return (0, _store.dispatch)((0, _make_current_user_active2.default)(uid));
	    },
	    awayTimeout: idleStartTime
	  });
	
	  idle.start();
	};
	
	var unwatchCurrentUserIdle = exports.unwatchCurrentUserIdle = function unwatchCurrentUserIdle() {
	  if (idle) idle.stop();
	};

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchCurrentUserPresence = exports.watchCurrentUserPresence = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _current_user_presence = __webpack_require__(225);
	
	var _current_user_presence2 = _interopRequireDefault(_current_user_presence);
	
	var _set_current_user_presence = __webpack_require__(485);
	
	var _set_current_user_presence2 = _interopRequireDefault(_set_current_user_presence);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var watchCurrentUserPresence = exports.watchCurrentUserPresence = function watchCurrentUserPresence(uid) {
	  var ENDPOINT = _constants.PRESENCE_ENDPOINT + '/' + uid;
	
	  // set to online after auth if he is offline
	  _firedux2.default.ref.child(ENDPOINT).once('value', function (snapshot) {
	    if (snapshot.val() === _constants.PRESENCE.OFFLINE) {
	      _firedux2.default.ref.child(ENDPOINT).set(_constants.PRESENCE.ONLINE);
	    }
	  });
	
	  _firedux2.default.ref.child(ENDPOINT).on('value', function (snapshot) {
	    if (!snapshot.exists()) return;
	
	    var presence = snapshot.val();
	    if (typeof presence === 'number' && presence !== _constants.PRESENCE.OFFLINE) {
	      (0, _store.dispatch)((0, _set_current_user_presence2.default)(presence));
	    } else if (presence === _constants.PRESENCE.OFFLINE) {
	      (0, _current_user_presence2.default)(_constants.PRESENCE.ONLINE);
	    }
	  });
	
	  // firedux.ref.child(ENDPOINT).onDisconnect().set(PRESENCE.OFFLINE)
	};
	
	var unwatchCurrentUserPresence = exports.unwatchCurrentUserPresence = function unwatchCurrentUserPresence() {
	  var currentUser = _store2.default.getState().get('currentUser');
	
	  if (currentUser && currentUser.get('uid')) {
	    var ENDPOINT = _constants.PRESENCE_ENDPOINT + '/' + currentUser.get('uid');
	    _firedux2.default.ref.child(ENDPOINT).set(_constants.PRESENCE.OFFLINE);
	    _firedux2.default.ref.child(ENDPOINT).off();
	    (0, _store.dispatch)((0, _set_current_user_presence2.default)(null));
	  }
	};

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchCurrentUserSessions = exports.watchCurrentUserSessions = undefined;
	
	var _immutable = __webpack_require__(5);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _user = __webpack_require__(19);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _set_user_session_refs = __webpack_require__(492);
	
	var _set_user_session_refs2 = _interopRequireDefault(_set_user_session_refs);
	
	var _remove_user_session_ref = __webpack_require__(473);
	
	var _remove_user_session_ref2 = _interopRequireDefault(_remove_user_session_ref);
	
	var _set_user_sessions = __webpack_require__(493);
	
	var _set_user_sessions2 = _interopRequireDefault(_set_user_sessions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getUsers = function getUsers(sessions) {
	  (0, _immutable.Map)(sessions).forEach(function (session) {
	    (0, _user2.default)(session.user);
	    (0, _user2.default)(session.expert);
	  });
	};
	
	var onSessionRefs = function onSessionRefs(snapshot) {
	  if (snapshot.exists()) (0, _store.dispatch)((0, _set_user_session_refs2.default)(snapshot.val()));
	};
	
	var onSessionRefRemoved = function onSessionRefRemoved(childSnapshot) {
	  (0, _store.dispatch)((0, _remove_user_session_ref2.default)(childSnapshot.key()));
	};
	
	var onSessions = function onSessions(snapshot) {
	  if (snapshot.exists()) {
	    var sessions = snapshot.val();
	    (0, _store.dispatch)((0, _set_user_sessions2.default)(sessions));
	    getUsers(sessions);
	  } else {
	    (0, _store.dispatch)((0, _set_user_sessions2.default)(null));
	  }
	};
	
	var getOrderKey = function getOrderKey(role) {
	  if (role === _constants.ROLES.EXPERT || role === _constants.ROLES.AUTHOR) {
	    return 'expert';
	  } else {
	    return 'user';
	  }
	};
	
	var watchCurrentUserSessions = exports.watchCurrentUserSessions = function watchCurrentUserSessions(uid, role) {
	  var REF_ENDPOINT = _constants.EXPERT_SESSIONS_REF_ENDPOINT + '/' + uid;
	  var orderKey = getOrderKey(role);
	
	  var refRef = _firedux2.default.ref.child(REF_ENDPOINT);
	  refRef.on('value', onSessionRefs);
	  refRef.on('child_removed', onSessionRefRemoved);
	
	  _firedux2.default.ref.child(_constants.EXPERT_SESSIONS_ENDPOINT).orderByChild(orderKey).equalTo(uid).on('value', onSessions);
	};
	
	var unwatchCurrentUserSessions = exports.unwatchCurrentUserSessions = function unwatchCurrentUserSessions() {
	  var uid = (0, _store.getState)().getIn(['currentUser', 'uid']);
	  if (!uid) return;
	
	  var REF_ENDPOINT = _constants.EXPERT_SESSIONS_REF_ENDPOINT + '/' + uid;
	
	  _firedux2.default.ref.child(REF_ENDPOINT).off('value', onSessionRefs);
	  _firedux2.default.ref.child(REF_ENDPOINT).off('child_removed', onSessionRefRemoved);
	  _firedux2.default.ref.child(_constants.EXPERT_SESSIONS_ENDPOINT).off('value', onSessions);
	};

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchEmbeds = exports.watchUI = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _auth = __webpack_require__(512);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _chat_settings = __webpack_require__(515);
	
	var _users = __webpack_require__(532);
	
	var _presences = __webpack_require__(243);
	
	var _current_user = __webpack_require__(522);
	
	var _current_user_presence = __webpack_require__(525);
	
	var _connection = __webpack_require__(516);
	
	var _current_user_idle = __webpack_require__(524);
	
	var _current_user_activity = __webpack_require__(523);
	
	var _conversations = __webpack_require__(518);
	
	var _conversation_stack = __webpack_require__(517);
	
	var _recent_conversations = __webpack_require__(529);
	
	var _notifications = __webpack_require__(528);
	
	var _current_guest = __webpack_require__(521);
	
	var _current_user_sessions = __webpack_require__(526);
	
	var _current_expert_session_requests = __webpack_require__(520);
	
	var _current_customer = __webpack_require__(519);
	
	var _group_chats = __webpack_require__(226);
	
	var _bookmarked_group_chats = __webpack_require__(513);
	
	var _subscribed_group_chats = __webpack_require__(530);
	
	var _group_chat_orders = __webpack_require__(336);
	
	var _chat_list = __webpack_require__(514);
	
	var _viewport_resize = __webpack_require__(533);
	
	var _viewport_resize2 = _interopRequireDefault(_viewport_resize);
	
	var _advertisements = __webpack_require__(272);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var watchUI = exports.watchUI = function watchUI() {
	  (0, _viewport_resize2.default)();
	  (0, _chat_settings.watchChatSettings)();
	  (0, _chat_list.watchChatListView)();
	  (0, _users.watchUsers)();
	  (0, _advertisements.watchAdvertisements)();
	  (0, _presences.watchPresences)();
	  (0, _group_chats.watchGlobalGroupChats)();
	  (0, _group_chat_orders.watchGlobalGroupOrders)();
	  (0, _group_chats.watchPrivateGroupChats)();
	
	  var currentUid = void 0;
	
	  (0, _auth2.default)(function (authData) {
	    if (authData) {
	      if (authData.provider === 'custom') {
	        if (!currentUid) currentUid = authData.uid;
	
	        (0, _current_guest.unwatchCurrentGuest)();
	        (0, _conversation_stack.unwatchConversationStack)(currentUid);
	        (0, _current_user.watchCurrentUser)(authData.uid);
	        (0, _current_user_presence.watchCurrentUserPresence)(authData.uid);
	        (0, _connection.watchConnection)(authData.uid);
	        (0, _current_user_idle.watchCurrentUserIdle)(authData.uid);
	        (0, _current_user_activity.watchCurrentUserActivity)();
	        (0, _current_user_sessions.watchCurrentUserSessions)(authData.uid, authData.auth.role);
	        (0, _current_expert_session_requests.watchCurrentExpertSessionRequests)(authData.uid, authData.auth.role);
	        (0, _current_customer.watchCurrentCustomer)(authData.uid);
	        (0, _conversations.watchConversations)(authData.uid);
	        (0, _conversation_stack.watchConversationStack)(authData.uid);
	        (0, _recent_conversations.watchRecentConversations)(authData.uid);
	        (0, _bookmarked_group_chats.watchBookmarkedGroups)(authData.uid);
	        (0, _subscribed_group_chats.watchUserGroupChatSubscriptions)(authData.uid);
	        (0, _notifications.watchNotifications)(authData.uid);
	
	        currentUid = authData.uid;
	      } else if (authData.provider === 'anonymous') {
	        if (!currentUid) currentUid = authData.uid;
	
	        (0, _notifications.unwatchNotifications)();
	        (0, _subscribed_group_chats.unwatchUserGroupChatSubscriptions)(currentUid);
	        (0, _bookmarked_group_chats.unwatchBookmarkedGroups)(currentUid);
	        (0, _conversation_stack.unwatchConversationStack)(currentUid);
	        (0, _conversations.unwatchConversations)();
	        (0, _current_expert_session_requests.unwatchCurrentExpertSessionRequests)();
	        (0, _current_customer.unwatchCurrentCustomer)();
	        (0, _current_user_sessions.unwatchCurrentUserSessions)();
	        (0, _current_user_activity.unwatchCurrentUserActivity)();
	        (0, _current_user_idle.unwatchCurrentUserIdle)();
	        (0, _connection.unwatchConnection)();
	        (0, _current_user_presence.unwatchCurrentUserPresence)();
	        (0, _current_user.unwatchCurrentUser)();
	        (0, _current_guest.watchCurrentGuest)(authData.uid);
	        (0, _conversation_stack.watchConversationStack)(authData.uid);
	
	        currentUid = authData.uid;
	      }
	    }
	  });
	};
	
	var watchEmbeds = exports.watchEmbeds = function watchEmbeds() {
	  (0, _chat_settings.watchChatSettings)();
	  (0, _group_chats.watchPrivateGroupChats)();
	  (0, _users.watchUsers)();
	
	  var currentUid = void 0;
	
	  (0, _auth2.default)(function (authData) {
	    if (authData) {
	      if (authData.provider === 'custom') {
	        if (!currentUid) currentUid = authData.uid;
	
	        (0, _current_user.watchCurrentUser)(authData.uid);
	        (0, _connection.watchConnection)(authData.uid);
	        (0, _current_user_presence.watchCurrentUserPresence)(authData.uid);
	        (0, _current_user_idle.watchCurrentUserIdle)(authData.uid);
	        (0, _current_user_activity.watchCurrentUserActivity)();
	        (0, _current_user_sessions.watchCurrentUserSessions)(authData.uid, authData.auth.role);
	        (0, _current_expert_session_requests.watchCurrentExpertSessionRequests)(authData.uid, authData.auth.role);
	        (0, _current_customer.watchCurrentCustomer)(authData.uid);
	        (0, _bookmarked_group_chats.watchBookmarkedGroups)(authData.uid);
	        (0, _subscribed_group_chats.watchUserGroupChatSubscriptions)(authData.uid);
	
	        currentUid = authData.uid;
	      }
	    } else {
	      if (currentUid) {
	        (0, _subscribed_group_chats.unwatchUserGroupChatSubscriptions)(currentUid);
	        (0, _bookmarked_group_chats.unwatchBookmarkedGroups)(currentUid);
	      }
	      (0, _current_customer.unwatchCurrentCustomer)();
	      (0, _current_expert_session_requests.unwatchCurrentExpertSessionRequests)();
	      (0, _current_user_sessions.unwatchCurrentUserSessions)();
	      (0, _current_user_activity.unwatchCurrentUserActivity)();
	      (0, _current_user_idle.unwatchCurrentUserIdle)();
	      (0, _current_user_presence.unwatchCurrentUserPresence)();
	      (0, _connection.unwatchConnection)();
	      (0, _current_user.unwatchCurrentUser)();
	    }
	  });
	};

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchNotifications = exports.watchNotifications = undefined;
	
	var _constants = __webpack_require__(2);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _set_new_message_notification = __webpack_require__(486);
	
	var _set_new_message_notification2 = _interopRequireDefault(_set_new_message_notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onNotification = function onNotification(snapshot) {
	  if (!snapshot.exists()) return;
	
	  var notification = snapshot.val();
	  var key = snapshot.key();
	  (0, _store.dispatch)((0, _set_new_message_notification2.default)(notification, key));
	};
	
	var watchNotifications = exports.watchNotifications = function watchNotifications(uid) {
	  var MESSAGE_ENDPOINT = (0, _constants.USER_MESSAGE_NOTIFICATIONS_ENDPOINT)(uid);
	
	  _firedux2.default.ref.child(MESSAGE_ENDPOINT).orderByChild('isReceived').equalTo(false).on('child_added', onNotification);
	};
	
	var unwatchNotifications = exports.unwatchNotifications = function unwatchNotifications() {
	  var uid = (0, _store.getState)().getIn(['currentUser', 'uid']);
	
	  if (uid) {
	    var MESSAGE_ENDPOINT = (0, _constants.USER_MESSAGE_NOTIFICATIONS_ENDPOINT)(uid);
	
	    _firedux2.default.ref.child(MESSAGE_ENDPOINT).off();
	  }
	};

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchRecentConversations = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(2);
	
	var _user = __webpack_require__(19);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _set_recent_conversations = __webpack_require__(489);
	
	var _set_recent_conversations2 = _interopRequireDefault(_set_recent_conversations);
	
	var _set_recent_conversation_user = __webpack_require__(488);
	
	var _set_recent_conversation_user2 = _interopRequireDefault(_set_recent_conversation_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getUsers = function getUsers() {
	  var uids = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	  return uids.forEach(function (uid) {
	    (0, _user2.default)(uid).then(function (user) {
	      if (user) (0, _store.dispatch)((0, _set_recent_conversation_user2.default)(user));
	    });
	  });
	};
	
	var onData = function onData(snapshot) {
	  if (snapshot.exists()) {
	    var convs = snapshot.val();
	    (0, _store.dispatch)((0, _set_recent_conversations2.default)(convs));
	    getUsers(Object.keys(convs));
	  }
	};
	
	var onSettings = function onSettings(uid, snapshot) {
	  if (!snapshot.exists()) return;
	
	  var _snapshot$val = snapshot.val();
	
	  var dayTimeout = _snapshot$val.dayTimeout;
	  var numberOfUsers = _snapshot$val.numberOfUsers;
	
	  var daysAgo = (0, _moment2.default)().subtract(dayTimeout, 'days').valueOf();
	
	  var ENDPOINT = _constants.CONVERSATIONS_PRIVATE_REFS_ENDPOINT + '/' + uid;
	  var ref = _firedux2.default.ref.child(ENDPOINT).orderByChild('latestMessageTime').startAt(daysAgo).limitToLast(numberOfUsers);
	
	  ref.off('value', onData);
	  ref.on('value', onData);
	};
	
	var watchRecentConversations = exports.watchRecentConversations = function watchRecentConversations(uid) {
	  var DAY_TIMEOUT_ENDPOINT = _constants.SETTINGS_SEGMENTS_ENDPOINT + '/recents';
	  _firedux2.default.ref.child(DAY_TIMEOUT_ENDPOINT).on('value', onSettings.bind(null, uid));
	};

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchUserGroupChatSubscriptions = exports.watchUserGroupChatSubscriptions = exports.unwatchUserGroupChatWeeklySubscriptions = exports.watchUserGroupChatWeeklySubscriptions = exports.unwatchUserGroupChatDailySubscriptions = exports.watchUserGroupChatDailySubscriptions = exports.unwatchUserGroupChatInstantSubscriptions = exports.watchUserGroupChatInstantSubscriptions = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_subscribed_groups = __webpack_require__(490);
	
	var _set_subscribed_groups2 = _interopRequireDefault(_set_subscribed_groups);
	
	var _remove_subscribed_group = __webpack_require__(472);
	
	var _remove_subscribed_group2 = _interopRequireDefault(_remove_subscribed_group);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INSTANT = _constants.GROUP_CHAT_SUBSCRIPTION_TYPES.INSTANT;
	var DAILY = _constants.GROUP_CHAT_SUBSCRIPTION_TYPES.DAILY;
	var WEEKLY = _constants.GROUP_CHAT_SUBSCRIPTION_TYPES.WEEKLY;
	
	
	var onSubscribedGroups = function onSubscribedGroups(uid, snapshot, scope) {
	  var groups = snapshot.val();
	
	  return (0, _store.dispatch)((0, _set_subscribed_groups2.default)(uid, groups, scope));
	};
	
	var onSubscribedGroupsInstant = function onSubscribedGroupsInstant(uid, snapshot) {
	  return onSubscribedGroups(uid, snapshot, INSTANT);
	};
	var onSubscribedGroupsDaily = function onSubscribedGroupsDaily(uid, snapshot) {
	  return onSubscribedGroups(uid, snapshot, DAILY);
	};
	var onSubscribedGroupsWeekly = function onSubscribedGroupsWeekly(uid, snapshot) {
	  return onSubscribedGroups(uid, snapshot, WEEKLY);
	};
	
	var onSubscribedGroupRemoved = function onSubscribedGroupRemoved(uid, snapshot, scope) {
	  var key = snapshot.key();
	
	  (0, _store.dispatch)((0, _remove_subscribed_group2.default)(uid, key, scope));
	};
	
	var onSubscribedGroupInstantRemoved = function onSubscribedGroupInstantRemoved(uid, snapshot) {
	  return onSubscribedGroupRemoved(uid, snapshot, INSTANT);
	};
	var onSubscribedGroupDailyRemoved = function onSubscribedGroupDailyRemoved(uid, snapshot) {
	  return onSubscribedGroupRemoved(uid, snapshot, DAILY);
	};
	var onSubscribedGroupWeeklyRemoved = function onSubscribedGroupWeeklyRemoved(uid, snapshot) {
	  return onSubscribedGroupRemoved(uid, snapshot, WEEKLY);
	};
	
	var watchUserGroupChatInstantSubscriptions = exports.watchUserGroupChatInstantSubscriptions = function watchUserGroupChatInstantSubscriptions(uid) {
	  if (!uid) return;
	
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT).child(INSTANT).child(uid);
	
	  ref.on('value', onSubscribedGroupsInstant.bind(null, uid));
	  ref.on('child_removed', onSubscribedGroupInstantRemoved.bind(null, uid));
	};
	
	var unwatchUserGroupChatInstantSubscriptions = exports.unwatchUserGroupChatInstantSubscriptions = function unwatchUserGroupChatInstantSubscriptions(uid) {
	  if (!uid) return;
	
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT).child(INSTANT).child(uid);
	
	  ref.off('value');
	  ref.off('child_removed');
	};
	
	var watchUserGroupChatDailySubscriptions = exports.watchUserGroupChatDailySubscriptions = function watchUserGroupChatDailySubscriptions(uid) {
	  if (!uid) return;
	
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT).child(DAILY).child(uid);
	
	  ref.on('value', onSubscribedGroupsDaily.bind(null, uid));
	  ref.on('child_removed', onSubscribedGroupDailyRemoved.bind(null, uid));
	};
	
	var unwatchUserGroupChatDailySubscriptions = exports.unwatchUserGroupChatDailySubscriptions = function unwatchUserGroupChatDailySubscriptions(uid) {
	  if (!uid) return;
	
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT).child(DAILY).child(uid);
	
	  ref.off('value');
	  ref.off('child_removed');
	};
	
	var watchUserGroupChatWeeklySubscriptions = exports.watchUserGroupChatWeeklySubscriptions = function watchUserGroupChatWeeklySubscriptions(uid) {
	  if (!uid) return;
	
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT).child(WEEKLY).child(uid);
	
	  ref.on('value', onSubscribedGroupsWeekly.bind(null, uid));
	  ref.on('child_removed', onSubscribedGroupWeeklyRemoved.bind(null, uid));
	};
	
	var unwatchUserGroupChatWeeklySubscriptions = exports.unwatchUserGroupChatWeeklySubscriptions = function unwatchUserGroupChatWeeklySubscriptions(uid) {
	  if (!uid) return;
	
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT).child(WEEKLY).child(uid);
	
	  ref.off('value');
	  ref.off('child_removed');
	};
	
	var watchUserGroupChatSubscriptions = exports.watchUserGroupChatSubscriptions = function watchUserGroupChatSubscriptions(uid) {
	  if (!uid) return;
	
	  watchUserGroupChatInstantSubscriptions(uid);
	  watchUserGroupChatDailySubscriptions(uid);
	  watchUserGroupChatWeeklySubscriptions(uid);
	};
	
	var unwatchUserGroupChatSubscriptions = exports.unwatchUserGroupChatSubscriptions = function unwatchUserGroupChatSubscriptions(uid) {
	  if (!uid) return;
	
	  unwatchUserGroupChatInstantSubscriptions(uid);
	  unwatchUserGroupChatDailySubscriptions(uid);
	  unwatchUserGroupChatWeeklySubscriptions(uid);
	};

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchCurrentUserPresence = exports.watchCurrentUserPresence = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_user_presence = __webpack_require__(491);
	
	var _set_user_presence2 = _interopRequireDefault(_set_user_presence);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onUserPresence = function onUserPresence(snapshot) {
	  if (!snapshot.exists()) return;
	
	  (0, _store.dispatch)((0, _set_user_presence2.default)(snapshot.val(), snapshot.key()));
	};
	
	var watchCurrentUserPresence = exports.watchCurrentUserPresence = function watchCurrentUserPresence(uid) {
	  var ENDPOINT = _constants.PRESENCE_ENDPOINT + '/' + uid;
	
	  _firedux2.default.ref.child(ENDPOINT).on('value', onUserPresence);
	};
	
	var unwatchCurrentUserPresence = exports.unwatchCurrentUserPresence = function unwatchCurrentUserPresence(uid) {
	  var ENDPOINT = _constants.PRESENCE_ENDPOINT + '/' + uid;
	
	  _firedux2.default.ref.child(ENDPOINT).off('value', onUserPresence);
	};

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchUsers = exports.watchUsers = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _constants = __webpack_require__(2);
	
	var _set_users = __webpack_require__(448);
	
	var _set_users2 = _interopRequireDefault(_set_users);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onUsers = function onUsers(snapshot) {
	  if (snapshot.exists()) (0, _store.dispatch)((0, _set_users2.default)(snapshot.val()), _store2.default.getState().currentUser);
	};
	
	var watchUsers = exports.watchUsers = function watchUsers() {
	  var usersViewRef = _firedux2.default.ref.child(_constants.USERS_VIEW_ENDPOINT);
	  usersViewRef.on('value', onUsers);
	};
	
	var unwatchUsers = exports.unwatchUsers = function unwatchUsers() {
	  var usersViewRef = _firedux2.default.ref.child(_constants.USERS_VIEW_ENDPOINT);
	  usersViewRef.off('value', onUsers);
	  (0, _store.dispatch)((0, _set_users2.default)(null));
	};

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _verge = __webpack_require__(86);
	
	var _verge2 = _interopRequireDefault(_verge);
	
	var _store = __webpack_require__(8);
	
	var _set_viewport_dimensions = __webpack_require__(494);
	
	var _set_viewport_dimensions2 = _interopRequireDefault(_set_viewport_dimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onResize = function onResize() {
	  var width = _verge2.default.viewportW();
	  var height = _verge2.default.viewportH();
	
	  (0, _store.dispatch)((0, _set_viewport_dimensions2.default)(width, height));
	};
	
	exports.default = function () {
	  onResize();
	
	  window.addEventListener('resize', onResize);
	};

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SlidingMenu = function (_React$Component) {
	  _inherits(SlidingMenu, _React$Component);
	
	  function SlidingMenu(props) {
	    _classCallCheck(this, SlidingMenu);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SlidingMenu).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(SlidingMenu, [{
	    key: 'render',
	    value: function render() {
	      var maxHeight = this.props.isVisible ? this.props.height : 0;
	      return _react2.default.createElement(
	        'div',
	        { className: 'sliding-menu ' + this.props.className, style: { top: this.props.top, maxHeight: maxHeight } },
	        _react2.default.createElement(
	          'div',
	          { className: 'sliding-menu-container' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return SlidingMenu;
	}(_react2.default.Component);
	
	exports.default = SlidingMenu;

/***/ },
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".chasing-dots{width:27px;height:27px;position:relative;-webkit-animation:rotate 2s infinite linear;animation:rotate 2s infinite linear}.dot1,.dot2{width:60%;height:60%;display:inline-block;position:absolute;top:0;background-color:#333;border-radius:100%;-webkit-animation:bounce 2s infinite ease-in-out;animation:bounce 2s infinite ease-in-out}.dot2{top:auto;bottom:0;-webkit-animation-delay:-1s;animation-delay:-1s}@-webkit-keyframes rotate{to{-webkit-transform:rotate(1turn)}}@keyframes rotate{to{transform:rotate(1turn);-webkit-transform:rotate(1turn)}}@-webkit-keyframes bounce{0%,to{-webkit-transform:scale(0)}50%{-webkit-transform:scale(1)}}@keyframes bounce{0%,to{transform:scale(0);-webkit-transform:scale(0)}50%{transform:scale(1);-webkit-transform:scale(1)}}", ""]);
	
	// exports


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".circle-wrapper{width:22px;height:22px;position:relative}.circle{width:100%;height:100%;position:absolute;left:0;top:0}.circle:before{content:'';display:block;margin:0 auto;width:20%;height:20%;background-color:#333;border-radius:100%;-webkit-animation:bouncedelay 1.2s infinite ease-in-out;animation:bouncedelay 1.2s infinite ease-in-out;-webkit-animation-fill-mode:both;animation-fill-mode:both}.circle2{-webkit-transform:rotate(30deg);transform:rotate(30deg)}.circle3{-webkit-transform:rotate(60deg);transform:rotate(60deg)}.circle4{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.circle5{-webkit-transform:rotate(120deg);transform:rotate(120deg)}.circle6{-webkit-transform:rotate(150deg);transform:rotate(150deg)}.circle7{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.circle8{-webkit-transform:rotate(210deg);transform:rotate(210deg)}.circle9{-webkit-transform:rotate(240deg);transform:rotate(240deg)}.circle10{-webkit-transform:rotate(270deg);transform:rotate(270deg)}.circle11{-webkit-transform:rotate(300deg);transform:rotate(300deg)}.circle12{-webkit-transform:rotate(330deg);transform:rotate(330deg)}.circle2:before{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.circle3:before{-webkit-animation-delay:-1s;animation-delay:-1s}.circle4:before{-webkit-animation-delay:-.9s;animation-delay:-.9s}.circle5:before{-webkit-animation-delay:-.8s;animation-delay:-.8s}.circle6:before{-webkit-animation-delay:-.7s;animation-delay:-.7s}.circle7:before{-webkit-animation-delay:-.6s;animation-delay:-.6s}.circle8:before{-webkit-animation-delay:-.5s;animation-delay:-.5s}.circle9:before{-webkit-animation-delay:-.4s;animation-delay:-.4s}.circle10:before{-webkit-animation-delay:-.3s;animation-delay:-.3s}.circle11:before{-webkit-animation-delay:-.2s;animation-delay:-.2s}.circle12:before{-webkit-animation-delay:-.1s;animation-delay:-.1s}@-webkit-keyframes bouncedelay{0%,80%,to{-webkit-transform:scale(0)}40%{-webkit-transform:scale(1)}}@keyframes bouncedelay{0%,80%,to{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}", ""]);
	
	// exports


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".cube-grid{width:27px;height:27px}.cube{width:33%;height:33%;background:#333;float:left;-webkit-animation:scaleDelay 1.3s infinite ease-in-out;animation:scaleDelay 1.3s infinite ease-in-out}.spinner .cube:nth-child(1){-webkit-animation-delay:.2s;animation-delay:.2s}.spinner .cube:nth-child(2){-webkit-animation-delay:.3s;animation-delay:.3s}.spinner .cube:nth-child(3){-webkit-animation-delay:.4s;animation-delay:.4s}.spinner .cube:nth-child(4){-webkit-animation-delay:.1s;animation-delay:.1s}.spinner .cube:nth-child(5){-webkit-animation-delay:.2s;animation-delay:.2s}.spinner .cube:nth-child(6){-webkit-animation-delay:.3s;animation-delay:.3s}.spinner .cube:nth-child(7){-webkit-animation-delay:0s;animation-delay:0s}.spinner .cube:nth-child(8){-webkit-animation-delay:.1s;animation-delay:.1s}.spinner .cube:nth-child(9){-webkit-animation-delay:.2s;animation-delay:.2s}@-webkit-keyframes scaleDelay{0%,70%,to{-webkit-transform:scale3D(1,1,1)}35%{-webkit-transform:scale3D(0,0,1)}}@keyframes scaleDelay{0%,70%,to{-webkit-transform:scale3D(1,1,1);transform:scale3D(1,1,1)}35%{-webkit-transform:scale3D(1,1,1);transform:scale3D(0,0,1)}}", ""]);
	
	// exports


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".double-bounce{width:27px;height:27px;position:relative}.double-bounce1,.double-bounce2{width:100%;height:100%;border-radius:50%;background-color:#333;opacity:.6;position:absolute;top:0;left:0;-webkit-animation:bounce 2s infinite ease-in-out;animation:bounce 2s infinite ease-in-out}.double-bounce2{-webkit-animation-delay:-1s;animation-delay:-1s}@-webkit-keyframes bounce{0%,to{-webkit-transform:scale(0)}50%{-webkit-transform:scale(1)}}@keyframes bounce{0%,to{transform:scale(0);-webkit-transform:scale(0)}50%{transform:scale(1);-webkit-transform:scale(1)}}", ""]);
	
	// exports


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, "@-webkit-keyframes fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}@keyframes fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}.fade-in{-webkit-animation:fade-in 2s;-moz-animation:fade-in 2s;-o-animation:fade-in 2s;-ms-animation:fade-in 2s}", ""]);
	
	// exports


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".pulse{width:27px;height:27px;background-color:#333;border-radius:100%;-webkit-animation:scaleout 1s infinite ease-in-out;animation:scaleout 1s infinite ease-in-out}@-webkit-keyframes scaleout{0%{-webkit-transform:scale(0)}to{-webkit-transform:scale(1);opacity:0}}@keyframes scaleout{0%{transform:scale(0);-webkit-transform:scale(0)}to{transform:scale(1);-webkit-transform:scale(1);opacity:0}}", ""]);
	
	// exports


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".rotating-plane{width:27px;height:27px;background-color:#333;-webkit-animation:rotateplane 1.2s infinite ease-in-out;animation:rotateplane 1.2s infinite ease-in-out}@-webkit-keyframes rotateplane{0%{-webkit-transform:perspective(120px)}50%{-webkit-transform:perspective(120px) rotateY(180deg)}to{-webkit-transform:perspective(120px) rotateY(180deg) rotateX(180deg)}}@keyframes rotateplane{0%{transform:perspective(120px) rotateX(0deg) rotateY(0deg);-webkit-transform:perspective(120px) rotateX(0deg) rotateY(0deg)}50%{transform:perspective(120px) rotateX(-180.1deg) rotateY(0deg);-webkit-transform:perspective(120px) rotateX(-180.1deg) rotateY(0deg)}to{transform:perspective(120px) rotateX(-180deg) rotateY(-179.9deg);-webkit-transform:perspective(120px) rotateX(-180deg) rotateY(-179.9deg)}}", ""]);
	
	// exports


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".three-bounce>div{width:18px;height:18px;background-color:#333;border-radius:100%;display:inline-block;-webkit-animation:bouncedelay 1.4s infinite ease-in-out;animation:bouncedelay 1.4s infinite ease-in-out;-webkit-animation-fill-mode:both;animation-fill-mode:both}.three-bounce .bounce1{-webkit-animation-delay:-.32s;animation-delay:-.32s}.three-bounce .bounce2{-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes bouncedelay{0%,80%,to{-webkit-transform:scale(0)}40%{-webkit-transform:scale(1)}}@keyframes bouncedelay{0%,80%,to{transform:scale(0);-webkit-transform:scale(0)}40%{transform:scale(1);-webkit-transform:scale(1)}}", ""]);
	
	// exports


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".wandering-cubes{width:27px;height:27px;position:relative}.cube1,.cube2{background-color:#333;width:10px;height:10px;position:absolute;top:0;left:0;-webkit-animation:cubemove 1.8s infinite ease-in-out;animation:cubemove 1.8s infinite ease-in-out}.cube2{-webkit-animation-delay:-.9s;animation-delay:-.9s}@-webkit-keyframes cubemove{25%{-webkit-transform:translateX(22px) rotate(-90deg) scale(.5)}50%{-webkit-transform:translateX(22px) translateY(22px) rotate(-180deg)}75%{-webkit-transform:translateX(0) translateY(22px) rotate(-270deg) scale(.5)}to{-webkit-transform:rotate(-1turn)}}@keyframes cubemove{25%{transform:translateX(42px) rotate(-90deg) scale(.5);-webkit-transform:translateX(42px) rotate(-90deg) scale(.5)}50%{transform:translateX(42px) translateY(42px) rotate(-179deg);-webkit-transform:translateX(42px) translateY(42px) rotate(-179deg)}50.1%{transform:translateX(42px) translateY(42px) rotate(-180deg);-webkit-transform:translateX(42px) translateY(42px) rotate(-180deg)}75%{transform:translateX(0) translateY(42px) rotate(-270deg) scale(.5);-webkit-transform:translateX(0) translateY(42px) rotate(-270deg) scale(.5)}to{transform:rotate(-1turn);-webkit-transform:rotate(-1turn)}}", ""]);
	
	// exports


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".wave{width:50px;height:27px}.wave>div{background-color:#333;height:100%;width:6px;display:inline-block;-webkit-animation:stretchdelay 1.2s infinite ease-in-out;animation:stretchdelay 1.2s infinite ease-in-out}.wave .rect2{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.wave .rect3{-webkit-animation-delay:-1s;animation-delay:-1s}.wave .rect4{-webkit-animation-delay:-.9s;animation-delay:-.9s}.wave .rect5{-webkit-animation-delay:-.8s;animation-delay:-.8s}@-webkit-keyframes stretchdelay{0%,40%,to{-webkit-transform:scaleY(.4)}20%{-webkit-transform:scaleY(1)}}@keyframes stretchdelay{0%,40%,to{transform:scaleY(.4);-webkit-transform:scaleY(.4)}20%{transform:scaleY(1);-webkit-transform:scaleY(1)}}", ""]);
	
	// exports


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".wordpress{background:#333;width:27px;height:27px;display:inline-block;border-radius:27px;position:relative;-webkit-animation:inner-circle 1s linear infinite;animation:inner-circle 1s linear infinite}.inner-circle{display:block;background:#fff;width:8px;height:8px;position:absolute;border-radius:8px;top:5px;left:5px}@-webkit-keyframes inner-circle{0%{-webkit-transform:rotate(0)}to{-webkit-transform:rotate(1turn)}}@keyframes inner-circle{0%{transform:rotate(0);-webkit-transform:rotate(0)}to{transform:rotate(1turn);-webkit-transform:rotate(1turn)}}", ""]);
	
	// exports


/***/ },
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  if (true) module.exports = definition()
	  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
	  else this[name] = definition()
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
	
	
	  if (!loaded)
	  doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener)
	    loaded = 1
	    while (listener = fns.shift()) listener()
	  })
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn)
	  }
	
	});


/***/ },
/* 561 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent) {
	    var keys = Object.getOwnPropertyNames(sourceComponent);
	    for (var i=0; i<keys.length; ++i) {
	        if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]]) {
	            try {
	                targetComponent[keys[i]] = sourceComponent[keys[i]];
	            } catch (error) {
	
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 562 */,
/* 563 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments to numbers.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the new array of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(563),
	    isIterateeCall = __webpack_require__(460),
	    toNumber = __webpack_require__(236);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toNumber(start);
	    start = start === start ? start : 0;
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toNumber(end) || 0;
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : (toNumber(step) || 0);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ },
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Format$HORIZONTAL$Fo;
	
	var _Format = __webpack_require__(425);
	
	var _Format2 = _interopRequireDefault(_Format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_Format$HORIZONTAL$Fo = {}, _defineProperty(_Format$HORIZONTAL$Fo, _Format2.default.HORIZONTAL, [[970, 90], [728, 90], [468, 60], [234, 60]]), _defineProperty(_Format$HORIZONTAL$Fo, _Format2.default.RECTANGLE, [[336, 280], [300, 250], [250, 250], [200, 200], [180, 150], [125, 125]]), _defineProperty(_Format$HORIZONTAL$Fo, _Format2.default.VERTICAL, [[300, 600], [160, 600], [120, 600], [120, 240]]), _defineProperty(_Format$HORIZONTAL$Fo, _Format2.default.MOBILE, [[320, 50]]), _defineProperty(_Format$HORIZONTAL$Fo, _Format2.default.MOBILE_BIG, [[320, 100], [320, 50]]), _defineProperty(_Format$HORIZONTAL$Fo, '300x600', [[300, 600], [160, 600]]), _defineProperty(_Format$HORIZONTAL$Fo, '336x280', [[336, 280], [300, 250]]), _defineProperty(_Format$HORIZONTAL$Fo, '728x90', [[728, 90], [468, 60]]), _defineProperty(_Format$HORIZONTAL$Fo, '970x90', [[970, 90], [728, 90], [468, 60]]), _Format$HORIZONTAL$Fo);

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Format = exports.Dimensions = undefined;
	
	var _Dimensions2 = __webpack_require__(578);
	
	var _Dimensions3 = _interopRequireDefault(_Dimensions2);
	
	var _Format2 = __webpack_require__(425);
	
	var _Format3 = _interopRequireDefault(_Format2);
	
	var _GooglePublisherTag = __webpack_require__(798);
	
	var _GooglePublisherTag2 = _interopRequireDefault(_GooglePublisherTag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Dimensions = _Dimensions3.default;
	exports.Format = _Format3.default;
	exports.default = _GooglePublisherTag2.default;

/***/ },
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(3);
	
	var _storeShape = __webpack_require__(294);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(295);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react.Children.only(children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = connect;
	
	var _react = __webpack_require__(3);
	
	var _storeShape = __webpack_require__(294);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(585);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(586);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(295);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(561);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(53);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = undefined;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure;
	  var pure = _options$pure === undefined ? true : _options$pure;
	  var _options$withRef = options.withRef;
	  var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged;
	        var hasStoreStateChanged = this.hasStoreStateChanged;
	        var haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated;
	        var statePropsPrecalculationError = this.statePropsPrecalculationError;
	        var renderedElement = this.renderedElement;
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 585 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(237);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(538);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./chasing-dots.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./chasing-dots.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(539);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./circle.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./circle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(540);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./cube-grid.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./cube-grid.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(541);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./double-bounce.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./double-bounce.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(542);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./fade-in.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./fade-in.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(543);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./pulse.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./pulse.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(544);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./rotating-plane.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./rotating-plane.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(545);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./three-bounce.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./three-bounce.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(546);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./wandering-cubes.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./wandering-cubes.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(547);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./wave.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./wave.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(548);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(13)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./wordpress.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./wordpress.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 598 */,
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _request_signin = __webpack_require__(266);
	
	var _request_signin2 = _interopRequireDefault(_request_signin);
	
	var _set_chat_list_toggled = __webpack_require__(602);
	
	var _set_chat_list_toggled2 = _interopRequireDefault(_set_chat_list_toggled);
	
	var _profile_image = __webpack_require__(45);
	
	var _profile_image2 = _interopRequireDefault(_profile_image);
	
	var _presence_indicator = __webpack_require__(79);
	
	var _presence_indicator2 = _interopRequireDefault(_presence_indicator);
	
	var _user_item_info = __webpack_require__(341);
	
	var _user_item_info2 = _interopRequireDefault(_user_item_info);
	
	var _current_user_sliding_menu = __webpack_require__(653);
	
	var _current_user_sliding_menu2 = _interopRequireDefault(_current_user_sliding_menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatCurrentUserBar = function (_React$Component) {
	  _inherits(ChatCurrentUserBar, _React$Component);
	
	  function ChatCurrentUserBar(props) {
	    _classCallCheck(this, ChatCurrentUserBar);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatCurrentUserBar).call(this, props));
	
	    _this.state = {};
	
	    _this.onActionMenuClose = _this.onActionMenuClose.bind(_this);
	    _this.toggleActionMenu = _this.toggleActionMenu.bind(_this);
	    _this.requestSignin = _this.requestSignin.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChatCurrentUserBar, [{
	    key: 'toggleActionMenu',
	    value: function toggleActionMenu() {
	      this.setState({ isActionMenuOpen: !this.state.isActionMenuOpen });
	    }
	  }, {
	    key: 'onActionMenuClose',
	    value: function onActionMenuClose() {
	      this.setState({ isActionMenuOpen: false });
	    }
	  }, {
	    key: 'requestSignin',
	    value: function requestSignin(e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      this.props.setChatListToToggled(false);
	      this.props.requestSignin();
	    }
	  }, {
	    key: 'renderSlidingMenu',
	    value: function renderSlidingMenu() {
	      if (this.props.currentUser && this.props.currentUser.get('uid')) {
	        return _react2.default.createElement(_current_user_sliding_menu2.default, {
	          top: 42,
	          isOpen: this.state.isActionMenuOpen,
	          onActionMenuClose: this.onActionMenuClose });
	      }
	    }
	  }, {
	    key: 'renderHelpButton',
	    value: function renderHelpButton() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'action-menu-button help' },
	        _react2.default.createElement(
	          'a',
	          { href: this.props.helpPageUrl, title: 'Go to Expert Chat Help & F.A.Q.', target: '_blank', style: { textDecoration: 'none', fontSize: 'inherit', 'fontWeight': 'inherit', color: 'inherit' } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'inline-block', width: 26, height: 26, lineHeight: '1.3em', borderRadius: 9999, border: '1px solid rgba(255, 255, 255, .8)' } },
	            '?'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderUserBar',
	    value: function renderUserBar() {
	      var user = this.props.currentUser.toJS();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'current-user-bar-container signed-in' },
	        _react2.default.createElement(_profile_image2.default, { user: user, image: user.profileImage, hasIndicator: false, size: 24 }),
	        _react2.default.createElement(_user_item_info2.default, { user: user, className: 'primary', ratingEnabled: false, sessionsCountEnabled: false, usernameColor: '#FFFFFF' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'actions' },
	          _react2.default.createElement(
	            'div',
	            { className: 'action-menu-button', onClick: this.toggleActionMenu },
	            _react2.default.createElement(_presence_indicator2.default, { user: user }),
	            _react2.default.createElement('i', { className: 'caret-icon rc-icon-caret-down' })
	          ),
	          this.renderHelpButton()
	        )
	      );
	    }
	  }, {
	    key: 'renderGuestBar',
	    value: function renderGuestBar() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'current-user-bar-container guest' },
	        _react2.default.createElement(
	          'div',
	          { className: 'guest-info' },
	          _react2.default.createElement(
	            'i',
	            null,
	            this.props.currentGuest.get('name')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'actions' },
	          _react2.default.createElement(
	            'button',
	            { className: 'action-menu-button signin', onClick: this.requestSignin },
	            'Sign in to chat'
	          ),
	          this.renderHelpButton()
	        )
	      );
	    }
	  }, {
	    key: 'renderLoading',
	    value: function renderLoading() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'current-user-bar-container guest' },
	        _react2.default.createElement(
	          'div',
	          { className: 'guest-info' },
	          _react2.default.createElement(
	            'i',
	            null,
	            'Loading...'
	          )
	        ),
	        _react2.default.createElement('div', { className: 'actions' })
	      );
	    }
	  }, {
	    key: 'renderInnerContent',
	    value: function renderInnerContent() {
	      if (this.props.currentUser && this.props.currentUser.get('uid')) return this.renderUserBar();else if (this.props.currentGuest) return this.renderGuestBar();else this.renderLoading();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'current-user-bar', style: { backgroundColor: this.props.currentUserBarBackground } },
	        this.renderInnerContent(),
	        this.renderSlidingMenu()
	      );
	    }
	  }]);
	
	  return ChatCurrentUserBar;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentUser: state.get('currentUser'),
	    currentGuest: state.get('currentGuest'),
	    currentUserBarBackground: state.getIn(['chatSettings', 'colors', 'chatList']),
	    helpPageUrl: state.getIn(['chatSettings', 'helpPageUrl'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    requestSignin: _request_signin2.default,
	    setChatListToToggled: function setChatListToToggled(toggled) {
	      return dispatch((0, _set_chat_list_toggled2.default)(toggled));
	    }
	  };
	};
	
	var ChatCurrentUserBarContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatCurrentUserBar);
	
	exports.default = ChatCurrentUserBarContainer;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _content = __webpack_require__(464);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _actions = __webpack_require__(463);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Conversation = function (_React$Component) {
	  _inherits(Conversation, _React$Component);
	
	  function Conversation(props) {
	    _classCallCheck(this, Conversation);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Conversation).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Conversation, [{
	    key: 'render',
	    value: function render() {
	      var contentHeight = this.props.contentHeight || this.props.height - this.props.actionsHeight;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'conversation-container' },
	        _react2.default.createElement(_content2.default, {
	          height: contentHeight,
	          maxBubbleWidth: this.props.maxBubbleWidth,
	          notificationOptions: this.props.notificationOptions,
	          conversationContainerId: this.props.conversationContainerId,
	          messageType: this.props.messageType,
	          shouldLoadPreviousMessages: this.props.shouldLoadPreviousMessages,
	          shouldLoadHistoryMessages: this.props.shouldLoadHistoryMessages,
	          historyBatchLimit: this.props.historyBatchLimit,
	          isRichMessageContentEnabled: this.props.isRichMessageContentEnabled }),
	        _react2.default.createElement(_actions2.default, {
	          ref: 'conversationActions',
	          isActive: this.props.isActive,
	          messageType: this.props.messageType,
	          height: this.props.actionsHeight,
	          conversationContainerId: this.props.conversationContainerId,
	          to: this.props.to,
	          warningMessage: this.props.warningMessage,
	          onNewMessageInputFocus: this.props.onConversationFocus,
	          onNewMessageInputBlur: this.props.onConversationBlur,
	          shouldSendNotification: this.props.shouldSendNotification,
	          otherUser: this.props.otherUser })
	      );
	    }
	  }]);
	
	  return Conversation;
	}(_react2.default.Component);
	
	Conversation.defaultProps = {
	  height: 200,
	  actionsHeight: 41,
	  isActive: true
	};
	
	exports.default = Conversation;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(7);
	
	var _reactMaskedinput = __webpack_require__(799);
	
	var _reactMaskedinput2 = _interopRequireDefault(_reactMaskedinput);
	
	var _reactSpinkit = __webpack_require__(67);
	
	var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);
	
	var _constants = __webpack_require__(2);
	
	var _full_path = __webpack_require__(239);
	
	var _full_path2 = _interopRequireDefault(_full_path);
	
	var _send_payout_request = __webpack_require__(510);
	
	var _send_payout_request2 = _interopRequireDefault(_send_payout_request);
	
	var _set_later_session_side_effects = __webpack_require__(609);
	
	var _set_later_session_side_effects2 = _interopRequireDefault(_set_later_session_side_effects);
	
	var _set_immediate_session_side_effects = __webpack_require__(683);
	
	var _set_immediate_session_side_effects2 = _interopRequireDefault(_set_immediate_session_side_effects);
	
	var _current_payout_request = __webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import sendPayoutRequestForLater from '../shared/data/setters/send_payout_request_for_later_session'
	
	
	var CreditCardForm = function (_React$Component) {
	  _inherits(CreditCardForm, _React$Component);
	
	  function CreditCardForm(props) {
	    _classCallCheck(this, CreditCardForm);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CreditCardForm).call(this, props));
	
	    _this.state = {
	      currentCard: 'default'
	    };
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.onSavedCardSubmit = _this.onSavedCardSubmit.bind(_this);
	    _this.onSwitchCurrentCard = _this.onSwitchCurrentCard.bind(_this);
	    _this.onCardNumChange = _this.onCardNumChange.bind(_this);
	    _this.sendPayoutRequest = _this.sendPayoutRequest.bind(_this);
	    _this.watchPayoutRequest = _this.watchPayoutRequest.bind(_this);
	
	    _this.cardMonths = [{ value: 1, label: '01' }, { value: 2, label: '02' }, { value: 3, label: '03' }, { value: 4, label: '04' }, { value: 5, label: '05' }, { value: 6, label: '06' }, { value: 7, label: '07' }, { value: 8, label: '08' }, { value: 9, label: '09' }, { value: 10, label: '10' }, { value: 11, label: '11' }, { value: 12, label: '12' }];
	
	    _this.cardYears = [{ value: 16, label: '16' }, { value: 17, label: '17' }, { value: 18, label: '18' }, { value: 19, label: '19' }, { value: 20, label: '20' }, { value: 21, label: '21' }, { value: 22, label: '22' }, { value: 23, label: '23' }, { value: 24, label: '24' }, { value: 25, label: '25' }, { value: 26, label: '26' }, { value: 27, label: '27' }, { value: 28, label: '28' }, { value: 29, label: '29' }];
	
	    _this.cardBrands = {
	      default: {
	        ccNum: {
	          placeholder: 'Card Number',
	          placeholderChar: '*',
	          mask: '1111',
	          size: '20'
	        },
	        cvc: {
	          placeholder: 'CVC',
	          placeholderChar: '*',
	          mask: '111',
	          size: '3'
	        }
	      },
	      visa: {
	        ccNum: {
	          placeholder: '**** **** **** ****',
	          placeholderChar: '*',
	          mask: '1111 1111 1111 1111',
	          size: '20'
	        },
	        cvc: {
	          placeholder: 'CVC',
	          placeholderChar: '*',
	          mask: '111',
	          size: '3'
	        }
	      },
	      mastercard: {
	        ccNum: {
	          placeholder: '**** **** **** ****',
	          placeholderChar: '*',
	          mask: '1111 1111 1111 1111',
	          size: '20'
	        },
	        cvc: {
	          placeholder: 'CVC',
	          placeholderChar: '*',
	          mask: '111',
	          size: '3'
	        }
	      },
	      amex: {
	        ccNum: {
	          placeholder: '**** ****** *****',
	          placeholderChar: '*',
	          mask: '1111 111111 11111',
	          size: '18'
	        },
	        cvc: {
	          placeholder: 'CVC',
	          placeholderChar: '*',
	          mask: '1111',
	          size: '4'
	        }
	      }
	    };
	    return _this;
	  }
	
	  _createClass(CreditCardForm, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.currentPayoutRequest) {
	        var payoutRequestKey = this.props.currentPayoutRequest.get('key');
	
	        if (payoutRequestKey) {
	          this.props.unwatchCurrentPayoutRequest(payoutRequestKey);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var request = this.props.currentPayoutRequest;
	      var nextRequest = nextProps.currentPayoutRequest;
	
	
	      if (nextRequest && request !== nextRequest) {
	        var status = request ? request.get('status') : null;
	        var nextStatus = nextRequest.get('status');
	        var SUCCESS = _constants.PAYOUT_REQUEST_STATUSES.SUCCESS;
	        var PENDING = _constants.PAYOUT_REQUEST_STATUSES.PENDING;
	        var ERROR = _constants.PAYOUT_REQUEST_STATUSES.ERROR;
	        var type = nextProps.type;
	        var user = nextProps.user;
	        var expert = nextProps.expert;
	        var sessionLength = nextProps.sessionLength;
	        var sessionStartTime = nextProps.sessionStartTime;
	        var sessionId = nextProps.sessionId;
	
	
	        if (status !== SUCCESS && nextStatus === SUCCESS || status !== PENDING && nextStatus === PENDING) {
	          if (type) {
	            // available types = ['immediate', 'later', 'addMoreTime']
	            if (type === 'later') {
	              this.props.submitLaterSessionSideEffects(user, expert, sessionLength, sessionStartTime, sessionId);
	            } else if (type === 'immediate') {
	              this.props.submitImmediateSessionSideEffects(user, expert, sessionLength, sessionId);
	            }
	          }
	
	          this.setState({ isSubmitting: false, errorMessage: null });
	
	          var currentPayoutRequest = nextProps.currentPayoutRequest;
	
	
	          this.props.onCheckoutComplete(currentPayoutRequest);
	        } else if (nextStatus === ERROR) {
	          var err = nextRequest.get('err');
	          var errorMessage = err ? 'Error while trying checkout: ' + err.get('message') : '';
	
	          this.setState({ isSubmitting: false, errorMessage: errorMessage });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(_, prevState) {
	      if (prevState.currentCard !== this.state.currentCard) {
	        if (this.refs && this.refs.ccNum && this.refs.ccNum.input) {
	          var placeholderChar = this.getCardRules(this.state.currentCard)['ccNum']['placeholderChar'];
	          var cursor = this.state.ccNum ? this.state.ccNum.replace(/[\*|\s]/g, '').length : 0;
	
	          this.refs.ccNum.input.focus();
	          this.refs.ccNum.input.selectionStart = cursor;
	          this.refs.ccNum.input.selectionEnd = cursor;
	        }
	      }
	    }
	  }, {
	    key: 'watchPayoutRequest',
	    value: function watchPayoutRequest(key) {
	      this.props.watchCurrentPayoutRequest(key);
	    }
	  }, {
	    key: 'sendPayoutRequest',
	    value: function sendPayoutRequest(card, id, sessionId) {
	      var payoutRequestData = (0, _immutable.Map)({
	        card: card, stripeToken: id,
	        amount: this.props.amount,
	        sessionId: sessionId,
	        user: this.props.user.get('uid'),
	        userName: this.props.user.get('name'),
	        expert: this.props.expert.get('uid'),
	        expertName: this.props.expert.get('name')
	      }).toJS();
	
	      this.props.sendPayoutRequest(payoutRequestData).then(this.watchPayoutRequest);
	    }
	  }, {
	    key: 'getCardRules',
	    value: function getCardRules(cardName) {
	      return this.cardBrands[cardName] || this.cardBrands['default'];
	    }
	  }, {
	    key: 'getCardBrand',
	    value: function getCardBrand(ccNum) {
	      if (ccNum.match(/^4/) != null) {
	        return 'visa';
	      } else if (ccNum.match(/^(34|37)/)) {
	        return 'amex';
	      } else if (ccNum.match(/^5[1-5]/)) {
	        return 'mastercard';
	      }
	      // we discard discover for now... pattern: /^6011/
	      else {
	          return 'default';
	        }
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      this.setState({
	        errorMessage: null,
	        isSubmitting: true
	      });
	
	      Stripe.card.createToken(e.currentTarget, function (status, response) {
	        if (status === 200) {
	          // this is success
	          _this2.sendPayoutRequest(response.card, response.id, _this2.props.sessionId);
	        } else {
	          _this2.setState({
	            errorMessage: response.error.message,
	            isSubmitting: false
	          });
	        }
	      });
	    }
	  }, {
	    key: 'onSavedCardSubmit',
	    value: function onSavedCardSubmit(e) {
	      if (e) e.preventDefault();
	
	      this.sendPayoutRequest(this.props.currentCustomer.get('card'), null, this.props.sessionId);
	    }
	  }, {
	    key: 'onSwitchCurrentCard',
	    value: function onSwitchCurrentCard(e) {
	      if (e) e.preventDefault();
	
	      this.setState({ shouldEnterNewCard: true });
	    }
	  }, {
	    key: 'onCardNumChange',
	    value: function onCardNumChange(e) {
	      var ccNum = e.target.value;
	
	      var currentCard = this.getCardBrand(ccNum);
	
	      if (currentCard !== this.state.currentCard) {
	        this.setState({ currentCard: currentCard, ccNum: ccNum });
	      }
	    }
	  }, {
	    key: 'renderInformation',
	    value: function renderInformation() {
	      if (this.state.errorMessage) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'alert danger' },
	          this.state.errorMessage
	        );
	      }
	    }
	  }, {
	    key: 'renderActions',
	    value: function renderActions() {
	      if (this.state.isSubmitting) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'form-section' },
	          _react2.default.createElement(_reactSpinkit2.default, { type: 'three-bounce' })
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'form-section' },
	          _react2.default.createElement(
	            'button',
	            { className: this.props.submitButtonClasses },
	            'Checkout'
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderCardForm',
	    value: function renderCardForm() {
	      var currentCard = this.state.currentCard;
	
	      var _getCardRules = this.getCardRules(currentCard);
	
	      var ccNum = _getCardRules.ccNum;
	      var cvc = _getCardRules.cvc;
	
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'credit-card-form form', onSubmit: this.onSubmit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 5 } },
	          _react2.default.createElement('img', { src: (0, _full_path2.default)('/cc_mastercard.jpg'), style: { marginRight: 5, opacity: currentCard === 'mastercard' ? 1 : .2 } }),
	          _react2.default.createElement('img', { src: (0, _full_path2.default)('/cc_visa.jpg'), style: { marginRight: 5, opacity: currentCard === 'visa' ? 1 : .2 } }),
	          _react2.default.createElement('img', { src: (0, _full_path2.default)('/cc_amex.jpg'), style: { opacity: currentCard === 'amex' ? 1 : .2 } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'primary-line form-group' },
	          _react2.default.createElement(_reactMaskedinput2.default, {
	            ref: 'ccNum',
	            className: 'card-number form-control',
	            key: currentCard,
	            placeholder: ccNum.placeholder,
	            placeholderChar: ccNum.placeholderChar,
	            mask: ccNum.mask,
	            size: ccNum.size,
	            value: this.state.ccNum,
	            'data-stripe': 'number',
	            onChange: this.onCardNumChange })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'secondary-line form-group' },
	          _react2.default.createElement(
	            'div',
	            { className: 'expire-date-group' },
	            _react2.default.createElement(
	              'select',
	              { className: 'expire-date-month form-control', 'data-stripe': 'exp_month' },
	              _react2.default.createElement(
	                'option',
	                { disabled: true, selected: true },
	                'MM'
	              ),
	              this.cardMonths.map(function (cM) {
	                return _react2.default.createElement(
	                  'option',
	                  { value: cM.value },
	                  cM.label
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'select',
	              { className: 'expire-date-year form-control', 'data-stripe': 'exp_year' },
	              _react2.default.createElement(
	                'option',
	                { disabled: true, selected: true },
	                'YY'
	              ),
	              this.cardYears.map(function (cY) {
	                return _react2.default.createElement(
	                  'option',
	                  { value: cY.value },
	                  cY.label
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(_reactMaskedinput2.default, {
	            className: 'cvc form-control',
	            style: { width: currentCard === 'amex' ? 58 : 52 },
	            placeholder: cvc.placeholder,
	            placeholderChar: cvc.placeholderChar,
	            mask: cvc.mask,
	            size: cvc.size,
	            'data-stripe': 'cvc',
	            onChange: function onChange(e) {
	              e.target.value;
	            } })
	        ),
	        this.renderActions()
	      );
	    }
	  }, {
	    key: 'renderSavedCardForm',
	    value: function renderSavedCardForm() {
	      var cardBrand = this.props.currentCustomer.getIn(['card', 'brand'], 'Visa');
	      var last4 = this.props.currentCustomer.getIn(['card', 'last4']);
	      var placeholder = cardBrand === 'American Express' ? '**** ****** *' + last4 : '**** **** **** ' + last4;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'saved-credit-card-form', style: { marginTop: 20 } },
	        _react2.default.createElement(
	          'h4',
	          null,
	          placeholder
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: 20 } },
	          'Payment will be done using this card.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-section' },
	          _react2.default.createElement(
	            'button',
	            { className: this.props.submitButtonClasses, onClick: this.onSavedCardSubmit },
	            'Checkout'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: '#', style: { display: 'block', marginTop: 20 }, onClick: this.onSwitchCurrentCard },
	            'Pay with another card'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      if (this.props.currentCustomer && this.props.currentCustomer.get('customerId') && !this.state.shouldEnterNewCard) {
	        return this.renderSavedCardForm();
	      } else {
	        return this.renderCardForm();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'information-line' },
	          this.renderInformation()
	        ),
	        this.renderBody()
	      );
	    }
	  }]);
	
	  return CreditCardForm;
	}(_react2.default.Component);
	
	CreditCardForm.defaultProps = {
	  onCheckoutComplete: function onCheckoutComplete() {},
	  submitButtonClasses: 'submit button success block'
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentPayoutRequest: state.get('currentPayoutRequest'),
	    currentCustomer: state.get('currentCustomer')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	  return {
	    sendPayoutRequest: ownProps.sendPayoutRequest || _send_payout_request2.default,
	    submitLaterSessionSideEffects: ownProps.setLaterSessionSideEffects || _set_later_session_side_effects2.default,
	    submitImmediateSessionSideEffects: ownProps.setImmediateSessionSideEffects || _set_immediate_session_side_effects2.default,
	    watchCurrentPayoutRequest: _current_payout_request.watchCurrentPayoutRequest,
	    unwatchCurrentPayoutRequest: _current_payout_request.unwatchCurrentPayoutRequest
	  };
	};
	
	var CreditCardFormContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CreditCardForm);
	
	exports.default = CreditCardFormContainer;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (toggled) {
	  return { type: _action_types.SET_CHAT_LIST_TOGGLED, toggled: toggled };
	};

/***/ },
/* 603 */,
/* 604 */,
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(2);
	
	exports.default = function (presence) {
	  if (typeof presence !== 'number') return false;
	
	  if (presence === _constants.PRESENCE.ONLINE || presence === _constants.PRESENCE.AWAY) return true;
	
	  return false;
	};

/***/ },
/* 606 */,
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (uid, groupId) {
	  if (!uid || !groupId) return Promise.reject();
	
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_BOOKMARKS_ENDPOINT).child('users').child(uid).child(groupId);
	
	  return ref.set(true);
	};

/***/ },
/* 608 */,
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _save_session_to_schedules = __webpack_require__(679);
	
	var _save_session_to_schedules2 = _interopRequireDefault(_save_session_to_schedules);
	
	var _save_schedule_notifications = __webpack_require__(678);
	
	var _save_schedule_notifications2 = _interopRequireDefault(_save_schedule_notifications);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (expert, user, sessionLength, startTime, sessionId) {
	  return (0, _save_session_to_schedules2.default)(expert, user, sessionLength, startTime, sessionId).then(_save_schedule_notifications2.default.bind(null, expert, user, sessionLength, startTime, sessionId));
	};

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (uid, groupId) {
	  if (!uid || !groupId) return Promise.reject();
	
	  var ref = _firedux2.default.ref.child(_constants.GROUP_CHAT_BOOKMARKS_ENDPOINT).child('users').child(uid).child(groupId);
	
	  return ref.remove();
	};

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _crud_list = __webpack_require__(58);
	
	var _crud_list2 = _interopRequireDefault(_crud_list);
	
	var _group_chat_avatar = __webpack_require__(244);
	
	var _group_chat_avatar2 = _interopRequireDefault(_group_chat_avatar);
	
	var _group_chat_bookmark_button = __webpack_require__(274);
	
	var _group_chat_bookmark_button2 = _interopRequireDefault(_group_chat_bookmark_button);
	
	var _group_chat_subscribe_button = __webpack_require__(227);
	
	var _group_chat_subscribe_button2 = _interopRequireDefault(_group_chat_subscribe_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PHONE = _constants.VIEWPORT_TYPES.PHONE;
	
	var GroupChatsBookmarked = function (_React$Component) {
	  _inherits(GroupChatsBookmarked, _React$Component);
	
	  function GroupChatsBookmarked(props) {
	    _classCallCheck(this, GroupChatsBookmarked);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GroupChatsBookmarked).call(this, props));
	
	    _this.formatGroupChatName = _this.formatGroupChatName.bind(_this);
	    _this.renderCustomListAction = _this.renderCustomListAction.bind(_this);
	    return _this;
	  }
	
	  _createClass(GroupChatsBookmarked, [{
	    key: 'formatGroupChatName',
	    value: function formatGroupChatName(name, group) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'inline-block', marginRight: 4, fontSize: 14 } },
	          _react2.default.createElement(_group_chat_avatar2.default, { size: 30, initials: group.get('initials') })
	        ),
	        _react2.default.createElement(
	          'h5',
	          { style: { display: 'inline-block', fontSize: 14 } },
	          name
	        )
	      );
	    }
	  }, {
	    key: 'getAttrs',
	    value: function getAttrs() {
	      return [{ name: 'name', label: 'Group Chat', isSortable: true, isPrimary: true, formatter: this.formatGroupChatName }];
	    }
	  }, {
	    key: 'renderCustomListAction',
	    value: function renderCustomListAction(group) {
	      var width = this.props.viewportType === PHONE ? 'auto' : 250;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'group-chat-resource-actions', style: { width: width, textAlign: 'right' } },
	        _react2.default.createElement(_group_chat_bookmark_button2.default, { groupId: group.get('key'), style: { marginRight: 5 } }),
	        _react2.default.createElement(_group_chat_subscribe_button2.default, { groupId: group.get('key') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.groupChats && this.props.groupChats.size === 0) {
	        return _react2.default.createElement(
	          'div',
	          { style: { textAlign: 'center', margin: '10px auto' } },
	          'You don\'t have any bookmarked group chats.'
	        );
	      } else {
	        return _react2.default.createElement(_crud_list2.default, {
	          resources: this.props.groupChats,
	          attrs: this.getAttrs(),
	          isActionsEnabled: true,
	          isActionDetailsEnabled: false,
	          customAction: this.renderCustomListAction,
	          limit: 10 });
	      }
	    }
	  }]);
	
	  return GroupChatsBookmarked;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    groupChats: state.getIn(['groups', '_bookmarks', 'list']),
	    viewportType: state.getIn(['viewport', 'type'])
	  };
	};
	
	var GroupChatsBookmarkedContainer = (0, _reactRedux.connect)(mapStateToProps)(GroupChatsBookmarked);
	
	exports.default = GroupChatsBookmarkedContainer;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupChatsLists = function (_React$Component) {
	  _inherits(GroupChatsLists, _React$Component);
	
	  function GroupChatsLists(props) {
	    _classCallCheck(this, GroupChatsLists);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GroupChatsLists).call(this, props));
	
	    _this.state = {
	      activeSection: props.activeSection
	    };
	    return _this;
	  }
	
	  _createClass(GroupChatsLists, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ activeSection: this.props.activeSection });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.activeSection !== nextProps.activeSection) {
	        this.setState({ activeSection: this.props.activeSection });
	      }
	    }
	  }, {
	    key: 'changeToSection',
	    value: function changeToSection(section, e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      if (this.state.activeSection !== section) this.setState({ activeSection: section });
	    }
	  }, {
	    key: 'renderSectionsTabButtons',
	    value: function renderSectionsTabButtons() {
	      var _this2 = this;
	
	      return this.props.sections.map(function (section, index) {
	        if (typeof section.isActive === 'function' && !section.isActive()) return false;
	        if (section.isActive === false) return false;
	
	        return _react2.default.createElement(
	          'button',
	          {
	            key: index,
	            className: _this2.state.activeSection === index ? 'active' : '',
	            onClick: _this2.changeToSection.bind(_this2, index) },
	          section.label
	        );
	      });
	    }
	  }, {
	    key: 'renderSectionsTab',
	    value: function renderSectionsTab() {
	      return _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center', paddingBottom: 10 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'button-group large success' },
	          this.renderSectionsTabButtons()
	        )
	      );
	    }
	  }, {
	    key: 'renderActiveSection',
	    value: function renderActiveSection() {
	      return this.props.sections[this.state.activeSection].Content;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'group-chats-lists' },
	        this.renderSectionsTab(),
	        this.renderActiveSection()
	      );
	    }
	  }]);
	
	  return GroupChatsLists;
	}(_react2.default.Component);
	
	GroupChatsLists.defaultProps = {
	  activeSection: 0,
	  sections: []
	};
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	var GroupChatsListsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GroupChatsLists);
	
	exports.default = GroupChatsListsContainer;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _close_modal = __webpack_require__(46);
	
	var _close_modal2 = _interopRequireDefault(_close_modal);
	
	var _modal_view = __webpack_require__(47);
	
	var _modal_view2 = _interopRequireDefault(_modal_view);
	
	var _group_chats_lists = __webpack_require__(612);
	
	var _group_chats_lists2 = _interopRequireDefault(_group_chats_lists);
	
	var _group_chats_listed = __webpack_require__(695);
	
	var _group_chats_listed2 = _interopRequireDefault(_group_chats_listed);
	
	var _group_chats_subscribed = __webpack_require__(614);
	
	var _group_chats_subscribed2 = _interopRequireDefault(_group_chats_subscribed);
	
	var _group_chats_bookmarked = __webpack_require__(611);
	
	var _group_chats_bookmarked2 = _interopRequireDefault(_group_chats_bookmarked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupChatsModal = function (_React$Component) {
	  _inherits(GroupChatsModal, _React$Component);
	
	  function GroupChatsModal(props) {
	    _classCallCheck(this, GroupChatsModal);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GroupChatsModal).call(this, props));
	
	    _this.state = {
	      isActive: true
	    };
	
	    _this.isThereCurrentUser = _this.isThereCurrentUser.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	
	    _this.sections = [{
	      name: 'all',
	      label: 'All',
	      Content: _react2.default.createElement(_group_chats_listed2.default, null)
	    }, {
	      name: 'bookmarks',
	      label: 'My List',
	      isActive: _this.isThereCurrentUser,
	      Content: _react2.default.createElement(_group_chats_bookmarked2.default, null)
	    }, {
	      name: 'subscriptions',
	      label: 'Notifications',
	      isActive: _this.isThereCurrentUser,
	      Content: _react2.default.createElement(_group_chats_subscribed2.default, null)
	    }];
	    return _this;
	  }
	
	  _createClass(GroupChatsModal, [{
	    key: 'onClose',
	    value: function onClose(e) {
	      if (e) e.stopPropagation();
	
	      this.setState({ isActive: false });
	
	      this.props.closeModal(this.props.modalKey);
	    }
	  }, {
	    key: 'isThereCurrentUser',
	    value: function isThereCurrentUser() {
	      return this.props.currentUserUid ? true : false;
	    }
	  }, {
	    key: 'renderInnerSections',
	    value: function renderInnerSections() {
	      return _react2.default.createElement(_group_chats_lists2.default, { sections: this.sections, activeSection: 0 });
	    }
	  }, {
	    key: 'renderInfoLegend',
	    value: function renderInfoLegend() {
	      return _react2.default.createElement(
	        'div',
	        { style: { background: '#EFEFEF', padding: 10, marginTop: 10, borderRadius: 4 } },
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'table' } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'table-cell', width: 110, verticalAlign: 'middle' } },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-success btn-sm btn-stripped', style: { marginRight: 2, width: 101 } },
	              'Add to My List'
	            ),
	            ':'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'table-cell', verticalAlign: 'middle' } },
	            _react2.default.createElement(
	              'span',
	              { style: { display: 'inline-block', marginLeft: 5, fontSize: 12 } },
	              'Customize your list of chat rooms by adding or removing a room.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'table', marginTop: 5 } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'table-cell', width: 110, verticalAlign: 'middle' } },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-success btn-sm btn-stripped', style: { marginRight: 2, width: 101 } },
	              'Notifications'
	            ),
	            ':'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'table-cell', verticalAlign: 'middle' } },
	            _react2.default.createElement(
	              'span',
	              { style: { display: 'inline-block', marginLeft: 5, fontSize: 12 } },
	              'Get Instant, daily, or weekly email notifications for a specific chat room whenever other people are active in that room'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderModalContent',
	    value: function renderModalContent() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-header', style: { paddingTop: 10, paddingBottom: 10 } },
	          _react2.default.createElement(
	            'h6',
	            { style: { fontSize: 18, margin: 0 } },
	            'Listing All Group Chats'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-body' },
	          this.renderInnerSections(),
	          this.renderInfoLegend()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-footer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'actions right' },
	            _react2.default.createElement(
	              'div',
	              { className: 'cancel button default', onClick: this.onClose },
	              'Close'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _modal_view2.default,
	        { isActive: this.state.isActive, onClose: this.onClose, size: 'large' },
	        this.renderModalContent()
	      );
	    }
	  }]);
	
	  return GroupChatsModal;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentUserUid: state.getIn(['currentUser', 'uid'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    closeModal: function closeModal(modalKey) {
	      return dispatch((0, _close_modal2.default)(modalKey));
	    }
	  };
	};
	
	var GroupChatsModalContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GroupChatsModal);
	
	exports.default = GroupChatsModalContainer;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _crud_list = __webpack_require__(58);
	
	var _crud_list2 = _interopRequireDefault(_crud_list);
	
	var _group_chat_avatar = __webpack_require__(244);
	
	var _group_chat_avatar2 = _interopRequireDefault(_group_chat_avatar);
	
	var _group_chat_bookmark_button = __webpack_require__(274);
	
	var _group_chat_bookmark_button2 = _interopRequireDefault(_group_chat_bookmark_button);
	
	var _group_chat_subscribe_button = __webpack_require__(227);
	
	var _group_chat_subscribe_button2 = _interopRequireDefault(_group_chat_subscribe_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PHONE = _constants.VIEWPORT_TYPES.PHONE;
	
	var GroupChatsSubscribed = function (_React$Component) {
	  _inherits(GroupChatsSubscribed, _React$Component);
	
	  function GroupChatsSubscribed(props) {
	    _classCallCheck(this, GroupChatsSubscribed);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GroupChatsSubscribed).call(this, props));
	
	    _this.state = {
	      groupChats: (0, _immutable.fromJS)([])
	    };
	
	    _this.formatGroupChatName = _this.formatGroupChatName.bind(_this);
	    _this.onSortChange = _this.onSortChange.bind(_this);
	    _this.renderCustomListAction = _this.renderCustomListAction.bind(_this);
	    return _this;
	  }
	
	  _createClass(GroupChatsSubscribed, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setSubscribedGroupChats(this.props.subscriptions, this.props.groupChats);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props;
	      var subscriptions = _props.subscriptions;
	      var groupChats = _props.groupChats;
	      var nextSubscriptions = nextProps.subscriptions;
	      var nextGroupChats = nextProps.groupChats;
	
	
	      if (subscriptions !== nextSubscriptions || groupChats !== nextGroupChats) {
	        this.setSubscribedGroupChats(nextSubscriptions, nextGroupChats);
	      }
	    }
	  }, {
	    key: 'setSubscribedGroupChats',
	    value: function setSubscribedGroupChats(subscriptions, groupChats) {
	      groupChats = subscriptions.map(function (_, key) {
	        return groupChats.get(key);
	      }).toList();
	      groupChats = this.sortGroupChats('name', 'asc', groupChats);
	
	      var isThereSubscription = groupChats.size > 0 ? true : false;
	
	      this.setState({ groupChats: groupChats, isThereSubscription: isThereSubscription });
	    }
	  }, {
	    key: 'sortGroupChats',
	    value: function sortGroupChats(attr, order, groupChats) {
	      var sorter = function sorter(g) {
	        return typeof g.get(attr) === 'string' ? g.get(attr).toLowerCase() : g.get(attr);
	      };
	
	      groupChats = groupChats.sortBy(sorter);
	
	      if (order === 'desc') groupChats = groupChats.reverse();
	
	      return groupChats;
	    }
	  }, {
	    key: 'formatGroupChatName',
	    value: function formatGroupChatName(name, group) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'inline-block', marginRight: 4, fontSize: 14 } },
	          _react2.default.createElement(_group_chat_avatar2.default, { size: 30, initials: group.get('initials') })
	        ),
	        _react2.default.createElement(
	          'h5',
	          { style: { display: 'inline-block', fontSize: 14 } },
	          name
	        )
	      );
	    }
	  }, {
	    key: 'getAttrs',
	    value: function getAttrs() {
	      return [{ name: 'name', label: 'Group Chat', isSortable: true, isPrimary: true, formatter: this.formatGroupChatName }];
	    }
	  }, {
	    key: 'onSortChange',
	    value: function onSortChange(attr, order) {
	      var groupChats = this.sortGroupChats(attr, order, this.state.groupChats);
	
	      this.setState({ groupChats: groupChats });
	    }
	  }, {
	    key: 'renderCustomListAction',
	    value: function renderCustomListAction(group) {
	      var width = this.props.viewportType === PHONE ? 'auto' : 250;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'group-chat-resource-actions', style: { width: width, textAlign: 'right' } },
	        _react2.default.createElement(_group_chat_bookmark_button2.default, { groupId: group.get('key'), style: { marginRight: 5 } }),
	        _react2.default.createElement(_group_chat_subscribe_button2.default, { groupId: group.get('key') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.isThereSubscription === false) {
	        return _react2.default.createElement(
	          'div',
	          { style: { textAlign: 'center', margin: '10px auto' } },
	          'You don\'t have any subscribed group chats.'
	        );
	      } else {
	        return _react2.default.createElement(_crud_list2.default, {
	          resources: this.state.groupChats,
	          attrs: this.getAttrs(),
	          isActionsEnabled: true,
	          isActionDetailsEnabled: false,
	          customAction: this.renderCustomListAction,
	          onSortChange: this.onSortChange,
	          paginationStyle: { marginTop: 5, marginBottom: 5 },
	          limit: 10 });
	      }
	    }
	  }]);
	
	  return GroupChatsSubscribed;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var currentUserUid = state.getIn(['currentUser', 'uid']);
	  var subscriptions = state.getIn(['groups', '_subscriptions', 'users', currentUserUid]);
	
	  return {
	    subscriptions: subscriptions,
	    groupChats: state.getIn(['groups', 'all'], (0, _immutable.fromJS)({})),
	    viewportType: state.getIn(['viewport', 'type'])
	  };
	};
	
	var GroupChatsSubscribedContainer = (0, _reactRedux.connect)(mapStateToProps)(GroupChatsSubscribed);
	
	exports.default = GroupChatsSubscribedContainer;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _firebase = __webpack_require__(33);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _dev = __webpack_require__(40);
	
	var _dev2 = _interopRequireDefault(_dev);
	
	var _constants = __webpack_require__(2);
	
	var _close_modal = __webpack_require__(46);
	
	var _close_modal2 = _interopRequireDefault(_close_modal);
	
	var _modal_view = __webpack_require__(47);
	
	var _modal_view2 = _interopRequireDefault(_modal_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReportModal = function (_React$Component) {
	  _inherits(ReportModal, _React$Component);
	
	  function ReportModal(props) {
	    _classCallCheck(this, ReportModal);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReportModal).call(this, props));
	
	    _this.state = {
	      isActive: true
	    };
	    _this.onClose = _this.onClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReportModal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.reportUserRef) this.reportUserRef.off();
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose(e) {
	      if (e) e.stopPropagation();
	
	      this.setState({
	        isActive: false,
	        isReportModalSubmitted: false
	      });
	
	      this.props.closeModal(this.props.modalKey);
	    }
	  }, {
	    key: 'submitReport',
	    value: function submitReport(e) {
	      if (e) e.stopPropagation();
	
	      this.reportUser(this.props.reportee, { comment: this.refs.reportComment.value });
	      this.setState({ isReportModalSubmitted: true });
	    }
	  }, {
	    key: 'saveReportNotification',
	    value: function saveReportNotification(reporter, reportee, comment, time) {
	      var endpoint = '' + _dev2.default.firebaseUrl + _constants.REPORT_NOTIFICATIONS_ENDPOINT;
	      var ref = new _firebase2.default(endpoint);
	
	      ref.push({
	        to: reportee.get('uid'),
	        from: reporter.get('uid'),
	        read: false,
	        time: time,
	        _isNotifServiceRead: false,
	        payload: {
	          comment: comment,
	          reporter: {
	            name: reporter.get('name'),
	            uid: reporter.get('uid')
	          },
	          reportee: {
	            name: reportee.get('name'),
	            uid: reportee.get('uid')
	          }
	        }
	      });
	    }
	  }, {
	    key: 'reportUser',
	    value: function reportUser(reportee, _ref) {
	      var _this2 = this;
	
	      var comment = _ref.comment;
	
	      if (this.props.currentUser && (typeof reportee === 'undefined' ? 'undefined' : _typeof(reportee)) === 'object') {
	        var endpoint = '' + _dev2.default.firebaseUrl + (0, _constants.USER_REPORTS_ENDPOINT)(reportee.get('uid'));
	        this.reportUserRef = new _firebase2.default(endpoint);
	
	        this.reportUserRef.push({
	          reporter: this.props.currentUser.get('uid'),
	          comment: comment,
	          time: _firebase2.default.ServerValue.TIMESTAMP
	        }).then(function (ref) {
	          ref.child('time').once('value').then(function (snapshot) {
	            if (snapshot.val()) {
	              _this2.saveReportNotification(_this2.props.currentUser, reportee, comment, snapshot.val());
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: 'renderModalContent',
	    value: function renderModalContent() {
	      if (this.state.isReportModalSubmitted) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-header' },
	            _react2.default.createElement(
	              'h3',
	              { style: { fontSize: 18, margin: '10px 0' } },
	              'Report User'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-body' },
	            _react2.default.createElement(
	              'div',
	              { className: 'alert success alert-success' },
	              'You have reported this user.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-footer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'actions right' },
	              _react2.default.createElement(
	                'div',
	                { className: 'cancel button default', onClick: this.onClose.bind(this) },
	                'Close'
	              )
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-header' },
	            _react2.default.createElement(
	              'h3',
	              { style: { fontSize: 18, margin: '10px 0' } },
	              'Report User'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-body' },
	            _react2.default.createElement(
	              'div',
	              { className: 'alert danger alert-danger' },
	              'You are about to report this user as an abusive member of the community. Please provide us with a comment as to why you are reporting this user.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form', style: { width: '100%' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-element', style: { width: '100%' } },
	                _react2.default.createElement('textarea', { ref: 'reportComment', placeholder: 'Your comment...', style: { height: '100px', width: '100%', borderColor: '#EEEEEE', borderRadius: '4px', padding: '5px 10px' } })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-footer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'actions right' },
	              _react2.default.createElement(
	                'div',
	                { className: 'button danger', onClick: this.submitReport.bind(this) },
	                'Submit report'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'cancel button default', onClick: this.onClose.bind(this) },
	                'Cancel'
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _modal_view2.default,
	        { isActive: this.state.isActive, onClose: this.onClose },
	        this.renderModalContent()
	      );
	    }
	  }]);
	
	  return ReportModal;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentUser: state.get('currentUser')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    closeModal: function closeModal(modalKey) {
	      return dispatch((0, _close_modal2.default)(modalKey));
	    }
	  };
	};
	
	var ReportModalContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReportModal);
	
	exports.default = ReportModalContainer;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(2);
	
	var _credit_card_form = __webpack_require__(601);
	
	var _credit_card_form2 = _interopRequireDefault(_credit_card_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SessionCheckoutForm = function (_React$Component) {
	  _inherits(SessionCheckoutForm, _React$Component);
	
	  function SessionCheckoutForm() {
	    _classCallCheck(this, SessionCheckoutForm);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(SessionCheckoutForm).apply(this, arguments));
	  }
	
	  _createClass(SessionCheckoutForm, [{
	    key: 'calculateTotalAmount',
	    value: function calculateTotalAmount() {
	      var minutes = this.props.bookData.requestData.get('sessionLength');
	
	      if (minutes === _constants.PAY_AS_YOU_GO_VALUE) return _constants.PAY_AS_YOU_GO_VALUE;
	
	      var expertRateByMinute = parseInt(this.props.expert.get('hourlyRate'), 10) / 60;
	
	      return minutes * expertRateByMinute;
	    }
	  }, {
	    key: 'renderAmountSection',
	    value: function renderAmountSection() {
	      if (this.props.bookData && this.props.bookData.requestData.get('sessionLength') === _constants.PAY_AS_YOU_GO_VALUE) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'section' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'PAY AS YOU GO'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Your card will be charged at the conclusion of your session.'
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Total amount: ',
	          _react2.default.createElement(
	            'b',
	            null,
	            '$',
	            this.calculateTotalAmount()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'book-session' },
	        this.renderAmountSection(),
	        _react2.default.createElement(
	          'div',
	          { className: 'section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'gray-box' },
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: 10 } },
	              'Please enter your credit card information.'
	            ),
	            _react2.default.createElement(_credit_card_form2.default, {
	              amount: this.calculateTotalAmount(),
	              sessionId: this.props.bookData.sessionId,
	              sessionLength: this.props.bookData.requestData.get('sessionLength'),
	              sessionStartTime: this.props.bookData.requestData.get('startTime'),
	              type: this.props.bookData.requestData.get('type'),
	              expert: this.props.expert,
	              expertUid: this.props.expert.get('uid'),
	              expertName: this.props.expert.get('name'),
	              user: this.props.user,
	              userUid: this.props.user.get('uid'),
	              userName: this.props.user.get('name'),
	              sendPayoutRequest: this.props.sendPayoutRequest,
	              setLaterSessionSideEffects: this.props.setLaterSessionSideEffects,
	              setImmediateSessionSideEffects: this.props.setImmediateSessionSideEffects,
	              onCheckoutComplete: this.props.onCheckoutComplete })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SessionCheckoutForm;
	}(_react2.default.Component);
	
	exports.default = SessionCheckoutForm;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _close_modal = __webpack_require__(46);
	
	var _close_modal2 = _interopRequireDefault(_close_modal);
	
	var _modal_view = __webpack_require__(47);
	
	var _modal_view2 = _interopRequireDefault(_modal_view);
	
	var _start_session_form = __webpack_require__(618);
	
	var _start_session_form2 = _interopRequireDefault(_start_session_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SessionInitiateModal = function (_React$Component) {
	  _inherits(SessionInitiateModal, _React$Component);
	
	  function SessionInitiateModal(props) {
	    _classCallCheck(this, SessionInitiateModal);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SessionInitiateModal).call(this, props));
	
	    _this.onClose = _this.onClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(SessionInitiateModal, [{
	    key: 'onClose',
	    value: function onClose(e) {
	      if (e) e.stopPropagation();
	
	      this.props.closeModal(this.props.modalKey);
	    }
	  }, {
	    key: 'renderModalContent',
	    value: function renderModalContent() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'session-initiate-modal-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-header' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Start premium session with ',
	            this.props.expert.get('name')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-body', style: { padding: 0 } },
	          _react2.default.createElement(_start_session_form2.default, { expert: this.props.expert, bookData: this.props.bookData })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-footer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'actions right' },
	            _react2.default.createElement(
	              'div',
	              { className: 'cancel button default', onClick: this.onClose },
	              'Close'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _modal_view2.default,
	        { isActive: true, onClose: this.onClose },
	        this.renderModalContent()
	      );
	    }
	  }]);
	
	  return SessionInitiateModal;
	}(_react2.default.Component);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    closeModal: function closeModal(modalKey) {
	      return dispatch((0, _close_modal2.default)(modalKey));
	    }
	  };
	};
	
	var SessionInitiateModalContainer = (0, _reactRedux.connect)(null, mapDispatchToProps)(SessionInitiateModal);
	
	exports.default = SessionInitiateModalContainer;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StartSessionFormStep = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _session_booker = __webpack_require__(700);
	
	var _session_booker2 = _interopRequireDefault(_session_booker);
	
	var _session_book_confirmation = __webpack_require__(697);
	
	var _session_book_confirmation2 = _interopRequireDefault(_session_book_confirmation);
	
	var _session_checkout_form = __webpack_require__(616);
	
	var _session_checkout_form2 = _interopRequireDefault(_session_checkout_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO: refactor this to its own module.
	
	var StartSessionFormStep = exports.StartSessionFormStep = function (_React$Component) {
	  _inherits(StartSessionFormStep, _React$Component);
	
	  function StartSessionFormStep() {
	    _classCallCheck(this, StartSessionFormStep);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(StartSessionFormStep).apply(this, arguments));
	  }
	
	  _createClass(StartSessionFormStep, [{
	    key: 'renderCompletedIcon',
	    value: function renderCompletedIcon() {
	      if (this.props.isCompleted && !this.props.isActive) {
	        return _react2.default.createElement('i', { className: 'completed-icon rc-icon-check' });
	      }
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      if (this.props.isActive) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'step-body' },
	          this.props.children
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'start-session-step ' + (this.props.isActive ? 'active' : '') },
	        _react2.default.createElement(
	          'div',
	          { className: 'step-header' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'step-title' },
	            _react2.default.createElement(
	              'span',
	              null,
	              '(',
	              this.props.step,
	              ') ',
	              this.props.title
	            ),
	            this.renderCompletedIcon()
	          )
	        ),
	        this.renderBody()
	      );
	    }
	  }]);
	
	  return StartSessionFormStep;
	}(_react2.default.Component);
	
	var StartSessionForm = function (_React$Component2) {
	  _inherits(StartSessionForm, _React$Component2);
	
	  function StartSessionForm(props) {
	    _classCallCheck(this, StartSessionForm);
	
	    var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(StartSessionForm).call(this, props));
	
	    _this2.state = {
	      activeStep: 1,
	      sessionBookData: null
	    };
	
	    _this2.onSessionBook = _this2.onSessionBook.bind(_this2);
	    _this2.onCheckoutComplete = _this2.onCheckoutComplete.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(StartSessionForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.bookData) {
	        this.setState({
	          activeStep: 2,
	          sessionBookData: this.props.bookData.toObject()
	        });
	      }
	    }
	  }, {
	    key: 'onSessionBook',
	    value: function onSessionBook(sessionBookData) {
	      this.setState({
	        sessionBookData: sessionBookData,
	        activeStep: 2
	      });
	    }
	  }, {
	    key: 'onCheckoutComplete',
	    value: function onCheckoutComplete(payoutRequestData) {
	      this.setState({
	        sessionPayoutRequestData: payoutRequestData,
	        activeStep: 3
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'start-session-form' },
	        _react2.default.createElement(
	          StartSessionFormStep,
	          {
	            step: 1,
	            isActive: this.state.activeStep === 1,
	            isCompleted: this.state.activeStep > 1,
	            title: 'Choose your time' },
	          _react2.default.createElement(_session_booker2.default, {
	            expert: this.props.expert,
	            currentUser: this.props.currentUser,
	            onSessionBook: this.onSessionBook })
	        ),
	        _react2.default.createElement(
	          StartSessionFormStep,
	          {
	            step: 2,
	            isActive: this.state.activeStep === 2,
	            isCompleted: this.state.activeStep > 2,
	            title: 'Checkout' },
	          _react2.default.createElement(_session_checkout_form2.default, {
	            expert: this.props.expert,
	            user: this.props.currentUser,
	            bookData: this.state.sessionBookData,
	            onCheckoutComplete: this.onCheckoutComplete })
	        ),
	        _react2.default.createElement(
	          StartSessionFormStep,
	          {
	            step: 3,
	            isActive: this.state.activeStep === 3,
	            isCompleted: this.state.activeStep > 3,
	            title: 'Confirmation' },
	          _react2.default.createElement(_session_book_confirmation2.default, {
	            expert: this.props.expert,
	            currentUser: this.props.currentUser,
	            sessionPayoutRequestData: this.state.sessionPayoutRequestData,
	            bookData: this.state.sessionBookData })
	        )
	      );
	    }
	  }]);
	
	  return StartSessionForm;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentUser: state.get('currentUser')
	  };
	};
	
	var StartSessionFormContainer = (0, _reactRedux.connect)(mapStateToProps)(StartSessionForm);
	
	exports.default = StartSessionFormContainer;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _close_modal = __webpack_require__(46);
	
	var _close_modal2 = _interopRequireDefault(_close_modal);
	
	var _show_modal = __webpack_require__(16);
	
	var _show_modal2 = _interopRequireDefault(_show_modal);
	
	var _modal_view = __webpack_require__(47);
	
	var _modal_view2 = _interopRequireDefault(_modal_view);
	
	var _profile_image = __webpack_require__(45);
	
	var _profile_image2 = _interopRequireDefault(_profile_image);
	
	var _role_indicator = __webpack_require__(276);
	
	var _role_indicator2 = _interopRequireDefault(_role_indicator);
	
	var _expert_rating = __webpack_require__(78);
	
	var _expert_rating2 = _interopRequireDefault(_expert_rating);
	
	var _expert_sessions_count = __webpack_require__(273);
	
	var _expert_sessions_count2 = _interopRequireDefault(_expert_sessions_count);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ADMIN = _constants.ROLES.ADMIN;
	var EXPERT = _constants.ROLES.EXPERT;
	
	var UserProfileModal = function (_React$Component) {
	  _inherits(UserProfileModal, _React$Component);
	
	  function UserProfileModal(props) {
	    _classCallCheck(this, UserProfileModal);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(UserProfileModal).call(this, props));
	
	    _this.state = {
	      isActive: true
	    };
	
	    _this.onClose = _this.onClose.bind(_this);
	    _this.onReportClick = _this.onReportClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserProfileModal, [{
	    key: 'onClose',
	    value: function onClose(e) {
	      if (e) e.stopPropagation();
	
	      this.setState({
	        isActive: false
	      });
	
	      this.props.closeModal(this.props.modalKey);
	    }
	  }, {
	    key: 'onReportClick',
	    value: function onReportClick(e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      this.props.showModal({ type: 'report', props: { reportee: this.props.user } });
	    }
	  }, {
	    key: 'renderDetailRow',
	    value: function renderDetailRow(label, content) {
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'table-row' } },
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'table-cell', textAlign: 'right', fontWeight: 'bold', width: '30%' } },
	          label
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'table-cell', textAlign: 'left', width: '70%' } },
	          content
	        )
	      );
	    }
	  }, {
	    key: 'renderExpertDetails',
	    value: function renderExpertDetails() {
	      if (this.props.user.get('role') === EXPERT) {
	        var content = [];
	
	        content.push(this.renderDetailRow('Rating:', _react2.default.createElement(_expert_rating2.default, { rating: this.props.user.get('rating') })));
	        content.push(this.renderDetailRow('Sessions:', _react2.default.createElement(_expert_sessions_count2.default, { uid: this.props.user.get('uid') })));
	
	        if (this.props.user.get('specialty')) {
	          content.push(this.renderDetailRow('Specialty:', this.props.user.get('specialty')));
	        }
	
	        return content;
	      }
	    }
	  }, {
	    key: 'renderUserDetails',
	    value: function renderUserDetails() {
	      var RoleDetails = _react2.default.createElement(_role_indicator2.default, { role: this.props.user.get('role'), size: 14 });
	
	      return this.renderDetailRow('Role:', RoleDetails);
	    }
	  }, {
	    key: 'renderDetails',
	    value: function renderDetails() {
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'table', margin: 'auto', borderSpacing: 10, fontSize: 16 } },
	        this.renderUserDetails(),
	        this.renderExpertDetails()
	      );
	    }
	  }, {
	    key: 'renderReportButton',
	    value: function renderReportButton() {
	      if (this.props.user && this.props.user.get('role') === ADMIN) return false;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'button danger stripped', onClick: this.onReportClick },
	        'Report User'
	      );
	    }
	  }, {
	    key: 'renderModalContent',
	    value: function renderModalContent() {
	      if (this.props.user) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-header', style: { textAlign: 'center' } },
	            _react2.default.createElement(
	              'div',
	              { style: { margin: '0 auto' } },
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'inline-block', marginRight: 5 } },
	                _react2.default.createElement(_profile_image2.default, { user: this.props.user.toJS(), image: this.props.user.get('profileImage') })
	              ),
	              _react2.default.createElement(
	                'h4',
	                { style: { display: 'inline-block' } },
	                this.props.user.get('name')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-body', style: { paddingTop: 10 } },
	            this.renderDetails()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-footer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'actions right' },
	              this.renderReportButton(),
	              _react2.default.createElement(
	                'div',
	                { className: 'cancel button default', onClick: this.onClose },
	                'Cancel'
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _modal_view2.default,
	        { isActive: this.state.isActive, onClose: this.onClose },
	        this.renderModalContent()
	      );
	    }
	  }]);
	
	  return UserProfileModal;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    user: state.getIn(['users', ownProps.uid])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    closeModal: function closeModal(modalKey) {
	      return dispatch((0, _close_modal2.default)(modalKey));
	    },
	    showModal: function showModal(modal) {
	      return dispatch((0, _show_modal2.default)(modal));
	    }
	  };
	};
	
	var UserProfileModalContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserProfileModal);
	
	exports.default = UserProfileModalContainer;

/***/ },
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConversationMessageInformer = function (_React$Component) {
	  _inherits(ConversationMessageInformer, _React$Component);
	
	  function ConversationMessageInformer(props) {
	    _classCallCheck(this, ConversationMessageInformer);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConversationMessageInformer).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ConversationMessageInformer, [{
	    key: 'render',
	    value: function render() {
	      var content = this.props.message || this.props.children;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'conversation-message-informer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'conversation-seperator-helper' },
	          content
	        )
	      );
	    }
	  }]);
	
	  return ConversationMessageInformer;
	}(_react2.default.Component);
	
	exports.default = ConversationMessageInformer;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _verge = __webpack_require__(86);
	
	var _verge2 = _interopRequireDefault(_verge);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (containerHeight, headerHeight, secondaryHeaderHeight, actionsHeight) {
	  if (_verge2.default.viewportW() <= _constants.VIEWPORT_MAX_WIDTH_PHONE) containerHeight = window.innerHeight;
	
	  return containerHeight - (headerHeight + secondaryHeaderHeight + actionsHeight);
	};

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _message_counts = __webpack_require__(1032);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnreadMessageCount = function (_React$Component) {
	  _inherits(UnreadMessageCount, _React$Component);
	
	  function UnreadMessageCount() {
	    _classCallCheck(this, UnreadMessageCount);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(UnreadMessageCount).apply(this, arguments));
	  }
	
	  _createClass(UnreadMessageCount, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props;
	      var uid = _props.uid;
	      var conversationId = _props.conversationId;
	
	
	      if (uid && conversationId) {
	        this.props.watchMessageCounts(uid, conversationId);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props2 = this.props;
	      var uid = _props2.uid;
	      var conversationId = _props2.conversationId;
	      var nextUid = nextProps.uid;
	      var nextConversationId = nextProps.conversationId;
	
	
	      if (uid !== nextUid || conversationId !== nextConversationId) {
	        this.props.rewatchMessageCounts(uid, conversationId, nextUid, nextConversationId);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props3 = this.props;
	      var uid = _props3.uid;
	      var conversationId = _props3.conversationId;
	
	
	      if (uid && conversationId) {
	        this.props.unwatchMessageCounts(uid, conversationId);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.shouldShowUnreadMessageCount && this.props.unreadMessageCount > 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'unread-messages-count' },
	          this.props.unreadMessageCount < 100 ? this.props.unreadMessageCount : '99+'
	        );
	      } else {
	        return false;
	      }
	    }
	  }]);
	
	  return UnreadMessageCount;
	}(_react2.default.Component);
	
	UnreadMessageCount.defaultProps = {
	  unreadMessageCount: 0
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    unreadMessageCount: state.getIn(['conversations', '_counts', ownProps.conversationId, 'unread'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    watchMessageCounts: _message_counts.watchMessageCounts,
	    unwatchMessageCounts: _message_counts.unwatchMessageCounts,
	    rewatchMessageCounts: function rewatchMessageCounts(uid, conversationId, nextUid, nextConversationId) {
	      if (uid && conversationId) (0, _message_counts.unwatchMessageCounts)(uid, conversationId);
	      if (nextUid && nextConversationId) (0, _message_counts.watchMessageCounts)(nextUid, nextConversationId);
	    }
	  };
	};
	
	var UnreadMessageCountContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UnreadMessageCount);
	
	exports.default = UnreadMessageCountContainer;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(7);
	
	var _reactGooglePublisherTag = __webpack_require__(579);
	
	var _reactGooglePublisherTag2 = _interopRequireDefault(_reactGooglePublisherTag);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatBotSlotAdvertisement = function (_React$Component) {
	  _inherits(ChatBotSlotAdvertisement, _React$Component);
	
	  function ChatBotSlotAdvertisement(props) {
	    _classCallCheck(this, ChatBotSlotAdvertisement);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatBotSlotAdvertisement).call(this, props));
	
	    _this.state = {};
	
	    _this.adjustAdvSize = _this.adjustAdvSize.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChatBotSlotAdvertisement, [{
	    key: 'adjustAdvSize',
	    value: function adjustAdvSize() {
	      if (this.refs.adContainer) {
	        var width = this.refs.adContainer.offsetWidth;
	
	        var dimensions = this.getScaledDimensions(this.props.heightSlot, width, this.props.dimensions);
	
	        var iframe = _reactDom2.default.findDOMNode(this.refs.adContainer).querySelector('iframe');
	
	        if (iframe) {
	          var img = iframe.contentDocument.querySelector('img');
	
	          iframe.width = dimensions[0];
	          iframe.height = dimensions[1];
	
	          if (img) {
	            img.width = dimensions[0];
	            img.height = dimensions[1];
	          }
	        }
	      }
	    }
	  }, {
	    key: 'getAdPath',
	    value: function getAdPath() {
	      return '/' + this.props.networkId + '/' + this.props.tagId;
	    }
	  }, {
	    key: 'getScaledDimensions',
	    value: function getScaledDimensions() {
	      var heightSlot = arguments.length <= 0 || arguments[0] === undefined ? this.props.heightSlot : arguments[0];
	      var width = arguments.length <= 1 || arguments[1] === undefined ? this.props.maxWidth : arguments[1];
	      var dimensions = arguments.length <= 2 || arguments[2] === undefined ? this.props.dimensions : arguments[2];
	
	      var scaledDimensions = this.getDimensions(heightSlot, width, dimensions);
	
	      if (scaledDimensions[0] < width) width = scaledDimensions[0];
	
	      var height = scaledDimensions[1] / scaledDimensions[0] * width;
	
	      return [width, height];
	    }
	  }, {
	    key: 'getDimensions',
	    value: function getDimensions() {
	      var heightSlot = arguments.length <= 0 || arguments[0] === undefined ? this.props.heightSlot : arguments[0];
	      var width = arguments.length <= 1 || arguments[1] === undefined ? this.props.maxWidth : arguments[1];
	      var dimensions = arguments.length <= 2 || arguments[2] === undefined ? this.props.dimensions : arguments[2];
	      var square = dimensions.square;
	      var mobile = dimensions.mobile;
	      var desktop = dimensions.leaderboard;
	
	
	      if (heightSlot === square[1]) {
	        return square;
	      } else if (width > mobile[0]) {
	        return desktop;
	      } else {
	        return mobile;
	      }
	    }
	  }, {
	    key: 'getClassName',
	    value: function getClassName() {
	      return 'rchat-ad-chat-bot-slot';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.tagId || !this.props.networkId) return false;
	      if (this.props.isModerated === true && this.props.isModeratedEnabled === false) return false;
	
	      var _getScaledDimensions = this.getScaledDimensions();
	
	      var _getScaledDimensions2 = _slicedToArray(_getScaledDimensions, 2);
	
	      var width = _getScaledDimensions2[0];
	      var height = _getScaledDimensions2[1];
	
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'adContainer', style: { width: width, height: height } },
	        _react2.default.createElement(_reactGooglePublisherTag2.default, {
	          ref: 'ad', path: this.getAdPath(),
	          dimensions: this.getDimensions(), responsive: false,
	          canBeLower: false,
	          className: this.getClassName(),
	          onSlotRenderEnded: this.adjustAdvSize,
	          onImpressionViewable: this.adjustAdvSize })
	      );
	    }
	  }]);
	
	  return ChatBotSlotAdvertisement;
	}(_react2.default.Component);
	
	ChatBotSlotAdvertisement.defaultProps = {
	  maxWidth: 218,
	  dimensions: {
	    square: [300, 250],
	    mobile: [320, 50],
	    leaderboard: [728, 90]
	  },
	  target: 'chatPane'
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    tagId: state.getIn(['advertisements', 'chatBotSlot', 'tagId']),
	    networkId: state.getIn(['advertisements', 'settings', 'networkId']),
	    heightSlot: state.getIn(['advertisements', 'chatBotSlot', 'advHeight']),
	    isModeratedEnabled: state.getIn(['advertisements', 'settings', 'isModeratedGroupChatEnabled'])
	  };
	};
	
	var ChatBotSlotAdvertisementContainer = (0, _reactRedux.connect)(mapStateToProps)(ChatBotSlotAdvertisement);
	
	exports.default = ChatBotSlotAdvertisementContainer;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _chat_bot_slot_advertisement = __webpack_require__(640);
	
	var _chat_bot_slot_advertisement2 = _interopRequireDefault(_chat_bot_slot_advertisement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdvertisementMessageItem = function (_React$Component) {
	  _inherits(AdvertisementMessageItem, _React$Component);
	
	  function AdvertisementMessageItem(props) {
	    _classCallCheck(this, AdvertisementMessageItem);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AdvertisementMessageItem).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(AdvertisementMessageItem, [{
	    key: 'getDominantBubbleColor',
	    value: function getDominantBubbleColor() {
	      return this.props.side === 'receiver' ? this.props.receiverBubbleBackgroundColor : this.props.senderBubbleBackgroundColor;
	    }
	  }, {
	    key: 'classNames',
	    value: function classNames() {
	      return 'message-item advertisement-message';
	    }
	  }, {
	    key: 'renderMessage',
	    value: function renderMessage() {
	      return _react2.default.createElement(_chat_bot_slot_advertisement2.default, { maxWidth: this.props.maxBubbleWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: this.classNames() },
	        _react2.default.createElement(
	          'div',
	          { className: 'chat-bubble', style: { color: this.props.textColor, backgroundColor: this.getDominantBubbleColor(), maxWidth: this.props.maxBubbleWidth } },
	          this.renderMessage()
	        )
	      );
	    }
	  }]);
	
	  return AdvertisementMessageItem;
	}(_react2.default.Component);
	
	AdvertisementMessageItem.defaultProps = {
	  maxBubbleWidth: 218,
	  isRichMessageContentEnabled: false,
	  shouldShowTriangle: true
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    textColor: state.getIn(['chatSettings', 'colors', 'conversation', 'messageColor']),
	    senderBubbleBackgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'senderBubbleBackground']),
	    receiverBubbleBackgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'receiverBubbleBackground'])
	  };
	};
	
	var AdvertisementMessageItemContainer = (0, _reactRedux.connect)(mapStateToProps)(AdvertisementMessageItem);
	
	exports.default = AdvertisementMessageItemContainer;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
	
	var InlineNotification = function InlineNotification(props) {
	  // return (
	  //   <div className='inline-notification'>
	  //     <ReactCSSTransitionGroup
	  //       transitionName='coming-from-bottom'
	  //       transitionAppear={true}
	  //       transitionEnterTimeout={200}
	  //       transitionLeaveTimeout={200}
	  //       transitionAppearTimeout={200}>
	  //       <div key={0} className='inline-notification-wrapper' onClick={props.onClick}>
	  //         {props.children}
	  //       </div>
	  //     </ReactCSSTransitionGroup>
	  //   </div>
	  // )
	  return _react2.default.createElement(
	    'div',
	    { className: 'inline-notification' },
	    _react2.default.createElement(
	      'div',
	      { key: 0, className: 'inline-notification-wrapper', onClick: props.onClick },
	      props.children
	    )
	  );
	};
	
	exports.default = InlineNotification;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _approve_moderated_message = __webpack_require__(670);
	
	var _approve_moderated_message2 = _interopRequireDefault(_approve_moderated_message);
	
	var _disapprove_moderated_message = __webpack_require__(673);
	
	var _disapprove_moderated_message2 = _interopRequireDefault(_disapprove_moderated_message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MessageApprovalActions = function MessageApprovalActions(props) {
	  var ApproveBtn = _react2.default.createElement(
	    'button',
	    {
	      className: 'approval-action btn btn-sm btn-success',
	      onClick: props.approveMessage },
	    _react2.default.createElement('i', { className: 'rc-icon-check' })
	  );
	
	  var DisapproveBtn = _react2.default.createElement(
	    'button',
	    {
	      className: 'approval-action btn btn-sm btn-danger',
	      onClick: props.disapproveMessage },
	    _react2.default.createElement('i', { className: 'rc-icon-close' })
	  );
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'message-approval-actions' },
	    ApproveBtn,
	    DisapproveBtn
	  );
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	  return {
	    approveMessage: function approveMessage() {
	      return (0, _approve_moderated_message2.default)(ownProps.containerId, ownProps.messageId);
	    },
	    disapproveMessage: function disapproveMessage() {
	      return (0, _disapprove_moderated_message2.default)(ownProps.containerId, ownProps.messageId);
	    }
	  };
	};
	
	var MessageApprovalActionsContainer = (0, _reactRedux.connect)(null, mapDispatchToProps)(MessageApprovalActions);
	
	exports.default = MessageApprovalActionsContainer;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _rich_media_container = __webpack_require__(462);
	
	var _rich_media_container2 = _interopRequireDefault(_rich_media_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageItem = function (_React$Component) {
	  _inherits(MessageItem, _React$Component);
	
	  function MessageItem(props) {
	    _classCallCheck(this, MessageItem);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MessageItem).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(MessageItem, [{
	    key: 'getDominantBubbleColor',
	    value: function getDominantBubbleColor() {
	      return this.props.side === 'receiver' ? this.props.receiverBubbleBackgroundColor : this.props.senderBubbleBackgroundColor;
	    }
	  }, {
	    key: 'classNames',
	    value: function classNames() {
	      return 'message-item';
	    }
	  }, {
	    key: 'renderRichMessage',
	    value: function renderRichMessage() {
	      return _react2.default.createElement(_rich_media_container2.default, {
	        isHidden: this.props.isHidden,
	        content: this.props.message.get('message'),
	        onHeightChange: this.props.onMessageItemHeightChange });
	    }
	  }, {
	    key: 'renderSimpleMessage',
	    value: function renderSimpleMessage() {
	      return this.props.message.get('message');
	    }
	  }, {
	    key: 'renderMessage',
	    value: function renderMessage() {
	      if (this.props.isRichMessageContentEnabled) {
	        return this.renderRichMessage();
	      } else {
	        return this.renderSimpleMessage();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: this.classNames() },
	        _react2.default.createElement(
	          'div',
	          { className: 'chat-bubble', style: { color: this.props.textColor, backgroundColor: this.getDominantBubbleColor(), maxWidth: '100%' } },
	          _react2.default.createElement('div', { className: 'triangle', style: { borderTopColor: this.getDominantBubbleColor(), visibility: this.props.shouldShowTriangle ? 'visible' : 'hidden' } }),
	          this.renderMessage()
	        )
	      );
	    }
	  }]);
	
	  return MessageItem;
	}(_react2.default.Component);
	
	MessageItem.defaultProps = {
	  isRichMessageContentEnabled: true,
	  shouldShowTriangle: false
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    textColor: state.getIn(['chatSettings', 'colors', 'conversation', 'messageColor']),
	    senderBubbleBackgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'senderBubbleBackground']),
	    receiverBubbleBackgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'receiverBubbleBackground'])
	  };
	};
	
	var MessageItemContainer = (0, _reactRedux.connect)(mapStateToProps)(MessageItem);
	
	exports.default = MessageItemContainer;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _truncate_string = __webpack_require__(77);
	
	var _truncate_string2 = _interopRequireDefault(_truncate_string);
	
	var _message_time = __webpack_require__(498);
	
	var _message_time2 = _interopRequireDefault(_message_time);
	
	var _advertisement_message_item = __webpack_require__(641);
	
	var _advertisement_message_item2 = _interopRequireDefault(_advertisement_message_item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessagesAdvertisementBatch = function (_React$Component) {
	  _inherits(MessagesAdvertisementBatch, _React$Component);
	
	  function MessagesAdvertisementBatch(props) {
	    _classCallCheck(this, MessagesAdvertisementBatch);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MessagesAdvertisementBatch).call(this, props));
	
	    _this.state = {};
	
	    _this.renderMessageBatch = _this.renderMessageBatch.bind(_this);
	    _this.renderMessageItem = _this.renderMessageItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(MessagesAdvertisementBatch, [{
	    key: 'renderMessageItem',
	    value: function renderMessageItem(side, message, index) {
	      return _react2.default.createElement(_advertisement_message_item2.default, {
	        key: message.get('key'),
	        message: message,
	        side: side,
	        containerId: this.props.containerId,
	        maxBubbleWidth: this.props.maxBubbleWidth,
	        shouldShowTriangle: true });
	    }
	  }, {
	    key: 'renderMessageBatch',
	    value: function renderMessageBatch(side) {
	      var messages = this.props.batch.get('messages') || (0, _immutable.fromJS)([]);
	
	      if (messages && messages.size > 0) {
	        return messages.map(this.renderMessageItem.bind(this, side));
	      } else {
	        return messages;
	      }
	    }
	  }, {
	    key: 'renderProfileImage',
	    value: function renderProfileImage() {
	      if (this.props.profileImage) {
	        return _react2.default.createElement(
	          'div',
	          { style: { width: 32, height: 32, borderSpacing: 0, verticalAlign: 'top', borderRadius: '50%' } },
	          _react2.default.createElement('div', { style: { width: 32, height: 32, borderRadius: '50%', backgroundColor: '#BABABA', backgroundImage: 'url(\'' + this.props.profileImage + '\')', backgroundPosition: 'center', backgroundSize: 'cover' } })
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('div', { style: { width: 32, height: 32, background: '#BABABA', borderRadius: '50%' } })
	        );
	      }
	    }
	  }, {
	    key: 'renderUserNameDetail',
	    value: function renderUserNameDetail() {
	      var userName = (0, _truncate_string2.default)(this.props.userName, 30);
	      return userName;
	    }
	  }, {
	    key: 'renderUserName',
	    value: function renderUserName() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'message-batch-username' },
	        this.renderUserNameDetail()
	      );
	    }
	  }, {
	    key: 'renderLastMessageTime',
	    value: function renderLastMessageTime() {
	      var time = this.props.batch.get('lastMessageTime');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'message-batch-time' },
	        (0, _message_time2.default)(time)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.currentUser.get('uid') === this.props.batch.get('from')) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'message-batch right' },
	          _react2.default.createElement(
	            'div',
	            null,
	            this.renderMessageBatch('receiver'),
	            this.renderLastMessageTime()
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'message-batch' },
	          this.renderProfileImage(),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.renderUserName(),
	            this.renderMessageBatch('sender'),
	            this.renderLastMessageTime()
	          )
	        );
	      }
	    }
	  }]);
	
	  return MessagesAdvertisementBatch;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    userName: state.getIn(['advertisements', 'chatBotSlot', 'chatBotName']),
	    profileImage: state.getIn(['advertisements', 'chatBotSlot', 'chatBotProfileImage']),
	    currentUser: state.get('currentUser', (0, _immutable.fromJS)({}))
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    showModal: function (_showModal) {
	      function showModal(_x) {
	        return _showModal.apply(this, arguments);
	      }
	
	      showModal.toString = function () {
	        return _showModal.toString();
	      };
	
	      return showModal;
	    }(function (modal) {
	      return dispatch(showModal(modal));
	    })
	  };
	};
	
	var MessagesAdvertisementBatchContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MessagesAdvertisementBatch);
	
	exports.default = MessagesAdvertisementBatchContainer;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _truncate_string = __webpack_require__(77);
	
	var _truncate_string2 = _interopRequireDefault(_truncate_string);
	
	var _message_time = __webpack_require__(498);
	
	var _message_time2 = _interopRequireDefault(_message_time);
	
	var _is_message_moderated = __webpack_require__(501);
	
	var _is_message_moderated2 = _interopRequireDefault(_is_message_moderated);
	
	var _show_modal = __webpack_require__(16);
	
	var _show_modal2 = _interopRequireDefault(_show_modal);
	
	var _profile_image = __webpack_require__(45);
	
	var _profile_image2 = _interopRequireDefault(_profile_image);
	
	var _message_item = __webpack_require__(644);
	
	var _message_item2 = _interopRequireDefault(_message_item);
	
	var _moderated_message_item = __webpack_require__(648);
	
	var _moderated_message_item2 = _interopRequireDefault(_moderated_message_item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import UserProfilePopup from '../user_profile_popup'
	
	
	var MessagesBatch = function (_React$Component) {
	  _inherits(MessagesBatch, _React$Component);
	
	  function MessagesBatch(props) {
	    _classCallCheck(this, MessagesBatch);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MessagesBatch).call(this, props));
	
	    _this.state = {};
	
	    _this.openUserProfileModal = _this.openUserProfileModal.bind(_this);
	    _this.renderMessageBatch = _this.renderMessageBatch.bind(_this);
	    _this.renderMessageItem = _this.renderMessageItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(MessagesBatch, [{
	    key: 'openUserProfileModal',
	    value: function openUserProfileModal(e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      this.props.showModal({ type: 'userProfile', props: { uid: this.props.chattingUser.get('uid') } });
	    }
	  }, {
	    key: 'renderMessageItem',
	    value: function renderMessageItem(side, message, index) {
	      if ((0, _is_message_moderated2.default)(message)) {
	        return _react2.default.createElement(_moderated_message_item2.default, {
	          key: message.get('key'),
	          message: message,
	          side: side,
	          containerId: this.props.containerId,
	          maxBubbleWidth: this.props.maxBubbleWidth,
	          shouldShowTriangle: index === 0 ? true : false,
	          onMessageItemHeightChange: this.props.onMessageItemHeightChange,
	          isRichMessageContentEnabled: this.props.isRichMessageContentEnabled });
	      } else {
	        return _react2.default.createElement(_message_item2.default, {
	          key: message.get('key'),
	          message: message,
	          side: side,
	          containerId: this.props.containerId,
	          maxBubbleWidth: this.props.maxBubbleWidth,
	          shouldShowTriangle: index === 0 ? true : false,
	          onMessageItemHeightChange: this.props.onMessageItemHeightChange,
	          isRichMessageContentEnabled: this.props.isRichMessageContentEnabled });
	      }
	    }
	  }, {
	    key: 'renderMessageBatch',
	    value: function renderMessageBatch(side) {
	      var messages = this.props.batch.get('messages') || (0, _immutable.fromJS)([]);
	
	      if (messages && messages.size > 0) {
	        return messages.map(this.renderMessageItem.bind(this, side));
	      } else {
	        return messages;
	      }
	    }
	  }, {
	    key: 'renderProfileImage',
	    value: function renderProfileImage(user) {
	      var profileImage = user.get('profileImage');
	      var uid = user.get('uid');
	
	      if (uid && profileImage) {
	        return _react2.default.createElement(
	          'div',
	          { style: { cursor: 'pointer', width: 32, height: 32, borderSpacing: 0, verticalAlign: 'top' }, onClick: this.openUserProfileModal },
	          _react2.default.createElement(_profile_image2.default, { image: profileImage, user: user.toJS(), hasIndicator: false, size: 32 })
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('div', { style: { width: 32, height: 32, background: '#BABABA', borderRadius: '50%' } })
	        );
	      }
	    }
	  }, {
	    key: 'renderUserNameDetail',
	    value: function renderUserNameDetail() {
	      var shouldShowModal = this.props.messageType === _constants.MESSAGE_TYPES.GROUP || this.props.messageType === _constants.MESSAGE_TYPES.MODERATED_GROUP;
	
	      var userName = (0, _truncate_string2.default)(this.props.chattingUser.get('name'), 20);
	
	      if (shouldShowModal) {
	        return _react2.default.createElement(
	          'span',
	          { style: { cursor: 'pointer' }, onClick: this.openUserProfileModal },
	          userName
	        );
	      } else {
	        return userName;
	      }
	    }
	  }, {
	    key: 'renderUserName',
	    value: function renderUserName() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'message-batch-username' },
	        this.renderUserNameDetail()
	      );
	    }
	  }, {
	    key: 'renderLastMessageTime',
	    value: function renderLastMessageTime() {
	      var time = this.props.batch.get('lastMessageTime');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'message-batch-time' },
	        (0, _message_time2.default)(time)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.currentUser.get('uid') === this.props.batch.get('from')) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'message-batch right' },
	          _react2.default.createElement(
	            'div',
	            null,
	            this.renderMessageBatch('receiver'),
	            this.renderLastMessageTime()
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'message-batch' },
	          this.renderProfileImage(this.props.chattingUser),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.renderUserName(),
	            this.renderMessageBatch('sender'),
	            this.renderLastMessageTime()
	          )
	        );
	      }
	    }
	  }]);
	
	  return MessagesBatch;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    chattingUser: (0, _immutable.fromJS)(state.getIn(['users', ownProps.batch.get('from')], {})),
	    currentUser: state.get('currentUser', (0, _immutable.fromJS)({}))
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    showModal: function showModal(modal) {
	      return dispatch((0, _show_modal2.default)(modal));
	    }
	  };
	};
	
	var MessagesBatchContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MessagesBatch);
	
	exports.default = MessagesBatchContainer;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _moderated_messages = __webpack_require__(690);
	
	var _filter_not_approved_messages = __webpack_require__(666);
	
	var _filter_not_approved_messages2 = _interopRequireDefault(_filter_not_approved_messages);
	
	var _filter_hidden_advertisement_candidates = __webpack_require__(665);
	
	var _filter_hidden_advertisement_candidates2 = _interopRequireDefault(_filter_hidden_advertisement_candidates);
	
	var _batch_messages = __webpack_require__(664);
	
	var _batch_messages2 = _interopRequireDefault(_batch_messages);
	
	var _messages_batch = __webpack_require__(646);
	
	var _messages_batch2 = _interopRequireDefault(_messages_batch);
	
	var _messages_advertisement_batch = __webpack_require__(645);
	
	var _messages_advertisement_batch2 = _interopRequireDefault(_messages_advertisement_batch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ADVERTISEMENT_BOT = _constants.MESSAGE_TYPES.ADVERTISEMENT_BOT;
	
	var MessagesList = function (_React$Component) {
	  _inherits(MessagesList, _React$Component);
	
	  function MessagesList(props) {
	    _classCallCheck(this, MessagesList);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MessagesList).call(this, props));
	
	    _this.state = {
	      messages: (0, _immutable.fromJS)([])
	    };
	
	    _this.renderMessagesBatch = _this.renderMessagesBatch.bind(_this);
	    return _this;
	  }
	
	  _createClass(MessagesList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.messages && this.props.messages.size > 0) {
	        this.updateMessages(this.props.messages);
	      }
	
	      if (this.props.messageType === _constants.MESSAGE_TYPES.MODERATED_GROUP) {
	        this.props.watchModeratedMessages(this.props.containerId);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.messageType && this.props.messageType === _constants.MESSAGE_TYPES.MODERATED_GROUP) {
	        this.moderatedListWillReceiveProps(nextProps);
	      } else {
	        this.listWillReceiveProps(nextProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.messageType === _constants.MESSAGE_TYPES.MODERATED_GROUP) {
	        this.props.unwatchModeratedMessages(this.props.containerId);
	      }
	    }
	  }, {
	    key: 'moderatedListWillReceiveProps',
	    value: function moderatedListWillReceiveProps(nextProps) {
	      var shouldUpdateMessages = !(0, _immutable.is)(this.props.currentUser, nextProps.currentUser) || !(0, _immutable.is)(this.props.messages, nextProps.messages) || !(0, _immutable.is)(this.props.isAdvEnabledForModeratedChat, nextProps.isAdvEnabledForModeratedChat);
	
	      if (shouldUpdateMessages) {
	        var uid = this.props.currentUser.get('uid');
	        var role = this.props.currentUser.get('role');
	
	        var messages = (0, _filter_not_approved_messages2.default)(nextProps.messages, uid, role);
	        messages = (0, _filter_hidden_advertisement_candidates2.default)(nextProps.messages, nextProps.groupChat, nextProps.isAdvEnabledForModeratedChat);
	
	        this.updateMessages(messages);
	      }
	    }
	  }, {
	    key: 'listWillReceiveProps',
	    value: function listWillReceiveProps(nextProps) {
	      var shouldUpdateMessages = !(0, _immutable.is)(this.props.messages, nextProps.messages);
	
	      if (shouldUpdateMessages) this.updateMessages(nextProps.messages);
	    }
	  }, {
	    key: 'updateMessages',
	    value: function updateMessages(nextMessages) {
	      var messages = (0, _batch_messages2.default)(nextMessages);
	      this.setState({ messages: messages });
	    }
	  }, {
	    key: 'renderMessagesBatch',
	    value: function renderMessagesBatch(batch, key) {
	      if (batch.get('type') === ADVERTISEMENT_BOT) {
	        return _react2.default.createElement(_messages_advertisement_batch2.default, {
	          key: key,
	          batch: batch,
	          containerId: this.props.containerId,
	          maxBubbleWidth: this.props.maxBubbleWidth,
	          messageType: batch.get('type') });
	      } else {
	        return _react2.default.createElement(_messages_batch2.default, {
	          key: key,
	          batch: batch,
	          containerId: this.props.containerId,
	          messageType: this.props.messageType,
	          maxBubbleWidth: this.props.maxBubbleWidth,
	          onMessageItemHeightChange: this.props.onMessageItemHeightChange,
	          isRichMessageContentEnabled: this.props.isRichMessageContentEnabled });
	      }
	    }
	  }, {
	    key: 'renderMessages',
	    value: function renderMessages() {
	      var conversationContent = [];
	
	      if (this.props.contentMessage) {
	        conversationContent.push(this.props.contentMessage);
	      }
	
	      if (this.props.messages) {
	        var messagesList = this.state.messages.map(this.renderMessagesBatch).toArray();
	
	        conversationContent = conversationContent.concat(messagesList);
	      }
	
	      return conversationContent;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'messages-list-container' },
	        _react2.default.createElement(
	          'div',
	          { ref: 'messagesList', className: 'messages-list' },
	          this.renderMessages()
	        )
	      );
	    }
	  }]);
	
	  return MessagesList;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    currentUser: state.get('currentUser', (0, _immutable.fromJS)({})),
	    groupChat: state.getIn(['groups', 'all', ownProps.containerId]),
	    isAdvEnabledForModeratedChat: state.getIn(['advertisements', 'settings', 'isModeratedGroupChatEnabled'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    watchModeratedMessages: _moderated_messages.watchModeratedMessages,
	    unwatchModeratedMessages: _moderated_messages.unwatchModeratedMessages
	  };
	};
	
	var MessagesListContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MessagesList);
	
	exports.default = MessagesListContainer;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _message = __webpack_require__(689);
	
	var _is_user_moderator = __webpack_require__(240);
	
	var _is_user_moderator2 = _interopRequireDefault(_is_user_moderator);
	
	var _is_user_allowed_to_see_moderated_message = __webpack_require__(505);
	
	var _is_user_allowed_to_see_moderated_message2 = _interopRequireDefault(_is_user_allowed_to_see_moderated_message);
	
	var _message_approval_actions = __webpack_require__(643);
	
	var _message_approval_actions2 = _interopRequireDefault(_message_approval_actions);
	
	var _rich_media_container = __webpack_require__(462);
	
	var _rich_media_container2 = _interopRequireDefault(_rich_media_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModeratedMessageItem = function (_React$Component) {
	  _inherits(ModeratedMessageItem, _React$Component);
	
	  function ModeratedMessageItem(props) {
	    _classCallCheck(this, ModeratedMessageItem);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ModeratedMessageItem).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ModeratedMessageItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.containerId && this.props.message) {
	        this.props.onComponentLoaded(this.props.containerId, this.props.message.get('key'));
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onComponentUnLoaded(this.props.containerId, this.props.message.get('key'));
	    }
	  }, {
	    key: 'getDominantBubbleColor',
	    value: function getDominantBubbleColor() {
	      return this.props.side === 'receiver' ? this.props.receiverBubbleBackgroundColor : this.props.senderBubbleBackgroundColor;
	    }
	  }, {
	    key: 'classNames',
	    value: function classNames() {
	      var classes = 'message-item moderated';
	
	      var approvalStatus = this.props.message.get('approvalStatus');
	      var INITIAL = _constants.MESSAGE_APPROVAL_STATUSES.INITIAL;
	      var DECLINED = _constants.MESSAGE_APPROVAL_STATUSES.DECLINED;
	
	
	      if (approvalStatus === INITIAL) classes += ' approval-waiting';else if (approvalStatus === DECLINED) classes += ' approval-declined';
	
	      return classes;
	    }
	  }, {
	    key: 'renderRichMessage',
	    value: function renderRichMessage() {
	      return _react2.default.createElement(_rich_media_container2.default, {
	        isHidden: this.props.isHidden,
	        content: this.props.message.get('message'),
	        onHeightChange: this.props.onMessageItemHeightChange });
	    }
	  }, {
	    key: 'renderSimpleMessage',
	    value: function renderSimpleMessage() {
	      return this.props.message.get('message');
	    }
	  }, {
	    key: 'renderMessage',
	    value: function renderMessage() {
	      if (this.props.isRichMessageContentEnabled) {
	        return this.renderRichMessage();
	      } else {
	        return this.renderSimpleMessage();
	      }
	    }
	  }, {
	    key: 'renderApprovalActions',
	    value: function renderApprovalActions() {
	      var isModerator = (0, _is_user_moderator2.default)(this.props.currentUserRole);
	
	      if (!isModerator) return false;
	      if (this.props.side === 'receiver') return false;
	
	      return _react2.default.createElement(_message_approval_actions2.default, {
	        containerId: this.props.containerId,
	        messageId: this.props.message.get('key') });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _is_user_allowed_to_see_moderated_message2.default)(this.props.message.get('from'), this.props.currentUserUid, this.props.message.get('approvalStatus'), this.props.currentUserRole)) return false;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.classNames() },
	        _react2.default.createElement(
	          'div',
	          { className: 'chat-bubble', style: { color: this.props.textColor, backgroundColor: this.getDominantBubbleColor(), maxWidth: '100%' } },
	          _react2.default.createElement('div', { className: 'triangle', style: { borderTopColor: this.getDominantBubbleColor(), visibility: this.props.shouldShowTriangle ? 'visible' : 'hidden' } }),
	          this.renderMessage(),
	          this.renderApprovalActions()
	        )
	      );
	    }
	  }]);
	
	  return ModeratedMessageItem;
	}(_react2.default.Component);
	
	ModeratedMessageItem.defaultProps = {
	  isRichMessageContentEnabled: true,
	  shouldShowTriangle: false
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentUserUid: state.getIn(['currentUser', 'uid']),
	    currentUserRole: state.getIn(['currentUser', 'role']),
	    textColor: state.getIn(['chatSettings', 'colors', 'conversation', 'messageColor']),
	    senderBubbleBackgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'senderBubbleBackground']),
	    receiverBubbleBackgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'receiverBubbleBackground'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    onComponentLoaded: _message.watchMessage,
	    onComponentUnLoaded: _message.unwatchMessage
	  };
	};
	
	var ModeratedMessageItemContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModeratedMessageItem);
	
	exports.default = ModeratedMessageItemContainer;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConversationScroller = function (_React$Component) {
	  _inherits(ConversationScroller, _React$Component);
	
	  function ConversationScroller(props) {
	    _classCallCheck(this, ConversationScroller);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConversationScroller).call(this, props));
	
	    _this.state = {};
	
	    _this.prevScrollTopRatio = 1;
	
	    _this.listenScroll = _this.listenScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(ConversationScroller, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refs.conversationScroller.onscroll = this.listenScroll;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var shouldForceUpdateScrollPos = nextProps.updatingScrollConcern && this.props.updatingScrollConcern !== nextProps.updatingScrollConcern && this.state.scrollConcern !== nextProps.updatingScrollConcern;
	
	      if (shouldForceUpdateScrollPos) this.scrollToConcern(nextProps.updatingScrollConcern);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.updatingScrollConcern === _constants.SCROLL_POS_CONCERNS.BOTTOM) {
	        this.maintainScrollPosition();
	      } else if (this.props.updatingScrollConcern === _constants.SCROLL_POS_CONCERNS.HISTORY) {
	        this.appendToScrollPosition();
	      }
	    }
	  }, {
	    key: 'calculateRatio',
	    value: function calculateRatio(scroller) {
	      if (scroller.scrollHeight <= scroller.offsetHeight) {
	        return scroller.scrollTop;
	      } else if (!this.isScrolledBefore) {
	        return 1;
	      } else if (scroller.scrollHeight - scroller.scrollTop - scroller.offsetHeight < 1) {
	        return 1;
	      }
	
	      return scroller.scrollTop / (scroller.scrollHeight - scroller.offsetHeight);
	    }
	  }, {
	    key: 'notifyScrollConcernChange',
	    value: function notifyScrollConcernChange(ratio) {
	      var TOP = _constants.SCROLL_POS_CONCERNS.TOP;
	      var MIDDLE = _constants.SCROLL_POS_CONCERNS.MIDDLE;
	      var BOTTOM = _constants.SCROLL_POS_CONCERNS.BOTTOM;
	
	      var scrollConcern = ratio === 0 ? TOP : ratio === 1 ? BOTTOM : MIDDLE;
	
	      if (scrollConcern !== this.state.scrollConcern) {
	        this.props.onScrollConcernChange(scrollConcern);
	        this.setState({ scrollConcern: scrollConcern });
	      }
	    }
	  }, {
	    key: 'updateScrollTop',
	    value: function updateScrollTop(ratio, scroller) {
	      scroller.scrollTop = ratio * (scroller.scrollHeight - scroller.offsetHeight);
	    }
	  }, {
	    key: 'listenScroll',
	    value: function listenScroll() {
	      this.prevScrollTopRatio = this.calculateRatio(this.refs.conversationScroller);
	      this.isScrolledBefore = true;
	      this.notifyScrollConcernChange(this.prevScrollTopRatio);
	    }
	  }, {
	    key: 'scrollToConcern',
	    value: function scrollToConcern(scrollConcern) {
	      var HISTORY = _constants.SCROLL_POS_CONCERNS.HISTORY;
	      var MIDDLE = _constants.SCROLL_POS_CONCERNS.MIDDLE;
	      var BOTTOM = _constants.SCROLL_POS_CONCERNS.BOTTOM;
	      var FORCE_BOTTOM = _constants.SCROLL_POS_CONCERNS.FORCE_BOTTOM;
	
	
	      if (scrollConcern == FORCE_BOTTOM) this.maintainScrollPosition(true);
	      if (scrollConcern === BOTTOM) this.maintainScrollPosition();else if (scrollConcern === MIDDLE) this.maintainScrollPosition();else if (scrollConcern === HISTORY) this.appendToScrollPosition();
	    }
	  }, {
	    key: 'maintainScrollPosition',
	    value: function maintainScrollPosition() {
	      var isBottomForced = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	      if (isBottomForced || this.prevScrollTopRatio === 1) {
	        this.scrollToBottom();
	      } else {
	        var cachedRatio = this.calculateRatio(this.refs.conversationScroller);
	        this.updateScrollTop(cachedRatio, this.refs.conversationScroller);
	      }
	
	      this.prevScrollTopRatio = this.calculateRatio(this.refs.conversationScroller);
	      this.prevHeight = this.refs.conversationScroller.scrollHeight;
	    }
	  }, {
	    key: 'scrollToBottom',
	    value: function scrollToBottom() {
	      var scroller = this.refs.conversationScroller;
	
	      this.updateScrollTop(1, scroller);
	    }
	  }, {
	    key: 'appendToScrollPosition',
	    value: function appendToScrollPosition() {
	      var diff = this.refs.conversationScroller.scrollHeight - (this.prevHeight || 0);
	
	      if (diff > 0) this.refs.conversationScroller.scrollTop += diff;
	      this.prevHeight = this.refs.conversationScroller.scrollHeight;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { ref: 'conversationScroller', className: 'conversation-scroller' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return ConversationScroller;
	}(_react2.default.Component);
	
	exports.default = ConversationScroller;

/***/ },
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _current_user_presence = __webpack_require__(225);
	
	var _current_user_presence2 = _interopRequireDefault(_current_user_presence);
	
	var _current_user_role = __webpack_require__(672);
	
	var _current_user_role2 = _interopRequireDefault(_current_user_role);
	
	var _presence_indicator = __webpack_require__(79);
	
	var _presence_indicator2 = _interopRequireDefault(_presence_indicator);
	
	var _sliding_menu = __webpack_require__(534);
	
	var _sliding_menu2 = _interopRequireDefault(_sliding_menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUserSlidingMenu = function (_React$Component) {
	  _inherits(CurrentUserSlidingMenu, _React$Component);
	
	  function CurrentUserSlidingMenu(props) {
	    _classCallCheck(this, CurrentUserSlidingMenu);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CurrentUserSlidingMenu).call(this, props));
	
	    _this.state = {
	      isOpen: _this.props.isOpen
	    };
	    return _this;
	  }
	
	  _createClass(CurrentUserSlidingMenu, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ isOpen: nextProps.isOpen });
	    }
	  }, {
	    key: 'setPresence',
	    value: function setPresence(presence) {
	      presence = parseInt(presence, 10);
	      this.props.onPresenceItemClick(presence);
	
	      this.props.onActionMenuClose();
	    }
	  }, {
	    key: 'onExpertModeSwitchClicked',
	    value: function onExpertModeSwitchClicked(role) {
	      var _this2 = this;
	
	      this.props.onExpertModeSwitchClicked(role);
	      setTimeout(function () {
	        return _this2.props.onActionMenuClose();
	      }, 400);
	    }
	  }, {
	    key: 'renderPresenceMenu',
	    value: function renderPresenceMenu() {
	      var _this3 = this;
	
	      var presenceMap = Object.keys(_constants.PRESENCE_LABELS);
	      presenceMap.reverse();
	
	      return presenceMap.map(function (key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key, className: 'sliding-menu-item', onClick: function onClick() {
	              return _this3.setPresence(key);
	            } },
	          _react2.default.createElement(_presence_indicator2.default, { presence: parseInt(key, 10) }),
	          _constants.PRESENCE_LABELS[key]
	        );
	      });
	    }
	  }, {
	    key: 'renderSettingsMenu',
	    value: function renderSettingsMenu() {
	      var _this4 = this;
	
	      if (this.props.currentUser) {
	        var settingsItems = [_react2.default.createElement('div', { key: 0, className: 'sliding-menu-seperator' }), _react2.default.createElement(
	          'div',
	          { key: 1, className: 'sliding-menu-item' },
	          _react2.default.createElement(
	            'a',
	            { href: this.props.currentUser.profileUrl, target: '_blank', onClick: this.props.onActionMenuClose },
	            _react2.default.createElement('i', { className: 'icon-indicator rc-icon-user' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Profile'
	            )
	          )
	        )];
	
	        if (this.props.currentUser.role === _constants.ROLES.EXPERT) {
	          settingsItems.push(_react2.default.createElement(
	            'div',
	            { key: 2, className: 'sliding-menu-item', onClick: function onClick() {
	                return _this4.onExpertModeSwitchClicked(_constants.ROLES.AUTHOR);
	              } },
	            _react2.default.createElement('i', { className: 'icon-indicator rc-icon-shuffle' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Writer mode'
	            )
	          ));
	        } else if (this.props.currentUser.role === _constants.ROLES.AUTHOR) {
	          settingsItems.push(_react2.default.createElement(
	            'div',
	            { key: 2, className: 'sliding-menu-item', onClick: function onClick() {
	                return _this4.onExpertModeSwitchClicked(_constants.ROLES.EXPERT);
	              } },
	            _react2.default.createElement('i', { className: 'icon-indicator rc-icon-shuffle' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Expert mode'
	            )
	          ));
	        }
	
	        return settingsItems;
	      }
	    }
	  }, {
	    key: 'shouldShowSubMenu',
	    value: function shouldShowSubMenu() {
	      if (this.props.currentUser && (this.props.currentUser.role === _constants.ROLES.EXPERT || this.props.currentUser.role === _constants.ROLES.AUTHOR)) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classNames = 'current-user-menu';
	      var height = void 0;
	      var isVisible = false;
	      if (!this.state.isOpen) classNames += ' hidden';
	
	      if (this.state.isOpen) {
	        height = 149;
	        isVisible = true;
	        if (this.shouldShowSubMenu()) height += 37;
	      }
	
	      return _react2.default.createElement(
	        _sliding_menu2.default,
	        { className: classNames, top: this.props.top, isVisible: isVisible, height: height },
	        this.renderPresenceMenu(),
	        this.renderSettingsMenu()
	      );
	    }
	  }]);
	
	  return CurrentUserSlidingMenu;
	}(_react2.default.Component);
	
	CurrentUserSlidingMenu.defaultProps = {
	  onActionMenuClose: function onActionMenuClose() {}
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentUser: state.get('currentUser') ? state.get('currentUser').toObject() : null
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    onPresenceItemClick: function onPresenceItemClick(presence) {
	      return (0, _current_user_presence2.default)(presence);
	    },
	    onExpertModeSwitchClicked: function onExpertModeSwitchClicked(role) {
	      return (0, _current_user_role2.default)(role);
	    }
	  };
	};
	
	var CurrentUserSlidingMenuContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CurrentUserSlidingMenu);
	
	exports.default = CurrentUserSlidingMenuContainer;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (containerId) {
	  return { type: _action_types.REMOVE_PREVIOUS_MESSAGES, containerId: containerId };
	};

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (payoutRequest, payoutRequestId) {
	  return { type: _action_types.SET_CURRENT_PAYOUT_REQUEST, payoutRequest: payoutRequest, payoutRequestId: payoutRequestId };
	};

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (message, messageKey, containerId) {
	  return { type: _action_types.SET_NEW_MESSAGE, message: message, messageKey: messageKey, containerId: containerId };
	};

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (notification, options) {
	  return { type: _action_types.SET_NEW_NOTIFICATION, notification: notification, options: options };
	};

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (messages, containerId) {
	  return { type: _action_types.SET_PREVIOUS_MESSAGES, messages: messages, containerId: containerId };
	};

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (sessionRequest, expertUid, userUid) {
	  return { type: _action_types.SET_SESSION_REQUEST, sessionRequest: sessionRequest, expertUid: expertUid, userUid: userUid };
	};

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (count, uid) {
	  return { type: _action_types.SET_USER_SESSIONS_COUNT, count: count, uid: uid };
	};

/***/ },
/* 661 */,
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _set_previous_messages = __webpack_require__(658);
	
	var _set_previous_messages2 = _interopRequireDefault(_set_previous_messages);
	
	var _user = __webpack_require__(19);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getUsersForMessages = function getUsersForMessages(messages) {
	  (0, _immutable.fromJS)(messages).forEach(function (message) {
	    return (0, _user2.default)(message.get('from'));
	  });
	};
	
	var onReceivePreviousMessages = function onReceivePreviousMessages(containerId, startTime, snapshot) {
	  if (!snapshot.exists()) return startTime;
	
	  var messages = snapshot.val();
	
	  (0, _store.dispatch)((0, _set_previous_messages2.default)(messages, containerId));
	  getUsersForMessages(messages);
	
	  return startTime;
	};
	
	exports.default = function (containerId) {
	  var limit = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	  var startTime = arguments.length <= 2 || arguments[2] === undefined ? (0, _moment2.default)().valueOf() : arguments[2];
	
	  if (!containerId) return;
	
	  startTime = startTime - 1; // not to get first message of previous batch
	
	  var ENDPOINT = _constants.MESSAGES_ENDPOINT + '/' + containerId;
	
	  var ref = _firedux2.default.ref.child(ENDPOINT).orderByChild('time').endAt(startTime);
	  if (limit) ref = ref.limitToLast(limit);
	
	  return ref.once('value').then(onReceivePreviousMessages.bind(null, containerId, startTime));
	};

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_user_sessions_count = __webpack_require__(660);
	
	var _set_user_sessions_count2 = _interopRequireDefault(_set_user_sessions_count);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onUserSessionsCount = function onUserSessionsCount(uid, snapshot) {
	  var count = snapshot.val() || 0;
	
	  (0, _store.dispatch)((0, _set_user_sessions_count2.default)(count, uid));
	
	  return snapshot;
	};
	
	exports.default = function (uid) {
	  if (!uid) return;
	
	  var sessionsCount = (0, _store.getState)().getIn(['sessions', '_counts', uid]);
	
	  if (sessionsCount) return;
	
	  var ENDPOINT = _constants.EXPERT_SESSION_COUNTS_ENDPOINT + '/' + uid;
	
	  return _firedux2.default.ref.child(ENDPOINT).once('value').then(onUserSessionsCount.bind(null, uid));
	};

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _is_one_hour_before = __webpack_require__(503);
	
	var _is_one_hour_before2 = _interopRequireDefault(_is_one_hour_before);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADVERTISEMENT_BOT = _constants.MESSAGE_TYPES.ADVERTISEMENT_BOT;
	
	
	var addAdvertisementMessageAsNewBatch = function addAdvertisementMessageAsNewBatch(batch, message) {
	  return batch.unshift((0, _immutable.fromJS)({
	    messages: [message],
	    type: ADVERTISEMENT_BOT,
	    from: message.get('from'),
	    lastMessageTime: message.get('time')
	  }));
	};
	
	var addMessageAsNewBatch = function addMessageAsNewBatch(batch, message) {
	  return batch.unshift((0, _immutable.fromJS)({
	    messages: [message],
	    from: message.get('from'),
	    lastMessageTime: message.get('time')
	  }));
	};
	
	var addMessageToBatch = function addMessageToBatch(batch, message) {
	  return batch.setIn([0, 'messages'], batch.getIn([0, 'messages']).unshift((0, _immutable.fromJS)(message)));
	};
	
	var reduceMessages = function reduceMessages(batch, message) {
	  if (message.get('type') === ADVERTISEMENT_BOT) {
	    return addAdvertisementMessageAsNewBatch(batch, message);
	  }
	
	  if (batch.size === 0) return addMessageAsNewBatch(batch, message);
	
	  var messageUser = message.get('from');
	  var messageTime = message.get('time');
	  var firstMessageUser = batch.getIn([0, 'messages', 0, 'from']);
	  var lastMessageTime = batch.getIn([0, 'lastMessageTime']);
	
	  if (messageUser === firstMessageUser && !(0, _is_one_hour_before2.default)(messageTime, lastMessageTime)) {
	    return addMessageToBatch(batch, message);
	  } else {
	    return addMessageAsNewBatch(batch, message);
	  }
	};
	
	exports.default = function (messages) {
	  return messages.reduceRight(reduceMessages, (0, _immutable.fromJS)([]));
	};

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(2);
	
	var ADVERTISEMENT_BOT = _constants.MESSAGE_TYPES.ADVERTISEMENT_BOT;
	
	exports.default = function (messages, groupChat, isEnabledForModeratedChat) {
	  if (!messages) return messages;
	  if (!groupChat || !groupChat.get || !groupChat.get('key')) return messages;
	
	  var isModerated = groupChat.get('isModerated');
	
	  if (isModerated !== true) return messages;
	  if (isEnabledForModeratedChat === true) return messages;
	
	  return messages.filterNot(function (m) {
	    return m.get('type') === ADVERTISEMENT_BOT;
	  });
	};

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _is_message_moderated = __webpack_require__(501);
	
	var _is_message_moderated2 = _interopRequireDefault(_is_message_moderated);
	
	var _is_user_allowed_to_see_moderated_message = __webpack_require__(505);
	
	var _is_user_allowed_to_see_moderated_message2 = _interopRequireDefault(_is_user_allowed_to_see_moderated_message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var byVisibilityForUser = function byVisibilityForUser(uid, role, message) {
	  if (!(0, _is_message_moderated2.default)(message)) return true;
	
	  var from = message.get('from');
	  var approvalStatus = message.get('approvalStatus');
	
	  if ((0, _is_user_allowed_to_see_moderated_message2.default)(from, uid, approvalStatus, role)) return true;
	
	  return false;
	};
	
	exports.default = function (messages) {
	  var uid = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	  var role = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  return messages.filter(byVisibilityForUser.bind(null, uid, role));
	};

/***/ },
/* 667 */,
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(2);
	
	exports.default = function (approvalStatus) {
	  return approvalStatus === _constants.MESSAGE_APPROVAL_STATUSES.APPROVED;
	};

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	var _create_session_with_expert = __webpack_require__(270);
	
	var _create_session_with_expert2 = _interopRequireDefault(_create_session_with_expert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var updateSessionRequestWithSessionId = function updateSessionRequestWithSessionId(expertUid, userUid, sessionId) {
	  var ENDPOINT = _constants.EXPERT_SESSION_REQUESTS_ENDPOINT + '/' + expertUid + '/' + userUid;
	
	  return _firedux2.default.ref.child(ENDPOINT).update({ sessionId: sessionId }).then(function () {
	    return sessionId;
	  });
	};
	
	exports.default = function (expertUid, userUid, sessionLength) {
	  var ENDPOINT = _constants.EXPERT_SESSION_REQUESTS_ENDPOINT + '/' + expertUid + '/' + userUid;
	
	  return _firedux2.default.ref.child(ENDPOINT).update({ status: _constants.SESSION_REQUEST_STATUSES.ACCEPTED }).then(_create_session_with_expert2.default.bind(null, expertUid, userUid, sessionLength)).then(updateSessionRequestWithSessionId.bind(null, expertUid, userUid));
	};

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (containerId, messageId) {
	  if (!containerId || !messageId) return;
	
	  var ref = _firedux2.default.ref.child(_constants.MESSAGES_ENDPOINT).child(containerId).child(messageId);
	
	  return ref.update({ approvalStatus: _constants.MESSAGE_APPROVAL_STATUSES.APPROVED, time: (0, _moment2.default)().valueOf() });
	};

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(2);
	
	var _create_session_with_expert = __webpack_require__(270);
	
	var _create_session_with_expert2 = _interopRequireDefault(_create_session_with_expert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (expert, user, sessionLength, startTime) {
	  if (!expert || !user || !sessionLength || !startTime) return;
	  if (!expert.get('uid') || !user.get('uid')) return;
	
	  return (0, _create_session_with_expert2.default)(expert.get('uid'), user.get('uid'), sessionLength, startTime, _constants.SESSION_TYPES.BOOKED);
	};

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (role) {
	  if (typeof role !== 'number') return;
	
	  var state = _store2.default.getState();
	
	  if (state.get('currentUser') && state.getIn(['currentUser', 'uid'])) {
	    var ENDPOINT = _constants.USERS_ENDPOINT + '/' + state.getIn(['currentUser', 'uid']) + '/role';
	    _firedux2.default.ref.child(ENDPOINT).set(role);
	  }
	};

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (containerId, messageId) {
	  if (!containerId || !messageId) return;
	
	  var ref = _firedux2.default.ref.child(_constants.MESSAGES_ENDPOINT).child(containerId).child(messageId);
	
	  return ref.update({ approvalStatus: _constants.MESSAGE_APPROVAL_STATUSES.DECLINED });
	};

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	var _create_session_with_expert = __webpack_require__(270);
	
	var _create_session_with_expert2 = _interopRequireDefault(_create_session_with_expert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (expertUid, userUid) {
	  var ENDPOINT = _constants.EXPERT_SESSION_REQUESTS_ENDPOINT + '/' + expertUid + '/' + userUid;
	
	  return _firedux2.default.ref.child(ENDPOINT).update({ status: _constants.SESSION_REQUEST_STATUSES.DISMISSED });
	};

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var incrementMessageCount = function incrementMessageCount(count) {
	  if (typeof count !== 'number' || count < 0) count = 0;
	
	  return count + 1;
	};
	
	exports.default = function (containerId) {
	  var ref = _firedux2.default.ref.child(_constants.CONVERSATION_MESSAGE_COUNTS_ENDPOINT).child(containerId);
	
	  return ref.transaction(incrementMessageCount);
	};

/***/ },
/* 676 */,
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(33);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (expertUid, userUid, sessionLength) {
	  var ENDPOINT = _constants.EXPERT_SESSION_REQUESTS_ENDPOINT + '/' + expertUid + '/' + userUid;
	
	  _firedux2.default.ref.child(ENDPOINT).set({
	    expert: expertUid,
	    user: userUid,
	    sessionLength: sessionLength,
	    status: _constants.SESSION_REQUEST_STATUSES.REQUESTED,
	    time: _firebase2.default.ServerValue.TIMESTAMP
	  });
	};

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _send_notification = __webpack_require__(242);
	
	var _send_notification2 = _interopRequireDefault(_send_notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var preparePayloadForNotification = function preparePayloadForNotification(user, otherUser, sessionLength, startTime, sessionId) {
	  return {
	    sessionId: sessionId,
	    sessionLength: sessionLength,
	    startTime: startTime,
	    role: user.get('role'),
	    user: {
	      name: user.get('name'),
	      uid: user.get('uid'),
	      email: user.get('email')
	    },
	    otherUser: {
	      name: otherUser.get('name'),
	      uid: otherUser.get('uid'),
	      email: otherUser.get('email')
	    }
	  };
	};
	
	var sendScheduleConfirmationNotification = function sendScheduleConfirmationNotification(user, otherUser, sessionLength, startTime, sessionId) {
	  var title = 'Your Session Confirmation';
	  var body = 'Your paid session is booked.';
	  var sent = false;
	  var from = otherUser.get('uid');
	  var to = user.get('uid');
	  var payload = preparePayloadForNotification(user, otherUser, sessionLength, startTime, sessionId);
	
	  return (0, _send_notification2.default)('sessionConfirmation', {
	    title: title, body: body, sent: sent, from: from, to: to, payload: payload, refKey: sessionId
	  });
	};
	
	var sendScheduleReminderNotification = function sendScheduleReminderNotification(user, otherUser, sessionLength, startTime, dueTime, sessionId) {
	  var title = 'Reminder for Your Session';
	  var body = 'Your session is upcoming.';
	  var sent = false;
	  var enqueued = false;
	  var from = otherUser.get('uid');
	  var to = user.get('uid');
	  var payload = preparePayloadForNotification(user, otherUser, sessionLength, startTime, sessionId);
	
	  return (0, _send_notification2.default)('scheduleReminder', {
	    title: title, body: body, sent: sent, enqueued: enqueued, dueTime: dueTime, from: from, to: to, payload: payload, refKey: sessionId
	  });
	};
	
	var sendScheduleReminderNotifications = function sendScheduleReminderNotifications(user, otherUser, sessionLength, startTime, sessionId) {
	  var dayBefore = (0, _moment2.default)(startTime).subtract(1, 'day').valueOf();
	  var hourBefore = (0, _moment2.default)(startTime).subtract(1, 'hour').valueOf();
	
	  if ((0, _moment2.default)().isSameOrBefore((0, _moment2.default)(dayBefore))) {
	    return sendScheduleReminderNotification(user, otherUser, sessionLength, startTime, dayBefore, sessionId).then(sendScheduleReminderNotification.bind(null, user, otherUser, sessionLength, startTime, hourBefore, sessionId));
	  } else {
	    return sendScheduleReminderNotification(user, otherUser, sessionLength, startTime, hourBefore, sessionId);
	  }
	};
	
	var saveScheduleNotification = function saveScheduleNotification(user, otherUser, sessionLength, startTime, sessionId) {
	  return sendScheduleConfirmationNotification(user, otherUser, sessionLength, startTime, sessionId).then(sendScheduleReminderNotifications.bind(null, user, otherUser, sessionLength, startTime, sessionId));
	};
	
	exports.default = function (expert, user, sessionLength, startTime, sessionId) {
	  return saveScheduleNotification(expert, user, sessionLength, startTime, sessionId).then(saveScheduleNotification.bind(null, user, expert, sessionLength, startTime, sessionId));
	};

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(2);
	
	var _schedule_entry = __webpack_require__(451);
	
	var _schedule_entry2 = _interopRequireDefault(_schedule_entry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var saveSessionToSchedule = function saveSessionToSchedule(user, otherUser, sessionLength, startTime, sessionId) {
	  var endTime = (0, _moment2.default)(startTime).add(sessionLength, 'minutes').valueOf();
	  var uid = user.get('uid');
	
	  var payload = {
	    user: {
	      name: user.get('name'),
	      uid: user.get('uid'),
	      profileImage: user.get('profileImage'),
	      profileUrl: user.get('profileUrl')
	    },
	    otherUser: {
	      name: otherUser.get('name'),
	      uid: otherUser.get('uid'),
	      profileImage: otherUser.get('profileImage'),
	      profileUrl: otherUser.get('profileUrl')
	    }
	  };
	
	  return (0, _schedule_entry2.default)(uid, startTime, endTime, _constants.SCHEDULE_ENTRIES.BOOKED, sessionId, payload);
	};
	
	exports.default = function (expert, user, sessionLength, startTime, sessionId) {
	  return saveSessionToSchedule(expert, user, sessionLength, startTime, sessionId).then(saveSessionToSchedule.bind(null, user, expert, sessionLength, startTime, sessionId));
	};

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _user = __webpack_require__(19);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _send_notification = __webpack_require__(242);
	
	var _send_notification2 = _interopRequireDefault(_send_notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var constructMessageNotification = function constructMessageNotification(message, user) {
	  if (!message || !user) return;
	
	  return {
	    payload: message, time: message.time,
	    from: message.from, to: message.to,
	    title: user.get('name'), icon: user.get('profileImage'), body: message.message,
	    read: false, isReceived: false
	  };
	};
	
	var sendMessageNotification = function sendMessageNotification(message) {
	  return (0, _user2.default)(message.from).then(constructMessageNotification.bind(null, message)).then(_send_notification2.default.bind(null, 'messages/' + message.to));
	};
	
	var getMessage = function getMessage(ref) {
	  return ref.once('value').then(function (snapshot) {
	    var message = snapshot.val();
	
	    if (!message.from) return getMessage(snapshot.ref());
	
	    return message;
	  });
	};
	
	exports.default = function (ref) {
	  return getMessage(ref).then(sendMessageNotification).then(function () {
	    return ref;
	  });
	};

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	var _is_user_moderator = __webpack_require__(240);
	
	var _is_user_moderator2 = _interopRequireDefault(_is_user_moderator);
	
	var _send_message_notification = __webpack_require__(680);
	
	var _send_message_notification2 = _interopRequireDefault(_send_message_notification);
	
	var _increment_total_message_count = __webpack_require__(675);
	
	var _increment_total_message_count2 = _interopRequireDefault(_increment_total_message_count);
	
	var _update_latest_message_times = __webpack_require__(685);
	
	var _update_latest_message_times2 = _interopRequireDefault(_update_latest_message_times);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var constructMessageObject = function constructMessageObject(message, from, to, type, role, conversationId) {
	  var approvalStatus = null;
	
	  if (type === _constants.MESSAGE_TYPES.MODERATED_GROUP) {
	    if ((0, _is_user_moderator2.default)(role)) approvalStatus = _constants.MESSAGE_APPROVAL_STATUSES.APPROVED;else approvalStatus = _constants.MESSAGE_APPROVAL_STATUSES.INITIAL;
	  }
	
	  return {
	    message: message, from: from, to: to, type: type, approvalStatus: approvalStatus,
	    conversationId: conversationId,
	    time: (0, _moment2.default)().valueOf()
	    // TODO: figure this out when firebase fixes timing on turkey's side (timezone change :/)
	    // time: Firebase.ServerValue.TIMESTAMP
	  };
	}; // import Firebase from 'firebase'
	
	
	var sendNewMessage = function sendNewMessage(containerId, message, from, to, type, role) {
	  var ENDPOINT = _constants.MESSAGES_ENDPOINT + '/' + containerId;
	
	  return _firedux2.default.ref.child(ENDPOINT).push(constructMessageObject(message, from, to, type, role, containerId));
	};
	
	var notify = function notify(shouldNotify, ref) {
	  if (!shouldNotify) return ref;
	
	  return (0, _send_message_notification2.default)(ref);
	};
	
	exports.default = function (message, containerId, from, to) {
	  var shouldNotify = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];
	  var type = arguments.length <= 5 || arguments[5] === undefined ? _constants.MESSAGE_TYPES.NORMAL : arguments[5];
	  var role = arguments[6];
	
	
	  if (!message || !containerId) return;
	
	  return sendNewMessage(containerId, message, from, to, type, role).then(notify.bind(null, shouldNotify)).then(_update_latest_message_times2.default.bind(null, type, from, to)).then(_increment_total_message_count2.default.bind(null, containerId));
	};

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (uid, containerId, messageCount) {
	  var ref = _firedux2.default.ref.child(_constants.CONVERSATION_REF_MESSAGE_COUNTS_ENDPOINT).child(uid).child(containerId);
	
	  return ref.set(messageCount);
	};

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _send_notification = __webpack_require__(242);
	
	var _send_notification2 = _interopRequireDefault(_send_notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var preparePayloadForNotification = function preparePayloadForNotification(user, otherUser, sessionLength, sessionId) {
	  return {
	    sessionId: sessionId,
	    sessionLength: sessionLength,
	    role: user.get('role'),
	    user: {
	      name: user.get('name'),
	      uid: user.get('uid'),
	      email: user.get('email')
	    },
	    otherUser: {
	      name: otherUser.get('name'),
	      uid: otherUser.get('uid'),
	      email: otherUser.get('email')
	    }
	  };
	};
	
	var sendImmediateSessionConfirmationNotification = function sendImmediateSessionConfirmationNotification(user, otherUser, sessionLength, sessionId) {
	  var title = 'Your Immediate Session Confirmation';
	  var body = 'Your immediate session is good to go.';
	  var sent = false;
	  var from = otherUser.get('uid');
	  var to = user.get('uid');
	  var payload = preparePayloadForNotification(user, otherUser, sessionLength, sessionId);
	
	  return (0, _send_notification2.default)('sessionConfirmationImmediate', {
	    title: title, body: body, sent: sent, from: from, to: to, payload: payload
	  });
	};
	
	var saveImmediateSessionConfirmationNotifications = function saveImmediateSessionConfirmationNotifications(expert, user, sessionLength, sessionId) {
	  return sendImmediateSessionConfirmationNotification(user, expert, sessionLength, sessionId).then(sendImmediateSessionConfirmationNotification.bind(null, expert, user, sessionLength, sessionId));
	};
	
	exports.default = function (expert, user, sessionLength, sessionId) {
	  return saveImmediateSessionConfirmationNotifications(expert, user, sessionLength, sessionId);
	};

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (sessionRequest) {
	  if (sessionRequest.get('status') !== _constants.SESSION_REQUEST_STATUSES.REQUESTED) return;
	
	  var expertUid = sessionRequest.get('expert');
	  var userUid = sessionRequest.get('user');
	
	  var ENDPOINT = _constants.EXPERT_SESSION_REQUESTS_ENDPOINT + '/' + expertUid + '/' + userUid;
	
	  _firedux2.default.ref.child(ENDPOINT).update({
	    status: _constants.SESSION_REQUEST_STATUSES.TIMEDOUT
	  });
	};

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getMessageTime = function getMessageTime(messageRef) {
	  return messageRef.child('time').once('value').then(function (snapshot) {
	    return snapshot.val();
	  });
	};
	
	var updateLatestMessageTimeForUser = function updateLatestMessageTimeForUser(uid, otherUid, latestMessageTime) {
	  if (!uid || !otherUid || !latestMessageTime) return latestMessageTime;
	
	  var ref = _firedux2.default.ref.child(_constants.CONVERSATIONS_PRIVATE_REFS_ENDPOINT).child(uid).child(otherUid).child('latestMessageTime');
	
	  return ref.set(latestMessageTime).then(function () {
	    return latestMessageTime;
	  });
	};
	
	exports.default = function (type, from, to, ref) {
	  if (!type || !from || !to || !ref) return ref;
	  if (type !== _constants.MESSAGE_TYPES.NORMAL) return ref;
	
	  return getMessageTime(ref).then(updateLatestMessageTimeForUser.bind(null, from, to)).then(updateLatestMessageTimeForUser.bind(null, to, from)).then(function () {
	    return ref;
	  });
	};

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchCurrentPayoutRequest = exports.watchCurrentPayoutRequest = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_current_payout_request = __webpack_require__(655);
	
	var _set_current_payout_request2 = _interopRequireDefault(_set_current_payout_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onPayoutRequest = function onPayoutRequest(snapshot) {
	  if (snapshot.exists()) (0, _store.dispatch)((0, _set_current_payout_request2.default)(snapshot.val(), snapshot.key()));
	};
	
	var watchCurrentPayoutRequest = exports.watchCurrentPayoutRequest = function watchCurrentPayoutRequest(payoutRequestId) {
	  if (!payoutRequestId) return;
	
	  var ENDPOINT = _constants.STRIPE_PAYOUT_REQUESTS_ENDPOINT + '/' + payoutRequestId;
	
	  _firedux2.default.ref.child(ENDPOINT).on('value', onPayoutRequest);
	};
	
	var unwatchCurrentPayoutRequest = exports.unwatchCurrentPayoutRequest = function unwatchCurrentPayoutRequest(payoutRequestId) {
	  if (!payoutRequestId) return;
	
	  var ENDPOINT = _constants.STRIPE_PAYOUT_REQUESTS_ENDPOINT + '/' + payoutRequestId;
	
	  _firedux2.default.ref.child(ENDPOINT).off('value', onPayoutRequest);
	
	  (0, _store.dispatch)((0, _set_current_payout_request2.default)(null));
	};

/***/ },
/* 687 */,
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchImmediateSessionRequest = exports.watchImmediateSessionRequest = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_session_request = __webpack_require__(659);
	
	var _set_session_request2 = _interopRequireDefault(_set_session_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onSessionRequest = function onSessionRequest(expertUid, userUid, snapshot) {
	  (0, _store.dispatch)((0, _set_session_request2.default)(snapshot.val(), expertUid, userUid));
	};
	
	var boundOnSessionRequest = void 0;
	
	var watchImmediateSessionRequest = exports.watchImmediateSessionRequest = function watchImmediateSessionRequest(expertUid, userUid) {
	  var ENDPOINT = _constants.EXPERT_SESSION_REQUESTS_ENDPOINT + '/' + expertUid + '/' + userUid;
	
	  var ref = _firedux2.default.ref.child(ENDPOINT);
	
	  if (boundOnSessionRequest) unwatchImmediateSessionRequest(expertUid, userUid);
	
	  boundOnSessionRequest = onSessionRequest.bind(null, expertUid, userUid);
	
	  ref.on('value', boundOnSessionRequest);
	};
	
	var unwatchImmediateSessionRequest = exports.unwatchImmediateSessionRequest = function unwatchImmediateSessionRequest(expertUid, userUid) {
	  var ENDPOINT = _constants.EXPERT_SESSION_REQUESTS_ENDPOINT + '/' + expertUid + '/' + userUid;
	
	  _firedux2.default.ref.child(ENDPOINT).off('value', boundOnSessionRequest);
	};

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchMessage = exports.watchMessage = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _update_message_attr = __webpack_require__(497);
	
	var _update_message_attr2 = _interopRequireDefault(_update_message_attr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onMessageUpdate = function onMessageUpdate(containerId, messageId, snapshot) {
	  (0, _store.dispatch)((0, _update_message_attr2.default)(containerId, messageId, snapshot.key(), snapshot.val()));
	};
	
	var watchMessage = exports.watchMessage = function watchMessage(containerId, messageId) {
	  if (!containerId || !messageId) return;
	
	  var ref = _firedux2.default.ref.child(_constants.MESSAGES_ENDPOINT).child(containerId).child(messageId);
	
	  ref.on('child_changed', onMessageUpdate.bind(null, containerId, messageId));
	};
	
	var unwatchMessage = exports.unwatchMessage = function unwatchMessage(containerId, messageId) {
	  if (!containerId || !messageId) return;
	
	  var ref = _firedux2.default.ref.child(_constants.MESSAGES_ENDPOINT).child(containerId).child(messageId);
	
	  ref.off('child_changed');
	};

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchModeratedMessages = exports.watchModeratedMessages = undefined;
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _update_message_attr = __webpack_require__(497);
	
	var _update_message_attr2 = _interopRequireDefault(_update_message_attr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onMessageUpdate = function onMessageUpdate(containerId, snapshot) {
	  var key = snapshot.key();
	  var message = snapshot.val();
	  var attr = 'approvalStatus';
	  var approvalStatus = message[attr];
	
	  (0, _store.dispatch)((0, _update_message_attr2.default)(containerId, key, attr, approvalStatus));
	};
	
	var watchModeratedMessages = exports.watchModeratedMessages = function watchModeratedMessages(containerId) {
	  if (!containerId) return;
	
	  var ref = _firedux2.default.ref.child(_constants.MESSAGES_ENDPOINT).child(containerId);
	
	  ref.on('child_changed', onMessageUpdate.bind(null, containerId));
	};
	
	var unwatchModeratedMessages = exports.unwatchModeratedMessages = function unwatchModeratedMessages(containerId) {
	  if (!containerId) return;
	
	  var ref = _firedux2.default.ref.child(_constants.MESSAGES_ENDPOINT).child(containerId);
	
	  ref.off('child_changed');
	};

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchNewMessages = exports.watchNewMessages = undefined;
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_new_message = __webpack_require__(656);
	
	var _set_new_message2 = _interopRequireDefault(_set_new_message);
	
	var _set_new_notification = __webpack_require__(657);
	
	var _set_new_notification2 = _interopRequireDefault(_set_new_notification);
	
	var _user = __webpack_require__(19);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messageRef = void 0;
	
	var setNewMessageNotification = function setNewMessageNotification(message, options) {
	  var notification = {
	    title: 'New Message',
	    body: message.message
	  };
	
	  (0, _store.dispatch)((0, _set_new_notification2.default)(notification, options));
	};
	
	var onReceiveNewMessage = function onReceiveNewMessage(containerId, notificationOptions, snapshot) {
	  if (snapshot.exists()) {
	    var message = snapshot.val();
	
	    (0, _store.dispatch)((0, _set_new_message2.default)(message, snapshot.key(), containerId));
	    (0, _user2.default)(message.from);
	    if (notificationOptions) setNewMessageNotification(message, notificationOptions);
	  }
	};
	
	var boundOnReceiveNewMessage = onReceiveNewMessage;
	
	var watchNewMessages = exports.watchNewMessages = function watchNewMessages(containerId) {
	  var notificationOptions = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	  var startTime = arguments.length <= 2 || arguments[2] === undefined ? (0, _moment2.default)().valueOf() : arguments[2];
	
	  if (!containerId) return;
	
	  var ENDPOINT = _constants.MESSAGES_ENDPOINT + '/' + containerId;
	
	  boundOnReceiveNewMessage = onReceiveNewMessage.bind(null, containerId, notificationOptions);
	  //messageRef = messageRef.bind(null, ENDPOINT, startTime)
	  messageRef = _firedux2.default.ref.child(ENDPOINT).orderByChild('time').startAt(startTime);
	
	  messageRef.on('child_added', boundOnReceiveNewMessage);
	  messageRef.on('child_changed', boundOnReceiveNewMessage);
	};
	
	var unwatchNewMessages = exports.unwatchNewMessages = function unwatchNewMessages() {
	  if (!messageRef) return;
	
	  // TODO: find a way to correctly off this bound function
	  messageRef.off('child_added', boundOnReceiveNewMessage);
	  messageRef.off('child_changed', boundOnReceiveNewMessage);
	};

/***/ },
/* 692 */,
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(7);
	
	var _reactGooglePublisherTag = __webpack_require__(579);
	
	var _reactGooglePublisherTag2 = _interopRequireDefault(_reactGooglePublisherTag);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FixedSlotAdvertisement = function (_React$Component) {
	  _inherits(FixedSlotAdvertisement, _React$Component);
	
	  function FixedSlotAdvertisement(props) {
	    _classCallCheck(this, FixedSlotAdvertisement);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(FixedSlotAdvertisement).call(this, props));
	
	    _this.state = {};
	
	    _this.refreshAd = _this.refreshAd.bind(_this);
	    _this.adjustAdvSize = _this.adjustAdvSize.bind(_this);
	    return _this;
	  }
	
	  _createClass(FixedSlotAdvertisement, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props;
	      var tagId = _props.tagId;
	      var networkId = _props.networkId;
	      var refreshInterval = _props.refreshInterval;
	
	
	      if (refreshInterval && tagId && networkId) {
	        this.startAdRefreshInterval(refreshInterval);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextTagId = nextProps.tagId;
	      var nextNetworkId = nextProps.networkId;
	      var nextRefreshInterval = nextProps.refreshInterval;
	      var _props2 = this.props;
	      var tagId = _props2.tagId;
	      var networkId = _props2.networkId;
	      var refreshInterval = _props2.refreshInterval;
	
	
	      if (tagId !== nextTagId || networkId !== nextNetworkId || refreshInterval !== nextRefreshInterval) {
	        this.startAdRefreshInterval(nextRefreshInterval);
	      }
	    }
	  }, {
	    key: 'startAdRefreshInterval',
	    value: function startAdRefreshInterval() {
	      var interval = arguments.length <= 0 || arguments[0] === undefined ? this.props.refreshInterval : arguments[0];
	
	      if (this.adRefreshInterval) clearInterval(this.adRefreshInterval);
	
	      this.adRefreshInterval = setInterval(this.refreshAd, interval * 1000);
	    }
	  }, {
	    key: 'refreshAd',
	    value: function refreshAd() {
	      if (!this.refs.ad || !this.refs.ad.refreshSlot) return;
	
	      this.refs.ad.refreshSlot();
	    }
	  }, {
	    key: 'getAdPath',
	    value: function getAdPath() {
	      return '/' + this.props.networkId + '/' + this.props.tagId;
	    }
	  }, {
	    key: 'adjustAdvSize',
	    value: function adjustAdvSize(_adv) {
	      var _this2 = this;
	
	      if (this.refs.adContainer) {
	        (function () {
	          var width = _this2.refs.adContainer.offsetWidth;
	          var dimensions = _this2.getScaledDimensions(width, _this2.props.dimensions);
	          var iframes = _reactDom2.default.findDOMNode(_this2.refs.adContainer).querySelectorAll('iframe');
	
	          iframes.forEach(function (iframe) {
	            if (iframe) {
	              var img = iframe.contentDocument.querySelector('img');
	
	              iframe.width = dimensions[0];
	              iframe.height = dimensions[1];
	
	              if (img) {
	                img.width = dimensions[0];
	                img.height = dimensions[1];
	              }
	            }
	          });
	        })();
	      }
	    }
	  }, {
	    key: 'getScaledDimensions',
	    value: function getScaledDimensions() {
	      var width = arguments.length <= 0 || arguments[0] === undefined ? this.props.maxWidth : arguments[0];
	      var dimensions = arguments.length <= 1 || arguments[1] === undefined ? this.props.dimensions : arguments[1];
	
	      var scaledDimensions = this.getDimensions(width, dimensions);
	
	      if (scaledDimensions[0] < width) width = scaledDimensions[0];
	
	      var height = scaledDimensions[1] / scaledDimensions[0] * width;
	
	      return [width, height];
	    }
	  }, {
	    key: 'getDimensions',
	    value: function getDimensions() {
	      var width = arguments.length <= 0 || arguments[0] === undefined ? this.props.maxWidth : arguments[0];
	      var dimensions = arguments.length <= 1 || arguments[1] === undefined ? this.props.dimensions : arguments[1];
	      var mobile = dimensions.mobile;
	      var desktop = dimensions.leaderboard;
	
	
	      if (width > mobile[0]) {
	        return desktop;
	      } else {
	        return mobile;
	      }
	    }
	  }, {
	    key: 'getClassName',
	    value: function getClassName() {
	      return 'rchat-ad-fixed-slot';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.tagId || !this.props.networkId) return false;
	      if (this.props.isModerated === true && this.props.isModeratedEnabled === false) return false;
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'adContainer', style: { width: this.props.maxWidth, margin: 'auto' } },
	        _react2.default.createElement(_reactGooglePublisherTag2.default, {
	          ref: 'ad', path: this.getAdPath(),
	          dimensions: this.getDimensions(), responsive: false,
	          canBeLower: false,
	          className: this.getClassName(),
	          onSlotRenderEnded: this.adjustAdvSize,
	          onImpressionViewable: this.adjustAdvSize })
	      );
	    }
	  }]);
	
	  return FixedSlotAdvertisement;
	}(_react2.default.Component);
	
	FixedSlotAdvertisement.defaultProps = {
	  maxWidth: 280,
	  dimensions: {
	    mobile: [320, 50],
	    leaderboard: [728, 90]
	  },
	  target: 'chatPane'
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    tagId: state.getIn(['advertisements', 'fixedSlot', 'tagId']),
	    networkId: state.getIn(['advertisements', 'settings', 'networkId']),
	    isModeratedEnabled: state.getIn(['advertisements', 'settings', 'isModeratedGroupChatEnabled']),
	    refreshInterval: state.getIn(['advertisements', 'fixedSlot', 'refreshInterval'])
	  };
	};
	
	var FixedSlotAdvertisementContainer = (0, _reactRedux.connect)(mapStateToProps)(FixedSlotAdvertisement);
	
	exports.default = FixedSlotAdvertisementContainer;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupChatAvatarBookmarkedIndicator = function (_React$Component) {
	  _inherits(GroupChatAvatarBookmarkedIndicator, _React$Component);
	
	  function GroupChatAvatarBookmarkedIndicator() {
	    _classCallCheck(this, GroupChatAvatarBookmarkedIndicator);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(GroupChatAvatarBookmarkedIndicator).apply(this, arguments));
	  }
	
	  _createClass(GroupChatAvatarBookmarkedIndicator, [{
	    key: 'render',
	    value: function render() {
	      if (!this.props.bookmarkedGroup) return false;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bookmarked-indicator' },
	        _react2.default.createElement('i', { className: 'rc-icon-bookmark' })
	      );
	    }
	  }]);
	
	  return GroupChatAvatarBookmarkedIndicator;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    bookmarkedGroup: state.getIn(['groups', '_bookmarks', 'all', ownProps.groupId])
	  };
	};
	
	var GroupChatAvatarBookmarkedIndicatorContainer = (0, _reactRedux.connect)(mapStateToProps)(GroupChatAvatarBookmarkedIndicator);
	
	exports.default = GroupChatAvatarBookmarkedIndicatorContainer;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _crud_list = __webpack_require__(58);
	
	var _crud_list2 = _interopRequireDefault(_crud_list);
	
	var _group_chat_avatar = __webpack_require__(244);
	
	var _group_chat_avatar2 = _interopRequireDefault(_group_chat_avatar);
	
	var _group_chat_bookmark_button = __webpack_require__(274);
	
	var _group_chat_bookmark_button2 = _interopRequireDefault(_group_chat_bookmark_button);
	
	var _group_chat_subscribe_button = __webpack_require__(227);
	
	var _group_chat_subscribe_button2 = _interopRequireDefault(_group_chat_subscribe_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PHONE = _constants.VIEWPORT_TYPES.PHONE;
	
	var GroupChatsListed = function (_React$Component) {
	  _inherits(GroupChatsListed, _React$Component);
	
	  function GroupChatsListed(props) {
	    _classCallCheck(this, GroupChatsListed);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GroupChatsListed).call(this, props));
	
	    _this.state = {
	      groupChats: (0, _immutable.fromJS)([])
	    };
	
	    _this.formatGroupChatName = _this.formatGroupChatName.bind(_this);
	    _this.onSortChange = _this.onSortChange.bind(_this);
	    _this.renderCustomListAction = _this.renderCustomListAction.bind(_this);
	    return _this;
	  }
	
	  _createClass(GroupChatsListed, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setGroupChats(this.props.groupChatsPrivate, this.props.groupChatsGlobal);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props;
	      var privates = _props.groupChatsPrivate;
	      var globals = _props.groupChatsGlobal;
	      var nextPrivates = nextProps.groupChatsPrivate;
	      var nextGlobals = nextProps.groupChatsGlobal;
	
	
	      if (privates !== nextPrivates || globals !== nextGlobals) {
	        this.setGroupChats(nextPrivates, nextGlobals);
	      }
	    }
	  }, {
	    key: 'setGroupChats',
	    value: function setGroupChats(privates, globals) {
	      var groupChats = privates.concat(globals);
	      groupChats = this.sortGroupChats('name', 'asc', groupChats);
	
	      this.setState({ groupChats: groupChats });
	    }
	  }, {
	    key: 'sortGroupChats',
	    value: function sortGroupChats(attr, order, groupChats) {
	      var sorter = function sorter(g) {
	        return typeof g.get(attr) === 'string' ? g.get(attr).toLowerCase() : g.get(attr);
	      };
	
	      groupChats = groupChats.sortBy(sorter);
	
	      if (order === 'desc') groupChats = groupChats.reverse();
	
	      return groupChats;
	    }
	  }, {
	    key: 'formatGroupChatName',
	    value: function formatGroupChatName(name, group) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'inline-block', marginRight: 4, fontSize: 14 } },
	          _react2.default.createElement(_group_chat_avatar2.default, { size: 30, initials: group.get('initials') })
	        ),
	        _react2.default.createElement(
	          'h5',
	          { style: { display: 'inline-block', fontSize: 14 } },
	          name
	        )
	      );
	    }
	  }, {
	    key: 'getAttrs',
	    value: function getAttrs() {
	      return [{ name: 'name', label: 'Group Chat', isSortable: true, isPrimary: true, formatter: this.formatGroupChatName }];
	    }
	  }, {
	    key: 'onSortChange',
	    value: function onSortChange(attr, order) {
	      var groupChats = this.sortGroupChats(attr, order, this.state.groupChats);
	
	      this.setState({ groupChats: groupChats });
	    }
	  }, {
	    key: 'renderCustomBookmarkAction',
	    value: function renderCustomBookmarkAction(group) {
	      var scope = group.get('scope');
	      var key = group.get('key');
	
	      if (scope === _constants.GROUP_CHAT_SCOPES.GLOBAL) {
	        return _react2.default.createElement(
	          'span',
	          { style: { display: 'inline-block', width: 116, textAlign: 'center', fontStyle: 'italic', fontSize: 14, marginRight: 5 } },
	          'Public Chat'
	        );
	      } else {
	        return _react2.default.createElement(_group_chat_bookmark_button2.default, { groupId: key, style: { marginRight: 5 } });
	      }
	    }
	  }, {
	    key: 'renderCustomListAction',
	    value: function renderCustomListAction(group) {
	      var width = this.props.viewportType === PHONE ? 'auto' : 250;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'group-chat-resource-actions', style: { width: width, textAlign: 'right' } },
	        this.renderCustomBookmarkAction(group),
	        _react2.default.createElement(_group_chat_subscribe_button2.default, { groupId: group.get('key') })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_crud_list2.default, {
	        resources: this.state.groupChats,
	        attrs: this.getAttrs(),
	        isActionsEnabled: true,
	        isActionDetailsEnabled: false,
	        customAction: this.renderCustomListAction,
	        onSortChange: this.onSortChange,
	        paginationStyle: { marginTop: 5, marginBottom: 5 },
	        limit: 10 });
	    }
	  }]);
	
	  return GroupChatsListed;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    groupChatsGlobal: state.getIn(['groups', 'global'], (0, _immutable.fromJS)([])),
	    groupChatsPrivate: state.getIn(['groups', 'private'], (0, _immutable.fromJS)([])),
	    viewportType: state.getIn(['viewport', 'type'])
	  };
	};
	
	var GroupChatsListedContainer = (0, _reactRedux.connect)(mapStateToProps)(GroupChatsListed);
	
	exports.default = GroupChatsListedContainer;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _show_modal = __webpack_require__(16);
	
	var _show_modal2 = _interopRequireDefault(_show_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupChatsSeeAllLink = function GroupChatsSeeAllLink(props) {
	  var classes = props.classes;
	  var style = props.style;
	  var showModal = props.showModal;
	  var children = props.children;
	
	
	  return _react2.default.createElement(
	    'a',
	    { className: classes, style: style, href: '#', onClick: showModal },
	    children
	  );
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    showModal: function showModal(e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      dispatch((0, _show_modal2.default)({ type: 'groupChats', props: {} }));
	    }
	  };
	};
	
	var GroupChatsSeeAllLinkContainer = (0, _reactRedux.connect)(null, mapDispatchToProps)(GroupChatsSeeAllLink);
	
	exports.default = GroupChatsSeeAllLinkContainer;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _go_to_session_button = __webpack_require__(337);
	
	var _go_to_session_button2 = _interopRequireDefault(_go_to_session_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SessionBookConfirmation = function SessionBookConfirmation(props) {
	  if (props.expert && props.currentUser && props.bookData.requestData.get('type') === 'immediate') {
	    return _react2.default.createElement(
	      'div',
	      { className: 'book-session' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'You are all set!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Go to your session to start it now.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section', style: { maxWidth: '400px', marginTop: 40 } },
	        _react2.default.createElement(_go_to_session_button2.default, { sessionId: props.bookData.sessionId })
	      )
	    );
	  } else {
	    // TODO: implement future booking sessions confirmation.
	    return _react2.default.createElement(
	      'div',
	      { className: 'book-session' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'You\'re all set! Here\'s what happens next...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'gray-box', style: { paddingLeft: 20 } },
	          _react2.default.createElement(
	            'ul',
	            { style: { textAlign: 'left' } },
	            _react2.default.createElement(
	              'li',
	              null,
	              'You and ',
	              props.expert.get('name'),
	              ' will receive an email notification confirming your expert advice session... '
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              '1 day and 1 hour before your session, you\'ll receive an email reminder...'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Show up ON TIME to maximize ',
	              props.expert.get('name'),
	              '\'s time!'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'If your chat ends early, you\'ll be refunded the difference.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Thanks for using RotoBaller, the only place for live fantasy advice with real experts!'
	        )
	      )
	    );
	  }
	};
	
	exports.default = SessionBookConfirmation;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _reactSpinkit = __webpack_require__(67);
	
	var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);
	
	var _constants = __webpack_require__(2);
	
	var _immediate_session_request = __webpack_require__(688);
	
	var _timeout_session_request = __webpack_require__(684);
	
	var _timeout_session_request2 = _interopRequireDefault(_timeout_session_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SessionBookConfirmationImmediate = function (_React$Component) {
	  _inherits(SessionBookConfirmationImmediate, _React$Component);
	
	  function SessionBookConfirmationImmediate(props) {
	    _classCallCheck(this, SessionBookConfirmationImmediate);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SessionBookConfirmationImmediate).call(this, props));
	
	    _this.state = {};
	
	    _this.onSessionRequestTimeout = _this.onSessionRequestTimeout.bind(_this);
	    return _this;
	  }
	
	  _createClass(SessionBookConfirmationImmediate, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.onLoadComponent(this.props.expert.get('uid'), this.props.currentUser.get('uid'));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.sessionRequest && nextProps.sessionRequest.get('status') === _constants.SESSION_REQUEST_STATUSES.ACCEPTED && nextProps.sessionRequest.get('sessionId')) {
	        var sessionId = nextProps.sessionRequest.get('sessionId');
	        var requestData = this.props.sessionRequest.merge({ type: 'immediate' });
	
	        this.props.onSessionRequestAccepted({ sessionId: sessionId, requestData: requestData });
	      }
	
	      if (this.props.sessionRequest !== nextProps.sessionRequest && nextProps.sessionRequest && nextProps.sessionRequest.get('status') === _constants.SESSION_REQUEST_STATUSES.REQUESTED) {
	        this.startSessionRequestTimeout();
	      }
	    }
	  }, {
	    key: 'componentWillUnMount',
	    value: function componentWillUnMount() {
	      this.props.onUnloadComponent(this.props.expert.get('uid'), this.props.currentUser.get('uid'));
	    }
	  }, {
	    key: 'startSessionRequestTimeout',
	    value: function startSessionRequestTimeout() {
	      if (this.sessionRequestTimeoutId) return;
	
	      this.sessionRequestTimeoutId = setTimeout(this.onSessionRequestTimeout, this.props.sessionRequestTimeout * 1000);
	    }
	  }, {
	    key: 'onSessionRequestTimeout',
	    value: function onSessionRequestTimeout() {
	      this.props.onSessionRequestTimeout(this.props.sessionRequest);
	    }
	  }, {
	    key: 'renderInnerContent',
	    value: function renderInnerContent() {
	      if (!this.props.sessionRequest) return false;
	
	      var status = this.props.sessionRequest.get('status');
	      var sessionRef = this.props.sessionRequest.get('sessionId');
	
	      if (sessionRef) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'section', style: { maxWidth: '400px' } },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Expert is accepted your session request.'
	            )
	          )
	        );
	      } else if (status === _constants.SESSION_REQUEST_STATUSES.REQUESTED) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'section', style: { maxWidth: '400px' } },
	            _react2.default.createElement(
	              'p',
	              null,
	              'You requested an immediate session with ',
	              this.props.expert.get('name'),
	              '.',
	              _react2.default.createElement('br', null),
	              'We\'re working to confirm ',
	              this.props.expert.get('name'),
	              '\'s availability and will get back to you ASAP!',
	              _react2.default.createElement('br', null),
	              'Please leave this window open.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section', style: { maxWidth: '400px', marginTop: 40 } },
	            _react2.default.createElement(_reactSpinkit2.default, { type: 'three-bounce' })
	          )
	        );
	      } else if (status === _constants.SESSION_REQUEST_STATUSES.TIMEDOUT) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'section', style: { maxWidth: '400px' } },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Expert hasn\'t responded to your session request.',
	              _react2.default.createElement('br', null),
	              'You can book your session for later or cancel this request.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section', style: { maxWidth: '400px', marginTop: 40, textAlign: 'center' } },
	            _react2.default.createElement(
	              'a',
	              { href: '#', className: 'button success', onClick: this.props.onBookLaterClick },
	              'Book for later'
	            )
	          )
	        );
	      } else if (status === _constants.SESSION_REQUEST_STATUSES.ACCEPTED) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'section', style: { maxWidth: '400px' } },
	            _react2.default.createElement(
	              'p',
	              null,
	              this.props.expert.get('name'),
	              ' accepted your session request.',
	              _react2.default.createElement('br', null)
	            )
	          )
	        );
	      } else if (status === _constants.SESSION_REQUEST_STATUSES.DISMISSED) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'section', style: { maxWidth: '400px' } },
	            _react2.default.createElement(
	              'p',
	              null,
	              this.props.expert.get('name'),
	              ' didn\'t accept your session request.',
	              _react2.default.createElement('br', null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section', style: { maxWidth: '400px', marginTop: 40, textAlign: 'center' } },
	            _react2.default.createElement(
	              'a',
	              { href: '#', className: 'button success', onClick: this.props.onBookLaterClick },
	              'Book for later'
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'book-session' },
	        this.renderInnerContent()
	      );
	    }
	  }]);
	
	  return SessionBookConfirmationImmediate;
	}(_react2.default.Component);
	
	SessionBookConfirmationImmediate.defaultProps = {
	  onSessionRequestAccepted: function onSessionRequestAccepted() {}
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    sessionRequest: state.getIn(['sessions', '_requests', ownProps.expert.get('uid'), ownProps.currentUser.get('uid')]),
	    sessionRequestTimeout: state.getIn(['chatSettings', 'sessionRequestTimeout'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    onLoadComponent: _immediate_session_request.watchImmediateSessionRequest,
	    onUnloadComponent: _immediate_session_request.unwatchImmediateSessionRequest,
	    onSessionRequestTimeout: _timeout_session_request2.default
	  };
	};
	
	var SessionBookConfirmationImmediateContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SessionBookConfirmationImmediate);
	
	exports.default = SessionBookConfirmationImmediateContainer;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(7);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _short_day = __webpack_require__(450);
	
	var _short_day2 = _interopRequireDefault(_short_day);
	
	var _short_time_of_day = __webpack_require__(302);
	
	var _short_time_of_day2 = _interopRequireDefault(_short_time_of_day);
	
	var _schedule = __webpack_require__(452);
	
	var _create_future_session_with_expert = __webpack_require__(671);
	
	var _create_future_session_with_expert2 = _interopRequireDefault(_create_future_session_with_expert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SessionBookLater = function (_React$Component) {
	  _inherits(SessionBookLater, _React$Component);
	
	  function SessionBookLater(props) {
	    _classCallCheck(this, SessionBookLater);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SessionBookLater).call(this, props));
	
	    _this.state = {};
	
	    _this.onDaySelect = _this.onDaySelect.bind(_this);
	    _this.onSessionTimeSelect = _this.onSessionTimeSelect.bind(_this);
	    _this.onSessionLengthSelect = _this.onSessionLengthSelect.bind(_this);
	    _this.onSessionSubmit = _this.onSessionSubmit.bind(_this);
	
	    _this.proceedToSessionBook = _this.proceedToSessionBook.bind(_this);
	    return _this;
	  }
	
	  _createClass(SessionBookLater, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.onComponentLoaded(this.props.expert.get('uid'));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onComponentUnLoaded();
	    }
	  }, {
	    key: 'proceedToSessionBook',
	    value: function proceedToSessionBook(sessionId) {
	      if (sessionId) {
	        var requestData = (0, _immutable.fromJS)({
	          sessionLength: this.state.selectedSessionLength,
	          startTime: this.state.selectedSessionTime,
	          type: 'later'
	        });
	
	        this.props.onSessionBook({ sessionId: sessionId, requestData: requestData });
	      }
	    }
	  }, {
	    key: 'onDaySelect',
	    value: function onDaySelect(e) {
	      var selectedDay = e.target.value;
	
	      this.setState({ selectedDay: selectedDay });
	    }
	  }, {
	    key: 'onSessionTimeSelect',
	    value: function onSessionTimeSelect(e) {
	      var selectedSessionTime = parseInt(e.target.value, 10);
	
	      if (typeof selectedSessionTime === 'number') {
	        this.setState({ selectedSessionTime: selectedSessionTime });
	      }
	    }
	  }, {
	    key: 'onSessionLengthSelect',
	    value: function onSessionLengthSelect(e) {
	      var selectedSessionLength = parseInt(e.target.value, 10);
	
	      if (typeof selectedSessionLength === 'number') {
	        this.setState({ selectedSessionLength: selectedSessionLength });
	      }
	    }
	  }, {
	    key: 'onSessionSubmit',
	    value: function onSessionSubmit(e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      var startTime = this.state.selectedSessionTime;
	      var sessionLength = this.state.selectedSessionLength;
	
	      this.props.createFutureSessionWithExpert(this.props.expert, this.props.currentUser, sessionLength, startTime).then(this.proceedToSessionBook);
	    }
	  }, {
	    key: 'shouldBookButtonDisabled',
	    value: function shouldBookButtonDisabled() {
	      if (!this.state.selectedDay || !this.state.selectedSessionTime || !this.state.selectedSessionLength) return true;
	
	      return false;
	    }
	  }, {
	    key: 'renderAvailableTimeOptions',
	    value: function renderAvailableTimeOptions() {
	      if (this.state.selectedDay) {
	        return this.props.expertSchedule.getIn([this.state.selectedDay, 'slots']).filter(function (slot) {
	          return slot.available === true;
	        }).filter(function (slot) {
	          return slot.startTime.isSameOrAfter((0, _moment2.default)());
	        }).map(function (slot) {
	          return _react2.default.createElement(
	            'option',
	            { key: slot.startTime.valueOf(), value: slot.startTime.valueOf() },
	            (0, _short_time_of_day2.default)(slot.startTime)
	          );
	        });
	      }
	    }
	  }, {
	    key: 'renderAvailableDays',
	    value: function renderAvailableDays() {
	      return this.props.expertSchedule.toList().sortBy(function (dayEntry) {
	        return dayEntry.get('index');
	      }).map(function (dayEntry) {
	        return _react2.default.createElement(
	          'option',
	          { key: dayEntry.get('index'), value: dayEntry.get('index') },
	          (0, _short_day2.default)(dayEntry.get('day'))
	        );
	      });
	    }
	  }, {
	    key: 'renderInnerSection',
	    value: function renderInnerSection() {
	      if (this.props.expertSchedule && this.props.expertSchedule.size > 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-section' },
	            _react2.default.createElement(
	              'select',
	              { style: { width: 250 }, onChange: this.onDaySelect },
	              _react2.default.createElement(
	                'option',
	                { key: -1, value: '', disabled: true, selected: true },
	                'Select day'
	              ),
	              this.renderAvailableDays()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-section', onChange: this.onSessionTimeSelect },
	            _react2.default.createElement(
	              'select',
	              { style: { width: 250 }, disabled: !this.state.selectedDay },
	              _react2.default.createElement(
	                'option',
	                { key: -1, value: '', disabled: true, selected: true },
	                'Select time'
	              ),
	              this.renderAvailableTimeOptions()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-section', onChange: this.onSessionLengthSelect },
	            _react2.default.createElement(
	              'select',
	              { style: { width: 250 }, disabled: !this.state.selectedDay },
	              _react2.default.createElement(
	                'option',
	                { key: -1, value: '', disabled: true, selected: true },
	                'Select your session length'
	              ),
	              this.props.sessionLengths.map(function (s) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: s.get('value'), value: s.get('value') },
	                  s.get('label')
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-section' },
	            _react2.default.createElement(
	              'button',
	              { className: 'button success', style: { width: 250 }, disabled: this.shouldBookButtonDisabled(), onClick: this.onSessionSubmit },
	              'Book'
	            )
	          )
	        );
	      } else if (this.props.expertSchedule) {
	        return _react2.default.createElement(
	          'p',
	          null,
	          'We\'re sorry, this expert has not scheduled available time yet.'
	        );
	      } else {
	        return _react2.default.createElement(
	          'p',
	          null,
	          'Loading...'
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Book a paid session for later.'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'text-warning', style: { color: '#8a6929', fontSize: 12 } },
	          'You are seeing expert\'s available times in your local time zone.'
	        ),
	        this.renderInnerSection()
	      );
	    }
	  }]);
	
	  return SessionBookLater;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    expertSchedule: state.getIn(['schedules', ownProps.expert.get('uid'), 'mapped']),
	    sessionLengths: state.getIn(['chatSettings', 'sessionPaymentLengths'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    onComponentLoaded: _schedule.watchUserSchedule,
	    onComponentUnLoaded: _schedule.unwatchUserSchedule,
	    createFutureSessionWithExpert: _create_future_session_with_expert2.default
	  };
	};
	
	var SessionBookLaterContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SessionBookLater);
	
	exports.default = SessionBookLaterContainer;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _request_immediate_session = __webpack_require__(677);
	
	var _request_immediate_session2 = _interopRequireDefault(_request_immediate_session);
	
	var _is_available_for_immediate_session = __webpack_require__(605);
	
	var _is_available_for_immediate_session2 = _interopRequireDefault(_is_available_for_immediate_session);
	
	var _session_book_confirmation_immediate = __webpack_require__(698);
	
	var _session_book_confirmation_immediate2 = _interopRequireDefault(_session_book_confirmation_immediate);
	
	var _session_book_later = __webpack_require__(699);
	
	var _session_book_later2 = _interopRequireDefault(_session_book_later);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SessionBooker = function (_React$Component) {
	  _inherits(SessionBooker, _React$Component);
	
	  function SessionBooker(props) {
	    _classCallCheck(this, SessionBooker);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SessionBooker).call(this, props));
	
	    _this.state = {
	      selectedSessionLength: null,
	      selectedBookForm: 'now'
	    };
	
	    _this.onSessionLengthSelect = _this.onSessionLengthSelect.bind(_this);
	    _this.onSessionBook = _this.onSessionBook.bind(_this);
	    _this.onBookFormImmediateClick = _this.onBookFormImmediateClick.bind(_this);
	    _this.onBookFormLaterClick = _this.onBookFormLaterClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(SessionBooker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ selectedBookForm: 'now' });
	    }
	  }, {
	    key: 'onSessionLengthSelect',
	    value: function onSessionLengthSelect(e) {
	      var length = parseInt(e.target.value, 10);
	
	      if (typeof length === 'number') {
	        this.setState({ selectedSessionLength: length });
	      }
	    }
	  }, {
	    key: 'onSessionBook',
	    value: function onSessionBook(e) {
	      e.preventDefault();
	
	      this.props.onSessionImmediateBook(this.props.expert.get('uid'), this.props.currentUser.get('uid'), this.state.selectedSessionLength);
	
	      this.setState({ sessionRequestData: {
	          type: 'immediate',
	          sessionLength: this.state.selectedSessionLength
	        } });
	    }
	  }, {
	    key: 'onBookFormImmediateClick',
	    value: function onBookFormImmediateClick(e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      this.setState({ selectedBookForm: 'now' });
	    }
	  }, {
	    key: 'onBookFormLaterClick',
	    value: function onBookFormLaterClick(e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      this.setState({ selectedBookForm: 'later' });
	    }
	  }, {
	    key: 'onBookFormClick',
	    value: function onBookFormClick(section) {
	      if (section === 'now') return this.onBookFormImmediateClick;else if (section === 'later') return this.onBookFormLaterClick;
	    }
	  }, {
	    key: 'isBookFormSectionActive',
	    value: function isBookFormSectionActive(section) {
	      if (section === 'now') {
	        return (0, _is_available_for_immediate_session2.default)(this.props.expertPresence) && this.state.selectedBookForm === 'now' ? true : false;
	      } else if (section === 'later') {
	        return !(0, _is_available_for_immediate_session2.default)(this.props.expertPresence) || this.state.selectedBookForm === 'later' ? true : false;
	      }
	    }
	  }, {
	    key: 'renderBookOptions',
	    value: function renderBookOptions() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'button-group large success' },
	        _react2.default.createElement(
	          'button',
	          { className: this.isBookFormSectionActive('now') ? 'active' : '', onClick: this.onBookFormClick('now'), disabled: !(0, _is_available_for_immediate_session2.default)(this.props.expertPresence) },
	          'Now'
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: this.isBookFormSectionActive('later') ? 'active' : '', onClick: this.onBookFormClick('later') },
	          'Later'
	        )
	      );
	    }
	  }, {
	    key: 'renderBookSubmit',
	    value: function renderBookSubmit() {
	      if (this.state.selectedSessionLength) {
	        return _react2.default.createElement(
	          'button',
	          { className: 'button success', onClick: this.onSessionBook, style: { width: 250 } },
	          'Request'
	        );
	      } else {
	        return _react2.default.createElement(
	          'button',
	          { className: 'button success', disabled: true, style: { width: 250 } },
	          'Request'
	        );
	      }
	    }
	  }, {
	    key: 'renderBookFormImmediate',
	    value: function renderBookFormImmediate() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'gray-box' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Expert is available for immediate session.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-section' },
	            _react2.default.createElement(
	              'select',
	              { onChange: this.onSessionLengthSelect, value: this.state.selectedSessionLength, style: { width: 250 } },
	              _react2.default.createElement(
	                'option',
	                { key: -1, value: '', disabled: true, selected: true },
	                'Select your session length'
	              ),
	              _react2.default.createElement(
	                'option',
	                { key: _constants.PAY_AS_YOU_GO_VALUE, value: _constants.PAY_AS_YOU_GO_VALUE },
	                'Pay as you go'
	              ),
	              this.props.sessionLengths.map(function (s) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: s.get('value'), value: s.get('value') },
	                  s.get('label')
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-section' },
	            this.renderBookSubmit()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderBookFormLater',
	    value: function renderBookFormLater() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'gray-box' },
	        _react2.default.createElement(_session_book_later2.default, {
	          expert: this.props.expert,
	          currentUser: this.props.currentUser,
	          onSessionBook: this.props.onSessionBook })
	      );
	    }
	  }, {
	    key: 'renderBookForm',
	    value: function renderBookForm() {
	      if ((0, _is_available_for_immediate_session2.default)(this.props.expertPresence) && this.state.selectedBookForm === 'now') {
	        return this.renderBookFormImmediate();
	      } else {
	        return this.renderBookFormLater();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.sessionRequestData && this.state.selectedBookForm === 'now') {
	        return _react2.default.createElement(_session_book_confirmation_immediate2.default, {
	          expert: this.props.expert,
	          currentUser: this.props.currentUser,
	          bookData: this.state.sessionRequestData,
	          onSessionRequestAccepted: this.props.onSessionBook,
	          onBookLaterClick: this.onBookFormLaterClick });
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'book-session' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            this.renderBookOptions()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            this.renderBookForm()
	          )
	        );
	      }
	    }
	  }]);
	
	  return SessionBooker;
	}(_react2.default.Component);
	
	SessionBooker.defaultProps = {
	  onSessionBook: function onSessionBook() {}
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    expertPresence: state.getIn(['presences', ownProps.expert.get('uid')]),
	    sessionLengths: state.getIn(['chatSettings', 'sessionPaymentLengths'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    onSessionImmediateBook: _request_immediate_session2.default
	  };
	};
	
	var SessionBookerContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SessionBooker);
	
	exports.default = SessionBookerContainer;

/***/ },
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*
	 * embed-js - v4.0.4
	 * A JavaScript plugin that analyses the string and embeds emojis, media, tweets, code and services.
	 * http://riteshkr.com/embed.js
	 *
	 *   Made by Ritesh Kumar
	 *   Under MIT License
	 */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.EmbedJS = factory());
	}(this, function () { 'use strict';
	
	    var __commonjs_global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : this;
	    function __commonjs(fn, module) { return module = { exports: {} }, fn(module, module.exports, __commonjs_global), module.exports; }
	
	
	    var babelHelpers = {};
	    babelHelpers.typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	      return typeof obj;
	    } : function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	    };
	
	    babelHelpers.classCallCheck = function (instance, Constructor) {
	      if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	      }
	    };
	
	    babelHelpers.createClass = function () {
	      function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	          var descriptor = props[i];
	          descriptor.enumerable = descriptor.enumerable || false;
	          descriptor.configurable = true;
	          if ("value" in descriptor) descriptor.writable = true;
	          Object.defineProperty(target, descriptor.key, descriptor);
	        }
	      }
	
	      return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);
	        if (staticProps) defineProperties(Constructor, staticProps);
	        return Constructor;
	      };
	    }();
	
	    babelHelpers.slicedToArray = function () {
	      function sliceIterator(arr, i) {
	        var _arr = [];
	        var _n = true;
	        var _d = false;
	        var _e = undefined;
	
	        try {
	          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	            _arr.push(_s.value);
	
	            if (i && _arr.length === i) break;
	          }
	        } catch (err) {
	          _d = true;
	          _e = err;
	        } finally {
	          try {
	            if (!_n && _i["return"]) _i["return"]();
	          } finally {
	            if (_d) throw _e;
	          }
	        }
	
	        return _arr;
	      }
	
	      return function (arr, i) {
	        if (Array.isArray(arr)) {
	          return arr;
	        } else if (Symbol.iterator in Object(arr)) {
	          return sliceIterator(arr, i);
	        } else {
	          throw new TypeError("Invalid attempt to destructure non-iterable instance");
	        }
	      };
	    }();
	
	    babelHelpers;
	
	    /**
	     * Trucates the string and adds ellipsis at the end.
	     * @param string        The string to be truncated
	     * @param n             Length to which it should be truncated
	     * @returns {string}    The truncated string
	     */
	    function truncate(string, n) {
	        return string.substr(0, n - 1) + (string.length > n ? '...' : '');
	    }
	
	    /**
	     * Converts a string into legitimate url.
	     * @param string
	     */
	    function toUrl(string) {
	        return string.indexOf('//') === -1 ? '//' + string : string;
	    }
	
	    /**
	     * Extends an Object
	     * @param destination
	     * @param source
	     * @returns {*}
	     */
	    function deepExtend(destination, source) {
	        for (var property in source) {
	            if (source.hasOwnProperty(property) && source[property] && source[property].constructor === Object) {
	                destination[property] = destination[property] || {};
	                deepExtend(destination[property], source[property]);
	            } else {
	                destination[property] = source[property];
	            }
	        }
	        return destination;
	    }
	
	    function escapeRegExp(str) {
	        return str.replace(/[\-\[\]\/\{}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	    }
	
	    /**
	     * Sort an array of objects based on the index value
	     * @param  {Array} arr Array to be sorted
	     * @return {Array}     Sorted array
	     */
	    function sortObject(arr) {
	        return arr.sort(function (a, b) {
	            return a.index - b.index;
	        });
	    }
	
	    /**
	     * Creates the string of the iframes after sorting them and finally returning a string
	     * @param  {string} str    String to which the created text has to be added
	     * @param  {object} embeds Sorted array of iframe html
	     * @return {string}        String to be rendered
	     */
	    function createText(str, embeds) {
	        var sortedEmbeds = sortObject(embeds);
	        for (var i = 0; i < sortedEmbeds.length; i++) {
	            str += ' ' + sortedEmbeds[i].text;
	        }
	        return str;
	    }
	
	    /**
	     * Matches the string and finds the substrings matching to the provided regex pattern
	     * @param  {object} regex Regex pattern
	     * @param  {string} input The string to be analyzed
	     * @return {object}       Returns the matched substring with their corresponding positions
	     */
	    function matches(regex, input) {
	        return regex.exec(input);
	    }
	
	    /**
	     * Checks whether a particular service should be embedded or not based on
	     * the setting provided by the user
	     * @param  {object} options The options provided by the user
	     * @param  {string} service Name of the service for which the condition is to be analyzed
	     * @return {boolean}        True if it should be embedded
	     */
	    function ifEmbed(options, service) {
	        if (options.singleEmbed && options.served.length) return;
	        return options.excludeEmbed.indexOf(service) == -1 && !(options.excludeEmbed === 'all');
	    }
	
	    function ifInline(options, service) {
	        return options.inlineEmbed.indexOf(service) >= 0 || options.inlineEmbed === 'all';
	    }
	
	    /**
	     * Calculates the dimensions for the elements based on a aspect ratio
	     * @param  {object} options Plugin options
	     * @return {object}         The width and height of the elements
	     */
	    function setDimensions(options) {
	        options.videoWidth = options.videoWidth || options.videoHeight / 3 * 4 || 800;
	        options.videoHeight = options.videoHeight || options.videoWidth / 4 * 3 || 600;
	        return options;
	    }
	
	    /**
	     * Returns a cloned object
	     * @param  {object} obj
	     * @return {object}     cloned object
	     */
	    function cloneObject(obj) {
	        if (obj === null || (typeof obj === 'undefined' ? 'undefined' : babelHelpers.typeof(obj)) !== 'object') return obj;
	        var temp = obj.constructor(); // give temp the original obj's constructor
	        for (var key in obj) {
	            temp[key] = cloneObject(obj[key]);
	        }
	        return temp;
	    }
	
	    function urlRegex() {
	        return (/((href|src)=["']|)(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])|(?:https?:\/\/)?(?:(?:0rz\.tw)|(?:1link\.in)|(?:1url\.com)|(?:2\.gp)|(?:2big\.at)|(?:2tu\.us)|(?:3\.ly)|(?:307\.to)|(?:4ms\.me)|(?:4sq\.com)|(?:4url\.cc)|(?:6url\.com)|(?:7\.ly)|(?:a\.gg)|(?:a\.nf)|(?:aa\.cx)|(?:abcurl\.net)|(?:ad\.vu)|(?:adf\.ly)|(?:adjix\.com)|(?:afx\.cc)|(?:all\.fuseurl.com)|(?:alturl\.com)|(?:amzn\.to)|(?:ar\.gy)|(?:arst\.ch)|(?:atu\.ca)|(?:azc\.cc)|(?:b23\.ru)|(?:b2l\.me)|(?:bacn\.me)|(?:bcool\.bz)|(?:binged\.it)|(?:bit\.ly)|(?:buff\.ly)|(?:bizj\.us)|(?:bloat\.me)|(?:bravo\.ly)|(?:bsa\.ly)|(?:budurl\.com)|(?:canurl\.com)|(?:chilp\.it)|(?:chzb\.gr)|(?:cl\.lk)|(?:cl\.ly)|(?:clck\.ru)|(?:cli\.gs)|(?:cliccami\.info)|(?:clickthru\.ca)|(?:clop\.in)|(?:conta\.cc)|(?:cort\.as)|(?:cot\.ag)|(?:crks\.me)|(?:ctvr\.us)|(?:cutt\.us)|(?:dai\.ly)|(?:decenturl\.com)|(?:dfl8\.me)|(?:digbig\.com)|(?:digg\.com)|(?:disq\.us)|(?:dld\.bz)|(?:dlvr\.it)|(?:do\.my)|(?:doiop\.com)|(?:dopen\.us)|(?:easyuri\.com)|(?:easyurl\.net)|(?:eepurl\.com)|(?:eweri\.com)|(?:fa\.by)|(?:fav\.me)|(?:fb\.me)|(?:fbshare\.me)|(?:ff\.im)|(?:fff\.to)|(?:fire\.to)|(?:firsturl\.de)|(?:firsturl\.net)|(?:flic\.kr)|(?:flq\.us)|(?:fly2\.ws)|(?:fon\.gs)|(?:freak\.to)|(?:fuseurl\.com)|(?:fuzzy\.to)|(?:fwd4\.me)|(?:fwib\.net)|(?:g\.ro.lt)|(?:gizmo\.do)|(?:gl\.am)|(?:go\.9nl.com)|(?:go\.ign.com)|(?:go\.usa.gov)|(?:goo\.gl)|(?:goshrink\.com)|(?:gurl\.es)|(?:hex\.io)|(?:hiderefer\.com)|(?:hmm\.ph)|(?:href\.in)|(?:hsblinks\.com)|(?:htxt\.it)|(?:huff\.to)|(?:hulu\.com)|(?:hurl\.me)|(?:hurl\.ws)|(?:icanhaz\.com)|(?:idek\.net)|(?:ilix\.in)|(?:is\.gd)|(?:its\.my)|(?:ix\.lt)|(?:j\.mp)|(?:jijr\.com)|(?:kl\.am)|(?:klck\.me)|(?:korta\.nu)|(?:krunchd\.com)|(?:l9k\.net)|(?:lat\.ms)|(?:liip\.to)|(?:liltext\.com)|(?:linkbee\.com)|(?:linkbun\.ch)|(?:liurl\.cn)|(?:ln-s\.net)|(?:ln-s\.ru)|(?:lnk\.gd)|(?:lnk\.ms)|(?:lnkd\.in)|(?:lnkurl\.com)|(?:lru\.jp)|(?:lt\.tl)|(?:lurl\.no)|(?:macte\.ch)|(?:mash\.to)|(?:merky\.de)|(?:migre\.me)|(?:miniurl\.com)|(?:minurl\.fr)|(?:mke\.me)|(?:moby\.to)|(?:moourl\.com)|(?:mrte\.ch)|(?:myloc\.me)|(?:myurl\.in)|(?:n\.pr)|(?:nbc\.co)|(?:nblo\.gs)|(?:nn\.nf)|(?:not\.my)|(?:notlong\.com)|(?:nsfw\.in)|(?:nutshellurl\.com)|(?:nxy\.in)|(?:nyti\.ms)|(?:o-x\.fr)|(?:oc1\.us)|(?:om\.ly)|(?:omf\.gd)|(?:omoikane\.net)|(?:on\.cnn.com)|(?:on\.mktw.net)|(?:onforb\.es)|(?:orz\.se)|(?:ow\.ly)|(?:ping\.fm)|(?:pli\.gs)|(?:pnt\.me)|(?:politi\.co)|(?:post\.ly)|(?:pp\.gg)|(?:profile\.to)|(?:ptiturl\.com)|(?:pub\.vitrue.com)|(?:qlnk\.net)|(?:qte\.me)|(?:qu\.tc)|(?:qy\.fi)|(?:r\.im)|(?:rb6\.me)|(?:read\.bi)|(?:readthis\.ca)|(?:reallytinyurl\.com)|(?:redir\.ec)|(?:redirects\.ca)|(?:redirx\.com)|(?:retwt\.me)|(?:ri\.ms)|(?:rickroll\.it)|(?:riz\.gd)|(?:rt\.nu)|(?:ru\.ly)|(?:rubyurl\.com)|(?:rurl\.org)|(?:rww\.tw)|(?:s4c\.in)|(?:s7y\.us)|(?:safe\.mn)|(?:sameurl\.com)|(?:sdut\.us)|(?:shar\.es)|(?:shink\.de)|(?:shorl\.com)|(?:short\.ie)|(?:short\.to)|(?:shortlinks\.co.uk)|(?:shorturl\.com)|(?:shout\.to)|(?:show\.my)|(?:shrinkify\.com)|(?:shrinkr\.com)|(?:shrt\.fr)|(?:shrt\.st)|(?:shrten\.com)|(?:shrunkin\.com)|(?:simurl\.com)|(?:slate\.me)|(?:smallr\.com)|(?:smsh\.me)|(?:smurl\.name)|(?:sn\.im)|(?:snipr\.com)|(?:snipurl\.com)|(?:snurl\.com)|(?:sp2\.ro)|(?:spedr\.com)|(?:srnk\.net)|(?:srs\.li)|(?:starturl\.com)|(?:su\.pr)|(?:surl\.co.uk)|(?:surl\.hu)|(?:t\.cn)|(?:t\.co)|(?:t\.lh.com)|(?:ta\.gd)|(?:tbd\.ly)|(?:tcrn\.ch)|(?:tgr\.me)|(?:tgr\.ph)|(?:tighturl\.com)|(?:tiniuri\.com)|(?:tiny\.cc)|(?:tiny\.ly)|(?:tiny\.pl)|(?:tinylink\.in)|(?:tinyuri\.ca)|(?:tinyurl\.com)|(?:tl\.gd)|(?:tmi\.me)|(?:tnij\.org)|(?:tnw\.to)|(?:tny\.com)|(?:to\.ly)|(?:togoto\.us)|(?:totc\.us)|(?:toysr\.us)|(?:tpm\.ly)|(?:tr\.im)|(?:tra\.kz)|(?:trunc\.it)|(?:twhub\.com)|(?:twirl\.at)|(?:twitclicks\.com)|(?:twitterurl\.net)|(?:twitterurl\.org)|(?:twiturl\.de)|(?:twurl\.cc)|(?:twurl\.nl)|(?:u\.mavrev.com)|(?:u\.nu)|(?:u76\.org)|(?:ub0\.cc)|(?:ulu\.lu)|(?:updating\.me)|(?:ur1\.ca)|(?:url\.az)|(?:url\.co.uk)|(?:url\.ie)|(?:url360\.me)|(?:url4\.eu)|(?:urlborg\.com)|(?:urlbrief\.com)|(?:urlcover\.com)|(?:urlcut\.com)|(?:urlenco\.de)|(?:urli\.nl)|(?:urls\.im)|(?:urlshorteningservicefortwitter\.com)|(?:urlx\.ie)|(?:urlzen\.com)|(?:usat\.ly)|(?:use\.my)|(?:vb\.ly)|(?:vgn\.am)|(?:vl\.am)|(?:vm\.lc)|(?:w55\.de)|(?:wapo\.st)|(?:wapurl\.co.uk)|(?:wipi\.es)|(?:wp\.me)|(?:x\.vu)|(?:xr\.com)|(?:xrl\.in)|(?:xrl\.us)|(?:xurl\.es)|(?:xurl\.jp)|(?:y\.ahoo.it)|(?:yatuc\.com)|(?:ye\.pe)|(?:yep\.it)|(?:yfrog\.com)|(?:yhoo\.it)|(?:yiyd\.com)|(?:youtu\.be)|(?:yuarel\.com)|(?:z0p\.de)|(?:zi\.ma)|(?:zi\.mu)|(?:zipmyurl\.com)|(?:zud\.me)|(?:zurl\.ws)|(?:zz\.gd)|(?:zzang\.kr)|(?:›\.ws)|(?:✩\.ws)|(?:✿\.ws)|(?:❥\.ws)|(?:➔\.ws)|(?:➞\.ws)|(?:➡\.ws)|(?:➨\.ws)|(?:➯\.ws)|(?:➹\.ws)|(?:➽\.ws))\/[a-z0-9]*/gi
	        );
	    }
	
	    function arrayLowercase(options, property) {
	        if (typeof options[property] !== 'string') {
	            options[property] = options[property].map(function (elem) {
	                return elem.toLowerCase();
	            });
	        }
	        return options;
	    }
	
	    /**
	     * Sets the dimensions and converts options values' Array into lowercase.
	     * @param options
	     * @returns {Object|*}
	     */
	    function processOptions(options) {
	        options = setDimensions(options);
	        options = arrayLowercase(options, 'excludeEmbed');
	        options = arrayLowercase(options, 'inlineEmbed');
	        return arrayLowercase(options, 'openGraphExclude');
	    }
	
	    /**
	     * Get the last element of an array or string
	     * @param elem [String|Array]
	     * @returns last element of the Array or String
	     */
	    function lastElement(elem) {
	        return elem[elem.length - 1];
	    }
	
	    var Renderer = function () {
	    	function Renderer(options) {
	    		babelHelpers.classCallCheck(this, Renderer);
	
	    		this.options = options || {};
	    	}
	
	    	babelHelpers.createClass(Renderer, [{
	    		key: 'url',
	    		value: function url(match, options) {
	    			var config = options.linkOptions;
	    			return '<a href="' + toUrl(match) + '" rel="' + config.rel + '" target="' + config.target + '">' + match + '</a>';
	    		}
	    	}, {
	    		key: 'smiley',
	    		value: function smiley(text, pre, code) {
	    			return '<span class="icon-emoticon" title="' + text + '">' + pre + code + '</span>';
	    		}
	    	}, {
	    		key: 'emoji',
	    		value: function emoji(text) {
	    			return '<span class="emoticon emoticon-' + text + '" title=":' + text + ':"></span>';
	    		}
	    	}, {
	    		key: 'audio',
	    		value: function audio(match) {
	    			return '<div class="ejs-audio ejs-embed"><audio src="' + match + '" controls class="video-js ejs-video-js"></audio></div>';
	    		}
	    	}, {
	    		key: 'soundcloud',
	    		value: function soundcloud(match, options) {
	    			var config = options.soundCloudOptions;
	    			return '<div class="ejs-embed">\n\t\t<iframe height="160" scrolling="no" src="https://w.soundcloud.com/player/?url=' + match + '\n\t\t&auto_play     = ' + config.autoPlay + '\n\t\t&hide_related  = ' + config.hideRelated + '\n\t\t&show_comments = ' + config.showComments + '\n\t\t&show_user     = ' + config.showUser + '\n\t\t&show_reposts  = ' + config.showReposts + '\n\t\t&visual        = ' + config.visual + '\n\t\t&download      = ' + config.download + '\n\t\t&color         = ' + config.themeColor + '\n\t\t&theme_color   = ' + config.themeColor + '"></iframe>\n\t\t</div>';
	    		}
	    	}, {
	    		key: 'spotify',
	    		value: function spotify(match) {
	    			var id = lastElement(match.split('/'));
	    			return '<div class="ejs-embed"><iframe src="https://embed.spotify.com/?uri=spotify:track:' + id + '" height="80"></iframe></div>';
	    		}
	    	}, {
	    		key: 'codepen',
	    		value: function codepen(id, options) {
	    			return '<div class="ejs-embed ejs-codepen"><iframe scrolling="no" height="' + options.codeEmbedHeight + '" src="' + id.replace(/\/pen\//, '/embed/') + '/?height=' + options.codeEmbedHeight + '"></iframe></div>';
	    		}
	    	}, {
	    		key: 'ideone',
	    		value: function ideone(match, options) {
	    			return '<div class="ejs-ideone ejs-embed"><iframe src="http://ideone.com/embed/' + match.split('/')[1] + '" frameborder="0" height="' + options.codeEmbedHeight + '"></iframe></div>';
	    		}
	    	}, {
	    		key: 'jsbin',
	    		value: function jsbin(id, options) {
	    			return '<div class="ejs-jsbin ejs-embed"><iframe height="' + options.codeEmbedHeight + '" class="jsbin-embed foo" src="http://' + id + '/embed?html,js,output"></iframe></div>';
	    		}
	    	}, {
	    		key: 'jsfiddle',
	    		value: function jsfiddle(id, options) {
	    			id = lastElement(id) == '/' ? id.slice(0, -1) : id;
	    			id = id.indexOf('//') !== -1 ? id : '//' + id;
	    			return '<div class="ejs-embed ejs-jsfiddle"><iframe height="' + options.codeEmbedHeight + '" src="' + id + '/embedded"></iframe></div>';
	    		}
	    	}, {
	    		key: 'plunker',
	    		value: function plunker(id, options) {
	    			return '<div class="ejs-embed ejs-plunker"><iframe class="ne-plunker" src="http://embed.plnkr.co/' + id + '" height="' + options.codeEmbedHeight + '"></iframe></div>';
	    		}
	    	}, {
	    		key: 'image',
	    		value: function image(match) {
	    			return '<div class="ejs-image ejs-embed"><div class="ne-image-wrapper"><img src="' + match + '"/></div></div>';
	    		}
	    	}, {
	    		key: 'flickr',
	    		value: function flickr(match, options) {
	    			return '<div class="ejs-embed"><div class="ne-image-wrapper"><iframe src="' + toUrl(match.split('/?')[0]) + '/player/" width="' + options.videoWidth + '" height="' + options.videoHeight + '"></iframe></div></div>';
	    		}
	    	}, {
	    		key: 'instagram',
	    		value: function instagram(match, options) {
	    			return '<div class="ejs-embed ejs-instagram"><iframe src="' + toUrl(match.split('/?')[0]) + '/embed/" height="' + options.videoHeight + '"></iframe></div>';
	    		}
	    	}, {
	    		key: 'slideShare',
	    		value: function slideShare(html) {
	    			return '<div class="ejs-embed ejs-slideshare">' + html + '</div>';
	    		}
	    	}, {
	    		key: 'video',
	    		value: function video(match) {
	    			return '<div class="ejs-video ejs-embed"><div class="ejs-video-player"><div class="ejs-player"><video src="' + match + '" class="ejs-video-js video-js" controls></video></div></div></div>';
	    		}
	    	}, {
	    		key: 'dailymotion',
	    		value: function dailymotion(match, options) {
	    			var id = lastElement(match.split('/'));
	    			return '<div class="ejs-video ejs-embed"><iframe src="http://www.dailymotion.com/embed/video/' + id + '" height="' + options.videoHeight + '" width="' + options.videoWidth + '"></iframe></div>';
	    		}
	    	}, {
	    		key: 'liveleak',
	    		value: function liveleak(match, options) {
	    			return '<div class="ejs-video ejs-embed"><iframe src="http://www.liveleak.com/e/' + match.split('=')[1] + '" height="' + options.videoHeight + '" width="' + options.videoWidth + '"></iframe></div>';
	    		}
	    	}, {
	    		key: 'ted',
	    		value: function ted(match, options) {
	    			var a = match.split('/');
	    			var id = a[a.length - 1];
	    			return '<div class="ejs-embed ejs-ted"><iframe src="http://embed.ted.com/talks/' + id + '.html" height="' + options.videoHeight + '" width="' + options.videoWidth + '"></iframe></div>';
	    		}
	    	}, {
	    		key: 'ustream',
	    		value: function ustream(match, options) {
	    			var id = match.split('/');
	    			id.splice(1, 0, 'embed');
	    			return '<div class="ejs-embed ejs-ustream"><iframe src="//www.' + id.join('/') + '" height="' + options.videoHeight + '" width="' + options.videoWidth + '"></iframe></div>';
	    		}
	    	}, {
	    		key: 'detailsVimeo',
	    		value: function detailsVimeo(data, fullData, embedUrl) {
	    			return '<div class="ejs-video ejs-embed"><div class="ejs-video-preview"><div class="ejs-video-thumb" data-ejs-url="' + embedUrl + '"><div class="ejs-thumb" style="background-image:url(' + data.thumbnail + ')"></div><i class="fa fa-play-circle-o"></i></div><div class="ejs-video-detail"><div class="ejs-video-title"><a href="' + data.url + '">' + data.title + '</a></div><div class="ejs-video-desc">' + data.description + '</div><div class="ejs-video-stats"><span><i class="fa fa-eye"></i>' + data.views + '</span><span><i class="fa fa-heart"></i>' + data.likes + '</span></div></div></div></div>';
	    		}
	    	}, {
	    		key: 'detailsYoutube',
	    		value: function detailsYoutube(data, fullData, embedUrl) {
	    			return '<div class="ejs-video ejs-embed"><div class="ejs-video-preview"><div class="ejs-video-thumb" data-ejs-url="' + embedUrl + '"><div class="ejs-thumb" style="background-image:url(' + data.thumbnail + ')"></div><i class="fa fa-play-circle-o"></i></div><div class="ejs-video-detail"><div class="ejs-video-title"><a href="' + data.url + '">' + data.title + '</a></div><div class="ejs-video-desc">' + data.description + '</div><div class="ejs-video-stats"><span><i class="fa fa-eye"></i>' + data.views + '</span><span><i class="fa fa-heart"></i>' + data.likes + '</span></div></div></div></div>';
	    		}
	    	}, {
	    		key: 'vine',
	    		value: function vine(match, options) {
	    			var id = lastElement(match.split('/'));
	    			var config = options.vineOptions;
	    			return '<div class="ejs-vine"><iframe class="ejs-vine-iframe" src="https://vine.co/v/' + id + '/embed/' + config.type + '" height="' + config.height + '" width="' + config.width + '"></iframe></div>';
	    		}
	    	}, {
	    		key: 'vimeo',
	    		value: function vimeo(url, options) {
	    			return '<div class="ejs-video-player ejs-embed"><iframe src="' + url + '" frameBorder="0" width="' + options.videoWidth + '" height="' + options.videoHeight + '"></iframe></div>';
	    		}
	    	}, {
	    		key: 'youtube',
	    		value: function youtube(url, options) {
	    			return '<div class="ejs-video-player ejs-embed"><iframe src="' + url + '" frameBorder="0" width="' + options.videoWidth + '" height="' + options.videoHeight + '"></iframe></div>';
	    		}
	    	}, {
	    		key: 'openGraph',
	    		value: function openGraph(data, options) {
	    			return '<div class="ejs-embed ejs-ogp"><div class="ejs-ogp-thumb" style="background-image:url(' + data.image + ')"></div><div class="ejs-ogp-details"><div class="ejs-ogp-title"><a href="' + data.url + '" target="' + options.linkOptions.target + '">' + data.title + '</a></div><div class="ejs-ogb-details">' + data.description + '</div></div></div>';
	    		}
	    	}, {
	    		key: 'github',
	    		value: function github(data, options) {
	    			return '<div class="ejs-embed ejs-github"><div class="ejs-ogp-thumb" style="background-image:url(' + data.owner.avatar_url + ')"></div><div class="ejs-ogp-details"><div class="ejs-ogp-title"><a href="' + data.html_url + '" target="' + options.linkOptions.target + '">' + data.full_name + '</a></div><div class="ejs-ogb-details">' + data.description + '</div><div class="ejs-github-stats"><span><i class="fa fa-star"></i>' + data.stargazers_count + '</span><span><i class="fa fa-code-fork"></i>' + data.network_count + '</span></div></div></div>';
	    		}
	    	}]);
	    	return Renderer;
	    }();
	
	    var regex = {
	    	basicAudio: /((?:https?):\/\/\S*\.(?:wav|mp3|ogg))/gi,
	    	soundCloud: /(soundcloud.com)\/[a-zA-Z0-9-_]+\/[a-zA-Z0-9-_]+/gi,
	    	spotify: /spotify.com\/track\/[a-zA-Z0-9_]+/gi,
	    	codepen: /http:\/\/codepen.io\/([A-Za-z0-9_]+)\/pen\/([A-Za-z0-9_]+)/gi,
	    	gist: /gist.github.com\/[a-zA-Z0-9_-]+\/([a-zA-Z0-9]+)/gi,
	    	highlightCode: /(`{3})(\s|[a-z]+)\s*([\s\S]*?[^`])\s*\1(?!`)/gm,
	    	inlineCode: /(`)\s*([\s\S]*?[^`])\s*\1(?!`)/gm,
	    	ideone: /ideone.com\/[a-zA-Z0-9]{6}/gi,
	    	jsbin: /jsbin.com\/[a-zA-Z0-9_]+\/[0-9_]+/gi,
	    	jsfiddle: /jsfiddle.net\/[a-zA-Z0-9_]+\/[a-zA-Z0-9_\/]+/gi,
	    	plunker: /plnkr.co\/edit\/[a-zA-Z0-9\?=]+/gi,
	    	basicImage: /((?:https?):\/\/\S*\.(?:gif|jpg|jpeg|tiff|png|svg|webp))/gi,
	    	flickr: /flickr.com\/[a-z]+\/[a-zA-Z@_$!\d\-\]+\/[\d]+/gi,
	    	instagram: /instagram.com\/p\/[a-zA-Z0-9_\/\?\-\=]+/gi,
	    	slideShare: /slideshare.net\/[a-zA-Z0-9_-]*\/[a-zA-Z0-9_-]*/gi,
	    	github: /[^\.]github.com\/([\w\.\-]+)\/([\w\.\-]+)/gi,
	    	basicVideo: /(?:https?):\/\/\S*\.(?:ogv|webm|mp4)/gi,
	    	dailymotion: /dailymotion.com\/video\/[a-zA-Z0-9-_]+/gi,
	    	liveleak: /liveleak.com\/view\?i=[a-zA-Z0-9_]+/gi,
	    	ted: /ted.com\/talks\/[a-zA-Z0-9_]+/gi,
	    	ustream: /ustream.tv\/[a-z\/0-9]*/gi,
	    	vimeo: /https?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)*/gi,
	    	vine: /vine.co\/v\/[a-zA-Z0-9]+/gi,
	    	youtube: /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/ytscreeningroom\?v=|\/feeds\/api\/videos\/|\/user\S*[^\w\-\s]|\S*[^\w\-\s]))([\w\-]{11})[?=&+%\w-]*/gi,
	    	gmap: /@\((.+)\)/gi,
	    	twitter: /https:\/\/twitter\.com\/\w+\/\w+\/\d+/gi,
	    	smileys: /(\:[\+\-\w]+\:|\<[\/\\]?3|[\(\)\\\D|\*\$][\-\^]?[\:\;\=]|[\:\;\=B8][\-\^]?[3DOPp\@\$\*\\\)\(\/\|])(?=\s|[\!\.\?]|$)/gi
	    };
	
	    var Emoji = function () {
	    	function Emoji(output, options) {
	    		babelHelpers.classCallCheck(this, Emoji);
	
	    		this.output = output;
	    		this.options = options;
	
	    		this.emojiRegex = regex.smileys;
	    	}
	
	    	babelHelpers.createClass(Emoji, [{
	    		key: 'process',
	    		value: function process() {
	    			var _this = this;
	
	    			return this.output.replace(this.emojiRegex, function (match) {
	    				var emoji = Emoji.getEmoji(match);
	    				if (emoji) {
	    					return _this.options.template.emoji(emoji, _this.options);
	    				}
	    				return match;
	    			});
	    		}
	    	}], [{
	    		key: 'getEmoji',
	    		value: function getEmoji(match) {
	    			return match[0] === ':' && match[match.length - 1] === ':' && match.substring(1, match.length - 1);
	    		}
	    	}]);
	    	return Emoji;
	    }();
	
	    var Smiley = function () {
	    	function Smiley(input, options) {
	    		babelHelpers.classCallCheck(this, Smiley);
	
	    		this.input = input;
	    		this.options = options;
	
	    		var defaultIcons = [{
	    			'text': ':)',
	    			'code': '&#xe60a'
	    		}, {
	    			'text': ':D',
	    			'code': '&#xe608'
	    		}, {
	    			'text': ':d',
	    			'code': '&#xe608'
	    		}, {
	    			'text': ':(',
	    			'code': '&#xe60e'
	    		}, {
	    			'text': ':/',
	    			'code': '&#xe620'
	
	    		}, {
	    			'text': ':P',
	    			'code': '&#xe60c'
	    		}, {
	    			'text': ':p',
	    			'code': '&#xe60c'
	    		}, {
	    			'text': '3:)',
	    			'code': '&#xe618'
	    		}, {
	    			'text': '(^)',
	    			'code': '&#xe607'
	    		}, {
	    			'text': ';)',
	    			'code': '&#xe610'
	    		}, {
	    			'text': ':o',
	    			'code': '&#xe61a'
	    		}, {
	    			'text': '-_-',
	    			'code': '&#xe61e'
	    		}, {
	    			'text': '(y)',
	    			'code': '&#xe606'
	    		}, {
	    			'text': ':*',
	    			'code': '&#xe604'
	    		}, {
	    			'text': '&lt;3',
	    			'code': '&#xe604'
	    		}, {
	    			'text': '<3',
	    			'code': '&#xe604'
	    		}, {
	    			'text': '&lt;/3',
	    			'code': '&#xe605'
	    		}, {
	    			'text': '</3',
	    			'code': '&#xe605'
	    		}, {
	    			'text': '^_^',
	    			'code': '&#xe612'
	    		}, {
	    			'text': '8-)',
	    			'code': '&#xe614'
	    		}, {
	    			'text': '8|',
	    			'code': '&#xe614'
	    		}, {
	    			'text': ':S',
	    			'code': '&#xe61c'
	    		}, {
	    			'text': ':s',
	    			'code': '&#xe61c'
	    		}];
	
	    		this.icons = options.customFontIcons.length ? options.customFontIcons : defaultIcons;
	
	    		this.escapedSymbols = this.icons.map(function (val) {
	    			return escapeRegExp(val.text);
	    		});
	
	    		this.smileyRegex = new RegExp('(^|\\s)(' + this.escapedSymbols.join('|') + ')(?=\\s|$)', 'gi');
	    	}
	
	    	babelHelpers.createClass(Smiley, [{
	    		key: 'process',
	    		value: function process() {
	    			var _this = this;
	
	    			return this.input.replace(this.smileyRegex, function (match, pre, text) {
	    				var index = _this.escapedSymbols.indexOf(escapeRegExp(text));
	    				var code = _this.icons[index].code;
	    				return _this.options.template.smiley(text, pre, code, _this.options);
	    			});
	    		}
	    	}]);
	    	return Smiley;
	    }();
	
	    var Url = function () {
	    	function Url(input, options) {
	    		babelHelpers.classCallCheck(this, Url);
	
	    		this.input = input;
	    		this.options = options;
	    		this.urlRegex = urlRegex();
	    	}
	
	    	babelHelpers.createClass(Url, [{
	    		key: 'process',
	    		value: function process() {
	    			var _this = this;
	
	    			var config = this.options.linkOptions;
	    			return this.input.replace(this.urlRegex, function (match) {
	    				var extension = lastElement(match.split('.'));
	    				if (lastElement(match) === '/') match = match.slice(0, -1);
	    				if (config.exclude.indexOf(extension) === -1) return _this.options.template.url(match, _this.options);
	    				return match;
	    			});
	    		}
	    	}]);
	    	return Url;
	    }();
	
	    var fetchJsonp = __commonjs(function (module, exports, global) {
	      (function (global, factory) {
	        if (true) {
	          !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
	          factory(exports, module);
	        } else {
	          var mod = {
	            exports: {}
	          };
	          factory(mod.exports, mod);
	          global.fetchJsonp = mod.exports;
	        }
	      })(__commonjs_global, function (exports, module) {
	        'use strict';
	
	        var defaultOptions = {
	          timeout: 5000,
	          jsonpCallback: 'callback',
	          jsonpCallbackFunction: null
	        };
	
	        function generateCallbackFunction() {
	          return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
	        }
	
	        // Known issue: Will throw 'Uncaught ReferenceError: callback_*** is not defined' error if request timeout
	        function clearFunction(functionName) {
	          // IE8 throws an exception when you try to delete a property on window
	          // http://stackoverflow.com/a/1824228/751089
	          try {
	            delete window[functionName];
	          } catch (e) {
	            window[functionName] = undefined;
	          }
	        }
	
	        function removeScript(scriptId) {
	          var script = document.getElementById(scriptId);
	          document.getElementsByTagName('head')[0].removeChild(script);
	        }
	
	        var fetchJsonp = function fetchJsonp(url) {
	          var options = arguments[1] === undefined ? {} : arguments[1];
	
	          var timeout = options.timeout != null ? options.timeout : defaultOptions.timeout;
	          var jsonpCallback = options.jsonpCallback != null ? options.jsonpCallback : defaultOptions.jsonpCallback;
	
	          var timeoutId = undefined;
	
	          return new Promise(function (resolve, reject) {
	            var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
	
	            window[callbackFunction] = function (response) {
	              resolve({
	                ok: true,
	                // keep consistent with fetch API
	                json: function json() {
	                  return Promise.resolve(response);
	                }
	              });
	
	              if (timeoutId) clearTimeout(timeoutId);
	
	              removeScript(jsonpCallback + '_' + callbackFunction);
	
	              clearFunction(callbackFunction);
	            };
	
	            // Check if the user set their own params, and if not add a ? to start a list of params
	            url += url.indexOf('?') === -1 ? '?' : '&';
	
	            var jsonpScript = document.createElement('script');
	            jsonpScript.setAttribute('src', url + jsonpCallback + '=' + callbackFunction);
	            jsonpScript.id = jsonpCallback + '_' + callbackFunction;
	            document.getElementsByTagName('head')[0].appendChild(jsonpScript);
	
	            timeoutId = setTimeout(function () {
	              reject(new Error('JSONP request to ' + url + ' timed out'));
	
	              clearFunction(callbackFunction);
	              removeScript(jsonpCallback + '_' + callbackFunction);
	            }, timeout);
	          });
	        };
	
	        // export as global function
	        /*
	        let local;
	        if (typeof global !== 'undefined') {
	          local = global;
	        } else if (typeof self !== 'undefined') {
	          local = self;
	        } else {
	          try {
	            local = Function('return this')();
	          } catch (e) {
	            throw new Error('polyfill failed because global object is unavailable in this environment');
	          }
	        }
	        
	        local.fetchJsonp = fetchJsonp;
	        */
	
	        module.exports = fetchJsonp;
	      });
	    });
	
	    var fetchJsonp$1 = fetchJsonp && (typeof fetchJsonp === 'undefined' ? 'undefined' : babelHelpers.typeof(fetchJsonp)) === 'object' && 'default' in fetchJsonp ? fetchJsonp['default'] : fetchJsonp;
	
	    /**
	     * Common template for vimeo and youtube iframes
	     * @param  {string} url     URL of the embedding video
	     * @param  {object} options Options object
	     * @return {string}         compiled template with variables replaced
	     */
	    function template(url, options) {
	      return options.template.vimeo(url, options) || options.template.youtube(url, options);
	    }
	
	    /**
	     * Plays the video after clicking on the thumbnail
	     * @param  {object} options   Options object
	     * @return {null}
	     */
	    function playVideo(options) {
	    	/** Execute the customVideoClickHandler if the user wants to handle it on his own. */
	    	if (options.customVideoClickHandler) return options.videoClickHandler(options, template);
	
	    	var classes = document.getElementsByClassName(options.videoClickClass);
	    	for (var i = 0; i < classes.length; i++) {
	    		classes[i].onclick = function () {
	    			options.onVideoShow();
	    			var url = this.getAttribute('data-ejs-url') + "?autoplay=true";
	    			this.parentNode.parentNode.innerHTML = template(url, options);
	    		};
	    	}
	    }
	
	    function getDetailsTemplate(data, fullData, embedUrl, options) {
	    	if (data.host === 'vimeo') {
	    		return options.template.detailsVimeo(data, fullData, embedUrl, options);
	    	} else if (data.host === 'youtube') {
	    		return options.template.detailsYoutube(data, fullData, embedUrl, options);
	    	}
	    }
	
	    /**
	     * Applies video.js to all audio and video dynamically
	     * @param  {object} options Options object
	     * @return {null}
	     */
	    function applyVideoJS(options) {
	    	options.videojsOptions.width = options.videoWidth;
	    	options.videojsOptions.height = options.videoHeight;
	    	if (options.videoJS) {
	    		if (!options.plugins.videojs) throw new ReferenceError("You have enabled videojs but you haven't loaded the library.Find it at http://videojs.com/");
	    		var VideoJS = options.plugins.videojs;
	    		var elements = options.input.getElementsByClassName('ejs-video-js');
	    		for (var i = 0; i < elements.length; i++) {
	    			VideoJS(elements[i], options.videojsOptions, function () {
	    				return options.videojsCallback();
	    			});
	    		}
	    	}
	    }
	
	    /**
	     * Destroys the onclick event for opening the video template from the details template
	     * @param  {className} className
	     * @return {null}
	     */
	    function destroyVideos(className) {
	      var classes = document.getElementsByClassName(className);
	      for (var i = 0; i < classes.length; i++) {
	        classes[i].onclick = null;
	      }
	    }
	
	    function inlineEmbed(_) {
	    	var regexInline = _.options.link ? new RegExp('([^>]*' + _.regex.source + ')</a>', 'gm') : new RegExp('([^\\s]*' + _.regex.source + ')', 'gm');
	    	_.output = _.output.replace(regexInline, function (match) {
	    		var url = _.options.link ? match.slice(0, -4) : match;
	    		if (_.options.served.indexOf(url) === -1) {
	    			_.options.served.push(url);
	    			if (_.options.link) {
	    				return !_.options.inlineText ? _.template(match.slice(0, -4)) + '</a>' : match + _.template(match.slice(0, -4));
	    			} else {
	    				return !_.options.inlineText ? _.template(match) : match + _.template(match);
	    			}
	    		} else {
	    			return match; //TODO : check whether this should be `match`
	    		}
	    	});
	    	return [_.output, _.embeds];
	    }
	
	    function normalEmbed(_) {
	    	var match = void 0;
	    	while ((match = matches(_.regex, _.input)) !== null) {
	    		var url = match[0];
	    		if (!(_.options.served.indexOf(url) === -1) || _.options.served.length && _.options.singleEmbed) continue;
	    		_.options.served.push(url);
	    		var text = _.template(url);
	    		_.embeds.push({
	    			text: text,
	    			index: match.index
	    		});
	    	}
	    	return [_.output, _.embeds];
	    }
	
	    function embed(_) {
	    	return ifInline(_.options, _.service) ? inlineEmbed(_) : normalEmbed(_);
	    }
	
	    var Base = function () {
	    	function Base(input, output, embeds, options, regex, service) {
	    		babelHelpers.classCallCheck(this, Base);
	
	    		this.input = input;
	    		this.output = output;
	    		this.options = options;
	    		this.embeds = embeds;
	    		this.regex = regex;
	    		this.service = service;
	    	}
	
	    	babelHelpers.createClass(Base, [{
	    		key: 'template',
	    		value: function template(match) {
	    			return this.options.template[this.service](match, this.options);
	    		}
	    	}, {
	    		key: 'process',
	    		value: function process() {
	    			return embed(this);
	    		}
	    	}]);
	    	return Base;
	    }();
	
	    function baseEmbed(input, output, embeds, options, regex, service, flag) {
	    	return ifEmbed(options, service) || ifEmbed(options, service) && flag ? new Base(input, output, embeds, options, regex, service).process() : [output, embeds];
	    }
	
	    /**
	     * This is a private function which is used to get the actual text to be replaced for
	     * a particular url in inline embedding. This returns a promise
	     * @param  {object} _     reference to this
	     * @param  {function} urlToText The function that converts url to replaceable text
	     * @param  {object} match     object containing info of matching string
	     * @return {Promise}           resolves to the text
	     */
	    function getInlineData(_, urlToText, match) {
	    	var url = (_.options.link ? match[0].slice(0, -4) : match[0]) || match[1];
	    	if (_.options.served.indexOf(url) >= 0) return Promise.resolve(null);
	
	    	return new Promise(function (resolve) {
	    		urlToText(_, match, url).then(function (text) {
	    			if (!text) return resolve();
	    			_.options.served.push(url);
	    			resolve(text);
	    		});
	    	});
	    }
	
	    /**
	     * A helper function for inline embedding
	     * @param _
	     * @param urlToText
	     * @returns Promise
	     */
	    function inlineAsyncEmbed(_, urlToText) {
	    	var regexInline = _.options.link ? new RegExp('([^>]*' + _.regex.source + ')</a>', 'gi') : new RegExp('([^\\s]*' + _.regex.source + ')', 'gi');
	    	var match = void 0,
	    	    promises = [];
	
	    	while ((match = matches(regexInline, _.output)) !== null) {
	    		promises.push(getInlineData(_, urlToText, match));
	    	}return new Promise(function (resolve) {
	    		if (matches.length) Promise.all(promises).then(function (data) {
	    			var i = 0;
	    			_.output = _.output.replace(regexInline, function (match) {
	    				if (_.options.link) return !_.options.inlineText ? data[i] + '</a>' : match + data[i++];else return !_.options.inlineText ? data[i] : match + data[i++];
	    			});
	    			resolve(_.output);
	    		});else resolve(_.output);
	    	});
	    }
	
	    function getNormalData(_, urlToText, match) {
	    	var url = match[0];
	    	if (_.options.served.indexOf(url) >= 0) return;
	
	    	return new Promise(function (resolve) {
	    		urlToText(_, match, url, true).then(function (text) {
	    			if (!text) resolve();
	    			_.options.served.push(url);
	    			_.embeds.push({
	    				text: text,
	    				index: match.index
	    			});
	    			resolve();
	    		});
	    	});
	    }
	
	    /**
	     * A helper function for normal embedding
	     * @param  {object} _
	     * @param  {function} urlToText
	     * @return {Promise}
	     */
	    function normalAsyncEmbed(_, urlToText) {
	    	var match = void 0,
	    	    promises = [];
	    	while ((match = matches(_.regex, _.input)) !== null) {
	    		promises.push(getNormalData(_, urlToText, match));
	    	}return new Promise(function (resolve) {
	    		Promise.all(promises).then(function () {
	    			resolve(_.embeds);
	    		});
	    	});
	    }
	
	    function asyncEmbed(_, urlToText) {
	    	return new Promise(function (resolve) {
	    		if (ifInline(_.options, _.service)) inlineAsyncEmbed(_, urlToText).then(function (output) {
	    			return resolve([output, _.embeds]);
	    		});else normalAsyncEmbed(_, urlToText).then(function (embeds) {
	    			return resolve([_.output, embeds]);
	    		});
	    	});
	    }
	
	    var Twitter = function () {
	    	function Twitter(input, output, options, embeds) {
	    		babelHelpers.classCallCheck(this, Twitter);
	
	    		this.input = input;
	    		this.output = output;
	    		this.options = options;
	    		this.embeds = embeds;
	    		this.regex = regex.twitter;
	    		this.service = 'twitter';
	
	    		this.load = this.load.bind(this);
	    		if (typeof this.options.input !== 'string') {
	    			this.options.input.addEventListener('rendered', this.load, false);
	    		}
	    	}
	
	    	/**
	      * Fetches the data from twitter's oEmbed API
	      * @param  {string} url URL of the tweet
	      * @return {object}     data containing the tweet info
	      */
	
	
	    	babelHelpers.createClass(Twitter, [{
	    		key: 'tweetData',
	    		value: function tweetData(url) {
	    			var config = this.options.tweetOptions;
	    			var apiUrl = 'https://api.twitter.com/1/statuses/oembed.json?omit_script=true&url=' + url + '&maxwidth=' + config.maxWidth + '&hide_media=' + config.hideMedia + '&hide_thread=' + config.hideThread + '&align=' + config.align + '&lang=' + config.lang;
	    			return new Promise(function (resolve) {
	    				fetchJsonp$1(apiUrl, { credentials: 'include' }).then(function (data) {
	    					return data.json();
	    				}).then(function (json) {
	    					return resolve(json);
	    				});
	    			});
	    		}
	
	    		/**
	       * Load twitter widgets
	       * @return null
	       */
	
	    	}, {
	    		key: 'load',
	    		value: function load() {
	    			var twitter = this.options.plugins.twitter;
	    			twitter.widgets.load(this.options.element); //here this refers to the element
	
	    			//Execute the function after the widget is loaded
	    			twitter.events.bind('loaded', this.options.onTweetsLoad);
	    		}
	    	}, {
	    		key: 'process',
	    		value: function process() {
	    			var _this2 = this;
	
	    			return new Promise(function (resolve) {
	    				return asyncEmbed(_this2, Twitter.urlToText).then(function (data) {
	    					return resolve(data);
	    				});
	    			});
	    		}
	    	}], [{
	    		key: 'urlToText',
	    		value: function urlToText(_this, match, url) {
	    			return new Promise(function (resolve) {
	    				return _this.tweetData(url).then(function (data) {
	    					return resolve(data.html);
	    				});
	    			});
	    		}
	    	}]);
	    	return Twitter;
	    }();
	
	    (function (self) {
	      'use strict';
	
	      if (self.fetch) {
	        return;
	      }
	
	      function normalizeName(name) {
	        if (typeof name !== 'string') {
	          name = String(name);
	        }
	        if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	          throw new TypeError('Invalid character in header field name');
	        }
	        return name.toLowerCase();
	      }
	
	      function normalizeValue(value) {
	        if (typeof value !== 'string') {
	          value = String(value);
	        }
	        return value;
	      }
	
	      function Headers(headers) {
	        this.map = {};
	
	        if (headers instanceof Headers) {
	          headers.forEach(function (value, name) {
	            this.append(name, value);
	          }, this);
	        } else if (headers) {
	          Object.getOwnPropertyNames(headers).forEach(function (name) {
	            this.append(name, headers[name]);
	          }, this);
	        }
	      }
	
	      Headers.prototype.append = function (name, value) {
	        name = normalizeName(name);
	        value = normalizeValue(value);
	        var list = this.map[name];
	        if (!list) {
	          list = [];
	          this.map[name] = list;
	        }
	        list.push(value);
	      };
	
	      Headers.prototype['delete'] = function (name) {
	        delete this.map[normalizeName(name)];
	      };
	
	      Headers.prototype.get = function (name) {
	        var values = this.map[normalizeName(name)];
	        return values ? values[0] : null;
	      };
	
	      Headers.prototype.getAll = function (name) {
	        return this.map[normalizeName(name)] || [];
	      };
	
	      Headers.prototype.has = function (name) {
	        return this.map.hasOwnProperty(normalizeName(name));
	      };
	
	      Headers.prototype.set = function (name, value) {
	        this.map[normalizeName(name)] = [normalizeValue(value)];
	      };
	
	      Headers.prototype.forEach = function (callback, thisArg) {
	        Object.getOwnPropertyNames(this.map).forEach(function (name) {
	          this.map[name].forEach(function (value) {
	            callback.call(thisArg, value, name, this);
	          }, this);
	        }, this);
	      };
	
	      function consumed(body) {
	        if (body.bodyUsed) {
	          return Promise.reject(new TypeError('Already read'));
	        }
	        body.bodyUsed = true;
	      }
	
	      function fileReaderReady(reader) {
	        return new Promise(function (resolve, reject) {
	          reader.onload = function () {
	            resolve(reader.result);
	          };
	          reader.onerror = function () {
	            reject(reader.error);
	          };
	        });
	      }
	
	      function readBlobAsArrayBuffer(blob) {
	        var reader = new FileReader();
	        reader.readAsArrayBuffer(blob);
	        return fileReaderReady(reader);
	      }
	
	      function readBlobAsText(blob) {
	        var reader = new FileReader();
	        reader.readAsText(blob);
	        return fileReaderReady(reader);
	      }
	
	      var support = {
	        blob: 'FileReader' in self && 'Blob' in self && function () {
	          try {
	            new Blob();
	            return true;
	          } catch (e) {
	            return false;
	          }
	        }(),
	        formData: 'FormData' in self,
	        arrayBuffer: 'ArrayBuffer' in self
	      };
	
	      function Body() {
	        this.bodyUsed = false;
	
	        this._initBody = function (body) {
	          this._bodyInit = body;
	          if (typeof body === 'string') {
	            this._bodyText = body;
	          } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	            this._bodyBlob = body;
	          } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	            this._bodyFormData = body;
	          } else if (!body) {
	            this._bodyText = '';
	          } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	            // Only support ArrayBuffers for POST method.
	            // Receiving ArrayBuffers happens via Blobs, instead.
	          } else {
	              throw new Error('unsupported BodyInit type');
	            }
	
	          if (!this.headers.get('content-type')) {
	            if (typeof body === 'string') {
	              this.headers.set('content-type', 'text/plain;charset=UTF-8');
	            } else if (this._bodyBlob && this._bodyBlob.type) {
	              this.headers.set('content-type', this._bodyBlob.type);
	            }
	          }
	        };
	
	        if (support.blob) {
	          this.blob = function () {
	            var rejected = consumed(this);
	            if (rejected) {
	              return rejected;
	            }
	
	            if (this._bodyBlob) {
	              return Promise.resolve(this._bodyBlob);
	            } else if (this._bodyFormData) {
	              throw new Error('could not read FormData body as blob');
	            } else {
	              return Promise.resolve(new Blob([this._bodyText]));
	            }
	          };
	
	          this.arrayBuffer = function () {
	            return this.blob().then(readBlobAsArrayBuffer);
	          };
	
	          this.text = function () {
	            var rejected = consumed(this);
	            if (rejected) {
	              return rejected;
	            }
	
	            if (this._bodyBlob) {
	              return readBlobAsText(this._bodyBlob);
	            } else if (this._bodyFormData) {
	              throw new Error('could not read FormData body as text');
	            } else {
	              return Promise.resolve(this._bodyText);
	            }
	          };
	        } else {
	          this.text = function () {
	            var rejected = consumed(this);
	            return rejected ? rejected : Promise.resolve(this._bodyText);
	          };
	        }
	
	        if (support.formData) {
	          this.formData = function () {
	            return this.text().then(decode);
	          };
	        }
	
	        this.json = function () {
	          return this.text().then(JSON.parse);
	        };
	
	        return this;
	      }
	
	      // HTTP methods whose capitalization should be normalized
	      var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	      function normalizeMethod(method) {
	        var upcased = method.toUpperCase();
	        return methods.indexOf(upcased) > -1 ? upcased : method;
	      }
	
	      function Request(input, options) {
	        options = options || {};
	        var body = options.body;
	        if (Request.prototype.isPrototypeOf(input)) {
	          if (input.bodyUsed) {
	            throw new TypeError('Already read');
	          }
	          this.url = input.url;
	          this.credentials = input.credentials;
	          if (!options.headers) {
	            this.headers = new Headers(input.headers);
	          }
	          this.method = input.method;
	          this.mode = input.mode;
	          if (!body) {
	            body = input._bodyInit;
	            input.bodyUsed = true;
	          }
	        } else {
	          this.url = input;
	        }
	
	        this.credentials = options.credentials || this.credentials || 'omit';
	        if (options.headers || !this.headers) {
	          this.headers = new Headers(options.headers);
	        }
	        this.method = normalizeMethod(options.method || this.method || 'GET');
	        this.mode = options.mode || this.mode || null;
	        this.referrer = null;
	
	        if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	          throw new TypeError('Body not allowed for GET or HEAD requests');
	        }
	        this._initBody(body);
	      }
	
	      Request.prototype.clone = function () {
	        return new Request(this);
	      };
	
	      function decode(body) {
	        var form = new FormData();
	        body.trim().split('&').forEach(function (bytes) {
	          if (bytes) {
	            var split = bytes.split('=');
	            var name = split.shift().replace(/\+/g, ' ');
	            var value = split.join('=').replace(/\+/g, ' ');
	            form.append(decodeURIComponent(name), decodeURIComponent(value));
	          }
	        });
	        return form;
	      }
	
	      function headers(xhr) {
	        var head = new Headers();
	        var pairs = xhr.getAllResponseHeaders().trim().split('\n');
	        pairs.forEach(function (header) {
	          var split = header.trim().split(':');
	          var key = split.shift().trim();
	          var value = split.join(':').trim();
	          head.append(key, value);
	        });
	        return head;
	      }
	
	      Body.call(Request.prototype);
	
	      function Response(bodyInit, options) {
	        if (!options) {
	          options = {};
	        }
	
	        this.type = 'default';
	        this.status = options.status;
	        this.ok = this.status >= 200 && this.status < 300;
	        this.statusText = options.statusText;
	        this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers);
	        this.url = options.url || '';
	        this._initBody(bodyInit);
	      }
	
	      Body.call(Response.prototype);
	
	      Response.prototype.clone = function () {
	        return new Response(this._bodyInit, {
	          status: this.status,
	          statusText: this.statusText,
	          headers: new Headers(this.headers),
	          url: this.url
	        });
	      };
	
	      Response.error = function () {
	        var response = new Response(null, { status: 0, statusText: '' });
	        response.type = 'error';
	        return response;
	      };
	
	      var redirectStatuses = [301, 302, 303, 307, 308];
	
	      Response.redirect = function (url, status) {
	        if (redirectStatuses.indexOf(status) === -1) {
	          throw new RangeError('Invalid status code');
	        }
	
	        return new Response(null, { status: status, headers: { location: url } });
	      };
	
	      self.Headers = Headers;
	      self.Request = Request;
	      self.Response = Response;
	
	      self.fetch = function (input, init) {
	        return new Promise(function (resolve, reject) {
	          var request;
	          if (Request.prototype.isPrototypeOf(input) && !init) {
	            request = input;
	          } else {
	            request = new Request(input, init);
	          }
	
	          var xhr = new XMLHttpRequest();
	
	          function responseURL() {
	            if ('responseURL' in xhr) {
	              return xhr.responseURL;
	            }
	
	            // Avoid security warnings on getResponseHeader when not allowed by CORS
	            if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	              return xhr.getResponseHeader('X-Request-URL');
	            }
	
	            return;
	          }
	
	          xhr.onload = function () {
	            var status = xhr.status === 1223 ? 204 : xhr.status;
	            if (status < 100 || status > 599) {
	              reject(new TypeError('Network request failed'));
	              return;
	            }
	            var options = {
	              status: status,
	              statusText: xhr.statusText,
	              headers: headers(xhr),
	              url: responseURL()
	            };
	            var body = 'response' in xhr ? xhr.response : xhr.responseText;
	            resolve(new Response(body, options));
	          };
	
	          xhr.onerror = function () {
	            reject(new TypeError('Network request failed'));
	          };
	
	          xhr.open(request.method, request.url, true);
	
	          if (request.credentials === 'include') {
	            xhr.withCredentials = true;
	          }
	
	          if ('responseType' in xhr && support.blob) {
	            xhr.responseType = 'blob';
	          }
	
	          request.headers.forEach(function (value, name) {
	            xhr.setRequestHeader(name, value);
	          });
	
	          xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	        });
	      };
	      self.fetch.polyfill = true;
	    })(typeof self !== 'undefined' ? self : this);
	
	    var Gmap = function () {
	        function Gmap(input, output, options, embeds) {
	            babelHelpers.classCallCheck(this, Gmap);
	
	            this.input = input;
	            this.output = output;
	            this.options = options;
	            this.embeds = embeds;
	            this.service = 'map';
	            this.regex = regex.gmap;
	        }
	
	        /**
	         * Takes the location name and returns the coordinates of that location using the Google
	         * Map API v3. This is an async function so it will return a promise.
	         * @param  {string} location The name of any location
	         * @return {array}           Returns an array in the form [latitude, longitude]
	         */
	
	
	        babelHelpers.createClass(Gmap, [{
	            key: 'process',
	            value: function process() {
	                var _this = this;
	
	                var match = void 0,
	                    promises = [],
	                    allMatches = [];
	                while ((match = matches(this.regex, this.output)) !== null) {
	                    this.options.served.push(match);
	                    var promise = this.options.mapOptions.mode !== 'place' ? Gmap.getCoordinate(match[0]) : Promise.resolve([null, null]);
	                    promises.push(promise);
	                    allMatches.push(match);
	                }
	
	                return new Promise(function (resolve) {
	                    Promise.all(promises).then(function (coordinatesArr) {
	                        var _loop = function _loop() {
	                            var _coordinatesArr$i = babelHelpers.slicedToArray(coordinatesArr[i], 2);
	
	                            var latitude = _coordinatesArr$i[0];
	                            var longitude = _coordinatesArr$i[1];
	
	                            var text = Gmap.template(allMatches[i][0], latitude, longitude, _this.options);
	                            if (ifInline(_this.options, _this.service)) {
	                                _this.output = _this.output.replace(_this.regex, function (regexMatch) {
	                                    return '<span class="ejs-location">' + Gmap.locationText(regexMatch) + '</span>' + text;
	                                });
	                            } else {
	                                _this.embeds.push({
	                                    text: text,
	                                    index: allMatches[i][0].index
	                                });
	                                _this.output = _this.output.replace(_this.regex, function (regexMatch) {
	                                    return '<span class="ejs-location">' + Gmap.locationText(regexMatch) + '</span>';
	                                });
	                            }
	                        };
	
	                        for (var i in promises) {
	                            _loop();
	                        }
	                        resolve([_this.output, _this.embeds]);
	                    });
	                });
	            }
	        }], [{
	            key: 'getCoordinate',
	            value: function getCoordinate(location) {
	                var url = 'http://maps.googleapis.com/maps/api/geocode/json?address=' + location + '&sensor=false';
	                return new Promise(function (resolve) {
	                    fetch(url).then(function (data) {
	                        return data.json();
	                    }).then(function (json) {
	                        return resolve([json.results[0].geometry.location.lat, json.results[0].geometry.location.lng]);
	                    });
	                });
	            }
	
	            /**
	             * Returns the template of the Map widget. The source of the iframe is based on whether the
	             * mode set in options is 'place', 'streetview' or 'view'.
	             * @param  {string} match     The matching string in the form of @(location name).
	             * @param  {number} latitude  Latitude of the location
	             * @param  {number} longitude Longitude of the location
	             * @param  {object} options   plugin options
	             * @return {string}           Template of the map widget.
	             */
	
	        }, {
	            key: 'template',
	            value: function template(match, latitude, longitude, options) {
	                var location = Gmap.locationText(match);
	                var config = options.mapOptions;
	                if (config.mode === 'place') {
	                    return '<div class="ejs-embed ejs-map"><iframe width="' + options.videoWidth + '" height="' + options.videoHeight + '" src="https://www.google.com/maps/embed/v1/place?key=' + options.googleAuthKey + '&q=' + location + '"></iframe></div>';
	                } else if (config.mode === 'streetview') {
	                    return '<div class="ejs-embed ejs-map"><iframe width="' + options.videoWidth + '" height="' + options.videoHeight + '" src="https://www.google.com/maps/embed/v1/streetview?key=' + options.googleAuthKey + '&location=' + latitude + ',' + longitude + '&heading=210&pitch=10&fov=35"></iframe></div>';
	                } else if (config.mode === 'view') {
	                    return '<div class="ejs-embed ejs-map"><iframe width="' + options.videoWidth + '" height="' + options.videoHeight + '" src="https://www.google.com/maps/embed/v1/view?key=' + options.googleAuthKey + '&center=' + latitude + ',' + longitude + '&zoom=18&maptype=satellite"></iframe></div>';
	                }
	            }
	
	            /**
	             * Extracts out the location name from the format @(locationName)
	             * @param  {string} match The string in the supported format. Eg : @(Delhi)
	             * @return {string}       Only the location name removing @ and brackets. Eg: Delhi
	             */
	
	        }, {
	            key: 'locationText',
	            value: function locationText(match) {
	                return match.split('(')[1].split(')')[0];
	            }
	        }]);
	        return Gmap;
	    }();
	
	    var Markdown = function () {
	    	function Markdown(output, options) {
	    		babelHelpers.classCallCheck(this, Markdown);
	
	    		if (!options.plugins.marked) throw new ReferenceError('marked.js is not loaded.');
	    		this.output = output;
	    		this.options = options;
	    	}
	
	    	babelHelpers.createClass(Markdown, [{
	    		key: 'process',
	    		value: function process() {
	    			var _this = this;
	
	    			var Marked = this.options.plugins.marked;
	    			var renderer = new Marked.Renderer();
	
	    			renderer.link = function (href, title, text) {
	    				if (href.indexOf('&lt;/a') === -1) return href;
	    				if (href.match(/&gt;(.+)&lt;\/a/gi)) {
	    					if (!title) title = '';
	    					return '<a href="' + RegExp.$1 + '" rel=' + _this.options.linkOptions.rel + '" target="' + _this.options.linkOptions.target + '" title="' + title + '">' + text + '</a>';
	    				}
	    			};
	
	    			renderer.image = function (href, title, text) {
	    				if (href.indexOf('&lt;/a') === -1) return href;
	    				if (href.match(/&gt;(.+)&lt;\/a/gi)) {
	    					if (!title) title = '';
	    					return '<div class="ejs-image ejs-embed"><div class="ne-image-wrapper"><img src="' + RegExp.$1 + '" title="' + title + '" alt="' + text + '"/></div></div>';
	    				}
	    			};
	
	    			renderer.paragraph = function (text) {
	    				return '<p> ' + text + ' </p>';
	    			}; //for font smiley in end.
	
	    			//Fix for heading that should be actually present in marked.js
	    			//if gfm is true the `## Heading` is acceptable but `##Heading` is not
	    			Marked.Lexer.rules.gfm.heading = Marked.Lexer.rules.normal.heading;
	    			Marked.Lexer.rules.tables.heading = Marked.Lexer.rules.normal.heading;
	
	    			this.options.markedOptions.renderer = renderer;
	    			this.options.markedOptions.highlight = false;
	    			return Marked(this.output, this.options.markedOptions);
	    		}
	    	}]);
	    	return Markdown;
	    }();
	
	    var Highlight = function () {
	    	function Highlight(output, options) {
	    		babelHelpers.classCallCheck(this, Highlight);
	
	    		if (!options.plugins.highlightjs && !this.isPrism()) {
	    			throw new ReferenceError('\'hljs is not defined. HighlightJS library is needed to highlight code. Visit https://highlightjs.org/\'');
	    		}
	
	    		this.output = output;
	    		this.options = options;
	    		this.regex = regex.highlightCode;
	    		this.inlineCodeRegex = regex.inlineCode;
	    	}
	
	    	/**
	      * Encodes the characters like <, > and space and replaces them with
	      * &lt;, &gt; and &gt; respectively.
	      * @param  {string} code The string that has to be encoded.
	      * @return {string}      The encoded string
	      */
	
	
	    	babelHelpers.createClass(Highlight, [{
	    		key: 'process',
	
	
	    		/**
	       * Replaces the code block with the pre tags and returns a string having the code
	       * formatting using Highlight.js.
	       * => Matches the string with the regex and finds the code written in three back-ticks ```
	       * => Detects whether any language has been provided by the user.
	       *     The format supported by embed.js is
	       *         ```[language-name]
	       *         var a = 2;
	       *         ```
	       * => Trims all the unnecessary spaces and newlines from the code.
	       * => Passes the code to `hljs.highlightAuto(code, language)` which returns a formatted string
	       *     having the html tags for styling. The `language` here is optional. In case we don't pass the
	       *     language, it tries to detect the language itself.
	       * => Replaces the code string in the template with the formatted string
	       * @return {string} The string in which the code is formatted
	       */
	    		value: function process() {
	    			var _this = this;
	
	    			this.output = this.output.replace(this.inlineCodeRegex, function (match, group1, group2) {
	    				return '<code>' + group2 + '</code>';
	    			});
	
	    			return this.output.replace(this.regex, function (match, group1, group2, group3) {
	    				var code = group3;
	    				code = Highlight.trimSpace(code);
	    				code = Highlight.encode(code);
	
	    				// to prevent auto-linking. Not necessary in code
	    				// *blocks*, but in code spans. Will be converted
	    				// back after the auto-linker runs.
	    				code = code.replace(/:\/\//g, '~P');
	
	    				var language = group2.split('\n')[0];
	    				var highlightedCode = void 0;
	
	    				var HighlightJS = _this.options.plugins.highlightjs;
	    				if (language) {
	    					highlightedCode = HighlightJS.highlightAuto(code, [language]);
	    				} else {
	    					highlightedCode = HighlightJS.highlightAuto(code);
	    					language = highlightedCode.language;
	    				}
	
	    				return Highlight.addTemplate(highlightedCode, language);
	    			});
	    		}
	    	}], [{
	    		key: 'encode',
	    		value: function encode(code) {
	    			code = code.replace(/&amp;/gm, '');
	    			code = code.replace(/&lt;/g, '<');
	    			code = code.replace(/&gt;/g, '>');
	    			return code;
	    		}
	
	    		/**
	       * removes whitespace characters
	       * @param  {string} code The string from which the whitespace has to be removed
	       * @return {string}
	       */
	
	    	}, {
	    		key: 'trimSpace',
	    		value: function trimSpace(code) {
	    			code = code.replace(/^([ \t]*)/g, ''); // leading whitespace
	    			code = code.replace(/[ \t]*$/g, ''); // trailing whitespace
	    			return code;
	    		}
	
	    		/**
	       * Places the code and the language name in the required template
	       * @param {string} processedCode
	       * @param {string} language
	       * @return {string}
	       */
	
	    	}, {
	    		key: 'addTemplate',
	    		value: function addTemplate(processedCode, language) {
	    			return '<pre><code class="ejs-code hljs ' + language + '">' + (processedCode.value || processedCode) + '</code></pre>';
	    		}
	    	}]);
	    	return Highlight;
	    }();
	
	    var Gist = function () {
	    	function Gist(input, output, options, embeds) {
	    		var _this = this;
	
	    		babelHelpers.classCallCheck(this, Gist);
	
	    		this.input = input;
	    		this.output = output;
	    		this.options = options;
	    		this.embeds = embeds;
	    		this.regex = regex.gist;
	    		this.service = 'gist';
	
	    		if (typeof this.options.input !== 'string') {
	    			this.options.input.addEventListener('rendered', function () {
	    				_this.load();
	    			});
	    		}
	    	}
	
	    	babelHelpers.createClass(Gist, [{
	    		key: 'template',
	    		value: function template(match) {
	    			return '<div class="ejs-gist" data-src="' + match + '"></div>';
	    		}
	    	}, {
	    		key: 'load',
	    		value: function load() {
	    			var gists = this.options.input.getElementsByClassName('ejs-gist');
	    			for (var i = 0; i < gists.length; i++) {
	    				var gistFrame = document.createElement("iframe");
	    				gistFrame.setAttribute("width", "100%");
	    				gistFrame.id = 'ejs-gist-' + i;
	
	    				var zone = gists[i];
	    				zone.innerHTML = "";
	    				zone.appendChild(gistFrame);
	
	    				// Create the iframe's document
	    				var url = gists[i].getAttribute('data-src');
	    				url = url.indexOf('http') === -1 ? 'https://' + url : url;
	    				var gistFrameHTML = '<html><base target="_parent"/><body onload="parent.document.getElementById(\'ejs-gist-' + i + '\').style.height=parseInt(document.body.scrollHeight)+20+\'px\'"><script type="text/javascript" src="' + url + '.js"></script></body></html>';
	
	    				// Set iframe's document with a trigger for this document to adjust the height
	    				var gistFrameDoc = gistFrame.document;
	
	    				if (gistFrame.contentDocument) {
	    					gistFrameDoc = gistFrame.contentDocument;
	    				} else if (gistFrame.contentWindow) {
	    					gistFrameDoc = gistFrame.contentWindow.document;
	    				}
	
	    				gistFrameDoc.open();
	    				gistFrameDoc.writeln(gistFrameHTML);
	    				gistFrameDoc.close();
	    			}
	    		}
	    	}, {
	    		key: 'process',
	    		value: function process() {
	    			return embed(this);
	    		}
	    	}]);
	    	return Gist;
	    }();
	
	    var Youtube = function () {
	    	function Youtube(input, output, options, embeds) {
	    		babelHelpers.classCallCheck(this, Youtube);
	
	    		this.input = input;
	    		this.output = output;
	    		this.options = options;
	    		this.embeds = embeds;
	    		this.regex = regex.youtube;
	    		this.service = 'youtube';
	    	}
	
	    	babelHelpers.createClass(Youtube, [{
	    		key: 'data',
	    		value: function data(id) {
	    			var url = 'https://www.googleapis.com/youtube/v3/videos?id=' + id + '&key=' + this.options.googleAuthKey + '&part=snippet,statistics';
	    			return new Promise(function (resolve) {
	    				fetch(url).then(function (data) {
	    					return data.json();
	    				}).then(function (json) {
	    					return resolve(json.items[0]);
	    				});
	    			});
	    		}
	    	}, {
	    		key: 'process',
	    		value: function process() {
	    			var _this2 = this;
	
	    			return new Promise(function (resolve) {
	    				return asyncEmbed(_this2, Youtube.urlToText).then(function (data) {
	    					return resolve(data);
	    				});
	    			});
	    		}
	    	}], [{
	    		key: 'formatData',
	    		value: function formatData(data, truncate) {
	    			return {
	    				title: data.snippet.title,
	    				thumbnail: data.snippet.thumbnails.medium.url,
	    				rawDescription: data.snippet.description,
	    				views: data.statistics.viewCount,
	    				likes: data.statistics.likeCount,
	    				description: truncate(data.snippet.description, 150),
	    				url: 'https://www.youtube.com/watch?v=' + data.id,
	    				id: data.id,
	    				host: 'youtube'
	    			};
	    		}
	    	}, {
	    		key: 'urlToText',
	    		value: function urlToText(_this, match, url, normalEmbed) {
	    			var id = normalEmbed ? match[1] : match[2];
	    			var embedUrl = 'https://www.youtube.com/embed/' + id;
	    			if (_this.options.videoDetails) {
	    				return new Promise(function (resolve) {
	    					_this.data(id).then(function (data) {
	    						return resolve(getDetailsTemplate(Youtube.formatData(data, truncate), data, embedUrl, _this.options));
	    					});
	    				});
	    			} else {
	    				return new Promise(function (resolve) {
	    					return resolve(template(embedUrl, _this.options));
	    				});
	    			}
	    		}
	    	}]);
	    	return Youtube;
	    }();
	
	    var Vimeo = function () {
	    	function Vimeo(input, output, options, embeds) {
	    		babelHelpers.classCallCheck(this, Vimeo);
	
	    		this.input = input;
	    		this.output = output;
	    		this.options = options;
	    		this.embeds = embeds;
	    		this.regex = regex.vimeo;
	    		this.service = 'vimeo';
	    	}
	
	    	babelHelpers.createClass(Vimeo, [{
	    		key: 'data',
	    		value: function data(id) {
	    			var url = 'https://vimeo.com/api/v2/video/' + id + '.json';
	    			return new Promise(function (resolve) {
	    				fetch(url).then(function (data) {
	    					return data.json();
	    				}).then(function (json) {
	    					return resolve(json[0]);
	    				});
	    			});
	    		}
	    	}, {
	    		key: 'process',
	    		value: function process() {
	    			var _this2 = this;
	
	    			return new Promise(function (resolve) {
	    				return asyncEmbed(_this2, Vimeo.urlToText).then(function (data) {
	    					return resolve(data);
	    				});
	    			});
	    		}
	    	}], [{
	    		key: 'formatData',
	    		value: function formatData(data, truncate) {
	    			return {
	    				title: data.title,
	    				thumbnail: data.thumbnail_medium,
	    				rawDescription: data.description.replace(/\n/g, '<br/>').replace(/&#10;/g, '<br/>'),
	    				views: data.stats_number_of_plays,
	    				likes: data.stats_number_of_likes,
	    				description: truncate(data.description.replace(/((<|&lt;)br\s*\/*(>|&gt;)\r\n)/g, ' '), 150),
	    				url: data.url,
	    				id: data.id,
	    				host: 'vimeo'
	    			};
	    		}
	    	}, {
	    		key: 'urlToText',
	    		value: function urlToText(_this, match, url, normalEmbed) {
	    			var id = void 0;
	    			if (!normalEmbed) {
	    				id = _this.options.link ? match[0].slice(0, -4).split('/').slice(-1).pop() : match[0].split('/').slice(-1).pop();
	    			} else {
	    				id = match[3];
	    			}
	    			if (!id) return;
	    			var embedUrl = 'https://player.vimeo.com/video/' + id;
	    			if (_this.options.videoDetails) {
	    				return new Promise(function (resolve) {
	    					_this.data(id).then(function (data) {
	    						return resolve(getDetailsTemplate(Vimeo.formatData(data, truncate), data, embedUrl, _this.options));
	    					});
	    				});
	    			} else {
	    				return new Promise(function (resolve) {
	    					return resolve(template(embedUrl, _this.options));
	    				});
	    			}
	    		}
	    	}]);
	    	return Vimeo;
	    }();
	
	    var SlideShare = function () {
	    	function SlideShare(input, output, options, embeds) {
	    		babelHelpers.classCallCheck(this, SlideShare);
	
	    		this.input = input;
	    		this.output = output;
	    		this.options = options;
	    		this.embeds = embeds;
	    		this.regex = regex.slideShare;
	    		this.service = 'slideshare';
	    	}
	
	    	babelHelpers.createClass(SlideShare, [{
	    		key: 'template',
	    		value: function template(html) {
	    			return this.options.template.slideShare(html, this.options);
	    		}
	    	}, {
	    		key: 'process',
	    		value: function process() {
	    			var _this2 = this;
	
	    			return new Promise(function (resolve) {
	    				return asyncEmbed(_this2, SlideShare.urlToText).then(function (data) {
	    					return resolve(data);
	    				});
	    			});
	    		}
	    	}], [{
	    		key: 'fetchData',
	    		value: function fetchData(_this, url) {
	    			var api = 'http://www.slideshare.net/api/oembed/2?url=' + url + '&format=jsonp&maxwidth=' + _this.options.videoWidth + '&maxheight=' + _this.options.videoHeight;
	    			return new Promise(function (resolve) {
	    				fetchJsonp$1(api, { credentials: 'include' }).then(function (data) {
	    					return data.json();
	    				}).then(function (json) {
	    					return resolve(json.html);
	    				});
	    			});
	    		}
	    	}, {
	    		key: 'urlToText',
	    		value: function urlToText(_this, match, url) {
	    			return new Promise(function (resolve) {
	    				SlideShare.fetchData(_this, url).then(function (html) {
	    					return resolve(_this.template(html));
	    				});
	    			});
	    		}
	    	}]);
	    	return SlideShare;
	    }();
	
	    var OpenGraph = function () {
	    	function OpenGraph(input, output, options, embeds) {
	    		babelHelpers.classCallCheck(this, OpenGraph);
	
	    		this.input = input;
	    		this.output = output;
	    		this.options = options;
	    		this.embeds = embeds;
	    		this.service = 'opengraph';
	    		this.regex = urlRegex();
	    		this.excludeRegex = new RegExp(['.mp4|.mp3|.gif|.pdf|.doc|.ppt|.docx|.jpg|.jpeg|.ogg'].concat(options.openGraphExclude).join('|'), 'gi');
	    	}
	
	    	babelHelpers.createClass(OpenGraph, [{
	    		key: 'template',
	    		value: function template(data) {
	    			return this.options.template.openGraph(data, this.options);
	    		}
	    	}, {
	    		key: 'process',
	    		value: function process() {
	    			var _this = this;
	
	    			return new Promise(function (resolve) {
	    				return asyncEmbed(_this, OpenGraph.urlToText).then(function (data) {
	    					return resolve(data);
	    				});
	    			});
	    		}
	    	}], [{
	    		key: 'fetchData',
	    		value: function fetchData(url, _) {
	    			url = encodeURIComponent(url);
	    			var api = new Function('url', 'return `' + _.options.openGraphEndpoint + '`')(url);
	    			return new Promise(function (resolve) {
	    				fetch(api).then(function (res) {
	    					return res.json();
	    				}).then(function (json) {
	    					return resolve(_.options.onOpenGraphFetch(json) || json);
	    				});
	    			});
	    		}
	    	}, {
	    		key: 'urlToText',
	    		value: function urlToText(_, match, url) {
	    			if (url.match(_.excludeRegex)) return Promise.resolve();
	
	    			return new Promise(function (resolve) {
	    				OpenGraph.fetchData(url, _).then(function (data) {
	    					return resolve(data && data.success ? _.template(data) : '');
	    				});
	    			});
	    		}
	    	}]);
	    	return OpenGraph;
	    }();
	
	    var Github = function () {
	    	function Github(input, output, options, embeds) {
	    		babelHelpers.classCallCheck(this, Github);
	
	    		this.input = input;
	    		this.output = output;
	    		this.options = options;
	    		this.embeds = embeds;
	    		this.service = 'github';
	    		this.regex = regex.github;
	    	}
	
	    	babelHelpers.createClass(Github, [{
	    		key: 'process',
	    		value: function process() {
	    			var _this2 = this;
	
	    			return new Promise(function (resolve) {
	    				return asyncEmbed(_this2, Github.urlToText).then(function (data) {
	    					return resolve(data);
	    				});
	    			});
	    		}
	    	}], [{
	    		key: 'fetchRepo',
	    		value: function fetchRepo(data) {
	    			var api = 'https://api.github.com/repos/' + data.user + '/' + data.repo;
	    			return new Promise(function (resolve) {
	    				fetch(api).then(function (data) {
	    					return data.json();
	    				}).then(function (json) {
	    					return resolve(json);
	    				});
	    			});
	    		}
	    	}, {
	    		key: 'template',
	    		value: function template(data, options) {
	    			return options.template.github(data, options);
	    		}
	    	}, {
	    		key: 'urlToText',
	    		value: function urlToText(_this, match, url, normalEmbed) {
	    			var data = !normalEmbed ? {
	    				user: match[2],
	    				repo: match[3]
	    			} : {
	    				user: match[1],
	    				repo: match[2]
	    			};
	
	    			if (!data.repo) return;
	    			return new Promise(function (resolve) {
	    				Github.fetchRepo(data).then(function (response) {
	    					return resolve(Github.template(response, _this.options));
	    				});
	    			});
	    		}
	    	}]);
	    	return Github;
	    }();
	
	    var globalOptions = {};
	
	    var defaultOptions = {
	    	marked: false,
	    	markedOptions: {},
	    	link: true,
	    	linkOptions: {
	    		target: 'self',
	    		exclude: ['pdf'],
	    		rel: ''
	    	},
	    	emoji: true,
	    	customEmoji: [],
	    	fontIcons: true,
	    	customFontIcons: [],
	    	highlightCode: false,
	    	videoJS: false,
	    	videojsOptions: {
	    		fluid: true,
	    		preload: 'metadata'
	    	},
	    	locationEmbed: true,
	    	mapOptions: {
	    		mode: 'place'
	    	},
	    	tweetsEmbed: false,
	    	tweetOptions: {
	    		maxWidth: 550,
	    		hideMedia: false,
	    		hideThread: false,
	    		align: 'none',
	    		lang: 'en'
	    	},
	    	singleEmbed: false,
	    	openGraphEndpoint: null,
	    	openGraphExclude: [],
	    	videoEmbed: true,
	    	videoHeight: null,
	    	videoWidth: null,
	    	videoDetails: true,
	    	audioEmbed: true,
	    	imageEmbed: true,
	    	excludeEmbed: [],
	    	inlineEmbed: [],
	    	inlineText: true,
	    	codeEmbedHeight: 500,
	    	vineOptions: {
	    		maxWidth: null,
	    		type: 'postcard', //'postcard' or 'simple' embedding
	    		responsive: true,
	    		width: 350,
	    		height: 460
	    	},
	    	plugins: {
	    		marked: window.marked,
	    		videojs: window.videojs,
	    		highlightjs: window.hljs,
	    		prismjs: window.Prism,
	    		twitter: window.twttr
	    	},
	    	googleAuthKey: '',
	    	soundCloudOptions: {
	    		height: 160,
	    		themeColor: 'f50000', //Hex Code of the player theme color
	    		autoPlay: false,
	    		hideRelated: false,
	    		showComments: true,
	    		showUser: true,
	    		showReposts: false,
	    		visual: false, //Show/hide the big preview image
	    		download: false //Show/Hide download buttons
	    	},
	    	videoClickClass: 'ejs-video-thumb',
	    	customVideoClickHandler: false,
	    	beforeEmbedJSApply: function beforeEmbedJSApply() {},
	    	afterEmbedJSApply: function afterEmbedJSApply() {},
	    	onVideoShow: function onVideoShow() {},
	    	onTweetsLoad: function onTweetsLoad() {},
	    	videojsCallback: function videojsCallback() {},
	    	onOpenGraphFetch: function onOpenGraphFetch() {},
	    	onOpenGraphFail: function onOpenGraphFail() {},
	    	videoClickHandler: function videoClickHandler() {},
	    	served: [] //Private variable used to store processed urls so that they are not processed multiple times.
	    };
	
	    var instances = [];
	    var allInstances = [];
	    var promises = [];
	
	    var EmbedJS = function () {
	    	/**
	      * The constructor takes two arguements. The first one is the options object and the second one is the
	      * optional string . If the user wants to provide a string directly instead of the element, he can do that.
	      * In case the user provides both the input element and the string, the input string will be taken from the element
	      * and the provided string won't be processed.
	      *
	      * @param  {object} options The options object
	      * @param template
	      * @return {null}
	      */
	
	    	function EmbedJS(options, template) {
	    		babelHelpers.classCallCheck(this, EmbedJS);
	
	    		/**
	       * We have created a clone of the original options to make sure that the original object
	       * isn't altered.
	       */
	    		var defOpts = cloneObject(defaultOptions);
	    		var globOpts = cloneObject(globalOptions);
	
	    		//merge global options with the default options
	    		var globOptions = deepExtend(defOpts, globOpts);
	
	    		//deepExtend global options with the overriding options provided by the user as an options
	    		//object while creating a new instance of embed.js
	    		this.options = deepExtend(globOptions, options);
	
	    		this.options.template = template || new Renderer();
	
	    		if (!this.options.input || !(typeof this.options.input === 'string' || babelHelpers.typeof(this.options.input) === 'object')) throw ReferenceError("You need to pass an element or the string that needs to be processed");
	
	    		this.input = babelHelpers.typeof(this.options.input) === 'object' ? this.options.input.innerHTML : this.options.input;
	    	}
	
	    	/**
	      * Processes the string and performs all the insertions and manipulations based on
	      * the options and the input provided by the user. This returns a promise which is resolved once the result data is ready
	      * @return {Promise} The processes resulting string
	      */
	
	
	    	babelHelpers.createClass(EmbedJS, [{
	    		key: 'process',
	    		value: function process() {
	    			var _this = this;
	
	    			var input = this.input;
	    			var options = processOptions(this.options);
	    			var embeds = [];
	    			var output = input;
	
	    			this.options.beforeEmbedJSApply();
	
	    			return new Promise(function (resolve) {
	    				if (options.link) output = new Url(input, options).process();
	
	    				var openGraphPromise = options.openGraphEndpoint ? new OpenGraph(input, output, options, embeds).process() : Promise.resolve([output, embeds]);
	
	    				openGraphPromise.then(function (_ref) {
	    					var _ref2 = babelHelpers.slicedToArray(_ref, 2);
	
	    					var output = _ref2[0];
	    					var embeds = _ref2[1];
	
	    					if (options.highlightCode) {
	    						output = new Highlight(output, options).process();
	    					}
	    					if (options.marked) {
	    						output = new Markdown(output, options).process();
	    					}
	    					if (options.emoji) {
	    						output = new Emoji(output, options).process();
	    					}
	    					if (options.fontIcons) {
	    						output = new Smiley(output, options).process();
	    					}
	
	    					var _baseEmbed = baseEmbed(input, output, embeds, options, regex.ideone, 'ideone');
	
	    					var _baseEmbed2 = babelHelpers.slicedToArray(_baseEmbed, 2);
	
	    					output = _baseEmbed2[0];
	    					embeds = _baseEmbed2[1];
	
	    					var _baseEmbed3 = baseEmbed(input, output, embeds, options, regex.plunker, 'plunker');
	
	    					var _baseEmbed4 = babelHelpers.slicedToArray(_baseEmbed3, 2);
	
	    					output = _baseEmbed4[0];
	    					embeds = _baseEmbed4[1];
	
	    					var _baseEmbed5 = baseEmbed(input, output, embeds, options, regex.jsbin, 'jsbin');
	
	    					var _baseEmbed6 = babelHelpers.slicedToArray(_baseEmbed5, 2);
	
	    					output = _baseEmbed6[0];
	    					embeds = _baseEmbed6[1];
	
	    					var _baseEmbed7 = baseEmbed(input, output, embeds, options, regex.codepen, 'codepen');
	
	    					var _baseEmbed8 = babelHelpers.slicedToArray(_baseEmbed7, 2);
	
	    					output = _baseEmbed8[0];
	    					embeds = _baseEmbed8[1];
	
	    					var _baseEmbed9 = baseEmbed(input, output, embeds, options, regex.jsfiddle, 'jsfiddle');
	
	    					var _baseEmbed10 = babelHelpers.slicedToArray(_baseEmbed9, 2);
	
	    					output = _baseEmbed10[0];
	    					embeds = _baseEmbed10[1];
	
	    					var _baseEmbed11 = baseEmbed(input, output, embeds, options, regex.ted, 'ted');
	
	    					var _baseEmbed12 = babelHelpers.slicedToArray(_baseEmbed11, 2);
	
	    					output = _baseEmbed12[0];
	    					embeds = _baseEmbed12[1];
	
	    					var _baseEmbed13 = baseEmbed(input, output, embeds, options, regex.dailymotion, 'dailymotion');
	
	    					var _baseEmbed14 = babelHelpers.slicedToArray(_baseEmbed13, 2);
	
	    					output = _baseEmbed14[0];
	    					embeds = _baseEmbed14[1];
	
	    					var _baseEmbed15 = baseEmbed(input, output, embeds, options, regex.ustream, 'ustream');
	
	    					var _baseEmbed16 = babelHelpers.slicedToArray(_baseEmbed15, 2);
	
	    					output = _baseEmbed16[0];
	    					embeds = _baseEmbed16[1];
	
	    					var _baseEmbed17 = baseEmbed(input, output, embeds, options, regex.liveleak, 'liveleak');
	
	    					var _baseEmbed18 = babelHelpers.slicedToArray(_baseEmbed17, 2);
	
	    					output = _baseEmbed18[0];
	    					embeds = _baseEmbed18[1];
	
	    					var _baseEmbed19 = baseEmbed(input, output, embeds, options, regex.basicVideo, 'video', options.videoEmbed);
	
	    					var _baseEmbed20 = babelHelpers.slicedToArray(_baseEmbed19, 2);
	
	    					output = _baseEmbed20[0];
	    					embeds = _baseEmbed20[1];
	
	    					var _baseEmbed21 = baseEmbed(input, output, embeds, options, regex.vine, 'vine');
	
	    					var _baseEmbed22 = babelHelpers.slicedToArray(_baseEmbed21, 2);
	
	    					output = _baseEmbed22[0];
	    					embeds = _baseEmbed22[1];
	
	    					var _baseEmbed23 = baseEmbed(input, output, embeds, options, regex.soundCloud, 'soundcloud');
	
	    					var _baseEmbed24 = babelHelpers.slicedToArray(_baseEmbed23, 2);
	
	    					output = _baseEmbed24[0];
	    					embeds = _baseEmbed24[1];
	
	    					var _baseEmbed25 = baseEmbed(input, output, embeds, options, regex.spotify, 'spotify');
	
	    					var _baseEmbed26 = babelHelpers.slicedToArray(_baseEmbed25, 2);
	
	    					output = _baseEmbed26[0];
	    					embeds = _baseEmbed26[1];
	
	    					var _baseEmbed27 = baseEmbed(input, output, embeds, options, regex.basicAudio, 'audio', options.audioEmbed);
	
	    					var _baseEmbed28 = babelHelpers.slicedToArray(_baseEmbed27, 2);
	
	    					output = _baseEmbed28[0];
	    					embeds = _baseEmbed28[1];
	
	    					var _baseEmbed29 = baseEmbed(input, output, embeds, options, regex.flickr, 'flickr');
	
	    					var _baseEmbed30 = babelHelpers.slicedToArray(_baseEmbed29, 2);
	
	    					output = _baseEmbed30[0];
	    					embeds = _baseEmbed30[1];
	
	    					var _baseEmbed31 = baseEmbed(input, output, embeds, options, regex.instagram, 'instagram');
	
	    					var _baseEmbed32 = babelHelpers.slicedToArray(_baseEmbed31, 2);
	
	    					output = _baseEmbed32[0];
	    					embeds = _baseEmbed32[1];
	
	    					var _baseEmbed33 = baseEmbed(input, output, embeds, options, regex.basicImage, 'image', options.imageEmbed);
	
	    					var _baseEmbed34 = babelHelpers.slicedToArray(_baseEmbed33, 2);
	
	    					output = _baseEmbed34[0];
	    					embeds = _baseEmbed34[1];
	
	
	    					if (ifEmbed(options, 'gist')) {
	    						var _process = new Gist(input, output, options, embeds).process();
	
	    						var _process2 = babelHelpers.slicedToArray(_process, 2);
	
	    						output = _process2[0];
	    						embeds = _process2[1];
	    					}
	
	    					return ifEmbed(options, 'youtube') ? new Youtube(input, output, options, embeds).process() : Promise.resolve([output, embeds]);
	    				}).then(function (_ref3) {
	    					var _ref4 = babelHelpers.slicedToArray(_ref3, 2);
	
	    					var output = _ref4[0];
	    					var embeds = _ref4[1];
	
	    					return ifEmbed(options, 'vimeo') ? new Vimeo(input, output, options, embeds).process() : Promise.resolve([output, embeds]);
	    				}).then(function (_ref5) {
	    					var _ref6 = babelHelpers.slicedToArray(_ref5, 2);
	
	    					var output = _ref6[0];
	    					var embeds = _ref6[1];
	
	    					return ifEmbed(options, 'github') ? new Github(input, output, options, embeds).process() : Promise.resolve([output, embeds]);
	    				}).then(function (_ref7) {
	    					var _ref8 = babelHelpers.slicedToArray(_ref7, 2);
	
	    					var output = _ref8[0];
	    					var embeds = _ref8[1];
	
	    					return options.locationEmbed && ifEmbed(options, 'gmap') ? new Gmap(input, output, options, embeds).process() : Promise.resolve([output, embeds]);
	    				}).then(function (_ref9) {
	    					var _ref10 = babelHelpers.slicedToArray(_ref9, 2);
	
	    					var output = _ref10[0];
	    					var embeds = _ref10[1];
	
	    					return ifEmbed(options, 'slideshare') ? new SlideShare(input, output, options, embeds).process() : Promise.resolve([output, embeds]);
	    				}).then(function (_ref11) {
	    					var _ref12 = babelHelpers.slicedToArray(_ref11, 2);
	
	    					var output = _ref12[0];
	    					var embeds = _ref12[1];
	
	    					if (options.tweetsEmbed && ifEmbed(options, 'twitter')) {
	    						_this.twitter = new Twitter(input, output, options, embeds);
	    						return _this.twitter.process();
	    					} else {
	    						return Promise.resolve([output, embeds]);
	    					}
	    				}).then(function (_ref13) {
	    					var _ref14 = babelHelpers.slicedToArray(_ref13, 2);
	
	    					var output = _ref14[0];
	    					var embeds = _ref14[1];
	
	    					_this.data = {
	    						input: options.input,
	    						output: output,
	    						options: options,
	    						inputString: _this.input,
	    						/**
	          	 TODO:
	           - Restructure served urls structure with services name
	          	 */
	
	    						services: options.served,
	    						template: options.template
	    					};
	
	    					resolve(createText(output, embeds));
	    				});
	    			});
	    		}
	
	    		/**
	       * First processes the data by calling the .process() and then renders the data in the div
	       * => Loads the twitter widgets
	       * => Executes the onTweetsLoad() once all the tweets have been rendered
	       * => Applies video.js on the media (both audio and video)
	       * => Triggers video loading on click of the video preview
	       * => Executes afterEmbedJSApply() once everything is done.
	       *
	       * @return Promise
	       */
	
	    	}, {
	    		key: 'render',
	    		value: function render() {
	    			var _this2 = this;
	
	    			if (typeof this.options.input === 'string') throw new Error('You cannot call render method for a string');
	    			if (!this.options.input) throw new Error('You didn\'t pass an element while creating this instance. render() method can\'t work without an input element');
	
	    			return new Promise(function (resolve) {
	    				_this2.process().then(function (data) {
	    					_this2.options.input.innerHTML = data;
	    					_this2.applyListeners();
	    					resolve(_this2.data);
	    				});
	    			});
	    		}
	
	    		/**
	       * This method listens to all the events like click, handle
	       * events to be done after an element has been rendered. These
	       * include twitter widget rendering, gist embedding, click event listeners .
	       */
	
	    	}, {
	    		key: 'applyListeners',
	    		value: function applyListeners() {
	    			applyVideoJS(this.options);
	
	    			playVideo(this.options);
	
	    			var event = new Event('rendered');
	    			this.options.input.dispatchEvent(event);
	
	    			this.options.afterEmbedJSApply();
	    		}
	
	    		/**
	       * This function updates the parametrs of the current instance
	       * @param options   New updated options object. will be extended with the older options
	       * @param template  [optional] the new template instance
	       */
	
	    	}, {
	    		key: 'update',
	    		value: function update(options, template) {
	
	    			if (options) this.options = deepExtend(this.options, options);
	
	    			if (template) this.options.template = template;
	
	    			if (!this.options.input || !(typeof this.options.input === 'string' || babelHelpers.typeof(this.options.input) === 'object')) throw ReferenceError("You need to pass an element or the string that needs to be processed");
	
	    			this.input = babelHelpers.typeof(this.options.input) === 'object' ? this.options.input.innerHTML : this.options.input;
	    		}
	
	    		/**
	       * returns the resulting string based on the input and the options passed by the user.
	       * @return Promise
	       */
	
	    	}, {
	    		key: 'text',
	    		value: function text(callback) {
	    			var _this3 = this;
	
	    			this.process().then(function (data) {
	    				return callback(data, _this3.input);
	    			});
	    		}
	
	    		/**
	       * The destroy method destroys all the listeners and replaces the rih text with the original text in the
	       * element.
	       * @return {null}
	       */
	
	    	}, {
	    		key: 'destroy',
	    		value: function destroy() {
	    			if (!this.element) throw new Error('destroy() method only if an element had been passed in the options object');
	    			destroyVideos('ejs-video-thumb');
	    			this.element.removeEventListener('rendered', this.twitter.load(), false);
	    			this.element.innerHTML = this.input;
	    		}
	
	    		/**
	       * Sets options globally
	       * @param {object} options
	       */
	
	    	}], [{
	    		key: 'setOptions',
	    		value: function setOptions(options) {
	    			globalOptions = deepExtend(defaultOptions, options);
	    		}
	
	    		/**
	       * Applies embed.js to all the elements with the class name provided as option
	       * @return {Promise}
	       * @param selectorName
	       * @param options
	       * @param template
	       */
	
	    	}, {
	    		key: 'applyEmbedJS',
	    		value: function applyEmbedJS(selectorName) {
	    			var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    			var template = arguments.length <= 2 || arguments[2] === undefined ? new Renderer() : arguments[2];
	
	    			var elements = document.querySelectorAll(selectorName);
	    			for (var i = 0; i < elements.length; i++) {
	    				options.input = elements[i];
	    				instances[i] = new EmbedJS(options, template);
	    				promises[i] = instances[i].render();
	    			}
	    			return new Promise(function (resolve) {
	    				Promise.all(promises).then(function (val) {
	    					resolve(val);
	    				});
	    			});
	    		}
	
	    		/**
	       * Destroys all the instances of EmbedJS created by using applyEmbedJS() method.
	       * @return {null}
	       */
	
	    	}, {
	    		key: 'destroyEmbedJS',
	    		value: function destroyEmbedJS() {
	    			for (var i = 0; i < instances.length; i++) {
	    				instances[i].destroy();
	    			}
	    		}
	
	    		/**
	       * Destroys all instances of EmbedJS on the page
	       * @return {null}
	       */
	
	    	}, {
	    		key: 'destroyAll',
	    		value: function destroyAll() {
	    			for (var i = 0; i < allInstances.length; i++) {
	    				allInstances[i].destroy();
	    			}
	    		}
	
	    		/**
	       * Creates a new instance of the Template constructor. This has been done so that multiple
	       * templates of a single service can be used by creating different instances of the Template.
	       *
	       * The usage of the plugin is described below.
	       *
	       * => Create a new Instance of the template by using .Template() method of EmbedJS.
	       *
	       *        var template = EmbedJS.Template()
	       *
	       * => Now create different templates for different service names.
	       *
	       *        template.url = function(match, options){
	          * 			return '<a href=" + match + "> + match + </a>'
	          * 		}
	       *
	       *        template.instagram = function(match, dimensions, options){
	          * 			var config = options.soundCloudOptions;
	          * 			return `<div class="ejs-embed ejs-instagram"><iframe src="${toUrl(match.split('/?')[0])}/embed/" height="${dimensions.height}"></iframe></div>`;
	          * 		}
	       *
	       */
	
	    	}, {
	    		key: 'Template',
	    		value: function Template() {
	    			return new Renderer();
	    		}
	    	}]);
	    	return EmbedJS;
	    }();
	
	    return EmbedJS;
	
	}));
	//# sourceMappingURL=embed.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 742 */
/***/ function(module, exports) {

	'use strict'
	
	function extend(dest, src) {
	  if (src) {
	    var props = Object.keys(src)
	    for (var i = 0, l = props.length; i < l ; i++) {
	      dest[props[i]] = src[props[i]]
	    }
	  }
	  return dest
	}
	
	function copy(obj) {
	  return extend({}, obj)
	}
	
	/**
	 * Merge an object defining format characters into the defaults.
	 * Passing null/undefined for en existing format character removes it.
	 * Passing a definition for an existing format character overrides it.
	 * @param {?Object} formatCharacters.
	 */
	function mergeFormatCharacters(formatCharacters) {
	  var merged = copy(DEFAULT_FORMAT_CHARACTERS)
	  if (formatCharacters) {
	    var chars = Object.keys(formatCharacters)
	    for (var i = 0, l = chars.length; i < l ; i++) {
	      var char = chars[i]
	      if (formatCharacters[char] == null) {
	        delete merged[char]
	      }
	      else {
	        merged[char] = formatCharacters[char]
	      }
	    }
	  }
	  return merged
	}
	
	var ESCAPE_CHAR = '\\'
	
	var DIGIT_RE = /^\d$/
	var LETTER_RE = /^[A-Za-z]$/
	var ALPHANNUMERIC_RE = /^[\dA-Za-z]$/
	
	var DEFAULT_PLACEHOLDER_CHAR = '_'
	var DEFAULT_FORMAT_CHARACTERS = {
	  '*': {
	    validate: function(char) { return ALPHANNUMERIC_RE.test(char) }
	  },
	  '1': {
	    validate: function(char) { return DIGIT_RE.test(char) }
	  },
	  'a': {
	    validate: function(char) { return LETTER_RE.test(char) }
	  },
	  'A': {
	    validate: function(char) { return LETTER_RE.test(char) },
	    transform: function(char) { return char.toUpperCase() }
	  },
	  '#': {
	    validate: function(char) { return ALPHANNUMERIC_RE.test(char) },
	    transform: function(char) { return char.toUpperCase() }
	  }
	}
	
	/**
	 * @param {string} source
	 * @patam {?Object} formatCharacters
	 */
	function Pattern(source, formatCharacters, placeholderChar, isRevealingMask) {
	  if (!(this instanceof Pattern)) {
	    return new Pattern(source, formatCharacters, placeholderChar)
	  }
	
	  /** Placeholder character */
	  this.placeholderChar = placeholderChar || DEFAULT_PLACEHOLDER_CHAR
	  /** Format character definitions. */
	  this.formatCharacters = formatCharacters || DEFAULT_FORMAT_CHARACTERS
	  /** Pattern definition string with escape characters. */
	  this.source = source
	  /** Pattern characters after escape characters have been processed. */
	  this.pattern = []
	  /** Length of the pattern after escape characters have been processed. */
	  this.length = 0
	  /** Index of the first editable character. */
	  this.firstEditableIndex = null
	  /** Index of the last editable character. */
	  this.lastEditableIndex = null
	  /** Lookup for indices of editable characters in the pattern. */
	  this._editableIndices = {}
	  /** If true, only the pattern before the last valid value character shows. */
	  this.isRevealingMask = isRevealingMask || false
	
	  this._parse()
	}
	
	Pattern.prototype._parse = function parse() {
	  var sourceChars = this.source.split('')
	  var patternIndex = 0
	  var pattern = []
	
	  for (var i = 0, l = sourceChars.length; i < l; i++) {
	    var char = sourceChars[i]
	    if (char === ESCAPE_CHAR) {
	      if (i === l - 1) {
	        throw new Error('InputMask: pattern ends with a raw ' + ESCAPE_CHAR)
	      }
	      char = sourceChars[++i]
	    }
	    else if (char in this.formatCharacters) {
	      if (this.firstEditableIndex === null) {
	        this.firstEditableIndex = patternIndex
	      }
	      this.lastEditableIndex = patternIndex
	      this._editableIndices[patternIndex] = true
	    }
	
	    pattern.push(char)
	    patternIndex++
	  }
	
	  if (this.firstEditableIndex === null) {
	    throw new Error(
	      'InputMask: pattern "' + this.source + '" does not contain any editable characters.'
	    )
	  }
	
	  this.pattern = pattern
	  this.length = pattern.length
	}
	
	/**
	 * @param {Array<string>} value
	 * @return {Array<string>}
	 */
	Pattern.prototype.formatValue = function format(value) {
	  var valueBuffer = new Array(this.length)
	  var valueIndex = 0
	
	  for (var i = 0, l = this.length; i < l ; i++) {
	    if (this.isEditableIndex(i)) {
	      if (this.isRevealingMask &&
	          value.length <= valueIndex &&
	          !this.isValidAtIndex(value[valueIndex], i)) {
	        break
	      }
	      valueBuffer[i] = (value.length > valueIndex && this.isValidAtIndex(value[valueIndex], i)
	                        ? this.transform(value[valueIndex], i)
	                        : this.placeholderChar)
	      valueIndex++
	    }
	    else {
	      valueBuffer[i] = this.pattern[i]
	      // Also allow the value to contain static values from the pattern by
	      // advancing its index.
	      if (value.length > valueIndex && value[valueIndex] === this.pattern[i]) {
	        valueIndex++
	      }
	    }
	  }
	
	  return valueBuffer
	}
	
	/**
	 * @param {number} index
	 * @return {boolean}
	 */
	Pattern.prototype.isEditableIndex = function isEditableIndex(index) {
	  return !!this._editableIndices[index]
	}
	
	/**
	 * @param {string} char
	 * @param {number} index
	 * @return {boolean}
	 */
	Pattern.prototype.isValidAtIndex = function isValidAtIndex(char, index) {
	  return this.formatCharacters[this.pattern[index]].validate(char)
	}
	
	Pattern.prototype.transform = function transform(char, index) {
	  var format = this.formatCharacters[this.pattern[index]]
	  return typeof format.transform == 'function' ? format.transform(char) : char
	}
	
	function InputMask(options) {
	  if (!(this instanceof InputMask)) { return new InputMask(options) }
	  options = extend({
	    formatCharacters: null,
	    pattern: null,
	    isRevealingMask: false,
	    placeholderChar: DEFAULT_PLACEHOLDER_CHAR,
	    selection: {start: 0, end: 0},
	    value: ''
	  }, options)
	
	  if (options.pattern == null) {
	    throw new Error('InputMask: you must provide a pattern.')
	  }
	
	  if (typeof options.placeholderChar !== 'string' || options.placeholderChar.length > 1) {
	    throw new Error('InputMask: placeholderChar should be a single character or an empty string.')
	  }
	
	  this.placeholderChar = options.placeholderChar
	  this.formatCharacters = mergeFormatCharacters(options.formatCharacters)
	  this.setPattern(options.pattern, {
	    value: options.value,
	    selection: options.selection,
	    isRevealingMask: options.isRevealingMask
	  })
	}
	
	// Editing
	
	/**
	 * Applies a single character of input based on the current selection.
	 * @param {string} char
	 * @return {boolean} true if a change has been made to value or selection as a
	 *   result of the input, false otherwise.
	 */
	InputMask.prototype.input = function input(char) {
	  // Ignore additional input if the cursor's at the end of the pattern
	  if (this.selection.start === this.selection.end &&
	      this.selection.start === this.pattern.length) {
	    return false
	  }
	
	  var selectionBefore = copy(this.selection)
	  var valueBefore = this.getValue()
	
	  var inputIndex = this.selection.start
	
	  // If the cursor or selection is prior to the first editable character, make
	  // sure any input given is applied to it.
	  if (inputIndex < this.pattern.firstEditableIndex) {
	    inputIndex = this.pattern.firstEditableIndex
	  }
	
	  // Bail out or add the character to input
	  if (this.pattern.isEditableIndex(inputIndex)) {
	    if (!this.pattern.isValidAtIndex(char, inputIndex)) {
	      return false
	    }
	    this.value[inputIndex] = this.pattern.transform(char, inputIndex)
	  }
	
	  // If multiple characters were selected, blank the remainder out based on the
	  // pattern.
	  var end = this.selection.end - 1
	  while (end > inputIndex) {
	    if (this.pattern.isEditableIndex(end)) {
	      this.value[end] = this.placeholderChar
	    }
	    end--
	  }
	
	  // Advance the cursor to the next character
	  this.selection.start = this.selection.end = inputIndex + 1
	
	  // Skip over any subsequent static characters
	  while (this.pattern.length > this.selection.start &&
	         !this.pattern.isEditableIndex(this.selection.start)) {
	    this.selection.start++
	    this.selection.end++
	  }
	
	  // History
	  if (this._historyIndex != null) {
	    // Took more input after undoing, so blow any subsequent history away
	    this._history.splice(this._historyIndex, this._history.length - this._historyIndex)
	    this._historyIndex = null
	  }
	  if (this._lastOp !== 'input' ||
	      selectionBefore.start !== selectionBefore.end ||
	      this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
	    this._history.push({value: valueBefore, selection: selectionBefore, lastOp: this._lastOp})
	  }
	  this._lastOp = 'input'
	  this._lastSelection = copy(this.selection)
	
	  return true
	}
	
	/**
	 * Attempts to delete from the value based on the current cursor position or
	 * selection.
	 * @return {boolean} true if the value or selection changed as the result of
	 *   backspacing, false otherwise.
	 */
	InputMask.prototype.backspace = function backspace() {
	  // If the cursor is at the start there's nothing to do
	  if (this.selection.start === 0 && this.selection.end === 0) {
	    return false
	  }
	
	  var selectionBefore = copy(this.selection)
	  var valueBefore = this.getValue()
	
	  // No range selected - work on the character preceding the cursor
	  if (this.selection.start === this.selection.end) {
	    if (this.pattern.isEditableIndex(this.selection.start - 1)) {
	      this.value[this.selection.start - 1] = this.placeholderChar
	    }
	    this.selection.start--
	    this.selection.end--
	  }
	  // Range selected - delete characters and leave the cursor at the start of the selection
	  else {
	    var end = this.selection.end - 1
	    while (end >= this.selection.start) {
	      if (this.pattern.isEditableIndex(end)) {
	        this.value[end] = this.placeholderChar
	      }
	      end--
	    }
	    this.selection.end = this.selection.start
	  }
	
	  // History
	  if (this._historyIndex != null) {
	    // Took more input after undoing, so blow any subsequent history away
	    this._history.splice(this._historyIndex, this._history.length - this._historyIndex)
	  }
	  if (this._lastOp !== 'backspace' ||
	      selectionBefore.start !== selectionBefore.end ||
	      this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
	    this._history.push({value: valueBefore, selection: selectionBefore, lastOp: this._lastOp})
	  }
	  this._lastOp = 'backspace'
	  this._lastSelection = copy(this.selection)
	
	  return true
	}
	
	/**
	 * Attempts to paste a string of input at the current cursor position or over
	 * the top of the current selection.
	 * Invalid content at any position will cause the paste to be rejected, and it
	 * may contain static parts of the mask's pattern.
	 * @param {string} input
	 * @return {boolean} true if the paste was successful, false otherwise.
	 */
	InputMask.prototype.paste = function paste(input) {
	  // This is necessary because we're just calling input() with each character
	  // and rolling back if any were invalid, rather than checking up-front.
	  var initialState = {
	    value: this.value.slice(),
	    selection: copy(this.selection),
	    _lastOp: this._lastOp,
	    _history: this._history.slice(),
	    _historyIndex: this._historyIndex,
	    _lastSelection: copy(this._lastSelection)
	  }
	
	  // If there are static characters at the start of the pattern and the cursor
	  // or selection is within them, the static characters must match for a valid
	  // paste.
	  if (this.selection.start < this.pattern.firstEditableIndex) {
	    for (var i = 0, l = this.pattern.firstEditableIndex - this.selection.start; i < l; i++) {
	      if (input.charAt(i) !== this.pattern.pattern[i]) {
	        return false
	      }
	    }
	
	    // Continue as if the selection and input started from the editable part of
	    // the pattern.
	    input = input.substring(this.pattern.firstEditableIndex - this.selection.start)
	    this.selection.start = this.pattern.firstEditableIndex
	  }
	
	  for (i = 0, l = input.length;
	       i < l && this.selection.start <= this.pattern.lastEditableIndex;
	       i++) {
	    var valid = this.input(input.charAt(i))
	    // Allow static parts of the pattern to appear in pasted input - they will
	    // already have been stepped over by input(), so verify that the value
	    // deemed invalid by input() was the expected static character.
	    if (!valid) {
	      if (this.selection.start > 0) {
	        // XXX This only allows for one static character to be skipped
	        var patternIndex = this.selection.start - 1
	        if (!this.pattern.isEditableIndex(patternIndex) &&
	            input.charAt(i) === this.pattern.pattern[patternIndex]) {
	          continue
	        }
	      }
	      extend(this, initialState)
	      return false
	    }
	  }
	
	  return true
	}
	
	// History
	
	InputMask.prototype.undo = function undo() {
	  // If there is no history, or nothing more on the history stack, we can't undo
	  if (this._history.length === 0 || this._historyIndex === 0) {
	    return false
	  }
	
	  var historyItem
	  if (this._historyIndex == null) {
	    // Not currently undoing, set up the initial history index
	    this._historyIndex = this._history.length - 1
	    historyItem = this._history[this._historyIndex]
	    // Add a new history entry if anything has changed since the last one, so we
	    // can redo back to the initial state we started undoing from.
	    var value = this.getValue()
	    if (historyItem.value !== value ||
	        historyItem.selection.start !== this.selection.start ||
	        historyItem.selection.end !== this.selection.end) {
	      this._history.push({value: value, selection: copy(this.selection), lastOp: this._lastOp, startUndo: true})
	    }
	  }
	  else {
	    historyItem = this._history[--this._historyIndex]
	  }
	
	  this.value = historyItem.value.split('')
	  this.selection = historyItem.selection
	  this._lastOp = historyItem.lastOp
	  return true
	}
	
	InputMask.prototype.redo = function redo() {
	  if (this._history.length === 0 || this._historyIndex == null) {
	    return false
	  }
	  var historyItem = this._history[++this._historyIndex]
	  // If this is the last history item, we're done redoing
	  if (this._historyIndex === this._history.length - 1) {
	    this._historyIndex = null
	    // If the last history item was only added to start undoing, remove it
	    if (historyItem.startUndo) {
	      this._history.pop()
	    }
	  }
	  this.value = historyItem.value.split('')
	  this.selection = historyItem.selection
	  this._lastOp = historyItem.lastOp
	  return true
	}
	
	// Getters & setters
	
	InputMask.prototype.setPattern = function setPattern(pattern, options) {
	  options = extend({
	    selection: {start: 0, end: 0},
	    value: ''
	  }, options)
	  this.pattern = new Pattern(pattern, this.formatCharacters, this.placeholderChar, options.isRevealingMask)
	  this.setValue(options.value)
	  this.emptyValue = this.pattern.formatValue([]).join('')
	  this.selection = options.selection
	  this._resetHistory()
	}
	
	InputMask.prototype.setSelection = function setSelection(selection) {
	  this.selection = copy(selection)
	  if (this.selection.start === this.selection.end) {
	    if (this.selection.start < this.pattern.firstEditableIndex) {
	      this.selection.start = this.selection.end = this.pattern.firstEditableIndex
	      return true
	    }
	    // Set selection to the first editable, non-placeholder character before the selection
	    // OR to the beginning of the pattern
	    var index = this.selection.start
	    while (index >= this.pattern.firstEditableIndex) {
	      if (this.pattern.isEditableIndex(index - 1) &&
	          this.value[index - 1] !== this.placeholderChar ||
	          index === this.pattern.firstEditableIndex) {
	        this.selection.start = this.selection.end = index
	        break
	      }
	      index--
	    }
	    return true
	  }
	  return false
	}
	
	InputMask.prototype.setValue = function setValue(value) {
	  if (value == null) {
	    value = ''
	  }
	  this.value = this.pattern.formatValue(value.split(''))
	}
	
	InputMask.prototype.getValue = function getValue() {
	  return this.value.join('')
	}
	
	InputMask.prototype.getRawValue = function getRawValue() {
	  var rawValue = []
	  for (var i = 0; i < this.value.length; i++) {
	    if (this.pattern._editableIndices[i] === true) {
	      rawValue.push(this.value[i])
	    }
	  }
	  return rawValue.join('')
	}
	
	InputMask.prototype._resetHistory = function _resetHistory() {
	  this._history = []
	  this._historyIndex = null
	  this._lastOp = null
	  this._lastSelection = copy(this.selection)
	}
	
	InputMask.Pattern = Pattern
	
	module.exports = InputMask


/***/ },
/* 743 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 */
	
	"use strict";
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function(obj) {
	  var ret = {};
	  var key;
	  if (!(obj instanceof Object && !Array.isArray(obj))) {
	    throw new Error('keyMirror(...): Argument must be an object.');
	  }
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;


/***/ },
/* 744 */,
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(250),
	    arrayIncludes = __webpack_require__(251),
	    arrayIncludesWith = __webpack_require__(252),
	    arrayMap = __webpack_require__(22),
	    baseUnary = __webpack_require__(234),
	    cacheHas = __webpack_require__(254);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 746 */,
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(75);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(22),
	    baseIntersection = __webpack_require__(745),
	    castArrayLikeObject = __webpack_require__(747),
	    rest = __webpack_require__(112);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons. The order of result values is determined by the
	 * order they occur in the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [4, 2], [1, 2]);
	 * // => [2]
	 */
	var intersection = rest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Format = __webpack_require__(425);
	
	var _Format2 = _interopRequireDefault(_Format);
	
	var _Dimensions = __webpack_require__(578);
	
	var _Dimensions2 = _interopRequireDefault(_Dimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * https://developers.google.com/doubleclick-gpt/reference
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	
	function debounce(fn, delay) {
	  var timer = null;
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    clearTimeout(timer);
	    timer = setTimeout(function () {
	      return fn.apply(undefined, args);
	    }, delay);
	  };
	}
	
	function prepareDimensions(dimensions) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Format2.default.HORIZONTAL;
	  var canBeLower = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!dimensions || !dimensions.length) {
	    return _Dimensions2.default[format] || [];
	  }
	
	  if (dimensions.length === 1 && canBeLower) {
	    var dimension = dimensions[0];
	    var key = dimension[0] + 'x' + dimension[1];
	
	    if (_Dimensions2.default[key]) {
	      return _Dimensions2.default[key] || [];
	    }
	  }
	
	  return dimensions;
	}
	
	var nextId = 1;
	var googletag = null;
	
	function getNextId() {
	  nextId += 1;
	
	  return 'rgpt-' + nextId;
	}
	
	function loadScript() {
	  var gads = document.createElement('script');
	  gads.async = true;
	  gads.type = 'text/javascript';
	  gads.src = '//www.googletagservices.com/tag/js/gpt.js';
	
	  var head = document.getElementsByTagName('head')[0];
	  head.appendChild(gads);
	}
	
	function initGooglePublisherTag(props) {
	  var exitAfterAddingCommands = !!googletag;
	
	  if (!googletag) {
	    googletag = window.googletag = window.googletag || {};
	    googletag.cmd = googletag.cmd || [];
	  }
	
	  var onImpressionViewable = props.onImpressionViewable,
	      onSlotRenderEnded = props.onSlotRenderEnded,
	      path = props.path;
	
	  // Execute callback when the slot is visible in DOM (thrown before 'impressionViewable' )
	
	  if (onSlotRenderEnded) {
	    googletag.cmd.push(function () {
	      googletag.pubads().addEventListener('slotRenderEnded', function (event) {
	        // check if the current slot is the one the callback was added to
	        // (as addEventListener is global)
	        if (event.slot.getAdUnitPath() === path) {
	          onSlotRenderEnded(event);
	        }
	      });
	    });
	  }
	
	  // Execute callback when ad is completely visible in DOM
	  if (onImpressionViewable) {
	    googletag.cmd.push(function () {
	      googletag.pubads().addEventListener('impressionViewable', function (event) {
	        if (event.slot.getAdUnitPath() === path) {
	          onImpressionViewable(event);
	        }
	      });
	    });
	  }
	
	  if (exitAfterAddingCommands) {
	    return;
	  }
	
	  googletag.cmd.push(function () {
	    // add support for async loading
	    googletag.pubads().enableAsyncRendering();
	
	    // collapse div without ad
	    googletag.pubads().collapseEmptyDivs();
	
	    // load ad with slot refresh
	    googletag.pubads().disableInitialLoad();
	
	    // enable google publisher tag
	    googletag.enableServices();
	  });
	
	  loadScript();
	}
	
	var GooglePublisherTag = function (_Component) {
	  _inherits(GooglePublisherTag, _Component);
	
	  function GooglePublisherTag() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GooglePublisherTag);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GooglePublisherTag.__proto__ || Object.getPrototypeOf(GooglePublisherTag)).call.apply(_ref, [this].concat(args))), _this), _this.onResize = function () {
	      var resizeDebounce = _this.props.resizeDebounce;
	
	
	      if (!_this.resizeDebounce) {
	        _this.resizeDebounce = debounce(function () {
	          return _this.update(_this.props);
	        }, resizeDebounce);
	      }
	
	      _this.resizeDebounce();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GooglePublisherTag, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      initGooglePublisherTag(this.props);
	
	      if (this.props.responsive) {
	        window.addEventListener('resize', this.onResize);
	      }
	
	      googletag.cmd.push(function () {
	        _this2.initialized = true;
	        _this2.update(_this2.props);
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.update(props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // TODO sometimes can props changed
	      if (this.props.responsive) {
	        window.removeEventListener('resize', this.onResize);
	      }
	
	      this.removeSlot();
	    }
	  }, {
	    key: 'update',
	    value: function update(props) {
	      if (!this.initialized) {
	        return;
	      }
	
	      var node = this.node;
	
	      if (!node) {
	        return;
	      }
	
	      var componentWidth = node.offsetWidth;
	      var availableDimensions = prepareDimensions(props.dimensions, props.format, props.canBeLower);
	
	      // filter by available node space
	      var dimensions = props.responsive ? availableDimensions.filter(function (dimension) {
	        return dimension[0] <= componentWidth;
	      }) : availableDimensions;
	
	      // filter by min and max width
	      var windowWidth = window.innerWidth;
	      var minWindowWidth = props.minWindowWidth,
	          maxWindowWidth = props.maxWindowWidth,
	          targeting = props.targeting,
	          collapseEmptyDiv = props.collapseEmptyDiv;
	
	
	      if (minWindowWidth !== undefined && minWindowWidth < windowWidth) {
	        dimensions = [];
	      } else if (maxWindowWidth !== undefined && maxWindowWidth > windowWidth) {
	        dimensions = [];
	      }
	
	      // do nothink
	      if (JSON.stringify(dimensions) === JSON.stringify(this.currentDimensions)) {
	        return;
	      }
	
	      this.currentDimensions = dimensions;
	
	      if (this.slot) {
	        // remove current slot because dimensions is changed and current slot is old
	        this.removeSlot();
	      }
	
	      // there is nothink to display
	      if (!dimensions || !dimensions.length) {
	        return;
	      }
	
	      // prepare new node content
	      var id = getNextId();
	      node.innerHTML = '<div id="' + id + '"></div>';
	
	      // prepare new slot
	      var slot = this.slot = googletag.defineSlot(props.path, dimensions, id);
	
	      // set targeting
	      if (targeting) {
	        Object.keys(targeting).forEach(function (key) {
	          slot.setTargeting(key, targeting[key]);
	        });
	      }
	
	      // set collapsing
	      if (typeof collapseEmptyDiv !== 'undefined') {
	        var args = Array.isArray(collapseEmptyDiv) ? collapseEmptyDiv : [collapseEmptyDiv];
	
	        slot.setCollapseEmptyDiv.apply(slot, _toConsumableArray(args));
	      }
	
	      slot.addService(googletag.pubads());
	
	      // display new slot
	      googletag.display(id);
	      googletag.pubads().refresh([slot]);
	    }
	  }, {
	    key: 'removeSlot',
	    value: function removeSlot() {
	      if (!this.slot) {
	        return;
	      }
	
	      googletag.pubads().clear([this.slot]);
	      this.slot = null;
	
	      if (this.node) {
	        this.node.innerHTML = null;
	      }
	    }
	  }, {
	    key: 'refreshSlot',
	    value: function refreshSlot() {
	      if (this.slot) {
	        googletag.pubads().refresh([this.slot]);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement('div', { className: this.props.className, ref: function ref(node) {
	          _this3.node = node;
	        } });
	    }
	  }]);
	
	  return GooglePublisherTag;
	}(_react.Component);
	
	GooglePublisherTag.propTypes = {
	  className: _react.PropTypes.string,
	  path: _react.PropTypes.string.isRequired,
	  format: _react.PropTypes.string.isRequired,
	  responsive: _react.PropTypes.bool.isRequired,
	  canBeLower: _react.PropTypes.bool.isRequired, // can be ad lower than original size,
	  dimensions: _react.PropTypes.array, // [[300, 600], [160, 600]]
	  minWindowWidth: _react.PropTypes.number,
	  maxWindowWidth: _react.PropTypes.number,
	  targeting: _react.PropTypes.object,
	  resizeDebounce: _react.PropTypes.number.isRequired,
	  onSlotRenderEnded: _react.PropTypes.func
	};
	GooglePublisherTag.defaultProps = {
	  format: _Format2.default.HORIZONTAL,
	  responsive: true,
	  canBeLower: true,
	  dimensions: null,
	  resizeDebounce: 100
	};
	exports.default = GooglePublisherTag;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(3);
	var InputMask = __webpack_require__(742);
	
	var KEYCODE_Z = 90;
	var KEYCODE_Y = 89;
	
	function isUndo(e) {
	  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Y : KEYCODE_Z);
	}
	
	function isRedo(e) {
	  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Z : KEYCODE_Y);
	}
	
	function getSelection(el) {
	  var start, end, rangeEl, clone;
	
	  if (el.selectionStart !== undefined) {
	    start = el.selectionStart;
	    end = el.selectionEnd;
	  } else {
	    try {
	      el.focus();
	      rangeEl = el.createTextRange();
	      clone = rangeEl.duplicate();
	
	      rangeEl.moveToBookmark(document.selection.createRange().getBookmark());
	      clone.setEndPoint('EndToStart', rangeEl);
	
	      start = clone.text.length;
	      end = start + rangeEl.text.length;
	    } catch (e) {/* not focused or not visible */}
	  }
	
	  return { start: start, end: end };
	}
	
	function setSelection(el, selection) {
	  var rangeEl;
	
	  try {
	    if (el.selectionStart !== undefined) {
	      el.focus();
	      el.setSelectionRange(selection.start, selection.end);
	    } else {
	      el.focus();
	      rangeEl = el.createTextRange();
	      rangeEl.collapse(true);
	      rangeEl.moveStart('character', selection.start);
	      rangeEl.moveEnd('character', selection.end - selection.start);
	      rangeEl.select();
	    }
	  } catch (e) {/* not focused or not visible */}
	}
	
	var MaskedInput = React.createClass({
	  displayName: 'MaskedInput',
	
	  propTypes: {
	    mask: React.PropTypes.string.isRequired,
	
	    formatCharacters: React.PropTypes.object,
	    placeholderChar: React.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      value: ''
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    var options = {
	      pattern: this.props.mask,
	      value: this.props.value,
	      formatCharacters: this.props.formatCharacters
	    };
	    if (this.props.placeholderChar) {
	      options.placeholderChar = this.props.placeholderChar;
	    }
	    this.mask = new InputMask(options);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.mask !== nextProps.mask && this.props.value !== nextProps.mask) {
	      // if we get a new value and a new mask at the same time
	      // check if the mask.value is still the initial value
	      // - if so use the nextProps value
	      // - otherwise the `this.mask` has a value for us (most likely from paste action)
	      if (this.mask.getValue() === this.mask.emptyValue) {
	        this.mask.setPattern(nextProps.mask, { value: nextProps.value });
	      } else {
	        this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
	      }
	    } else if (this.props.mask !== nextProps.mask) {
	      this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
	    } else if (this.props.value !== nextProps.value) {
	      this.mask.setValue(nextProps.value);
	    }
	  },
	
	  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
	    if (nextProps.mask !== this.props.mask) {
	      this._updatePattern(nextProps);
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.mask !== this.props.mask && this.mask.selection.start) {
	      this._updateInputSelection();
	    }
	  },
	
	  _updatePattern: function _updatePattern(props) {
	    this.mask.setPattern(props.mask, {
	      value: this.mask.getRawValue(),
	      selection: getSelection(this.input)
	    });
	  },
	
	  _updateMaskSelection: function _updateMaskSelection() {
	    this.mask.selection = getSelection(this.input);
	  },
	
	  _updateInputSelection: function _updateInputSelection() {
	    setSelection(this.input, this.mask.selection);
	  },
	
	  _onChange: function _onChange(e) {
	    // console.log('onChange', JSON.stringify(getSelection(this.input)), e.target.value)
	
	    var maskValue = this.mask.getValue();
	    if (e.target.value !== maskValue) {
	      // Cut or delete operations will have shortened the value
	      if (e.target.value.length < maskValue.length) {
	        var sizeDiff = maskValue.length - e.target.value.length;
	        this._updateMaskSelection();
	        this.mask.selection.end = this.mask.selection.start + sizeDiff;
	        this.mask.backspace();
	      }
	      var value = this._getDisplayValue();
	      e.target.value = value;
	      if (value) {
	        this._updateInputSelection();
	      }
	    }
	    if (this.props.onChange) {
	      this.props.onChange(e);
	    }
	  },
	
	  _onKeyDown: function _onKeyDown(e) {
	    // console.log('onKeyDown', JSON.stringify(getSelection(this.input)), e.key, e.target.value)
	
	    if (isUndo(e)) {
	      e.preventDefault();
	      if (this.mask.undo()) {
	        e.target.value = this._getDisplayValue();
	        this._updateInputSelection();
	        if (this.props.onChange) {
	          this.props.onChange(e);
	        }
	      }
	      return;
	    } else if (isRedo(e)) {
	      e.preventDefault();
	      if (this.mask.redo()) {
	        e.target.value = this._getDisplayValue();
	        this._updateInputSelection();
	        if (this.props.onChange) {
	          this.props.onChange(e);
	        }
	      }
	      return;
	    }
	
	    if (e.key === 'Backspace') {
	      e.preventDefault();
	      this._updateMaskSelection();
	      if (this.mask.backspace()) {
	        var value = this._getDisplayValue();
	        e.target.value = value;
	        if (value) {
	          this._updateInputSelection();
	        }
	        if (this.props.onChange) {
	          this.props.onChange(e);
	        }
	      }
	    }
	  },
	
	  _onKeyPress: function _onKeyPress(e) {
	    // console.log('onKeyPress', JSON.stringify(getSelection(this.input)), e.key, e.target.value)
	
	    // Ignore modified key presses
	    // Ignore enter key to allow form submission
	    if (e.metaKey || e.altKey || e.ctrlKey || e.key === 'Enter') {
	      return;
	    }
	
	    e.preventDefault();
	    this._updateMaskSelection();
	    if (this.mask.input(e.key || e.data)) {
	      e.target.value = this.mask.getValue();
	      this._updateInputSelection();
	      if (this.props.onChange) {
	        this.props.onChange(e);
	      }
	    }
	  },
	
	  _onPaste: function _onPaste(e) {
	    // console.log('onPaste', JSON.stringify(getSelection(this.input)), e.clipboardData.getData('Text'), e.target.value)
	
	    e.preventDefault();
	    this._updateMaskSelection();
	    // getData value needed for IE also works in FF & Chrome
	    if (this.mask.paste(e.clipboardData.getData('Text'))) {
	      e.target.value = this.mask.getValue();
	      // Timeout needed for IE
	      setTimeout(this._updateInputSelection, 0);
	      if (this.props.onChange) {
	        this.props.onChange(e);
	      }
	    }
	  },
	
	  _getDisplayValue: function _getDisplayValue() {
	    var value = this.mask.getValue();
	    return value === this.mask.emptyValue ? '' : value;
	  },
	
	  _keyPressPropName: function _keyPressPropName() {
	    if (typeof navigator !== 'undefined') {
	      return navigator.userAgent.match(/Android/i) ? 'onBeforeInput' : 'onKeyPress';
	    }
	    return 'onKeyPress';
	  },
	
	  _getEventHandlers: function _getEventHandlers() {
	    return _defineProperty({
	      onChange: this._onChange,
	      onKeyDown: this._onKeyDown,
	      onPaste: this._onPaste
	    }, this._keyPressPropName(), this._onKeyPress);
	  },
	
	  focus: function focus() {
	    this.input.focus();
	  },
	
	  blur: function blur() {
	    this.input.blur();
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var ref = function ref(r) {
	      return _this.input = r;
	    };
	    var maxLength = this.mask.pattern.length;
	    var value = this._getDisplayValue();
	    var eventHandlers = this._getEventHandlers();
	    var _props = this.props;
	    var _props$size = _props.size;
	    var size = _props$size === undefined ? maxLength : _props$size;
	    var _props$placeholder = _props.placeholder;
	    var placeholder = _props$placeholder === undefined ? this.mask.emptyValue : _props$placeholder;
	    var _props2 = this.props;
	    var placeholderChar = _props2.placeholderChar;
	    var formatCharacters = _props2.formatCharacters;
	
	    var cleanedProps = _objectWithoutProperties(_props2, ['placeholderChar', 'formatCharacters']);
	
	    var inputProps = _extends({}, cleanedProps, eventHandlers, { ref: ref, maxLength: maxLength, value: value, size: size, placeholder: placeholder });
	    return React.createElement('input', inputProps);
	  }
	});
	
	module.exports = MaskedInput;

/***/ },
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatHeaderActions = function (_React$Component) {
	  _inherits(ChatHeaderActions, _React$Component);
	
	  function ChatHeaderActions(props) {
	    _classCallCheck(this, ChatHeaderActions);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ChatHeaderActions).call(this, props));
	  }
	
	  _createClass(ChatHeaderActions, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "chat-header-actions" },
	        this.props.children
	      );
	    }
	  }]);
	
	  return ChatHeaderActions;
	}(_react2.default.Component);
	
	exports.default = ChatHeaderActions;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _chat_list_recent_segment = __webpack_require__(911);
	
	var _chat_list_recent_segment2 = _interopRequireDefault(_chat_list_recent_segment);
	
	var _chat_list_admin_segment = __webpack_require__(906);
	
	var _chat_list_admin_segment2 = _interopRequireDefault(_chat_list_admin_segment);
	
	var _chat_list_author_segment = __webpack_require__(907);
	
	var _chat_list_author_segment2 = _interopRequireDefault(_chat_list_author_segment);
	
	var _chat_list_expert_segment = __webpack_require__(908);
	
	var _chat_list_expert_segment2 = _interopRequireDefault(_chat_list_expert_segment);
	
	var _chat_list_user_segment = __webpack_require__(912);
	
	var _chat_list_user_segment2 = _interopRequireDefault(_chat_list_user_segment);
	
	var _chat_list_group_chat_segment = __webpack_require__(909);
	
	var _chat_list_group_chat_segment2 = _interopRequireDefault(_chat_list_group_chat_segment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatList = function (_React$Component) {
	  _inherits(ChatList, _React$Component);
	
	  function ChatList(props) {
	    _classCallCheck(this, ChatList);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatList).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ChatList, [{
	    key: 'getSortedSegmentKeys',
	    value: function getSortedSegmentKeys(segments) {
	      return Object.keys(segments).sort(function (a, b) {
	        return segments[a].order - segments[b].order;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var segments = this.props.segments;
	      var segmentUIs = {
	        recents: _react2.default.createElement(_chat_list_recent_segment2.default, { key: 'recents' }),
	        groups: _react2.default.createElement(_chat_list_group_chat_segment2.default, { key: 'groups' }),
	        admins: _react2.default.createElement(_chat_list_admin_segment2.default, { key: 'admins' }),
	        writers: _react2.default.createElement(_chat_list_author_segment2.default, { key: 'writers' }),
	        experts: _react2.default.createElement(_chat_list_expert_segment2.default, { key: 'experts' }),
	        users: _react2.default.createElement(_chat_list_user_segment2.default, { key: 'users' })
	      };
	
	      var sortedSegmentKeys = this.getSortedSegmentKeys(segments);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'chat-list ' + this.props.className, style: { backgroundColor: this.props.background } },
	        _react2.default.createElement(
	          'div',
	          { style: { width: '100%', height: '100%', overflowX: 'hidden', overflowY: 'auto' } },
	          sortedSegmentKeys.map(function (key) {
	            return segmentUIs[key];
	          })
	        )
	      );
	    }
	  }]);
	
	  return ChatList;
	}(_react2.default.Component);
	
	ChatList.defaultProps = {};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    background: state.getIn(['chatSettings', 'colors', 'chatList', 'background']),
	    segments: state.getIn(['chatSettings', 'segments']).toJS()
	  };
	};
	
	var ChatListContainer = (0, _reactRedux.connect)(mapStateToProps)(ChatList);
	
	exports.default = ChatListContainer;

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _chat_ui_info = __webpack_require__(916);
	
	var _chat_ui_info2 = _interopRequireDefault(_chat_ui_info);
	
	var _unread_message_indicator = __webpack_require__(929);
	
	var _unread_message_indicator2 = _interopRequireDefault(_unread_message_indicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ChatHeaderActions from './chat_header_actions'
	// import CloseButton from './close_button'
	
	
	var ChatListHeader = function (_React$Component) {
	  _inherits(ChatListHeader, _React$Component);
	
	  function ChatListHeader(props) {
	    _classCallCheck(this, ChatListHeader);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatListHeader).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ChatListHeader, [{
	    key: 'renderUnreadMessageIndicator',
	    value: function renderUnreadMessageIndicator() {
	      if (!this.props.shouldShowUnreadMessageIndicator) return;
	
	      return _react2.default.createElement(_unread_message_indicator2.default, null);
	    }
	  }, {
	    key: 'renderMinimizeButton',
	    value: function renderMinimizeButton() {
	      if (!this.props.isMinimized && this.props.shouldShowMinimizeIndicator) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'minimize-button' },
	          _react2.default.createElement('i', { className: 'rc-icon-minimize' })
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'chat-list-header', onClick: this.props.onClick, style: { backgroundColor: this.props.headerBackground } },
	        _react2.default.createElement(_chat_ui_info2.default, null),
	        this.renderUnreadMessageIndicator(),
	        this.renderMinimizeButton()
	      );
	    }
	  }]);
	
	  return ChatListHeader;
	}(_react2.default.Component);
	
	ChatListHeader.defaultProps = {
	  shouldShowMinimizeIndicator: true
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    headerBackground: state.getIn(['chatSettings', 'colors', 'chatList', 'headerBackground'])
	  };
	};
	
	var ChatListHeaderContainer = (0, _reactRedux.connect)(mapStateToProps)(ChatListHeader);
	
	exports.default = ChatListHeaderContainer;

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CloseButton = function (_React$Component) {
	  _inherits(CloseButton, _React$Component);
	
	  function CloseButton(props) {
	    _classCallCheck(this, CloseButton);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(CloseButton).call(this, props));
	  }
	
	  _createClass(CloseButton, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "close-button", onClick: this.props.onClick },
	        _react2.default.createElement("i", { className: "rc-icon-close" })
	      );
	    }
	  }]);
	
	  return CloseButton;
	}(_react2.default.Component);
	
	exports.default = CloseButton;

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConversationSecondaryHeader = function ConversationSecondaryHeader(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'conversation-secondary-header',
	      style: { backgroundClolor: props.backgroundColor, height: props.height } },
	    _react2.default.createElement(
	      'div',
	      { className: 'conversation-secondary-header-wrapper' },
	      props.children
	    )
	  );
	};
	
	ConversationSecondaryHeader.defaultProps = {
	  height: 62
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    backgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'secondaryHeaderBackground'])
	  };
	};
	
	var ConversationSecondaryHeaderContainer = (0, _reactRedux.connect)(mapStateToProps)(ConversationSecondaryHeader);
	
	exports.default = ConversationSecondaryHeaderContainer;

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _truncate_string = __webpack_require__(77);
	
	var _truncate_string2 = _interopRequireDefault(_truncate_string);
	
	var _close_conversation = __webpack_require__(832);
	
	var _close_conversation2 = _interopRequireDefault(_close_conversation);
	
	var _update_conversation_status = __webpack_require__(836);
	
	var _update_conversation_status2 = _interopRequireDefault(_update_conversation_status);
	
	var _toggle_ignored_user = __webpack_require__(1026);
	
	var _toggle_ignored_user2 = _interopRequireDefault(_toggle_ignored_user);
	
	var _chat_header_actions = __webpack_require__(814);
	
	var _chat_header_actions2 = _interopRequireDefault(_chat_header_actions);
	
	var _close_button = __webpack_require__(817);
	
	var _close_button2 = _interopRequireDefault(_close_button);
	
	var _presence_indicator = __webpack_require__(79);
	
	var _presence_indicator2 = _interopRequireDefault(_presence_indicator);
	
	var _sliding_menu = __webpack_require__(534);
	
	var _sliding_menu2 = _interopRequireDefault(_sliding_menu);
	
	var _conversation_menu_report_item = __webpack_require__(921);
	
	var _conversation_menu_report_item2 = _interopRequireDefault(_conversation_menu_report_item);
	
	var _unread_message_count = __webpack_require__(639);
	
	var _unread_message_count2 = _interopRequireDefault(_unread_message_count);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ADMIN = _constants.ROLES.ADMIN;
	
	var ConversationUserHeader = function (_React$Component) {
	  _inherits(ConversationUserHeader, _React$Component);
	
	  function ConversationUserHeader(props) {
	    _classCallCheck(this, ConversationUserHeader);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConversationUserHeader).call(this, props));
	
	    _this.state = {
	      userIgnored: false
	    };
	
	    _this.toggleMenu = _this.toggleMenu.bind(_this);
	    _this.toggleHide = _this.toggleHide.bind(_this);
	    _this.toggleIgnore = _this.toggleIgnore.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(ConversationUserHeader, [{
	    key: 'toggleMenu',
	    value: function toggleMenu(e) {
	      e.stopPropagation();
	
	      this.setState({ isSettingsMenuOpen: !this.state.isSettingsMenuOpen });
	    }
	  }, {
	    key: 'toggleIgnore',
	    value: function toggleIgnore(e) {
	      e.stopPropagation();
	
	      this.props.toggleIgnoredUser(this.props.currentUser.get('uid'), this.props.user.get('uid'), !this.props.isUserIgnored);
	    }
	  }, {
	    key: 'closeConversation',
	    value: function closeConversation() {
	      var uid = this.props.currentUserUid || this.props.currentGuestUid;
	      var conversationId = this.props.conversation.get('conversationId');
	
	      this.props.closeConversation(uid, conversationId, this.props.viewportType);
	    }
	  }, {
	    key: 'toggleConversationHidden',
	    value: function toggleConversationHidden() {
	      var uid = this.props.currentUserUid || this.props.currentGuestUid;
	      var conversationId = this.props.conversation.get('conversationId');
	
	      var OPEN = _constants.CONVERSATION_PANE_STATUSES.OPEN;
	      var MINIMIZED = _constants.CONVERSATION_PANE_STATUSES.MINIMIZED;
	
	      var status = this.props.conversation.get('status');
	      status = status === OPEN ? MINIMIZED : OPEN;
	
	      this.props.updateConversationStatus(uid, conversationId, status, this.props.viewportType);
	    }
	  }, {
	    key: 'toggleHide',
	    value: function toggleHide(e) {
	      if (e & e.preventDefault) e.preventDefault();
	
	      if (this.props.viewportType === _constants.VIEWPORT_TYPES.PHONE) this.closeConversation();else this.toggleConversationHidden();
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose(e) {
	      if (e && e.stopPropagation) e.stopPropagation();
	
	      this.closeConversation();
	    }
	  }, {
	    key: 'renderUnreadMessageCount',
	    value: function renderUnreadMessageCount() {
	      return _react2.default.createElement(_unread_message_count2.default, {
	        uid: this.props.currentUserUid,
	        shouldShowUnreadMessageCount: this.props.shouldShowUnreadMessageCount,
	        conversationId: this.props.conversation.get('conversationId') });
	    }
	  }, {
	    key: 'renderIgnore',
	    value: function renderIgnore() {
	      var ignoreUser = _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('i', { className: 'menu-item-icon rc-icon-ignore' }),
	        'Ignore user'
	      );
	
	      if (this.props.isUserIgnored) {
	        ignoreUser = _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('i', { className: 'menu-item-icon rc-icon-confirm' }),
	          'Unignore user'
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sliding-menu-item ignore-user', onClick: this.toggleIgnore },
	        ignoreUser
	      );
	    }
	  }, {
	    key: 'renderReport',
	    value: function renderReport() {
	      return _react2.default.createElement(_conversation_menu_report_item2.default, {
	        reportee: this.props.user,
	        onReportClicked: this.toggleMenu });
	    }
	  }, {
	    key: 'renderSlidingMenu',
	    value: function renderSlidingMenu() {
	      if (this.props.user && this.props.user.get('role') >= ADMIN) return false;
	
	      if (this.props.currentUser) {
	        var slidingMenuClasses = 'conversation-menu';
	        var isVisible = true;
	
	        if (!this.state.isSettingsMenuOpen) {
	          slidingMenuClasses += ' hidden';
	          isVisible = false;
	        }
	
	        return _react2.default.createElement(
	          _sliding_menu2.default,
	          { className: slidingMenuClasses, top: 42, isVisible: isVisible },
	          this.renderIgnore(),
	          this.renderReport()
	        );
	      }
	    }
	  }, {
	    key: 'renderSettingsButton',
	    value: function renderSettingsButton() {
	      if (this.props.user && this.props.user.get('role') >= ADMIN) return false;
	
	      if (this.props.currentUser && !this.props.currentUser.get('isBanned')) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'conversation-settings-button', onClick: this.toggleMenu },
	          _react2.default.createElement('i', { className: 'rc-icon-settings' })
	        );
	      }
	    }
	  }, {
	    key: 'renderUserName',
	    value: function renderUserName() {
	      return _react2.default.createElement(
	        'a',
	        { href: this.props.user.get('profileUrl'), target: '_blank', onClick: function onClick(e) {
	            return e.stopPropagation();
	          } },
	        (0, _truncate_string2.default)(this.props.user.get('name'))
	      );
	    }
	  }, {
	    key: 'renderChatTitle',
	    value: function renderChatTitle() {
	      if (!this.props.user) return _react2.default.createElement('div', { className: 'chat-title' });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'chat-title' },
	        this.renderUserName(),
	        _react2.default.createElement(_presence_indicator2.default, { user: this.props.user.toJS() }),
	        this.renderUnreadMessageCount()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'conversationHeader',
	          className: 'conversation-header',
	          style: { backgroundColor: this.props.backgroundColor },
	          onClick: this.toggleHide },
	        _react2.default.createElement(
	          'div',
	          { className: 'conversation-info' },
	          this.renderChatTitle()
	        ),
	        _react2.default.createElement(
	          _chat_header_actions2.default,
	          null,
	          this.renderSettingsButton(),
	          _react2.default.createElement(_close_button2.default, { onClick: this.onClose })
	        ),
	        this.renderSlidingMenu()
	      );
	    }
	  }]);
	
	  return ConversationUserHeader;
	}(_react2.default.Component);
	
	ConversationUserHeader.defaultProps = {
	  isHidden: false,
	  unreadNotificationsCount: 0,
	  shouldShowUnreadMessageCount: false
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    currentUser: state.get('currentUser'),
	    currentUserUid: state.getIn(['currentUser', 'uid']),
	    currentGuestUid: state.getIn(['currentGuest', 'uid']),
	    user: state.getIn(['users', ownProps.conversation.get('targetId')]),
	    viewportType: state.getIn(['viewport', 'type']),
	    isUserIgnored: state.getIn(['currentUser', 'ignored', ownProps.conversation.get('targetId')]),
	    backgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'headerBackground'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    closeConversation: _close_conversation2.default,
	    updateConversationStatus: _update_conversation_status2.default,
	    toggleIgnoredUser: _toggle_ignored_user2.default
	  };
	};
	
	var ConversationUserHeaderContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConversationUserHeader);
	
	exports.default = ConversationUserHeaderContainer;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _conversation_director = __webpack_require__(918);
	
	var _conversation_director2 = _interopRequireDefault(_conversation_director);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConversationsStack = function (_React$Component) {
	  _inherits(ConversationsStack, _React$Component);
	
	  function ConversationsStack(props) {
	    _classCallCheck(this, ConversationsStack);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConversationsStack).call(this, props));
	
	    _this.state = {
	      stack: (0, _immutable.fromJS)([])
	    };
	    return _this;
	  }
	
	  _createClass(ConversationsStack, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setStack(this.props.stack);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.stack !== nextProps.stack) {
	        this.setStack(nextProps.stack);
	      }
	    }
	  }, {
	    key: 'setStack',
	    value: function setStack(stack) {
	      this.setState({ stack: stack });
	    }
	  }, {
	    key: 'renderConversation',
	    value: function renderConversation(conv, index) {
	      return _react2.default.createElement(_conversation_director2.default, {
	        key: conv.get('conversationId'),
	        index: index,
	        conversation: conv });
	    }
	  }, {
	    key: 'renderConversationStack',
	    value: function renderConversationStack() {
	      return this.state.stack.map(this.renderConversation);
	    }
	  }, {
	    key: 'renderConversationStackForPhone',
	    value: function renderConversationStackForPhone() {
	      var conv = this.state.stack.find(function (c) {
	        return c.get('status') === _constants.CONVERSATION_PANE_STATUSES.OPEN;
	      });
	
	      if (!conv) return false;
	
	      return this.renderConversation(conv, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.phoneView) return this.renderConversationStackForPhone();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'conversations-stack' },
	        this.renderConversationStack()
	      );
	    }
	  }]);
	
	  return ConversationsStack;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    stack: state.getIn(['conversations', '_stack', 'visibles'], (0, _immutable.List)())
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	var ConversationsStackContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConversationsStack);
	
	exports.default = ConversationsStackContainer;

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoToSessionButton = function (_React$Component) {
	  _inherits(GoToSessionButton, _React$Component);
	
	  function GoToSessionButton() {
	    _classCallCheck(this, GoToSessionButton);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(GoToSessionButton).apply(this, arguments));
	  }
	
	  _createClass(GoToSessionButton, [{
	    key: 'sessionUrl',
	    value: function sessionUrl() {
	      return this.props.sessionsUrl + '?sessionId=' + this.props.sessionId;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'a',
	        { href: this.sessionUrl(), target: '_blank', className: this.props.classNames },
	        'Go to your session'
	      );
	    }
	  }]);
	
	  return GoToSessionButton;
	}(_react2.default.Component);
	
	GoToSessionButton.defaultProps = {
	  classNames: 'button success'
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    sessionsUrl: state.getIn(['pluginSettings', 'sessionsUrl'])
	  };
	};
	
	var GoToSessionButtonContainer = (0, _reactRedux.connect)(mapStateToProps)(GoToSessionButton);
	
	exports.default = GoToSessionButtonContainer;

/***/ },
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _conversation_stack = __webpack_require__(241);
	
	var _conversation_stack2 = _interopRequireDefault(_conversation_stack);
	
	var _conversation_stack3 = __webpack_require__(238);
	
	var _conversation_stack4 = _interopRequireDefault(_conversation_stack3);
	
	var _remove_conversation_from_stack = __webpack_require__(1008);
	
	var _remove_conversation_from_stack2 = _interopRequireDefault(_remove_conversation_from_stack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var updateConversationStack = function updateConversationStack(currentUserUid, viewportType, conversationId) {
	  return (0, _conversation_stack4.default)(currentUserUid).then(_remove_conversation_from_stack2.default.bind(null, conversationId)).then(_conversation_stack2.default.bind(null, currentUserUid, viewportType));
	};
	
	exports.default = function (currentUserUid, conversationId, viewportType) {
	  return updateConversationStack(currentUserUid, viewportType, conversationId);
	};

/***/ },
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _conversation_stack = __webpack_require__(241);
	
	var _conversation_stack2 = _interopRequireDefault(_conversation_stack);
	
	var _conversation_stack3 = __webpack_require__(238);
	
	var _conversation_stack4 = _interopRequireDefault(_conversation_stack3);
	
	var _update_conversation_status_at_stack = __webpack_require__(1010);
	
	var _update_conversation_status_at_stack2 = _interopRequireDefault(_update_conversation_status_at_stack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var updateConversationStack = function updateConversationStack(currentUserUid, conversationId, status, viewportType) {
	  return (0, _conversation_stack4.default)(currentUserUid).then(_update_conversation_status_at_stack2.default.bind(null, conversationId, status)).then(_conversation_stack2.default.bind(null, currentUserUid, viewportType));
	};
	
	exports.default = function (currentUserUid, conversationId, status, viewportType) {
	  return updateConversationStack(currentUserUid, conversationId, status, viewportType);
	};

/***/ },
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _chat_list_segment = __webpack_require__(444);
	
	var _chat_list_segment2 = _interopRequireDefault(_chat_list_segment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatListAdminSegment = function (_React$Component) {
	  _inherits(ChatListAdminSegment, _React$Component);
	
	  function ChatListAdminSegment(props) {
	    _classCallCheck(this, ChatListAdminSegment);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatListAdminSegment).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ChatListAdminSegment, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props;
	      var admins = _props.admins;
	      var count = _props.count;
	
	      if (admins || count) {
	        this.setAdmins(admins, count);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props2 = this.props;
	      var admins = _props2.admins;
	      var count = _props2.count;
	      var nextAdmins = nextProps.admins;
	      var nextCount = nextProps.count;
	
	
	      if (admins !== nextAdmins || count !== nextCount) {
	        this.setAdmins(nextAdmins, nextCount);
	      }
	    }
	  }, {
	    key: 'setAdmins',
	    value: function setAdmins(admins, count) {
	      admins = admins.sortBy(function (a) {
	        return (a.get('name') || '').toLowerCase();
	      }).sortBy(function (a) {
	        return -1 * a.get('presence');
	      }).take(parseInt(count, 10));
	
	      this.setState({ admins: admins });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_chat_list_segment2.default, {
	        label: this.props.title,
	        emptyMessage: 'There are no online admins at the moment.',
	        conversationType: _constants.CONVERSATION_TYPES.NORMAL,
	        shouldShowUnreadMessageCount: false,
	        list: this.state.admins });
	    }
	  }]);
	
	  return ChatListAdminSegment;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    title: state.getIn(['chatSettings', 'segments', 'admins', 'title']),
	    count: state.getIn(['chatSettings', 'segments', 'admins', 'numberOfUsers']),
	    admins: state.getIn(['chatListView', 'segments', 'admins'], (0, _immutable.List)())
	  };
	};
	
	var ChatListAdminSegmentContainer = (0, _reactRedux.connect)(mapStateToProps)(ChatListAdminSegment);
	
	exports.default = ChatListAdminSegmentContainer;

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _chat_list_segment = __webpack_require__(444);
	
	var _chat_list_segment2 = _interopRequireDefault(_chat_list_segment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatListAuthorSegment = function (_React$Component) {
	  _inherits(ChatListAuthorSegment, _React$Component);
	
	  function ChatListAuthorSegment(props) {
	    _classCallCheck(this, ChatListAuthorSegment);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatListAuthorSegment).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ChatListAuthorSegment, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props;
	      var authors = _props.authors;
	      var count = _props.count;
	
	
	      if (authors || count) {
	        this.setAuthors(authors, count);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props2 = this.props;
	      var authors = _props2.authors;
	      var count = _props2.count;
	      var nextAuthors = nextProps.authors;
	      var nextCount = nextProps.count;
	
	
	      if (authors !== nextAuthors || count !== nextCount) {
	        this.setAuthors(nextAuthors, nextCount);
	      }
	    }
	  }, {
	    key: 'setAuthors',
	    value: function setAuthors(authors, count) {
	      authors = authors.sortBy(function (a) {
	        return (a.get('name') || '').toLowerCase();
	      }).sortBy(function (a) {
	        return -1 * a.get('presence');
	      }).take(parseInt(count, 10));
	
	      this.setState({ authors: authors });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_chat_list_segment2.default, {
	        label: this.props.title,
	        emptyMessage: 'There are no online writers at the moment.',
	        conversationType: _constants.CONVERSATION_TYPES.NORMAL,
	        shouldShowUnreadMessageCount: false,
	        list: this.state.authors });
	    }
	  }]);
	
	  return ChatListAuthorSegment;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    title: state.getIn(['chatSettings', 'segments', 'writers', 'title']),
	    count: state.getIn(['chatSettings', 'segments', 'writers', 'numberOfUsers']),
	    authors: state.getIn(['chatListView', 'segments', 'authors'], (0, _immutable.List)())
	  };
	};
	
	var ChatListAuthorSegmentContainer = (0, _reactRedux.connect)(mapStateToProps)(ChatListAuthorSegment);
	
	exports.default = ChatListAuthorSegmentContainer;

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _chat_list_segment = __webpack_require__(444);
	
	var _chat_list_segment2 = _interopRequireDefault(_chat_list_segment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatListExpertSegment = function (_React$Component) {
	  _inherits(ChatListExpertSegment, _React$Component);
	
	  function ChatListExpertSegment(props) {
	    _classCallCheck(this, ChatListExpertSegment);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatListExpertSegment).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ChatListExpertSegment, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props;
	      var experts = _props.experts;
	      var count = _props.count;
	
	
	      if (experts || count) {
	        this.setExperts(experts, count);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props2 = this.props;
	      var experts = _props2.experts;
	      var count = _props2.count;
	      var nextExperts = nextProps.experts;
	      var nextCount = nextProps.count;
	
	
	      if (experts !== nextExperts || count !== nextCount) {
	        this.setExperts(nextExperts, nextCount);
	      }
	    }
	  }, {
	    key: 'setExperts',
	    value: function setExperts(experts, count) {
	      experts = experts.map(function (e) {
	        return e.get('lastAvailableTimeUpdate') ? e : e.set('lastAvailableTimeUpdate', 0);
	      }).sortBy(function (e) {
	        return (e.get('name') || '').toLowerCase();
	      }).sortBy(function (e) {
	        return -1 * e.get('lastAvailableTimeUpdate');
	      }).sortBy(function (e) {
	        return -1 * e.get('presence');
	      }).take(parseInt(count, 10));
	
	      this.setState({ experts: experts });
	    }
	  }, {
	    key: 'renderExpertFooter',
	    value: function renderExpertFooter() {
	      return _react2.default.createElement(
	        'a',
	        { className: 'chat-list-footer-action', href: this.props.expertsUrl, target: '_blank' },
	        'SEE ALL EXPERTS'
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_chat_list_segment2.default, {
	        label: this.props.title,
	        emptyMessage: 'There are no online experts at the moment.',
	        footer: this.renderExpertFooter(),
	        conversationType: _constants.CONVERSATION_TYPES.EXPERT,
	        shouldShowUnreadMessageCount: false,
	        list: this.state.experts });
	    }
	  }]);
	
	  return ChatListExpertSegment;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    title: state.getIn(['chatSettings', 'segments', 'experts', 'title']),
	    count: state.getIn(['chatSettings', 'segments', 'experts', 'numberOfUsers']),
	    experts: state.getIn(['chatListView', 'segments', 'experts'], (0, _immutable.List)()),
	    expertsUrl: state.getIn(['pluginSettings', 'expertsUrl'], '#')
	  };
	};
	
	var ChatListExpertSegmentContainer = (0, _reactRedux.connect)(mapStateToProps)(ChatListExpertSegment);
	
	exports.default = ChatListExpertSegmentContainer;

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _show_modal = __webpack_require__(16);
	
	var _show_modal2 = _interopRequireDefault(_show_modal);
	
	var _group_chats_see_all_link = __webpack_require__(696);
	
	var _group_chats_see_all_link2 = _interopRequireDefault(_group_chats_see_all_link);
	
	var _chat_list_segment = __webpack_require__(444);
	
	var _chat_list_segment2 = _interopRequireDefault(_chat_list_segment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatListGroupChatSegment = function (_React$Component) {
	  _inherits(ChatListGroupChatSegment, _React$Component);
	
	  function ChatListGroupChatSegment(props) {
	    _classCallCheck(this, ChatListGroupChatSegment);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatListGroupChatSegment).call(this, props));
	
	    _this.state = {};
	
	    _this.onGroupChatFooterClick = _this.onGroupChatFooterClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChatListGroupChatSegment, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setGroupChats(this.props.globalGroupChats, this.props.bookmarkedGroupChats);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props;
	      var globals = _props.globalGroupChats;
	      var bookmarkeds = _props.bookmarkedGroupChats;
	      var nextGlobals = nextProps.globalGroupChats;
	      var nextBookmarkeds = nextProps.bookmarkedGroupChats;
	
	
	      if (globals !== nextGlobals || bookmarkeds !== nextBookmarkeds) {
	        this.setGroupChats(nextGlobals, nextBookmarkeds);
	      }
	    }
	  }, {
	    key: 'setGroupChats',
	    value: function setGroupChats(globals, bookmarkeds) {
	      var groupChats = globals.concat(bookmarkeds);
	
	      this.setState({ groupChats: groupChats });
	    }
	  }, {
	    key: 'onGroupChatFooterClick',
	    value: function onGroupChatFooterClick(e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      this.props.showModal({ type: 'groupChats', props: {} });
	    }
	  }, {
	    key: 'renderGroupFooter',
	    value: function renderGroupFooter() {
	      return _react2.default.createElement(
	        _group_chats_see_all_link2.default,
	        { classes: 'chat-list-footer-action' },
	        'SEE ALL CHAT ROOMS'
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_chat_list_segment2.default, {
	        label: this.props.title,
	        footer: this.renderGroupFooter(),
	        conversationType: _constants.CONVERSATION_TYPES.GROUP,
	        shouldShowUnreadMessageCount: true,
	        list: this.state.groupChats });
	    }
	  }]);
	
	  return ChatListGroupChatSegment;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    title: state.getIn(['chatSettings', 'segments', 'groups', 'title']),
	    globalGroupChats: state.getIn(['chatListView', 'segments', 'groups', 'list'], (0, _immutable.List)()),
	    bookmarkedGroupChats: state.getIn(['groups', '_bookmarks', 'list'], (0, _immutable.List)())
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    showModal: function showModal(modal) {
	      return dispatch((0, _show_modal2.default)(modal));
	    }
	  };
	};
	
	var ChatListGroupChatSegmentContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatListGroupChatSegment);
	
	exports.default = ChatListGroupChatSegmentContainer;

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _truncate_string = __webpack_require__(77);
	
	var _truncate_string2 = _interopRequireDefault(_truncate_string);
	
	var _open_conversation = __webpack_require__(271);
	
	var _open_conversation2 = _interopRequireDefault(_open_conversation);
	
	var _predict_conversation_type = __webpack_require__(1007);
	
	var _predict_conversation_type2 = _interopRequireDefault(_predict_conversation_type);
	
	var _profile_image = __webpack_require__(45);
	
	var _profile_image2 = _interopRequireDefault(_profile_image);
	
	var _user_item_info = __webpack_require__(341);
	
	var _user_item_info2 = _interopRequireDefault(_user_item_info);
	
	var _unread_message_count = __webpack_require__(639);
	
	var _unread_message_count2 = _interopRequireDefault(_unread_message_count);
	
	var _group_chat_avatar = __webpack_require__(244);
	
	var _group_chat_avatar2 = _interopRequireDefault(_group_chat_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatListItem = function (_React$Component) {
	  _inherits(ChatListItem, _React$Component);
	
	  function ChatListItem(props) {
	    _classCallCheck(this, ChatListItem);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatListItem).call(this, props));
	
	    _this.state = {};
	
	    _this.openConversation = _this.openConversation.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChatListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.conversationType && this.props.item) {
	        this.setConversationType(this.props.conversationType, this.props.item);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.conversationType !== nextProps.conversationType && nextProps.item) {
	        this.setConversationType(nextProps.conversationType, nextProps.item);
	      }
	    }
	  }, {
	    key: 'isConversationVisible',
	    value: function isConversationVisible(conversationId) {
	      var index = this.props.visibleConversations.findIndex(function (conv) {
	        return conv.get('conversationId') === conversationId;
	      });
	
	      return index >= 0 ? true : false;
	    }
	  }, {
	    key: 'setConversationType',
	    value: function setConversationType(conversationType) {
	      if (conversationType === _constants.CONVERSATION_TYPES.MIXED) conversationType = (0, _predict_conversation_type2.default)(this.props.item);
	
	      this.setState({ conversationType: conversationType });
	    }
	  }, {
	    key: 'openConversation',
	    value: function openConversation() {
	      var uid = this.props.currentUserUid || this.props.currentGuestUid;
	      if (uid && this.props.id && this.state.conversationType !== _constants.CONVERSATION_TYPES.GUEST) {
	        this.props.openConversation(uid, this.props.id, this.props.conversationId, this.state.conversationType, this.props.viewportType);
	      }
	    }
	  }, {
	    key: 'renderUnreadMessageCount',
	    value: function renderUnreadMessageCount(uid, conversationId) {
	      var isConvVisible = this.isConversationVisible(conversationId);
	      var shouldShow = uid && conversationId && this.props.shouldShowUnreadMessageCount && !isConvVisible;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_unread_message_count2.default, {
	          uid: uid,
	          conversationId: conversationId,
	          shouldShowUnreadMessageCount: shouldShow })
	      );
	    }
	  }, {
	    key: 'renderUserItem',
	    value: function renderUserItem(item) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'chat-list-item-wrapper' },
	        _react2.default.createElement(_profile_image2.default, { user: item.toJS(), image: this.props.item.get('profileImage'), hasIndicator: this.props.hasIndicator }),
	        _react2.default.createElement(_user_item_info2.default, { user: item.toJS(), className: 'primary', usernameColor: this.props.usernameColor, ratingEnabled: false, sessionsCountEnabled: false, truncateTo: 100, shouldFixLineClamp: true }),
	        this.renderUnreadMessageCount(this.props.currentUserUid, this.props.conversationId)
	      );
	    }
	  }, {
	    key: 'renderExpertItem',
	    value: function renderExpertItem(item) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'chat-list-item-wrapper' },
	        _react2.default.createElement(_profile_image2.default, { user: item.toJS(), image: this.props.item.get('profileImage'), hasIndicator: this.props.hasIndicator }),
	        _react2.default.createElement(_user_item_info2.default, { user: item.toJS(), className: 'primary', usernameColor: this.props.usernameColor, ratingEnabled: this.props.shouldForceHideRatings ? false : true, sessionsCountEnabled: false, truncateTo: 100, shouldFixLineClamp: true }),
	        this.renderUnreadMessageCount(this.props.currentUserUid, this.props.conversationId)
	      );
	    }
	  }, {
	    key: 'renderGroupItem',
	    value: function renderGroupItem(item) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'chat-list-item-wrapper' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_group_chat_avatar2.default, { size: 48, initials: item.get('initials'), groupId: item.get('key') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'primary group-chat-name', style: { color: '#212121' } },
	          _react2.default.createElement(
	            'h4',
	            { className: 'one-line-text', style: { color: this.props.usernameColor, whiteSpace: 'initial' } },
	            (0, _truncate_string2.default)(item.get('name'), 100)
	          )
	        ),
	        this.renderUnreadMessageCount(this.props.currentUserUid, item.get('key'))
	      );
	    }
	  }, {
	    key: 'renderGuestItem',
	    value: function renderGuestItem(item) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'chat-list-item-wrapper' },
	        _react2.default.createElement(_profile_image2.default, { user: item.toJS(), hasIndicator: false }),
	        _react2.default.createElement(_user_item_info2.default, { user: item.toJS(), className: 'primary', usernameColor: this.props.usernameColor, ratingEnabled: false, sessionsCountEnabled: false })
	      );
	    }
	  }, {
	    key: 'renderInnerContent',
	    value: function renderInnerContent() {
	      if (this.props.item) {
	        var type = this.state.conversationType;
	
	
	        if (type === _constants.CONVERSATION_TYPES.NORMAL) return this.renderUserItem(this.props.item);
	        if (type === _constants.CONVERSATION_TYPES.EXPERT) return this.renderExpertItem(this.props.item);
	        if (type === _constants.CONVERSATION_TYPES.GROUP) return this.renderGroupItem(this.props.item);
	        if (type === _constants.CONVERSATION_TYPES.GUEST) return this.renderGuestItem(this.props.item);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'chat-list-item',
	          style: { backgroundColor: this.state.isItemHovered ? this.props.itemHoverColor : this.props.background },
	          onClick: this.openConversation,
	          onMouseEnter: function onMouseEnter() {
	            return _this2.setState({ isItemHovered: true });
	          },
	          onTouchStart: function onTouchStart() {
	            return _this2.setState({ isItemHovered: true });
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this2.setState({ isItemHovered: false });
	          },
	          onTouchEnd: function onTouchEnd() {
	            return _this2.setState({ isItemHovered: false });
	          } },
	        this.renderInnerContent()
	      );
	    }
	  }]);
	
	  return ChatListItem;
	}(_react2.default.Component);
	
	ChatListItem.defaultProps = {
	  shouldShowUnreadMessageCount: false
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    conversationId: state.getIn(['conversations', '_refs', ownProps.id, 'conversationId']),
	    currentUserUid: state.getIn(['currentUser', 'uid']),
	    currentGuestUid: state.getIn(['currentGuest', 'uid']),
	    visibleConversations: state.getIn(['conversations', '_stack', 'visibles'], (0, _immutable.fromJS)([])),
	    usernameColor: state.getIn(['chatSettings', 'colors', 'chatList', 'username']),
	    itemHoverColor: state.getIn(['chatSettings', 'colors', 'chatList', 'itemHoverColor']),
	    background: state.getIn(['chatSettings', 'colors', 'chatList', 'background']),
	    viewportType: state.getIn(['viewport', 'type'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    openConversation: _open_conversation2.default
	  };
	};
	
	var ChatListItemContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatListItem);
	
	exports.default = ChatListItemContainer;

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _chat_list_segment = __webpack_require__(444);
	
	var _chat_list_segment2 = _interopRequireDefault(_chat_list_segment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatListRecentSegment = function (_React$Component) {
	  _inherits(ChatListRecentSegment, _React$Component);
	
	  function ChatListRecentSegment(props) {
	    _classCallCheck(this, ChatListRecentSegment);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatListRecentSegment).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ChatListRecentSegment, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_chat_list_segment2.default, {
	        label: this.props.title,
	        emptyMessage: 'There are no users in your recents list.',
	        conversationType: _constants.CONVERSATION_TYPES.MIXED,
	        shouldShowUnreadMessageCount: true,
	        shouldForceHideRatings: true,
	        list: this.props.recents });
	    }
	  }]);
	
	  return ChatListRecentSegment;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    title: state.getIn(['chatSettings', 'segments', 'recents', 'title']),
	    recents: state.getIn(['chatListView', 'segments', 'recents', 'segment'], (0, _immutable.List)())
	  };
	};
	
	var ChatListRecentSegmentContainer = (0, _reactRedux.connect)(mapStateToProps)(ChatListRecentSegment);
	
	exports.default = ChatListRecentSegmentContainer;

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _constants = __webpack_require__(2);
	
	var _chat_list_segment = __webpack_require__(444);
	
	var _chat_list_segment2 = _interopRequireDefault(_chat_list_segment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatListUserSegment = function (_React$Component) {
	  _inherits(ChatListUserSegment, _React$Component);
	
	  function ChatListUserSegment(props) {
	    _classCallCheck(this, ChatListUserSegment);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatListUserSegment).call(this, props));
	
	    _this.state = {
	      page: 1
	    };
	
	    _this.loadNextUserBatch = _this.loadNextUserBatch.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChatListUserSegment, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props;
	      var users = _props.users;
	      var guests = _props.guests;
	      var page = this.state.page;
	
	
	      if (users || guests) {
	        this.setVisibleUsers(users, guests, page);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextState) {
	      var _props2 = this.props;
	      var users = _props2.users;
	      var guests = _props2.guests;
	      var nextUsers = nextProps.users;
	      var nextGuests = nextProps.guests;
	      var page = this.state.page;
	      var nextPage = nextState.page;
	
	
	      if (users !== nextUsers || guests !== nextGuests || page !== nextPage) {
	        this.setVisibleUsers(nextUsers, nextGuests, nextPage);
	      }
	    }
	  }, {
	    key: 'setVisibleUsers',
	    value: function setVisibleUsers(users, guests) {
	      var page = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];
	
	      users = users.concat(guests).take(page * 20);
	
	      this.setState({ users: users });
	    }
	  }, {
	    key: 'loadNextUserBatch',
	    value: function loadNextUserBatch(e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      var page = this.state.page + 1;
	
	      this.setState({ page: page });
	      this.setVisibleUsers(this.props.users, this.props.guests, page);
	    }
	  }, {
	    key: 'renderUserFooter',
	    value: function renderUserFooter() {
	      var totalSize = this.props.users.size + this.props.guests.size;
	
	      if (totalSize > this.state.page * 20) {
	        return _react2.default.createElement(
	          'a',
	          {
	            href: '#',
	            className: 'chat-list-footer-action',
	            onClick: this.loadNextUserBatch },
	          'LOAD MORE USERS'
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_chat_list_segment2.default, {
	        label: this.props.title,
	        emptyMessage: 'There are no online users at the moment.',
	        footer: this.renderUserFooter(),
	        conversationType: _constants.CONVERSATION_TYPES.MIXED,
	        shouldShowUnreadMessageCount: false,
	        list: this.state.users });
	    }
	  }]);
	
	  return ChatListUserSegment;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    title: state.getIn(['chatSettings', 'segments', 'users', 'title']),
	    users: state.getIn(['chatListView', 'segments', 'users'], (0, _immutable.List)()),
	    guests: state.getIn(['chatListView', 'segments', 'guests'], (0, _immutable.List)())
	  };
	};
	
	var ChatListUserSegmentContainer = (0, _reactRedux.connect)(mapStateToProps)(ChatListUserSegment);
	
	exports.default = ChatListUserSegmentContainer;

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _chat_list_header = __webpack_require__(816);
	
	var _chat_list_header2 = _interopRequireDefault(_chat_list_header);
	
	var _chat_current_user_bar = __webpack_require__(599);
	
	var _chat_current_user_bar2 = _interopRequireDefault(_chat_current_user_bar);
	
	var _chat_list = __webpack_require__(815);
	
	var _chat_list2 = _interopRequireDefault(_chat_list);
	
	var _conversations_stack = __webpack_require__(820);
	
	var _conversations_stack2 = _interopRequireDefault(_conversations_stack);
	
	var _modal_director = __webpack_require__(245);
	
	var _modal_director2 = _interopRequireDefault(_modal_director);
	
	var _report_modal = __webpack_require__(615);
	
	var _report_modal2 = _interopRequireDefault(_report_modal);
	
	var _user_profile_modal = __webpack_require__(619);
	
	var _user_profile_modal2 = _interopRequireDefault(_user_profile_modal);
	
	var _session_initiate_modal = __webpack_require__(617);
	
	var _session_initiate_modal2 = _interopRequireDefault(_session_initiate_modal);
	
	var _session_request_modal = __webpack_require__(453);
	
	var _session_request_modal2 = _interopRequireDefault(_session_request_modal);
	
	var _group_chats_modal = __webpack_require__(613);
	
	var _group_chats_modal2 = _interopRequireDefault(_group_chats_modal);
	
	var _group_chat_subscription_modal = __webpack_require__(338);
	
	var _group_chat_subscription_modal2 = _interopRequireDefault(_group_chat_subscription_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatUIDesktop = function (_React$Component) {
	  _inherits(ChatUIDesktop, _React$Component);
	
	  function ChatUIDesktop(props) {
	    _classCallCheck(this, ChatUIDesktop);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatUIDesktop).call(this, props));
	
	    _this.state = {
	      toggled: true
	    };
	
	    _this.modalsList = {
	      report: _report_modal2.default,
	      userProfile: _user_profile_modal2.default,
	      sessionInitiate: _session_initiate_modal2.default,
	      sessionRequest: _session_request_modal2.default,
	      groupChats: _group_chats_modal2.default,
	      groupSubscribe: _group_chat_subscription_modal2.default
	    };
	    return _this;
	  }
	
	  _createClass(ChatUIDesktop, [{
	    key: 'renderConversationsStack',
	    value: function renderConversationsStack() {
	      return _react2.default.createElement(_conversations_stack2.default, this.props);
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({ toggled: !this.state.toggled });
	    }
	  }, {
	    key: 'renderChatList',
	    value: function renderChatList() {
	      var isMinimized = !this.state.toggled;
	
	      if (this.state.toggled) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'chat-list-desktop-container' },
	          _react2.default.createElement(_chat_list_header2.default, _extends({ onClick: this.toggle.bind(this) }, this.props, { isMinimized: isMinimized })),
	          _react2.default.createElement(_chat_current_user_bar2.default, null),
	          _react2.default.createElement(_chat_list2.default, _extends({ className: 'desktop' }, this.props))
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'chat-list-desktop-container minified' },
	          _react2.default.createElement(_chat_list_header2.default, _extends({ onClick: this.toggle.bind(this) }, this.props, { isMinimized: isMinimized }))
	        );
	      }
	    }
	  }, {
	    key: 'renderModalView',
	    value: function renderModalView() {
	      return _react2.default.createElement(_modal_director2.default, { modalsList: this.modalsList });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'chat-ui-desktop' },
	        this.renderConversationsStack(),
	        this.renderChatList(),
	        this.renderModalView()
	      );
	    }
	  }]);
	
	  return ChatUIDesktop;
	}(_react2.default.Component);
	
	exports.default = ChatUIDesktop;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _chat_ui = __webpack_require__(915);
	
	var _chat_ui2 = _interopRequireDefault(_chat_ui);
	
	var _chat_ui3 = __webpack_require__(913);
	
	var _chat_ui4 = _interopRequireDefault(_chat_ui3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatUI = function (_React$Component) {
	  _inherits(ChatUI, _React$Component);
	
	  function ChatUI(props) {
	    _classCallCheck(this, ChatUI);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatUI).call(this, props));
	
	    _this.state = {
	      toggled: false
	    };
	    return _this;
	  }
	
	  _createClass(ChatUI, [{
	    key: 'userIdleTimeout',
	    value: function userIdleTimeout() {
	      var timeout = 3 * 60 * 1000; // 3 minutes
	
	      if (this.props.chatSettings.idleStartMinutes) {
	        timeout = parseInt(this.props.chatSettings.idleStartMinutes, 10) * 60 * 1000;
	      }
	
	      return timeout;
	    }
	  }, {
	    key: 'renderUI',
	    value: function renderUI() {
	      if (this.props.viewportType === _constants.VIEWPORT_TYPES.DESKTOP) {
	        return _react2.default.createElement(_chat_ui4.default, this.props);
	      } else if (this.props.viewportType === _constants.VIEWPORT_TYPES.PHONE) {
	        return _react2.default.createElement(_chat_ui2.default, this.props);
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.chatSettings.chatStatus === _constants.CHAT_STATUS.ON) {
	        return this.renderUI();
	      } else {
	        return false;
	      }
	    }
	  }]);
	
	  return ChatUI;
	}(_react2.default.Component);
	
	ChatUI.defaultProps = {
	  chatSettings: {}
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var chatSettings = state.getIn(['chatSettings']),
	      currentUser = state.getIn(['currentUser']),
	      currentGuest = state.getIn(['currentGuest']);
	
	  return {
	    viewportType: state.getIn(['viewport', 'type']),
	    chatSettings: chatSettings.toObject(),
	    currentUser: currentUser ? currentUser.toObject() : null,
	    currentGuest: currentGuest ? currentGuest.toObject() : null
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {};
	};
	
	var ChatUIContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatUI);
	
	exports.default = ChatUIContainer;

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _unset_new_message_indicator_on_mobile = __webpack_require__(997);
	
	var _unset_new_message_indicator_on_mobile2 = _interopRequireDefault(_unset_new_message_indicator_on_mobile);
	
	var _set_chat_list_toggled = __webpack_require__(602);
	
	var _set_chat_list_toggled2 = _interopRequireDefault(_set_chat_list_toggled);
	
	var _chat_list_header = __webpack_require__(816);
	
	var _chat_list_header2 = _interopRequireDefault(_chat_list_header);
	
	var _chat_current_user_bar = __webpack_require__(599);
	
	var _chat_current_user_bar2 = _interopRequireDefault(_chat_current_user_bar);
	
	var _chat_list = __webpack_require__(815);
	
	var _chat_list2 = _interopRequireDefault(_chat_list);
	
	var _conversations_stack = __webpack_require__(820);
	
	var _conversations_stack2 = _interopRequireDefault(_conversations_stack);
	
	var _modal_director = __webpack_require__(245);
	
	var _modal_director2 = _interopRequireDefault(_modal_director);
	
	var _report_modal = __webpack_require__(615);
	
	var _report_modal2 = _interopRequireDefault(_report_modal);
	
	var _user_profile_modal = __webpack_require__(619);
	
	var _user_profile_modal2 = _interopRequireDefault(_user_profile_modal);
	
	var _session_initiate_modal = __webpack_require__(617);
	
	var _session_initiate_modal2 = _interopRequireDefault(_session_initiate_modal);
	
	var _session_request_modal = __webpack_require__(453);
	
	var _session_request_modal2 = _interopRequireDefault(_session_request_modal);
	
	var _group_chats_modal = __webpack_require__(613);
	
	var _group_chats_modal2 = _interopRequireDefault(_group_chats_modal);
	
	var _group_chat_subscription_modal = __webpack_require__(338);
	
	var _group_chat_subscription_modal2 = _interopRequireDefault(_group_chat_subscription_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatUIPhone = function (_React$Component) {
	  _inherits(ChatUIPhone, _React$Component);
	
	  function ChatUIPhone(props) {
	    _classCallCheck(this, ChatUIPhone);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatUIPhone).call(this, props));
	
	    _this.state = {};
	
	    _this.modalsList = {
	      report: _report_modal2.default,
	      userProfile: _user_profile_modal2.default,
	      sessionInitiate: _session_initiate_modal2.default,
	      sessionRequest: _session_request_modal2.default,
	      groupChats: _group_chats_modal2.default,
	      groupSubscribe: _group_chat_subscription_modal2.default
	    };
	
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChatUIPhone, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.isToggled) {
	        this.togglePageContent(true);
	        this.props.removeNewMessageMobileIndicator();
	      }
	
	      if (!this.props.isToggled) {
	        this.togglePageContent(false);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!prevProps.isToggled && this.props.isToggled) {
	        this.togglePageContent(true);
	        this.props.removeNewMessageMobileIndicator();
	      }
	
	      if (prevProps.isToggled && !this.props.isToggled) {
	        this.togglePageContent(false);
	      }
	    }
	  }, {
	    key: 'togglePageContent',
	    value: function togglePageContent(determiner) {
	      var displayStyle = determiner ? 'none' : '';
	      var el = document.querySelector(_constants.UI_SELECTOR);
	      var siblings = document.querySelectorAll('body > *');
	
	      if (siblings && siblings.length > 0) {
	        for (var i = 0; i < siblings.length; i++) {
	          if (siblings[i] != el && siblings[i].nodeType == 1) {
	            siblings[i].style.display = displayStyle;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      if (this.props.isMobilePage) return false;
	      var toggled = !this.props.isToggled;
	      this.props.setChatListToToggled(toggled);
	    }
	  }, {
	    key: 'renderInnerContent',
	    value: function renderInnerContent() {
	      if (this.props.isMobilePage) {
	        if (this.props.stack && this.props.stack.size > 0) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'chat-ui-phone-wrapper' },
	            _react2.default.createElement(_conversations_stack2.default, _extends({}, this.props, { phoneView: true }))
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { className: 'chat-ui-phone-wrapper' },
	            _react2.default.createElement(_chat_list_header2.default, _extends({}, this.props, { isMinimized: false, shouldShowMinimizeIndicator: false })),
	            _react2.default.createElement(_chat_current_user_bar2.default, null),
	            _react2.default.createElement(_chat_list2.default, this.props)
	          );
	        }
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'chat-ui-phone-wrapper minified' },
	          _react2.default.createElement(
	            'a',
	            { href: this.props.mobilePageUrl, target: '_blank' },
	            _react2.default.createElement(_chat_list_header2.default, _extends({
	              shouldShowUnreadMessageIndicator: false,
	              isMinimized: true
	            }, this.props))
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderModalView',
	    value: function renderModalView() {
	      return _react2.default.createElement(_modal_director2.default, { modalsList: this.modalsList });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var height = this.props.isMobilePage ? '100%' : 'auto';
	      return _react2.default.createElement(
	        'div',
	        { className: 'chat-ui-phone', style: { height: height } },
	        this.renderInnerContent(),
	        this.renderModalView()
	      );
	    }
	  }]);
	
	  return ChatUIPhone;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    stack: state.getIn(['conversations', '_stack', 'visibles']),
	    isToggled: state.getIn(['chatListState', 'isToggled'], false),
	    isMobilePage: state.getIn(['pluginSettings', 'isMobilePage'], false),
	    mobilePageUrl: state.getIn(['pluginSettings', 'mobilePageUrl'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    removeNewMessageMobileIndicator: function removeNewMessageMobileIndicator() {
	      return dispatch((0, _unset_new_message_indicator_on_mobile2.default)());
	    },
	    setChatListToToggled: function setChatListToToggled(toggled) {
	      return dispatch((0, _set_chat_list_toggled2.default)(toggled));
	    }
	  };
	};
	
	var ChatUIPhoneContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatUIPhone);
	
	exports.default = ChatUIPhoneContainer;

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatUIInfo = function (_React$Component) {
	  _inherits(ChatUIInfo, _React$Component);
	
	  function ChatUIInfo(props) {
	    _classCallCheck(this, ChatUIInfo);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChatUIInfo).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ChatUIInfo, [{
	    key: 'renderExpertModeTag',
	    value: function renderExpertModeTag() {
	      return _react2.default.createElement(
	        'span',
	        { className: 'chat-list-extra-context' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'EXPERT MODE'
	        )
	      );
	    }
	  }, {
	    key: 'renderChatListCount',
	    value: function renderChatListCount() {
	      if (typeof this.props.chatListCount === 'number' && this.props.chatListCount > 0) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'chat-total-user-count' },
	          _react2.default.createElement('i', { className: 'rc-icon-user' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.chatListCount
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderExtraContext',
	    value: function renderExtraContext() {
	      if (this.props.currentUserRole === _constants.ROLES.EXPERT) {
	        return this.renderExpertModeTag();
	      } else {
	        return this.renderChatListCount();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        { className: 'chat-ui-info' },
	        _react2.default.createElement('i', { className: 'rchat-icon rc-icon-rchat' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'chat-title' },
	          'Rotoballer Live Advice'
	        ),
	        this.renderExtraContext()
	      );
	    }
	  }]);
	
	  return ChatUIInfo;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentUserRole: state.getIn(['currentUser', 'role'], null),
	    chatListCount: state.getIn(['chatListCount', 'count'], 0)
	  };
	};
	
	var ChatUIInfoContainer = (0, _reactRedux.connect)(mapStateToProps)(ChatUIInfo);
	
	exports.default = ChatUIInfoContainer;

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _verge = __webpack_require__(86);
	
	var _verge2 = _interopRequireDefault(_verge);
	
	var _constants = __webpack_require__(2);
	
	var _user = __webpack_require__(19);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _calculate_conversation_content_height = __webpack_require__(638);
	
	var _calculate_conversation_content_height2 = _interopRequireDefault(_calculate_conversation_content_height);
	
	var _set_conversation_ref_read_message_count = __webpack_require__(682);
	
	var _set_conversation_ref_read_message_count2 = _interopRequireDefault(_set_conversation_ref_read_message_count);
	
	var _conversation_user_header = __webpack_require__(819);
	
	var _conversation_user_header2 = _interopRequireDefault(_conversation_user_header);
	
	var _content = __webpack_require__(464);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _actions = __webpack_require__(463);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Conversation = function (_React$Component) {
	  _inherits(Conversation, _React$Component);
	
	  function Conversation(props) {
	    _classCallCheck(this, Conversation);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Conversation).call(this, props));
	
	    _this.state = {};
	
	    _this.adjustContentHeight = _this.adjustContentHeight.bind(_this);
	    return _this;
	  }
	
	  _createClass(Conversation, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (_verge2.default.viewportW() <= _constants.VIEWPORT_MAX_WIDTH_PHONE) {
	        window.addEventListener('resize', this.adjustContentHeight);
	      }
	
	      if (this.props.conversation.get('targetId')) {
	        this.props.getUser(this.props.conversation.get('targetId'));
	      }
	
	      if (this.shouldUpdateReadMessageCount(this.props)) {
	        this.props.setReadMessageCount(this.props.currentUserUid, this.props.conversation.get('conversationId'), this.props.totalMessageCount);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.shouldUpdateReadMessageCount(nextProps)) {
	        this.props.setReadMessageCount(nextProps.currentUserUid, nextProps.conversation.get('conversationId'), nextProps.totalMessageCount);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.adjustContentHeight();
	    }
	  }, {
	    key: 'adjustContentHeight',
	    value: function adjustContentHeight() {
	      var contentHeight = (0, _calculate_conversation_content_height2.default)(_constants.CONVERSATION_PANE_HEIGHT, this.props.headerHeight, 0, this.props.actionsHeight);
	
	      this.setState({ contentHeight: contentHeight });
	    }
	  }, {
	    key: 'isConversationOpen',
	    value: function isConversationOpen() {
	      var status = arguments.length <= 0 || arguments[0] === undefined ? this.props.conversation.get('status') : arguments[0];
	      var OPEN = _constants.CONVERSATION_PANE_STATUSES.OPEN;
	
	
	      return status === OPEN ? true : false;
	    }
	  }, {
	    key: 'shouldShowUnreadMessageCount',
	    value: function shouldShowUnreadMessageCount() {
	      return !this.isConversationOpen();
	    }
	  }, {
	    key: 'shouldShowBody',
	    value: function shouldShowBody() {
	      return this.isConversationOpen();
	    }
	  }, {
	    key: 'shouldUpdateReadMessageCount',
	    value: function shouldUpdateReadMessageCount(nextProps) {
	      return nextProps.currentUserUid && this.isConversationOpen(nextProps.conversation.get('status')) && nextProps.totalMessageCount > nextProps.readMessageCount;
	    }
	  }, {
	    key: 'renderConversationContentMessage',
	    value: function renderConversationContentMessage() {}
	  }, {
	    key: 'renderActionWarningMessage',
	    value: function renderActionWarningMessage() {
	      if (this.props.isUserIgnored) {
	        return 'You have ignored this user.';
	      }
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      return _react2.default.createElement(_conversation_user_header2.default, {
	        ref: 'conversationHeader',
	        shouldShowUnreadMessageCount: this.shouldShowUnreadMessageCount(),
	        conversation: this.props.conversation });
	    }
	  }, {
	    key: 'renderConversationActions',
	    value: function renderConversationActions() {
	      return _react2.default.createElement(_actions2.default, {
	        ref: 'conversationActions',
	        isActive: true,
	        currentUser: this.props.currentUser,
	        otherUser: this.props.user,
	        warningMessage: this.renderActionWarningMessage(),
	        onNewMessageInputFocus: this.props.onConversationFocus,
	        onNewMessageInputBlur: this.props.onConversationBlur,
	        conversationContainerId: this.props.conversation.get('conversationId'),
	        shouldSendNotification: true });
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'conversation-body', style: { display: this.shouldShowBody() ? '' : 'none' } },
	        _react2.default.createElement(_content2.default, {
	          ref: 'conversationContent',
	          height: this.state.contentHeight,
	          isDisabled: this.props.isUserIgnored,
	          conversationContainerId: this.props.conversation.get('conversationId'),
	          currentUser: this.props.currentUser,
	          otherUser: this.props.user,
	          contentMessage: this.renderConversationContentMessage(),
	          shouldLoadPreviousMessages: true,
	          shouldLoadHistoryMessages: true,
	          historyBatchLimit: 20,
	          isRichMessageContentEnabled: true }),
	        this.renderConversationActions()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { ref: 'conversation', className: 'conversation' },
	        this.renderHeader(),
	        this.renderBody()
	      );
	    }
	  }]);
	
	  return Conversation;
	}(_react2.default.Component);
	
	Conversation.defaultProps = {
	  headerHeight: 42,
	  actionsHeight: 41
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    currentUser: state.get('currentUser'),
	    currentUserUid: state.getIn(['currentUser', 'uid']),
	    totalMessageCount: state.getIn(['conversations', '_counts', ownProps.conversation.get('conversationId'), 'total']),
	    readMessageCount: state.getIn(['conversations', '_counts', ownProps.conversation.get('conversationId'), 'read']),
	    isUserIgnored: state.getIn(['currentUser', 'ignored', ownProps.conversation.get('targetId')]),
	    user: state.getIn(['users', ownProps.conversation.get('targetId')])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    getUser: _user2.default,
	    setReadMessageCount: _set_conversation_ref_read_message_count2.default
	  };
	};
	
	var ConversationContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Conversation);
	
	exports.default = ConversationContainer;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _set_focused_conversation = __webpack_require__(988);
	
	var _set_focused_conversation2 = _interopRequireDefault(_set_focused_conversation);
	
	var _conversation = __webpack_require__(917);
	
	var _conversation2 = _interopRequireDefault(_conversation);
	
	var _expert_conversation = __webpack_require__(923);
	
	var _expert_conversation2 = _interopRequireDefault(_expert_conversation);
	
	var _group_chat_conversation = __webpack_require__(926);
	
	var _group_chat_conversation2 = _interopRequireDefault(_group_chat_conversation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NORMAL = _constants.CONVERSATION_TYPES.NORMAL;
	var EXPERT = _constants.CONVERSATION_TYPES.EXPERT;
	var GROUP = _constants.CONVERSATION_TYPES.GROUP;
	
	var ConversationDirector = function (_React$Component) {
	  _inherits(ConversationDirector, _React$Component);
	
	  function ConversationDirector(props) {
	    _classCallCheck(this, ConversationDirector);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConversationDirector).call(this, props));
	
	    _this.state = {};
	
	    _this.onConversationFocus = _this.onConversationFocus.bind(_this);
	    _this.onConversationBlur = _this.onConversationBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(ConversationDirector, [{
	    key: 'onConversationFocus',
	    value: function onConversationFocus() {
	      this.props.focusConversation(this.props.conversation, this.props.index, true);
	    }
	  }, {
	    key: 'onConversationBlur',
	    value: function onConversationBlur() {
	      this.props.focusConversation(this.props.conversation, this.props.index, false);
	    }
	  }, {
	    key: 'renderExpertConversation',
	    value: function renderExpertConversation(conv, index) {
	      return _react2.default.createElement(_expert_conversation2.default, {
	        index: index,
	        onConversationFocus: this.onConversationFocus,
	        onConversationBlur: this.onConversationBlur,
	        conversation: conv });
	    }
	  }, {
	    key: 'renderNormalConversation',
	    value: function renderNormalConversation(conv, index) {
	      return _react2.default.createElement(_conversation2.default, {
	        index: index,
	        onConversationFocus: this.onConversationFocus,
	        onConversationBlur: this.onConversationBlur,
	        conversation: conv });
	    }
	  }, {
	    key: 'renderGroupConversation',
	    value: function renderGroupConversation(conv, index) {
	      return _react2.default.createElement(_group_chat_conversation2.default, {
	        index: index,
	        onConversationFocus: this.onConversationFocus,
	        onConversationBlur: this.onConversationBlur,
	        conversation: conv });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var conversation = _props.conversation;
	      var currentUser = _props.currentUser;
	      var targetUser = _props.targetUser;
	
	
	      var convType = conversation.get('type');
	      var isExpertConversation = targetUser && targetUser.get('role') === _constants.ROLES.EXPERT || currentUser && currentUser.get('role') === _constants.ROLES.EXPERT;
	
	      if (convType === GROUP) return this.renderGroupConversation(this.props.conversation, this.props.index);
	      if (isExpertConversation) return this.renderExpertConversation(this.props.conversation, this.props.index);
	      if (convType === NORMAL || convType === EXPERT && !isExpertConversation) return this.renderNormalConversation(this.props.conversation, this.props.index);
	
	      return false;
	    }
	  }]);
	
	  return ConversationDirector;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    currentUser: state.get('currentUser'),
	    targetUser: state.getIn(['users', ownProps.conversation.get('targetId')])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    focusConversation: function focusConversation(conversation, index, isFocused) {
	      return dispatch((0, _set_focused_conversation2.default)(conversation, index, isFocused));
	    }
	  };
	};
	
	var ConversationDirectorContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConversationDirector);
	
	exports.default = ConversationDirectorContainer;

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _truncate_string = __webpack_require__(77);
	
	var _truncate_string2 = _interopRequireDefault(_truncate_string);
	
	var _close_conversation = __webpack_require__(832);
	
	var _close_conversation2 = _interopRequireDefault(_close_conversation);
	
	var _update_conversation_status = __webpack_require__(836);
	
	var _update_conversation_status2 = _interopRequireDefault(_update_conversation_status);
	
	var _chat_header_actions = __webpack_require__(814);
	
	var _chat_header_actions2 = _interopRequireDefault(_chat_header_actions);
	
	var _close_button = __webpack_require__(817);
	
	var _close_button2 = _interopRequireDefault(_close_button);
	
	var _unread_message_count = __webpack_require__(639);
	
	var _unread_message_count2 = _interopRequireDefault(_unread_message_count);
	
	var _sliding_menu = __webpack_require__(534);
	
	var _sliding_menu2 = _interopRequireDefault(_sliding_menu);
	
	var _conversation_menu_bookmark_item = __webpack_require__(920);
	
	var _conversation_menu_bookmark_item2 = _interopRequireDefault(_conversation_menu_bookmark_item);
	
	var _conversation_menu_subscribe_item = __webpack_require__(922);
	
	var _conversation_menu_subscribe_item2 = _interopRequireDefault(_conversation_menu_subscribe_item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConversationGroupChatHeader = function (_React$Component) {
	  _inherits(ConversationGroupChatHeader, _React$Component);
	
	  function ConversationGroupChatHeader(props) {
	    _classCallCheck(this, ConversationGroupChatHeader);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConversationGroupChatHeader).call(this, props));
	
	    _this.state = {};
	
	    _this.toggleHide = _this.toggleHide.bind(_this);
	    _this.toggleMenu = _this.toggleMenu.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(ConversationGroupChatHeader, [{
	    key: 'toggleHide',
	    value: function toggleHide(e) {
	      if (e & e.preventDefault) e.preventDefault();
	
	      var uid = this.props.currentUserUid || this.props.currentGuestUid;
	      var conversationId = this.props.conversation.get('conversationId');
	
	      var OPEN = _constants.CONVERSATION_PANE_STATUSES.OPEN;
	      var MINIMIZED = _constants.CONVERSATION_PANE_STATUSES.MINIMIZED;
	
	      var status = this.props.conversation.get('status');
	      status = status === OPEN ? MINIMIZED : OPEN;
	
	      this.props.updateConversationStatus(uid, conversationId, status, this.props.viewportType);
	    }
	  }, {
	    key: 'toggleMenu',
	    value: function toggleMenu(e) {
	      e.stopPropagation();
	
	      this.setState({ isSettingsMenuOpen: !this.state.isSettingsMenuOpen });
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose(e) {
	      if (e && e.stopPropagation) e.stopPropagation();
	
	      var uid = this.props.currentUserUid || this.props.currentGuestUid;
	      var conversationId = this.props.conversation.get('conversationId');
	
	      this.props.closeConversation(uid, conversationId, this.props.viewportType);
	    }
	  }, {
	    key: 'renderBookmark',
	    value: function renderBookmark() {
	      return _react2.default.createElement(_conversation_menu_bookmark_item2.default, {
	        groupId: this.props.conversation.get('conversationId') });
	    }
	  }, {
	    key: 'renderSubscribe',
	    value: function renderSubscribe() {
	      return _react2.default.createElement(_conversation_menu_subscribe_item2.default, {
	        groupId: this.props.conversation.get('conversationId') });
	    }
	  }, {
	    key: 'renderSlidingMenu',
	    value: function renderSlidingMenu() {
	      if (!this.props.currentUser) return;
	      if (!this.props.groupChat) return;
	
	      var slidingMenuClasses = 'conversation-menu';
	      var isVisible = true;
	      var height = 74;
	      var shouldShowBookmark = true;
	
	      if (this.props.groupChat.get('scope') === _constants.GROUP_CHAT_SCOPES.GLOBAL) {
	        height -= 37;
	        shouldShowBookmark = false;
	      }
	
	      if (!this.state.isSettingsMenuOpen) {
	        slidingMenuClasses += ' hidden';
	        isVisible = false;
	      }
	
	      return _react2.default.createElement(
	        _sliding_menu2.default,
	        { className: slidingMenuClasses, top: 42, height: height, isVisible: isVisible },
	        shouldShowBookmark ? this.renderBookmark() : null,
	        this.renderSubscribe()
	      );
	    }
	  }, {
	    key: 'renderSettingsButton',
	    value: function renderSettingsButton() {
	      if (!this.props.currentUser) return;
	      if (this.props.currentUser.get('isBanned')) return;
	      if (!this.props.groupChat) return;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'conversation-settings-button', onClick: this.toggleMenu },
	        _react2.default.createElement('i', { className: 'rc-icon-settings' })
	      );
	    }
	  }, {
	    key: 'renderUnreadMessageCount',
	    value: function renderUnreadMessageCount() {
	      return _react2.default.createElement(_unread_message_count2.default, {
	        uid: this.props.currentUserUid,
	        shouldShowUnreadMessageCount: this.props.shouldShowUnreadMessageCount,
	        conversationId: this.props.conversation.get('conversationId') });
	    }
	  }, {
	    key: 'renderGroupChatName',
	    value: function renderGroupChatName() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        (0, _truncate_string2.default)(this.props.groupChat.get('name'))
	      );
	    }
	  }, {
	    key: 'renderChatTitle',
	    value: function renderChatTitle() {
	      if (!this.props.groupChat) return _react2.default.createElement('div', { className: 'chat-title' });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'chat-title' },
	        this.renderGroupChatName(),
	        this.renderUnreadMessageCount()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'conversationHeader',
	          className: 'conversation-header',
	          style: { backgroundColor: this.props.backgroundColor },
	          onClick: this.toggleHide },
	        _react2.default.createElement(
	          'div',
	          { className: 'conversation-info' },
	          this.renderChatTitle()
	        ),
	        _react2.default.createElement(
	          _chat_header_actions2.default,
	          null,
	          this.renderSettingsButton(),
	          _react2.default.createElement(_close_button2.default, { onClick: this.onClose })
	        ),
	        this.renderSlidingMenu()
	      );
	    }
	  }]);
	
	  return ConversationGroupChatHeader;
	}(_react2.default.Component);
	
	ConversationGroupChatHeader.defaultProps = {
	  isHidden: false,
	  unreadNotificationsCount: 0,
	  shouldShowUnreadMessageCount: false
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    currentUser: state.get('currentUser'),
	    currentUserUid: state.getIn(['currentUser', 'uid']),
	    currentGuestUid: state.getIn(['currentGuest', 'uid']),
	    groupChat: state.getIn(['groups', 'all', ownProps.conversation.get('conversationId')]),
	    backgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'headerBackground']),
	    viewportType: state.getIn(['viewport', 'type'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    closeConversation: _close_conversation2.default,
	    updateConversationStatus: _update_conversation_status2.default
	  };
	};
	
	var ConversationGroupChatHeaderContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConversationGroupChatHeader);
	
	exports.default = ConversationGroupChatHeaderContainer;

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _bookmark_group = __webpack_require__(607);
	
	var _bookmark_group2 = _interopRequireDefault(_bookmark_group);
	
	var _unbookmark_group = __webpack_require__(610);
	
	var _unbookmark_group2 = _interopRequireDefault(_unbookmark_group);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConversationMenuBookmarkItem = function (_React$Component) {
	  _inherits(ConversationMenuBookmarkItem, _React$Component);
	
	  function ConversationMenuBookmarkItem(props) {
	    _classCallCheck(this, ConversationMenuBookmarkItem);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConversationMenuBookmarkItem).call(this, props));
	
	    _this.bookmark = _this.bookmark.bind(_this);
	    _this.unbookmark = _this.unbookmark.bind(_this);
	    return _this;
	  }
	
	  _createClass(ConversationMenuBookmarkItem, [{
	    key: 'bookmark',
	    value: function bookmark(e) {
	      if (e && e.stopPropagation) e.stopPropagation();
	
	      this.props.bookmarkGroup(this.props.currentUserUid, this.props.groupId);
	    }
	  }, {
	    key: 'unbookmark',
	    value: function unbookmark(e) {
	      if (e && e.stopPropagation) e.stopPropagation();
	
	      this.props.unbookmarkGroup(this.props.currentUserUid, this.props.groupId);
	    }
	  }, {
	    key: 'renderBookmarked',
	    value: function renderBookmarked() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'sliding-menu-item report-user', onClick: this.unbookmark },
	        _react2.default.createElement('i', { className: 'menu-item-icon rc-icon-bookmark' }),
	        'Remove from My List'
	      );
	    }
	  }, {
	    key: 'renderUnBookmarked',
	    value: function renderUnBookmarked() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'sliding-menu-item report-user', onClick: this.bookmark },
	        _react2.default.createElement('i', { className: 'menu-item-icon rc-icon-bookmark-outline' }),
	        'Add to My List'
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.currentUserUid) return false;
	      if (!this.props.groupChat) return false;
	      if (this.props.groupChat.get('scope') === _constants.GROUP_CHAT_SCOPES.GLOBAL) return false;
	      if (this.props.bookmarkedGroup) return this.renderBookmarked();
	
	      return this.renderUnBookmarked();
	    }
	  }]);
	
	  return ConversationMenuBookmarkItem;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    currentUserUid: state.getIn(['currentUser', 'uid']),
	    groupChat: state.getIn(['groups', 'all', ownProps.groupId]),
	    bookmarkedGroup: state.getIn(['groups', '_bookmarks', 'all', ownProps.groupId])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    bookmarkGroup: _bookmark_group2.default,
	    unbookmarkGroup: _unbookmark_group2.default
	  };
	};
	
	var ConversationMenuBookmarkItemContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConversationMenuBookmarkItem);
	
	exports.default = ConversationMenuBookmarkItemContainer;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _show_modal = __webpack_require__(16);
	
	var _show_modal2 = _interopRequireDefault(_show_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConversationMenuReportItem = function (_React$Component) {
	  _inherits(ConversationMenuReportItem, _React$Component);
	
	  function ConversationMenuReportItem(props) {
	    _classCallCheck(this, ConversationMenuReportItem);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConversationMenuReportItem).call(this, props));
	
	    _this.showReportModal = _this.showReportModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(ConversationMenuReportItem, [{
	    key: 'showReportModal',
	    value: function showReportModal(e) {
	      e.stopPropagation();
	      this.props.showModal({ type: 'report', props: { reportee: this.props.reportee } });
	
	      this.props.onReportClicked(e);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'sliding-menu-item report-user', onClick: this.showReportModal },
	        _react2.default.createElement('i', { className: 'menu-item-icon rc-icon-report' }),
	        'Report user'
	      );
	    }
	  }]);
	
	  return ConversationMenuReportItem;
	}(_react2.default.Component);
	
	ConversationMenuReportItem.defaultProps = {
	  onReportClicked: function onReportClicked() {}
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    showModal: function showModal(modal) {
	      return dispatch((0, _show_modal2.default)(modal));
	    }
	  };
	};
	
	var ConversationMenuReportItemContainer = (0, _reactRedux.connect)(null, mapDispatchToProps)(ConversationMenuReportItem);
	
	exports.default = ConversationMenuReportItemContainer;

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _show_modal = __webpack_require__(16);
	
	var _show_modal2 = _interopRequireDefault(_show_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConversationMenuSubscribeItem = function (_React$Component) {
	  _inherits(ConversationMenuSubscribeItem, _React$Component);
	
	  function ConversationMenuSubscribeItem(props) {
	    _classCallCheck(this, ConversationMenuSubscribeItem);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConversationMenuSubscribeItem).call(this, props));
	
	    _this.openSubscriptionModal = _this.openSubscriptionModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(ConversationMenuSubscribeItem, [{
	    key: 'openSubscriptionModal',
	    value: function openSubscriptionModal(e) {
	      if (e && e.preventDefault) e.preventDefault();
	      if (e && e.stopPropagation) e.stopPropagation();
	
	      this.props.showModal({ type: 'groupSubscribe', props: { groupId: this.props.groupId } });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.currentUserUid) return false;
	      if (!this.props.groupId) return false;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sliding-menu-item subscribe-group', onClick: this.openSubscriptionModal },
	        _react2.default.createElement('i', { className: 'menu-item-icon rc-icon-subscribe' }),
	        this.props.subscribedGroup ? 'Change notifications' : 'Notifications'
	      );
	    }
	  }]);
	
	  return ConversationMenuSubscribeItem;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var currentUserUid = state.getIn(['currentUser', 'uid']);
	  var subscribedGroup = state.getIn(['groups', '_subscriptions', 'users', currentUserUid, ownProps.groupId]);
	
	  return { currentUserUid: currentUserUid, subscribedGroup: subscribedGroup };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    showModal: function showModal(modal) {
	      return dispatch((0, _show_modal2.default)(modal));
	    }
	  };
	};
	
	var ConversationMenuSubscribeItemContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConversationMenuSubscribeItem);
	
	exports.default = ConversationMenuSubscribeItemContainer;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _immutable = __webpack_require__(5);
	
	var _verge = __webpack_require__(86);
	
	var _verge2 = _interopRequireDefault(_verge);
	
	var _constants = __webpack_require__(2);
	
	var _user = __webpack_require__(19);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _calculate_conversation_content_height = __webpack_require__(638);
	
	var _calculate_conversation_content_height2 = _interopRequireDefault(_calculate_conversation_content_height);
	
	var _set_conversation_ref_read_message_count = __webpack_require__(682);
	
	var _set_conversation_ref_read_message_count2 = _interopRequireDefault(_set_conversation_ref_read_message_count);
	
	var _conversation_user_header = __webpack_require__(819);
	
	var _conversation_user_header2 = _interopRequireDefault(_conversation_user_header);
	
	var _content = __webpack_require__(464);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _actions = __webpack_require__(463);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _conversation_message_informer = __webpack_require__(637);
	
	var _conversation_message_informer2 = _interopRequireDefault(_conversation_message_informer);
	
	var _expert_info_message_informer = __webpack_require__(925);
	
	var _expert_info_message_informer2 = _interopRequireDefault(_expert_info_message_informer);
	
	var _session_info_message_informer = __webpack_require__(928);
	
	var _session_info_message_informer2 = _interopRequireDefault(_session_info_message_informer);
	
	var _conversation_secondary_header = __webpack_require__(818);
	
	var _conversation_secondary_header2 = _interopRequireDefault(_conversation_secondary_header);
	
	var _expert_conversation_session_progress_action = __webpack_require__(924);
	
	var _expert_conversation_session_progress_action2 = _interopRequireDefault(_expert_conversation_session_progress_action);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpertConversation = function (_React$Component) {
	  _inherits(ExpertConversation, _React$Component);
	
	  function ExpertConversation(props) {
	    _classCallCheck(this, ExpertConversation);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ExpertConversation).call(this, props));
	
	    _this.state = {
	      isHidden: _this.props.isHidden || false,
	      isActive: _this.props.isActive
	    };
	
	    _this.adjustContentHeight = _this.adjustContentHeight.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExpertConversation, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (_verge2.default.viewportW() <= _constants.VIEWPORT_MAX_WIDTH_PHONE) {
	        window.addEventListener('resize', this.adjustContentHeight);
	      }
	
	      if (this.props.conversation.get('targetId')) {
	        this.props.getUser(this.props.conversation.get('targetId'));
	      }
	
	      if (this.shouldUpdateReadMessageCount(this.props)) {
	        this.props.setReadMessageCount(this.props.currentUserUid, this.props.conversation.get('conversationId'), this.props.totalMessageCount);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.shouldUpdateReadMessageCount(nextProps)) {
	        this.props.setReadMessageCount(nextProps.currentUserUid, nextProps.conversation.get('conversationId'), nextProps.totalMessageCount);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.adjustContentHeight();
	    }
	  }, {
	    key: 'adjustContentHeight',
	    value: function adjustContentHeight() {
	      var contentHeight = (0, _calculate_conversation_content_height2.default)(_constants.CONVERSATION_PANE_HEIGHT, this.props.headerHeight, this.props.secondaryHeaderHeight, this.props.actionsHeight);
	
	      this.setState({ contentHeight: contentHeight });
	    }
	  }, {
	    key: 'shouldShowBody',
	    value: function shouldShowBody() {
	      var OPEN = _constants.CONVERSATION_PANE_STATUSES.OPEN;
	
	      var status = this.props.conversation.get('status');
	
	      return status === OPEN ? true : false;
	    }
	  }, {
	    key: 'shouldUpdateReadMessageCount',
	    value: function shouldUpdateReadMessageCount(nextProps) {
	      return nextProps.currentUserUid && this.isConversationOpen(nextProps.conversation.get('status')) && nextProps.totalMessageCount > nextProps.readMessageCount;
	    }
	  }, {
	    key: 'isConversationOpen',
	    value: function isConversationOpen() {
	      var status = arguments.length <= 0 || arguments[0] === undefined ? this.props.conversation.get('status') : arguments[0];
	      var OPEN = _constants.CONVERSATION_PANE_STATUSES.OPEN;
	
	
	      return status === OPEN ? true : false;
	    }
	  }, {
	    key: 'isConversationActive',
	    value: function isConversationActive() {
	      if (this.props.currentUser.get('role') !== _constants.ROLES.EXPERT) return false;
	
	      if (this.props.isUserIgnored) return false;
	
	      return true;
	    }
	  }, {
	    key: 'renderSessionInfoMessage',
	    value: function renderSessionInfoMessage() {
	      return _react2.default.createElement(_session_info_message_informer2.default, {
	        user: this.props.user.toJS(),
	        sessionId: this.props.activeSessionId });
	    }
	  }, {
	    key: 'renderExpertInfoMessage',
	    value: function renderExpertInfoMessage() {
	      return _react2.default.createElement(
	        _conversation_message_informer2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          'You are in expert mode.',
	          _react2.default.createElement('br', null),
	          'You can send message to user, but user won\'t be able to respond back.',
	          _react2.default.createElement('br', null),
	          'Otherwise, you can switch to writer mode to enable chat with everyone.'
	        )
	      );
	    }
	  }, {
	    key: 'renderUserInfoMessage',
	    value: function renderUserInfoMessage() {
	      return _react2.default.createElement(_expert_info_message_informer2.default, { user: this.props.user.toJS() });
	    }
	  }, {
	    key: 'renderActionWarningMessage',
	    value: function renderActionWarningMessage() {
	      if (this.props.isUserIgnored) {
	        return 'You have ignored this user.';
	      }
	    }
	  }, {
	    key: 'renderConversationContentMessage',
	    value: function renderConversationContentMessage() {
	      if (this.props.currentUser.get('role') === _constants.ROLES.EXPERT) {
	        if (this.props.activeSessionId) return this.renderSessionInfoMessage();else return this.renderExpertInfoMessage();
	      } else if (this.props.user.get('role') === _constants.ROLES.EXPERT) {
	        if (this.props.activeSessionId) return this.renderSessionInfoMessage();else return this.renderUserInfoMessage();
	      }
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      return _react2.default.createElement(_conversation_user_header2.default, {
	        ref: 'conversationHeader',
	        conversation: this.props.conversation });
	    }
	  }, {
	    key: 'renderSecondaryHeader',
	    value: function renderSecondaryHeader() {
	      if (!this.shouldShowBody()) return false;
	
	      if (this.props.currentUser.get('role') !== _constants.ROLES.EXPERT) {
	        return _react2.default.createElement(
	          _conversation_secondary_header2.default,
	          { ref: 'secondaryHeader', height: this.props.secondaryHeaderHeight },
	          _react2.default.createElement(_expert_conversation_session_progress_action2.default, {
	            sessionId: this.props.activeSessionId,
	            expert: this.props.user.toJS(),
	            classNames: 'conversation-secondary-header-button' })
	        );
	      }
	    }
	  }, {
	    key: 'renderConversationActions',
	    value: function renderConversationActions() {
	      return _react2.default.createElement(_actions2.default, {
	        ref: 'conversationActions',
	        isActive: this.isConversationActive(),
	        height: this.props.actionsHeight,
	        currentUser: this.props.currentUser,
	        otherUser: this.props.user,
	        warningMessage: this.renderActionWarningMessage(),
	        onNewMessageInputFocus: this.props.onConversationFocus,
	        onNewMessageInputBlur: this.props.onConversationBlur,
	        conversationContainerId: this.props.conversation.get('conversationId') });
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'conversation-body', style: { display: this.shouldShowBody() ? '' : 'none' } },
	        _react2.default.createElement(_content2.default, {
	          ref: 'conversationContent',
	          height: this.state.contentHeight,
	          conversationContainerId: this.props.conversation.get('conversationId'),
	          currentUser: this.props.currentUser,
	          otherUser: this.props.user,
	          contentMessage: this.renderConversationContentMessage(),
	          shouldLoadPreviousMessages: false,
	          isRichMessageContentEnabled: true }),
	        this.renderConversationActions()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { ref: 'conversation', className: 'conversation expert' },
	        this.renderHeader(),
	        this.renderSecondaryHeader(),
	        this.renderBody()
	      );
	    }
	  }]);
	
	  return ExpertConversation;
	}(_react2.default.Component);
	
	ExpertConversation.defaultProps = {
	  isActive: false,
	  actionsHeight: 41,
	  headerHeight: 42,
	  secondaryHeaderHeight: 54,
	  onConversationActive: function onConversationActive() {}
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    currentUser: state.get('currentUser', (0, _immutable.fromJS)({})),
	    currentUserUid: state.getIn(['currentUser', 'uid']),
	    user: state.getIn(['users', ownProps.conversation.get('targetId')]),
	    totalMessageCount: state.getIn(['conversations', '_counts', ownProps.conversation.get('conversationId'), 'total']),
	    readMessageCount: state.getIn(['conversations', '_counts', ownProps.conversation.get('conversationId'), 'read']),
	    isUserIgnored: state.getIn(['currentUser', 'ignored', ownProps.conversation.get('targetId')]),
	    activeSessionId: state.getIn(['sessions', '_refs', ownProps.conversation.get('targetId'), 0, 'sessionId'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    getUser: _user2.default,
	    setReadMessageCount: _set_conversation_ref_read_message_count2.default
	  };
	};
	
	var ExpertConversationContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ExpertConversation);
	
	exports.default = ExpertConversationContainer;

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _summary_date_time = __webpack_require__(69);
	
	var _summary_date_time2 = _interopRequireDefault(_summary_date_time);
	
	var _is_session_on_time = __webpack_require__(504);
	
	var _is_session_on_time2 = _interopRequireDefault(_is_session_on_time);
	
	var _show_modal = __webpack_require__(16);
	
	var _show_modal2 = _interopRequireDefault(_show_modal);
	
	var _go_to_session_button = __webpack_require__(821);
	
	var _go_to_session_button2 = _interopRequireDefault(_go_to_session_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpertConversationSessionProgressAction = function (_React$Component) {
	  _inherits(ExpertConversationSessionProgressAction, _React$Component);
	
	  function ExpertConversationSessionProgressAction(props) {
	    _classCallCheck(this, ExpertConversationSessionProgressAction);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ExpertConversationSessionProgressAction).call(this, props));
	
	    _this.state = {};
	
	    _this.onRequestSession = _this.onRequestSession.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExpertConversationSessionProgressAction, [{
	    key: 'onRequestSession',
	    value: function onRequestSession(e) {
	      if (e) e.preventDefault();
	
	      this.props.showInitiateSessionModal({
	        type: 'sessionInitiate',
	        props: { expert: this.props.expert }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.sessionId) {
	        return _react2.default.createElement(
	          'a',
	          { href: '#', className: this.props.classNames, onClick: this.onRequestSession },
	          'Request paid session'
	        );
	      }
	
	      if (this.props.sessionId && this.props.session) {
	        var status = this.props.session.get('status');
	        var startTime = this.props.session.get('startTime');
	
	        if (status >= _constants.SESSION_STATUSES.BOOKED && status <= _constants.SESSION_STATUSES.PAUSED) {
	          if ((0, _is_session_on_time2.default)(startTime)) {
	            return _react2.default.createElement(_go_to_session_button2.default, {
	              classNames: this.props.classNames,
	              sessionId: this.props.sessionId });
	          } else {
	            return _react2.default.createElement(
	              'h5',
	              null,
	              'Session on ',
	              (0, _summary_date_time2.default)(startTime)
	            );
	          }
	        }
	      }
	
	      return false;
	    }
	  }]);
	
	  return ExpertConversationSessionProgressAction;
	}(_react2.default.Component);
	
	ExpertConversationSessionProgressAction.defaultProps = {
	  classNames: 'button success'
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    session: state.getIn(['sessions', 'experts', ownProps.sessionId])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    showInitiateSessionModal: function showInitiateSessionModal(modal) {
	      return dispatch((0, _show_modal2.default)(modal));
	    }
	  };
	};
	
	var ExpertConversationSessionProgressActionContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ExpertConversationSessionProgressAction);
	
	exports.default = ExpertConversationSessionProgressActionContainer;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _show_modal = __webpack_require__(16);
	
	var _show_modal2 = _interopRequireDefault(_show_modal);
	
	var _conversation_message_informer = __webpack_require__(637);
	
	var _conversation_message_informer2 = _interopRequireDefault(_conversation_message_informer);
	
	var _profile_image = __webpack_require__(45);
	
	var _profile_image2 = _interopRequireDefault(_profile_image);
	
	var _expert_rating = __webpack_require__(78);
	
	var _expert_rating2 = _interopRequireDefault(_expert_rating);
	
	var _expert_sessions_count = __webpack_require__(273);
	
	var _expert_sessions_count2 = _interopRequireDefault(_expert_sessions_count);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpertInfoMessageInformer = function (_React$Component) {
	  _inherits(ExpertInfoMessageInformer, _React$Component);
	
	  function ExpertInfoMessageInformer(props) {
	    _classCallCheck(this, ExpertInfoMessageInformer);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ExpertInfoMessageInformer).call(this, props));
	
	    _this.state = {};
	
	    _this.onRequestSessionButtonClicked = _this.onRequestSessionButtonClicked.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExpertInfoMessageInformer, [{
	    key: 'onRequestSessionButtonClicked',
	    value: function onRequestSessionButtonClicked(e) {
	      e.preventDefault();
	      this.props.showInitiateSessionModal({
	        type: 'sessionInitiate',
	        props: { expert: this.props.user }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _conversation_message_informer2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'informer-section' },
	          _react2.default.createElement(_profile_image2.default, { user: this.props.user, image: this.props.user.profileImage, size: 64 })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'informer-section', style: { fontSize: '20px' } },
	          _react2.default.createElement(_expert_rating2.default, { rating: this.props.user.rating })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'informer-section', style: { fontSize: '14px' } },
	          _react2.default.createElement(_expert_sessions_count2.default, { uid: this.props.user.uid, size: 16 }),
	          _react2.default.createElement(
	            'p',
	            null,
	            'sessions so far'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'informer-section' },
	          'This expert is in expert mode.',
	          _react2.default.createElement('br', null),
	          'You must initiate a paid session to chat with him.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-area' },
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'button success', onClick: this.onRequestSessionButtonClicked },
	            'Request a paid session'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ExpertInfoMessageInformer;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    showInitiateSessionModal: function showInitiateSessionModal(modal) {
	      return dispatch((0, _show_modal2.default)(modal));
	    }
	  };
	};
	
	var ExpertInfoMessageInformerContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ExpertInfoMessageInformer);
	
	exports.default = ExpertInfoMessageInformerContainer;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _verge = __webpack_require__(86);
	
	var _verge2 = _interopRequireDefault(_verge);
	
	var _constants = __webpack_require__(2);
	
	var _calculate_conversation_content_height = __webpack_require__(638);
	
	var _calculate_conversation_content_height2 = _interopRequireDefault(_calculate_conversation_content_height);
	
	var _set_conversation_ref_read_message_count = __webpack_require__(682);
	
	var _set_conversation_ref_read_message_count2 = _interopRequireDefault(_set_conversation_ref_read_message_count);
	
	var _fixed_slot_advertisement = __webpack_require__(693);
	
	var _fixed_slot_advertisement2 = _interopRequireDefault(_fixed_slot_advertisement);
	
	var _conversation_group_chat_header = __webpack_require__(919);
	
	var _conversation_group_chat_header2 = _interopRequireDefault(_conversation_group_chat_header);
	
	var _conversation = __webpack_require__(600);
	
	var _conversation2 = _interopRequireDefault(_conversation);
	
	var _conversation_secondary_header = __webpack_require__(818);
	
	var _conversation_secondary_header2 = _interopRequireDefault(_conversation_secondary_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SECONDARY_HEADER_HEIGHT = _constants.CONVERSATION_PANE_ADV_DIMENSIONS.HEIGHT;
	
	var GroupChatConversation = function (_React$Component) {
	  _inherits(GroupChatConversation, _React$Component);
	
	  function GroupChatConversation(props) {
	    _classCallCheck(this, GroupChatConversation);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GroupChatConversation).call(this, props));
	
	    _this.state = {};
	
	    _this.adjustContentHeight = _this.adjustContentHeight.bind(_this);
	    return _this;
	  }
	
	  _createClass(GroupChatConversation, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (_verge2.default.viewportW() <= _constants.VIEWPORT_MAX_WIDTH_PHONE) {
	        window.addEventListener('resize', this.adjustContentHeight);
	      }
	
	      this.adjustContentHeight();
	
	      if (this.shouldUpdateReadMessageCount(this.props)) {
	        this.props.setReadMessageCount(this.props.currentUserUid, this.props.conversation.get('conversationId'), this.props.totalMessageCount);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.shouldUpdateReadMessageCount(nextProps)) {
	        this.props.setReadMessageCount(nextProps.currentUserUid, nextProps.conversation.get('conversationId'), nextProps.totalMessageCount);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.adjustContentHeight();
	    }
	  }, {
	    key: 'adjustContentHeight',
	    value: function adjustContentHeight() {
	      var secondaryHeaderHeight = this.shouldShowAdvertisement() ? SECONDARY_HEADER_HEIGHT : 0;
	
	      var contentHeight = (0, _calculate_conversation_content_height2.default)(_constants.CONVERSATION_PANE_HEIGHT, this.props.headerHeight, secondaryHeaderHeight, this.props.actionsHeight);
	
	      this.setState({ contentHeight: contentHeight });
	    }
	  }, {
	    key: 'isConversationOpen',
	    value: function isConversationOpen() {
	      var status = arguments.length <= 0 || arguments[0] === undefined ? this.props.conversation.get('status') : arguments[0];
	      var OPEN = _constants.CONVERSATION_PANE_STATUSES.OPEN;
	
	
	      return status === OPEN ? true : false;
	    }
	  }, {
	    key: 'shouldShowUnreadMessageCount',
	    value: function shouldShowUnreadMessageCount() {
	      return !this.isConversationOpen();
	    }
	  }, {
	    key: 'shouldShowBody',
	    value: function shouldShowBody() {
	      return this.isConversationOpen();
	    }
	  }, {
	    key: 'shouldUpdateReadMessageCount',
	    value: function shouldUpdateReadMessageCount(nextProps) {
	      return nextProps.currentUserUid && this.isConversationOpen(nextProps.conversation.get('status')) && nextProps.totalMessageCount > nextProps.readMessageCount;
	    }
	  }, {
	    key: 'shouldShowAdvertisement',
	    value: function shouldShowAdvertisement() {
	      if (!this.props.isModerated) return true;
	      if (this.props.isAdvertisementEnabledForModeratedChat) return true;
	
	      return false;
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      return _react2.default.createElement(_conversation_group_chat_header2.default, {
	        ref: 'conversationHeader',
	        shouldShowUnreadMessageCount: this.shouldShowUnreadMessageCount(),
	        height: this.props.headerHeight,
	        conversation: this.props.conversation });
	    }
	  }, {
	    key: 'renderSecondaryHeader',
	    value: function renderSecondaryHeader() {
	      if (!this.shouldShowAdvertisement()) return false;
	      if (!this.shouldShowBody()) return false;
	
	      return _react2.default.createElement(
	        _conversation_secondary_header2.default,
	        { ref: 'secondaryHeader', height: SECONDARY_HEADER_HEIGHT },
	        _react2.default.createElement(_fixed_slot_advertisement2.default, { isModerated: this.props.isModerated, maxWidth: 280 })
	      );
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      var messageType = this.props.isModerated ? _constants.MESSAGE_TYPES.MODERATED_GROUP : _constants.MESSAGE_TYPES.GROUP;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'conversation-body', style: { display: this.shouldShowBody() ? '' : 'none' } },
	        _react2.default.createElement(_conversation2.default, {
	          currentUser: this.props.currentUser,
	          to: this.props.conversation.get('conversationId'),
	          contentHeight: this.state.contentHeight,
	          maxBubbleWidth: 210,
	          actionsHeight: this.props.actionsHeight,
	          isModerated: this.props.isModerated,
	          conversationContainerId: this.props.conversation.get('conversationId'),
	          isActive: true,
	          messageType: messageType,
	          shouldLoadHistoryMessages: true,
	          shouldLoadPreviousMessages: true,
	          shouldSendNotification: false,
	          notificationOptions: { title: false },
	          historyBatchLimit: 20,
	          isRichMessageContentEnabled: true })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { ref: 'conversation', className: 'conversation' },
	        this.renderHeader(),
	        this.renderSecondaryHeader(),
	        this.renderBody()
	      );
	    }
	  }]);
	
	  return GroupChatConversation;
	}(_react2.default.Component);
	
	GroupChatConversation.defaultProps = {
	  headerHeight: 42,
	  actionsHeight: 41
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    currentUser: state.get('currentUser'),
	    currentUserUid: state.getIn(['currentUser', 'uid']),
	    totalMessageCount: state.getIn(['conversations', '_counts', ownProps.conversation.get('conversationId'), 'total']),
	    readMessageCount: state.getIn(['conversations', '_counts', ownProps.conversation.get('conversationId'), 'read']),
	    isModerated: state.getIn(['groups', 'all', ownProps.conversation.get('conversationId'), 'isModerated']),
	    isAdvertisementEnabledForModeratedChat: state.getIn(['advertisements', 'settings', 'isModeratedGroupChatEnabled']),
	    user: state.getIn(['users', ownProps.conversation.get('targetId')])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps() {
	  return {
	    setReadMessageCount: _set_conversation_ref_read_message_count2.default
	  };
	};
	
	var GroupChatConversationContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GroupChatConversation);
	
	exports.default = GroupChatConversationContainer;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(7);
	
	var _store = __webpack_require__(8);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _chat_ui = __webpack_require__(914);
	
	var _chat_ui2 = _interopRequireDefault(_chat_ui);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return React.createElement(
	    _reactRedux.Provider,
	    { store: _store2.default },
	    React.createElement(_chat_ui2.default, null)
	  );
	};

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _summary_date_time = __webpack_require__(69);
	
	var _summary_date_time2 = _interopRequireDefault(_summary_date_time);
	
	var _is_session_on_time = __webpack_require__(504);
	
	var _is_session_on_time2 = _interopRequireDefault(_is_session_on_time);
	
	var _show_modal = __webpack_require__(16);
	
	var _show_modal2 = _interopRequireDefault(_show_modal);
	
	var _profile_image = __webpack_require__(45);
	
	var _profile_image2 = _interopRequireDefault(_profile_image);
	
	var _expert_rating = __webpack_require__(78);
	
	var _expert_rating2 = _interopRequireDefault(_expert_rating);
	
	var _expert_sessions_count = __webpack_require__(273);
	
	var _expert_sessions_count2 = _interopRequireDefault(_expert_sessions_count);
	
	var _conversation_message_informer = __webpack_require__(637);
	
	var _conversation_message_informer2 = _interopRequireDefault(_conversation_message_informer);
	
	var _go_to_session_button = __webpack_require__(821);
	
	var _go_to_session_button2 = _interopRequireDefault(_go_to_session_button);
	
	var _continue_checkout_session_button = __webpack_require__(979);
	
	var _continue_checkout_session_button2 = _interopRequireDefault(_continue_checkout_session_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SessionInfoMessageInformer = function (_React$Component) {
	  _inherits(SessionInfoMessageInformer, _React$Component);
	
	  function SessionInfoMessageInformer(props) {
	    _classCallCheck(this, SessionInfoMessageInformer);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SessionInfoMessageInformer).call(this, props));
	
	    _this.state = {};
	
	    _this.onRequestSession = _this.onRequestSession.bind(_this);
	    return _this;
	  }
	
	  _createClass(SessionInfoMessageInformer, [{
	    key: 'onRequestSession',
	    value: function onRequestSession(e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      this.props.showInitiateSessionModal({
	        type: 'sessionInitiate',
	        props: { expert: this.props.user }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.currentSession) return false;
	
	      var startTime = this.props.currentSession.get('startTime');
	      var status = this.props.currentSession.get('status');
	
	      if (this.props.currentUser.get('role') === _constants.ROLES.EXPERT) {
	        if (status === _constants.SESSION_STATUSES.PAID && (0, _is_session_on_time2.default)(startTime)) {
	          return _react2.default.createElement(
	            _conversation_message_informer2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section' },
	              'You are in paid session with this user.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'action-area' },
	              _react2.default.createElement(_go_to_session_button2.default, { sessionId: this.props.sessionId })
	            )
	          );
	        } else if (status === _constants.SESSION_STATUSES.INITIATED) {
	          return _react2.default.createElement(
	            _conversation_message_informer2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section' },
	              'User is about to complete checkout. Give user a moment.'
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            _conversation_message_informer2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section' },
	              'Your closest session with this user is on',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'b',
	                null,
	                (0, _summary_date_time2.default)(startTime)
	              ),
	              '.'
	            )
	          );
	        }
	      } else {
	        if (status === _constants.SESSION_STATUSES.PAID && (0, _is_session_on_time2.default)(startTime)) {
	          return _react2.default.createElement(
	            _conversation_message_informer2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section' },
	              _react2.default.createElement(_profile_image2.default, { user: this.props.user, image: this.props.user.profileImage, size: 64 })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section', style: { fontSize: '20px' } },
	              _react2.default.createElement(_expert_rating2.default, { rating: this.props.user.rating })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section', style: { fontSize: '14px' } },
	              _react2.default.createElement(_expert_sessions_count2.default, { uid: this.props.user.uid, size: 16 }),
	              _react2.default.createElement(
	                'p',
	                null,
	                'sessions so far'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section' },
	              'You are in paid session with this expert.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'action-area' },
	              _react2.default.createElement(_go_to_session_button2.default, { sessionId: this.props.sessionId })
	            )
	          );
	        } else if (status === _constants.SESSION_STATUSES.INITIATED) {
	          return _react2.default.createElement(
	            _conversation_message_informer2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section' },
	              _react2.default.createElement(_profile_image2.default, { user: this.props.user, image: this.props.user.profileImage, size: 64 })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section', style: { fontSize: '20px' } },
	              _react2.default.createElement(_expert_rating2.default, { rating: this.props.user.rating })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section', style: { fontSize: '14px' } },
	              _react2.default.createElement(_expert_sessions_count2.default, { uid: this.props.user.uid, size: 16 }),
	              _react2.default.createElement(
	                'p',
	                null,
	                'sessions so far'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section' },
	              'You are about to complete checkout steps for a session with this expert.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'action-area' },
	              _react2.default.createElement(_continue_checkout_session_button2.default, {
	                sessionId: this.props.sessionId,
	                session: this.props.currentSession,
	                expert: this.props.user })
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            _conversation_message_informer2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section' },
	              _react2.default.createElement(_profile_image2.default, { user: this.props.user, image: this.props.user.profileImage, size: 64 })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section', style: { fontSize: '20px' } },
	              _react2.default.createElement(_expert_rating2.default, { rating: this.props.user.rating })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section', style: { fontSize: '14px' } },
	              _react2.default.createElement(_expert_sessions_count2.default, { uid: this.props.user.uid, size: 16 }),
	              _react2.default.createElement(
	                'p',
	                null,
	                'sessions so far'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'informer-section' },
	              'Your closest session with this expert is on ',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'b',
	                null,
	                (0, _summary_date_time2.default)(startTime),
	                '.'
	              ),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'action-area' },
	              _react2.default.createElement(
	                'a',
	                { href: '#', className: 'button success', onClick: this.onRequestSession },
	                'Request another session'
	              )
	            )
	          );
	        }
	      }
	    }
	  }]);
	
	  return SessionInfoMessageInformer;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    currentUser: state.get('currentUser'),
	    currentSession: state.getIn(['sessions', 'experts', ownProps.sessionId])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    showInitiateSessionModal: function showInitiateSessionModal(modal) {
	      return dispatch((0, _show_modal2.default)(modal));
	    }
	  };
	};
	
	var SessionInfoMessageInformerContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SessionInfoMessageInformer);
	
	exports.default = SessionInfoMessageInformerContainer;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnreadMessageIndicator = function (_React$Component) {
	  _inherits(UnreadMessageIndicator, _React$Component);
	
	  function UnreadMessageIndicator() {
	    _classCallCheck(this, UnreadMessageIndicator);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(UnreadMessageIndicator).apply(this, arguments));
	  }
	
	  _createClass(UnreadMessageIndicator, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.viewportType !== _constants.VIEWPORT_TYPES.PHONE) return false;
	      if (!this.props.shouldShowIt) return false;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'unread-message-indicator' },
	        '!'
	      );
	    }
	  }]);
	
	  return UnreadMessageIndicator;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    shouldShowIt: state.get('shouldShowNewMessageIndicatorOnMobile'),
	    viewportType: state.getIn(['viewport', 'type'])
	  };
	};
	
	var UnreadMessageIndicatorContainer = (0, _reactRedux.connect)(mapStateToProps)(UnreadMessageIndicator);
	
	exports.default = UnreadMessageIndicatorContainer;

/***/ },
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _show_modal = __webpack_require__(16);
	
	var _show_modal2 = _interopRequireDefault(_show_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContinueCheckoutSessionButton = function (_React$Component) {
	  _inherits(ContinueCheckoutSessionButton, _React$Component);
	
	  function ContinueCheckoutSessionButton(props) {
	    _classCallCheck(this, ContinueCheckoutSessionButton);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ContinueCheckoutSessionButton).call(this, props));
	
	    _this.state = {};
	
	    _this.showModal = _this.showModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(ContinueCheckoutSessionButton, [{
	    key: 'showModal',
	    value: function showModal(e) {
	      if (e && e.preventDefault) e.preventDefault();
	
	      var requestData = (0, _immutable.fromJS)({
	        sessionLength: this.props.session.get('sessionLength'),
	        type: this.props.session.get('type') === _constants.SESSION_TYPES.BOOKED ? 'later' : 'immediate'
	      });
	
	      this.props.showSessionInitiateModal({
	        type: 'sessionInitiate',
	        props: { expert: this.props.expert, bookData: { sessionId: this.props.sessionId, requestData: requestData } }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'a',
	        { href: '#', className: this.props.classNames, onClick: this.showModal },
	        'Continue checkout'
	      );
	    }
	  }]);
	
	  return ContinueCheckoutSessionButton;
	}(_react2.default.Component);
	
	ContinueCheckoutSessionButton.defaultProps = {
	  classNames: 'button success'
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    showSessionInitiateModal: function showSessionInitiateModal(modal) {
	      return dispatch((0, _show_modal2.default)(modal));
	    }
	  };
	};
	
	var ContinueCheckoutSessionButtonContainer = (0, _reactRedux.connect)(null, mapDispatchToProps)(ContinueCheckoutSessionButton);
	
	exports.default = ContinueCheckoutSessionButtonContainer;

/***/ },
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function (conversation, index, isFocused) {
	  return { type: _action_types.SET_FOCUSED_CONVERSATION, conversation: conversation, index: index, isFocused: isFocused };
	};

/***/ },
/* 989 */,
/* 990 */,
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function () {
	  var count = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	  var conversationId = arguments[1];
	
	  return { type: _action_types.SET_READ_CONV_MESSAGE_COUNT, count: count, conversationId: conversationId };
	};

/***/ },
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function () {
	  var count = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	  var conversationId = arguments[1];
	
	  return { type: _action_types.SET_TOTAL_CONV_MESSAGE_COUNT, count: count, conversationId: conversationId };
	};

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _action_types = __webpack_require__(4);
	
	exports.default = function () {
	  return { type: _action_types.UNSET_NEW_MESSAGE_INDICATOR_ON_MOBILE };
	};

/***/ },
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(2);
	
	exports.default = function (item) {
	  var GUEST = _constants.CONVERSATION_TYPES.GUEST;
	  var NORMAL = _constants.CONVERSATION_TYPES.NORMAL;
	  var EXPERT = _constants.CONVERSATION_TYPES.EXPERT;
	  var GROUP = _constants.CONVERSATION_TYPES.GROUP;
	
	
	  if (!item.get('uid')) return GROUP;
	  if (!item.get('role')) return GUEST;
	  if (item.get('role') === _constants.ROLES.EXPERT) return EXPERT;
	
	  return NORMAL;
	};

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var existingConversation = function existingConversation(convId, conv) {
	  return conv.get('conversationId') === convId;
	};
	
	exports.default = function (conversationId, stack) {
	  if (typeof stack === 'undefined' || stack === null) stack = (0, _immutable.fromJS)([]);
	  if (!_immutable.List.isList(stack)) stack = (0, _immutable.fromJS)(stack);
	  if (!conversationId) return stack;
	
	  var index = stack.findKey(existingConversation.bind(null, conversationId));
	
	  if (index >= 0) stack = stack.delete(index);
	
	  return stack;
	};

/***/ },
/* 1009 */,
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(5);
	
	var existingConversation = function existingConversation(convId, conv) {
	  return conv.get('conversationId') === convId;
	};
	
	exports.default = function (conversationId, status, stack) {
	  if (typeof stack === 'undefined' || stack === null) stack = (0, _immutable.fromJS)([]);
	  if (!_immutable.List.isList(stack)) stack = (0, _immutable.fromJS)(stack);
	  if (!conversationId) return stack;
	
	  var index = stack.findKey(existingConversation.bind(null, conversationId));
	
	  if (index >= 0) stack = stack.setIn([index, 'status'], status);
	
	  return stack;
	};

/***/ },
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toggleIgnoring = function toggleIgnoring(uid, otherUid, isIgnored) {
	  var ENDPOINT = (0, _constants.USER_IGNORING_USER_ENDPOINT)(uid, otherUid);
	  var ref = _firedux2.default.ref.child(ENDPOINT);
	
	  return ref.set(isIgnored);
	};
	
	var toggleIgnored = function toggleIgnored(uid, otherUid, isIgnored) {
	  var ENDPOINT = (0, _constants.USER_IGNORED_USER_ENDPOINT)(uid, otherUid);
	  var ref = _firedux2.default.ref.child(ENDPOINT);
	
	  return ref.set(isIgnored);
	};
	
	exports.default = function (currentUserUid, otherUid, isIgnored) {
	  if (!currentUserUid || !otherUid) return Promise.reject();
	
	  return toggleIgnored(currentUserUid, otherUid, isIgnored).then(toggleIgnoring.bind(null, otherUid, currentUserUid, isIgnored));
	};

/***/ },
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unwatchMessageCounts = exports.watchMessageCounts = exports.unwatchReadMessageCount = exports.watchReadMessageCount = exports.unwatchTotalMessageCount = exports.watchTotalMessageCount = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _firedux = __webpack_require__(6);
	
	var _firedux2 = _interopRequireDefault(_firedux);
	
	var _store = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var _set_total_message_count = __webpack_require__(996);
	
	var _set_total_message_count2 = _interopRequireDefault(_set_total_message_count);
	
	var _set_read_message_count = __webpack_require__(991);
	
	var _set_read_message_count2 = _interopRequireDefault(_set_read_message_count);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initReadMessageCount = function initReadMessageCount(uid, containerId) {
	  var readRef = _firedux2.default.ref.child(_constants.CONVERSATION_REF_MESSAGE_COUNTS_ENDPOINT).child(uid).child(containerId);
	  var totalRef = _firedux2.default.ref.child(_constants.CONVERSATION_MESSAGE_COUNTS_ENDPOINT).child(containerId);
	
	  Promise.all([readRef.once('value'), totalRef.once('value')]).then(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2);
	
	    var readSnap = _ref2[0];
	    var totalSnap = _ref2[1];
	
	    if (readSnap.exists()) return Promise.resolve();
	    if (!totalSnap.exists()) return Promise.resolve();
	
	    return readRef.set(totalSnap.val());
	  });
	};
	
	var onTotalMessageCount = function onTotalMessageCount(snapshot) {
	  (0, _store.dispatch)((0, _set_total_message_count2.default)(snapshot.val() || 0, snapshot.key()));
	};
	
	var onReadMessageCount = function onReadMessageCount(snapshot) {
	  (0, _store.dispatch)((0, _set_read_message_count2.default)(snapshot.val() || 0, snapshot.key()));
	};
	
	var watchTotalMessageCount = exports.watchTotalMessageCount = function watchTotalMessageCount(containerId) {
	  var ref = _firedux2.default.ref.child(_constants.CONVERSATION_MESSAGE_COUNTS_ENDPOINT).child(containerId);
	
	  ref.on('value', onTotalMessageCount);
	};
	
	var unwatchTotalMessageCount = exports.unwatchTotalMessageCount = function unwatchTotalMessageCount(containerId) {
	  var ref = _firedux2.default.ref.child(_constants.CONVERSATION_MESSAGE_COUNTS_ENDPOINT).child(containerId);
	
	  ref.off('value', onTotalMessageCount);
	};
	
	var watchReadMessageCount = exports.watchReadMessageCount = function watchReadMessageCount(uid, containerId) {
	  var ref = _firedux2.default.ref.child(_constants.CONVERSATION_REF_MESSAGE_COUNTS_ENDPOINT).child(uid).child(containerId);
	
	  initReadMessageCount(uid, containerId);
	
	  ref.on('value', onReadMessageCount);
	};
	
	var unwatchReadMessageCount = exports.unwatchReadMessageCount = function unwatchReadMessageCount(uid, containerId) {
	  var ref = _firedux2.default.ref.child(_constants.CONVERSATION_REF_MESSAGE_COUNTS_ENDPOINT).child(uid).child(containerId);
	
	  ref.off('value', onReadMessageCount);
	};
	
	var watchMessageCounts = exports.watchMessageCounts = function watchMessageCounts(uid, containerId) {
	  watchReadMessageCount(uid, containerId);
	  watchTotalMessageCount(containerId);
	};
	
	var unwatchMessageCounts = exports.unwatchMessageCounts = function unwatchMessageCounts(uid, containerId) {
	  unwatchReadMessageCount(uid, containerId);
	  unwatchTotalMessageCount(containerId);
	};

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** rchat.ui.min.js
 **/